
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5PFTV", function(module, exports) {
typeof document !== "undefined" && typeof navigator !== "undefined" && function(global, factory) {
    module.exports = factory();
}(this, function() {
    'use strict';
    var svgNS = 'http://www.w3.org/2000/svg';
    var locationHref = '';
    var _useWebWorker = false;
    var initialDefaultFrame = -999999;
    var setWebWorker = function setWebWorker(flag) {
        _useWebWorker = !!flag;
    };
    var getWebWorker = function getWebWorker() {
        return _useWebWorker;
    };
    var setLocationHref = function setLocationHref(value) {
        locationHref = value;
    };
    var getLocationHref = function getLocationHref() {
        return locationHref;
    };
    function createTag(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElement(type);
    }
    function extendPrototype(sources, destination) {
        var i;
        var len = sources.length;
        var sourcePrototype;
        for(i = 0; i < len; i += 1){
            sourcePrototype = sources[i].prototype;
            for(var attr in sourcePrototype)if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
        }
    }
    function getDescriptor(object, prop) {
        return Object.getOwnPropertyDescriptor(object, prop);
    }
    function createProxyFunction(prototype) {
        function ProxyFunction() {}
        ProxyFunction.prototype = prototype;
        return ProxyFunction;
    }
    // import Howl from '../../3rd_party/howler';
    var audioControllerFactory = function() {
        function AudioController(audioFactory) {
            this.audios = [];
            this.audioFactory = audioFactory;
            this._volume = 1;
            this._isMuted = false;
        }
        AudioController.prototype = {
            addAudio: function addAudio(audio) {
                this.audios.push(audio);
            },
            pause: function pause() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].pause();
            },
            resume: function resume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].resume();
            },
            setRate: function setRate(rateValue) {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].setRate(rateValue);
            },
            createAudio: function createAudio(assetPath) {
                if (this.audioFactory) return this.audioFactory(assetPath);
                if (window.Howl) return new window.Howl({
                    src: [
                        assetPath
                    ]
                });
                return {
                    isPlaying: false,
                    play: function play() {
                        this.isPlaying = true;
                    },
                    seek: function seek() {
                        this.isPlaying = false;
                    },
                    playing: function playing() {},
                    rate: function rate() {},
                    setVolume: function setVolume() {}
                };
            },
            setAudioFactory: function setAudioFactory(audioFactory) {
                this.audioFactory = audioFactory;
            },
            setVolume: function setVolume(value) {
                this._volume = value;
                this._updateVolume();
            },
            mute: function mute() {
                this._isMuted = true;
                this._updateVolume();
            },
            unmute: function unmute() {
                this._isMuted = false;
                this._updateVolume();
            },
            getVolume: function getVolume() {
                return this._volume;
            },
            _updateVolume: function _updateVolume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
            }
        };
        return function() {
            return new AudioController();
        };
    }();
    var createTypedArray = function() {
        function createRegularArray(type, len) {
            var i = 0;
            var arr = [];
            var value;
            switch(type){
                case 'int16':
                case 'uint8c':
                    value = 1;
                    break;
                default:
                    value = 1.1;
                    break;
            }
            for(i = 0; i < len; i += 1)arr.push(value);
            return arr;
        }
        function createTypedArrayFactory(type, len) {
            if (type === 'float32') return new Float32Array(len);
            if (type === 'int16') return new Int16Array(len);
            if (type === 'uint8c') return new Uint8ClampedArray(len);
            return createRegularArray(type, len);
        }
        if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') return createTypedArrayFactory;
        return createRegularArray;
    }();
    function createSizedArray(len) {
        return Array.apply(null, {
            length: len
        });
    }
    function _typeof$6(o) {
        "@babel/helpers - typeof";
        return _typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof$6(o);
    }
    var subframeEnabled = true;
    var expressionsPlugin = null;
    var expressionsInterfaces = null;
    var idPrefix$1 = '';
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var _shouldRoundValues = false;
    var bmPow = Math.pow;
    var bmSqrt = Math.sqrt;
    var bmFloor = Math.floor;
    var bmMax = Math.max;
    var bmMin = Math.min;
    var BMMath = {};
    (function() {
        var propertyNames = [
            'abs',
            'acos',
            'acosh',
            'asin',
            'asinh',
            'atan',
            'atanh',
            'atan2',
            'ceil',
            'cbrt',
            'expm1',
            'clz32',
            'cos',
            'cosh',
            'exp',
            'floor',
            'fround',
            'hypot',
            'imul',
            'log',
            'log1p',
            'log2',
            'log10',
            'max',
            'min',
            'pow',
            'random',
            'round',
            'sign',
            'sin',
            'sinh',
            'sqrt',
            'tan',
            'tanh',
            'trunc',
            'E',
            'LN10',
            'LN2',
            'LOG10E',
            'LOG2E',
            'PI',
            'SQRT1_2',
            'SQRT2'
        ];
        var i;
        var len = propertyNames.length;
        for(i = 0; i < len; i += 1)BMMath[propertyNames[i]] = Math[propertyNames[i]];
    })();
    function ProjectInterface$1() {
        return {};
    }
    BMMath.random = Math.random;
    BMMath.abs = function(val) {
        var tOfVal = _typeof$6(val);
        if (tOfVal === 'object' && val.length) {
            var absArr = createSizedArray(val.length);
            var i;
            var len = val.length;
            for(i = 0; i < len; i += 1)absArr[i] = Math.abs(val[i]);
            return absArr;
        }
        return Math.abs(val);
    };
    var defaultCurveSegments = 150;
    var degToRads = Math.PI / 180;
    var roundCorner = 0.5519;
    function roundValues(flag) {
        _shouldRoundValues = !!flag;
    }
    function bmRnd(value) {
        if (_shouldRoundValues) return Math.round(value);
        return value;
    }
    function styleDiv(element) {
        element.style.position = 'absolute';
        element.style.top = 0;
        element.style.left = 0;
        element.style.display = 'block';
        element.style.transformOrigin = '0 0';
        element.style.webkitTransformOrigin = '0 0';
        element.style.backfaceVisibility = 'visible';
        element.style.webkitBackfaceVisibility = 'visible';
        element.style.transformStyle = 'preserve-3d';
        element.style.webkitTransformStyle = 'preserve-3d';
        element.style.mozTransformStyle = 'preserve-3d';
    }
    function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
        this.type = type;
        this.currentTime = currentTime;
        this.totalTime = totalTime;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteEvent(type, frameMultiplier) {
        this.type = type;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
        this.type = type;
        this.currentLoop = currentLoop;
        this.totalLoops = totalLoops;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(type, firstFrame, totalFrames) {
        this.type = type;
        this.firstFrame = firstFrame;
        this.totalFrames = totalFrames;
    }
    function BMDestroyEvent(type, target) {
        this.type = type;
        this.target = target;
    }
    function BMRenderFrameErrorEvent(nativeError, currentTime) {
        this.type = 'renderFrameError';
        this.nativeError = nativeError;
        this.currentTime = currentTime;
    }
    function BMConfigErrorEvent(nativeError) {
        this.type = 'configError';
        this.nativeError = nativeError;
    }
    function BMAnimationConfigErrorEvent(type, nativeError) {
        this.type = type;
        this.nativeError = nativeError;
    }
    var createElementID = function() {
        var _count = 0;
        return function createID() {
            _count += 1;
            return idPrefix$1 + '__lottie_element_' + _count;
        };
    }();
    function HSVtoRGB(h, s, v) {
        var r;
        var g;
        var b;
        var i;
        var f;
        var p;
        var q;
        var t;
        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s);
        q = v * (1 - f * s);
        t = v * (1 - (1 - f) * s);
        switch(i % 6){
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            case 5:
                r = v;
                g = p;
                b = q;
                break;
            default:
                break;
        }
        return [
            r,
            g,
            b
        ];
    }
    function RGBtoHSV(r, g, b) {
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var d = max - min;
        var h;
        var s = max === 0 ? 0 : d / max;
        var v = max / 255;
        switch(max){
            case min:
                h = 0;
                break;
            case r:
                h = g - b + d * (g < b ? 6 : 0);
                h /= 6 * d;
                break;
            case g:
                h = b - r + d * 2;
                h /= 6 * d;
                break;
            case b:
                h = r - g + d * 4;
                h /= 6 * d;
                break;
            default:
                break;
        }
        return [
            h,
            s,
            v
        ];
    }
    function addSaturationToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[1] += offset;
        if (hsv[1] > 1) hsv[1] = 1;
        else if (hsv[1] <= 0) hsv[1] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addBrightnessToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[2] += offset;
        if (hsv[2] > 1) hsv[2] = 1;
        else if (hsv[2] < 0) hsv[2] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addHueToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[0] += offset / 360;
        if (hsv[0] > 1) hsv[0] -= 1;
        else if (hsv[0] < 0) hsv[0] += 1;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    var rgbToHex = function() {
        var colorMap = [];
        var i;
        var hex;
        for(i = 0; i < 256; i += 1){
            hex = i.toString(16);
            colorMap[i] = hex.length === 1 ? '0' + hex : hex;
        }
        return function(r, g, b) {
            if (r < 0) r = 0;
            if (g < 0) g = 0;
            if (b < 0) b = 0;
            return '#' + colorMap[r] + colorMap[g] + colorMap[b];
        };
    }();
    var setSubframeEnabled = function setSubframeEnabled(flag) {
        subframeEnabled = !!flag;
    };
    var getSubframeEnabled = function getSubframeEnabled() {
        return subframeEnabled;
    };
    var setExpressionsPlugin = function setExpressionsPlugin(value) {
        expressionsPlugin = value;
    };
    var getExpressionsPlugin = function getExpressionsPlugin() {
        return expressionsPlugin;
    };
    var setExpressionInterfaces = function setExpressionInterfaces(value) {
        expressionsInterfaces = value;
    };
    var getExpressionInterfaces = function getExpressionInterfaces() {
        return expressionsInterfaces;
    };
    var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
        defaultCurveSegments = value;
    };
    var getDefaultCurveSegments = function getDefaultCurveSegments() {
        return defaultCurveSegments;
    };
    var setIdPrefix = function setIdPrefix(value) {
        idPrefix$1 = value;
    };
    var getIdPrefix = function getIdPrefix() {
        return idPrefix$1;
    };
    function createNS(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElementNS(svgNS, type);
    }
    function _typeof$5(o) {
        "@babel/helpers - typeof";
        return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof$5(o);
    }
    var dataManager = function() {
        var _counterId = 1;
        var processes = [];
        var workerFn;
        var workerInstance;
        var workerProxy = {
            onmessage: function onmessage() {},
            postMessage: function postMessage(path) {
                workerFn({
                    data: path
                });
            }
        };
        var _workerSelf = {
            postMessage: function postMessage(data) {
                workerProxy.onmessage({
                    data: data
                });
            }
        };
        function createWorker(fn) {
            if (window.Worker && window.Blob && getWebWorker()) {
                var blob = new Blob([
                    'var _workerSelf = self; self.onmessage = ',
                    fn.toString()
                ], {
                    type: 'text/javascript'
                });
                // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
                var url = URL.createObjectURL(blob);
                return new Worker(url);
            }
            workerFn = fn;
            return workerProxy;
        }
        function setupWorker() {
            if (!workerInstance) {
                workerInstance = createWorker(function workerStart(e) {
                    function dataFunctionManager() {
                        function completeLayers(layers, comps) {
                            var layerData;
                            var i;
                            var len = layers.length;
                            var j;
                            var jLen;
                            var k;
                            var kLen;
                            for(i = 0; i < len; i += 1){
                                layerData = layers[i];
                                if ('ks' in layerData && !layerData.completed) {
                                    layerData.completed = true;
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) convertPathsToAbsoluteValues(maskProps[j].pt.k);
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                                                if (maskProps[j].pt.k[k].e) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                                            }
                                        }
                                    }
                                    if (layerData.ty === 0) {
                                        layerData.layers = findCompLayers(layerData.refId, comps);
                                        completeLayers(layerData.layers, comps);
                                    } else if (layerData.ty === 4) completeShapes(layerData.shapes);
                                    else if (layerData.ty === 5) completeText(layerData);
                                }
                            }
                        }
                        function completeChars(chars, assets) {
                            if (chars) {
                                var i = 0;
                                var len = chars.length;
                                for(i = 0; i < len; i += 1)if (chars[i].t === 1) {
                                    // var compData = findComp(chars[i].data.refId, assets);
                                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets);
                                    // chars[i].data.ip = 0;
                                    // chars[i].data.op = 99999;
                                    // chars[i].data.st = 0;
                                    // chars[i].data.sr = 1;
                                    // chars[i].w = compData.w;
                                    // chars[i].data.ks = {
                                    //   a: { k: [0, 0, 0], a: 0 },
                                    //   p: { k: [0, -compData.h, 0], a: 0 },
                                    //   r: { k: 0, a: 0 },
                                    //   s: { k: [100, 100], a: 0 },
                                    //   o: { k: 100, a: 0 },
                                    // };
                                    completeLayers(chars[i].data.layers, assets);
                                }
                            }
                        }
                        function findComp(id, comps) {
                            var i = 0;
                            var len = comps.length;
                            while(i < len){
                                if (comps[i].id === id) return comps[i];
                                i += 1;
                            }
                            return null;
                        }
                        function findCompLayers(id, comps) {
                            var comp = findComp(id, comps);
                            if (comp) {
                                if (!comp.layers.__used) {
                                    comp.layers.__used = true;
                                    return comp.layers;
                                }
                                return JSON.parse(JSON.stringify(comp.layers));
                            }
                            return null;
                        }
                        function completeShapes(arr) {
                            var i;
                            var len = arr.length;
                            var j;
                            var jLen;
                            for(i = len - 1; i >= 0; i -= 1){
                                if (arr[i].ty === 'sh') {
                                    if (arr[i].ks.k.i) convertPathsToAbsoluteValues(arr[i].ks.k);
                                    else {
                                        jLen = arr[i].ks.k.length;
                                        for(j = 0; j < jLen; j += 1){
                                            if (arr[i].ks.k[j].s) convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                                            if (arr[i].ks.k[j].e) convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                                        }
                                    }
                                } else if (arr[i].ty === 'gr') completeShapes(arr[i].it);
                            }
                        }
                        function convertPathsToAbsoluteValues(path) {
                            var i;
                            var len = path.i.length;
                            for(i = 0; i < len; i += 1){
                                path.i[i][0] += path.v[i][0];
                                path.i[i][1] += path.v[i][1];
                                path.o[i][0] += path.v[i][0];
                                path.o[i][1] += path.v[i][1];
                            }
                        }
                        function checkVersion(minimum, animVersionString) {
                            var animVersion = animVersionString ? animVersionString.split('.') : [
                                100,
                                100,
                                100
                            ];
                            if (minimum[0] > animVersion[0]) return true;
                            if (animVersion[0] > minimum[0]) return false;
                            if (minimum[1] > animVersion[1]) return true;
                            if (animVersion[1] > minimum[1]) return false;
                            if (minimum[2] > animVersion[2]) return true;
                            if (animVersion[2] > minimum[2]) return false;
                            return null;
                        }
                        var checkText = function() {
                            var minimumVersion = [
                                4,
                                4,
                                14
                            ];
                            function updateTextLayer(textLayer) {
                                var documentData = textLayer.t.d;
                                textLayer.t.d = {
                                    k: [
                                        {
                                            s: documentData,
                                            t: 0
                                        }
                                    ]
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkChars = function() {
                            var minimumVersion = [
                                4,
                                7,
                                99
                            ];
                            return function(animationData) {
                                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                                    var i;
                                    var len = animationData.chars.length;
                                    for(i = 0; i < len; i += 1){
                                        var charData = animationData.chars[i];
                                        if (charData.data && charData.data.shapes) {
                                            completeShapes(charData.data.shapes);
                                            charData.data.ip = 0;
                                            charData.data.op = 99999;
                                            charData.data.st = 0;
                                            charData.data.sr = 1;
                                            charData.data.ks = {
                                                p: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                s: {
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    a: 0
                                                },
                                                a: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                r: {
                                                    k: 0,
                                                    a: 0
                                                },
                                                o: {
                                                    k: 100,
                                                    a: 0
                                                }
                                            };
                                            if (!animationData.chars[i].t) {
                                                charData.data.shapes.push({
                                                    ty: 'no'
                                                });
                                                charData.data.shapes[0].it.push({
                                                    p: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    s: {
                                                        k: [
                                                            100,
                                                            100
                                                        ],
                                                        a: 0
                                                    },
                                                    a: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    r: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    o: {
                                                        k: 100,
                                                        a: 0
                                                    },
                                                    sk: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    sa: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    ty: 'tr'
                                                });
                                            }
                                        }
                                    }
                                }
                            };
                        }();
                        var checkPathProperties = function() {
                            var minimumVersion = [
                                5,
                                7,
                                15
                            ];
                            function updateTextLayer(textLayer) {
                                var pathData = textLayer.t.p;
                                if (typeof pathData.a === 'number') pathData.a = {
                                    a: 0,
                                    k: pathData.a
                                };
                                if (typeof pathData.p === 'number') pathData.p = {
                                    a: 0,
                                    k: pathData.p
                                };
                                if (typeof pathData.r === 'number') pathData.r = {
                                    a: 0,
                                    k: pathData.r
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkColors = function() {
                            var minimumVersion = [
                                4,
                                1,
                                9
                            ];
                            function iterateShapes(shapes) {
                                var i;
                                var len = shapes.length;
                                var j;
                                var jLen;
                                for(i = 0; i < len; i += 1){
                                    if (shapes[i].ty === 'gr') iterateShapes(shapes[i].it);
                                    else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
                                        if (shapes[i].c.k && shapes[i].c.k[0].i) {
                                            jLen = shapes[i].c.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (shapes[i].c.k[j].s) {
                                                    shapes[i].c.k[j].s[0] /= 255;
                                                    shapes[i].c.k[j].s[1] /= 255;
                                                    shapes[i].c.k[j].s[2] /= 255;
                                                    shapes[i].c.k[j].s[3] /= 255;
                                                }
                                                if (shapes[i].c.k[j].e) {
                                                    shapes[i].c.k[j].e[0] /= 255;
                                                    shapes[i].c.k[j].e[1] /= 255;
                                                    shapes[i].c.k[j].e[2] /= 255;
                                                    shapes[i].c.k[j].e[3] /= 255;
                                                }
                                            }
                                        } else {
                                            shapes[i].c.k[0] /= 255;
                                            shapes[i].c.k[1] /= 255;
                                            shapes[i].c.k[2] /= 255;
                                            shapes[i].c.k[3] /= 255;
                                        }
                                    }
                                }
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 4) iterateShapes(layers[i].shapes);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkShapes = function() {
                            var minimumVersion = [
                                4,
                                4,
                                18
                            ];
                            function completeClosingShapes(arr) {
                                var i;
                                var len = arr.length;
                                var j;
                                var jLen;
                                for(i = len - 1; i >= 0; i -= 1){
                                    if (arr[i].ty === 'sh') {
                                        if (arr[i].ks.k.i) arr[i].ks.k.c = arr[i].closed;
                                        else {
                                            jLen = arr[i].ks.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (arr[i].ks.k[j].s) arr[i].ks.k[j].s[0].c = arr[i].closed;
                                                if (arr[i].ks.k[j].e) arr[i].ks.k[j].e[0].c = arr[i].closed;
                                            }
                                        }
                                    } else if (arr[i].ty === 'gr') completeClosingShapes(arr[i].it);
                                }
                            }
                            function iterateLayers(layers) {
                                var layerData;
                                var i;
                                var len = layers.length;
                                var j;
                                var jLen;
                                var k;
                                var kLen;
                                for(i = 0; i < len; i += 1){
                                    layerData = layers[i];
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) maskProps[j].pt.k.c = maskProps[j].cl;
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                                                if (maskProps[j].pt.k[k].e) maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                                            }
                                        }
                                    }
                                    if (layerData.ty === 4) completeClosingShapes(layerData.shapes);
                                }
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        function completeData(animationData) {
                            if (animationData.__complete) return;
                            checkColors(animationData);
                            checkText(animationData);
                            checkChars(animationData);
                            checkPathProperties(animationData);
                            checkShapes(animationData);
                            completeLayers(animationData.layers, animationData.assets);
                            completeChars(animationData.chars, animationData.assets);
                            animationData.__complete = true;
                        }
                        function completeText(data) {
                            data.t.a.length === 0 && data.t.p;
                        }
                        var moduleOb = {};
                        moduleOb.completeData = completeData;
                        moduleOb.checkColors = checkColors;
                        moduleOb.checkChars = checkChars;
                        moduleOb.checkPathProperties = checkPathProperties;
                        moduleOb.checkShapes = checkShapes;
                        moduleOb.completeLayers = completeLayers;
                        return moduleOb;
                    }
                    if (!_workerSelf.dataManager) _workerSelf.dataManager = dataFunctionManager();
                    if (!_workerSelf.assetLoader) _workerSelf.assetLoader = function() {
                        function formatResponse(xhr) {
                            // using typeof doubles the time of execution of this method,
                            // so if available, it's better to use the header to validate the type
                            var contentTypeHeader = xhr.getResponseHeader('content-type');
                            if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) return xhr.response;
                            if (xhr.response && _typeof$5(xhr.response) === 'object') return xhr.response;
                            if (xhr.response && typeof xhr.response === 'string') return JSON.parse(xhr.response);
                            if (xhr.responseText) return JSON.parse(xhr.responseText);
                            return null;
                        }
                        function loadAsset(path, fullPath, callback, errorCallback) {
                            var response;
                            var xhr = new XMLHttpRequest();
                            // set responseType after calling open or IE will break.
                            try {
                                // This crashes on Android WebView prior to KitKat
                                xhr.responseType = 'json';
                            } catch (err) {} // eslint-disable-line no-empty
                            xhr.onreadystatechange = function() {
                                if (xhr.readyState === 4) {
                                    if (xhr.status === 200) {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } else try {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } catch (err) {
                                        if (errorCallback) errorCallback(err);
                                    }
                                }
                            };
                            try {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), path, true);
                            } catch (error) {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), fullPath + '/' + path, true);
                            }
                            xhr.send();
                        }
                        return {
                            load: loadAsset
                        };
                    }();
                    if (e.data.type === 'loadAnimation') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.dataManager.completeData(data);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                    else if (e.data.type === 'complete') {
                        var animation = e.data.animation;
                        _workerSelf.dataManager.completeData(animation);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: animation,
                            status: 'success'
                        });
                    } else if (e.data.type === 'loadData') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                });
                workerInstance.onmessage = function(event) {
                    var data = event.data;
                    var id = data.id;
                    var process = processes[id];
                    processes[id] = null;
                    if (data.status === 'success') process.onComplete(data.payload);
                    else if (process.onError) process.onError();
                };
            }
        }
        function createProcess(onComplete, onError) {
            _counterId += 1;
            var id = 'processId_' + _counterId;
            processes[id] = {
                onComplete: onComplete,
                onError: onError
            };
            return id;
        }
        function loadAnimation(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadAnimation',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function loadData(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadData',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function completeAnimation(anim, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'complete',
                animation: anim,
                id: processId
            });
        }
        return {
            loadAnimation: loadAnimation,
            loadData: loadData,
            completeAnimation: completeAnimation
        };
    }();
    var ImagePreloader = function() {
        var proxyImage = function() {
            var canvas = createTag('canvas');
            canvas.width = 1;
            canvas.height = 1;
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = 'rgba(0,0,0,0)';
            ctx.fillRect(0, 0, 1, 1);
            return canvas;
        }();
        function imageLoaded() {
            this.loadedAssets += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function footageLoaded() {
            this.loadedFootagesCount += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function getAssetsPath(assetData, assetsPath, originalPath) {
            var path = '';
            if (assetData.e) path = assetData.p;
            else if (assetsPath) {
                var imagePath = assetData.p;
                if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
                path = assetsPath + imagePath;
            } else {
                path = originalPath;
                path += assetData.u ? assetData.u : '';
                path += assetData.p;
            }
            return path;
        }
        function testImageLoaded(img) {
            var _count = 0;
            var intervalId = setInterval((function() {
                var box = img.getBBox();
                if (box.width || _count > 500) {
                    this._imageLoaded();
                    clearInterval(intervalId);
                }
                _count += 1;
            }).bind(this), 50);
        }
        function createImageData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createNS('image');
            if (isSafari) this.testImageLoaded(img);
            else img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
            if (this._elementHelper.append) this._elementHelper.append(img);
            else this._elementHelper.appendChild(img);
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createImgData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createTag('img');
            img.crossOrigin = 'anonymous';
            img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.src = path;
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createFootageData(data) {
            var ob = {
                assetData: data
            };
            var path = getAssetsPath(data, this.assetsPath, this.path);
            dataManager.loadData(path, (function(footageData) {
                ob.img = footageData;
                this._footageLoaded();
            }).bind(this), (function() {
                ob.img = {};
                this._footageLoaded();
            }).bind(this));
            return ob;
        }
        function loadAssets(assets, cb) {
            this.imagesLoadedCb = cb;
            var i;
            var len = assets.length;
            for(i = 0; i < len; i += 1)if (!assets[i].layers) {
                if (!assets[i].t || assets[i].t === 'seq') {
                    this.totalImages += 1;
                    this.images.push(this._createImageData(assets[i]));
                } else if (assets[i].t === 3) {
                    this.totalFootages += 1;
                    this.images.push(this.createFootageData(assets[i]));
                }
            }
        }
        function setPath(path) {
            this.path = path || '';
        }
        function setAssetsPath(path) {
            this.assetsPath = path || '';
        }
        function getAsset(assetData) {
            var i = 0;
            var len = this.images.length;
            while(i < len){
                if (this.images[i].assetData === assetData) return this.images[i].img;
                i += 1;
            }
            return null;
        }
        function destroy() {
            this.imagesLoadedCb = null;
            this.images.length = 0;
        }
        function loadedImages() {
            return this.totalImages === this.loadedAssets;
        }
        function loadedFootages() {
            return this.totalFootages === this.loadedFootagesCount;
        }
        function setCacheType(type, elementHelper) {
            if (type === 'svg') {
                this._elementHelper = elementHelper;
                this._createImageData = this.createImageData.bind(this);
            } else this._createImageData = this.createImgData.bind(this);
        }
        function ImagePreloaderFactory() {
            this._imageLoaded = imageLoaded.bind(this);
            this._footageLoaded = footageLoaded.bind(this);
            this.testImageLoaded = testImageLoaded.bind(this);
            this.createFootageData = createFootageData.bind(this);
            this.assetsPath = '';
            this.path = '';
            this.totalImages = 0;
            this.totalFootages = 0;
            this.loadedAssets = 0;
            this.loadedFootagesCount = 0;
            this.imagesLoadedCb = null;
            this.images = [];
        }
        ImagePreloaderFactory.prototype = {
            loadAssets: loadAssets,
            setAssetsPath: setAssetsPath,
            setPath: setPath,
            loadedImages: loadedImages,
            loadedFootages: loadedFootages,
            destroy: destroy,
            getAsset: getAsset,
            createImgData: createImgData,
            createImageData: createImageData,
            imageLoaded: imageLoaded,
            footageLoaded: footageLoaded,
            setCacheType: setCacheType
        };
        return ImagePreloaderFactory;
    }();
    function BaseEvent() {}
    BaseEvent.prototype = {
        triggerEvent: function triggerEvent(eventName, args) {
            if (this._cbs[eventName]) {
                var callbacks = this._cbs[eventName];
                for(var i = 0; i < callbacks.length; i += 1)callbacks[i](args);
            }
        },
        addEventListener: function addEventListener(eventName, callback) {
            if (!this._cbs[eventName]) this._cbs[eventName] = [];
            this._cbs[eventName].push(callback);
            return (function() {
                this.removeEventListener(eventName, callback);
            }).bind(this);
        },
        removeEventListener: function removeEventListener(eventName, callback) {
            if (!callback) this._cbs[eventName] = null;
            else if (this._cbs[eventName]) {
                var i = 0;
                var len = this._cbs[eventName].length;
                while(i < len){
                    if (this._cbs[eventName][i] === callback) {
                        this._cbs[eventName].splice(i, 1);
                        i -= 1;
                        len -= 1;
                    }
                    i += 1;
                }
                if (!this._cbs[eventName].length) this._cbs[eventName] = null;
            }
        }
    };
    var markerParser = function() {
        function parsePayloadLines(payload) {
            var lines = payload.split('\r\n');
            var keys = {};
            var line;
            var keysCount = 0;
            for(var i = 0; i < lines.length; i += 1){
                line = lines[i].split(':');
                if (line.length === 2) {
                    keys[line[0]] = line[1].trim();
                    keysCount += 1;
                }
            }
            if (keysCount === 0) throw new Error();
            return keys;
        }
        return function(_markers) {
            var markers = [];
            for(var i = 0; i < _markers.length; i += 1){
                var _marker = _markers[i];
                var markerData = {
                    time: _marker.tm,
                    duration: _marker.dr
                };
                try {
                    markerData.payload = JSON.parse(_markers[i].cm);
                } catch (_) {
                    try {
                        markerData.payload = parsePayloadLines(_markers[i].cm);
                    } catch (__) {
                        markerData.payload = {
                            name: _markers[i].cm
                        };
                    }
                }
                markers.push(markerData);
            }
            return markers;
        };
    }();
    var ProjectInterface = function() {
        function registerComposition(comp) {
            this.compositions.push(comp);
        }
        return function() {
            function _thisProjectFunction(name) {
                var i = 0;
                var len = this.compositions.length;
                while(i < len){
                    if (this.compositions[i].data && this.compositions[i].data.nm === name) {
                        if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) this.compositions[i].prepareFrame(this.currentFrame);
                        return this.compositions[i].compInterface;
                    }
                    i += 1;
                }
                return null;
            }
            _thisProjectFunction.compositions = [];
            _thisProjectFunction.currentFrame = 0;
            _thisProjectFunction.registerComposition = registerComposition;
            return _thisProjectFunction;
        };
    }();
    var renderers = {};
    var registerRenderer = function registerRenderer(key, value) {
        renderers[key] = value;
    };
    function getRenderer(key) {
        return renderers[key];
    }
    function getRegisteredRenderer() {
        // Returns canvas by default for compatibility
        if (renderers.canvas) return 'canvas';
        // Returns any renderer that is registered
        for(var key in renderers){
            if (renderers[key]) return key;
        }
        return '';
    }
    function _typeof$4(o) {
        "@babel/helpers - typeof";
        return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof$4(o);
    }
    var AnimationItem = function AnimationItem() {
        this._cbs = [];
        this.name = '';
        this.path = '';
        this.isLoaded = false;
        this.currentFrame = 0;
        this.currentRawFrame = 0;
        this.firstFrame = 0;
        this.totalFrames = 0;
        this.frameRate = 0;
        this.frameMult = 0;
        this.playSpeed = 1;
        this.playDirection = 1;
        this.playCount = 0;
        this.animationData = {};
        this.assets = [];
        this.isPaused = true;
        this.autoplay = false;
        this.loop = true;
        this.renderer = null;
        this.animationID = createElementID();
        this.assetsPath = '';
        this.timeCompleted = 0;
        this.segmentPos = 0;
        this.isSubframeEnabled = getSubframeEnabled();
        this.segments = [];
        this._idle = true;
        this._completedLoop = false;
        this.projectInterface = ProjectInterface();
        this.imagePreloader = new ImagePreloader();
        this.audioController = audioControllerFactory();
        this.markers = [];
        this.configAnimation = this.configAnimation.bind(this);
        this.onSetupError = this.onSetupError.bind(this);
        this.onSegmentComplete = this.onSegmentComplete.bind(this);
        this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0);
        this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([
        BaseEvent
    ], AnimationItem);
    AnimationItem.prototype.setParams = function(params) {
        if (params.wrapper || params.container) this.wrapper = params.wrapper || params.container;
        var animType = 'svg';
        if (params.animType) animType = params.animType;
        else if (params.renderer) animType = params.renderer;
        var RendererClass = getRenderer(animType);
        this.renderer = new RendererClass(this, params.rendererSettings);
        this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
        this.renderer.setProjectInterface(this.projectInterface);
        this.animType = animType;
        if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) this.loop = true;
        else if (params.loop === false) this.loop = false;
        else this.loop = parseInt(params.loop, 10);
        this.autoplay = 'autoplay' in params ? params.autoplay : true;
        this.name = params.name ? params.name : '';
        this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
        this.assetsPath = params.assetsPath;
        this.initialSegment = params.initialSegment;
        if (params.audioFactory) this.audioController.setAudioFactory(params.audioFactory);
        if (params.animationData) this.setupAnimation(params.animationData);
        else if (params.path) {
            if (params.path.lastIndexOf('\\') !== -1) this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
            else this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
            this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
            this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
            dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
        }
    };
    AnimationItem.prototype.onSetupError = function() {
        this.trigger('data_failed');
    };
    AnimationItem.prototype.setupAnimation = function(data) {
        dataManager.completeAnimation(data, this.configAnimation);
    };
    AnimationItem.prototype.setData = function(wrapper, animationData) {
        if (animationData) {
            if (_typeof$4(animationData) !== 'object') animationData = JSON.parse(animationData);
        }
        var params = {
            wrapper: wrapper,
            animationData: animationData
        };
        var wrapperAttributes = wrapper.attributes;
        params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
        params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : getRegisteredRenderer() || 'canvas';
        var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
        if (loop === 'false') params.loop = false;
        else if (loop === 'true') params.loop = true;
        else if (loop !== '') params.loop = parseInt(loop, 10);
        var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
        params.autoplay = autoplay !== 'false';
        params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
        var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
        if (prerender === 'false') params.prerender = false;
        if (!params.path) this.trigger('destroy');
        else this.setParams(params);
    };
    AnimationItem.prototype.includeLayers = function(data) {
        if (data.op > this.animationData.op) {
            this.animationData.op = data.op;
            this.totalFrames = Math.floor(data.op - this.animationData.ip);
        }
        var layers = this.animationData.layers;
        var i;
        var len = layers.length;
        var newLayers = data.layers;
        var j;
        var jLen = newLayers.length;
        for(j = 0; j < jLen; j += 1){
            i = 0;
            while(i < len){
                if (layers[i].id === newLayers[j].id) {
                    layers[i] = newLayers[j];
                    break;
                }
                i += 1;
            }
        }
        if (data.chars || data.fonts) {
            this.renderer.globalData.fontManager.addChars(data.chars);
            this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
        }
        if (data.assets) {
            len = data.assets.length;
            for(i = 0; i < len; i += 1)this.animationData.assets.push(data.assets[i]);
        }
        this.animationData.__complete = false;
        dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    };
    AnimationItem.prototype.onSegmentComplete = function(data) {
        this.animationData = data;
        var expressionsPlugin = getExpressionsPlugin();
        if (expressionsPlugin) expressionsPlugin.initExpressions(this);
        this.loadNextSegment();
    };
    AnimationItem.prototype.loadNextSegment = function() {
        var segments = this.animationData.segments;
        if (!segments || segments.length === 0 || !this.autoloadSegments) {
            this.trigger('data_ready');
            this.timeCompleted = this.totalFrames;
            return;
        }
        var segment = segments.shift();
        this.timeCompleted = segment.time * this.frameRate;
        var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
        this.segmentPos += 1;
        dataManager.loadData(segmentPath, this.includeLayers.bind(this), (function() {
            this.trigger('data_failed');
        }).bind(this));
    };
    AnimationItem.prototype.loadSegments = function() {
        var segments = this.animationData.segments;
        if (!segments) this.timeCompleted = this.totalFrames;
        this.loadNextSegment();
    };
    AnimationItem.prototype.imagesLoaded = function() {
        this.trigger('loaded_images');
        this.checkLoaded();
    };
    AnimationItem.prototype.preloadImages = function() {
        this.imagePreloader.setAssetsPath(this.assetsPath);
        this.imagePreloader.setPath(this.path);
        this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    };
    AnimationItem.prototype.configAnimation = function(animData) {
        if (!this.renderer) return;
        try {
            this.animationData = animData;
            if (this.initialSegment) {
                this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
                this.firstFrame = Math.round(this.initialSegment[0]);
            } else {
                this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
                this.firstFrame = Math.round(this.animationData.ip);
            }
            this.renderer.configAnimation(animData);
            if (!animData.assets) animData.assets = [];
            this.assets = this.animationData.assets;
            this.frameRate = this.animationData.fr;
            this.frameMult = this.animationData.fr / 1000;
            this.renderer.searchExtraCompositions(animData.assets);
            this.markers = markerParser(animData.markers || []);
            this.trigger('config_ready');
            this.preloadImages();
            this.loadSegments();
            this.updaFrameModifier();
            this.waitForFontsLoaded();
            if (this.isPaused) this.audioController.pause();
        } catch (error) {
            this.triggerConfigError(error);
        }
    };
    AnimationItem.prototype.waitForFontsLoaded = function() {
        if (!this.renderer) return;
        if (this.renderer.globalData.fontManager.isLoaded) this.checkLoaded();
        else setTimeout(this.waitForFontsLoaded.bind(this), 20);
    };
    AnimationItem.prototype.checkLoaded = function() {
        if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
            this.isLoaded = true;
            var expressionsPlugin = getExpressionsPlugin();
            if (expressionsPlugin) expressionsPlugin.initExpressions(this);
            this.renderer.initItems();
            setTimeout((function() {
                this.trigger('DOMLoaded');
            }).bind(this), 0);
            this.gotoFrame();
            if (this.autoplay) this.play();
        }
    };
    AnimationItem.prototype.resize = function(width, height) {
        // Adding this validation for backwards compatibility in case an event object was being passed down
        var _width = typeof width === 'number' ? width : undefined;
        var _height = typeof height === 'number' ? height : undefined;
        this.renderer.updateContainerSize(_width, _height);
    };
    AnimationItem.prototype.setSubframe = function(flag) {
        this.isSubframeEnabled = !!flag;
    };
    AnimationItem.prototype.gotoFrame = function() {
        this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise
        if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) this.currentFrame = this.timeCompleted;
        this.trigger('enterFrame');
        this.renderFrame();
        this.trigger('drawnFrame');
    };
    AnimationItem.prototype.renderFrame = function() {
        if (this.isLoaded === false || !this.renderer) return;
        try {
            if (this.expressionsPlugin) this.expressionsPlugin.resetFrame();
            this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (error) {
            this.triggerRenderFrameError(error);
        }
    };
    AnimationItem.prototype.play = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) {
            this.isPaused = false;
            this.trigger('_play');
            this.audioController.resume();
            if (this._idle) {
                this._idle = false;
                this.trigger('_active');
            }
        }
    };
    AnimationItem.prototype.pause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === false) {
            this.isPaused = true;
            this.trigger('_pause');
            this._idle = true;
            this.trigger('_idle');
            this.audioController.pause();
        }
    };
    AnimationItem.prototype.togglePause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) this.play();
        else this.pause();
    };
    AnimationItem.prototype.stop = function(name) {
        if (name && this.name !== name) return;
        this.pause();
        this.playCount = 0;
        this._completedLoop = false;
        this.setCurrentRawFrameValue(0);
    };
    AnimationItem.prototype.getMarkerData = function(markerName) {
        var marker;
        for(var i = 0; i < this.markers.length; i += 1){
            marker = this.markers[i];
            if (marker.payload && marker.payload.name === markerName) return marker;
        }
        return null;
    };
    AnimationItem.prototype.goToAndStop = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) this.goToAndStop(marker.time, true);
        } else if (isFrame) this.setCurrentRawFrameValue(value);
        else this.setCurrentRawFrameValue(value * this.frameModifier);
        this.pause();
    };
    AnimationItem.prototype.goToAndPlay = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) {
                if (!marker.duration) this.goToAndStop(marker.time, true);
                else this.playSegments([
                    marker.time,
                    marker.time + marker.duration
                ], true);
            }
        } else this.goToAndStop(numValue, isFrame, name);
        this.play();
    };
    AnimationItem.prototype.advanceTime = function(value) {
        if (this.isPaused === true || this.isLoaded === false) return;
        var nextValue = this.currentRawFrame + value * this.frameModifier;
        var _isComplete = false;
        // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
        // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
        if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
            if (!this.loop || this.playCount === this.loop) {
                if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
                    _isComplete = true;
                    nextValue = this.totalFrames - 1;
                }
            } else if (nextValue >= this.totalFrames) {
                this.playCount += 1;
                if (!this.checkSegments(nextValue % this.totalFrames)) {
                    this.setCurrentRawFrameValue(nextValue % this.totalFrames);
                    this._completedLoop = true;
                    this.trigger('loopComplete');
                }
            } else this.setCurrentRawFrameValue(nextValue);
        } else if (nextValue < 0) {
            if (!this.checkSegments(nextValue % this.totalFrames)) {
                if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
                    // eslint-disable-line no-plusplus
                    this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);
                    if (!this._completedLoop) this._completedLoop = true;
                    else this.trigger('loopComplete');
                } else {
                    _isComplete = true;
                    nextValue = 0;
                }
            }
        } else this.setCurrentRawFrameValue(nextValue);
        if (_isComplete) {
            this.setCurrentRawFrameValue(nextValue);
            this.pause();
            this.trigger('complete');
        }
    };
    AnimationItem.prototype.adjustSegment = function(arr, offset) {
        this.playCount = 0;
        if (arr[1] < arr[0]) {
            if (this.frameModifier > 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(-1);
            }
            this.totalFrames = arr[0] - arr[1];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[1];
            this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
        } else if (arr[1] > arr[0]) {
            if (this.frameModifier < 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(1);
            }
            this.totalFrames = arr[1] - arr[0];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[0];
            this.setCurrentRawFrameValue(0.001 + offset);
        }
        this.trigger('segmentStart');
    };
    AnimationItem.prototype.setSegment = function(init, end) {
        var pendingFrame = -1;
        if (this.isPaused) {
            if (this.currentRawFrame + this.firstFrame < init) pendingFrame = init;
            else if (this.currentRawFrame + this.firstFrame > end) pendingFrame = end - init;
        }
        this.firstFrame = init;
        this.totalFrames = end - init;
        this.timeCompleted = this.totalFrames;
        if (pendingFrame !== -1) this.goToAndStop(pendingFrame, true);
    };
    AnimationItem.prototype.playSegments = function(arr, forceFlag) {
        if (forceFlag) this.segments.length = 0;
        if (_typeof$4(arr[0]) === 'object') {
            var i;
            var len = arr.length;
            for(i = 0; i < len; i += 1)this.segments.push(arr[i]);
        } else this.segments.push(arr);
        if (this.segments.length && forceFlag) this.adjustSegment(this.segments.shift(), 0);
        if (this.isPaused) this.play();
    };
    AnimationItem.prototype.resetSegments = function(forceFlag) {
        this.segments.length = 0;
        this.segments.push([
            this.animationData.ip,
            this.animationData.op
        ]);
        if (forceFlag) this.checkSegments(0);
    };
    AnimationItem.prototype.checkSegments = function(offset) {
        if (this.segments.length) {
            this.adjustSegment(this.segments.shift(), offset);
            return true;
        }
        return false;
    };
    AnimationItem.prototype.destroy = function(name) {
        if (name && this.name !== name || !this.renderer) return;
        this.renderer.destroy();
        this.imagePreloader.destroy();
        this.trigger('destroy');
        this._cbs = null;
        this.onEnterFrame = null;
        this.onLoopComplete = null;
        this.onComplete = null;
        this.onSegmentStart = null;
        this.onDestroy = null;
        this.renderer = null;
        this.expressionsPlugin = null;
        this.imagePreloader = null;
        this.projectInterface = null;
    };
    AnimationItem.prototype.setCurrentRawFrameValue = function(value) {
        this.currentRawFrame = value;
        this.gotoFrame();
    };
    AnimationItem.prototype.setSpeed = function(val) {
        this.playSpeed = val;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setDirection = function(val) {
        this.playDirection = val < 0 ? -1 : 1;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setLoop = function(isLooping) {
        this.loop = isLooping;
    };
    AnimationItem.prototype.setVolume = function(val, name) {
        if (name && this.name !== name) return;
        this.audioController.setVolume(val);
    };
    AnimationItem.prototype.getVolume = function() {
        return this.audioController.getVolume();
    };
    AnimationItem.prototype.mute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.mute();
    };
    AnimationItem.prototype.unmute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.unmute();
    };
    AnimationItem.prototype.updaFrameModifier = function() {
        this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
        this.audioController.setRate(this.playSpeed * this.playDirection);
    };
    AnimationItem.prototype.getPath = function() {
        return this.path;
    };
    AnimationItem.prototype.getAssetsPath = function(assetData) {
        var path = '';
        if (assetData.e) path = assetData.p;
        else if (this.assetsPath) {
            var imagePath = assetData.p;
            if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
            path = this.assetsPath + imagePath;
        } else {
            path = this.path;
            path += assetData.u ? assetData.u : '';
            path += assetData.p;
        }
        return path;
    };
    AnimationItem.prototype.getAssetData = function(id) {
        var i = 0;
        var len = this.assets.length;
        while(i < len){
            if (id === this.assets[i].id) return this.assets[i];
            i += 1;
        }
        return null;
    };
    AnimationItem.prototype.hide = function() {
        this.renderer.hide();
    };
    AnimationItem.prototype.show = function() {
        this.renderer.show();
    };
    AnimationItem.prototype.getDuration = function(isFrame) {
        return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
    };
    AnimationItem.prototype.updateDocumentData = function(path, documentData, index) {
        try {
            var element = this.renderer.getElementByPath(path);
            element.updateDocumentData(documentData, index);
        } catch (error) {
        // TODO: decide how to handle catch case
        }
    };
    AnimationItem.prototype.trigger = function(name) {
        if (this._cbs && this._cbs[name]) switch(name){
            case 'enterFrame':
                this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
                break;
            case 'drawnFrame':
                this.drawnFrameEvent.currentTime = this.currentFrame;
                this.drawnFrameEvent.totalTime = this.totalFrames;
                this.drawnFrameEvent.direction = this.frameModifier;
                this.triggerEvent(name, this.drawnFrameEvent);
                break;
            case 'loopComplete':
                this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
                break;
            case 'complete':
                this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
                break;
            case 'segmentStart':
                this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
                break;
            case 'destroy':
                this.triggerEvent(name, new BMDestroyEvent(name, this));
                break;
            default:
                this.triggerEvent(name);
        }
        if (name === 'enterFrame' && this.onEnterFrame) this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
        if (name === 'loopComplete' && this.onLoopComplete) this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
        if (name === 'complete' && this.onComplete) this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
        if (name === 'segmentStart' && this.onSegmentStart) this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
        if (name === 'destroy' && this.onDestroy) this.onDestroy.call(this, new BMDestroyEvent(name, this));
    };
    AnimationItem.prototype.triggerRenderFrameError = function(nativeError) {
        var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    AnimationItem.prototype.triggerConfigError = function(nativeError) {
        var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    var animationManager = function() {
        var moduleOb = {};
        var registeredAnimations = [];
        var initTime = 0;
        var len = 0;
        var playingAnimationsNum = 0;
        var _stopped = true;
        var _isFrozen = false;
        function removeElement(ev) {
            var i = 0;
            var animItem = ev.target;
            while(i < len){
                if (registeredAnimations[i].animation === animItem) {
                    registeredAnimations.splice(i, 1);
                    i -= 1;
                    len -= 1;
                    if (!animItem.isPaused) subtractPlayingCount();
                }
                i += 1;
            }
        }
        function registerAnimation(element, animationData) {
            if (!element) return null;
            var i = 0;
            while(i < len){
                if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) return registeredAnimations[i].animation;
                i += 1;
            }
            var animItem = new AnimationItem();
            setupAnimation(animItem, element);
            animItem.setData(element, animationData);
            return animItem;
        }
        function getRegisteredAnimations() {
            var i;
            var lenAnims = registeredAnimations.length;
            var animations = [];
            for(i = 0; i < lenAnims; i += 1)animations.push(registeredAnimations[i].animation);
            return animations;
        }
        function addPlayingCount() {
            playingAnimationsNum += 1;
            activate();
        }
        function subtractPlayingCount() {
            playingAnimationsNum -= 1;
        }
        function setupAnimation(animItem, element) {
            animItem.addEventListener('destroy', removeElement);
            animItem.addEventListener('_active', addPlayingCount);
            animItem.addEventListener('_idle', subtractPlayingCount);
            registeredAnimations.push({
                elem: element,
                animation: animItem
            });
            len += 1;
        }
        function loadAnimation(params) {
            var animItem = new AnimationItem();
            setupAnimation(animItem, null);
            animItem.setParams(params);
            return animItem;
        }
        function setSpeed(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setSpeed(val, animation);
        }
        function setDirection(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setDirection(val, animation);
        }
        function play(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.play(animation);
        }
        function resume(nowTime) {
            var elapsedTime = nowTime - initTime;
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.advanceTime(elapsedTime);
            initTime = nowTime;
            if (playingAnimationsNum && !_isFrozen) window.requestAnimationFrame(resume);
            else _stopped = true;
        }
        function first(nowTime) {
            initTime = nowTime;
            window.requestAnimationFrame(resume);
        }
        function pause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.pause(animation);
        }
        function goToAndStop(value, isFrame, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
        }
        function stop(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.stop(animation);
        }
        function togglePause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.togglePause(animation);
        }
        function destroy(animation) {
            var i;
            for(i = len - 1; i >= 0; i -= 1)registeredAnimations[i].animation.destroy(animation);
        }
        function searchAnimations(animationData, standalone, renderer) {
            var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
            var i;
            var lenAnims = animElements.length;
            for(i = 0; i < lenAnims; i += 1){
                if (renderer) animElements[i].setAttribute('data-bm-type', renderer);
                registerAnimation(animElements[i], animationData);
            }
            if (standalone && lenAnims === 0) {
                if (!renderer) renderer = 'svg';
                var body = document.getElementsByTagName('body')[0];
                body.innerText = '';
                var div = createTag('div');
                div.style.width = '100%';
                div.style.height = '100%';
                div.setAttribute('data-bm-type', renderer);
                body.appendChild(div);
                registerAnimation(div, animationData);
            }
        }
        function resize() {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.resize();
        }
        function activate() {
            if (!_isFrozen && playingAnimationsNum) {
                if (_stopped) {
                    window.requestAnimationFrame(first);
                    _stopped = false;
                }
            }
        }
        function freeze() {
            _isFrozen = true;
        }
        function unfreeze() {
            _isFrozen = false;
            activate();
        }
        function setVolume(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setVolume(val, animation);
        }
        function mute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.mute(animation);
        }
        function unmute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.unmute(animation);
        }
        moduleOb.registerAnimation = registerAnimation;
        moduleOb.loadAnimation = loadAnimation;
        moduleOb.setSpeed = setSpeed;
        moduleOb.setDirection = setDirection;
        moduleOb.play = play;
        moduleOb.pause = pause;
        moduleOb.stop = stop;
        moduleOb.togglePause = togglePause;
        moduleOb.searchAnimations = searchAnimations;
        moduleOb.resize = resize;
        // moduleOb.start = start;
        moduleOb.goToAndStop = goToAndStop;
        moduleOb.destroy = destroy;
        moduleOb.freeze = freeze;
        moduleOb.unfreeze = unfreeze;
        moduleOb.setVolume = setVolume;
        moduleOb.mute = mute;
        moduleOb.unmute = unmute;
        moduleOb.getRegisteredAnimations = getRegisteredAnimations;
        return moduleOb;
    }();
    /* eslint-disable */ var BezierFactory = function() {
        /**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */ var ob = {};
        ob.getBezierEasing = getBezierEasing;
        var beziers = {};
        function getBezierEasing(a, b, c, d, nm) {
            var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');
            if (beziers[str]) return beziers[str];
            var bezEasing = new BezierEasing([
                a,
                b,
                c,
                d
            ]);
            beziers[str] = bezEasing;
            return bezEasing;
        }
        // These values are established by empiricism with tests (tradeoff: performance VS precision)
        var NEWTON_ITERATIONS = 4;
        var NEWTON_MIN_SLOPE = 0.001;
        var SUBDIVISION_PRECISION = 0.0000001;
        var SUBDIVISION_MAX_ITERATIONS = 10;
        var kSplineTableSize = 11;
        var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
        var float32ArraySupported = typeof Float32Array === 'function';
        function A(aA1, aA2) {
            return 1.0 - 3.0 * aA2 + 3.0 * aA1;
        }
        function B(aA1, aA2) {
            return 3.0 * aA2 - 6.0 * aA1;
        }
        function C(aA1) {
            return 3.0 * aA1;
        }
        // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
        function calcBezier(aT, aA1, aA2) {
            return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
        }
        // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
        function getSlope(aT, aA1, aA2) {
            return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
        }
        function binarySubdivide(aX, aA, aB, mX1, mX2) {
            var currentX, currentT, i = 0;
            do {
                currentT = aA + (aB - aA) / 2.0;
                currentX = calcBezier(currentT, mX1, mX2) - aX;
                if (currentX > 0.0) aB = currentT;
                else aA = currentT;
            }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
            return currentT;
        }
        function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
            for(var i = 0; i < NEWTON_ITERATIONS; ++i){
                var currentSlope = getSlope(aGuessT, mX1, mX2);
                if (currentSlope === 0.0) return aGuessT;
                var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
                aGuessT -= currentX / currentSlope;
            }
            return aGuessT;
        }
        /**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */ function BezierEasing(points) {
            this._p = points;
            this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
            this._precomputed = false;
            this.get = this.get.bind(this);
        }
        BezierEasing.prototype = {
            get: function get(x) {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                if (!this._precomputed) this._precompute();
                if (mX1 === mY1 && mX2 === mY2) return x; // linear
                // Because JavaScript number are imprecise, we should guarantee the extremes are right.
                if (x === 0) return 0;
                if (x === 1) return 1;
                return calcBezier(this._getTForX(x), mY1, mY2);
            },
            // Private part
            _precompute: function _precompute() {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                this._precomputed = true;
                if (mX1 !== mY1 || mX2 !== mY2) this._calcSampleValues();
            },
            _calcSampleValues: function _calcSampleValues() {
                var mX1 = this._p[0], mX2 = this._p[2];
                for(var i = 0; i < kSplineTableSize; ++i)this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            },
            /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */ _getTForX: function _getTForX(aX) {
                var mX1 = this._p[0], mX2 = this._p[2], mSampleValues = this._mSampleValues;
                var intervalStart = 0.0;
                var currentSample = 1;
                var lastSample = kSplineTableSize - 1;
                for(; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
                --currentSample;
                // Interpolate to provide an initial guess for t
                var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
                var guessForT = intervalStart + dist * kSampleStepSize;
                var initialSlope = getSlope(guessForT, mX1, mX2);
                if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
                if (initialSlope === 0.0) return guessForT;
                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
            }
        };
        return ob;
    }();
    var pooling = function() {
        function _double(arr) {
            return arr.concat(createSizedArray(arr.length));
        }
        return {
            "double": _double
        };
    }();
    var poolFactory = function() {
        return function(initialLength, _create, _release) {
            var _length = 0;
            var _maxLength = initialLength;
            var pool = createSizedArray(_maxLength);
            var ob = {
                newElement: newElement,
                release: release
            };
            function newElement() {
                var element;
                if (_length) {
                    _length -= 1;
                    element = pool[_length];
                } else element = _create();
                return element;
            }
            function release(element) {
                if (_length === _maxLength) {
                    pool = pooling["double"](pool);
                    _maxLength *= 2;
                }
                if (_release) _release(element);
                pool[_length] = element;
                _length += 1;
            }
            return ob;
        };
    }();
    var bezierLengthPool = function() {
        function create() {
            return {
                addedLength: 0,
                percents: createTypedArray('float32', getDefaultCurveSegments()),
                lengths: createTypedArray('float32', getDefaultCurveSegments())
            };
        }
        return poolFactory(8, create);
    }();
    var segmentsLengthPool = function() {
        function create() {
            return {
                lengths: [],
                totalLength: 0
            };
        }
        function release(element) {
            var i;
            var len = element.lengths.length;
            for(i = 0; i < len; i += 1)bezierLengthPool.release(element.lengths[i]);
            element.lengths.length = 0;
        }
        return poolFactory(8, create, release);
    }();
    function bezFunction() {
        var math = Math;
        function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
            var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
            return det1 > -0.001 && det1 < 0.001;
        }
        function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
            if (z1 === 0 && z2 === 0 && z3 === 0) return pointOnLine2D(x1, y1, x2, y2, x3, y3);
            var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
            var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
            var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
            var diffDist;
            if (dist1 > dist2) {
                if (dist1 > dist3) diffDist = dist1 - dist2 - dist3;
                else diffDist = dist3 - dist2 - dist1;
            } else if (dist3 > dist2) diffDist = dist3 - dist2 - dist1;
            else diffDist = dist2 - dist1 - dist3;
            return diffDist > -0.0001 && diffDist < 0.0001;
        }
        var getBezierLength = function() {
            return function(pt1, pt2, pt3, pt4) {
                var curveSegments = getDefaultCurveSegments();
                var k;
                var i;
                var len;
                var ptCoord;
                var perc;
                var addedLength = 0;
                var ptDistance;
                var point = [];
                var lastPoint = [];
                var lengthData = bezierLengthPool.newElement();
                len = pt3.length;
                for(k = 0; k < curveSegments; k += 1){
                    perc = k / (curveSegments - 1);
                    ptDistance = 0;
                    for(i = 0; i < len; i += 1){
                        ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
                        point[i] = ptCoord;
                        if (lastPoint[i] !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        lastPoint[i] = point[i];
                    }
                    if (ptDistance) {
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                    }
                    lengthData.percents[k] = perc;
                    lengthData.lengths[k] = addedLength;
                }
                lengthData.addedLength = addedLength;
                return lengthData;
            };
        }();
        function getSegmentsLength(shapeData) {
            var segmentsLength = segmentsLengthPool.newElement();
            var closed = shapeData.c;
            var pathV = shapeData.v;
            var pathO = shapeData.o;
            var pathI = shapeData.i;
            var i;
            var len = shapeData._length;
            var lengths = segmentsLength.lengths;
            var totalLength = 0;
            for(i = 0; i < len - 1; i += 1){
                lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
                totalLength += lengths[i].addedLength;
            }
            if (closed && len) {
                lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
                totalLength += lengths[i].addedLength;
            }
            segmentsLength.totalLength = totalLength;
            return segmentsLength;
        }
        function BezierData(length) {
            this.segmentLength = 0;
            this.points = new Array(length);
        }
        function PointData(partial, point) {
            this.partialLength = partial;
            this.point = point;
        }
        var buildBezierData = function() {
            var storedData = {};
            return function(pt1, pt2, pt3, pt4) {
                var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');
                if (!storedData[bezierName]) {
                    var curveSegments = getDefaultCurveSegments();
                    var k;
                    var i;
                    var len;
                    var ptCoord;
                    var perc;
                    var addedLength = 0;
                    var ptDistance;
                    var point;
                    var lastPoint = null;
                    if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) curveSegments = 2;
                    var bezierData = new BezierData(curveSegments);
                    len = pt3.length;
                    for(k = 0; k < curveSegments; k += 1){
                        point = createSizedArray(len);
                        perc = k / (curveSegments - 1);
                        ptDistance = 0;
                        for(i = 0; i < len; i += 1){
                            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
                            point[i] = ptCoord;
                            if (lastPoint !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        }
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                        bezierData.points[k] = new PointData(ptDistance, point);
                        lastPoint = point;
                    }
                    bezierData.segmentLength = addedLength;
                    storedData[bezierName] = bezierData;
                }
                return storedData[bezierName];
            };
        }();
        function getDistancePerc(perc, bezierData) {
            var percents = bezierData.percents;
            var lengths = bezierData.lengths;
            var len = percents.length;
            var initPos = bmFloor((len - 1) * perc);
            var lengthPos = perc * bezierData.addedLength;
            var lPerc = 0;
            if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) return percents[initPos];
            var dir = lengths[initPos] > lengthPos ? -1 : 1;
            var flag = true;
            while(flag){
                if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
                    lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
                    flag = false;
                } else initPos += dir;
                if (initPos < 0 || initPos >= len - 1) {
                    // FIX for TypedArrays that don't store floating point values with enough accuracy
                    if (initPos === len - 1) return percents[initPos];
                    flag = false;
                }
            }
            return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
        }
        function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
            var t1 = getDistancePerc(percent, bezierData);
            var u1 = 1 - t1;
            var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
            var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
            return [
                ptX,
                ptY
            ];
        }
        var bezierSegmentPoints = createTypedArray('float32', 8);
        function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
            if (startPerc < 0) startPerc = 0;
            else if (startPerc > 1) startPerc = 1;
            var t0 = getDistancePerc(startPerc, bezierData);
            endPerc = endPerc > 1 ? 1 : endPerc;
            var t1 = getDistancePerc(endPerc, bezierData);
            var i;
            var len = pt1.length;
            var u0 = 1 - t0;
            var u1 = 1 - t1;
            var u0u0u0 = u0 * u0 * u0;
            var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0t0 = t0 * t0 * t0;
            //
            var u0u0u1 = u0 * u0 * u1;
            var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0t1 = t0 * t0 * t1;
            //
            var u0u1u1 = u0 * u1 * u1;
            var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1t1 = t0 * t1 * t1;
            //
            var u1u1u1 = u1 * u1 * u1;
            var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1t1 = t1 * t1 * t1;
            for(i = 0; i < len; i += 1){
                bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
            }
            return bezierSegmentPoints;
        }
        return {
            getSegmentsLength: getSegmentsLength,
            getNewSegment: getNewSegment,
            getPointInSegment: getPointInSegment,
            buildBezierData: buildBezierData,
            pointOnLine2D: pointOnLine2D,
            pointOnLine3D: pointOnLine3D
        };
    }
    var bez = bezFunction();
    var initFrame = initialDefaultFrame;
    var mathAbs = Math.abs;
    function interpolateValue(frameNum, caching) {
        var offsetTime = this.offsetTime;
        var newValue;
        if (this.propType === 'multidimensional') newValue = createTypedArray('float32', this.pv.length);
        var iterationIndex = caching.lastIndex;
        var i = iterationIndex;
        var len = this.keyframes.length - 1;
        var flag = true;
        var keyData;
        var nextKeyData;
        var keyframeMetadata;
        while(flag){
            keyData = this.keyframes[i];
            nextKeyData = this.keyframes[i + 1];
            if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
                if (keyData.h) keyData = nextKeyData;
                iterationIndex = 0;
                break;
            }
            if (nextKeyData.t - offsetTime > frameNum) {
                iterationIndex = i;
                break;
            }
            if (i < len - 1) i += 1;
            else {
                iterationIndex = 0;
                flag = false;
            }
        }
        keyframeMetadata = this.keyframesMetadata[i] || {};
        var k;
        var kLen;
        var perc;
        var jLen;
        var j;
        var fnc;
        var nextKeyTime = nextKeyData.t - offsetTime;
        var keyTime = keyData.t - offsetTime;
        var endValue;
        if (keyData.to) {
            if (!keyframeMetadata.bezierData) keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
            var bezierData = keyframeMetadata.bezierData;
            if (frameNum >= nextKeyTime || frameNum < keyTime) {
                var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
                kLen = bezierData.points[ind].point.length;
                for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[ind].point[k];
            // caching._lastKeyframeIndex = -1;
            } else {
                if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                else {
                    fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
                    keyframeMetadata.__fnct = fnc;
                }
                perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                var distanceInLine = bezierData.segmentLength * perc;
                var segmentPerc;
                var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
                j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
                flag = true;
                jLen = bezierData.points.length;
                while(flag){
                    addedLength += bezierData.points[j].partialLength;
                    if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k];
                        break;
                    } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
                        segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
                        break;
                    }
                    if (j < jLen - 1) j += 1;
                    else flag = false;
                }
                caching._lastPoint = j;
                caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
                caching._lastKeyframeIndex = i;
            }
        } else {
            var outX;
            var outY;
            var inX;
            var inY;
            var keyValue;
            len = keyData.s.length;
            endValue = nextKeyData.s || keyData.e;
            if (this.sh && keyData.h !== 1) {
                if (frameNum >= nextKeyTime) {
                    newValue[0] = endValue[0];
                    newValue[1] = endValue[1];
                    newValue[2] = endValue[2];
                } else if (frameNum <= keyTime) {
                    newValue[0] = keyData.s[0];
                    newValue[1] = keyData.s[1];
                    newValue[2] = keyData.s[2];
                } else {
                    var quatStart = createQuaternion(keyData.s);
                    var quatEnd = createQuaternion(endValue);
                    var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
                    quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
                }
            } else for(i = 0; i < len; i += 1){
                if (keyData.h !== 1) {
                    if (frameNum >= nextKeyTime) perc = 1;
                    else if (frameNum < keyTime) perc = 0;
                    else {
                        if (keyData.o.x.constructor === Array) {
                            if (!keyframeMetadata.__fnct) keyframeMetadata.__fnct = [];
                            if (!keyframeMetadata.__fnct[i]) {
                                outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                                outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                                inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                                inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                                keyframeMetadata.__fnct[i] = fnc;
                            } else fnc = keyframeMetadata.__fnct[i];
                        } else if (!keyframeMetadata.__fnct) {
                            outX = keyData.o.x;
                            outY = keyData.o.y;
                            inX = keyData.i.x;
                            inY = keyData.i.y;
                            fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                            keyData.keyframeMetadata = fnc;
                        } else fnc = keyframeMetadata.__fnct;
                        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                    }
                }
                endValue = nextKeyData.s || keyData.e;
                keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;
                if (this.propType === 'multidimensional') newValue[i] = keyValue;
                else newValue = keyValue;
            }
        }
        caching.lastIndex = iterationIndex;
        return newValue;
    }
    // based on @Toji's https://github.com/toji/gl-matrix/
    function slerp(a, b, t) {
        var out = [];
        var ax = a[0];
        var ay = a[1];
        var az = a[2];
        var aw = a[3];
        var bx = b[0];
        var by = b[1];
        var bz = b[2];
        var bw = b[3];
        var omega;
        var cosom;
        var sinom;
        var scale0;
        var scale1;
        cosom = ax * bx + ay * by + az * bz + aw * bw;
        if (cosom < 0.0) {
            cosom = -cosom;
            bx = -bx;
            by = -by;
            bz = -bz;
            bw = -bw;
        }
        if (1.0 - cosom > 0.000001) {
            omega = Math.acos(cosom);
            sinom = Math.sin(omega);
            scale0 = Math.sin((1.0 - t) * omega) / sinom;
            scale1 = Math.sin(t * omega) / sinom;
        } else {
            scale0 = 1.0 - t;
            scale1 = t;
        }
        out[0] = scale0 * ax + scale1 * bx;
        out[1] = scale0 * ay + scale1 * by;
        out[2] = scale0 * az + scale1 * bz;
        out[3] = scale0 * aw + scale1 * bw;
        return out;
    }
    function quaternionToEuler(out, quat) {
        var qx = quat[0];
        var qy = quat[1];
        var qz = quat[2];
        var qw = quat[3];
        var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
        var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
        var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
        out[0] = heading / degToRads;
        out[1] = attitude / degToRads;
        out[2] = bank / degToRads;
    }
    function createQuaternion(values) {
        var heading = values[0] * degToRads;
        var attitude = values[1] * degToRads;
        var bank = values[2] * degToRads;
        var c1 = Math.cos(heading / 2);
        var c2 = Math.cos(attitude / 2);
        var c3 = Math.cos(bank / 2);
        var s1 = Math.sin(heading / 2);
        var s2 = Math.sin(attitude / 2);
        var s3 = Math.sin(bank / 2);
        var w = c1 * c2 * c3 - s1 * s2 * s3;
        var x = s1 * s2 * c3 + c1 * c2 * s3;
        var y = s1 * c2 * c3 + c1 * s2 * s3;
        var z = c1 * s2 * c3 - s1 * c2 * s3;
        return [
            x,
            y,
            z,
            w
        ];
    }
    function getValueAtCurrentTime() {
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        var initTime = this.keyframes[0].t - this.offsetTime;
        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
            if (this._caching.lastFrame >= frameNum) {
                this._caching._lastKeyframeIndex = -1;
                this._caching.lastIndex = 0;
            }
            var renderResult = this.interpolateValue(frameNum, this._caching);
            this.pv = renderResult;
        }
        this._caching.lastFrame = frameNum;
        return this.pv;
    }
    function setVValue(val) {
        var multipliedValue;
        if (this.propType === 'unidimensional') {
            multipliedValue = val * this.mult;
            if (mathAbs(this.v - multipliedValue) > 0.00001) {
                this.v = multipliedValue;
                this._mdf = true;
            }
        } else {
            var i = 0;
            var len = this.v.length;
            while(i < len){
                multipliedValue = val[i] * this.mult;
                if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
                    this.v[i] = multipliedValue;
                    this._mdf = true;
                }
                i += 1;
            }
        }
    }
    function processEffectsSequence() {
        if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) return;
        if (this.lock) {
            this.setVValue(this.pv);
            return;
        }
        this.lock = true;
        this._mdf = this._isFirstFrame;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = this.kf ? this.pv : this.data.k;
        for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
        this.setVValue(finalValue);
        this._isFirstFrame = false;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    }
    function addEffect(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.container.addDynamicProperty(this);
    }
    function ValueProperty(elem, data, mult, container) {
        this.propType = 'unidimensional';
        this.mult = mult || 1;
        this.data = data;
        this.v = mult ? data.k * mult : data.k;
        this.pv = data.k;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.vel = 0;
        this.effectsSequence = [];
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(elem, data, mult, container) {
        this.propType = 'multidimensional';
        this.mult = mult || 1;
        this.data = data;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.frameId = -1;
        var i;
        var len = data.k.length;
        this.v = createTypedArray('float32', len);
        this.pv = createTypedArray('float32', len);
        this.vel = createTypedArray('float32', len);
        for(i = 0; i < len; i += 1){
            this.v[i] = data.k[i] * this.mult;
            this.pv[i] = data.k[i];
        }
        this._isFirstFrame = true;
        this.effectsSequence = [];
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function KeyframedValueProperty(elem, data, mult, container) {
        this.propType = 'unidimensional';
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.frameId = -1;
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: 0,
            _lastKeyframeIndex: -1
        };
        this.k = true;
        this.kf = true;
        this.data = data;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.v = initFrame;
        this.pv = initFrame;
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(elem, data, mult, container) {
        this.propType = 'multidimensional';
        var i;
        var len = data.k.length;
        var s;
        var e;
        var to;
        var ti;
        for(i = 0; i < len - 1; i += 1)if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
            s = data.k[i].s;
            e = data.k[i + 1].s;
            to = data.k[i].to;
            ti = data.k[i].ti;
            if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
                data.k[i].to = null;
                data.k[i].ti = null;
            }
            if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
                if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
                    data.k[i].to = null;
                    data.k[i].ti = null;
                }
            }
        }
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.data = data;
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.k = true;
        this.kf = true;
        this._isFirstFrame = true;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.frameId = -1;
        var arrLen = data.k[0].s.length;
        this.v = createTypedArray('float32', arrLen);
        this.pv = createTypedArray('float32', arrLen);
        for(i = 0; i < arrLen; i += 1){
            this.v[i] = initFrame;
            this.pv[i] = initFrame;
        }
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: createTypedArray('float32', arrLen)
        };
        this.addEffect = addEffect;
    }
    var PropertyFactory = function() {
        function getProp(elem, data, type, mult, container) {
            if (data.sid) data = elem.globalData.slotManager.getProp(data);
            var p;
            if (!data.k.length) p = new ValueProperty(elem, data, mult, container);
            else if (typeof data.k[0] === 'number') p = new MultiDimensionalProperty(elem, data, mult, container);
            else switch(type){
                case 0:
                    p = new KeyframedValueProperty(elem, data, mult, container);
                    break;
                case 1:
                    p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
                    break;
                default:
                    break;
            }
            if (p.effectsSequence.length) container.addDynamicProperty(p);
            return p;
        }
        var ob = {
            getProp: getProp
        };
        return ob;
    }();
    function DynamicPropertyContainer() {}
    DynamicPropertyContainer.prototype = {
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) {
                this.dynamicProperties.push(prop);
                this.container.addDynamicProperty(this);
                this._isAnimated = true;
            }
        },
        iterateDynamicProperties: function iterateDynamicProperties() {
            this._mdf = false;
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1){
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) this._mdf = true;
            }
        },
        initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
            this.container = container;
            this.dynamicProperties = [];
            this._mdf = false;
            this._isAnimated = false;
        }
    };
    var pointPool = function() {
        function create() {
            return createTypedArray('float32', 2);
        }
        return poolFactory(8, create);
    }();
    function ShapePath() {
        this.c = false;
        this._length = 0;
        this._maxLength = 8;
        this.v = createSizedArray(this._maxLength);
        this.o = createSizedArray(this._maxLength);
        this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(closed, len) {
        this.c = closed;
        this.setLength(len);
        var i = 0;
        while(i < len){
            this.v[i] = pointPool.newElement();
            this.o[i] = pointPool.newElement();
            this.i[i] = pointPool.newElement();
            i += 1;
        }
    };
    ShapePath.prototype.setLength = function(len) {
        while(this._maxLength < len)this.doubleArrayLength();
        this._length = len;
    };
    ShapePath.prototype.doubleArrayLength = function() {
        this.v = this.v.concat(createSizedArray(this._maxLength));
        this.i = this.i.concat(createSizedArray(this._maxLength));
        this.o = this.o.concat(createSizedArray(this._maxLength));
        this._maxLength *= 2;
    };
    ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
        var arr;
        this._length = Math.max(this._length, pos + 1);
        if (this._length >= this._maxLength) this.doubleArrayLength();
        switch(type){
            case 'v':
                arr = this.v;
                break;
            case 'i':
                arr = this.i;
                break;
            case 'o':
                arr = this.o;
                break;
            default:
                arr = [];
                break;
        }
        if (!arr[pos] || arr[pos] && !replace) arr[pos] = pointPool.newElement();
        arr[pos][0] = x;
        arr[pos][1] = y;
    };
    ShapePath.prototype.setTripleAt = function(vX, vY, oX, oY, iX, iY, pos, replace) {
        this.setXYAt(vX, vY, 'v', pos, replace);
        this.setXYAt(oX, oY, 'o', pos, replace);
        this.setXYAt(iX, iY, 'i', pos, replace);
    };
    ShapePath.prototype.reverse = function() {
        var newPath = new ShapePath();
        newPath.setPathData(this.c, this._length);
        var vertices = this.v;
        var outPoints = this.o;
        var inPoints = this.i;
        var init = 0;
        if (this.c) {
            newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
            init = 1;
        }
        var cnt = this._length - 1;
        var len = this._length;
        var i;
        for(i = init; i < len; i += 1){
            newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
            cnt -= 1;
        }
        return newPath;
    };
    ShapePath.prototype.length = function() {
        return this._length;
    };
    var shapePool = function() {
        function create() {
            return new ShapePath();
        }
        function release(shapePath) {
            var len = shapePath._length;
            var i;
            for(i = 0; i < len; i += 1){
                pointPool.release(shapePath.v[i]);
                pointPool.release(shapePath.i[i]);
                pointPool.release(shapePath.o[i]);
                shapePath.v[i] = null;
                shapePath.i[i] = null;
                shapePath.o[i] = null;
            }
            shapePath._length = 0;
            shapePath.c = false;
        }
        function clone(shape) {
            var cloned = factory.newElement();
            var i;
            var len = shape._length === undefined ? shape.v.length : shape._length;
            cloned.setLength(len);
            cloned.c = shape.c;
            for(i = 0; i < len; i += 1)cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
            return cloned;
        }
        var factory = poolFactory(4, create, release);
        factory.clone = clone;
        return factory;
    }();
    function ShapeCollection() {
        this._length = 0;
        this._maxLength = 4;
        this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(shapeData) {
        if (this._length === this._maxLength) {
            this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
            this._maxLength *= 2;
        }
        this.shapes[this._length] = shapeData;
        this._length += 1;
    };
    ShapeCollection.prototype.releaseShapes = function() {
        var i;
        for(i = 0; i < this._length; i += 1)shapePool.release(this.shapes[i]);
        this._length = 0;
    };
    var shapeCollectionPool = function() {
        var ob = {
            newShapeCollection: newShapeCollection,
            release: release
        };
        var _length = 0;
        var _maxLength = 4;
        var pool = createSizedArray(_maxLength);
        function newShapeCollection() {
            var shapeCollection;
            if (_length) {
                _length -= 1;
                shapeCollection = pool[_length];
            } else shapeCollection = new ShapeCollection();
            return shapeCollection;
        }
        function release(shapeCollection) {
            var i;
            var len = shapeCollection._length;
            for(i = 0; i < len; i += 1)shapePool.release(shapeCollection.shapes[i]);
            shapeCollection._length = 0;
            if (_length === _maxLength) {
                pool = pooling["double"](pool);
                _maxLength *= 2;
            }
            pool[_length] = shapeCollection;
            _length += 1;
        }
        return ob;
    }();
    var ShapePropertyFactory = function() {
        var initFrame = -999999;
        function interpolateShape(frameNum, previousValue, caching) {
            var iterationIndex = caching.lastIndex;
            var keyPropS;
            var keyPropE;
            var isHold;
            var j;
            var k;
            var jLen;
            var kLen;
            var perc;
            var vertexValue;
            var kf = this.keyframes;
            if (frameNum < kf[0].t - this.offsetTime) {
                keyPropS = kf[0].s[0];
                isHold = true;
                iterationIndex = 0;
            } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
                keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
                /* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */ isHold = true;
            } else {
                var i = iterationIndex;
                var len = kf.length - 1;
                var flag = true;
                var keyData;
                var nextKeyData;
                var keyframeMetadata;
                while(flag){
                    keyData = kf[i];
                    nextKeyData = kf[i + 1];
                    if (nextKeyData.t - this.offsetTime > frameNum) break;
                    if (i < len - 1) i += 1;
                    else flag = false;
                }
                keyframeMetadata = this.keyframesMetadata[i] || {};
                isHold = keyData.h === 1;
                iterationIndex = i;
                if (!isHold) {
                    if (frameNum >= nextKeyData.t - this.offsetTime) perc = 1;
                    else if (frameNum < keyData.t - this.offsetTime) perc = 0;
                    else {
                        var fnc;
                        if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                        else {
                            fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
                            keyframeMetadata.__fnct = fnc;
                        }
                        perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
                    }
                    keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
                }
                keyPropS = keyData.s[0];
            }
            jLen = previousValue._length;
            kLen = keyPropS.i[0].length;
            caching.lastIndex = iterationIndex;
            for(j = 0; j < jLen; j += 1)for(k = 0; k < kLen; k += 1){
                vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
                previousValue.i[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
                previousValue.o[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
                previousValue.v[j][k] = vertexValue;
            }
        }
        function interpolateShapeCurrentTime() {
            var frameNum = this.comp.renderedFrame - this.offsetTime;
            var initTime = this.keyframes[0].t - this.offsetTime;
            var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            var lastFrame = this._caching.lastFrame;
            if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
                /// /
                this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
                this.interpolateShape(frameNum, this.pv, this._caching);
            /// /
            }
            this._caching.lastFrame = frameNum;
            return this.pv;
        }
        function resetShape() {
            this.paths = this.localShapeCollection;
        }
        function shapesEqual(shape1, shape2) {
            if (shape1._length !== shape2._length || shape1.c !== shape2.c) return false;
            var i;
            var len = shape1._length;
            for(i = 0; i < len; i += 1){
                if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) return false;
            }
            return true;
        }
        function setVValue(newPath) {
            if (!shapesEqual(this.v, newPath)) {
                this.v = shapePool.clone(newPath);
                this.localShapeCollection.releaseShapes();
                this.localShapeCollection.addShape(this.v);
                this._mdf = true;
                this.paths = this.localShapeCollection;
            }
        }
        function processEffectsSequence() {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (!this.effectsSequence.length) {
                this._mdf = false;
                return;
            }
            if (this.lock) {
                this.setVValue(this.pv);
                return;
            }
            this.lock = true;
            this._mdf = false;
            var finalValue;
            if (this.kf) finalValue = this.pv;
            else if (this.data.ks) finalValue = this.data.ks.k;
            else finalValue = this.data.pt.k;
            var i;
            var len = this.effectsSequence.length;
            for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
            this.setVValue(finalValue);
            this.lock = false;
            this.frameId = this.elem.globalData.frameId;
        }
        function ShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.container = elem;
            this.elem = elem;
            this.data = data;
            this.k = false;
            this.kf = false;
            this._mdf = false;
            var pathData = type === 3 ? data.pt.k : data.ks.k;
            this.v = shapePool.clone(pathData);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.reset = resetShape;
            this.effectsSequence = [];
        }
        function addEffect(effectFunction) {
            this.effectsSequence.push(effectFunction);
            this.container.addDynamicProperty(this);
        }
        ShapeProperty.prototype.interpolateShape = interpolateShape;
        ShapeProperty.prototype.getValue = processEffectsSequence;
        ShapeProperty.prototype.setVValue = setVValue;
        ShapeProperty.prototype.addEffect = addEffect;
        function KeyframedShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.elem = elem;
            this.container = elem;
            this.offsetTime = elem.data.st;
            this.keyframes = type === 3 ? data.pt.k : data.ks.k;
            this.keyframesMetadata = [];
            this.k = true;
            this.kf = true;
            var len = this.keyframes[0].s[0].i.length;
            this.v = shapePool.newElement();
            this.v.setPathData(this.keyframes[0].s[0].c, len);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.lastFrame = initFrame;
            this.reset = resetShape;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0
            };
            this.effectsSequence = [
                interpolateShapeCurrentTime.bind(this)
            ];
        }
        KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
        KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
        KeyframedShapeProperty.prototype.setVValue = setVValue;
        KeyframedShapeProperty.prototype.addEffect = addEffect;
        var EllShapeProperty = function() {
            var cPoint = roundCorner;
            function EllShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 4);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.paths = this.localShapeCollection;
                this.localShapeCollection.addShape(this.v);
                this.d = data.d;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertEllToPath();
                }
            }
            EllShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertEllToPath();
                },
                convertEllToPath: function convertEllToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var s0 = this.s.v[0] / 2;
                    var s1 = this.s.v[1] / 2;
                    var _cw = this.d !== 3;
                    var _v = this.v;
                    _v.v[0][0] = p0;
                    _v.v[0][1] = p1 - s1;
                    _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.v[1][1] = p1;
                    _v.v[2][0] = p0;
                    _v.v[2][1] = p1 + s1;
                    _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.v[3][1] = p1;
                    _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.i[0][1] = p1 - s1;
                    _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.i[1][1] = p1 - s1 * cPoint;
                    _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.i[2][1] = p1 + s1;
                    _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.i[3][1] = p1 + s1 * cPoint;
                    _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.o[0][1] = p1 - s1;
                    _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.o[1][1] = p1 + s1 * cPoint;
                    _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.o[2][1] = p1 + s1;
                    _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.o[3][1] = p1 - s1 * cPoint;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], EllShapePropertyFactory);
            return EllShapePropertyFactory;
        }();
        var StarShapeProperty = function() {
            function StarShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 0);
                this.elem = elem;
                this.comp = elem.comp;
                this.data = data;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                if (data.sy === 1) {
                    this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
                    this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
                    this.convertToPath = this.convertStarToPath;
                } else this.convertToPath = this.convertPolygonToPath;
                this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
                this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
                this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertToPath();
                }
            }
            StarShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertToPath();
                },
                convertStarToPath: function convertStarToPath() {
                    var numPts = Math.floor(this.pt.v) * 2;
                    var angle = Math.PI * 2 / numPts;
                    /* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */ var longFlag = true;
                    var longRad = this.or.v;
                    var shortRad = this.ir.v;
                    var longRound = this.os.v;
                    var shortRound = this.is.v;
                    var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
                    var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
                    var i;
                    var rad;
                    var roundness;
                    var perimSegment;
                    var currentAng = -Math.PI / 2;
                    currentAng += this.r.v;
                    var dir = this.data.d === 3 ? -1 : 1;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        rad = longFlag ? longRad : shortRad;
                        roundness = longFlag ? longRound : shortRound;
                        perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        /* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */ longFlag = !longFlag;
                        currentAng += angle * dir;
                    }
                },
                convertPolygonToPath: function convertPolygonToPath() {
                    var numPts = Math.floor(this.pt.v);
                    var angle = Math.PI * 2 / numPts;
                    var rad = this.or.v;
                    var roundness = this.os.v;
                    var perimSegment = 2 * Math.PI * rad / (numPts * 4);
                    var i;
                    var currentAng = -Math.PI * 0.5;
                    var dir = this.data.d === 3 ? -1 : 1;
                    currentAng += this.r.v;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        currentAng += angle * dir;
                    }
                    this.paths.length = 0;
                    this.paths[0] = this.v;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], StarShapePropertyFactory);
            return StarShapePropertyFactory;
        }();
        var RectShapeProperty = function() {
            function RectShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.c = true;
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertRectToPath();
                }
            }
            RectShapePropertyFactory.prototype = {
                convertRectToPath: function convertRectToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var v0 = this.s.v[0] / 2;
                    var v1 = this.s.v[1] / 2;
                    var round = bmMin(v0, v1, this.r.v);
                    var cPoint = round * (1 - roundCorner);
                    this.v._length = 0;
                    if (this.d === 2 || this.d === 1) {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
                        this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
                        }
                    } else {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
                        }
                    }
                },
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertRectToPath();
                },
                reset: resetShape
            };
            extendPrototype([
                DynamicPropertyContainer
            ], RectShapePropertyFactory);
            return RectShapePropertyFactory;
        }();
        function getShapeProp(elem, data, type) {
            var prop;
            if (type === 3 || type === 4) {
                var dataProp = type === 3 ? data.pt : data.ks;
                var keys = dataProp.k;
                if (keys.length) prop = new KeyframedShapeProperty(elem, data, type);
                else prop = new ShapeProperty(elem, data, type);
            } else if (type === 5) prop = new RectShapeProperty(elem, data);
            else if (type === 6) prop = new EllShapeProperty(elem, data);
            else if (type === 7) prop = new StarShapeProperty(elem, data);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        }
        function getConstructorFunction() {
            return ShapeProperty;
        }
        function getKeyframedConstructorFunction() {
            return KeyframedShapeProperty;
        }
        var ob = {};
        ob.getShapeProp = getShapeProp;
        ob.getConstructorFunction = getConstructorFunction;
        ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
        return ob;
    }();
    /*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */ /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */ var Matrix = function() {
        var _cos = Math.cos;
        var _sin = Math.sin;
        var _tan = Math.tan;
        var _rnd = Math.round;
        function reset() {
            this.props[0] = 1;
            this.props[1] = 0;
            this.props[2] = 0;
            this.props[3] = 0;
            this.props[4] = 0;
            this.props[5] = 1;
            this.props[6] = 0;
            this.props[7] = 0;
            this.props[8] = 0;
            this.props[9] = 0;
            this.props[10] = 1;
            this.props[11] = 0;
            this.props[12] = 0;
            this.props[13] = 0;
            this.props[14] = 0;
            this.props[15] = 1;
            return this;
        }
        function rotate(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function rotateX(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
        }
        function rotateY(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
        }
        function rotateZ(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function shear(sx, sy) {
            return this._t(1, sy, sx, 1, 0, 0);
        }
        function skew(ax, ay) {
            return this.shear(_tan(ax), _tan(ay));
        }
        function skewFromAxis(ax, angle) {
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
        }
        function scale(sx, sy, sz) {
            if (!sz && sz !== 0) sz = 1;
            if (sx === 1 && sy === 1 && sz === 1) return this;
            return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
        }
        function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
            this.props[0] = a;
            this.props[1] = b;
            this.props[2] = c;
            this.props[3] = d;
            this.props[4] = e;
            this.props[5] = f;
            this.props[6] = g;
            this.props[7] = h;
            this.props[8] = i;
            this.props[9] = j;
            this.props[10] = k;
            this.props[11] = l;
            this.props[12] = m;
            this.props[13] = n;
            this.props[14] = o;
            this.props[15] = p;
            return this;
        }
        function translate(tx, ty, tz) {
            tz = tz || 0;
            if (tx !== 0 || ty !== 0 || tz !== 0) return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
            return this;
        }
        function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
            var _p = this.props;
            if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
                // NOTE: commenting this condition because TurboFan deoptimizes code when present
                // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
                _p[12] = _p[12] * a2 + _p[15] * m2;
                _p[13] = _p[13] * f2 + _p[15] * n2;
                _p[14] = _p[14] * k2 + _p[15] * o2;
                _p[15] *= p2;
                // }
                this._identityCalculated = false;
                return this;
            }
            var a1 = _p[0];
            var b1 = _p[1];
            var c1 = _p[2];
            var d1 = _p[3];
            var e1 = _p[4];
            var f1 = _p[5];
            var g1 = _p[6];
            var h1 = _p[7];
            var i1 = _p[8];
            var j1 = _p[9];
            var k1 = _p[10];
            var l1 = _p[11];
            var m1 = _p[12];
            var n1 = _p[13];
            var o1 = _p[14];
            var p1 = _p[15];
            /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */ _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
            _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
            _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
            _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
            _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
            _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
            _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
            _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
            _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
            _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
            _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
            _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
            _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
            _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
            _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
            _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
            this._identityCalculated = false;
            return this;
        }
        function multiply(matrix) {
            var matrixProps = matrix.props;
            return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
        }
        function isIdentity() {
            if (!this._identityCalculated) {
                this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
                this._identityCalculated = true;
            }
            return this._identity;
        }
        function equals(matr) {
            var i = 0;
            while(i < 16){
                if (matr.props[i] !== this.props[i]) return false;
                i += 1;
            }
            return true;
        }
        function clone(matr) {
            var i;
            for(i = 0; i < 16; i += 1)matr.props[i] = this.props[i];
            return matr;
        }
        function cloneFromProps(props) {
            var i;
            for(i = 0; i < 16; i += 1)this.props[i] = props[i];
        }
        function applyToPoint(x, y, z) {
            return {
                x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            };
        /* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */ }
        function applyToX(x, y, z) {
            return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
        }
        function applyToY(x, y, z) {
            return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
        }
        function applyToZ(x, y, z) {
            return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
        }
        function getInverseMatrix() {
            var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
            var a = this.props[5] / determinant;
            var b = -this.props[1] / determinant;
            var c = -this.props[4] / determinant;
            var d = this.props[0] / determinant;
            var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
            var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
            var inverseMatrix = new Matrix();
            inverseMatrix.props[0] = a;
            inverseMatrix.props[1] = b;
            inverseMatrix.props[4] = c;
            inverseMatrix.props[5] = d;
            inverseMatrix.props[12] = e;
            inverseMatrix.props[13] = f;
            return inverseMatrix;
        }
        function inversePoint(pt) {
            var inverseMatrix = this.getInverseMatrix();
            return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
        }
        function inversePoints(pts) {
            var i;
            var len = pts.length;
            var retPts = [];
            for(i = 0; i < len; i += 1)retPts[i] = inversePoint(pts[i]);
            return retPts;
        }
        function applyToTriplePoints(pt1, pt2, pt3) {
            var arr = createTypedArray('float32', 6);
            if (this.isIdentity()) {
                arr[0] = pt1[0];
                arr[1] = pt1[1];
                arr[2] = pt2[0];
                arr[3] = pt2[1];
                arr[4] = pt3[0];
                arr[5] = pt3[1];
            } else {
                var p0 = this.props[0];
                var p1 = this.props[1];
                var p4 = this.props[4];
                var p5 = this.props[5];
                var p12 = this.props[12];
                var p13 = this.props[13];
                arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
                arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
                arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
                arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
                arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
                arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
            }
            return arr;
        }
        function applyToPointArray(x, y, z) {
            var arr;
            if (this.isIdentity()) arr = [
                x,
                y,
                z
            ];
            else arr = [
                x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            ];
            return arr;
        }
        function applyToPointStringified(x, y) {
            if (this.isIdentity()) return x + ',' + y;
            var _p = this.props;
            return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
        }
        function toCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var i = 0;
            var props = this.props;
            var cssValue = 'matrix3d(';
            var v = 10000;
            while(i < 16){
                cssValue += _rnd(props[i] * v) / v;
                cssValue += i === 15 ? ')' : ',';
                i += 1;
            }
            return cssValue;
        }
        function roundMatrixProperty(val) {
            var v = 10000;
            if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) return _rnd(val * v) / v;
            return val;
        }
        function to2dCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var props = this.props;
            var _a = roundMatrixProperty(props[0]);
            var _b = roundMatrixProperty(props[1]);
            var _c = roundMatrixProperty(props[4]);
            var _d = roundMatrixProperty(props[5]);
            var _e = roundMatrixProperty(props[12]);
            var _f = roundMatrixProperty(props[13]);
            return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
        }
        return function() {
            this.reset = reset;
            this.rotate = rotate;
            this.rotateX = rotateX;
            this.rotateY = rotateY;
            this.rotateZ = rotateZ;
            this.skew = skew;
            this.skewFromAxis = skewFromAxis;
            this.shear = shear;
            this.scale = scale;
            this.setTransform = setTransform;
            this.translate = translate;
            this.transform = transform;
            this.multiply = multiply;
            this.applyToPoint = applyToPoint;
            this.applyToX = applyToX;
            this.applyToY = applyToY;
            this.applyToZ = applyToZ;
            this.applyToPointArray = applyToPointArray;
            this.applyToTriplePoints = applyToTriplePoints;
            this.applyToPointStringified = applyToPointStringified;
            this.toCSS = toCSS;
            this.to2dCSS = to2dCSS;
            this.clone = clone;
            this.cloneFromProps = cloneFromProps;
            this.equals = equals;
            this.inversePoints = inversePoints;
            this.inversePoint = inversePoint;
            this.getInverseMatrix = getInverseMatrix;
            this._t = this.transform;
            this.isIdentity = isIdentity;
            this._identity = true;
            this._identityCalculated = false;
            this.props = createTypedArray('float32', 16);
            this.reset();
        };
    }();
    function _typeof$3(o) {
        "@babel/helpers - typeof";
        return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof$3(o);
    }
    var lottie = {};
    var standalone = '__[STANDALONE]__';
    var animationData = '__[ANIMATIONDATA]__';
    var renderer = '';
    function setLocation(href) {
        setLocationHref(href);
    }
    function searchAnimations() {
        if (standalone === true) animationManager.searchAnimations(animationData, standalone, renderer);
        else animationManager.searchAnimations();
    }
    function setSubframeRendering(flag) {
        setSubframeEnabled(flag);
    }
    function setPrefix(prefix) {
        setIdPrefix(prefix);
    }
    function loadAnimation(params) {
        if (standalone === true) params.animationData = JSON.parse(animationData);
        return animationManager.loadAnimation(params);
    }
    function setQuality(value) {
        if (typeof value === 'string') switch(value){
            case 'high':
                setDefaultCurveSegments(200);
                break;
            default:
            case 'medium':
                setDefaultCurveSegments(50);
                break;
            case 'low':
                setDefaultCurveSegments(10);
                break;
        }
        else if (!isNaN(value) && value > 1) setDefaultCurveSegments(value);
        if (getDefaultCurveSegments() >= 50) roundValues(false);
        else roundValues(true);
    }
    function inBrowser() {
        return typeof navigator !== 'undefined';
    }
    function installPlugin(type, plugin) {
        if (type === 'expressions') setExpressionsPlugin(plugin);
    }
    function getFactory(name) {
        switch(name){
            case 'propertyFactory':
                return PropertyFactory;
            case 'shapePropertyFactory':
                return ShapePropertyFactory;
            case 'matrix':
                return Matrix;
            default:
                return null;
        }
    }
    lottie.play = animationManager.play;
    lottie.pause = animationManager.pause;
    lottie.setLocationHref = setLocation;
    lottie.togglePause = animationManager.togglePause;
    lottie.setSpeed = animationManager.setSpeed;
    lottie.setDirection = animationManager.setDirection;
    lottie.stop = animationManager.stop;
    lottie.searchAnimations = searchAnimations;
    lottie.registerAnimation = animationManager.registerAnimation;
    lottie.loadAnimation = loadAnimation;
    lottie.setSubframeRendering = setSubframeRendering;
    lottie.resize = animationManager.resize;
    // lottie.start = start;
    lottie.goToAndStop = animationManager.goToAndStop;
    lottie.destroy = animationManager.destroy;
    lottie.setQuality = setQuality;
    lottie.inBrowser = inBrowser;
    lottie.installPlugin = installPlugin;
    lottie.freeze = animationManager.freeze;
    lottie.unfreeze = animationManager.unfreeze;
    lottie.setVolume = animationManager.setVolume;
    lottie.mute = animationManager.mute;
    lottie.unmute = animationManager.unmute;
    lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
    lottie.useWebWorker = setWebWorker;
    lottie.setIDPrefix = setPrefix;
    lottie.__getFactory = getFactory;
    lottie.version = '5.13.0';
    function checkReady() {
        if (document.readyState === 'complete') {
            clearInterval(readyStateCheckInterval);
            searchAnimations();
        }
    }
    function getQueryVariable(variable) {
        var vars = queryString.split('&');
        for(var i = 0; i < vars.length; i += 1){
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) // eslint-disable-line eqeqeq
            return decodeURIComponent(pair[1]);
        }
        return null;
    }
    var queryString = '';
    if (standalone) {
        var scripts = document.getElementsByTagName('script');
        var index = scripts.length - 1;
        var myScript = scripts[index] || {
            src: ''
        };
        queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape
        renderer = getQueryVariable('renderer');
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    // this adds bodymovin to the window object for backwards compatibility
    try {
        if (!(_typeof$3(exports) === 'object' && true) && !(typeof define === 'function' && define.amd // eslint-disable-line no-undef
        )) window.bodymovin = lottie;
    } catch (err) {
    //
    }
    var ShapeModifiers = function() {
        var ob = {};
        var modifiers = {};
        ob.registerModifier = registerModifier;
        ob.getModifier = getModifier;
        function registerModifier(nm, factory) {
            if (!modifiers[nm]) modifiers[nm] = factory;
        }
        function getModifier(nm, elem, data) {
            return new modifiers[nm](elem, data);
        }
        return ob;
    }();
    function ShapeModifier() {}
    ShapeModifier.prototype.initModifierProperties = function() {};
    ShapeModifier.prototype.addShapeToModifier = function() {};
    ShapeModifier.prototype.addShape = function(data) {
        if (!this.closed) {
            // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
            data.sh.container.addDynamicProperty(data.sh);
            var shapeData = {
                shape: data.sh,
                data: data,
                localShapeCollection: shapeCollectionPool.newShapeCollection()
            };
            this.shapes.push(shapeData);
            this.addShapeToModifier(shapeData);
            if (this._isAnimated) data.setAsAnimated();
        }
    };
    ShapeModifier.prototype.init = function(elem, data) {
        this.shapes = [];
        this.elem = elem;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, data);
        this.frameId = initialDefaultFrame;
        this.closed = false;
        this.k = false;
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    ShapeModifier.prototype.processKeys = function() {
        if (this.elem.globalData.frameId === this.frameId) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    extendPrototype([
        DynamicPropertyContainer
    ], ShapeModifier);
    function TrimModifier() {}
    extendPrototype([
        ShapeModifier
    ], TrimModifier);
    TrimModifier.prototype.initModifierProperties = function(elem, data) {
        this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
        this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
        this.sValue = 0;
        this.eValue = 0;
        this.getValue = this.processKeys;
        this.m = data.m;
        this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    };
    TrimModifier.prototype.addShapeToModifier = function(shapeData) {
        shapeData.pathsData = [];
    };
    TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
        var segments = [];
        if (e <= 1) segments.push({
            s: s,
            e: e
        });
        else if (s >= 1) segments.push({
            s: s - 1,
            e: e - 1
        });
        else {
            segments.push({
                s: s,
                e: 1
            });
            segments.push({
                s: 0,
                e: e - 1
            });
        }
        var shapeSegments = [];
        var i;
        var len = segments.length;
        var segmentOb;
        for(i = 0; i < len; i += 1){
            segmentOb = segments[i];
            if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
                var shapeS;
                var shapeE;
                if (segmentOb.s * totalModifierLength <= addedLength) shapeS = 0;
                else shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
                if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) shapeE = 1;
                else shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
                shapeSegments.push([
                    shapeS,
                    shapeE
                ]);
            }
        }
        if (!shapeSegments.length) shapeSegments.push([
            0,
            0
        ]);
        return shapeSegments;
    };
    TrimModifier.prototype.releasePathsData = function(pathsData) {
        var i;
        var len = pathsData.length;
        for(i = 0; i < len; i += 1)segmentsLengthPool.release(pathsData[i]);
        pathsData.length = 0;
        return pathsData;
    };
    TrimModifier.prototype.processShapes = function(_isFirstFrame) {
        var s;
        var e;
        if (this._mdf || _isFirstFrame) {
            var o = this.o.v % 360 / 360;
            if (o < 0) o += 1;
            if (this.s.v > 1) s = 1 + o;
            else if (this.s.v < 0) s = 0 + o;
            else s = this.s.v + o;
            if (this.e.v > 1) e = 1 + o;
            else if (this.e.v < 0) e = 0 + o;
            else e = this.e.v + o;
            if (s > e) {
                var _s = s;
                s = e;
                e = _s;
            }
            s = Math.round(s * 10000) * 0.0001;
            e = Math.round(e * 10000) * 0.0001;
            this.sValue = s;
            this.eValue = e;
        } else {
            s = this.sValue;
            e = this.eValue;
        }
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var pathsData;
        var pathData;
        var totalShapeLength;
        var totalModifierLength = 0;
        if (e === s) for(i = 0; i < len; i += 1){
            this.shapes[i].localShapeCollection.releaseShapes();
            this.shapes[i].shape._mdf = true;
            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
            if (this._mdf) this.shapes[i].pathsData.length = 0;
        }
        else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
            var segments = [];
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
                if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) shapeData.shape.paths = shapeData.localShapeCollection;
                else {
                    shapePaths = shapeData.shape.paths;
                    jLen = shapePaths._length;
                    totalShapeLength = 0;
                    if (!shapeData.shape._mdf && shapeData.pathsData.length) totalShapeLength = shapeData.totalShapeLength;
                    else {
                        pathsData = this.releasePathsData(shapeData.pathsData);
                        for(j = 0; j < jLen; j += 1){
                            pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
                            pathsData.push(pathData);
                            totalShapeLength += pathData.totalLength;
                        }
                        shapeData.totalShapeLength = totalShapeLength;
                        shapeData.pathsData = pathsData;
                    }
                    totalModifierLength += totalShapeLength;
                    shapeData.shape._mdf = true;
                }
            }
            var shapeS = s;
            var shapeE = e;
            var addedLength = 0;
            var edges;
            for(i = len - 1; i >= 0; i -= 1){
                shapeData = this.shapes[i];
                if (shapeData.shape._mdf) {
                    localShapeCollection = shapeData.localShapeCollection;
                    localShapeCollection.releaseShapes();
                    // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
                    if (this.m === 2 && len > 1) {
                        edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
                        addedLength += shapeData.totalShapeLength;
                    } else edges = [
                        [
                            shapeS,
                            shapeE
                        ]
                    ];
                    jLen = edges.length;
                    for(j = 0; j < jLen; j += 1){
                        shapeS = edges[j][0];
                        shapeE = edges[j][1];
                        segments.length = 0;
                        if (shapeE <= 1) segments.push({
                            s: shapeData.totalShapeLength * shapeS,
                            e: shapeData.totalShapeLength * shapeE
                        });
                        else if (shapeS >= 1) segments.push({
                            s: shapeData.totalShapeLength * (shapeS - 1),
                            e: shapeData.totalShapeLength * (shapeE - 1)
                        });
                        else {
                            segments.push({
                                s: shapeData.totalShapeLength * shapeS,
                                e: shapeData.totalShapeLength
                            });
                            segments.push({
                                s: 0,
                                e: shapeData.totalShapeLength * (shapeE - 1)
                            });
                        }
                        var newShapesData = this.addShapes(shapeData, segments[0]);
                        if (segments[0].s !== segments[0].e) {
                            if (segments.length > 1) {
                                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
                                if (lastShapeInCollection.c) {
                                    var lastShape = newShapesData.pop();
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1], lastShape);
                                } else {
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1]);
                                }
                            }
                            this.addPaths(newShapesData, localShapeCollection);
                        }
                    }
                    shapeData.shape.paths = localShapeCollection;
                }
            }
        } else if (this._mdf) for(i = 0; i < len; i += 1){
            // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
            // Don't remove this even if it's losing cached info.
            this.shapes[i].pathsData.length = 0;
            this.shapes[i].shape._mdf = true;
        }
    };
    TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
        var i;
        var len = newPaths.length;
        for(i = 0; i < len; i += 1)localShapeCollection.addShape(newPaths[i]);
    };
    TrimModifier.prototype.addSegment = function(pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
        shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
        shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
        shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
    };
    TrimModifier.prototype.addSegmentFromArray = function(points, shapePath, pos, newShape) {
        shapePath.setXYAt(points[1], points[5], 'o', pos);
        shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(points[0], points[4], 'v', pos);
        shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
    };
    TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath) {
        var pathsData = shapeData.pathsData;
        var shapePaths = shapeData.shape.paths.shapes;
        var i;
        var len = shapeData.shape.paths._length;
        var j;
        var jLen;
        var addedLength = 0;
        var currentLengthData;
        var segmentCount;
        var lengths;
        var segment;
        var shapes = [];
        var initPos;
        var newShape = true;
        if (!shapePath) {
            shapePath = shapePool.newElement();
            segmentCount = 0;
            initPos = 0;
        } else {
            segmentCount = shapePath._length;
            initPos = shapePath._length;
        }
        shapes.push(shapePath);
        for(i = 0; i < len; i += 1){
            lengths = pathsData[i].lengths;
            shapePath.c = shapePaths[i].c;
            jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
            for(j = 1; j < jLen; j += 1){
                currentLengthData = lengths[j - 1];
                if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
                    addedLength += currentLengthData.addedLength;
                    shapePath.c = false;
                } else if (addedLength > shapeSegment.e) {
                    shapePath.c = false;
                    break;
                } else {
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
                        // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                    addedLength += currentLengthData.addedLength;
                    segmentCount += 1;
                }
            }
            if (shapePaths[i].c && lengths.length) {
                currentLengthData = lengths[j - 1];
                if (addedLength <= shapeSegment.e) {
                    var segmentLength = lengths[j - 1].addedLength;
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
                        // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                } else shapePath.c = false;
                addedLength += currentLengthData.addedLength;
                segmentCount += 1;
            }
            if (shapePath._length) {
                shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
                shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
            }
            if (addedLength > shapeSegment.e) break;
            if (i < len - 1) {
                shapePath = shapePool.newElement();
                newShape = true;
                shapes.push(shapePath);
                segmentCount = 0;
            }
        }
        return shapes;
    };
    function PuckerAndBloatModifier() {}
    extendPrototype([
        ShapeModifier
    ], PuckerAndBloatModifier);
    PuckerAndBloatModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this._isAnimated = !!this.amount.effectsSequence.length;
    };
    PuckerAndBloatModifier.prototype.processPath = function(path, amount) {
        var percent = amount / 100;
        var centerPoint = [
            0,
            0
        ];
        var pathLength = path._length;
        var i = 0;
        for(i = 0; i < pathLength; i += 1){
            centerPoint[0] += path.v[i][0];
            centerPoint[1] += path.v[i][1];
        }
        centerPoint[0] /= pathLength;
        centerPoint[1] /= pathLength;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < pathLength; i += 1){
            vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
            vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
            oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
            oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
            iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
            iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
            clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
        }
        return clonedPath;
    };
    PuckerAndBloatModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    var TransformPropertyFactory = function() {
        var defaultVector = [
            0,
            0
        ];
        function applyToMatrix(mat) {
            var _mdf = this._mdf;
            this.iterateDynamicProperties();
            this._mdf = this._mdf || _mdf;
            if (this.a) mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            if (this.s) mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            if (this.sk) mat.skewFromAxis(-this.sk.v, this.sa.v);
            if (this.r) mat.rotate(-this.r.v);
            else mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            if (this.data.p.s) {
                if (this.data.p.z) mat.translate(this.px.v, this.py.v, -this.pz.v);
                else mat.translate(this.px.v, this.py.v, 0);
            } else mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
        function processKeys(forceRender) {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (this._isDirty) {
                this.precalculateMatrix();
                this._isDirty = false;
            }
            this.iterateDynamicProperties();
            if (this._mdf || forceRender) {
                var frameRate;
                this.v.cloneFromProps(this.pre.props);
                if (this.appliedTransformations < 1) this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                if (this.appliedTransformations < 2) this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                if (this.sk && this.appliedTransformations < 3) this.v.skewFromAxis(-this.sk.v, this.sa.v);
                if (this.r && this.appliedTransformations < 4) this.v.rotate(-this.r.v);
                else if (!this.r && this.appliedTransformations < 4) this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                if (this.autoOriented) {
                    var v1;
                    var v2;
                    frameRate = this.elem.globalData.frameRate;
                    if (this.p && this.p.keyframes && this.p.getValueAtTime) {
                        if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
                            v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
                            v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
                        } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                            v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
                            v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
                        } else {
                            v1 = this.p.pv;
                            v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
                        }
                    } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                        v1 = [];
                        v2 = [];
                        var px = this.px;
                        var py = this.py;
                        if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
                            v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
                            v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
                            v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
                            v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
                        } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
                            v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
                            v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
                            v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
                            v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
                        } else {
                            v1 = [
                                px.pv,
                                py.pv
                            ];
                            v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
                            v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
                        }
                    } else {
                        v2 = defaultVector;
                        v1 = v2;
                    }
                    this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
                }
                if (this.data.p && this.data.p.s) {
                    if (this.data.p.z) this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    else this.v.translate(this.px.v, this.py.v, 0);
                } else this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
            this.frameId = this.elem.globalData.frameId;
        }
        function precalculateMatrix() {
            this.appliedTransformations = 0;
            this.pre.reset();
            if (!this.a.effectsSequence.length) {
                this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                this.appliedTransformations = 1;
            } else return;
            if (!this.s.effectsSequence.length) {
                this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                this.appliedTransformations = 2;
            } else return;
            if (this.sk) {
                if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
                    this.pre.skewFromAxis(-this.sk.v, this.sa.v);
                    this.appliedTransformations = 3;
                } else return;
            }
            if (this.r) {
                if (!this.r.effectsSequence.length) {
                    this.pre.rotate(-this.r.v);
                    this.appliedTransformations = 4;
                }
            } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
                this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                this.appliedTransformations = 4;
            }
        }
        function autoOrient() {
        //
        // var prevP = this.getValueAtTime();
        }
        function addDynamicProperty(prop) {
            this._addDynamicProperty(prop);
            this.elem.addDynamicProperty(prop);
            this._isDirty = true;
        }
        function TransformProperty(elem, data, container) {
            this.elem = elem;
            this.frameId = -1;
            this.propType = 'transform';
            this.data = data;
            this.v = new Matrix();
            // Precalculated matrix with non animated properties
            this.pre = new Matrix();
            this.appliedTransformations = 0;
            this.initDynamicPropertyContainer(container || elem);
            if (data.p && data.p.s) {
                this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
                this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
                if (data.p.z) this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
            } else this.p = PropertyFactory.getProp(elem, data.p || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            if (data.rx) {
                this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
                this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
                this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
                if (data.or.k[0].ti) {
                    var i;
                    var len = data.or.k.length;
                    for(i = 0; i < len; i += 1){
                        data.or.k[i].to = null;
                        data.or.k[i].ti = null;
                    }
                }
                this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this);
                // sh Indicates it needs to be capped between -180 and 180
                this.or.sh = true;
            } else this.r = PropertyFactory.getProp(elem, data.r || {
                k: 0
            }, 0, degToRads, this);
            if (data.sk) {
                this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
                this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
            }
            this.a = PropertyFactory.getProp(elem, data.a || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: [
                    100,
                    100,
                    100
                ]
            }, 1, 0.01, this);
            // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
            if (data.o) this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
            else this.o = {
                _mdf: false,
                v: 1
            };
            this._isDirty = true;
            if (!this.dynamicProperties.length) this.getValue(true);
        }
        TransformProperty.prototype = {
            applyToMatrix: applyToMatrix,
            getValue: processKeys,
            precalculateMatrix: precalculateMatrix,
            autoOrient: autoOrient
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TransformProperty);
        TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
        TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
        function getTransformProperty(elem, data, container) {
            return new TransformProperty(elem, data, container);
        }
        return {
            getTransformProperty: getTransformProperty
        };
    }();
    function RepeaterModifier() {}
    extendPrototype([
        ShapeModifier
    ], RepeaterModifier);
    RepeaterModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
        this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
        this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
        this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
        this.data = data;
        if (!this.dynamicProperties.length) this.getValue(true);
        this._isAnimated = !!this.dynamicProperties.length;
        this.pMatrix = new Matrix();
        this.rMatrix = new Matrix();
        this.sMatrix = new Matrix();
        this.tMatrix = new Matrix();
        this.matrix = new Matrix();
    };
    RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv) {
        var dir = inv ? -1 : 1;
        var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
        var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
        pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
        rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        rMatrix.rotate(-transform.r.v * dir * perc);
        rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
        sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
        sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    };
    RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData) {
        this.elem = elem;
        this.arr = arr;
        this.pos = pos;
        this.elemsData = elemsData;
        this._currentCopies = 0;
        this._elements = [];
        this._groups = [];
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, arr[pos]);
        while(pos > 0){
            pos -= 1;
            // this._elements.unshift(arr.splice(pos,1)[0]);
            this._elements.unshift(arr[pos]);
        }
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    RepeaterModifier.prototype.resetElements = function(elements) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._processed = false;
            if (elements[i].ty === 'gr') this.resetElements(elements[i].it);
        }
    };
    RepeaterModifier.prototype.cloneElements = function(elements) {
        var newElements = JSON.parse(JSON.stringify(elements));
        this.resetElements(newElements);
        return newElements;
    };
    RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._render = renderFlag;
            if (elements[i].ty === 'gr') this.changeGroupRender(elements[i].it, renderFlag);
        }
    };
    RepeaterModifier.prototype.processShapes = function(_isFirstFrame) {
        var items;
        var itemsTransform;
        var i;
        var dir;
        var cont;
        var hasReloaded = false;
        if (this._mdf || _isFirstFrame) {
            var copies = Math.ceil(this.c.v);
            if (this._groups.length < copies) {
                while(this._groups.length < copies){
                    var group = {
                        it: this.cloneElements(this._elements),
                        ty: 'gr'
                    };
                    group.it.push({
                        a: {
                            a: 0,
                            ix: 1,
                            k: [
                                0,
                                0
                            ]
                        },
                        nm: 'Transform',
                        o: {
                            a: 0,
                            ix: 7,
                            k: 100
                        },
                        p: {
                            a: 0,
                            ix: 2,
                            k: [
                                0,
                                0
                            ]
                        },
                        r: {
                            a: 1,
                            ix: 6,
                            k: [
                                {
                                    s: 0,
                                    e: 0,
                                    t: 0
                                },
                                {
                                    s: 0,
                                    e: 0,
                                    t: 1
                                }
                            ]
                        },
                        s: {
                            a: 0,
                            ix: 3,
                            k: [
                                100,
                                100
                            ]
                        },
                        sa: {
                            a: 0,
                            ix: 5,
                            k: 0
                        },
                        sk: {
                            a: 0,
                            ix: 4,
                            k: 0
                        },
                        ty: 'tr'
                    });
                    this.arr.splice(0, 0, group);
                    this._groups.splice(0, 0, group);
                    this._currentCopies += 1;
                }
                this.elem.reloadShapes();
                hasReloaded = true;
            }
            cont = 0;
            var renderFlag;
            for(i = 0; i <= this._groups.length - 1; i += 1){
                renderFlag = cont < copies;
                this._groups[i]._render = renderFlag;
                this.changeGroupRender(this._groups[i].it, renderFlag);
                if (!renderFlag) {
                    var elems = this.elemsData[i].it;
                    var transformData = elems[elems.length - 1];
                    if (transformData.transform.op.v !== 0) {
                        transformData.transform.op._mdf = true;
                        transformData.transform.op.v = 0;
                    } else transformData.transform.op._mdf = false;
                }
                cont += 1;
            }
            this._currentCopies = copies;
            /// /
            var offset = this.o.v;
            var offsetModulo = offset % 1;
            var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
            var pProps = this.pMatrix.props;
            var rProps = this.rMatrix.props;
            var sProps = this.sMatrix.props;
            this.pMatrix.reset();
            this.rMatrix.reset();
            this.sMatrix.reset();
            this.tMatrix.reset();
            this.matrix.reset();
            var iteration = 0;
            if (offset > 0) {
                while(iteration < roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    iteration += 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
                    iteration += offsetModulo;
                }
            } else if (offset < 0) {
                while(iteration > roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
                    iteration -= 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
                    iteration -= offsetModulo;
                }
            }
            i = this.data.m === 1 ? 0 : this._currentCopies - 1;
            dir = this.data.m === 1 ? 1 : -1;
            cont = this._currentCopies;
            var j;
            var jLen;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                jLen = itemsTransform.length;
                items[items.length - 1].transform.mProps._mdf = true;
                items[items.length - 1].transform.op._mdf = true;
                items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
                if (iteration !== 0) {
                    if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
                    this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
                    this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                    this.matrix.reset();
                } else {
                    this.matrix.reset();
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                }
                iteration += 1;
                cont -= 1;
                i += dir;
            }
        } else {
            cont = this._currentCopies;
            i = 0;
            dir = 1;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                items[items.length - 1].transform.mProps._mdf = false;
                items[items.length - 1].transform.op._mdf = false;
                cont -= 1;
                i += dir;
            }
        }
        return hasReloaded;
    };
    RepeaterModifier.prototype.addShape = function() {};
    function RoundCornersModifier() {}
    extendPrototype([
        ShapeModifier
    ], RoundCornersModifier);
    RoundCornersModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this._isAnimated = !!this.rd.effectsSequence.length;
    };
    RoundCornersModifier.prototype.processPath = function(path, round) {
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var i;
        var len = path._length;
        var currentV;
        var currentI;
        var currentO;
        var closerV;
        var distance;
        var newPosPerc;
        var index = 0;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < len; i += 1){
            currentV = path.v[i];
            currentO = path.o[i];
            currentI = path.i[i];
            if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
                if ((i === 0 || i === len - 1) && !path.c) {
                    clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
                    /* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */ index += 1;
                } else {
                    if (i === 0) closerV = path.v[len - 1];
                    else closerV = path.v[i - 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = iX;
                    iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
                    vY = iY;
                    oX = vX - (vX - currentV[0]) * roundCorner;
                    oY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                    if (i === len - 1) closerV = path.v[0];
                    else closerV = path.v[i + 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = oX;
                    oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
                    vY = oY;
                    iX = vX - (vX - currentV[0]) * roundCorner;
                    iY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                }
            } else {
                clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
                index += 1;
            }
        }
        return clonedPath;
    };
    RoundCornersModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var rd = this.rd.v;
        if (rd !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function floatEqual(a, b) {
        return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
    }
    function floatZero(f) {
        return Math.abs(f) <= 0.00001;
    }
    function lerp(p0, p1, amount) {
        return p0 * (1 - amount) + p1 * amount;
    }
    function lerpPoint(p0, p1, amount) {
        return [
            lerp(p0[0], p1[0], amount),
            lerp(p0[1], p1[1], amount)
        ];
    }
    function quadRoots(a, b, c) {
        // no root
        if (a === 0) return [];
        var s = b * b - 4 * a * c;
        // Complex roots
        if (s < 0) return [];
        var singleRoot = -b / (2 * a);
        // 1 root
        if (s === 0) return [
            singleRoot
        ];
        var delta = Math.sqrt(s) / (2 * a);
        // 2 roots
        return [
            singleRoot - delta,
            singleRoot + delta
        ];
    }
    function polynomialCoefficients(p0, p1, p2, p3) {
        return [
            -p0 + 3 * p1 - 3 * p2 + p3,
            3 * p0 - 6 * p1 + 3 * p2,
            -3 * p0 + 3 * p1,
            p0
        ];
    }
    function singlePoint(p) {
        return new PolynomialBezier(p, p, p, p, false);
    }
    function PolynomialBezier(p0, p1, p2, p3, linearize) {
        if (linearize && pointEqual(p0, p1)) p1 = lerpPoint(p0, p3, 1 / 3);
        if (linearize && pointEqual(p2, p3)) p2 = lerpPoint(p0, p3, 2 / 3);
        var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
        var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
        this.a = [
            coeffx[0],
            coeffy[0]
        ];
        this.b = [
            coeffx[1],
            coeffy[1]
        ];
        this.c = [
            coeffx[2],
            coeffy[2]
        ];
        this.d = [
            coeffx[3],
            coeffy[3]
        ];
        this.points = [
            p0,
            p1,
            p2,
            p3
        ];
    }
    PolynomialBezier.prototype.point = function(t) {
        return [
            ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
            ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
        ];
    };
    PolynomialBezier.prototype.derivative = function(t) {
        return [
            (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
            (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
        ];
    };
    PolynomialBezier.prototype.tangentAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[1], p[0]);
    };
    PolynomialBezier.prototype.normalAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[0], p[1]);
    };
    PolynomialBezier.prototype.inflectionPoints = function() {
        var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
        if (floatZero(denom)) return [];
        var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
        var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
        if (square < 0) return [];
        var root = Math.sqrt(square);
        if (floatZero(root)) {
            if (root > 0 && root < 1) return [
                tcusp
            ];
            return [];
        }
        return [
            tcusp - root,
            tcusp + root
        ].filter(function(r) {
            return r > 0 && r < 1;
        });
    };
    PolynomialBezier.prototype.split = function(t) {
        if (t <= 0) return [
            singlePoint(this.points[0]),
            this
        ];
        if (t >= 1) return [
            this,
            singlePoint(this.points[this.points.length - 1])
        ];
        var p10 = lerpPoint(this.points[0], this.points[1], t);
        var p11 = lerpPoint(this.points[1], this.points[2], t);
        var p12 = lerpPoint(this.points[2], this.points[3], t);
        var p20 = lerpPoint(p10, p11, t);
        var p21 = lerpPoint(p11, p12, t);
        var p3 = lerpPoint(p20, p21, t);
        return [
            new PolynomialBezier(this.points[0], p10, p20, p3, true),
            new PolynomialBezier(p3, p21, p12, this.points[3], true)
        ];
    };
    function extrema(bez, comp) {
        var min = bez.points[0][comp];
        var max = bez.points[bez.points.length - 1][comp];
        if (min > max) {
            var e = max;
            max = min;
            min = e;
        }
        // Derivative roots to find min/max
        var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);
        for(var i = 0; i < f.length; i += 1)if (f[i] > 0 && f[i] < 1) {
            var val = bez.point(f[i])[comp];
            if (val < min) min = val;
            else if (val > max) max = val;
        }
        return {
            min: min,
            max: max
        };
    }
    PolynomialBezier.prototype.bounds = function() {
        return {
            x: extrema(this, 0),
            y: extrema(this, 1)
        };
    };
    PolynomialBezier.prototype.boundingBox = function() {
        var bounds = this.bounds();
        return {
            left: bounds.x.min,
            right: bounds.x.max,
            top: bounds.y.min,
            bottom: bounds.y.max,
            width: bounds.x.max - bounds.x.min,
            height: bounds.y.max - bounds.y.min,
            cx: (bounds.x.max + bounds.x.min) / 2,
            cy: (bounds.y.max + bounds.y.min) / 2
        };
    };
    function intersectData(bez, t1, t2) {
        var box = bez.boundingBox();
        return {
            cx: box.cx,
            cy: box.cy,
            width: box.width,
            height: box.height,
            bez: bez,
            t: (t1 + t2) / 2,
            t1: t1,
            t2: t2
        };
    }
    function splitData(data) {
        var split = data.bez.split(0.5);
        return [
            intersectData(split[0], data.t1, data.t),
            intersectData(split[1], data.t, data.t2)
        ];
    }
    function boxIntersect(b1, b2) {
        return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
    }
    function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
        if (!boxIntersect(d1, d2)) return;
        if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
            intersections.push([
                d1.t,
                d2.t
            ]);
            return;
        }
        var d1s = splitData(d1);
        var d2s = splitData(d2);
        intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
    }
    PolynomialBezier.prototype.intersections = function(other, tolerance, maxRecursion) {
        if (tolerance === undefined) tolerance = 2;
        if (maxRecursion === undefined) maxRecursion = 7;
        var intersections = [];
        intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
        return intersections;
    };
    PolynomialBezier.shapeSegment = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
    };
    PolynomialBezier.shapeSegmentInverted = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
    };
    function crossProduct(a, b) {
        return [
            a[1] * b[2] - a[2] * b[1],
            a[2] * b[0] - a[0] * b[2],
            a[0] * b[1] - a[1] * b[0]
        ];
    }
    function lineIntersection(start1, end1, start2, end2) {
        var v1 = [
            start1[0],
            start1[1],
            1
        ];
        var v2 = [
            end1[0],
            end1[1],
            1
        ];
        var v3 = [
            start2[0],
            start2[1],
            1
        ];
        var v4 = [
            end2[0],
            end2[1],
            1
        ];
        var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
        if (floatZero(r[2])) return null;
        return [
            r[0] / r[2],
            r[1] / r[2]
        ];
    }
    function polarOffset(p, angle, length) {
        return [
            p[0] + Math.cos(angle) * length,
            p[1] - Math.sin(angle) * length
        ];
    }
    function pointDistance(p1, p2) {
        return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
    }
    function pointEqual(p1, p2) {
        return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
    }
    function ZigZagModifier() {}
    extendPrototype([
        ShapeModifier
    ], ZigZagModifier);
    ZigZagModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
        this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
        this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
        var angO = angle - Math.PI / 2;
        var angI = angle + Math.PI / 2;
        var px = point[0] + Math.cos(angle) * direction * amplitude;
        var py = point[1] - Math.sin(angle) * direction * amplitude;
        outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
    }
    function getPerpendicularVector(pt1, pt2) {
        var vector = [
            pt2[0] - pt1[0],
            pt2[1] - pt1[1]
        ];
        var rot = -Math.PI * 0.5;
        var rotatedVector = [
            Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1],
            Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]
        ];
        return rotatedVector;
    }
    function getProjectingAngle(path, cur) {
        var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
        var nextIndex = (cur + 1) % path.length();
        var prevPoint = path.v[prevIndex];
        var nextPoint = path.v[nextIndex];
        var pVector = getPerpendicularVector(prevPoint, nextPoint);
        return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
    }
    function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
        var angle = getProjectingAngle(path, cur);
        var point = path.v[cur % path._length];
        var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
        var nextPoint = path.v[(cur + 1) % path._length];
        var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
        var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
        setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2), pointType);
    }
    function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
        for(var i = 0; i < frequency; i += 1){
            var t = (i + 1) / (frequency + 1);
            var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
            var angle = segment.normalAngle(t);
            var point = segment.point(t);
            setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2), pointType);
            direction = -direction;
        }
        return direction;
    }
    ZigZagModifier.prototype.processPath = function(path, amplitude, frequency, pointType) {
        var count = path._length;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        if (!path.c) count -= 1;
        if (count === 0) return clonedPath;
        var direction = -1;
        var segment = PolynomialBezier.shapeSegment(path, 0);
        zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);
        for(var i = 0; i < count; i += 1){
            direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);
            if (i === count - 1 && !path.c) segment = null;
            else segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
            zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
        }
        return clonedPath;
    };
    ZigZagModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amplitude = this.amplitude.v;
        var frequency = Math.max(0, Math.round(this.frequency.v));
        var pointType = this.pointsType.v;
        if (amplitude !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function linearOffset(p1, p2, amount) {
        var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
        return [
            polarOffset(p1, angle, amount),
            polarOffset(p2, angle, amount)
        ];
    }
    function offsetSegment(segment, amount) {
        var p0;
        var p1a;
        var p1b;
        var p2b;
        var p2a;
        var p3;
        var e;
        e = linearOffset(segment.points[0], segment.points[1], amount);
        p0 = e[0];
        p1a = e[1];
        e = linearOffset(segment.points[1], segment.points[2], amount);
        p1b = e[0];
        p2b = e[1];
        e = linearOffset(segment.points[2], segment.points[3], amount);
        p2a = e[0];
        p3 = e[1];
        var p1 = lineIntersection(p0, p1a, p1b, p2b);
        if (p1 === null) p1 = p1a;
        var p2 = lineIntersection(p2a, p3, p1b, p2b);
        if (p2 === null) p2 = p2a;
        return new PolynomialBezier(p0, p1, p2, p3);
    }
    function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
        var p0 = seg1.points[3];
        var p1 = seg2.points[0];
        // Bevel
        if (lineJoin === 3) return p0;
        // Connected, they don't need a joint
        if (pointEqual(p0, p1)) return p0;
        // Round
        if (lineJoin === 2) {
            var angleOut = -seg1.tangentAngle(1);
            var angleIn = -seg2.tangentAngle(0) + Math.PI;
            var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
            var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
            var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
            outputBezier.setXYAt(tan[0], tan[1], 'o', outputBezier.length() - 1);
            tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
            outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
            return p1;
        }
        // Miter
        var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
        var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
        var intersection = lineIntersection(t0, p0, p1, t1);
        if (intersection && pointDistance(intersection, p0) < miterLimit) {
            outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
            return intersection;
        }
        return p0;
    }
    function getIntersection(a, b) {
        var intersect = a.intersections(b);
        if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
        if (intersect.length) return intersect[0];
        return null;
    }
    function pruneSegmentIntersection(a, b) {
        var outa = a.slice();
        var outb = b.slice();
        var intersect = getIntersection(a[a.length - 1], b[0]);
        if (intersect) {
            outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
            outb[0] = b[0].split(intersect[1])[1];
        }
        if (a.length > 1 && b.length > 1) {
            intersect = getIntersection(a[0], b[b.length - 1]);
            if (intersect) return [
                [
                    a[0].split(intersect[0])[0]
                ],
                [
                    b[b.length - 1].split(intersect[1])[1]
                ]
            ];
        }
        return [
            outa,
            outb
        ];
    }
    function pruneIntersections(segments) {
        var e;
        for(var i = 1; i < segments.length; i += 1){
            e = pruneSegmentIntersection(segments[i - 1], segments[i]);
            segments[i - 1] = e[0];
            segments[i] = e[1];
        }
        if (segments.length > 1) {
            e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
            segments[segments.length - 1] = e[0];
            segments[0] = e[1];
        }
        return segments;
    }
    function offsetSegmentSplit(segment, amount) {
        /*
      We split each bezier segment into smaller pieces based
      on inflection points, this ensures the control point
      polygon is convex.
       (A cubic bezier can have none, one, or two inflection points)
    */ var flex = segment.inflectionPoints();
        var left;
        var right;
        var split;
        var mid;
        if (flex.length === 0) return [
            offsetSegment(segment, amount)
        ];
        if (flex.length === 1 || floatEqual(flex[1], 1)) {
            split = segment.split(flex[0]);
            left = split[0];
            right = split[1];
            return [
                offsetSegment(left, amount),
                offsetSegment(right, amount)
            ];
        }
        split = segment.split(flex[0]);
        left = split[0];
        var t = (flex[1] - flex[0]) / (1 - flex[0]);
        split = split[1].split(t);
        mid = split[0];
        right = split[1];
        return [
            offsetSegment(left, amount),
            offsetSegment(mid, amount),
            offsetSegment(right, amount)
        ];
    }
    function OffsetPathModifier() {}
    extendPrototype([
        ShapeModifier
    ], OffsetPathModifier);
    OffsetPathModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
        this.lineJoin = data.lj;
        this._isAnimated = this.amount.effectsSequence.length !== 0;
    };
    OffsetPathModifier.prototype.processPath = function(inputBezier, amount, lineJoin, miterLimit) {
        var outputBezier = shapePool.newElement();
        outputBezier.c = inputBezier.c;
        var count = inputBezier.length();
        if (!inputBezier.c) count -= 1;
        var i;
        var j;
        var segment;
        var multiSegments = [];
        for(i = 0; i < count; i += 1){
            segment = PolynomialBezier.shapeSegment(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        if (!inputBezier.c) for(i = count - 1; i >= 0; i -= 1){
            segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        multiSegments = pruneIntersections(multiSegments);
        // Add bezier segments to the output and apply line joints
        var lastPoint = null;
        var lastSeg = null;
        for(i = 0; i < multiSegments.length; i += 1){
            var multiSegment = multiSegments[i];
            if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
            lastSeg = multiSegment[multiSegment.length - 1];
            for(j = 0; j < multiSegment.length; j += 1){
                segment = multiSegment[j];
                if (lastPoint && pointEqual(segment.points[0], lastPoint)) outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], 'o', outputBezier.length() - 1);
                else outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
                outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
                lastPoint = segment.points[3];
            }
        }
        if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
        return outputBezier;
    };
    OffsetPathModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        var miterLimit = this.miterLimit.v;
        var lineJoin = this.lineJoin;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function getFontProperties(fontData) {
        var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
        var fWeight = 'normal';
        var fStyle = 'normal';
        var len = styles.length;
        var styleName;
        for(var i = 0; i < len; i += 1){
            styleName = styles[i].toLowerCase();
            switch(styleName){
                case 'italic':
                    fStyle = 'italic';
                    break;
                case 'bold':
                    fWeight = '700';
                    break;
                case 'black':
                    fWeight = '900';
                    break;
                case 'medium':
                    fWeight = '500';
                    break;
                case 'regular':
                case 'normal':
                    fWeight = '400';
                    break;
                case 'light':
                case 'thin':
                    fWeight = '200';
                    break;
                default:
                    break;
            }
        }
        return {
            style: fStyle,
            weight: fontData.fWeight || fWeight
        };
    }
    var FontManager = function() {
        var maxWaitingTime = 5000;
        var emptyChar = {
            w: 0,
            size: 0,
            shapes: [],
            data: {
                shapes: []
            }
        };
        var combinedCharacters = [];
        // Hindi characters
        combinedCharacters = combinedCharacters.concat([
            2304,
            2305,
            2306,
            2307,
            2362,
            2363,
            2364,
            2364,
            2366,
            2367,
            2368,
            2369,
            2370,
            2371,
            2372,
            2373,
            2374,
            2375,
            2376,
            2377,
            2378,
            2379,
            2380,
            2381,
            2382,
            2383,
            2387,
            2388,
            2389,
            2390,
            2391,
            2402,
            2403
        ]);
        var BLACK_FLAG_CODE_POINT = 127988;
        var CANCEL_TAG_CODE_POINT = 917631;
        var A_TAG_CODE_POINT = 917601;
        var Z_TAG_CODE_POINT = 917626;
        var VARIATION_SELECTOR_16_CODE_POINT = 65039;
        var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
        var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
        var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
        var surrogateModifiers = [
            'd83cdffb',
            'd83cdffc',
            'd83cdffd',
            'd83cdffe',
            'd83cdfff'
        ];
        function trimFontOptions(font) {
            var familyArray = font.split(',');
            var i;
            var len = familyArray.length;
            var enabledFamilies = [];
            for(i = 0; i < len; i += 1)if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') enabledFamilies.push(familyArray[i]);
            return enabledFamilies.join(',');
        }
        function setUpNode(font, family) {
            var parentNode = createTag('span');
            // Node is invisible to screen readers.
            parentNode.setAttribute('aria-hidden', true);
            parentNode.style.fontFamily = family;
            var node = createTag('span');
            // Characters that vary significantly among different fonts
            node.innerText = 'giItT1WQy@!-/#';
            // Visible - so we can measure it - but not on the screen
            parentNode.style.position = 'absolute';
            parentNode.style.left = '-10000px';
            parentNode.style.top = '-10000px';
            // Large font size makes even subtle changes obvious
            parentNode.style.fontSize = '300px';
            // Reset any font properties
            parentNode.style.fontVariant = 'normal';
            parentNode.style.fontStyle = 'normal';
            parentNode.style.fontWeight = 'normal';
            parentNode.style.letterSpacing = '0';
            parentNode.appendChild(node);
            document.body.appendChild(parentNode);
            // Remember width with no applied web font
            var width = node.offsetWidth;
            node.style.fontFamily = trimFontOptions(font) + ', ' + family;
            return {
                node: node,
                w: width,
                parent: parentNode
            };
        }
        function checkLoadedFonts() {
            var i;
            var len = this.fonts.length;
            var node;
            var w;
            var loadedCount = len;
            for(i = 0; i < len; i += 1){
                if (this.fonts[i].loaded) loadedCount -= 1;
                else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) this.fonts[i].loaded = true;
                else {
                    node = this.fonts[i].monoCase.node;
                    w = this.fonts[i].monoCase.w;
                    if (node.offsetWidth !== w) {
                        loadedCount -= 1;
                        this.fonts[i].loaded = true;
                    } else {
                        node = this.fonts[i].sansCase.node;
                        w = this.fonts[i].sansCase.w;
                        if (node.offsetWidth !== w) {
                            loadedCount -= 1;
                            this.fonts[i].loaded = true;
                        }
                    }
                    if (this.fonts[i].loaded) {
                        this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
                        this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
                    }
                }
            }
            if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) setTimeout(this.checkLoadedFontsBinded, 20);
            else setTimeout(this.setIsLoadedBinded, 10);
        }
        function createHelper(fontData, def) {
            var engine = document.body && def ? 'svg' : 'canvas';
            var helper;
            var fontProps = getFontProperties(fontData);
            if (engine === 'svg') {
                var tHelper = createNS('text');
                tHelper.style.fontSize = '100px';
                // tHelper.style.fontFamily = fontData.fFamily;
                tHelper.setAttribute('font-family', fontData.fFamily);
                tHelper.setAttribute('font-style', fontProps.style);
                tHelper.setAttribute('font-weight', fontProps.weight);
                tHelper.textContent = '1';
                if (fontData.fClass) {
                    tHelper.style.fontFamily = 'inherit';
                    tHelper.setAttribute('class', fontData.fClass);
                } else tHelper.style.fontFamily = fontData.fFamily;
                def.appendChild(tHelper);
                helper = tHelper;
            } else {
                var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
                tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
                helper = tCanvasHelper;
            }
            function measure(text) {
                if (engine === 'svg') {
                    helper.textContent = text;
                    return helper.getComputedTextLength();
                }
                return helper.measureText(text).width;
            }
            return {
                measureText: measure
            };
        }
        function addFonts(fontData, defs) {
            if (!fontData) {
                this.isLoaded = true;
                return;
            }
            if (this.chars) {
                this.isLoaded = true;
                this.fonts = fontData.list;
                return;
            }
            if (!document.body) {
                this.isLoaded = true;
                fontData.list.forEach(function(data) {
                    data.helper = createHelper(data);
                    data.cache = {};
                });
                this.fonts = fontData.list;
                return;
            }
            var fontArr = fontData.list;
            var i;
            var len = fontArr.length;
            var _pendingFonts = len;
            for(i = 0; i < len; i += 1){
                var shouldLoadFont = true;
                var loadedSelector;
                var j;
                fontArr[i].loaded = false;
                fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
                fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');
                if (!fontArr[i].fPath) {
                    fontArr[i].loaded = true;
                    _pendingFonts -= 1;
                } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
                    loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');
                    if (loadedSelector.length > 0) shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var s = createTag('style');
                        s.setAttribute('f-forigin', fontArr[i].fOrigin);
                        s.setAttribute('f-origin', fontArr[i].origin);
                        s.setAttribute('f-family', fontArr[i].fFamily);
                        s.type = 'text/css';
                        s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
                        defs.appendChild(s);
                    }
                } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
                    loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var l = createTag('link');
                        l.setAttribute('f-forigin', fontArr[i].fOrigin);
                        l.setAttribute('f-origin', fontArr[i].origin);
                        l.type = 'text/css';
                        l.rel = 'stylesheet';
                        l.href = fontArr[i].fPath;
                        document.body.appendChild(l);
                    }
                } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
                    loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (fontArr[i].fPath === loadedSelector[j].src) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var sc = createTag('link');
                        sc.setAttribute('f-forigin', fontArr[i].fOrigin);
                        sc.setAttribute('f-origin', fontArr[i].origin);
                        sc.setAttribute('rel', 'stylesheet');
                        sc.setAttribute('href', fontArr[i].fPath);
                        defs.appendChild(sc);
                    }
                }
                fontArr[i].helper = createHelper(fontArr[i], defs);
                fontArr[i].cache = {};
                this.fonts.push(fontArr[i]);
            }
            if (_pendingFonts === 0) this.isLoaded = true;
            else // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
            // Adding this timeout seems to fix it
            setTimeout(this.checkLoadedFonts.bind(this), 100);
        }
        function addChars(chars) {
            if (!chars) return;
            if (!this.chars) this.chars = [];
            var i;
            var len = chars.length;
            var j;
            var jLen = this.chars.length;
            var found;
            for(i = 0; i < len; i += 1){
                j = 0;
                found = false;
                while(j < jLen){
                    if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) found = true;
                    j += 1;
                }
                if (!found) {
                    this.chars.push(chars[i]);
                    jLen += 1;
                }
            }
        }
        function getCharData(_char, style, font) {
            var i = 0;
            var len = this.chars.length;
            while(i < len){
                if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) return this.chars[i];
                i += 1;
            }
            if ((typeof _char === 'string' && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
             && !this._warned) {
                this._warned = true;
                console.warn('Missing character from exported characters list: ', _char, style, font); // eslint-disable-line no-console
            }
            return emptyChar;
        }
        function measureText(_char2, fontName, size) {
            var fontData = this.getFontByName(fontName);
            // Using the char instead of char.charCodeAt(0)
            // to avoid collisions between equal chars
            var index = _char2;
            if (!fontData.cache[index]) {
                var tHelper = fontData.helper;
                if (_char2 === ' ') {
                    var doubleSize = tHelper.measureText('|' + _char2 + '|');
                    var singleSize = tHelper.measureText('||');
                    fontData.cache[index] = (doubleSize - singleSize) / 100;
                } else fontData.cache[index] = tHelper.measureText(_char2) / 100;
            }
            return fontData.cache[index] * size;
        }
        function getFontByName(name) {
            var i = 0;
            var len = this.fonts.length;
            while(i < len){
                if (this.fonts[i].fName === name) return this.fonts[i];
                i += 1;
            }
            return this.fonts[0];
        }
        function getCodePoint(string) {
            var codePoint = 0;
            var first = string.charCodeAt(0);
            if (first >= 0xD800 && first <= 0xDBFF) {
                var second = string.charCodeAt(1);
                if (second >= 0xDC00 && second <= 0xDFFF) codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
            }
            return codePoint;
        }
        // Skin tone modifiers
        function isModifier(firstCharCode, secondCharCode) {
            var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
            return surrogateModifiers.indexOf(sum) !== -1;
        }
        function isZeroWidthJoiner(charCode) {
            return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
        }
        // This codepoint may change the appearance of the preceding character.
        // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
        // as a colorful image as compared to a monochrome text variant.
        function isVariationSelector(charCode) {
            return charCode === VARIATION_SELECTOR_16_CODE_POINT;
        }
        // The regional indicator symbols are a set of 26 alphabetic Unicode
        /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
        // two-letter country codes in a way that allows optional special treatment.
        function isRegionalCode(string) {
            var codePoint = getCodePoint(string);
            if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) return true;
            return false;
        }
        // Some Emoji implementations represent combinations of
        // two “regional indicator” letters as a single flag symbol.
        function isFlagEmoji(string) {
            return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
        }
        function isCombinedCharacter(_char3) {
            return combinedCharacters.indexOf(_char3) !== -1;
        }
        // Regional flags start with a BLACK_FLAG_CODE_POINT
        // folowed by 5 chars in the TAG range
        // and end with a CANCEL_TAG_CODE_POINT
        function isRegionalFlag(text, index) {
            var codePoint = getCodePoint(text.substr(index, 2));
            if (codePoint !== BLACK_FLAG_CODE_POINT) return false;
            var count = 0;
            index += 2;
            while(count < 5){
                codePoint = getCodePoint(text.substr(index, 2));
                if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) return false;
                count += 1;
                index += 2;
            }
            return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
        }
        function setIsLoaded() {
            this.isLoaded = true;
        }
        var Font = function Font() {
            this.fonts = [];
            this.chars = null;
            this.typekitLoaded = 0;
            this.isLoaded = false;
            this._warned = false;
            this.initTime = Date.now();
            this.setIsLoadedBinded = this.setIsLoaded.bind(this);
            this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
        };
        Font.isModifier = isModifier;
        Font.isZeroWidthJoiner = isZeroWidthJoiner;
        Font.isFlagEmoji = isFlagEmoji;
        Font.isRegionalCode = isRegionalCode;
        Font.isCombinedCharacter = isCombinedCharacter;
        Font.isRegionalFlag = isRegionalFlag;
        Font.isVariationSelector = isVariationSelector;
        Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
        var fontPrototype = {
            addChars: addChars,
            addFonts: addFonts,
            getCharData: getCharData,
            getFontByName: getFontByName,
            measureText: measureText,
            checkLoadedFonts: checkLoadedFonts,
            setIsLoaded: setIsLoaded
        };
        Font.prototype = fontPrototype;
        return Font;
    }();
    function SlotManager(animationData) {
        this.animationData = animationData;
    }
    SlotManager.prototype.getProp = function(data) {
        if (this.animationData.slots && this.animationData.slots[data.sid]) return Object.assign(data, this.animationData.slots[data.sid].p);
        return data;
    };
    function slotFactory(animationData) {
        return new SlotManager(animationData);
    }
    function RenderableElement() {}
    RenderableElement.prototype = {
        initRenderable: function initRenderable() {
            // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
            this.isInRange = false;
            // layer's display state
            this.hidden = false;
            // If layer's transparency equals 0, it can be hidden
            this.isTransparent = false;
            // list of animated components
            this.renderableComponents = [];
        },
        addRenderableComponent: function addRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) === -1) this.renderableComponents.push(component);
        },
        removeRenderableComponent: function removeRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) !== -1) this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
        },
        prepareRenderableFrame: function prepareRenderableFrame(num) {
            this.checkLayerLimits(num);
        },
        checkTransparency: function checkTransparency() {
            if (this.finalTransform.mProp.o.v <= 0) {
                if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
                    this.isTransparent = true;
                    this.hide();
                }
            } else if (this.isTransparent) {
                this.isTransparent = false;
                this.show();
            }
        },
        /**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */ checkLayerLimits: function checkLayerLimits(num) {
            if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
                if (this.isInRange !== true) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                    this.isInRange = true;
                    this.show();
                }
            } else if (this.isInRange !== false) {
                this.globalData._mdf = true;
                this.isInRange = false;
                this.hide();
            }
        },
        renderRenderable: function renderRenderable() {
            var i;
            var len = this.renderableComponents.length;
            for(i = 0; i < len; i += 1)this.renderableComponents[i].renderFrame(this._isFirstFrame);
        /* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */ },
        sourceRectAtTime: function sourceRectAtTime() {
            return {
                top: 0,
                left: 0,
                width: 100,
                height: 100
            };
        },
        getLayerSize: function getLayerSize() {
            if (this.data.ty === 5) return {
                w: this.data.textData.width,
                h: this.data.textData.height
            };
            return {
                w: this.data.width,
                h: this.data.height
            };
        }
    };
    var getBlendMode = function() {
        var blendModeEnums = {
            0: 'source-over',
            1: 'multiply',
            2: 'screen',
            3: 'overlay',
            4: 'darken',
            5: 'lighten',
            6: 'color-dodge',
            7: 'color-burn',
            8: 'hard-light',
            9: 'soft-light',
            10: 'difference',
            11: 'exclusion',
            12: 'hue',
            13: 'saturation',
            14: 'color',
            15: 'luminosity'
        };
        return function(mode) {
            return blendModeEnums[mode] || '';
        };
    }();
    function SliderEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function AngleEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function ColorEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function PointEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function LayerIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function MaskIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function CheckboxEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function NoValueEffect() {
        this.p = {};
    }
    function EffectsManager(data, element) {
        var effects = data.ef || [];
        this.effectElements = [];
        var i;
        var len = effects.length;
        var effectItem;
        for(i = 0; i < len; i += 1){
            effectItem = new GroupEffect(effects[i], element);
            this.effectElements.push(effectItem);
        }
    }
    function GroupEffect(data, element) {
        this.init(data, element);
    }
    extendPrototype([
        DynamicPropertyContainer
    ], GroupEffect);
    GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
    GroupEffect.prototype.init = function(data, element) {
        this.data = data;
        this.effectElements = [];
        this.initDynamicPropertyContainer(element);
        var i;
        var len = this.data.ef.length;
        var eff;
        var effects = this.data.ef;
        for(i = 0; i < len; i += 1){
            eff = null;
            switch(effects[i].ty){
                case 0:
                    eff = new SliderEffect(effects[i], element, this);
                    break;
                case 1:
                    eff = new AngleEffect(effects[i], element, this);
                    break;
                case 2:
                    eff = new ColorEffect(effects[i], element, this);
                    break;
                case 3:
                    eff = new PointEffect(effects[i], element, this);
                    break;
                case 4:
                case 7:
                    eff = new CheckboxEffect(effects[i], element, this);
                    break;
                case 10:
                    eff = new LayerIndexEffect(effects[i], element, this);
                    break;
                case 11:
                    eff = new MaskIndexEffect(effects[i], element, this);
                    break;
                case 5:
                    eff = new EffectsManager(effects[i], element, this);
                    break;
                // case 6:
                default:
                    eff = new NoValueEffect(effects[i], element, this);
                    break;
            }
            if (eff) this.effectElements.push(eff);
        }
    };
    function BaseElement() {}
    BaseElement.prototype = {
        checkMasks: function checkMasks() {
            if (!this.data.hasMask) return false;
            var i = 0;
            var len = this.data.masksProperties.length;
            while(i < len){
                if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) return true;
                i += 1;
            }
            return false;
        },
        initExpressions: function initExpressions() {
            var expressionsInterfaces = getExpressionInterfaces();
            if (!expressionsInterfaces) return;
            var LayerExpressionInterface = expressionsInterfaces('layer');
            var EffectsExpressionInterface = expressionsInterfaces('effects');
            var ShapeExpressionInterface = expressionsInterfaces('shape');
            var TextExpressionInterface = expressionsInterfaces('text');
            var CompExpressionInterface = expressionsInterfaces('comp');
            this.layerInterface = LayerExpressionInterface(this);
            if (this.data.hasMask && this.maskManager) this.layerInterface.registerMaskInterface(this.maskManager);
            var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
            this.layerInterface.registerEffectsInterface(effectsInterface);
            if (this.data.ty === 0 || this.data.xt) this.compInterface = CompExpressionInterface(this);
            else if (this.data.ty === 4) {
                this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
                this.layerInterface.content = this.layerInterface.shapeInterface;
            } else if (this.data.ty === 5) {
                this.layerInterface.textInterface = TextExpressionInterface(this);
                this.layerInterface.text = this.layerInterface.textInterface;
            }
        },
        setBlendMode: function setBlendMode() {
            var blendModeValue = getBlendMode(this.data.bm);
            var elem = this.baseElement || this.layerElement;
            elem.style['mix-blend-mode'] = blendModeValue;
        },
        initBaseData: function initBaseData(data, globalData, comp) {
            this.globalData = globalData;
            this.comp = comp;
            this.data = data;
            this.layerId = createElementID();
            // Stretch factor for old animations missing this property.
            if (!this.data.sr) this.data.sr = 1;
            // effects manager
            this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
        },
        getType: function getType() {
            return this.type;
        },
        sourceRectAtTime: function sourceRectAtTime() {}
    };
    /**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */ function FrameElement() {}
    FrameElement.prototype = {
        /**
       * @function
       * Initializes frame related properties.
       *
       */ initFrame: function initFrame() {
            // set to true when inpoint is rendered
            this._isFirstFrame = false;
            // list of animated properties
            this.dynamicProperties = [];
            // If layer has been modified in current tick this will be true
            this._mdf = false;
        },
        /**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */ prepareProperties: function prepareProperties(num, isVisible) {
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1)if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                }
            }
        },
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) this.dynamicProperties.push(prop);
        }
    };
    function FootageElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.footageData = globalData.imageLoader.getAsset(this.assetData);
        this.initBaseData(data, globalData, comp);
    }
    FootageElement.prototype.prepareFrame = function() {};
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], FootageElement);
    FootageElement.prototype.getBaseElement = function() {
        return null;
    };
    FootageElement.prototype.renderFrame = function() {};
    FootageElement.prototype.destroy = function() {};
    FootageElement.prototype.initExpressions = function() {
        var expressionsInterfaces = getExpressionInterfaces();
        if (!expressionsInterfaces) return;
        var FootageInterface = expressionsInterfaces('footage');
        this.layerInterface = FootageInterface(this);
    };
    FootageElement.prototype.getFootageData = function() {
        return this.footageData;
    };
    function AudioElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.initBaseData(data, globalData, comp);
        this._isPlaying = false;
        this._canPlay = false;
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.audio = this.globalData.audioController.createAudio(assetPath);
        this._currentTime = 0;
        this.globalData.audioController.addAudio(this);
        this._volumeMultiplier = 1;
        this._volume = 1;
        this._previousVolume = null;
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
        this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
            k: [
                100
            ]
        }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(num) {
        this.prepareRenderableFrame(num, true);
        this.prepareProperties(num, true);
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            this._currentTime = timeRemapped;
        } else this._currentTime = num / this.data.sr;
        this._volume = this.lv.v[0];
        var totalVolume = this._volume * this._volumeMultiplier;
        if (this._previousVolume !== totalVolume) {
            this._previousVolume = totalVolume;
            this.audio.volume(totalVolume);
        }
    };
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], AudioElement);
    AudioElement.prototype.renderFrame = function() {
        if (this.isInRange && this._canPlay) {
            if (!this._isPlaying) {
                this.audio.play();
                this.audio.seek(this._currentTime / this.globalData.frameRate);
                this._isPlaying = true;
            } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) this.audio.seek(this._currentTime / this.globalData.frameRate);
        }
    };
    AudioElement.prototype.show = function() {
    // this.audio.play()
    };
    AudioElement.prototype.hide = function() {
        this.audio.pause();
        this._isPlaying = false;
    };
    AudioElement.prototype.pause = function() {
        this.audio.pause();
        this._isPlaying = false;
        this._canPlay = false;
    };
    AudioElement.prototype.resume = function() {
        this._canPlay = true;
    };
    AudioElement.prototype.setRate = function(rateValue) {
        this.audio.rate(rateValue);
    };
    AudioElement.prototype.volume = function(volumeValue) {
        this._volumeMultiplier = volumeValue;
        this._previousVolume = volumeValue * this._volume;
        this.audio.volume(this._previousVolume);
    };
    AudioElement.prototype.getBaseElement = function() {
        return null;
    };
    AudioElement.prototype.destroy = function() {};
    AudioElement.prototype.sourceRectAtTime = function() {};
    AudioElement.prototype.initExpressions = function() {};
    function BaseRenderer() {}
    BaseRenderer.prototype.checkLayers = function(num) {
        var i;
        var len = this.layers.length;
        var data;
        this.completeLayers = true;
        for(i = len - 1; i >= 0; i -= 1){
            if (!this.elements[i]) {
                data = this.layers[i];
                if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) this.buildItem(i);
            }
            this.completeLayers = this.elements[i] ? this.completeLayers : false;
        }
        this.checkPendingElements();
    };
    BaseRenderer.prototype.createItem = function(layer) {
        switch(layer.ty){
            case 2:
                return this.createImage(layer);
            case 0:
                return this.createComp(layer);
            case 1:
                return this.createSolid(layer);
            case 3:
                return this.createNull(layer);
            case 4:
                return this.createShape(layer);
            case 5:
                return this.createText(layer);
            case 6:
                return this.createAudio(layer);
            case 13:
                return this.createCamera(layer);
            case 15:
                return this.createFootage(layer);
            default:
                return this.createNull(layer);
        }
    };
    BaseRenderer.prototype.createCamera = function() {
        throw new Error('You\'re using a 3d camera. Try the html renderer.');
    };
    BaseRenderer.prototype.createAudio = function(data) {
        return new AudioElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.createFootage = function(data) {
        return new FootageElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.buildAllItems = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)this.buildItem(i);
        this.checkPendingElements();
    };
    BaseRenderer.prototype.includeLayers = function(newLayers) {
        this.completeLayers = false;
        var i;
        var len = newLayers.length;
        var j;
        var jLen = this.layers.length;
        for(i = 0; i < len; i += 1){
            j = 0;
            while(j < jLen){
                if (this.layers[j].id === newLayers[i].id) {
                    this.layers[j] = newLayers[i];
                    break;
                }
                j += 1;
            }
        }
    };
    BaseRenderer.prototype.setProjectInterface = function(pInterface) {
        this.globalData.projectInterface = pInterface;
    };
    BaseRenderer.prototype.initItems = function() {
        if (!this.globalData.progressiveLoad) this.buildAllItems();
    };
    BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy) {
        var elements = this.elements;
        var layers = this.layers;
        var i = 0;
        var len = layers.length;
        while(i < len){
            if (layers[i].ind == parentName) {
                // eslint-disable-line eqeqeq
                if (!elements[i] || elements[i] === true) {
                    this.buildItem(i);
                    this.addPendingElement(element);
                } else {
                    hierarchy.push(elements[i]);
                    elements[i].setAsParent();
                    if (layers[i].parent !== undefined) this.buildElementParenting(element, layers[i].parent, hierarchy);
                    else element.setHierarchy(hierarchy);
                }
            }
            i += 1;
        }
    };
    BaseRenderer.prototype.addPendingElement = function(element) {
        this.pendingElements.push(element);
    };
    BaseRenderer.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i]);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    BaseRenderer.prototype.getElementById = function(ind) {
        var i;
        var len = this.elements.length;
        for(i = 0; i < len; i += 1){
            if (this.elements[i].data.ind === ind) return this.elements[i];
        }
        return null;
    };
    BaseRenderer.prototype.getElementByPath = function(path) {
        var pathValue = path.shift();
        var element;
        if (typeof pathValue === 'number') element = this.elements[pathValue];
        else {
            var i;
            var len = this.elements.length;
            for(i = 0; i < len; i += 1)if (this.elements[i].data.nm === pathValue) {
                element = this.elements[i];
                break;
            }
        }
        if (path.length === 0) return element;
        return element.getElementByPath(path);
    };
    BaseRenderer.prototype.setupGlobalData = function(animData, fontsContainer) {
        this.globalData.fontManager = new FontManager();
        this.globalData.slotManager = slotFactory(animData);
        this.globalData.fontManager.addChars(animData.chars);
        this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
        this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
        this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
        this.globalData.imageLoader = this.animationItem.imagePreloader;
        this.globalData.audioController = this.animationItem.audioController;
        this.globalData.frameId = 0;
        this.globalData.frameRate = animData.fr;
        this.globalData.nm = animData.nm;
        this.globalData.compSize = {
            w: animData.w,
            h: animData.h
        };
    };
    var effectTypes = {
        TRANSFORM_EFFECT: 'transformEFfect'
    };
    function TransformElement() {}
    TransformElement.prototype = {
        initTransform: function initTransform() {
            var mat = new Matrix();
            this.finalTransform = {
                mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                    o: 0
                },
                _matMdf: false,
                _localMatMdf: false,
                _opMdf: false,
                mat: mat,
                localMat: mat,
                localOpacity: 1
            };
            if (this.data.ao) this.finalTransform.mProp.autoOriented = true;
            // TODO: check TYPE 11: Guided elements
            this.data.ty;
        },
        renderTransform: function renderTransform() {
            this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
            this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
            if (this.hierarchy) {
                var mat;
                var finalMat = this.finalTransform.mat;
                var i = 0;
                var len = this.hierarchy.length;
                // Checking if any of the transformation matrices in the hierarchy chain has changed.
                if (!this.finalTransform._matMdf) while(i < len){
                    if (this.hierarchy[i].finalTransform.mProp._mdf) {
                        this.finalTransform._matMdf = true;
                        break;
                    }
                    i += 1;
                }
                if (this.finalTransform._matMdf) {
                    mat = this.finalTransform.mProp.v.props;
                    finalMat.cloneFromProps(mat);
                    for(i = 0; i < len; i += 1)finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
                }
            }
            if (!this.localTransforms || this.finalTransform._matMdf) this.finalTransform._localMatMdf = this.finalTransform._matMdf;
            if (this.finalTransform._opMdf) this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
        },
        renderLocalTransform: function renderLocalTransform() {
            if (this.localTransforms) {
                var i = 0;
                var len = this.localTransforms.length;
                this.finalTransform._localMatMdf = this.finalTransform._matMdf;
                if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) while(i < len){
                    if (this.localTransforms[i]._mdf) this.finalTransform._localMatMdf = true;
                    if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
                        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
                        this.finalTransform._opMdf = true;
                    }
                    i += 1;
                }
                if (this.finalTransform._localMatMdf) {
                    var localMat = this.finalTransform.localMat;
                    this.localTransforms[0].matrix.clone(localMat);
                    for(i = 1; i < len; i += 1){
                        var lmat = this.localTransforms[i].matrix;
                        localMat.multiply(lmat);
                    }
                    localMat.multiply(this.finalTransform.mat);
                }
                if (this.finalTransform._opMdf) {
                    var localOp = this.finalTransform.localOpacity;
                    for(i = 0; i < len; i += 1)localOp *= this.localTransforms[i].opacity * 0.01;
                    this.finalTransform.localOpacity = localOp;
                }
            }
        },
        searchEffectTransforms: function searchEffectTransforms() {
            if (this.renderableEffectsManager) {
                var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                if (transformEffects.length) {
                    this.localTransforms = [];
                    this.finalTransform.localMat = new Matrix();
                    var i = 0;
                    var len = transformEffects.length;
                    for(i = 0; i < len; i += 1)this.localTransforms.push(transformEffects[i]);
                }
            }
        },
        globalToLocal: function globalToLocal(pt) {
            var transforms = [];
            transforms.push(this.finalTransform);
            var flag = true;
            var comp = this.comp;
            while(flag)if (comp.finalTransform) {
                if (comp.data.hasMask) transforms.splice(0, 0, comp.finalTransform);
                comp = comp.comp;
            } else flag = false;
            var i;
            var len = transforms.length;
            var ptNew;
            for(i = 0; i < len; i += 1){
                ptNew = transforms[i].mat.applyToPointArray(0, 0, 0);
                // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
                pt = [
                    pt[0] - ptNew[0],
                    pt[1] - ptNew[1],
                    0
                ];
            }
            return pt;
        },
        mHelper: new Matrix()
    };
    function MaskElement(data, element, globalData) {
        this.data = data;
        this.element = element;
        this.globalData = globalData;
        this.storedData = [];
        this.masksProperties = this.data.masksProperties || [];
        this.maskElement = null;
        var defs = this.globalData.defs;
        var i;
        var len = this.masksProperties ? this.masksProperties.length : 0;
        this.viewData = createSizedArray(len);
        this.solidPath = '';
        var path;
        var properties = this.masksProperties;
        var count = 0;
        var currentMasks = [];
        var j;
        var jLen;
        var layerId = createElementID();
        var rect;
        var expansor;
        var feMorph;
        var x;
        var maskType = 'clipPath';
        var maskRef = 'clip-path';
        for(i = 0; i < len; i += 1){
            if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
                maskType = 'mask';
                maskRef = 'mask';
            }
            if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
                rect = createNS('rect');
                rect.setAttribute('fill', '#ffffff');
                rect.setAttribute('width', this.element.comp.data.w || 0);
                rect.setAttribute('height', this.element.comp.data.h || 0);
                currentMasks.push(rect);
            } else rect = null;
            path = createNS('path');
            if (properties[i].mode === 'n') {
                // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    elem: path,
                    lastPath: ''
                };
                defs.appendChild(path);
            } else {
                count += 1;
                path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
                path.setAttribute('clip-rule', 'nonzero');
                var filterID;
                if (properties[i].x.k !== 0) {
                    maskType = 'mask';
                    maskRef = 'mask';
                    x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
                    filterID = createElementID();
                    expansor = createNS('filter');
                    expansor.setAttribute('id', filterID);
                    feMorph = createNS('feMorphology');
                    feMorph.setAttribute('operator', 'erode');
                    feMorph.setAttribute('in', 'SourceGraphic');
                    feMorph.setAttribute('radius', '0');
                    expansor.appendChild(feMorph);
                    defs.appendChild(expansor);
                    path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
                } else {
                    feMorph = null;
                    x = null;
                }
                // TODO move this to a factory or to a constructor
                this.storedData[i] = {
                    elem: path,
                    x: x,
                    expan: feMorph,
                    lastPath: '',
                    lastOperator: '',
                    filterId: filterID,
                    lastRadius: 0
                };
                if (properties[i].mode === 'i') {
                    jLen = currentMasks.length;
                    var g = createNS('g');
                    for(j = 0; j < jLen; j += 1)g.appendChild(currentMasks[j]);
                    var mask = createNS('mask');
                    mask.setAttribute('mask-type', 'alpha');
                    mask.setAttribute('id', layerId + '_' + count);
                    mask.appendChild(path);
                    defs.appendChild(mask);
                    g.setAttribute('mask', 'url(' + getLocationHref() + '#' + layerId + '_' + count + ')');
                    currentMasks.length = 0;
                    currentMasks.push(g);
                } else currentMasks.push(path);
                if (properties[i].inv && !this.solidPath) this.solidPath = this.createLayerSolidPath();
                // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    elem: path,
                    lastPath: '',
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    invRect: rect
                };
                if (!this.viewData[i].prop.k) this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
            }
        }
        this.maskElement = createNS(maskType);
        len = currentMasks.length;
        for(i = 0; i < len; i += 1)this.maskElement.appendChild(currentMasks[i]);
        if (count > 0) {
            this.maskElement.setAttribute('id', layerId);
            this.element.maskedElement.setAttribute(maskRef, 'url(' + getLocationHref() + '#' + layerId + ')');
            defs.appendChild(this.maskElement);
        }
        if (this.viewData.length) this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(pos) {
        return this.viewData[pos].prop;
    };
    MaskElement.prototype.renderFrame = function(isFirstFrame) {
        var finalMat = this.element.finalTransform.mat;
        var i;
        var len = this.masksProperties.length;
        for(i = 0; i < len; i += 1){
            if (this.viewData[i].prop._mdf || isFirstFrame) this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
            if (this.viewData[i].op._mdf || isFirstFrame) this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
            if (this.masksProperties[i].mode !== 'n') {
                if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
                if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
                    var feMorph = this.storedData[i].expan;
                    if (this.storedData[i].x.v < 0) {
                        if (this.storedData[i].lastOperator !== 'erode') {
                            this.storedData[i].lastOperator = 'erode';
                            this.storedData[i].elem.setAttribute('filter', 'url(' + getLocationHref() + '#' + this.storedData[i].filterId + ')');
                        }
                        feMorph.setAttribute('radius', -this.storedData[i].x.v);
                    } else {
                        if (this.storedData[i].lastOperator !== 'dilate') {
                            this.storedData[i].lastOperator = 'dilate';
                            this.storedData[i].elem.setAttribute('filter', null);
                        }
                        this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
                    }
                }
            }
        }
    };
    MaskElement.prototype.getMaskelement = function() {
        return this.maskElement;
    };
    MaskElement.prototype.createLayerSolidPath = function() {
        var path = 'M0,0 ';
        path += ' h' + this.globalData.compSize.w;
        path += ' v' + this.globalData.compSize.h;
        path += ' h-' + this.globalData.compSize.w;
        path += ' v-' + this.globalData.compSize.h + ' ';
        return path;
    };
    MaskElement.prototype.drawPath = function(pathData, pathNodes, viewData) {
        var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
        var i;
        var len;
        len = pathNodes._length;
        for(i = 1; i < len; i += 1)// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
        pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
        // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
        if (pathNodes.c && len > 1) pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
        // pathNodes.__renderedString = pathString;
        if (viewData.lastPath !== pathString) {
            var pathShapeValue = '';
            if (viewData.elem) {
                if (pathNodes.c) pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
                viewData.elem.setAttribute('d', pathShapeValue);
            }
            viewData.lastPath = pathString;
        }
    };
    MaskElement.prototype.destroy = function() {
        this.element = null;
        this.globalData = null;
        this.maskElement = null;
        this.data = null;
        this.masksProperties = null;
    };
    var filtersFactory = function() {
        var ob = {};
        ob.createFilter = createFilter;
        ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
        function createFilter(filId, skipCoordinates) {
            var fil = createNS('filter');
            fil.setAttribute('id', filId);
            if (skipCoordinates !== true) {
                fil.setAttribute('filterUnits', 'objectBoundingBox');
                fil.setAttribute('x', '0%');
                fil.setAttribute('y', '0%');
                fil.setAttribute('width', '100%');
                fil.setAttribute('height', '100%');
            }
            return fil;
        }
        function createAlphaToLuminanceFilter() {
            var feColorMatrix = createNS('feColorMatrix');
            feColorMatrix.setAttribute('type', 'matrix');
            feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
            feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
            return feColorMatrix;
        }
        return ob;
    }();
    var featureSupport = function() {
        var ob = {
            maskType: true,
            svgLumaHidden: true,
            offscreenCanvas: typeof OffscreenCanvas !== 'undefined'
        };
        if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) ob.maskType = false;
        if (/firefox/i.test(navigator.userAgent)) ob.svgLumaHidden = false;
        return ob;
    }();
    var registeredEffects$1 = {};
    var idPrefix = 'filter_result_';
    function SVGEffects(elem) {
        var i;
        var source = 'SourceGraphic';
        var len = elem.data.ef ? elem.data.ef.length : 0;
        var filId = createElementID();
        var fil = filtersFactory.createFilter(filId, true);
        var count = 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects$1[type]) {
                var Effect = registeredEffects$1[type].effect;
                filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
                source = idPrefix + count;
                if (registeredEffects$1[type].countsAsEffect) count += 1;
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (count) {
            elem.globalData.defs.appendChild(fil);
            elem.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    SVGEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect$1(id, effect, countsAsEffect) {
        registeredEffects$1[id] = {
            effect: effect,
            countsAsEffect: countsAsEffect
        };
    }
    function SVGBaseElement() {}
    SVGBaseElement.prototype = {
        initRendererElement: function initRendererElement() {
            this.layerElement = createNS('g');
        },
        createContainerElements: function createContainerElements() {
            this.matteElement = createNS('g');
            this.transformedElement = this.layerElement;
            this.maskedElement = this.layerElement;
            this._sizeChanged = false;
            var layerElementParent = null;
            // If this layer acts as a mask for the following layer
            if (this.data.td) {
                this.matteMasks = {};
                var gg = createNS('g');
                gg.setAttribute('id', this.layerId);
                gg.appendChild(this.layerElement);
                layerElementParent = gg;
                this.globalData.defs.appendChild(gg);
            } else if (this.data.tt) {
                this.matteElement.appendChild(this.layerElement);
                layerElementParent = this.matteElement;
                this.baseElement = this.matteElement;
            } else this.baseElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute('id', this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute('class', this.data.cl);
            // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
            if (this.data.ty === 0 && !this.data.hd) {
                var cp = createNS('clipPath');
                var pt = createNS('path');
                pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
                var clipId = createElementID();
                cp.setAttribute('id', clipId);
                cp.appendChild(pt);
                this.globalData.defs.appendChild(cp);
                if (this.checkMasks()) {
                    var cpGroup = createNS('g');
                    cpGroup.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
                    cpGroup.appendChild(this.layerElement);
                    this.transformedElement = cpGroup;
                    if (layerElementParent) layerElementParent.appendChild(this.transformedElement);
                    else this.baseElement = this.transformedElement;
                } else this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
            }
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            if (this.finalTransform._localMatMdf) this.transformedElement.setAttribute('transform', this.finalTransform.localMat.to2dCSS());
            if (this.finalTransform._opMdf) this.transformedElement.setAttribute('opacity', this.finalTransform.localOpacity);
        },
        destroyBaseElement: function destroyBaseElement() {
            this.layerElement = null;
            this.matteElement = null;
            this.maskManager.destroy();
        },
        getBaseElement: function getBaseElement() {
            if (this.data.hd) return null;
            return this.baseElement;
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
            this.renderableEffectsManager = new SVGEffects(this);
            this.searchEffectTransforms();
        },
        getMatte: function getMatte(matteType) {
            // This should not be a common case. But for backward compatibility, we'll create the matte object.
            // It solves animations that have two consecutive layers marked as matte masks.
            // Which is an undefined behavior in AE.
            if (!this.matteMasks) this.matteMasks = {};
            if (!this.matteMasks[matteType]) {
                var id = this.layerId + '_' + matteType;
                var filId;
                var fil;
                var useElement;
                var gg;
                if (matteType === 1 || matteType === 3) {
                    var masker = createNS('mask');
                    masker.setAttribute('id', id);
                    masker.setAttribute('mask-type', matteType === 3 ? 'luminance' : 'alpha');
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    masker.appendChild(useElement);
                    this.globalData.defs.appendChild(masker);
                    if (!featureSupport.maskType && matteType === 1) {
                        masker.setAttribute('mask-type', 'luminance');
                        filId = createElementID();
                        fil = filtersFactory.createFilter(filId);
                        this.globalData.defs.appendChild(fil);
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        gg.appendChild(useElement);
                        masker.appendChild(gg);
                        gg.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    }
                } else if (matteType === 2) {
                    var maskGroup = createNS('mask');
                    maskGroup.setAttribute('id', id);
                    maskGroup.setAttribute('mask-type', 'alpha');
                    var maskGrouper = createNS('g');
                    maskGroup.appendChild(maskGrouper);
                    filId = createElementID();
                    fil = filtersFactory.createFilter(filId);
                    /// /
                    var feCTr = createNS('feComponentTransfer');
                    feCTr.setAttribute('in', 'SourceGraphic');
                    fil.appendChild(feCTr);
                    var feFunc = createNS('feFuncA');
                    feFunc.setAttribute('type', 'table');
                    feFunc.setAttribute('tableValues', '1.0 0.0');
                    feCTr.appendChild(feFunc);
                    /// /
                    this.globalData.defs.appendChild(fil);
                    var alphaRect = createNS('rect');
                    alphaRect.setAttribute('width', this.comp.data.w);
                    alphaRect.setAttribute('height', this.comp.data.h);
                    alphaRect.setAttribute('x', '0');
                    alphaRect.setAttribute('y', '0');
                    alphaRect.setAttribute('fill', '#ffffff');
                    alphaRect.setAttribute('opacity', '0');
                    maskGrouper.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    maskGrouper.appendChild(alphaRect);
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    maskGrouper.appendChild(useElement);
                    if (!featureSupport.maskType) {
                        maskGroup.setAttribute('mask-type', 'luminance');
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        maskGrouper.appendChild(alphaRect);
                        gg.appendChild(this.layerElement);
                        maskGrouper.appendChild(gg);
                    }
                    this.globalData.defs.appendChild(maskGroup);
                }
                this.matteMasks[matteType] = id;
            }
            return this.matteMasks[matteType];
        },
        setMatte: function setMatte(id) {
            if (!this.matteElement) return;
            this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
        }
    };
    /**
   * @file
   * Handles AE's layer parenting property.
   *
   */ function HierarchyElement() {}
    HierarchyElement.prototype = {
        /**
       * @function
       * Initializes hierarchy properties
       *
       */ initHierarchy: function initHierarchy() {
            // element's parent list
            this.hierarchy = [];
            // if element is parent of another layer _isParent will be true
            this._isParent = false;
            this.checkParenting();
        },
        /**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */ setHierarchy: function setHierarchy(hierarchy) {
            this.hierarchy = hierarchy;
        },
        /**
       * @function
       * Sets layer as parent.
       *
       */ setAsParent: function setAsParent() {
            this._isParent = true;
        },
        /**
       * @function
       * Searches layer's parenting chain
       *
       */ checkParenting: function checkParenting() {
            if (this.data.parent !== undefined) this.comp.buildElementParenting(this, this.data.parent, []);
        }
    };
    function RenderableDOMElement() {}
    (function() {
        var _prototype = {
            initElement: function initElement(data, globalData, comp) {
                this.initFrame();
                this.initBaseData(data, globalData, comp);
                this.initTransform(data, globalData, comp);
                this.initHierarchy();
                this.initRenderable();
                this.initRendererElement();
                this.createContainerElements();
                this.createRenderableComponents();
                this.createContent();
                this.hide();
            },
            hide: function hide() {
                // console.log('HIDE', this);
                if (!this.hidden && (!this.isInRange || this.isTransparent)) {
                    var elem = this.baseElement || this.layerElement;
                    elem.style.display = 'none';
                    this.hidden = true;
                }
            },
            show: function show() {
                // console.log('SHOW', this);
                if (this.isInRange && !this.isTransparent) {
                    if (!this.data.hd) {
                        var elem = this.baseElement || this.layerElement;
                        elem.style.display = 'block';
                    }
                    this.hidden = false;
                    this._isFirstFrame = true;
                }
            },
            renderFrame: function renderFrame() {
                // If it is exported as hidden (data.hd === true) no need to render
                // If it is not visible no need to render
                if (this.data.hd || this.hidden) return;
                this.renderTransform();
                this.renderRenderable();
                this.renderLocalTransform();
                this.renderElement();
                this.renderInnerContent();
                if (this._isFirstFrame) this._isFirstFrame = false;
            },
            renderInnerContent: function renderInnerContent() {},
            prepareFrame: function prepareFrame(num) {
                this._mdf = false;
                this.prepareRenderableFrame(num);
                this.prepareProperties(num, this.isInRange);
                this.checkTransparency();
            },
            destroy: function destroy() {
                this.innerElem = null;
                this.destroyBaseElement();
            }
        };
        extendPrototype([
            RenderableElement,
            createProxyFunction(_prototype)
        ], RenderableDOMElement);
    })();
    function IImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        if (this.assetData && this.assetData.sid) this.assetData = globalData.slotManager.getProp(this.assetData);
        this.initElement(data, globalData, comp);
        this.sourceRect = {
            top: 0,
            left: 0,
            width: this.assetData.w,
            height: this.assetData.h
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], IImageElement);
    IImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.innerElem = createNS('image');
        this.innerElem.setAttribute('width', this.assetData.w + 'px');
        this.innerElem.setAttribute('height', this.assetData.h + 'px');
        this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
        this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
        this.layerElement.appendChild(this.innerElem);
    };
    IImageElement.prototype.sourceRectAtTime = function() {
        return this.sourceRect;
    };
    function ProcessedElement(element, position) {
        this.elem = element;
        this.pos = position;
    }
    function IShapeElement() {}
    IShapeElement.prototype = {
        addShapeToModifiers: function addShapeToModifiers(data) {
            var i;
            var len = this.shapeModifiers.length;
            for(i = 0; i < len; i += 1)this.shapeModifiers[i].addShape(data);
        },
        isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
            var i = 0;
            var len = this.shapeModifiers.length;
            while(i < len){
                if (this.shapeModifiers[i].isAnimatedWithShape(data)) return true;
            }
            return false;
        },
        renderModifiers: function renderModifiers() {
            if (!this.shapeModifiers.length) return;
            var i;
            var len = this.shapes.length;
            for(i = 0; i < len; i += 1)this.shapes[i].sh.reset();
            len = this.shapeModifiers.length;
            var shouldBreakProcess;
            for(i = len - 1; i >= 0; i -= 1){
                shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame);
                // workaround to fix cases where a repeater resets the shape so the following processes get called twice
                // TODO: find a better solution for this
                if (shouldBreakProcess) break;
            }
        },
        searchProcessedElement: function searchProcessedElement(elem) {
            var elements = this.processedElements;
            var i = 0;
            var len = elements.length;
            while(i < len){
                if (elements[i].elem === elem) return elements[i].pos;
                i += 1;
            }
            return 0;
        },
        addProcessedElement: function addProcessedElement(elem, pos) {
            var elements = this.processedElements;
            var i = elements.length;
            while(i){
                i -= 1;
                if (elements[i].elem === elem) {
                    elements[i].pos = pos;
                    return;
                }
            }
            elements.push(new ProcessedElement(elem, pos));
        },
        prepareFrame: function prepareFrame(num) {
            this.prepareRenderableFrame(num);
            this.prepareProperties(num, this.isInRange);
        }
    };
    var lineCapEnum = {
        1: 'butt',
        2: 'round',
        3: 'square'
    };
    var lineJoinEnum = {
        1: 'miter',
        2: 'round',
        3: 'bevel'
    };
    function SVGShapeData(transformers, level, shape) {
        this.caches = [];
        this.styles = [];
        this.transformers = transformers;
        this.lStr = '';
        this.sh = shape;
        this.lvl = level;
        // TODO find if there are some cases where _isAnimated can be false.
        // For now, since shapes add up with other shapes. They have to be calculated every time.
        // One way of finding out is checking if all styles associated to this shape depend only of this shape
        this._isAnimated = !!shape.k;
        // TODO: commenting this for now since all shapes are animated
        var i = 0;
        var len = transformers.length;
        while(i < len){
            if (transformers[i].mProps.dynamicProperties.length) {
                this._isAnimated = true;
                break;
            }
            i += 1;
        }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
        this._isAnimated = true;
    };
    function SVGStyleData(data, level) {
        this.data = data;
        this.type = data.ty;
        this.d = '';
        this.lvl = level;
        this._mdf = false;
        this.closed = data.hd === true;
        this.pElem = createNS('path');
        this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
        this.d = '';
        this._mdf = false;
    };
    function DashProperty(elem, data, renderer, container) {
        this.elem = elem;
        this.frameId = -1;
        this.dataProps = createSizedArray(data.length);
        this.renderer = renderer;
        this.k = false;
        this.dashStr = '';
        this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
        this.dashoffset = createTypedArray('float32', 1);
        this.initDynamicPropertyContainer(container);
        var i;
        var len = data.length || 0;
        var prop;
        for(i = 0; i < len; i += 1){
            prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
            this.k = prop.k || this.k;
            this.dataProps[i] = {
                n: data[i].n,
                p: prop
            };
        }
        if (!this.k) this.getValue(true);
        this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(forceRender) {
        if (this.elem.globalData.frameId === this.frameId && !forceRender) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        this._mdf = this._mdf || forceRender;
        if (this._mdf) {
            var i = 0;
            var len = this.dataProps.length;
            if (this.renderer === 'svg') this.dashStr = '';
            for(i = 0; i < len; i += 1)if (this.dataProps[i].n !== 'o') {
                if (this.renderer === 'svg') this.dashStr += ' ' + this.dataProps[i].p.v;
                else this.dashArray[i] = this.dataProps[i].p.v;
            } else this.dashoffset[0] = this.dataProps[i].p.v;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], DashProperty);
    function SVGStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGStrokeStyleData);
    function SVGFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGFillStyleData);
    function SVGNoStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGNoStyleData);
    function GradientProperty(elem, data, container) {
        this.data = data;
        this.c = createTypedArray('uint8c', data.p * 4);
        var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
        this.o = createTypedArray('float32', cLength);
        this._cmdf = false;
        this._omdf = false;
        this._collapsable = this.checkCollapsable();
        this._hasOpacity = cLength;
        this.initDynamicPropertyContainer(container);
        this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
        this.k = this.prop.k;
        this.getValue(true);
    }
    GradientProperty.prototype.comparePoints = function(values, points) {
        var i = 0;
        var len = this.o.length / 2;
        var diff;
        while(i < len){
            diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
            if (diff > 0.01) return false;
            i += 1;
        }
        return true;
    };
    GradientProperty.prototype.checkCollapsable = function() {
        if (this.o.length / 2 !== this.c.length / 4) return false;
        if (this.data.k.k[0].s) {
            var i = 0;
            var len = this.data.k.k.length;
            while(i < len){
                if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) return false;
                i += 1;
            }
        } else if (!this.comparePoints(this.data.k.k, this.data.p)) return false;
        return true;
    };
    GradientProperty.prototype.getValue = function(forceRender) {
        this.prop.getValue();
        this._mdf = false;
        this._cmdf = false;
        this._omdf = false;
        if (this.prop._mdf || forceRender) {
            var i;
            var len = this.data.p * 4;
            var mult;
            var val;
            for(i = 0; i < len; i += 1){
                mult = i % 4 === 0 ? 100 : 255;
                val = Math.round(this.prop.v[i] * mult);
                if (this.c[i] !== val) {
                    this.c[i] = val;
                    this._cmdf = !forceRender;
                }
            }
            if (this.o.length) {
                len = this.prop.v.length;
                for(i = this.data.p * 4; i < len; i += 1){
                    mult = i % 2 === 0 ? 100 : 1;
                    val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
                    if (this.o[i - this.data.p * 4] !== val) {
                        this.o[i - this.data.p * 4] = val;
                        this._omdf = !forceRender;
                    }
                }
            }
            this._mdf = !forceRender;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], GradientProperty);
    function SVGGradientFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.initGradientData(elem, data, styleOb);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(elem, data, styleOb) {
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
        this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
        this.h = PropertyFactory.getProp(elem, data.h || {
            k: 0
        }, 0, 0.01, this);
        this.a = PropertyFactory.getProp(elem, data.a || {
            k: 0
        }, 0, degToRads, this);
        this.g = new GradientProperty(elem, data.g, this);
        this.style = styleOb;
        this.stops = [];
        this.setGradientData(styleOb.pElem, data);
        this.setGradientOpacity(data, styleOb);
        this._isAnimated = !!this._isAnimated;
    };
    SVGGradientFillStyleData.prototype.setGradientData = function(pathElement, data) {
        var gradientId = createElementID();
        var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
        gfill.setAttribute('id', gradientId);
        gfill.setAttribute('spreadMethod', 'pad');
        gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
        var stops = [];
        var stop;
        var j;
        var jLen;
        jLen = data.g.p * 4;
        for(j = 0; j < jLen; j += 4){
            stop = createNS('stop');
            gfill.appendChild(stop);
            stops.push(stop);
        }
        pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + gradientId + ')');
        this.gf = gfill;
        this.cst = stops;
    };
    SVGGradientFillStyleData.prototype.setGradientOpacity = function(data, styleOb) {
        if (this.g._hasOpacity && !this.g._collapsable) {
            var stop;
            var j;
            var jLen;
            var mask = createNS('mask');
            var maskElement = createNS('path');
            mask.appendChild(maskElement);
            var opacityId = createElementID();
            var maskId = createElementID();
            mask.setAttribute('id', maskId);
            var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
            opFill.setAttribute('id', opacityId);
            opFill.setAttribute('spreadMethod', 'pad');
            opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
            jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
            var stops = this.stops;
            for(j = data.g.p * 4; j < jLen; j += 2){
                stop = createNS('stop');
                stop.setAttribute('stop-color', 'rgb(255,255,255)');
                opFill.appendChild(stop);
                stops.push(stop);
            }
            maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + opacityId + ')');
            if (data.ty === 'gs') {
                maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
                maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
                if (data.lj === 1) maskElement.setAttribute('stroke-miterlimit', data.ml);
            }
            this.of = opFill;
            this.ms = mask;
            this.ost = stops;
            this.maskId = maskId;
            styleOb.msElem = maskElement;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.initGradientData(elem, data, styleOb);
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        SVGGradientFillStyleData,
        DynamicPropertyContainer
    ], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
        this.it = [];
        this.prevViewData = [];
        this.gr = createNS('g');
    }
    function SVGTransformData(mProps, op, container) {
        this.transform = {
            mProps: mProps,
            op: op,
            container: container
        };
        this.elements = [];
        this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
        if (length === 0) return '';
        var _o = pathNodes.o;
        var _i = pathNodes.i;
        var _v = pathNodes.v;
        var i;
        var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
        for(i = 1; i < length; i += 1)shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
        if (closed && length) {
            shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
            shapeString += 'z';
        }
        return shapeString;
    };
    var SVGElementsRenderer = function() {
        var _identityMatrix = new Matrix();
        var _matrixHelper = new Matrix();
        var ob = {
            createRenderFunction: createRenderFunction
        };
        function createRenderFunction(data) {
            switch(data.ty){
                case 'fl':
                    return renderFill;
                case 'gf':
                    return renderGradient;
                case 'gs':
                    return renderGradientStroke;
                case 'st':
                    return renderStroke;
                case 'sh':
                case 'el':
                case 'rc':
                case 'sr':
                    return renderPath;
                case 'tr':
                    return renderContentTransform;
                case 'no':
                    return renderNoop;
                default:
                    return null;
            }
        }
        function renderContentTransform(styleData, itemData, isFirstFrame) {
            if (isFirstFrame || itemData.transform.op._mdf) itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
            if (isFirstFrame || itemData.transform.mProps._mdf) itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
        }
        function renderNoop() {}
        function renderPath(styleData, itemData, isFirstFrame) {
            var j;
            var jLen;
            var pathStringTransformed;
            var redraw;
            var pathNodes;
            var l;
            var lLen = itemData.styles.length;
            var lvl = itemData.lvl;
            var paths;
            var mat;
            var iterations;
            var k;
            for(l = 0; l < lLen; l += 1){
                redraw = itemData.sh._mdf || isFirstFrame;
                if (itemData.styles[l].lvl < lvl) {
                    mat = _matrixHelper.reset();
                    iterations = lvl - itemData.styles[l].lvl;
                    k = itemData.transformers.length - 1;
                    while(!redraw && iterations > 0){
                        redraw = itemData.transformers[k].mProps._mdf || redraw;
                        iterations -= 1;
                        k -= 1;
                    }
                    if (redraw) {
                        iterations = lvl - itemData.styles[l].lvl;
                        k = itemData.transformers.length - 1;
                        while(iterations > 0){
                            mat.multiply(itemData.transformers[k].mProps.v);
                            iterations -= 1;
                            k -= 1;
                        }
                    }
                } else mat = _identityMatrix;
                paths = itemData.sh.paths;
                jLen = paths._length;
                if (redraw) {
                    pathStringTransformed = '';
                    for(j = 0; j < jLen; j += 1){
                        pathNodes = paths.shapes[j];
                        if (pathNodes && pathNodes._length) pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
                    }
                    itemData.caches[l] = pathStringTransformed;
                } else pathStringTransformed = itemData.caches[l];
                itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
                itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
            }
        }
        function renderFill(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            if (itemData.c._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
        }
        function renderGradientStroke(styleData, itemData, isFirstFrame) {
            renderGradient(styleData, itemData, isFirstFrame);
            renderStroke(styleData, itemData, isFirstFrame);
        }
        function renderGradient(styleData, itemData, isFirstFrame) {
            var gfill = itemData.gf;
            var hasOpacity = itemData.g._hasOpacity;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (itemData.o._mdf || isFirstFrame) {
                var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
                itemData.style.pElem.setAttribute(attr, itemData.o.v);
            }
            if (itemData.s._mdf || isFirstFrame) {
                var attr1 = styleData.t === 1 ? 'x1' : 'cx';
                var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
                gfill.setAttribute(attr1, pt1[0]);
                gfill.setAttribute(attr2, pt1[1]);
                if (hasOpacity && !itemData.g._collapsable) {
                    itemData.of.setAttribute(attr1, pt1[0]);
                    itemData.of.setAttribute(attr2, pt1[1]);
                }
            }
            var stops;
            var i;
            var len;
            var stop;
            if (itemData.g._cmdf || isFirstFrame) {
                stops = itemData.cst;
                var cValues = itemData.g.c;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    stop.setAttribute('offset', cValues[i * 4] + '%');
                    stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
                }
            }
            if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
                var oValues = itemData.g.o;
                if (itemData.g._collapsable) stops = itemData.cst;
                else stops = itemData.ost;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    if (!itemData.g._collapsable) stop.setAttribute('offset', oValues[i * 2] + '%');
                    stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
                }
            }
            if (styleData.t === 1) {
                if (itemData.e._mdf || isFirstFrame) {
                    gfill.setAttribute('x2', pt2[0]);
                    gfill.setAttribute('y2', pt2[1]);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('x2', pt2[0]);
                        itemData.of.setAttribute('y2', pt2[1]);
                    }
                }
            } else {
                var rad;
                if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
                    rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    gfill.setAttribute('r', rad);
                    if (hasOpacity && !itemData.g._collapsable) itemData.of.setAttribute('r', rad);
                }
                if (itemData.s._mdf || itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
                    if (!rad) rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                    var percent = itemData.h.v;
                    if (percent >= 1) percent = 0.99;
                    else if (percent <= -1) percent = -0.99;
                    var dist = rad * percent;
                    var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                    var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                    gfill.setAttribute('fx', x);
                    gfill.setAttribute('fy', y);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('fx', x);
                        itemData.of.setAttribute('fy', y);
                    }
                }
            // gfill.setAttribute('fy','200');
            }
        }
        function renderStroke(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            var d = itemData.d;
            if (d && (d._mdf || isFirstFrame) && d.dashStr) {
                styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
                styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
            }
            if (itemData.c && (itemData.c._mdf || isFirstFrame)) styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
            if (itemData.w._mdf || isFirstFrame) {
                styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
                if (styleElem.msElem) styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
            }
        }
        return ob;
    }();
    function SVGShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = [];
        // Full shape data
        this.shapesData = data.shapes;
        // List of styles that will be applied to shapes
        this.stylesList = [];
        // List of modifiers that will be applied to shapes
        this.shapeModifiers = [];
        // List of items in shape tree
        this.itemsData = [];
        // List of items in previous shape tree
        this.processedElements = [];
        // List of animated components
        this.animatedContents = [];
        this.initElement(data, globalData, comp);
        // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = [];
    // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], SVGShapeElement);
    SVGShapeElement.prototype.initSecondaryElement = function() {};
    SVGShapeElement.prototype.identityMatrix = new Matrix();
    SVGShapeElement.prototype.buildExpressionInterface = function() {};
    SVGShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
    };
    /*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */ SVGShapeElement.prototype.filterUniqueShapes = function() {
        var i;
        var len = this.shapes.length;
        var shape;
        var j;
        var jLen = this.stylesList.length;
        var style;
        var tempShapes = [];
        var areAnimated = false;
        for(j = 0; j < jLen; j += 1){
            style = this.stylesList[j];
            areAnimated = false;
            tempShapes.length = 0;
            for(i = 0; i < len; i += 1){
                shape = this.shapes[i];
                if (shape.styles.indexOf(style) !== -1) {
                    tempShapes.push(shape);
                    areAnimated = shape._isAnimated || areAnimated;
                }
            }
            if (tempShapes.length > 1 && areAnimated) this.setShapesAsAnimated(tempShapes);
        }
    };
    SVGShapeElement.prototype.setShapesAsAnimated = function(shapes) {
        var i;
        var len = shapes.length;
        for(i = 0; i < len; i += 1)shapes[i].setAsAnimated();
    };
    SVGShapeElement.prototype.createStyleElement = function(data, level) {
        // TODO: prevent drawing of hidden styles
        var elementData;
        var styleOb = new SVGStyleData(data, level);
        var pathElement = styleOb.pElem;
        if (data.ty === 'st') elementData = new SVGStrokeStyleData(this, data, styleOb);
        else if (data.ty === 'fl') elementData = new SVGFillStyleData(this, data, styleOb);
        else if (data.ty === 'gf' || data.ty === 'gs') {
            var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
            elementData = new GradientConstructor(this, data, styleOb);
            this.globalData.defs.appendChild(elementData.gf);
            if (elementData.maskId) {
                this.globalData.defs.appendChild(elementData.ms);
                this.globalData.defs.appendChild(elementData.of);
                pathElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + elementData.maskId + ')');
            }
        } else if (data.ty === 'no') elementData = new SVGNoStyleData(this, data, styleOb);
        if (data.ty === 'st' || data.ty === 'gs') {
            pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
            pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
            pathElement.setAttribute('fill-opacity', '0');
            if (data.lj === 1) pathElement.setAttribute('stroke-miterlimit', data.ml);
        }
        if (data.r === 2) pathElement.setAttribute('fill-rule', 'evenodd');
        if (data.ln) pathElement.setAttribute('id', data.ln);
        if (data.cl) pathElement.setAttribute('class', data.cl);
        if (data.bm) pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
        this.stylesList.push(styleOb);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createGroupElement = function(data) {
        var elementData = new ShapeGroupData();
        if (data.ln) elementData.gr.setAttribute('id', data.ln);
        if (data.cl) elementData.gr.setAttribute('class', data.cl);
        if (data.bm) elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
        return elementData;
    };
    SVGShapeElement.prototype.createTransformElement = function(data, container) {
        var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
        var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createShapeElement = function(data, ownTransformers, level) {
        var ty = 4;
        if (data.ty === 'rc') ty = 5;
        else if (data.ty === 'el') ty = 6;
        else if (data.ty === 'sr') ty = 7;
        var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
        var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.addToAnimatedContents = function(data, element) {
        var i = 0;
        var len = this.animatedContents.length;
        while(i < len){
            if (this.animatedContents[i].element === element) return;
            i += 1;
        }
        this.animatedContents.push({
            fn: SVGElementsRenderer.createRenderFunction(data),
            element: element,
            data: data
        });
    };
    SVGShapeElement.prototype.setElementStyles = function(elementData) {
        var arr = elementData.styles;
        var j;
        var jLen = this.stylesList.length;
        for(j = 0; j < jLen; j += 1)if (arr.indexOf(this.stylesList[j]) === -1 && !this.stylesList[j].closed) arr.push(this.stylesList[j]);
    };
    SVGShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
    };
    SVGShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, container, level, transformers, render) {
        var ownTransformers = [].concat(transformers);
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var currentTransform;
        var modifier;
        var processedPos;
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._render = render;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], level);
                else itemsData[i].style.closed = arr[i].hd;
                if (arr[i]._render) {
                    if (itemsData[i].style.pElem.parentNode !== container) container.appendChild(itemsData[i].style.pElem);
                }
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === 'gr') {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
                if (arr[i]._render) {
                    if (itemsData[i].gr.parentNode !== container) container.appendChild(itemsData[i].gr);
                }
            } else if (arr[i].ty === 'tr') {
                if (!processedPos) itemsData[i] = this.createTransformElement(arr[i], container);
                currentTransform = itemsData[i].transform;
                ownTransformers.push(currentTransform);
            } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
                this.setElementStyles(itemsData[i]);
            } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === 'rp') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    render = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        len = ownStyles.length;
        for(i = 0; i < len; i += 1)ownStyles[i].closed = true;
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    SVGShapeElement.prototype.renderInnerContent = function() {
        this.renderModifiers();
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)this.stylesList[i].reset();
        this.renderShape();
        for(i = 0; i < len; i += 1)if (this.stylesList[i]._mdf || this._isFirstFrame) {
            if (this.stylesList[i].msElem) {
                this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
                // Adding M0 0 fixes same mask bug on all browsers
                this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
            }
            this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
        }
    };
    SVGShapeElement.prototype.renderShape = function() {
        var i;
        var len = this.animatedContents.length;
        var animatedContent;
        for(i = 0; i < len; i += 1){
            animatedContent = this.animatedContents[i];
            if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
        }
    };
    SVGShapeElement.prototype.destroy = function() {
        this.destroyBaseElement();
        this.shapesData = null;
        this.itemsData = null;
    };
    function LetterProps(o, sw, sc, fc, m, p) {
        this.o = o;
        this.sw = sw;
        this.sc = sc;
        this.fc = fc;
        this.m = m;
        this.p = p;
        this._mdf = {
            o: true,
            sw: !!sw,
            sc: !!sc,
            fc: !!fc,
            m: true,
            p: true
        };
    }
    LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
        this._mdf.o = false;
        this._mdf.sw = false;
        this._mdf.sc = false;
        this._mdf.fc = false;
        this._mdf.m = false;
        this._mdf.p = false;
        var updated = false;
        if (this.o !== o) {
            this.o = o;
            this._mdf.o = true;
            updated = true;
        }
        if (this.sw !== sw) {
            this.sw = sw;
            this._mdf.sw = true;
            updated = true;
        }
        if (this.sc !== sc) {
            this.sc = sc;
            this._mdf.sc = true;
            updated = true;
        }
        if (this.fc !== fc) {
            this.fc = fc;
            this._mdf.fc = true;
            updated = true;
        }
        if (this.m !== m) {
            this.m = m;
            this._mdf.m = true;
            updated = true;
        }
        if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
            this.p = p;
            this._mdf.p = true;
            updated = true;
        }
        return updated;
    };
    function TextProperty(elem, data) {
        this._frameId = initialDefaultFrame;
        this.pv = '';
        this.v = '';
        this.kf = false;
        this._isFirstFrame = true;
        this._mdf = false;
        if (data.d && data.d.sid) data.d = elem.globalData.slotManager.getProp(data.d);
        this.data = data;
        this.elem = elem;
        this.comp = this.elem.comp;
        this.keysIndex = 0;
        this.canResize = false;
        this.minimumFontSize = 1;
        this.effectsSequence = [];
        this.currentData = {
            ascent: 0,
            boxWidth: this.defaultBoxWidth,
            f: '',
            fStyle: '',
            fWeight: '',
            fc: '',
            j: '',
            justifyOffset: '',
            l: [],
            lh: 0,
            lineWidths: [],
            ls: '',
            of: '',
            s: '',
            sc: '',
            sw: 0,
            t: 0,
            tr: 0,
            sz: 0,
            ps: null,
            fillColorAnim: false,
            strokeColorAnim: false,
            strokeWidthAnim: false,
            yOffset: 0,
            finalSize: 0,
            finalText: [],
            finalLineHeight: 0,
            __complete: false
        };
        this.copyData(this.currentData, this.data.d.k[0].s);
        if (!this.searchProperty()) this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [
        0,
        0
    ];
    TextProperty.prototype.copyData = function(obj, data) {
        for(var s in data)if (Object.prototype.hasOwnProperty.call(data, s)) obj[s] = data[s];
        return obj;
    };
    TextProperty.prototype.setCurrentData = function(data) {
        if (!data.__complete) this.completeTextData(data);
        this.currentData = data;
        this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
        this._mdf = true;
    };
    TextProperty.prototype.searchProperty = function() {
        return this.searchKeyframes();
    };
    TextProperty.prototype.searchKeyframes = function() {
        this.kf = this.data.d.k.length > 1;
        if (this.kf) this.addEffect(this.getKeyframeValue.bind(this));
        return this.kf;
    };
    TextProperty.prototype.addEffect = function(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.getValue = function(_finalValue) {
        if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) return;
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var currentValue = this.currentData;
        var currentIndex = this.keysIndex;
        if (this.lock) {
            this.setCurrentData(this.currentData);
            return;
        }
        this.lock = true;
        this._mdf = false;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
        for(i = 0; i < len; i += 1)// Checking if index changed to prevent creating a new object every time the expression updates.
        if (currentIndex !== this.keysIndex) finalValue = this.effectsSequence[i](finalValue, finalValue.t);
        else finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
        if (currentValue !== finalValue) this.setCurrentData(finalValue);
        this.v = this.currentData;
        this.pv = this.v;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    };
    TextProperty.prototype.getKeyframeValue = function() {
        var textKeys = this.data.d.k;
        var frameNum = this.elem.comp.renderedFrame;
        var i = 0;
        var len = textKeys.length;
        while(i <= len - 1){
            if (i === len - 1 || textKeys[i + 1].t > frameNum) break;
            i += 1;
        }
        if (this.keysIndex !== i) this.keysIndex = i;
        return this.data.d.k[this.keysIndex].s;
    };
    TextProperty.prototype.buildFinalText = function(text) {
        var charactersArray = [];
        var i = 0;
        var len = text.length;
        var charCode;
        var secondCharCode;
        var shouldCombine = false;
        var shouldCombineNext = false;
        var currentChars = '';
        while(i < len){
            shouldCombine = shouldCombineNext;
            shouldCombineNext = false;
            charCode = text.charCodeAt(i);
            currentChars = text.charAt(i);
            if (FontManager.isCombinedCharacter(charCode)) shouldCombine = true;
            else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
                if (FontManager.isRegionalFlag(text, i)) currentChars = text.substr(i, 14);
                else {
                    secondCharCode = text.charCodeAt(i + 1);
                    // It's a surrogate pair (this is the Low surrogate)
                    if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
                        if (FontManager.isModifier(charCode, secondCharCode)) {
                            currentChars = text.substr(i, 2);
                            shouldCombine = true;
                        } else if (FontManager.isFlagEmoji(text.substr(i, 4))) currentChars = text.substr(i, 4);
                        else currentChars = text.substr(i, 2);
                    }
                }
            } else if (charCode > 0xDBFF) {
                secondCharCode = text.charCodeAt(i + 1);
                if (FontManager.isVariationSelector(charCode)) shouldCombine = true;
            } else if (FontManager.isZeroWidthJoiner(charCode)) {
                shouldCombine = true;
                shouldCombineNext = true;
            }
            if (shouldCombine) {
                charactersArray[charactersArray.length - 1] += currentChars;
                shouldCombine = false;
            } else charactersArray.push(currentChars);
            i += currentChars.length;
        }
        return charactersArray;
    };
    TextProperty.prototype.completeTextData = function(documentData) {
        documentData.__complete = true;
        var fontManager = this.elem.globalData.fontManager;
        var data = this.data;
        var letters = [];
        var i;
        var len;
        var newLineFlag;
        var index = 0;
        var val;
        var anchorGrouping = data.m.g;
        var currentSize = 0;
        var currentPos = 0;
        var currentLine = 0;
        var lineWidths = [];
        var lineWidth = 0;
        var maxLineWidth = 0;
        var j;
        var jLen;
        var fontData = fontManager.getFontByName(documentData.f);
        var charData;
        var cLength = 0;
        var fontProps = getFontProperties(fontData);
        documentData.fWeight = fontProps.weight;
        documentData.fStyle = fontProps.style;
        documentData.finalSize = documentData.s;
        documentData.finalText = this.buildFinalText(documentData.t);
        len = documentData.finalText.length;
        documentData.finalLineHeight = documentData.lh;
        var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
        var charCode;
        if (documentData.sz) {
            var flag = true;
            var boxWidth = documentData.sz[0];
            var boxHeight = documentData.sz[1];
            var currentHeight;
            var finalText;
            while(flag){
                finalText = this.buildFinalText(documentData.t);
                currentHeight = 0;
                lineWidth = 0;
                len = finalText.length;
                trackingOffset = documentData.tr / 1000 * documentData.finalSize;
                var lastSpaceIndex = -1;
                for(i = 0; i < len; i += 1){
                    charCode = finalText[i].charCodeAt(0);
                    newLineFlag = false;
                    if (finalText[i] === ' ') lastSpaceIndex = i;
                    else if (charCode === 13 || charCode === 3) {
                        lineWidth = 0;
                        newLineFlag = true;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                    }
                    if (fontManager.chars) {
                        charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
                        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
                    } else // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
                    cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
                    if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
                        if (lastSpaceIndex === -1) len += 1;
                        else i = lastSpaceIndex;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                        finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r');
                        // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
                        lastSpaceIndex = -1;
                        lineWidth = 0;
                    } else {
                        lineWidth += cLength;
                        lineWidth += trackingOffset;
                    }
                }
                currentHeight += fontData.ascent * documentData.finalSize / 100;
                if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
                    documentData.finalSize -= 1;
                    documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
                } else {
                    documentData.finalText = finalText;
                    len = documentData.finalText.length;
                    flag = false;
                }
            }
        }
        lineWidth = -trackingOffset;
        cLength = 0;
        var uncollapsedSpaces = 0;
        var currentChar;
        for(i = 0; i < len; i += 1){
            newLineFlag = false;
            currentChar = documentData.finalText[i];
            charCode = currentChar.charCodeAt(0);
            if (charCode === 13 || charCode === 3) {
                uncollapsedSpaces = 0;
                lineWidths.push(lineWidth);
                maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
                lineWidth = -2 * trackingOffset;
                val = '';
                newLineFlag = true;
                currentLine += 1;
            } else val = currentChar;
            if (fontManager.chars) {
                charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
                cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
            } else // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
            // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
            cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
            //
            if (currentChar === ' ') uncollapsedSpaces += cLength + trackingOffset;
            else {
                lineWidth += cLength + trackingOffset + uncollapsedSpaces;
                uncollapsedSpaces = 0;
            }
            letters.push({
                l: cLength,
                an: cLength,
                add: currentSize,
                n: newLineFlag,
                anIndexes: [],
                val: val,
                line: currentLine,
                animatorJustifyOffset: 0
            });
            if (anchorGrouping == 2) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || val === ' ' || i === len - 1) {
                    if (val === '' || val === ' ') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    index += 1;
                    currentSize = 0;
                }
            } else if (anchorGrouping == 3) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || i === len - 1) {
                    if (val === '') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    currentSize = 0;
                    index += 1;
                }
            } else {
                letters[index].ind = index;
                letters[index].extra = 0;
                index += 1;
            }
        }
        documentData.l = letters;
        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
        lineWidths.push(lineWidth);
        if (documentData.sz) {
            documentData.boxWidth = documentData.sz[0];
            documentData.justifyOffset = 0;
        } else {
            documentData.boxWidth = maxLineWidth;
            switch(documentData.j){
                case 1:
                    documentData.justifyOffset = -documentData.boxWidth;
                    break;
                case 2:
                    documentData.justifyOffset = -documentData.boxWidth / 2;
                    break;
                default:
                    documentData.justifyOffset = 0;
            }
        }
        documentData.lineWidths = lineWidths;
        var animators = data.a;
        var animatorData;
        var letterData;
        jLen = animators.length;
        var based;
        var ind;
        var indexes = [];
        for(j = 0; j < jLen; j += 1){
            animatorData = animators[j];
            if (animatorData.a.sc) documentData.strokeColorAnim = true;
            if (animatorData.a.sw) documentData.strokeWidthAnim = true;
            if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) documentData.fillColorAnim = true;
            ind = 0;
            based = animatorData.s.b;
            for(i = 0; i < len; i += 1){
                letterData = letters[i];
                letterData.anIndexes[j] = ind;
                if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
                    // eslint-disable-line eqeqeq
                    if (animatorData.s.rn === 1) indexes.push(ind);
                    ind += 1;
                }
            }
            data.a[j].s.totalChars = ind;
            var currentInd = -1;
            var newInd;
            if (animatorData.s.rn === 1) for(i = 0; i < len; i += 1){
                letterData = letters[i];
                if (currentInd != letterData.anIndexes[j]) {
                    // eslint-disable-line eqeqeq
                    currentInd = letterData.anIndexes[j];
                    newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
                }
                letterData.anIndexes[j] = newInd;
            }
        }
        documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
        documentData.ls = documentData.ls || 0;
        documentData.ascent = fontData.ascent * documentData.finalSize / 100;
    };
    TextProperty.prototype.updateDocumentData = function(newData, index) {
        index = index === undefined ? this.keysIndex : index;
        var dData = this.copyData({}, this.data.d.k[index].s);
        dData = this.copyData(dData, newData);
        this.data.d.k[index].s = dData;
        this.recalculate(index);
        this.setCurrentData(dData);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.recalculate = function(index) {
        var dData = this.data.d.k[index].s;
        dData.__complete = false;
        this.keysIndex = 0;
        this._isFirstFrame = true;
        this.getValue(dData);
    };
    TextProperty.prototype.canResizeFont = function(_canResize) {
        this.canResize = _canResize;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.setMinimumFontSize = function(_fontValue) {
        this.minimumFontSize = Math.floor(_fontValue) || 1;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
        var max = Math.max;
        var min = Math.min;
        var floor = Math.floor;
        function TextSelectorPropFactory(elem, data) {
            this._currentTextLength = -1;
            this.k = false;
            this.data = data;
            this.elem = elem;
            this.comp = elem.comp;
            this.finalS = 0;
            this.finalE = 0;
            this.initDynamicPropertyContainer(elem);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: 0
            }, 0, 0, this);
            if ('e' in data) this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
            else this.e = {
                v: 100
            };
            this.o = PropertyFactory.getProp(elem, data.o || {
                k: 0
            }, 0, 0, this);
            this.xe = PropertyFactory.getProp(elem, data.xe || {
                k: 0
            }, 0, 0, this);
            this.ne = PropertyFactory.getProp(elem, data.ne || {
                k: 0
            }, 0, 0, this);
            this.sm = PropertyFactory.getProp(elem, data.sm || {
                k: 100
            }, 0, 0, this);
            this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
            if (!this.dynamicProperties.length) this.getValue();
        }
        TextSelectorPropFactory.prototype = {
            getMult: function getMult(ind) {
                if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) this.getValue();
                var x1 = 0;
                var y1 = 0;
                var x2 = 1;
                var y2 = 1;
                if (this.ne.v > 0) x1 = this.ne.v / 100.0;
                else y1 = -this.ne.v / 100.0;
                if (this.xe.v > 0) x2 = 1.0 - this.xe.v / 100.0;
                else y2 = 1.0 + this.xe.v / 100.0;
                var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
                var mult = 0;
                var s = this.finalS;
                var e = this.finalE;
                var type = this.data.sh;
                if (type === 2) {
                    if (e === s) mult = ind >= e ? 1 : 0;
                    else mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 3) {
                    if (e === s) mult = ind >= e ? 0 : 1;
                    else mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 4) {
                    if (e === s) mult = 0;
                    else {
                        mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                        if (mult < 0.5) mult *= 2;
                        else mult = 1 - 2 * (mult - 0.5);
                    }
                    mult = easer(mult);
                } else if (type === 5) {
                    if (e === s) mult = 0;
                    else {
                        var tot = e - s;
                        /* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */ ind = min(max(0, ind + 0.5 - s), e - s);
                        var x = -tot / 2 + ind;
                        var a = tot / 2;
                        mult = Math.sqrt(1 - x * x / (a * a));
                    }
                    mult = easer(mult);
                } else if (type === 6) {
                    if (e === s) mult = 0;
                    else {
                        ind = min(max(0, ind + 0.5 - s), e - s);
                        mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
                    }
                    mult = easer(mult);
                } else {
                    if (ind >= floor(s)) {
                        if (ind - s < 0) mult = max(0, min(min(e, 1) - (s - ind), 1));
                        else mult = max(0, min(e - ind, 1));
                    }
                    mult = easer(mult);
                }
                // Smoothness implementation.
                // The smoothness represents a reduced range of the original [0; 1] range.
                // if smoothness is 25%, the new range will be [0.375; 0.625]
                // Steps are:
                // - find the lower value of the new range (threshold)
                // - if multiplier is smaller than that value, floor it to 0
                // - if it is larger,
                //     - subtract the threshold
                //     - divide it by the smoothness (this will return the range to [0; 1])
                // Note: If it doesn't work on some scenarios, consider applying it before the easer.
                if (this.sm.v !== 100) {
                    var smoothness = this.sm.v * 0.01;
                    if (smoothness === 0) smoothness = 0.00000001;
                    var threshold = 0.5 - smoothness * 0.5;
                    if (mult < threshold) mult = 0;
                    else {
                        mult = (mult - threshold) / smoothness;
                        if (mult > 1) mult = 1;
                    }
                }
                return mult * this.a.v;
            },
            getValue: function getValue(newCharsFlag) {
                this.iterateDynamicProperties();
                this._mdf = newCharsFlag || this._mdf;
                this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
                if (newCharsFlag && this.data.r === 2) this.e.v = this._currentTextLength;
                var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
                var o = this.o.v / divisor;
                var s = this.s.v / divisor + o;
                var e = this.e.v / divisor + o;
                if (s > e) {
                    var _s = s;
                    s = e;
                    e = _s;
                }
                this.finalS = s;
                this.finalE = e;
            }
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TextSelectorPropFactory);
        function getTextSelectorProp(elem, data, arr) {
            return new TextSelectorPropFactory(elem, data, arr);
        }
        return {
            getTextSelectorProp: getTextSelectorProp
        };
    }();
    function TextAnimatorDataProperty(elem, animatorProps, container) {
        var defaultData = {
            propType: false
        };
        var getProp = PropertyFactory.getProp;
        var textAnimatorAnimatables = animatorProps.a;
        this.a = {
            r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
            rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
            ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
            sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
            sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
            s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
            a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
            o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
            p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
            sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
            sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
            fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
            fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
            fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
            fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
            t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
        };
        this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
        this.s.t = animatorProps.s.t;
    }
    function TextAnimatorProperty(textData, renderType, elem) {
        this._isFirstFrame = true;
        this._hasMaskedPath = false;
        this._frameId = -1;
        this._textData = textData;
        this._renderType = renderType;
        this._elem = elem;
        this._animatorsData = createSizedArray(this._textData.a.length);
        this._pathData = {};
        this._moreOptions = {
            alignment: {}
        };
        this.renderedLetters = [];
        this.lettersChangedFlag = false;
        this.initDynamicPropertyContainer(elem);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
        var i;
        var len = this._textData.a.length;
        var animatorProps;
        var getProp = PropertyFactory.getProp;
        for(i = 0; i < len; i += 1){
            animatorProps = this._textData.a[i];
            this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
        }
        if (this._textData.p && 'm' in this._textData.p) {
            this._pathData = {
                a: getProp(this._elem, this._textData.p.a, 0, 0, this),
                f: getProp(this._elem, this._textData.p.f, 0, 0, this),
                l: getProp(this._elem, this._textData.p.l, 0, 0, this),
                r: getProp(this._elem, this._textData.p.r, 0, 0, this),
                p: getProp(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            };
            this._hasMaskedPath = true;
        } else this._hasMaskedPath = false;
        this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
    };
    TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag) {
        this.lettersChangedFlag = lettersChangedFlag;
        if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) return;
        this._isFirstFrame = false;
        var alignment = this._moreOptions.alignment.v;
        var animators = this._animatorsData;
        var textData = this._textData;
        var matrixHelper = this.mHelper;
        var renderType = this._renderType;
        var renderedLettersCount = this.renderedLetters.length;
        var xPos;
        var yPos;
        var i;
        var len;
        var letters = documentData.l;
        var pathInfo;
        var currentLength;
        var currentPoint;
        var segmentLength;
        var flag;
        var pointInd;
        var segmentInd;
        var prevPoint;
        var points;
        var segments;
        var partialLength;
        var totalLength;
        var perc;
        var tanAngle;
        var mask;
        if (this._hasMaskedPath) {
            mask = this._pathData.m;
            if (!this._pathData.n || this._pathData._mdf) {
                var paths = mask.v;
                if (this._pathData.r.v) paths = paths.reverse();
                // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
                pathInfo = {
                    tLength: 0,
                    segments: []
                };
                len = paths._length - 1;
                var bezierData;
                totalLength = 0;
                for(i = 0; i < len; i += 1){
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[i + 1][0] - paths.v[i + 1][0],
                        paths.i[i + 1][1] - paths.v[i + 1][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                i = len;
                if (mask.v.c) {
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[0][0] - paths.v[0][0],
                        paths.i[0][1] - paths.v[0][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                this._pathData.pi = pathInfo;
            }
            pathInfo = this._pathData.pi;
            currentLength = this._pathData.f.v;
            segmentInd = 0;
            pointInd = 1;
            segmentLength = 0;
            flag = true;
            segments = pathInfo.segments;
            if (currentLength < 0 && mask.v.c) {
                if (pathInfo.tLength < Math.abs(currentLength)) currentLength = -Math.abs(currentLength) % pathInfo.tLength;
                segmentInd = segments.length - 1;
                points = segments[segmentInd].points;
                pointInd = points.length - 1;
                while(currentLength < 0){
                    currentLength += points[pointInd].partialLength;
                    pointInd -= 1;
                    if (pointInd < 0) {
                        segmentInd -= 1;
                        points = segments[segmentInd].points;
                        pointInd = points.length - 1;
                    }
                }
            }
            points = segments[segmentInd].points;
            prevPoint = points[pointInd - 1];
            currentPoint = points[pointInd];
            partialLength = currentPoint.partialLength;
        }
        len = letters.length;
        xPos = 0;
        yPos = 0;
        var yOff = documentData.finalSize * 1.2 * 0.714;
        var firstLine = true;
        var animatorProps;
        var animatorSelector;
        var j;
        var jLen;
        var letterValue;
        jLen = animators.length;
        var mult;
        var ind = -1;
        var offf;
        var xPathPos;
        var yPathPos;
        var initPathPos = currentLength;
        var initSegmentInd = segmentInd;
        var initPointInd = pointInd;
        var currentLine = -1;
        var elemOpacity;
        var sc;
        var sw;
        var fc;
        var k;
        var letterSw;
        var letterSc;
        var letterFc;
        var letterM = '';
        var letterP = this.defaultPropsArray;
        var letterO;
        //
        if (documentData.j === 2 || documentData.j === 1) {
            var animatorJustifyOffset = 0;
            var animatorFirstCharOffset = 0;
            var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
            var lastIndex = 0;
            var isNewLine = true;
            for(i = 0; i < len; i += 1)if (letters[i].n) {
                if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
                while(lastIndex < i){
                    letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                    lastIndex += 1;
                }
                animatorJustifyOffset = 0;
                isNewLine = true;
            } else {
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        if (isNewLine && documentData.j === 2) animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
                        else animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
                    }
                }
                isNewLine = false;
            }
            if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
            while(lastIndex < i){
                letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                lastIndex += 1;
            }
        }
        //
        for(i = 0; i < len; i += 1){
            matrixHelper.reset();
            elemOpacity = 1;
            if (letters[i].n) {
                xPos = 0;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                currentLength = initPathPos;
                firstLine = false;
                if (this._hasMaskedPath) {
                    segmentInd = initSegmentInd;
                    pointInd = initPointInd;
                    points = segments[segmentInd].points;
                    prevPoint = points[pointInd - 1];
                    currentPoint = points[pointInd];
                    partialLength = currentPoint.partialLength;
                    segmentLength = 0;
                }
                letterM = '';
                letterFc = '';
                letterSw = '';
                letterO = '';
                letterP = this.defaultPropsArray;
            } else {
                if (this._hasMaskedPath) {
                    if (currentLine !== letters[i].line) {
                        switch(documentData.j){
                            case 1:
                                currentLength += totalLength - documentData.lineWidths[letters[i].line];
                                break;
                            case 2:
                                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
                                break;
                            default:
                                break;
                        }
                        currentLine = letters[i].line;
                    }
                    if (ind !== letters[i].ind) {
                        if (letters[ind]) currentLength += letters[ind].extra;
                        currentLength += letters[i].an / 2;
                        ind = letters[i].ind;
                    }
                    currentLength += alignment[0] * letters[i].an * 0.005;
                    var animatorOffset = 0;
                    for(j = 0; j < jLen; j += 1){
                        animatorProps = animators[j].a;
                        if (animatorProps.p.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.p.v[0] * mult[0];
                            else animatorOffset += animatorProps.p.v[0] * mult;
                        }
                        if (animatorProps.a.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.a.v[0] * mult[0];
                            else animatorOffset += animatorProps.a.v[0] * mult;
                        }
                    }
                    flag = true;
                    // Force alignment only works with a single line for now
                    if (this._pathData.a.v) {
                        currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
                        currentLength += this._pathData.f.v;
                    }
                    while(flag){
                        if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
                            perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
                            xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
                            yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
                            matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
                            flag = false;
                        } else if (points) {
                            segmentLength += currentPoint.partialLength;
                            pointInd += 1;
                            if (pointInd >= points.length) {
                                pointInd = 0;
                                segmentInd += 1;
                                if (!segments[segmentInd]) {
                                    if (mask.v.c) {
                                        pointInd = 0;
                                        segmentInd = 0;
                                        points = segments[segmentInd].points;
                                    } else {
                                        segmentLength -= currentPoint.partialLength;
                                        points = null;
                                    }
                                } else points = segments[segmentInd].points;
                            }
                            if (points) {
                                prevPoint = currentPoint;
                                currentPoint = points[pointInd];
                                partialLength = currentPoint.partialLength;
                            }
                        }
                    }
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0);
                } else {
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0);
                    // Grouping alignment
                    matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
                        if (xPos !== 0 || documentData.j !== 0) {
                            if (this._hasMaskedPath) {
                                if (mult.length) currentLength += animatorProps.t.v * mult[0];
                                else currentLength += animatorProps.t.v * mult;
                            } else if (mult.length) xPos += animatorProps.t.v * mult[0];
                            else xPos += animatorProps.t.v * mult;
                        }
                    }
                }
                if (documentData.strokeWidthAnim) sw = documentData.sw || 0;
                if (documentData.strokeColorAnim) {
                    if (documentData.sc) sc = [
                        documentData.sc[0],
                        documentData.sc[1],
                        documentData.sc[2]
                    ];
                    else sc = [
                        0,
                        0,
                        0
                    ];
                }
                if (documentData.fillColorAnim && documentData.fc) fc = [
                    documentData.fc[0],
                    documentData.fc[1],
                    documentData.fc[2]
                ];
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.a.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
                        else matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.s.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
                        else matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                    if (animatorProps.sk.propType) {
                        if (mult.length) matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
                        else matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
                    }
                    if (animatorProps.r.propType) {
                        if (mult.length) matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
                        else matrixHelper.rotateZ(-animatorProps.r.v * mult);
                    }
                    if (animatorProps.ry.propType) {
                        if (mult.length) matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
                        else matrixHelper.rotateY(animatorProps.ry.v * mult);
                    }
                    if (animatorProps.rx.propType) {
                        if (mult.length) matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
                        else matrixHelper.rotateX(animatorProps.rx.v * mult);
                    }
                    if (animatorProps.o.propType) {
                        if (mult.length) elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
                        else elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
                    }
                    if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
                        if (mult.length) sw += animatorProps.sw.v * mult[0];
                        else sw += animatorProps.sw.v * mult;
                    }
                    if (documentData.strokeColorAnim && animatorProps.sc.propType) {
                        for(k = 0; k < 3; k += 1)if (mult.length) sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
                        else sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
                    }
                    if (documentData.fillColorAnim && documentData.fc) {
                        if (animatorProps.fc.propType) {
                            for(k = 0; k < 3; k += 1)if (mult.length) fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
                            else fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
                        }
                        if (animatorProps.fh.propType) {
                            if (mult.length) fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
                            else fc = addHueToRGB(fc, animatorProps.fh.v * mult);
                        }
                        if (animatorProps.fs.propType) {
                            if (mult.length) fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
                            else fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
                        }
                        if (animatorProps.fb.propType) {
                            if (mult.length) fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
                            else fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
                        }
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.p.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (this._hasMaskedPath) {
                            if (mult.length) matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
                            else matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                        } else if (mult.length) matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
                        else matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                    }
                }
                if (documentData.strokeWidthAnim) letterSw = sw < 0 ? 0 : sw;
                if (documentData.strokeColorAnim) letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
                if (documentData.fillColorAnim && documentData.fc) letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
                if (this._hasMaskedPath) {
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);
                    if (this._pathData.p.v) {
                        tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
                        var rot = Math.atan(tanAngle) * 180 / Math.PI;
                        if (currentPoint.point[0] < prevPoint.point[0]) rot += 180;
                        matrixHelper.rotate(-rot * Math.PI / 180);
                    }
                    matrixHelper.translate(xPathPos, yPathPos, 0);
                    currentLength -= alignment[0] * letters[i].an * 0.005;
                    if (letters[i + 1] && ind !== letters[i + 1].ind) {
                        currentLength += letters[i].an / 2;
                        currentLength += documentData.tr * 0.001 * documentData.finalSize;
                    }
                } else {
                    matrixHelper.translate(xPos, yPos, 0);
                    if (documentData.ps) // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
                    matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
                    switch(documentData.j){
                        case 1:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
                            break;
                        case 2:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
                            break;
                        default:
                            break;
                    }
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(offf, 0, 0);
                    matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
                    xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
                }
                if (renderType === 'html') letterM = matrixHelper.toCSS();
                else if (renderType === 'svg') letterM = matrixHelper.to2dCSS();
                else letterP = [
                    matrixHelper.props[0],
                    matrixHelper.props[1],
                    matrixHelper.props[2],
                    matrixHelper.props[3],
                    matrixHelper.props[4],
                    matrixHelper.props[5],
                    matrixHelper.props[6],
                    matrixHelper.props[7],
                    matrixHelper.props[8],
                    matrixHelper.props[9],
                    matrixHelper.props[10],
                    matrixHelper.props[11],
                    matrixHelper.props[12],
                    matrixHelper.props[13],
                    matrixHelper.props[14],
                    matrixHelper.props[15]
                ];
                letterO = elemOpacity;
            }
            if (renderedLettersCount <= i) {
                letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
                this.renderedLetters.push(letterValue);
                renderedLettersCount += 1;
                this.lettersChangedFlag = true;
            } else {
                letterValue = this.renderedLetters[i];
                this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
            }
        }
    };
    TextAnimatorProperty.prototype.getValue = function() {
        if (this._elem.globalData.frameId === this._frameId) return;
        this._frameId = this._elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    TextAnimatorProperty.prototype.mHelper = new Matrix();
    TextAnimatorProperty.prototype.defaultPropsArray = [];
    extendPrototype([
        DynamicPropertyContainer
    ], TextAnimatorProperty);
    function ITextElement() {}
    ITextElement.prototype.initElement = function(data, globalData, comp) {
        this.lettersChangedFlag = true;
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
        this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
        this.textAnimator.searchProperties(this.dynamicProperties);
    };
    ITextElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
    };
    ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
        var j;
        var jLen = shapes.length;
        var pathNodes;
        var shapeStr = '';
        for(j = 0; j < jLen; j += 1)if (shapes[j].ty === 'sh') {
            pathNodes = shapes[j].ks.k;
            shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
        }
        return shapeStr;
    };
    ITextElement.prototype.updateDocumentData = function(newData, index) {
        this.textProperty.updateDocumentData(newData, index);
    };
    ITextElement.prototype.canResizeFont = function(_canResize) {
        this.textProperty.canResizeFont(_canResize);
    };
    ITextElement.prototype.setMinimumFontSize = function(_fontSize) {
        this.textProperty.setMinimumFontSize(_fontSize);
    };
    ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
        if (documentData.ps) matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
        matrixHelper.translate(0, -documentData.ls, 0);
        switch(documentData.j){
            case 1:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
                break;
            case 2:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
                break;
            default:
                break;
        }
        matrixHelper.translate(xPos, yPos, 0);
    };
    ITextElement.prototype.buildColor = function(colorData) {
        return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
    };
    ITextElement.prototype.emptyProp = new LetterProps();
    ITextElement.prototype.destroy = function() {};
    ITextElement.prototype.validateText = function() {
        if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
            this.buildNewText();
            this.textProperty._isFirstFrame = false;
            this.textProperty._mdf = false;
        }
    };
    var emptyShapeData = {
        shapes: []
    };
    function SVGTextLottieElement(data, globalData, comp) {
        this.textSpans = [];
        this.renderType = 'svg';
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], SVGTextLottieElement);
    SVGTextLottieElement.prototype.createContent = function() {
        if (this.data.singleShape && !this.globalData.fontManager.chars) this.textContainer = createNS('text');
    };
    SVGTextLottieElement.prototype.buildTextContents = function(textArray) {
        var i = 0;
        var len = textArray.length;
        var textContents = [];
        var currentTextContent = '';
        while(i < len){
            if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
                textContents.push(currentTextContent);
                currentTextContent = '';
            } else currentTextContent += textArray[i];
            i += 1;
        }
        textContents.push(currentTextContent);
        return textContents;
    };
    SVGTextLottieElement.prototype.buildShapeData = function(data, scale) {
        // data should probably be cloned to apply scale separately to each instance of a text on different layers
        // but since text internal content gets only rendered once and then it's never rerendered,
        // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
        // Avoiding cloning is preferred since cloning each character shape data is expensive
        if (data.shapes && data.shapes.length) {
            var shape = data.shapes[0];
            if (shape.it) {
                var shapeItem = shape.it[shape.it.length - 1];
                if (shapeItem.s) {
                    shapeItem.s.k[0] = scale;
                    shapeItem.s.k[1] = scale;
                }
            }
        }
        return data;
    };
    SVGTextLottieElement.prototype.buildNewText = function() {
        this.addDynamicProperty(this);
        var i;
        var len;
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
        if (documentData.fc) this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
        else this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
        if (documentData.sc) {
            this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
            this.layerElement.setAttribute('stroke-width', documentData.sw);
        }
        this.layerElement.setAttribute('font-size', documentData.finalSize);
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (fontData.fClass) this.layerElement.setAttribute('class', fontData.fClass);
        else {
            this.layerElement.setAttribute('font-family', fontData.fFamily);
            var fWeight = documentData.fWeight;
            var fStyle = documentData.fStyle;
            this.layerElement.setAttribute('font-style', fStyle);
            this.layerElement.setAttribute('font-weight', fWeight);
        }
        this.layerElement.setAttribute('aria-label', documentData.t);
        var letters = documentData.l || [];
        var usesGlyphs = !!this.globalData.fontManager.chars;
        len = letters.length;
        var tSpan;
        var matrixHelper = this.mHelper;
        var shapeStr = '';
        var singleShape = this.data.singleShape;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        if (singleShape && !usesGlyphs && !documentData.sz) {
            var tElement = this.textContainer;
            var justify = 'start';
            switch(documentData.j){
                case 1:
                    justify = 'end';
                    break;
                case 2:
                    justify = 'middle';
                    break;
                default:
                    justify = 'start';
                    break;
            }
            tElement.setAttribute('text-anchor', justify);
            tElement.setAttribute('letter-spacing', trackingOffset);
            var textContent = this.buildTextContents(documentData.finalText);
            len = textContent.length;
            yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
            for(i = 0; i < len; i += 1){
                tSpan = this.textSpans[i].span || createNS('tspan');
                tSpan.textContent = textContent[i];
                tSpan.setAttribute('x', 0);
                tSpan.setAttribute('y', yPos);
                tSpan.style.display = 'inherit';
                tElement.appendChild(tSpan);
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    glyph: null
                };
                this.textSpans[i].span = tSpan;
                yPos += documentData.finalLineHeight;
            }
            this.layerElement.appendChild(tElement);
        } else {
            var cachedSpansLength = this.textSpans.length;
            var charData;
            for(i = 0; i < len; i += 1){
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    childSpan: null,
                    glyph: null
                };
                if (!usesGlyphs || !singleShape || i === 0) {
                    tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? 'g' : 'text');
                    if (cachedSpansLength <= i) {
                        tSpan.setAttribute('stroke-linecap', 'butt');
                        tSpan.setAttribute('stroke-linejoin', 'round');
                        tSpan.setAttribute('stroke-miterlimit', '4');
                        this.textSpans[i].span = tSpan;
                        if (usesGlyphs) {
                            var childSpan = createNS('g');
                            tSpan.appendChild(childSpan);
                            this.textSpans[i].childSpan = childSpan;
                        }
                        this.textSpans[i].span = tSpan;
                        this.layerElement.appendChild(tSpan);
                    }
                    tSpan.style.display = 'inherit';
                }
                matrixHelper.reset();
                if (singleShape) {
                    if (letters[i].n) {
                        xPos = -trackingOffset;
                        yPos += documentData.yOffset;
                        yPos += firstLine ? 1 : 0;
                        firstLine = false;
                    }
                    this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
                    xPos += letters[i].l || 0;
                    // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
                    xPos += trackingOffset;
                }
                if (usesGlyphs) {
                    charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                    var glyphElement;
                    // t === 1 means the character has been replaced with an animated shaped
                    if (charData.t === 1) glyphElement = new SVGCompElement(charData.data, this.globalData, this);
                    else {
                        var data = emptyShapeData;
                        if (charData.data && charData.data.shapes) data = this.buildShapeData(charData.data, documentData.finalSize);
                        glyphElement = new SVGShapeElement(data, this.globalData, this);
                    }
                    if (this.textSpans[i].glyph) {
                        var glyph = this.textSpans[i].glyph;
                        this.textSpans[i].childSpan.removeChild(glyph.layerElement);
                        glyph.destroy();
                    }
                    this.textSpans[i].glyph = glyphElement;
                    glyphElement._debug = true;
                    glyphElement.prepareFrame(0);
                    glyphElement.renderFrame();
                    this.textSpans[i].childSpan.appendChild(glyphElement.layerElement);
                    // when using animated shapes, the layer will be scaled instead of replacing the internal scale
                    // this might have issues with strokes and might need a different solution
                    if (charData.t === 1) this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
                } else {
                    if (singleShape) tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
                    tSpan.textContent = letters[i].val;
                    tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
                }
            //
            }
            if (singleShape && tSpan) tSpan.setAttribute('d', shapeStr);
        }
        while(i < this.textSpans.length){
            this.textSpans[i].span.style.display = 'none';
            i += 1;
        }
        this._sizeChanged = true;
    };
    SVGTextLottieElement.prototype.sourceRectAtTime = function() {
        this.prepareFrame(this.comp.renderedFrame - this.data.st);
        this.renderInnerContent();
        if (this._sizeChanged) {
            this._sizeChanged = false;
            var textBox = this.layerElement.getBBox();
            this.bbox = {
                top: textBox.y,
                left: textBox.x,
                width: textBox.width,
                height: textBox.height
            };
        }
        return this.bbox;
    };
    SVGTextLottieElement.prototype.getValue = function() {
        var i;
        var len = this.textSpans.length;
        var glyphElement;
        this.renderedFrame = this.comp.renderedFrame;
        for(i = 0; i < len; i += 1){
            glyphElement = this.textSpans[i].glyph;
            if (glyphElement) {
                glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);
                if (glyphElement._mdf) this._mdf = true;
            }
        }
    };
    SVGTextLottieElement.prototype.renderInnerContent = function() {
        this.validateText();
        if (!this.data.singleShape || this._mdf) {
            this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                this._sizeChanged = true;
                var i;
                var len;
                var renderedLetters = this.textAnimator.renderedLetters;
                var letters = this.textProperty.currentData.l;
                len = letters.length;
                var renderedLetter;
                var textSpan;
                var glyphElement;
                for(i = 0; i < len; i += 1)if (!letters[i].n) {
                    renderedLetter = renderedLetters[i];
                    textSpan = this.textSpans[i].span;
                    glyphElement = this.textSpans[i].glyph;
                    if (glyphElement) glyphElement.renderFrame();
                    if (renderedLetter._mdf.m) textSpan.setAttribute('transform', renderedLetter.m);
                    if (renderedLetter._mdf.o) textSpan.setAttribute('opacity', renderedLetter.o);
                    if (renderedLetter._mdf.sw) textSpan.setAttribute('stroke-width', renderedLetter.sw);
                    if (renderedLetter._mdf.sc) textSpan.setAttribute('stroke', renderedLetter.sc);
                    if (renderedLetter._mdf.fc) textSpan.setAttribute('fill', renderedLetter.fc);
                }
            }
        }
    };
    function ISolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        IImageElement
    ], ISolidElement);
    ISolidElement.prototype.createContent = function() {
        var rect = createNS('rect');
        /// /rect.style.width = this.data.sw;
        /// /rect.style.height = this.data.sh;
        /// /rect.style.fill = this.data.sc;
        rect.setAttribute('width', this.data.sw);
        rect.setAttribute('height', this.data.sh);
        rect.setAttribute('fill', this.data.sc);
        this.layerElement.appendChild(rect);
    };
    function NullElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initFrame();
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    NullElement.prototype.renderFrame = function() {};
    NullElement.prototype.getBaseElement = function() {
        return null;
    };
    NullElement.prototype.destroy = function() {};
    NullElement.prototype.sourceRectAtTime = function() {};
    NullElement.prototype.hide = function() {};
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement
    ], NullElement);
    function SVGRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], SVGRendererBase);
    SVGRendererBase.prototype.createNull = function(data) {
        return new NullElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createShape = function(data) {
        return new SVGShapeElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createText = function(data) {
        return new SVGTextLottieElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createImage = function(data) {
        return new IImageElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createSolid = function(data) {
        return new ISolidElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.configAnimation = function(animData) {
        this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
        if (this.renderConfig.viewBoxSize) this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
        else this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
        if (!this.renderConfig.viewBoxOnly) {
            this.svgElement.setAttribute('width', animData.w);
            this.svgElement.setAttribute('height', animData.h);
            this.svgElement.style.width = '100%';
            this.svgElement.style.height = '100%';
            this.svgElement.style.transform = 'translate3d(0,0,0)';
            this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
        }
        if (this.renderConfig.width) this.svgElement.setAttribute('width', this.renderConfig.width);
        if (this.renderConfig.height) this.svgElement.setAttribute('height', this.renderConfig.height);
        if (this.renderConfig.className) this.svgElement.setAttribute('class', this.renderConfig.className);
        if (this.renderConfig.id) this.svgElement.setAttribute('id', this.renderConfig.id);
        if (this.renderConfig.focusable !== undefined) this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
        this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio);
        // this.layerElement.style.transform = 'translate3d(0,0,0)';
        // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
        this.animationItem.wrapper.appendChild(this.svgElement);
        // Mask animation
        var defs = this.globalData.defs;
        this.setupGlobalData(animData, defs);
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.data = animData;
        var maskElement = createNS('clipPath');
        var rect = createNS('rect');
        rect.setAttribute('width', animData.w);
        rect.setAttribute('height', animData.h);
        rect.setAttribute('x', 0);
        rect.setAttribute('y', 0);
        var maskId = createElementID();
        maskElement.setAttribute('id', maskId);
        maskElement.appendChild(rect);
        this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + maskId + ')');
        defs.appendChild(maskElement);
        this.layers = animData.layers;
        this.elements = createSizedArray(animData.layers.length);
    };
    SVGRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        this.layerElement = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    SVGRendererBase.prototype.updateContainerSize = function() {};
    SVGRendererBase.prototype.findIndexByInd = function(ind) {
        var i = 0;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1){
            if (this.layers[i].ind === ind) return i;
        }
        return -1;
    };
    SVGRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        elements[pos] = true;
        var element = this.createItem(this.layers[pos]);
        elements[pos] = element;
        if (getExpressionsPlugin()) {
            if (this.layers[pos].ty === 0) this.globalData.projectInterface.registerComposition(element);
            element.initExpressions();
        }
        this.appendElementInPos(element, pos);
        if (this.layers[pos].tt) {
            var elementIndex = 'tp' in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;
            if (elementIndex === -1) return;
            if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
                this.buildItem(elementIndex);
                this.addPendingElement(element);
            } else {
                var matteElement = elements[elementIndex];
                var matteMask = matteElement.getMatte(this.layers[pos].tt);
                element.setMatte(matteMask);
            }
        }
    };
    SVGRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
            if (element.data.tt) {
                var i = 0;
                var len = this.elements.length;
                while(i < len){
                    if (this.elements[i] === element) {
                        var elementIndex = 'tp' in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
                        var matteElement = this.elements[elementIndex];
                        var matteMask = matteElement.getMatte(this.layers[i].tt);
                        element.setMatte(matteMask);
                        break;
                    }
                    i += 1;
                }
            }
        }
    };
    SVGRendererBase.prototype.renderFrame = function(num) {
        if (this.renderedFrame === num || this.destroyed) return;
        if (num === null) num = this.renderedFrame;
        else this.renderedFrame = num;
        // console.log('-------');
        // console.log('FRAME ',num);
        this.globalData.frameNum = num;
        this.globalData.frameId += 1;
        this.globalData.projectInterface.currentFrame = num;
        this.globalData._mdf = false;
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
        }
    };
    SVGRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newElement = element.getBaseElement();
        if (!newElement) return;
        var i = 0;
        var nextElement;
        while(i < pos){
            if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) nextElement = this.elements[i].getBaseElement();
            i += 1;
        }
        if (nextElement) this.layerElement.insertBefore(newElement, nextElement);
        else this.layerElement.appendChild(newElement);
    };
    SVGRendererBase.prototype.hide = function() {
        this.layerElement.style.display = 'none';
    };
    SVGRendererBase.prototype.show = function() {
        this.layerElement.style.display = 'block';
    };
    function ICompElement() {}
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], ICompElement);
    ICompElement.prototype.initElement = function(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initTransform(data, globalData, comp);
        this.initRenderable();
        this.initHierarchy();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        if (this.data.xt || !globalData.progressiveLoad) this.buildAllItems();
        this.hide();
    };
    /* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */ ICompElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
        if (!this.isInRange && !this.data.xt) return;
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            if (timeRemapped === this.data.op) timeRemapped = this.data.op - 1;
            this.renderedFrame = timeRemapped;
        } else this.renderedFrame = num / this.data.sr;
        var i;
        var len = this.elements.length;
        if (!this.completeLayers) this.checkLayers(this.renderedFrame);
        // This iteration needs to be backwards because of how expressions connect between each other
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) {
            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
            if (this.elements[i]._mdf) this._mdf = true;
        }
    };
    ICompElement.prototype.renderInnerContent = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    ICompElement.prototype.setElements = function(elems) {
        this.elements = elems;
    };
    ICompElement.prototype.getElements = function() {
        return this.elements;
    };
    ICompElement.prototype.destroyElements = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.elements[i]) this.elements[i].destroy();
    };
    ICompElement.prototype.destroy = function() {
        this.destroyElements();
        this.destroyBaseElement();
    };
    function SVGCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = true;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        SVGRendererBase,
        ICompElement,
        SVGBaseElement
    ], SVGCompElement);
    SVGCompElement.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function SVGRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.svgElement = createNS('svg');
        var ariaLabel = '';
        if (config && config.title) {
            var titleElement = createNS('title');
            var titleId = createElementID();
            titleElement.setAttribute('id', titleId);
            titleElement.textContent = config.title;
            this.svgElement.appendChild(titleElement);
            ariaLabel += titleId;
        }
        if (config && config.description) {
            var descElement = createNS('desc');
            var descId = createElementID();
            descElement.setAttribute('id', descId);
            descElement.textContent = config.description;
            this.svgElement.appendChild(descElement);
            ariaLabel += ' ' + descId;
        }
        if (ariaLabel) this.svgElement.setAttribute('aria-labelledby', ariaLabel);
        var defs = createNS('defs');
        this.svgElement.appendChild(defs);
        var maskElement = createNS('g');
        this.svgElement.appendChild(maskElement);
        this.layerElement = maskElement;
        this.renderConfig = {
            preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            contentVisibility: config && config.contentVisibility || 'visible',
            progressiveLoad: config && config.progressiveLoad || false,
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            viewBoxOnly: config && config.viewBoxOnly || false,
            viewBoxSize: config && config.viewBoxSize || false,
            className: config && config.className || '',
            id: config && config.id || '',
            focusable: config && config.focusable,
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '100%',
                height: config && config.filterSize && config.filterSize.height || '100%',
                x: config && config.filterSize && config.filterSize.x || '0%',
                y: config && config.filterSize && config.filterSize.y || '0%'
            },
            width: config && config.width,
            height: config && config.height,
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            defs: defs,
            renderConfig: this.renderConfig
        };
        this.elements = [];
        this.pendingElements = [];
        this.destroyed = false;
        this.rendererType = 'svg';
    }
    extendPrototype([
        SVGRendererBase
    ], SVGRenderer);
    SVGRenderer.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function ShapeTransformManager() {
        this.sequences = {};
        this.sequenceList = [];
        this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
        addTransformSequence: function addTransformSequence(transforms) {
            var i;
            var len = transforms.length;
            var key = '_';
            for(i = 0; i < len; i += 1)key += transforms[i].transform.key + '_';
            var sequence = this.sequences[key];
            if (!sequence) {
                sequence = {
                    transforms: [].concat(transforms),
                    finalTransform: new Matrix(),
                    _mdf: false
                };
                this.sequences[key] = sequence;
                this.sequenceList.push(sequence);
            }
            return sequence;
        },
        processSequence: function processSequence(sequence, isFirstFrame) {
            var i = 0;
            var len = sequence.transforms.length;
            var _mdf = isFirstFrame;
            while(i < len && !isFirstFrame){
                if (sequence.transforms[i].transform.mProps._mdf) {
                    _mdf = true;
                    break;
                }
                i += 1;
            }
            if (_mdf) {
                sequence.finalTransform.reset();
                for(i = len - 1; i >= 0; i -= 1)sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);
            }
            sequence._mdf = _mdf;
        },
        processSequences: function processSequences(isFirstFrame) {
            var i;
            var len = this.sequenceList.length;
            for(i = 0; i < len; i += 1)this.processSequence(this.sequenceList[i], isFirstFrame);
        },
        getNewKey: function getNewKey() {
            this.transform_key_count += 1;
            return '_' + this.transform_key_count;
        }
    };
    var lumaLoader = function lumaLoader() {
        var id = '__lottie_element_luma_buffer';
        var lumaBuffer = null;
        var lumaBufferCtx = null;
        var svg = null;
        // This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
        // Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
        // For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
        // Naming it solution 2 to mark the extra comment lines.
        /*
    var svgString = [
      '<svg xmlns="http://www.w3.org/2000/svg">',
      '<filter id="' + id + '">',
      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0',
      '"/>',
      '</filter>',
      '</svg>',
    ].join('');
    var blob = new Blob([svgString], { type: 'image/svg+xml' });
    var url = URL.createObjectURL(blob);
    */ function createLumaSvgFilter() {
            var _svg = createNS('svg');
            var fil = createNS('filter');
            var matrix = createNS('feColorMatrix');
            fil.setAttribute('id', id);
            matrix.setAttribute('type', 'matrix');
            matrix.setAttribute('color-interpolation-filters', 'sRGB');
            matrix.setAttribute('values', '0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0');
            fil.appendChild(matrix);
            _svg.appendChild(fil);
            _svg.setAttribute('id', id + '_svg');
            if (featureSupport.svgLumaHidden) _svg.style.display = 'none';
            return _svg;
        }
        function loadLuma() {
            if (!lumaBuffer) {
                svg = createLumaSvgFilter();
                document.body.appendChild(svg);
                lumaBuffer = createTag('canvas');
                lumaBufferCtx = lumaBuffer.getContext('2d');
                // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
                lumaBufferCtx.filter = 'url(#' + id + ')';
                lumaBufferCtx.fillStyle = 'rgba(0,0,0,0)';
                lumaBufferCtx.fillRect(0, 0, 1, 1);
            }
        }
        function getLuma(canvas) {
            if (!lumaBuffer) loadLuma();
            lumaBuffer.width = canvas.width;
            lumaBuffer.height = canvas.height;
            // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
            lumaBufferCtx.filter = 'url(#' + id + ')';
            return lumaBuffer;
        }
        return {
            load: loadLuma,
            get: getLuma
        };
    };
    function createCanvas(width, height) {
        if (featureSupport.offscreenCanvas) return new OffscreenCanvas(width, height);
        var canvas = createTag('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    var assetLoader = function() {
        return {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        };
    }();
    var registeredEffects = {};
    function CVEffects(elem) {
        var i;
        var len = elem.data.ef ? elem.data.ef.length : 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects[type]) {
                var Effect = registeredEffects[type].effect;
                filterManager = new Effect(elem.effectsManager.effectElements[i], elem);
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    CVEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect(id, effect) {
        registeredEffects[id] = {
            effect: effect
        };
    }
    function CVMaskElement(data, element) {
        this.data = data;
        this.element = element;
        this.masksProperties = this.data.masksProperties || [];
        this.viewData = createSizedArray(this.masksProperties.length);
        var i;
        var len = this.masksProperties.length;
        var hasMasks = false;
        for(i = 0; i < len; i += 1){
            if (this.masksProperties[i].mode !== 'n') hasMasks = true;
            this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
        }
        this.hasMasks = hasMasks;
        if (hasMasks) this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
        if (!this.hasMasks) return;
        var transform = this.element.finalTransform.mat;
        var ctx = this.element.canvasContext;
        var i;
        var len = this.masksProperties.length;
        var pt;
        var pts;
        var data;
        ctx.beginPath();
        for(i = 0; i < len; i += 1)if (this.masksProperties[i].mode !== 'n') {
            if (this.masksProperties[i].inv) {
                ctx.moveTo(0, 0);
                ctx.lineTo(this.element.globalData.compSize.w, 0);
                ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
                ctx.lineTo(0, this.element.globalData.compSize.h);
                ctx.lineTo(0, 0);
            }
            data = this.viewData[i].v;
            pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
            ctx.moveTo(pt[0], pt[1]);
            var j;
            var jLen = data._length;
            for(j = 1; j < jLen; j += 1){
                pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
                ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
            }
            pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
            ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
        }
        this.element.globalData.renderer.save(true);
        ctx.clip();
    };
    CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
    CVMaskElement.prototype.destroy = function() {
        this.element = null;
    };
    function CVBaseElement() {}
    var operationsMap = {
        1: 'source-in',
        2: 'source-out',
        3: 'source-in',
        4: 'source-out'
    };
    CVBaseElement.prototype = {
        createElements: function createElements() {},
        initRendererElement: function initRendererElement() {},
        createContainerElements: function createContainerElements() {
            // If the layer is masked we will use two buffers to store each different states of the drawing
            // This solution is not ideal for several reason. But unfortunately, because of the recursive
            // nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
            // TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
            // It might be challenging because the layer most likely is transformed in some way
            if (this.data.tt >= 1) {
                this.buffers = [];
                var canvasContext = this.globalData.canvasContext;
                var bufferCanvas = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas);
                var bufferCanvas2 = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas2);
                if (this.data.tt >= 3 && !document._isProxy) assetLoader.loadLumaCanvas();
            }
            this.canvasContext = this.globalData.canvasContext;
            this.transformCanvas = this.globalData.transformCanvas;
            this.renderableEffectsManager = new CVEffects(this);
            this.searchEffectTransforms();
        },
        createContent: function createContent() {},
        setBlendMode: function setBlendMode() {
            var globalData = this.globalData;
            if (globalData.blendMode !== this.data.bm) {
                globalData.blendMode = this.data.bm;
                var blendModeValue = getBlendMode(this.data.bm);
                globalData.canvasContext.globalCompositeOperation = blendModeValue;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new CVMaskElement(this.data, this);
            this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
        },
        hideElement: function hideElement() {
            if (!this.hidden && (!this.isInRange || this.isTransparent)) this.hidden = true;
        },
        showElement: function showElement() {
            if (this.isInRange && !this.isTransparent) {
                this.hidden = false;
                this._isFirstFrame = true;
                this.maskManager._isFirstFrame = true;
            }
        },
        clearCanvas: function clearCanvas(canvasContext) {
            canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
        },
        prepareLayer: function prepareLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[0];
                var bufferCtx = buffer.getContext('2d');
                this.clearCanvas(bufferCtx);
                // on the first buffer we store the current state of the global drawing
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
                // The next four lines are to clear the canvas
                // TODO: Check if there is a way to clear the canvas without resetting the transform
                this.currentTransform = this.canvasContext.getTransform();
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform);
            }
        },
        exitLayer: function exitLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[1];
                // On the second buffer we store the current state of the global drawing
                // that only contains the content of this layer
                // (if it is a composition, it also includes the nested layers)
                var bufferCtx = buffer.getContext('2d');
                this.clearCanvas(bufferCtx);
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
                // We clear the canvas again
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform);
                // We draw the mask
                var mask = this.comp.getElementById('tp' in this.data ? this.data.tp : this.data.ind - 1);
                mask.renderFrame(true);
                // We draw the second buffer (that contains the content of this layer)
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                // If the mask is a Luma matte, we need to do two extra painting operations
                // the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error
                if (this.data.tt >= 3 && !document._isProxy) {
                    // We copy the painted mask to a buffer that has a color matrix filter applied to it
                    // that applies the rgb values to the alpha channel
                    var lumaBuffer = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                    var lumaBufferCtx = lumaBuffer.getContext('2d');
                    lumaBufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
                    this.clearCanvas(this.canvasContext);
                    // we repaint the context with the mask applied to it
                    this.canvasContext.drawImage(lumaBuffer, 0, 0);
                }
                this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
                this.canvasContext.drawImage(buffer, 0, 0);
                // We finally draw the first buffer (that contains the content of the global drawing)
                // We use destination-over to draw the global drawing below the current layer
                this.canvasContext.globalCompositeOperation = 'destination-over';
                this.canvasContext.drawImage(this.buffers[0], 0, 0);
                this.canvasContext.setTransform(this.currentTransform);
                // We reset the globalCompositeOperation to source-over, the standard type of operation
                this.canvasContext.globalCompositeOperation = 'source-over';
            }
        },
        renderFrame: function renderFrame(forceRender) {
            if (this.hidden || this.data.hd) return;
            if (this.data.td === 1 && !forceRender) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderLocalTransform();
            this.setBlendMode();
            var forceRealStack = this.data.ty === 0;
            this.prepareLayer();
            this.globalData.renderer.save(forceRealStack);
            this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
            this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
            this.renderInnerContent();
            this.globalData.renderer.restore(forceRealStack);
            this.exitLayer();
            if (this.maskManager.hasMasks) this.globalData.renderer.restore(true);
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.canvasContext = null;
            this.data = null;
            this.globalData = null;
            this.maskManager.destroy();
        },
        mHelper: new Matrix()
    };
    CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
    CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(element, data, styles, transformsManager) {
        this.styledShapes = [];
        this.tr = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var ty = 4;
        if (data.ty === 'rc') ty = 5;
        else if (data.ty === 'el') ty = 6;
        else if (data.ty === 'sr') ty = 7;
        this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
        var i;
        var len = styles.length;
        var styledShape;
        for(i = 0; i < len; i += 1)if (!styles[i].closed) {
            styledShape = {
                transforms: transformsManager.addTransformSequence(styles[i].transforms),
                trNodes: []
            };
            this.styledShapes.push(styledShape);
            styles[i].elements.push(styledShape);
        }
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(data, globalData, comp) {
        this.shapes = [];
        this.shapesData = data.shapes;
        this.stylesList = [];
        this.itemsData = [];
        this.prevViewData = [];
        this.shapeModifiers = [];
        this.processedElements = [];
        this.transformsManager = new ShapeTransformManager();
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVShapeElement);
    CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
    CVShapeElement.prototype.transformHelper = {
        opacity: 1,
        _opMdf: false
    };
    CVShapeElement.prototype.dashResetter = [];
    CVShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
    };
    CVShapeElement.prototype.createStyleElement = function(data, transforms) {
        var styleElem = {
            data: data,
            type: data.ty,
            preTransforms: this.transformsManager.addTransformSequence(transforms),
            transforms: [],
            elements: [],
            closed: data.hd === true
        };
        var elementData = {};
        if (data.ty === 'fl' || data.ty === 'st') {
            elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);
            if (!elementData.c.k) styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
        } else if (data.ty === 'gf' || data.ty === 'gs') {
            elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
            elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
            elementData.h = PropertyFactory.getProp(this, data.h || {
                k: 0
            }, 0, 0.01, this);
            elementData.a = PropertyFactory.getProp(this, data.a || {
                k: 0
            }, 0, degToRads, this);
            elementData.g = new GradientProperty(this, data.g, this);
        }
        elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);
        if (data.ty === 'st' || data.ty === 'gs') {
            styleElem.lc = lineCapEnum[data.lc || 2];
            styleElem.lj = lineJoinEnum[data.lj || 2];
            if (data.lj == 1) // eslint-disable-line eqeqeq
            styleElem.ml = data.ml;
            elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);
            if (!elementData.w.k) styleElem.wi = elementData.w.v;
            if (data.d) {
                var d = new DashProperty(this, data.d, 'canvas', this);
                elementData.d = d;
                if (!elementData.d.k) {
                    styleElem.da = elementData.d.dashArray;
                    styleElem["do"] = elementData.d.dashoffset[0];
                }
            }
        } else styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
        this.stylesList.push(styleElem);
        elementData.style = styleElem;
        return elementData;
    };
    CVShapeElement.prototype.createGroupElement = function() {
        var elementData = {
            it: [],
            prevViewData: []
        };
        return elementData;
    };
    CVShapeElement.prototype.createTransformElement = function(data) {
        var elementData = {
            transform: {
                opacity: 1,
                _opMdf: false,
                key: this.transformsManager.getNewKey(),
                op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
                mProps: TransformPropertyFactory.getTransformProperty(this, data, this)
            }
        };
        return elementData;
    };
    CVShapeElement.prototype.createShapeElement = function(data) {
        var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        return elementData;
    };
    CVShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
    };
    CVShapeElement.prototype.addTransformToStyleList = function(transform) {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.push(transform);
    };
    CVShapeElement.prototype.removeTransformFromStyleList = function() {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.pop();
    };
    CVShapeElement.prototype.closeStyles = function(styles) {
        var i;
        var len = styles.length;
        for(i = 0; i < len; i += 1)styles[i].closed = true;
    };
    CVShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, shouldRender, transforms) {
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var processedPos;
        var modifier;
        var currentTransform;
        var ownTransforms = [].concat(transforms);
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._shouldRender = shouldRender;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
                else itemsData[i].style.closed = false;
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === 'gr') {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
            } else if (arr[i].ty === 'tr') {
                if (!processedPos) {
                    currentTransform = this.createTransformElement(arr[i]);
                    itemsData[i] = currentTransform;
                }
                ownTransforms.push(itemsData[i]);
                this.addTransformToStyleList(itemsData[i]);
            } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i]);
            } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === 'rp') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    shouldRender = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        this.removeTransformFromStyleList();
        this.closeStyles(ownStyles);
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    CVShapeElement.prototype.renderInnerContent = function() {
        this.transformHelper.opacity = 1;
        this.transformHelper._opMdf = false;
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
        this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
    };
    CVShapeElement.prototype.renderShapeTransform = function(parentTransform, groupTransform) {
        if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
            groupTransform.opacity = parentTransform.opacity;
            groupTransform.opacity *= groupTransform.op.v;
            groupTransform._opMdf = true;
        }
    };
    CVShapeElement.prototype.drawLayer = function() {
        var i;
        var len = this.stylesList.length;
        var j;
        var jLen;
        var k;
        var kLen;
        var elems;
        var nodes;
        var renderer = this.globalData.renderer;
        var ctx = this.globalData.canvasContext;
        var type;
        var currentStyle;
        for(i = 0; i < len; i += 1){
            currentStyle = this.stylesList[i];
            type = currentStyle.type;
            // Skipping style when
            // Stroke width equals 0
            // style should not be rendered (extra unused repeaters)
            // current opacity equals 0
            // global opacity equals 0
            if (!((type === 'st' || type === 'gs') && currentStyle.wi === 0 || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
                renderer.save();
                elems = currentStyle.elements;
                if (type === 'st' || type === 'gs') {
                    renderer.ctxStrokeStyle(type === 'st' ? currentStyle.co : currentStyle.grd);
                    // ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
                    renderer.ctxLineWidth(currentStyle.wi);
                    // ctx.lineWidth = currentStyle.wi;
                    renderer.ctxLineCap(currentStyle.lc);
                    // ctx.lineCap = currentStyle.lc;
                    renderer.ctxLineJoin(currentStyle.lj);
                    // ctx.lineJoin = currentStyle.lj;
                    renderer.ctxMiterLimit(currentStyle.ml || 0);
                // ctx.miterLimit = currentStyle.ml || 0;
                } else renderer.ctxFillStyle(type === 'fl' ? currentStyle.co : currentStyle.grd);
                renderer.ctxOpacity(currentStyle.coOp);
                if (type !== 'st' && type !== 'gs') ctx.beginPath();
                renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
                jLen = elems.length;
                for(j = 0; j < jLen; j += 1){
                    if (type === 'st' || type === 'gs') {
                        ctx.beginPath();
                        if (currentStyle.da) {
                            ctx.setLineDash(currentStyle.da);
                            ctx.lineDashOffset = currentStyle["do"];
                        }
                    }
                    nodes = elems[j].trNodes;
                    kLen = nodes.length;
                    for(k = 0; k < kLen; k += 1){
                        if (nodes[k].t === 'm') ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
                        else if (nodes[k].t === 'c') ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
                        else ctx.closePath();
                    }
                    if (type === 'st' || type === 'gs') {
                        // ctx.stroke();
                        renderer.ctxStroke();
                        if (currentStyle.da) ctx.setLineDash(this.dashResetter);
                    }
                }
                if (type !== 'st' && type !== 'gs') // ctx.fill(currentStyle.r);
                this.globalData.renderer.ctxFill(currentStyle.r);
                renderer.restore();
            }
        }
    };
    CVShapeElement.prototype.renderShape = function(parentTransform, items, data, isMain) {
        var i;
        var len = items.length - 1;
        var groupTransform;
        groupTransform = parentTransform;
        for(i = len; i >= 0; i -= 1){
            if (items[i].ty === 'tr') {
                groupTransform = data[i].transform;
                this.renderShapeTransform(parentTransform, groupTransform);
            } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') this.renderPath(items[i], data[i]);
            else if (items[i].ty === 'fl') this.renderFill(items[i], data[i], groupTransform);
            else if (items[i].ty === 'st') this.renderStroke(items[i], data[i], groupTransform);
            else if (items[i].ty === 'gf' || items[i].ty === 'gs') this.renderGradientFill(items[i], data[i], groupTransform);
            else if (items[i].ty === 'gr') this.renderShape(groupTransform, items[i].it, data[i].it);
            else items[i].ty;
        }
        if (isMain) this.drawLayer();
    };
    CVShapeElement.prototype.renderStyledShape = function(styledShape, shape) {
        if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
            var shapeNodes = styledShape.trNodes;
            var paths = shape.paths;
            var i;
            var len;
            var j;
            var jLen = paths._length;
            shapeNodes.length = 0;
            var groupTransformMat = styledShape.transforms.finalTransform;
            for(j = 0; j < jLen; j += 1){
                var pathNodes = paths.shapes[j];
                if (pathNodes && pathNodes.v) {
                    len = pathNodes._length;
                    for(i = 1; i < len; i += 1){
                        if (i === 1) shapeNodes.push({
                            t: 'm',
                            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                        });
                        shapeNodes.push({
                            t: 'c',
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
                        });
                    }
                    if (len === 1) shapeNodes.push({
                        t: 'm',
                        p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                    });
                    if (pathNodes.c && len) {
                        shapeNodes.push({
                            t: 'c',
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
                        });
                        shapeNodes.push({
                            t: 'z'
                        });
                    }
                }
            }
            styledShape.trNodes = shapeNodes;
        }
    };
    CVShapeElement.prototype.renderPath = function(pathData, itemData) {
        if (pathData.hd !== true && pathData._shouldRender) {
            var i;
            var len = itemData.styledShapes.length;
            for(i = 0; i < len; i += 1)this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
        }
    };
    CVShapeElement.prototype.renderFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderGradientFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var grd;
        if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf)) {
            var ctx = this.globalData.canvasContext;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (styleData.t === 1) grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
            else {
                var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                var percent = itemData.h.v;
                if (percent >= 1) percent = 0.99;
                else if (percent <= -1) percent = -0.99;
                var dist = rad * percent;
                var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
            }
            var i;
            var len = styleData.g.p;
            var cValues = itemData.g.c;
            var opacity = 1;
            for(i = 0; i < len; i += 1){
                if (itemData.g._hasOpacity && itemData.g._collapsable) opacity = itemData.g.o[i * 2 + 1];
                grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
            }
            styleElem.grd = grd;
        }
        styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderStroke = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var d = itemData.d;
        if (d && (d._mdf || this._isFirstFrame)) {
            styleElem.da = d.dashArray;
            styleElem["do"] = d.dashoffset[0];
        }
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
        if (itemData.w._mdf || this._isFirstFrame) styleElem.wi = itemData.w.v;
    };
    CVShapeElement.prototype.destroy = function() {
        this.shapesData = null;
        this.globalData = null;
        this.canvasContext = null;
        this.stylesList.length = 0;
        this.itemsData.length = 0;
    };
    function CVTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.yOffset = 0;
        this.fillColorAnim = false;
        this.strokeColorAnim = false;
        this.strokeWidthAnim = false;
        this.stroke = false;
        this.fill = false;
        this.justifyOffset = 0;
        this.currentRender = null;
        this.renderType = 'canvas';
        this.values = {
            fill: 'rgba(0,0,0,0)',
            stroke: 'rgba(0,0,0,0)',
            sWidth: 0,
            fValue: ''
        };
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement,
        ITextElement
    ], CVTextElement);
    CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');
    CVTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var hasFill = false;
        if (documentData.fc) {
            hasFill = true;
            this.values.fill = this.buildColor(documentData.fc);
        } else this.values.fill = 'rgba(0,0,0,0)';
        this.fill = hasFill;
        var hasStroke = false;
        if (documentData.sc) {
            hasStroke = true;
            this.values.stroke = this.buildColor(documentData.sc);
            this.values.sWidth = documentData.sw;
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        var i;
        var len;
        var letters = documentData.l;
        var matrixHelper = this.mHelper;
        this.stroke = hasStroke;
        this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
        len = documentData.finalText.length;
        // this.tHelper.font = this.values.fValue;
        var charData;
        var shapeData;
        var k;
        var kLen;
        var shapes;
        var j;
        var jLen;
        var pathNodes;
        var commands;
        var pathArr;
        var singleShape = this.data.singleShape;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
            shapeData = charData && charData.data || {};
            matrixHelper.reset();
            if (singleShape && letters[i].n) {
                xPos = -trackingOffset;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                firstLine = false;
            }
            shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
            jLen = shapes.length;
            matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
            if (singleShape) this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
            commands = createSizedArray(jLen - 1);
            var commandsCounter = 0;
            for(j = 0; j < jLen; j += 1)if (shapes[j].ty === 'sh') {
                kLen = shapes[j].ks.k.i.length;
                pathNodes = shapes[j].ks.k;
                pathArr = [];
                for(k = 1; k < kLen; k += 1){
                    if (k === 1) pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                    pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
                }
                pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                commands[commandsCounter] = pathArr;
                commandsCounter += 1;
            }
            if (singleShape) {
                xPos += letters[i].l;
                xPos += trackingOffset;
            }
            if (this.textSpans[cnt]) this.textSpans[cnt].elem = commands;
            else this.textSpans[cnt] = {
                elem: commands
            };
            cnt += 1;
        }
    };
    CVTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var ctx = this.canvasContext;
        ctx.font = this.values.fValue;
        this.globalData.renderer.ctxLineCap('butt');
        // ctx.lineCap = 'butt';
        this.globalData.renderer.ctxLineJoin('miter');
        // ctx.lineJoin = 'miter';
        this.globalData.renderer.ctxMiterLimit(4);
        // ctx.miterLimit = 4;
        if (!this.data.singleShape) this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        var i;
        var len;
        var j;
        var jLen;
        var k;
        var kLen;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var lastFill = null;
        var lastStroke = null;
        var lastStrokeW = null;
        var commands;
        var pathArr;
        var renderer = this.globalData.renderer;
        for(i = 0; i < len; i += 1)if (!letters[i].n) {
            renderedLetter = renderedLetters[i];
            if (renderedLetter) {
                renderer.save();
                renderer.ctxTransform(renderedLetter.p);
                renderer.ctxOpacity(renderedLetter.o);
            }
            if (this.fill) {
                if (renderedLetter && renderedLetter.fc) {
                    if (lastFill !== renderedLetter.fc) {
                        renderer.ctxFillStyle(renderedLetter.fc);
                        lastFill = renderedLetter.fc;
                    // ctx.fillStyle = renderedLetter.fc;
                    }
                } else if (lastFill !== this.values.fill) {
                    lastFill = this.values.fill;
                    renderer.ctxFillStyle(this.values.fill);
                // ctx.fillStyle = this.values.fill;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxFill();
            // this.globalData.canvasContext.fill();
            /// ctx.fillText(this.textSpans[i].val,0,0);
            }
            if (this.stroke) {
                if (renderedLetter && renderedLetter.sw) {
                    if (lastStrokeW !== renderedLetter.sw) {
                        lastStrokeW = renderedLetter.sw;
                        renderer.ctxLineWidth(renderedLetter.sw);
                    // ctx.lineWidth = renderedLetter.sw;
                    }
                } else if (lastStrokeW !== this.values.sWidth) {
                    lastStrokeW = this.values.sWidth;
                    renderer.ctxLineWidth(this.values.sWidth);
                // ctx.lineWidth = this.values.sWidth;
                }
                if (renderedLetter && renderedLetter.sc) {
                    if (lastStroke !== renderedLetter.sc) {
                        lastStroke = renderedLetter.sc;
                        renderer.ctxStrokeStyle(renderedLetter.sc);
                    // ctx.strokeStyle = renderedLetter.sc;
                    }
                } else if (lastStroke !== this.values.stroke) {
                    lastStroke = this.values.stroke;
                    renderer.ctxStrokeStyle(this.values.stroke);
                // ctx.strokeStyle = this.values.stroke;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxStroke();
            // this.globalData.canvasContext.stroke();
            /// ctx.strokeText(letters[i].val,0,0);
            }
            if (renderedLetter) this.globalData.renderer.restore();
        }
    };
    function CVImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.img = globalData.imageLoader.getAsset(this.assetData);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVImageElement);
    CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVImageElement.prototype.createContent = function() {
        if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
            var canvas = createTag('canvas');
            canvas.width = this.assetData.w;
            canvas.height = this.assetData.h;
            var ctx = canvas.getContext('2d');
            var imgW = this.img.width;
            var imgH = this.img.height;
            var imgRel = imgW / imgH;
            var canvasRel = this.assetData.w / this.assetData.h;
            var widthCrop;
            var heightCrop;
            var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
            if (imgRel > canvasRel && par === 'xMidYMid slice' || imgRel < canvasRel && par !== 'xMidYMid slice') {
                heightCrop = imgH;
                widthCrop = heightCrop * canvasRel;
            } else {
                widthCrop = imgW;
                heightCrop = widthCrop / canvasRel;
            }
            ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
            this.img = canvas;
        }
    };
    CVImageElement.prototype.renderInnerContent = function() {
        this.canvasContext.drawImage(this.img, 0, 0);
    };
    CVImageElement.prototype.destroy = function() {
        this.img = null;
    };
    function CVSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVSolidElement);
    CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVSolidElement.prototype.renderInnerContent = function() {
        // var ctx = this.canvasContext;
        this.globalData.renderer.ctxFillStyle(this.data.sc);
        // ctx.fillStyle = this.data.sc;
        this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
    // ctx.fillRect(0, 0, this.data.sw, this.data.sh);
    //
    };
    function CanvasRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], CanvasRendererBase);
    CanvasRendererBase.prototype.createShape = function(data) {
        return new CVShapeElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createText = function(data) {
        return new CVTextElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createImage = function(data) {
        return new CVImageElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createSolid = function(data) {
        return new CVSolidElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    CanvasRendererBase.prototype.ctxTransform = function(props) {
        if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) return;
        this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
    };
    CanvasRendererBase.prototype.ctxOpacity = function(op) {
        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
    };
    CanvasRendererBase.prototype.ctxFillStyle = function(value) {
        this.canvasContext.fillStyle = value;
    };
    CanvasRendererBase.prototype.ctxStrokeStyle = function(value) {
        this.canvasContext.strokeStyle = value;
    };
    CanvasRendererBase.prototype.ctxLineWidth = function(value) {
        this.canvasContext.lineWidth = value;
    };
    CanvasRendererBase.prototype.ctxLineCap = function(value) {
        this.canvasContext.lineCap = value;
    };
    CanvasRendererBase.prototype.ctxLineJoin = function(value) {
        this.canvasContext.lineJoin = value;
    };
    CanvasRendererBase.prototype.ctxMiterLimit = function(value) {
        this.canvasContext.miterLimit = value;
    };
    CanvasRendererBase.prototype.ctxFill = function(rule) {
        this.canvasContext.fill(rule);
    };
    CanvasRendererBase.prototype.ctxFillRect = function(x, y, w, h) {
        this.canvasContext.fillRect(x, y, w, h);
    };
    CanvasRendererBase.prototype.ctxStroke = function() {
        this.canvasContext.stroke();
    };
    CanvasRendererBase.prototype.reset = function() {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        this.contextData.reset();
    };
    CanvasRendererBase.prototype.save = function() {
        this.canvasContext.save();
    };
    CanvasRendererBase.prototype.restore = function(actionFlag) {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        if (actionFlag) this.globalData.blendMode = 'source-over';
        this.contextData.restore(actionFlag);
    };
    CanvasRendererBase.prototype.configAnimation = function(animData) {
        if (this.animationItem.wrapper) {
            this.animationItem.container = createTag('canvas');
            var containerStyle = this.animationItem.container.style;
            containerStyle.width = '100%';
            containerStyle.height = '100%';
            var origin = '0px 0px 0px';
            containerStyle.transformOrigin = origin;
            containerStyle.mozTransformOrigin = origin;
            containerStyle.webkitTransformOrigin = origin;
            containerStyle['-webkit-transform'] = origin;
            containerStyle.contentVisibility = this.renderConfig.contentVisibility;
            this.animationItem.wrapper.appendChild(this.animationItem.container);
            this.canvasContext = this.animationItem.container.getContext('2d');
            if (this.renderConfig.className) this.animationItem.container.setAttribute('class', this.renderConfig.className);
            if (this.renderConfig.id) this.animationItem.container.setAttribute('id', this.renderConfig.id);
        } else this.canvasContext = this.renderConfig.context;
        this.contextData.setContext(this.canvasContext);
        this.data = animData;
        this.layers = animData.layers;
        this.transformCanvas = {
            w: animData.w,
            h: animData.h,
            sx: 0,
            sy: 0,
            tx: 0,
            ty: 0
        };
        this.setupGlobalData(animData, document.body);
        this.globalData.canvasContext = this.canvasContext;
        this.globalData.renderer = this;
        this.globalData.isDashed = false;
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.globalData.transformCanvas = this.transformCanvas;
        this.elements = createSizedArray(animData.layers.length);
        this.updateContainerSize();
    };
    CanvasRendererBase.prototype.updateContainerSize = function(width, height) {
        this.reset();
        var elementWidth;
        var elementHeight;
        if (width) {
            elementWidth = width;
            elementHeight = height;
            this.canvasContext.canvas.width = elementWidth;
            this.canvasContext.canvas.height = elementHeight;
        } else {
            if (this.animationItem.wrapper && this.animationItem.container) {
                elementWidth = this.animationItem.wrapper.offsetWidth;
                elementHeight = this.animationItem.wrapper.offsetHeight;
            } else {
                elementWidth = this.canvasContext.canvas.width;
                elementHeight = this.canvasContext.canvas.height;
            }
            this.canvasContext.canvas.width = elementWidth * this.renderConfig.dpr;
            this.canvasContext.canvas.height = elementHeight * this.renderConfig.dpr;
        }
        var elementRel;
        var animationRel;
        if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
            var par = this.renderConfig.preserveAspectRatio.split(' ');
            var fillType = par[1] || 'meet';
            var pos = par[0] || 'xMidYMid';
            var xPos = pos.substr(0, 4);
            var yPos = pos.substr(4);
            elementRel = elementWidth / elementHeight;
            animationRel = this.transformCanvas.w / this.transformCanvas.h;
            if (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice') {
                this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
                this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            } else {
                this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
                this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            }
            if (xPos === 'xMid' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
            else if (xPos === 'xMax' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
            else this.transformCanvas.tx = 0;
            if (yPos === 'YMid' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
            else if (yPos === 'YMax' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) * this.renderConfig.dpr;
            else this.transformCanvas.ty = 0;
        } else if (this.renderConfig.preserveAspectRatio === 'none') {
            this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        } else {
            this.transformCanvas.sx = this.renderConfig.dpr;
            this.transformCanvas.sy = this.renderConfig.dpr;
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        }
        this.transformCanvas.props = [
            this.transformCanvas.sx,
            0,
            0,
            0,
            0,
            this.transformCanvas.sy,
            0,
            0,
            0,
            0,
            1,
            0,
            this.transformCanvas.tx,
            this.transformCanvas.ty,
            0,
            1
        ];
        /* var i, len = this.elements.length;
      for(i=0;i<len;i+=1){
          if(this.elements[i] && this.elements[i].data.ty === 0){
              this.elements[i].resize(this.globalData.transformCanvas);
          }
      } */ this.ctxTransform(this.transformCanvas.props);
        this.canvasContext.beginPath();
        this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
        this.canvasContext.closePath();
        this.canvasContext.clip();
        this.renderFrame(this.renderedFrame, true);
    };
    CanvasRendererBase.prototype.destroy = function() {
        if (this.renderConfig.clearCanvas && this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.globalData.canvasContext = null;
        this.animationItem.container = null;
        this.destroyed = true;
    };
    CanvasRendererBase.prototype.renderFrame = function(num, forceRender) {
        if (this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender || this.destroyed || num === -1) return;
        this.renderedFrame = num;
        this.globalData.frameNum = num - this.animationItem._isFirstFrame;
        this.globalData.frameId += 1;
        this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
        this.globalData.projectInterface.currentFrame = num;
        // console.log('--------');
        // console.log('NEW: ',num);
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            if (this.renderConfig.clearCanvas === true) this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
            else this.save();
            for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
            if (this.renderConfig.clearCanvas !== true) this.restore();
        }
    };
    CanvasRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        var element = this.createItem(this.layers[pos], this, this.globalData);
        elements[pos] = element;
        element.initExpressions();
    /* if(this.layers[pos].ty === 0){
          element.resize(this.globalData.transformCanvas);
      } */ };
    CanvasRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    CanvasRendererBase.prototype.hide = function() {
        this.animationItem.container.style.display = 'none';
    };
    CanvasRendererBase.prototype.show = function() {
        this.animationItem.container.style.display = 'block';
    };
    function CanvasContext() {
        this.opacity = -1;
        this.transform = createTypedArray('float32', 16);
        this.fillStyle = '';
        this.strokeStyle = '';
        this.lineWidth = '';
        this.lineCap = '';
        this.lineJoin = '';
        this.miterLimit = '';
        this.id = Math.random();
    }
    function CVContextData() {
        this.stack = [];
        this.cArrPos = 0;
        this.cTr = new Matrix();
        var i;
        var len = 15;
        for(i = 0; i < len; i += 1){
            var canvasContext = new CanvasContext();
            this.stack[i] = canvasContext;
        }
        this._length = len;
        this.nativeContext = null;
        this.transformMat = new Matrix();
        this.currentOpacity = 1;
        //
        this.currentFillStyle = '';
        this.appliedFillStyle = '';
        //
        this.currentStrokeStyle = '';
        this.appliedStrokeStyle = '';
        //
        this.currentLineWidth = '';
        this.appliedLineWidth = '';
        //
        this.currentLineCap = '';
        this.appliedLineCap = '';
        //
        this.currentLineJoin = '';
        this.appliedLineJoin = '';
        //
        this.appliedMiterLimit = '';
        this.currentMiterLimit = '';
    }
    CVContextData.prototype.duplicate = function() {
        var newLength = this._length * 2;
        var i = 0;
        for(i = this._length; i < newLength; i += 1)this.stack[i] = new CanvasContext();
        this._length = newLength;
    };
    CVContextData.prototype.reset = function() {
        this.cArrPos = 0;
        this.cTr.reset();
        this.stack[this.cArrPos].opacity = 1;
    };
    CVContextData.prototype.restore = function(forceRestore) {
        this.cArrPos -= 1;
        var currentContext = this.stack[this.cArrPos];
        var transform = currentContext.transform;
        var i;
        var arr = this.cTr.props;
        for(i = 0; i < 16; i += 1)arr[i] = transform[i];
        if (forceRestore) {
            this.nativeContext.restore();
            var prevStack = this.stack[this.cArrPos + 1];
            this.appliedFillStyle = prevStack.fillStyle;
            this.appliedStrokeStyle = prevStack.strokeStyle;
            this.appliedLineWidth = prevStack.lineWidth;
            this.appliedLineCap = prevStack.lineCap;
            this.appliedLineJoin = prevStack.lineJoin;
            this.appliedMiterLimit = prevStack.miterLimit;
        }
        this.nativeContext.setTransform(transform[0], transform[1], transform[4], transform[5], transform[12], transform[13]);
        if (forceRestore || currentContext.opacity !== -1 && this.currentOpacity !== currentContext.opacity) {
            this.nativeContext.globalAlpha = currentContext.opacity;
            this.currentOpacity = currentContext.opacity;
        }
        this.currentFillStyle = currentContext.fillStyle;
        this.currentStrokeStyle = currentContext.strokeStyle;
        this.currentLineWidth = currentContext.lineWidth;
        this.currentLineCap = currentContext.lineCap;
        this.currentLineJoin = currentContext.lineJoin;
        this.currentMiterLimit = currentContext.miterLimit;
    };
    CVContextData.prototype.save = function(saveOnNativeFlag) {
        if (saveOnNativeFlag) this.nativeContext.save();
        var props = this.cTr.props;
        if (this._length <= this.cArrPos) this.duplicate();
        var currentStack = this.stack[this.cArrPos];
        var i;
        for(i = 0; i < 16; i += 1)currentStack.transform[i] = props[i];
        this.cArrPos += 1;
        var newStack = this.stack[this.cArrPos];
        newStack.opacity = currentStack.opacity;
        newStack.fillStyle = currentStack.fillStyle;
        newStack.strokeStyle = currentStack.strokeStyle;
        newStack.lineWidth = currentStack.lineWidth;
        newStack.lineCap = currentStack.lineCap;
        newStack.lineJoin = currentStack.lineJoin;
        newStack.miterLimit = currentStack.miterLimit;
    };
    CVContextData.prototype.setOpacity = function(value) {
        this.stack[this.cArrPos].opacity = value;
    };
    CVContextData.prototype.setContext = function(value) {
        this.nativeContext = value;
    };
    CVContextData.prototype.fillStyle = function(value) {
        if (this.stack[this.cArrPos].fillStyle !== value) {
            this.currentFillStyle = value;
            this.stack[this.cArrPos].fillStyle = value;
        }
    };
    CVContextData.prototype.strokeStyle = function(value) {
        if (this.stack[this.cArrPos].strokeStyle !== value) {
            this.currentStrokeStyle = value;
            this.stack[this.cArrPos].strokeStyle = value;
        }
    };
    CVContextData.prototype.lineWidth = function(value) {
        if (this.stack[this.cArrPos].lineWidth !== value) {
            this.currentLineWidth = value;
            this.stack[this.cArrPos].lineWidth = value;
        }
    };
    CVContextData.prototype.lineCap = function(value) {
        if (this.stack[this.cArrPos].lineCap !== value) {
            this.currentLineCap = value;
            this.stack[this.cArrPos].lineCap = value;
        }
    };
    CVContextData.prototype.lineJoin = function(value) {
        if (this.stack[this.cArrPos].lineJoin !== value) {
            this.currentLineJoin = value;
            this.stack[this.cArrPos].lineJoin = value;
        }
    };
    CVContextData.prototype.miterLimit = function(value) {
        if (this.stack[this.cArrPos].miterLimit !== value) {
            this.currentMiterLimit = value;
            this.stack[this.cArrPos].miterLimit = value;
        }
    };
    CVContextData.prototype.transform = function(props) {
        this.transformMat.cloneFromProps(props);
        // Taking the last transform value from the stored stack of transforms
        var currentTransform = this.cTr;
        // Applying the last transform value after the new transform to respect the order of transformations
        this.transformMat.multiply(currentTransform);
        // Storing the new transformed value in the stored transform
        currentTransform.cloneFromProps(this.transformMat.props);
        var trProps = currentTransform.props;
        // Applying the new transform to the canvas
        this.nativeContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
    };
    CVContextData.prototype.opacity = function(op) {
        var currentOpacity = this.stack[this.cArrPos].opacity;
        currentOpacity *= op < 0 ? 0 : op;
        if (this.stack[this.cArrPos].opacity !== currentOpacity) {
            if (this.currentOpacity !== op) {
                this.nativeContext.globalAlpha = op;
                this.currentOpacity = op;
            }
            this.stack[this.cArrPos].opacity = currentOpacity;
        }
    };
    CVContextData.prototype.fill = function(rule) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fill(rule);
    };
    CVContextData.prototype.fillRect = function(x, y, w, h) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fillRect(x, y, w, h);
    };
    CVContextData.prototype.stroke = function() {
        if (this.appliedStrokeStyle !== this.currentStrokeStyle) {
            this.appliedStrokeStyle = this.currentStrokeStyle;
            this.nativeContext.strokeStyle = this.appliedStrokeStyle;
        }
        if (this.appliedLineWidth !== this.currentLineWidth) {
            this.appliedLineWidth = this.currentLineWidth;
            this.nativeContext.lineWidth = this.appliedLineWidth;
        }
        if (this.appliedLineCap !== this.currentLineCap) {
            this.appliedLineCap = this.currentLineCap;
            this.nativeContext.lineCap = this.appliedLineCap;
        }
        if (this.appliedLineJoin !== this.currentLineJoin) {
            this.appliedLineJoin = this.currentLineJoin;
            this.nativeContext.lineJoin = this.appliedLineJoin;
        }
        if (this.appliedMiterLimit !== this.currentMiterLimit) {
            this.appliedMiterLimit = this.currentMiterLimit;
            this.nativeContext.miterLimit = this.appliedMiterLimit;
        }
        this.nativeContext.stroke();
    };
    function CVCompElement(data, globalData, comp) {
        this.completeLayers = false;
        this.layers = data.layers;
        this.pendingElements = [];
        this.elements = createSizedArray(this.layers.length);
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        CanvasRendererBase,
        ICompElement,
        CVBaseElement
    ], CVCompElement);
    CVCompElement.prototype.renderInnerContent = function() {
        var ctx = this.canvasContext;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(this.data.w, 0);
        ctx.lineTo(this.data.w, this.data.h);
        ctx.lineTo(0, this.data.h);
        ctx.lineTo(0, 0);
        ctx.clip();
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    CVCompElement.prototype.destroy = function() {
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i]) this.elements[i].destroy();
        this.layers = null;
        this.elements = null;
    };
    CVCompElement.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function CanvasRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.renderConfig = {
            clearCanvas: config && config.clearCanvas !== undefined ? config.clearCanvas : true,
            context: config && config.context || null,
            progressiveLoad: config && config.progressiveLoad || false,
            preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            contentVisibility: config && config.contentVisibility || 'visible',
            className: config && config.className || '',
            id: config && config.id || '',
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.renderConfig.dpr = config && config.dpr || 1;
        if (this.animationItem.wrapper) this.renderConfig.dpr = config && config.dpr || window.devicePixelRatio || 1;
        this.renderedFrame = -1;
        this.globalData = {
            frameNum: -1,
            _mdf: false,
            renderConfig: this.renderConfig,
            currentGlobalAlpha: -1
        };
        this.contextData = new CVContextData();
        this.elements = [];
        this.pendingElements = [];
        this.transformMat = new Matrix();
        this.completeLayers = false;
        this.rendererType = 'canvas';
        if (this.renderConfig.clearCanvas) {
            this.ctxTransform = this.contextData.transform.bind(this.contextData);
            this.ctxOpacity = this.contextData.opacity.bind(this.contextData);
            this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData);
            this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData);
            this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData);
            this.ctxLineCap = this.contextData.lineCap.bind(this.contextData);
            this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData);
            this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData);
            this.ctxFill = this.contextData.fill.bind(this.contextData);
            this.ctxFillRect = this.contextData.fillRect.bind(this.contextData);
            this.ctxStroke = this.contextData.stroke.bind(this.contextData);
            this.save = this.contextData.save.bind(this.contextData);
        }
    }
    extendPrototype([
        CanvasRendererBase
    ], CanvasRenderer);
    CanvasRenderer.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function HBaseElement() {}
    HBaseElement.prototype = {
        checkBlendMode: function checkBlendMode() {},
        initRendererElement: function initRendererElement() {
            this.baseElement = createTag(this.data.tg || 'div');
            if (this.data.hasMask) {
                this.svgElement = createNS('svg');
                this.layerElement = createNS('g');
                this.maskedElement = this.layerElement;
                this.svgElement.appendChild(this.layerElement);
                this.baseElement.appendChild(this.svgElement);
            } else this.layerElement = this.baseElement;
            styleDiv(this.baseElement);
        },
        createContainerElements: function createContainerElements() {
            this.renderableEffectsManager = new CVEffects(this);
            this.transformedElement = this.baseElement;
            this.maskedElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute('id', this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute('class', this.data.cl);
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};
            if (this.finalTransform._matMdf) {
                var matrixValue = this.finalTransform.mat.toCSS();
                transformedElementStyle.transform = matrixValue;
                transformedElementStyle.webkitTransform = matrixValue;
            }
            if (this.finalTransform._opMdf) transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
        },
        renderFrame: function renderFrame() {
            // If it is exported as hidden (data.hd === true) no need to render
            // If it is not visible no need to render
            if (this.data.hd || this.hidden) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderElement();
            this.renderInnerContent();
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.layerElement = null;
            this.transformedElement = null;
            if (this.matteElement) this.matteElement = null;
            if (this.maskManager) {
                this.maskManager.destroy();
                this.maskManager = null;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
        },
        addEffects: function addEffects() {},
        setMatte: function setMatte() {}
    };
    HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
    HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
    HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], HSolidElement);
    HSolidElement.prototype.createContent = function() {
        var rect;
        if (this.data.hasMask) {
            rect = createNS('rect');
            rect.setAttribute('width', this.data.sw);
            rect.setAttribute('height', this.data.sh);
            rect.setAttribute('fill', this.data.sc);
            this.svgElement.setAttribute('width', this.data.sw);
            this.svgElement.setAttribute('height', this.data.sh);
        } else {
            rect = createTag('div');
            rect.style.width = this.data.sw + 'px';
            rect.style.height = this.data.sh + 'px';
            rect.style.backgroundColor = this.data.sc;
        }
        this.layerElement.appendChild(rect);
    };
    function HShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = [];
        // Full shape data
        this.shapesData = data.shapes;
        // List of styles that will be applied to shapes
        this.stylesList = [];
        // List of modifiers that will be applied to shapes
        this.shapeModifiers = [];
        // List of items in shape tree
        this.itemsData = [];
        // List of items in previous shape tree
        this.processedElements = [];
        // List of animated components
        this.animatedContents = [];
        this.shapesContainer = createNS('g');
        this.initElement(data, globalData, comp);
        // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HSolidElement,
        SVGShapeElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HShapeElement);
    HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
    HShapeElement.prototype.createContent = function() {
        var cont;
        this.baseElement.style.fontSize = 0;
        if (this.data.hasMask) {
            this.layerElement.appendChild(this.shapesContainer);
            cont = this.svgElement;
        } else {
            cont = createNS('svg');
            var size = this.comp.data ? this.comp.data : this.globalData.compSize;
            cont.setAttribute('width', size.w);
            cont.setAttribute('height', size.h);
            cont.appendChild(this.shapesContainer);
            this.layerElement.appendChild(cont);
        }
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
        this.filterUniqueShapes();
        this.shapeCont = cont;
    };
    HShapeElement.prototype.getTransformedPoint = function(transformers, point) {
        var i;
        var len = transformers.length;
        for(i = 0; i < len; i += 1)point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
        return point;
    };
    HShapeElement.prototype.calculateShapeBoundingBox = function(item, boundingBox) {
        var shape = item.sh.v;
        var transformers = item.transformers;
        var i;
        var len = shape._length;
        var vPoint;
        var oPoint;
        var nextIPoint;
        var nextVPoint;
        if (len <= 1) return;
        for(i = 0; i < len - 1; i += 1){
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
        if (shape.c) {
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
    };
    HShapeElement.prototype.checkBounds = function(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
        this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
        var bounds = this.shapeBoundingBox;
        boundingBox.x = bmMin(bounds.left, boundingBox.x);
        boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
        boundingBox.y = bmMin(bounds.top, boundingBox.y);
        boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
    };
    HShapeElement.prototype.shapeBoundingBox = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    HShapeElement.prototype.tempBoundingBox = {
        x: 0,
        xMax: 0,
        y: 0,
        yMax: 0,
        width: 0,
        height: 0
    };
    HShapeElement.prototype.getBoundsOfCurve = function(p0, p1, p2, p3) {
        var bounds = [
            [
                p0[0],
                p3[0]
            ],
            [
                p0[1],
                p3[1]
            ]
        ];
        for(var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i){
            // eslint-disable-line no-plusplus
            b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
            a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
            c = 3 * p1[i] - 3 * p0[i];
            b |= 0; // eslint-disable-line no-bitwise
            a |= 0; // eslint-disable-line no-bitwise
            c |= 0; // eslint-disable-line no-bitwise
            if (a === 0 && b === 0) ;
            else if (a === 0) {
                t = -c / b;
                if (t > 0 && t < 1) bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
            } else {
                b2ac = b * b - 4 * c * a;
                if (b2ac >= 0) {
                    t1 = (-b + bmSqrt(b2ac)) / (2 * a);
                    if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
                    t2 = (-b - bmSqrt(b2ac)) / (2 * a);
                    if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
                }
            }
        }
        this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
        this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
        this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
        this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
    };
    HShapeElement.prototype.calculateF = function(t, p0, p1, p2, p3, i) {
        return bmPow(1 - t, 3) * p0[i] + 3 * bmPow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * bmPow(t, 2) * p2[i] + bmPow(t, 3) * p3[i];
    };
    HShapeElement.prototype.calculateBoundingBox = function(itemsData, boundingBox) {
        var i;
        var len = itemsData.length;
        for(i = 0; i < len; i += 1){
            if (itemsData[i] && itemsData[i].sh) this.calculateShapeBoundingBox(itemsData[i], boundingBox);
            else if (itemsData[i] && itemsData[i].it) this.calculateBoundingBox(itemsData[i].it, boundingBox);
            else if (itemsData[i] && itemsData[i].style && itemsData[i].w) this.expandStrokeBoundingBox(itemsData[i].w, boundingBox);
        }
    };
    HShapeElement.prototype.expandStrokeBoundingBox = function(widthProperty, boundingBox) {
        var width = 0;
        if (widthProperty.keyframes) {
            for(var i = 0; i < widthProperty.keyframes.length; i += 1){
                var kfw = widthProperty.keyframes[i].s;
                if (kfw > width) width = kfw;
            }
            width *= widthProperty.mult;
        } else width = widthProperty.v * widthProperty.mult;
        boundingBox.x -= width;
        boundingBox.xMax += width;
        boundingBox.y -= width;
        boundingBox.yMax += width;
    };
    HShapeElement.prototype.currentBoxContains = function(box) {
        return this.currentBBox.x <= box.x && this.currentBBox.y <= box.y && this.currentBBox.width + this.currentBBox.x >= box.x + box.width && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
    };
    HShapeElement.prototype.renderInnerContent = function() {
        this._renderShapeFrame();
        if (!this.hidden && (this._isFirstFrame || this._mdf)) {
            var tempBoundingBox = this.tempBoundingBox;
            var max = 999999;
            tempBoundingBox.x = max;
            tempBoundingBox.xMax = -max;
            tempBoundingBox.y = max;
            tempBoundingBox.yMax = -max;
            this.calculateBoundingBox(this.itemsData, tempBoundingBox);
            tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
            tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y;
            // var tempBoundingBox = this.shapeCont.getBBox();
            if (this.currentBoxContains(tempBoundingBox)) return;
            var changed = false;
            if (this.currentBBox.w !== tempBoundingBox.width) {
                this.currentBBox.w = tempBoundingBox.width;
                this.shapeCont.setAttribute('width', tempBoundingBox.width);
                changed = true;
            }
            if (this.currentBBox.h !== tempBoundingBox.height) {
                this.currentBBox.h = tempBoundingBox.height;
                this.shapeCont.setAttribute('height', tempBoundingBox.height);
                changed = true;
            }
            if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
                this.currentBBox.w = tempBoundingBox.width;
                this.currentBBox.h = tempBoundingBox.height;
                this.currentBBox.x = tempBoundingBox.x;
                this.currentBBox.y = tempBoundingBox.y;
                this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
                var shapeStyle = this.shapeCont.style;
                var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
                shapeStyle.transform = shapeTransform;
                shapeStyle.webkitTransform = shapeTransform;
            }
        }
    };
    function HTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.textPaths = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
        this.renderType = 'svg';
        this.isMasked = false;
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], HTextElement);
    HTextElement.prototype.createContent = function() {
        this.isMasked = this.checkMasks();
        if (this.isMasked) {
            this.renderType = 'svg';
            this.compW = this.comp.data.w;
            this.compH = this.comp.data.h;
            this.svgElement.setAttribute('width', this.compW);
            this.svgElement.setAttribute('height', this.compH);
            var g = createNS('g');
            this.maskedElement.appendChild(g);
            this.innerElem = g;
        } else {
            this.renderType = 'html';
            this.innerElem = this.layerElement;
        }
        this.checkParenting();
    };
    HTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var innerElemStyle = this.innerElem.style;
        var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
        innerElemStyle.fill = textColor;
        innerElemStyle.color = textColor;
        if (documentData.sc) {
            innerElemStyle.stroke = this.buildColor(documentData.sc);
            innerElemStyle.strokeWidth = documentData.sw + 'px';
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (!this.globalData.fontManager.chars) {
            innerElemStyle.fontSize = documentData.finalSize + 'px';
            innerElemStyle.lineHeight = documentData.finalSize + 'px';
            if (fontData.fClass) this.innerElem.className = fontData.fClass;
            else {
                innerElemStyle.fontFamily = fontData.fFamily;
                var fWeight = documentData.fWeight;
                var fStyle = documentData.fStyle;
                innerElemStyle.fontStyle = fStyle;
                innerElemStyle.fontWeight = fWeight;
            }
        }
        var i;
        var len;
        var letters = documentData.l;
        len = letters.length;
        var tSpan;
        var tParent;
        var tCont;
        var matrixHelper = this.mHelper;
        var shapes;
        var shapeStr = '';
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            if (this.globalData.fontManager.chars) {
                if (!this.textPaths[cnt]) {
                    tSpan = createNS('path');
                    tSpan.setAttribute('stroke-linecap', lineCapEnum[1]);
                    tSpan.setAttribute('stroke-linejoin', lineJoinEnum[2]);
                    tSpan.setAttribute('stroke-miterlimit', '4');
                } else tSpan = this.textPaths[cnt];
                if (!this.isMasked) {
                    if (this.textSpans[cnt]) {
                        tParent = this.textSpans[cnt];
                        tCont = tParent.children[0];
                    } else {
                        tParent = createTag('div');
                        tParent.style.lineHeight = 0;
                        tCont = createNS('svg');
                        tCont.appendChild(tSpan);
                        styleDiv(tParent);
                    }
                }
            } else if (!this.isMasked) {
                if (this.textSpans[cnt]) {
                    tParent = this.textSpans[cnt];
                    tSpan = this.textPaths[cnt];
                } else {
                    tParent = createTag('span');
                    styleDiv(tParent);
                    tSpan = createTag('span');
                    styleDiv(tSpan);
                    tParent.appendChild(tSpan);
                }
            } else tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
            // tSpan.setAttribute('visibility', 'hidden');
            if (this.globalData.fontManager.chars) {
                var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                var shapeData;
                if (charData) shapeData = charData.data;
                else shapeData = null;
                matrixHelper.reset();
                if (shapeData && shapeData.shapes && shapeData.shapes.length) {
                    shapes = shapeData.shapes[0].it;
                    matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
                    shapeStr = this.createPathShape(matrixHelper, shapes);
                    tSpan.setAttribute('d', shapeStr);
                }
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent);
                    if (shapeData && shapeData.shapes) {
                        // document.body.appendChild is needed to get exact measure of shape
                        document.body.appendChild(tCont);
                        var boundingBox = tCont.getBBox();
                        tCont.setAttribute('width', boundingBox.width + 2);
                        tCont.setAttribute('height', boundingBox.height + 2);
                        tCont.setAttribute('viewBox', boundingBox.x - 1 + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
                        var tContStyle = tCont.style;
                        var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
                        tContStyle.transform = tContTranslation;
                        tContStyle.webkitTransform = tContTranslation;
                        letters[i].yOffset = boundingBox.y - 1;
                    } else {
                        tCont.setAttribute('width', 1);
                        tCont.setAttribute('height', 1);
                    }
                    tParent.appendChild(tCont);
                } else this.innerElem.appendChild(tSpan);
            } else {
                tSpan.textContent = letters[i].val;
                tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent);
                    //
                    var tStyle = tSpan.style;
                    var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
                    tStyle.transform = tSpanTranslation;
                    tStyle.webkitTransform = tSpanTranslation;
                } else this.innerElem.appendChild(tSpan);
            }
            //
            if (!this.isMasked) this.textSpans[cnt] = tParent;
            else this.textSpans[cnt] = tSpan;
            this.textSpans[cnt].style.display = 'block';
            this.textPaths[cnt] = tSpan;
            cnt += 1;
        }
        while(cnt < this.textSpans.length){
            this.textSpans[cnt].style.display = 'none';
            cnt += 1;
        }
    };
    HTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var svgStyle;
        if (this.data.singleShape) {
            if (!this._isFirstFrame && !this.lettersChangedFlag) return;
            if (this.isMasked && this.finalTransform._matMdf) {
                // Todo Benchmark if using this is better than getBBox
                this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
                svgStyle = this.svgElement.style;
                var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
                svgStyle.transform = translation;
                svgStyle.webkitTransform = translation;
            }
        }
        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) return;
        var i;
        var len;
        var count = 0;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var textSpan;
        var textPath;
        for(i = 0; i < len; i += 1)if (letters[i].n) count += 1;
        else {
            textSpan = this.textSpans[i];
            textPath = this.textPaths[i];
            renderedLetter = renderedLetters[count];
            count += 1;
            if (renderedLetter._mdf.m) {
                if (!this.isMasked) {
                    textSpan.style.webkitTransform = renderedLetter.m;
                    textSpan.style.transform = renderedLetter.m;
                } else textSpan.setAttribute('transform', renderedLetter.m);
            }
            /// /textSpan.setAttribute('opacity',renderedLetter.o);
            textSpan.style.opacity = renderedLetter.o;
            if (renderedLetter.sw && renderedLetter._mdf.sw) textPath.setAttribute('stroke-width', renderedLetter.sw);
            if (renderedLetter.sc && renderedLetter._mdf.sc) textPath.setAttribute('stroke', renderedLetter.sc);
            if (renderedLetter.fc && renderedLetter._mdf.fc) {
                textPath.setAttribute('fill', renderedLetter.fc);
                textPath.style.color = renderedLetter.fc;
            }
        }
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
            var boundingBox = this.innerElem.getBBox();
            if (this.currentBBox.w !== boundingBox.width) {
                this.currentBBox.w = boundingBox.width;
                this.svgElement.setAttribute('width', boundingBox.width);
            }
            if (this.currentBBox.h !== boundingBox.height) {
                this.currentBBox.h = boundingBox.height;
                this.svgElement.setAttribute('height', boundingBox.height);
            }
            var margin = 1;
            if (this.currentBBox.w !== boundingBox.width + margin * 2 || this.currentBBox.h !== boundingBox.height + margin * 2 || this.currentBBox.x !== boundingBox.x - margin || this.currentBBox.y !== boundingBox.y - margin) {
                this.currentBBox.w = boundingBox.width + margin * 2;
                this.currentBBox.h = boundingBox.height + margin * 2;
                this.currentBBox.x = boundingBox.x - margin;
                this.currentBBox.y = boundingBox.y - margin;
                this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
                svgStyle = this.svgElement.style;
                var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
                svgStyle.transform = svgTransform;
                svgStyle.webkitTransform = svgTransform;
            }
        }
    };
    function HCameraElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initHierarchy();
        var getProp = PropertyFactory.getProp;
        this.pe = getProp(this, data.pe, 0, 0, this);
        if (data.ks.p.s) {
            this.px = getProp(this, data.ks.p.x, 1, 0, this);
            this.py = getProp(this, data.ks.p.y, 1, 0, this);
            this.pz = getProp(this, data.ks.p.z, 1, 0, this);
        } else this.p = getProp(this, data.ks.p, 1, 0, this);
        if (data.ks.a) this.a = getProp(this, data.ks.a, 1, 0, this);
        if (data.ks.or.k.length && data.ks.or.k[0].to) {
            var i;
            var len = data.ks.or.k.length;
            for(i = 0; i < len; i += 1){
                data.ks.or.k[i].to = null;
                data.ks.or.k[i].ti = null;
            }
        }
        this.or = getProp(this, data.ks.or, 1, degToRads, this);
        this.or.sh = true;
        this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
        this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
        this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
        this.mat = new Matrix();
        this._prevMat = new Matrix();
        this._isFirstFrame = true;
        // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
        this.finalTransform = {
            mProp: this
        };
    }
    extendPrototype([
        BaseElement,
        FrameElement,
        HierarchyElement
    ], HCameraElement);
    HCameraElement.prototype.setup = function() {
        var i;
        var len = this.comp.threeDElements.length;
        var comp;
        var perspectiveStyle;
        var containerStyle;
        for(i = 0; i < len; i += 1){
            // [perspectiveElem,container]
            comp = this.comp.threeDElements[i];
            if (comp.type === '3d') {
                perspectiveStyle = comp.perspectiveElem.style;
                containerStyle = comp.container.style;
                var perspective = this.pe.v + 'px';
                var origin = '0px 0px 0px';
                var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
                perspectiveStyle.perspective = perspective;
                perspectiveStyle.webkitPerspective = perspective;
                containerStyle.transformOrigin = origin;
                containerStyle.mozTransformOrigin = origin;
                containerStyle.webkitTransformOrigin = origin;
                perspectiveStyle.transform = matrix;
                perspectiveStyle.webkitTransform = matrix;
            }
        }
    };
    HCameraElement.prototype.createElements = function() {};
    HCameraElement.prototype.hide = function() {};
    HCameraElement.prototype.renderFrame = function() {
        var _mdf = this._isFirstFrame;
        var i;
        var len;
        if (this.hierarchy) {
            len = this.hierarchy.length;
            for(i = 0; i < len; i += 1)_mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
        }
        if (_mdf || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
            this.mat.reset();
            if (this.hierarchy) {
                len = this.hierarchy.length - 1;
                for(i = len; i >= 0; i -= 1){
                    var mTransf = this.hierarchy[i].finalTransform.mProp;
                    this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
                    this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
                    this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
                    this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
                    this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
                }
            }
            if (this.p) this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
            else this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
            if (this.a) {
                var diffVector;
                if (this.p) diffVector = [
                    this.p.v[0] - this.a.v[0],
                    this.p.v[1] - this.a.v[1],
                    this.p.v[2] - this.a.v[2]
                ];
                else diffVector = [
                    this.px.v - this.a.v[0],
                    this.py.v - this.a.v[1],
                    this.pz.v - this.a.v[2]
                ];
                var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2));
                // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
                var lookDir = [
                    diffVector[0] / mag,
                    diffVector[1] / mag,
                    diffVector[2] / mag
                ];
                var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
                var mRotationX = Math.atan2(lookDir[1], lookLengthOnXZ);
                var mRotationY = Math.atan2(lookDir[0], -lookDir[2]);
                this.mat.rotateY(mRotationY).rotateX(-mRotationX);
            }
            this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
            this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
            this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
            this.mat.translate(0, 0, this.pe.v);
            var hasMatrixChanged = !this._prevMat.equals(this.mat);
            if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
                len = this.comp.threeDElements.length;
                var comp;
                var perspectiveStyle;
                var containerStyle;
                for(i = 0; i < len; i += 1){
                    comp = this.comp.threeDElements[i];
                    if (comp.type === '3d') {
                        if (hasMatrixChanged) {
                            var matValue = this.mat.toCSS();
                            containerStyle = comp.container.style;
                            containerStyle.transform = matValue;
                            containerStyle.webkitTransform = matValue;
                        }
                        if (this.pe._mdf) {
                            perspectiveStyle = comp.perspectiveElem.style;
                            perspectiveStyle.perspective = this.pe.v + 'px';
                            perspectiveStyle.webkitPerspective = this.pe.v + 'px';
                        }
                    }
                }
                this.mat.clone(this._prevMat);
            }
        }
        this._isFirstFrame = false;
    };
    HCameraElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    HCameraElement.prototype.destroy = function() {};
    HCameraElement.prototype.getBaseElement = function() {
        return null;
    };
    function HImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HSolidElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HImageElement);
    HImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        var img = new Image();
        if (this.data.hasMask) {
            this.imageElem = createNS('image');
            this.imageElem.setAttribute('width', this.assetData.w + 'px');
            this.imageElem.setAttribute('height', this.assetData.h + 'px');
            this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
            this.layerElement.appendChild(this.imageElem);
            this.baseElement.setAttribute('width', this.assetData.w);
            this.baseElement.setAttribute('height', this.assetData.h);
        } else this.layerElement.appendChild(img);
        img.crossOrigin = 'anonymous';
        img.src = assetPath;
        if (this.data.ln) this.baseElement.setAttribute('id', this.data.ln);
    };
    function HybridRendererBase(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || '',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '400%',
                height: config && config.filterSize && config.filterSize.height || '400%',
                x: config && config.filterSize && config.filterSize.x || '-100%',
                y: config && config.filterSize && config.filterSize.y || '-100%'
            }
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = 'html';
    }
    extendPrototype([
        BaseRenderer
    ], HybridRendererBase);
    HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;
    HybridRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    HybridRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newDOMElement = element.getBaseElement();
        if (!newDOMElement) return;
        var layer = this.layers[pos];
        if (!layer.ddd || !this.supports3d) {
            if (this.threeDElements) this.addTo3dContainer(newDOMElement, pos);
            else {
                var i = 0;
                var nextDOMElement;
                var nextLayer;
                var tmpDOMElement;
                while(i < pos){
                    if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
                        nextLayer = this.elements[i];
                        tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
                        nextDOMElement = tmpDOMElement || nextDOMElement;
                    }
                    i += 1;
                }
                if (nextDOMElement) {
                    if (!layer.ddd || !this.supports3d) this.layerElement.insertBefore(newDOMElement, nextDOMElement);
                } else if (!layer.ddd || !this.supports3d) this.layerElement.appendChild(newDOMElement);
            }
        } else this.addTo3dContainer(newDOMElement, pos);
    };
    HybridRendererBase.prototype.createShape = function(data) {
        if (!this.supports3d) return new SVGShapeElement(data, this.globalData, this);
        return new HShapeElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createText = function(data) {
        if (!this.supports3d) return new SVGTextLottieElement(data, this.globalData, this);
        return new HTextElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createCamera = function(data) {
        this.camera = new HCameraElement(data, this.globalData, this);
        return this.camera;
    };
    HybridRendererBase.prototype.createImage = function(data) {
        if (!this.supports3d) return new IImageElement(data, this.globalData, this);
        return new HImageElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createSolid = function(data) {
        if (!this.supports3d) return new ISolidElement(data, this.globalData, this);
        return new HSolidElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    HybridRendererBase.prototype.getThreeDContainerByPos = function(pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) return this.threeDElements[i].perspectiveElem;
            i += 1;
        }
        return null;
    };
    HybridRendererBase.prototype.createThreeDContainer = function(pos, type) {
        var perspectiveElem = createTag('div');
        var style;
        var containerStyle;
        styleDiv(perspectiveElem);
        var container = createTag('div');
        styleDiv(container);
        if (type === '3d') {
            style = perspectiveElem.style;
            style.width = this.globalData.compSize.w + 'px';
            style.height = this.globalData.compSize.h + 'px';
            var center = '50% 50%';
            style.webkitTransformOrigin = center;
            style.mozTransformOrigin = center;
            style.transformOrigin = center;
            containerStyle = container.style;
            var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
            containerStyle.transform = matrix;
            containerStyle.webkitTransform = matrix;
        }
        perspectiveElem.appendChild(container);
        // this.resizerElem.appendChild(perspectiveElem);
        var threeDContainerData = {
            container: container,
            perspectiveElem: perspectiveElem,
            startPos: pos,
            endPos: pos,
            type: type
        };
        this.threeDElements.push(threeDContainerData);
        return threeDContainerData;
    };
    HybridRendererBase.prototype.build3dContainers = function() {
        var i;
        var len = this.layers.length;
        var lastThreeDContainerData;
        var currentContainer = '';
        for(i = 0; i < len; i += 1)if (this.layers[i].ddd && this.layers[i].ty !== 3) {
            if (currentContainer !== '3d') {
                currentContainer = '3d';
                lastThreeDContainerData = this.createThreeDContainer(i, '3d');
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        } else {
            if (currentContainer !== '2d') {
                currentContainer = '2d';
                lastThreeDContainerData = this.createThreeDContainer(i, '2d');
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        }
        len = this.threeDElements.length;
        for(i = len - 1; i >= 0; i -= 1)this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
    };
    HybridRendererBase.prototype.addTo3dContainer = function(elem, pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (pos <= this.threeDElements[i].endPos) {
                var j = this.threeDElements[i].startPos;
                var nextElement;
                while(j < pos){
                    if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
                    j += 1;
                }
                if (nextElement) this.threeDElements[i].container.insertBefore(elem, nextElement);
                else this.threeDElements[i].container.appendChild(elem);
                break;
            }
            i += 1;
        }
    };
    HybridRendererBase.prototype.configAnimation = function(animData) {
        var resizerElem = createTag('div');
        var wrapper = this.animationItem.wrapper;
        var style = resizerElem.style;
        style.width = animData.w + 'px';
        style.height = animData.h + 'px';
        this.resizerElem = resizerElem;
        styleDiv(resizerElem);
        style.transformStyle = 'flat';
        style.mozTransformStyle = 'flat';
        style.webkitTransformStyle = 'flat';
        if (this.renderConfig.className) resizerElem.setAttribute('class', this.renderConfig.className);
        wrapper.appendChild(resizerElem);
        style.overflow = 'hidden';
        var svg = createNS('svg');
        svg.setAttribute('width', '1');
        svg.setAttribute('height', '1');
        styleDiv(svg);
        this.resizerElem.appendChild(svg);
        var defs = createNS('defs');
        svg.appendChild(defs);
        this.data = animData;
        // Mask animation
        this.setupGlobalData(animData, svg);
        this.globalData.defs = defs;
        this.layers = animData.layers;
        this.layerElement = this.resizerElem;
        this.build3dContainers();
        this.updateContainerSize();
    };
    HybridRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        this.animationItem.container = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    HybridRendererBase.prototype.updateContainerSize = function() {
        var elementWidth = this.animationItem.wrapper.offsetWidth;
        var elementHeight = this.animationItem.wrapper.offsetHeight;
        var elementRel = elementWidth / elementHeight;
        var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
        var sx;
        var sy;
        var tx;
        var ty;
        if (animationRel > elementRel) {
            sx = elementWidth / this.globalData.compSize.w;
            sy = elementWidth / this.globalData.compSize.w;
            tx = 0;
            ty = (elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2;
        } else {
            sx = elementHeight / this.globalData.compSize.h;
            sy = elementHeight / this.globalData.compSize.h;
            tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
            ty = 0;
        }
        var style = this.resizerElem.style;
        style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
        style.transform = style.webkitTransform;
    };
    HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
    HybridRendererBase.prototype.hide = function() {
        this.resizerElem.style.display = 'none';
    };
    HybridRendererBase.prototype.show = function() {
        this.resizerElem.style.display = 'block';
    };
    HybridRendererBase.prototype.initItems = function() {
        this.buildAllItems();
        if (this.camera) this.camera.setup();
        else {
            var cWidth = this.globalData.compSize.w;
            var cHeight = this.globalData.compSize.h;
            var i;
            var len = this.threeDElements.length;
            for(i = 0; i < len; i += 1){
                var style = this.threeDElements[i].perspectiveElem.style;
                style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
                style.perspective = style.webkitPerspective;
            }
        }
    };
    HybridRendererBase.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        var floatingContainer = createTag('div');
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    function HCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = !data.hasMask;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        HybridRendererBase,
        ICompElement,
        HBaseElement
    ], HCompElement);
    HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
    HCompElement.prototype.createContainerElements = function() {
        this._createBaseContainerElements();
        // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
        if (this.data.hasMask) {
            this.svgElement.setAttribute('width', this.data.w);
            this.svgElement.setAttribute('height', this.data.h);
            this.transformedElement = this.baseElement;
        } else this.transformedElement = this.layerElement;
    };
    HCompElement.prototype.addTo3dContainer = function(elem, pos) {
        var j = 0;
        var nextElement;
        while(j < pos){
            if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
            j += 1;
        }
        if (nextElement) this.layerElement.insertBefore(elem, nextElement);
        else this.layerElement.appendChild(elem);
    };
    HCompElement.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    function HybridRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || '',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '400%',
                height: config && config.filterSize && config.filterSize.height || '400%',
                x: config && config.filterSize && config.filterSize.x || '-100%',
                y: config && config.filterSize && config.filterSize.y || '-100%'
            },
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = 'html';
    }
    extendPrototype([
        HybridRendererBase
    ], HybridRenderer);
    HybridRenderer.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    var CompExpressionInterface = function() {
        return function(comp) {
            function _thisLayerFunction(name) {
                var i = 0;
                var len = comp.layers.length;
                while(i < len){
                    if (comp.layers[i].nm === name || comp.layers[i].ind === name) return comp.elements[i].layerInterface;
                    i += 1;
                }
                return null;
            // return {active:false};
            }
            Object.defineProperty(_thisLayerFunction, '_name', {
                value: comp.data.nm
            });
            _thisLayerFunction.layer = _thisLayerFunction;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
            _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
            _thisLayerFunction.displayStartTime = 0;
            _thisLayerFunction.numLayers = comp.layers.length;
            return _thisLayerFunction;
        };
    }();
    function _typeof$2(o) {
        "@babel/helpers - typeof";
        return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof$2(o);
    }
    /* eslint-disable */ /*
   Copyright 2014 David Bau.

   Permission is hereby granted, free of charge, to any person obtaining
   a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including
   without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to
   permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice shall be
   included in all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

   */ function seedRandom(pool, math) {
        //
        // The following constants are related to IEEE 754 limits.
        //
        var global = this, width = 256, // each RC4 output is 0 <= x < 256
        chunks = 6, // at least six RC4 outputs for each double
        digits = 52, // there are 52 significant digits in a double
        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
        startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
        //
        // seedrandom()
        // This is the seedrandom function described above.
        //
        function seedrandom(seed, options, callback) {
            var key = [];
            options = options === true ? {
                entropy: true
            } : options || {};
            // Flatten the seed string or build one from local entropy if needed.
            var shortseed = mixkey(flatten(options.entropy ? [
                seed,
                tostring(pool)
            ] : seed === null ? autoseed() : seed, 3), key);
            // Use the seed to initialize an ARC4 generator.
            var arc4 = new ARC4(key);
            // This function returns a random double in [0, 1) that contains
            // randomness in every bit of the mantissa of the IEEE 754 value.
            var prng = function prng() {
                var n = arc4.g(chunks), // Start with a numerator n < 2 ^ 48
                d = startdenom, //   and denominator d = 2 ^ 48.
                x = 0; //   and no 'extra last byte'.
                while(n < significance){
                    // Fill up all significant digits by
                    n = (n + x) * width; //   shifting numerator and
                    d *= width; //   denominator and generating a
                    x = arc4.g(1); //   new least-significant-byte.
                }
                while(n >= overflow){
                    // To avoid rounding up, before adding
                    n /= 2; //   last byte, shift everything
                    d /= 2; //   right using integer math until
                    x >>>= 1; //   we have exactly the desired bits.
                }
                return (n + x) / d; // Form the number within [0, 1).
            };
            prng.int32 = function() {
                return arc4.g(4) | 0;
            };
            prng.quick = function() {
                return arc4.g(4) / 0x100000000;
            };
            prng["double"] = prng;
            // Mix the randomness into accumulated entropy.
            mixkey(tostring(arc4.S), pool);
            // Calling convention: what to return as a function of prng, seed, is_math.
            return (options.pass || callback || function(prng, seed, is_math_call, state) {
                if (state) {
                    // Load the arc4 state from the given state if it has an S array.
                    if (state.S) copy(state, arc4);
                    // Only provide the .state method if requested via options.state.
                    prng.state = function() {
                        return copy(arc4, {});
                    };
                }
                // If called as a method of Math (Math.seedrandom()), mutate
                // Math.random because that is how seedrandom.js has worked since v1.0.
                if (is_math_call) {
                    math[rngname] = prng;
                    return seed;
                } else return prng;
            })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
        }
        math['seed' + rngname] = seedrandom;
        //
        // ARC4
        //
        // An ARC4 implementation.  The constructor takes a key in the form of
        // an array of at most (width) integers that should be 0 <= x < (width).
        //
        // The g(count) method returns a pseudorandom integer that concatenates
        // the next (count) outputs from ARC4.  Its return value is a number x
        // that is in the range 0 <= x < (width ^ count).
        //
        function ARC4(key) {
            var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
            // The empty key [] is treated as [0].
            if (!keylen) key = [
                keylen++
            ];
            // Set up S using the standard key scheduling algorithm.
            while(i < width)s[i] = i++;
            for(i = 0; i < width; i++){
                s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
                s[j] = t;
            }
            // The "g" method returns the next (count) outputs as one number.
            me.g = function(count) {
                // Using instance members instead of closure state nearly doubles speed.
                var t, r = 0, i = me.i, j = me.j, s = me.S;
                while(count--){
                    t = s[i = mask & i + 1];
                    r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
                }
                me.i = i;
                me.j = j;
                return r;
            // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
            };
        }
        //
        // copy()
        // Copies internal state of ARC4 to or from a plain object.
        //
        function copy(f, t) {
            t.i = f.i;
            t.j = f.j;
            t.S = f.S.slice();
            return t;
        }
        //
        // flatten()
        // Converts an object tree to nested arrays of strings.
        //
        function flatten(obj, depth) {
            var result = [], typ = _typeof$2(obj), prop;
            if (depth && typ == 'object') {
                for(prop in obj)try {
                    result.push(flatten(obj[prop], depth - 1));
                } catch (e) {}
            }
            return result.length ? result : typ == 'string' ? obj : obj + '\0';
        }
        //
        // mixkey()
        // Mixes a string seed into a key that is an array of integers, and
        // returns a shortened string seed that is equivalent to the result key.
        //
        function mixkey(seed, key) {
            var stringseed = seed + '', smear, j = 0;
            while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
            return tostring(key);
        }
        //
        // autoseed()
        // Returns an object for autoseeding, using window.crypto and Node crypto
        // module if available.
        //
        function autoseed() {
            try {
                if (nodecrypto) return tostring(nodecrypto.randomBytes(width));
                var out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
                return tostring(out);
            } catch (e) {
                var browser = global.navigator, plugins = browser && browser.plugins;
                return [
                    +new Date(),
                    global,
                    plugins,
                    global.screen,
                    tostring(pool)
                ];
            }
        }
        //
        // tostring()
        // Converts an array of charcodes to a string
        //
        function tostring(a) {
            return String.fromCharCode.apply(0, a);
        }
        //
        // When seedrandom.js is loaded, we immediately mix a few bits
        // from the built-in RNG into the entropy pool.  Because we do
        // not want to interfere with deterministic PRNG state later,
        // seedrandom will not call math.random on its own again after
        // initialization.
        //
        mixkey(math.random(), pool);
    //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    // End anonymous scope, and pass initial values.
    }
    function initialize$2(BMMath) {
        seedRandom([], BMMath);
    }
    var propTypes = {
        SHAPE: 'shape'
    };
    function _typeof$1(o) {
        "@babel/helpers - typeof";
        return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof$1(o);
    }
    var ExpressionManager = function() {
        'use strict';
        var ob = {};
        var Math1 = BMMath;
        var window1 = null;
        var document1 = null;
        var XMLHttpRequest1 = null;
        var fetch = null;
        var frames = null;
        var _lottieGlobal = {};
        initialize$2(BMMath);
        function resetFrame() {
            _lottieGlobal = {};
        }
        function $bm_isInstanceOfArray(arr) {
            return arr.constructor === Array || arr.constructor === Float32Array;
        }
        function isNumerable(tOfV, v) {
            return tOfV === 'number' || v instanceof Number || tOfV === 'boolean' || tOfV === 'string';
        }
        function $bm_neg(a) {
            var tOfA = _typeof$1(a);
            if (tOfA === 'number' || a instanceof Number || tOfA === 'boolean') return -a;
            if ($bm_isInstanceOfArray(a)) {
                var i;
                var lenA = a.length;
                var retArr = [];
                for(i = 0; i < lenA; i += 1)retArr[i] = -a[i];
                return retArr;
            }
            if (a.propType) return a.v;
            return -a;
        }
        var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
        var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
        var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;
        function sum(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b) || tOfA === 'string' || tOfB === 'string') return a + b;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] += b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a + b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) retArr[i] = a[i] + b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        var add = sum;
        function sub(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
                if (tOfA === 'string') a = parseInt(a, 10);
                if (tOfB === 'string') b = parseInt(b, 10);
                return a - b;
            }
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] -= b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a - b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) retArr[i] = a[i] - b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        function mul(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a * b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] * b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a * b[i];
                return arr;
            }
            return 0;
        }
        function div(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a / b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] / b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a / b[i];
                return arr;
            }
            return 0;
        }
        function mod(a, b) {
            if (typeof a === 'string') a = parseInt(a, 10);
            if (typeof b === 'string') b = parseInt(b, 10);
            return a % b;
        }
        var $bm_sum = sum;
        var $bm_sub = sub;
        var $bm_mul = mul;
        var $bm_div = div;
        var $bm_mod = mod;
        function clamp(num, min, max) {
            if (min > max) {
                var mm = max;
                max = min;
                min = mm;
            }
            return Math1.min(Math1.max(num, min), max);
        }
        function radiansToDegrees(val) {
            return val / degToRads;
        }
        var radians_to_degrees = radiansToDegrees;
        function degreesToRadians(val) {
            return val * degToRads;
        }
        var degrees_to_radians = radiansToDegrees;
        var helperLengthArray = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        function length(arr1, arr2) {
            if (typeof arr1 === 'number' || arr1 instanceof Number) {
                arr2 = arr2 || 0;
                return Math1.abs(arr1 - arr2);
            }
            if (!arr2) arr2 = helperLengthArray;
            var i;
            var len = Math1.min(arr1.length, arr2.length);
            var addedLength = 0;
            for(i = 0; i < len; i += 1)addedLength += Math1.pow(arr2[i] - arr1[i], 2);
            return Math1.sqrt(addedLength);
        }
        function normalize(vec) {
            return div(vec, length(vec));
        }
        function rgbToHsl(val) {
            var r = val[0];
            var g = val[1];
            var b = val[2];
            var max = Math1.max(r, g, b);
            var min = Math1.min(r, g, b);
            var h;
            var s;
            var l = (max + min) / 2;
            if (max === min) {
                h = 0; // achromatic
                s = 0; // achromatic
            } else {
                var d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch(max){
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                    default:
                        break;
                }
                h /= 6;
            }
            return [
                h,
                s,
                l,
                val[3]
            ];
        }
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        function hslToRgb(val) {
            var h = val[0];
            var s = val[1];
            var l = val[2];
            var r;
            var g;
            var b;
            if (s === 0) {
                r = l; // achromatic
                b = l; // achromatic
                g = l; // achromatic
            } else {
                var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                var p = 2 * l - q;
                r = hue2rgb(p, q, h + 1 / 3);
                g = hue2rgb(p, q, h);
                b = hue2rgb(p, q, h - 1 / 3);
            }
            return [
                r,
                g,
                b,
                val[3]
            ];
        }
        function linear(t, tMin, tMax, value1, value2) {
            if (value1 === undefined || value2 === undefined) {
                value1 = tMin;
                value2 = tMax;
                tMin = 0;
                tMax = 1;
            }
            if (tMax < tMin) {
                var _tMin = tMax;
                tMax = tMin;
                tMin = _tMin;
            }
            if (t <= tMin) return value1;
            if (t >= tMax) return value2;
            var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);
            if (!value1.length) return value1 + (value2 - value1) * perc;
            var i;
            var len = value1.length;
            var arr = createTypedArray('float32', len);
            for(i = 0; i < len; i += 1)arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
            return arr;
        }
        function random(min, max) {
            if (max === undefined) {
                if (min === undefined) {
                    min = 0;
                    max = 1;
                } else {
                    max = min;
                    min = undefined;
                }
            }
            if (max.length) {
                var i;
                var len = max.length;
                if (!min) min = createTypedArray('float32', len);
                var arr = createTypedArray('float32', len);
                var rnd = BMMath.random();
                for(i = 0; i < len; i += 1)arr[i] = min[i] + rnd * (max[i] - min[i]);
                return arr;
            }
            if (min === undefined) min = 0;
            var rndm = BMMath.random();
            return min + rndm * (max - min);
        }
        function createPath(points, inTangents, outTangents, closed) {
            var i;
            var len = points.length;
            var path = shapePool.newElement();
            path.setPathData(!!closed, len);
            var arrPlaceholder = [
                0,
                0
            ];
            var inVertexPoint;
            var outVertexPoint;
            for(i = 0; i < len; i += 1){
                inVertexPoint = inTangents && inTangents[i] ? inTangents[i] : arrPlaceholder;
                outVertexPoint = outTangents && outTangents[i] ? outTangents[i] : arrPlaceholder;
                path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
            }
            return path;
        }
        function initiateExpression(elem, data, property) {
            // Bail out if we don't want expressions
            function noOp(_value) {
                return _value;
            }
            if (!elem.globalData.renderConfig.runExpressions) return noOp;
            var val = data.x;
            var needsVelocity = /velocity(?![\w\d])/.test(val);
            var _needsRandom = val.indexOf('random') !== -1;
            var elemType = elem.data.ty;
            var transform;
            var $bm_transform;
            var content;
            var effect;
            var thisProperty = property;
            thisProperty._name = elem.data.nm;
            thisProperty.valueAtTime = thisProperty.getValueAtTime;
            Object.defineProperty(thisProperty, 'value', {
                get: function get() {
                    return thisProperty.v;
                }
            });
            elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
            elem.comp.displayStartTime = 0;
            var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            var outPoint = elem.data.op / elem.comp.globalData.frameRate;
            var width = elem.data.sw ? elem.data.sw : 0;
            var height = elem.data.sh ? elem.data.sh : 0;
            var name = elem.data.nm;
            var loopIn;
            var loop_in;
            var loopOut;
            var loop_out;
            var smooth;
            var toWorld;
            var fromWorld;
            var fromComp;
            var toComp;
            var fromCompToSurface;
            var position;
            var rotation;
            var anchorPoint;
            var scale;
            var thisLayer;
            var thisComp;
            var mask;
            var valueAtTime;
            var velocityAtTime;
            var scoped_bm_rt;
            // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
            var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval
            var numKeys = property.kf ? data.k.length : 0;
            var active = !this.data || this.data.hd !== true;
            var wiggle = (function wiggle(freq, amp) {
                var iWiggle;
                var j;
                var lenWiggle = this.pv.length ? this.pv.length : 1;
                var addedAmps = createTypedArray('float32', lenWiggle);
                freq = 5;
                var iterations = Math1.floor(time * freq);
                iWiggle = 0;
                j = 0;
                while(iWiggle < iterations){
                    // var rnd = BMMath.random();
                    for(j = 0; j < lenWiggle; j += 1)addedAmps[j] += -amp + amp * 2 * BMMath.random();
                    iWiggle += 1;
                }
                // var rnd2 = BMMath.random();
                var periods = time * freq;
                var perc = periods - Math1.floor(periods);
                var arr = createTypedArray('float32', lenWiggle);
                if (lenWiggle > 1) {
                    for(j = 0; j < lenWiggle; j += 1)arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc;
                    return arr;
                }
                return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
            }).bind(this);
            if (thisProperty.loopIn) {
                loopIn = thisProperty.loopIn.bind(thisProperty);
                loop_in = loopIn;
            }
            if (thisProperty.loopOut) {
                loopOut = thisProperty.loopOut.bind(thisProperty);
                loop_out = loopOut;
            }
            if (thisProperty.smooth) smooth = thisProperty.smooth.bind(thisProperty);
            function loopInDuration(type, duration) {
                return loopIn(type, duration, true);
            }
            function loopOutDuration(type, duration) {
                return loopOut(type, duration, true);
            }
            if (this.getValueAtTime) valueAtTime = this.getValueAtTime.bind(this);
            if (this.getVelocityAtTime) velocityAtTime = this.getVelocityAtTime.bind(this);
            var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
            function lookAt(elem1, elem2) {
                var fVec = [
                    elem2[0] - elem1[0],
                    elem2[1] - elem1[1],
                    elem2[2] - elem1[2]
                ];
                var pitch = Math1.atan2(fVec[0], Math1.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
                var yaw = -Math1.atan2(fVec[1], fVec[2]) / degToRads;
                return [
                    yaw,
                    pitch,
                    0
                ];
            }
            function easeOut(t, tMin, tMax, val1, val2) {
                return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
            }
            function easeIn(t, tMin, tMax, val1, val2) {
                return applyEase(easeInBez, t, tMin, tMax, val1, val2);
            }
            function ease(t, tMin, tMax, val1, val2) {
                return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
            }
            function applyEase(fn, t, tMin, tMax, val1, val2) {
                if (val1 === undefined) {
                    val1 = tMin;
                    val2 = tMax;
                } else t = (t - tMin) / (tMax - tMin);
                if (t > 1) t = 1;
                else if (t < 0) t = 0;
                var mult = fn(t);
                if ($bm_isInstanceOfArray(val1)) {
                    var iKey;
                    var lenKey = val1.length;
                    var arr = createTypedArray('float32', lenKey);
                    for(iKey = 0; iKey < lenKey; iKey += 1)arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
                    return arr;
                }
                return (val2 - val1) * mult + val1;
            }
            function nearestKey(time) {
                var iKey;
                var lenKey = data.k.length;
                var index;
                var keyTime;
                if (!data.k.length || typeof data.k[0] === 'number') {
                    index = 0;
                    keyTime = 0;
                } else {
                    index = -1;
                    time *= elem.comp.globalData.frameRate;
                    if (time < data.k[0].t) {
                        index = 1;
                        keyTime = data.k[0].t;
                    } else {
                        for(iKey = 0; iKey < lenKey - 1; iKey += 1){
                            if (time === data.k[iKey].t) {
                                index = iKey + 1;
                                keyTime = data.k[iKey].t;
                                break;
                            } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
                                if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
                                    index = iKey + 2;
                                    keyTime = data.k[iKey + 1].t;
                                } else {
                                    index = iKey + 1;
                                    keyTime = data.k[iKey].t;
                                }
                                break;
                            }
                        }
                        if (index === -1) {
                            index = iKey + 1;
                            keyTime = data.k[iKey].t;
                        }
                    }
                }
                var obKey = {};
                obKey.index = index;
                obKey.time = keyTime / elem.comp.globalData.frameRate;
                return obKey;
            }
            function key(ind) {
                var obKey;
                var iKey;
                var lenKey;
                if (!data.k.length || typeof data.k[0] === 'number') throw new Error('The property has no keyframe at index ' + ind);
                ind -= 1;
                obKey = {
                    time: data.k[ind].t / elem.comp.globalData.frameRate,
                    value: []
                };
                var arr = Object.prototype.hasOwnProperty.call(data.k[ind], 's') ? data.k[ind].s : data.k[ind - 1].e;
                lenKey = arr.length;
                for(iKey = 0; iKey < lenKey; iKey += 1){
                    obKey[iKey] = arr[iKey];
                    obKey.value[iKey] = arr[iKey];
                }
                return obKey;
            }
            function framesToTime(fr, fps) {
                if (!fps) fps = elem.comp.globalData.frameRate;
                return fr / fps;
            }
            function timeToFrames(t, fps) {
                if (!t && t !== 0) t = time;
                if (!fps) fps = elem.comp.globalData.frameRate;
                return t * fps;
            }
            function seedRandom(seed) {
                BMMath.seedrandom(randSeed + seed);
            }
            function sourceRectAtTime() {
                return elem.sourceRectAtTime();
            }
            function substring(init, end) {
                if (typeof value === 'string') {
                    if (end === undefined) return value.substring(init);
                    return value.substring(init, end);
                }
                return '';
            }
            function substr(init, end) {
                if (typeof value === 'string') {
                    if (end === undefined) return value.substr(init);
                    return value.substr(init, end);
                }
                return '';
            }
            function posterizeTime(framesPerSecond) {
                time = framesPerSecond === 0 ? 0 : Math1.floor(time * framesPerSecond) / framesPerSecond;
                value = valueAtTime(time);
            }
            var time;
            var velocity;
            var value;
            var text;
            var textIndex;
            var textTotal;
            var selectorValue;
            var index = elem.data.ind;
            var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
            var parent;
            var randSeed = Math1.floor(Math1.random() * 1000000);
            var globalData = elem.globalData;
            function executeExpression(_value) {
                // globalData.pushExpression();
                value = _value;
                if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') return value;
                if (this.propType === 'textSelector') {
                    textIndex = this.textIndex;
                    textTotal = this.textTotal;
                    selectorValue = this.selectorValue;
                }
                if (!thisLayer) {
                    text = elem.layerInterface.text;
                    thisLayer = elem.layerInterface;
                    thisComp = elem.comp.compInterface;
                    toWorld = thisLayer.toWorld.bind(thisLayer);
                    fromWorld = thisLayer.fromWorld.bind(thisLayer);
                    fromComp = thisLayer.fromComp.bind(thisLayer);
                    toComp = thisLayer.toComp.bind(thisLayer);
                    mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
                    fromCompToSurface = fromComp;
                }
                if (!transform) {
                    transform = elem.layerInterface('ADBE Transform Group');
                    $bm_transform = transform;
                    if (transform) anchorPoint = transform.anchorPoint;
                }
                if (elemType === 4 && !content) content = thisLayer('ADBE Root Vectors Group');
                if (!effect) effect = thisLayer(4);
                hasParent = !!(elem.hierarchy && elem.hierarchy.length);
                if (hasParent && !parent) parent = elem.hierarchy[0].layerInterface;
                time = this.comp.renderedFrame / this.comp.globalData.frameRate;
                if (_needsRandom) seedRandom(randSeed + time);
                if (needsVelocity) velocity = velocityAtTime(time);
                expression_function();
                this.frameExpressionId = elem.globalData.frameId;
                // TODO: Check if it's possible to return on ShapeInterface the .v value
                // Changed this to a ternary operation because Rollup failed compiling it correctly
                scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
                return scoped_bm_rt;
            }
            // Bundlers will see these as dead code and unless we reference them
            executeExpression.__preventDeadCodeRemoval = [
                $bm_transform,
                anchorPoint,
                time,
                velocity,
                inPoint,
                outPoint,
                width,
                height,
                name,
                loop_in,
                loop_out,
                smooth,
                toComp,
                fromCompToSurface,
                toWorld,
                fromWorld,
                mask,
                position,
                rotation,
                scale,
                thisComp,
                numKeys,
                active,
                wiggle,
                loopInDuration,
                loopOutDuration,
                comp,
                lookAt,
                easeOut,
                easeIn,
                ease,
                nearestKey,
                key,
                text,
                textIndex,
                textTotal,
                selectorValue,
                framesToTime,
                timeToFrames,
                sourceRectAtTime,
                substring,
                substr,
                posterizeTime,
                index,
                globalData
            ];
            return executeExpression;
        }
        ob.initiateExpression = initiateExpression;
        ob.__preventDeadCodeRemoval = [
            window1,
            document1,
            XMLHttpRequest1,
            fetch,
            frames,
            $bm_neg,
            add,
            $bm_sum,
            $bm_sub,
            $bm_mul,
            $bm_div,
            $bm_mod,
            clamp,
            radians_to_degrees,
            degreesToRadians,
            degrees_to_radians,
            normalize,
            rgbToHsl,
            hslToRgb,
            linear,
            random,
            createPath,
            _lottieGlobal
        ];
        ob.resetFrame = resetFrame;
        return ob;
    }();
    var Expressions = function() {
        var ob = {};
        ob.initExpressions = initExpressions;
        ob.resetFrame = ExpressionManager.resetFrame;
        function initExpressions(animation) {
            var stackCount = 0;
            var registers = [];
            function pushExpression() {
                stackCount += 1;
            }
            function popExpression() {
                stackCount -= 1;
                if (stackCount === 0) releaseInstances();
            }
            function registerExpressionProperty(expression) {
                if (registers.indexOf(expression) === -1) registers.push(expression);
            }
            function releaseInstances() {
                var i;
                var len = registers.length;
                for(i = 0; i < len; i += 1)registers[i].release();
                registers.length = 0;
            }
            animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
            animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
            animation.renderer.globalData.pushExpression = pushExpression;
            animation.renderer.globalData.popExpression = popExpression;
            animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
        }
        return ob;
    }();
    var MaskManagerInterface = function() {
        function MaskInterface(mask, data) {
            this._mask = mask;
            this._data = data;
        }
        Object.defineProperty(MaskInterface.prototype, 'maskPath', {
            get: function get() {
                if (this._mask.prop.k) this._mask.prop.getValue();
                return this._mask.prop;
            }
        });
        Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
            get: function get() {
                if (this._mask.op.k) this._mask.op.getValue();
                return this._mask.op.v * 100;
            }
        });
        var MaskManager = function MaskManager(maskManager) {
            var _masksInterfaces = createSizedArray(maskManager.viewData.length);
            var i;
            var len = maskManager.viewData.length;
            for(i = 0; i < len; i += 1)_masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
            var maskFunction = function maskFunction(name) {
                i = 0;
                while(i < len){
                    if (maskManager.masksProperties[i].nm === name) return _masksInterfaces[i];
                    i += 1;
                }
                return null;
            };
            return maskFunction;
        };
        return MaskManager;
    }();
    var ExpressionPropertyInterface = function() {
        var defaultUnidimensionalValue = {
            pv: 0,
            v: 0,
            mult: 1
        };
        var defaultMultidimensionalValue = {
            pv: [
                0,
                0,
                0
            ],
            v: [
                0,
                0,
                0
            ],
            mult: 1
        };
        function completeProperty(expressionValue, property, type) {
            Object.defineProperty(expressionValue, 'velocity', {
                get: function get() {
                    return property.getVelocityAtTime(property.comp.currentFrame);
                }
            });
            expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
            expressionValue.key = function(pos) {
                if (!expressionValue.numKeys) return 0;
                var value = '';
                if ('s' in property.keyframes[pos - 1]) value = property.keyframes[pos - 1].s;
                else if ('e' in property.keyframes[pos - 2]) value = property.keyframes[pos - 2].e;
                else value = property.keyframes[pos - 2].s;
                var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers
                valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
                valueProp.value = type === 'unidimensional' ? value[0] : value;
                return valueProp;
            };
            expressionValue.valueAtTime = property.getValueAtTime;
            expressionValue.speedAtTime = property.getSpeedAtTime;
            expressionValue.velocityAtTime = property.getVelocityAtTime;
            expressionValue.propertyGroup = property.propertyGroup;
        }
        function UnidimensionalPropertyInterface(property) {
            if (!property || !('pv' in property)) property = defaultUnidimensionalValue;
            var mult = 1 / property.mult;
            var val = property.pv * mult;
            var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
            expressionValue.value = val;
            completeProperty(expressionValue, property, 'unidimensional');
            return function() {
                if (property.k) property.getValue();
                val = property.v * mult;
                if (expressionValue.value !== val) {
                    expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
                    expressionValue.value = val;
                    expressionValue[0] = val;
                    completeProperty(expressionValue, property, 'unidimensional');
                }
                return expressionValue;
            };
        }
        function MultidimensionalPropertyInterface(property) {
            if (!property || !('pv' in property)) property = defaultMultidimensionalValue;
            var mult = 1 / property.mult;
            var len = property.data && property.data.l || property.pv.length;
            var expressionValue = createTypedArray('float32', len);
            var arrValue = createTypedArray('float32', len);
            expressionValue.value = arrValue;
            completeProperty(expressionValue, property, 'multidimensional');
            return function() {
                if (property.k) property.getValue();
                for(var i = 0; i < len; i += 1){
                    arrValue[i] = property.v[i] * mult;
                    expressionValue[i] = arrValue[i];
                }
                return expressionValue;
            };
        }
        // TODO: try to avoid using this getter
        function defaultGetter() {
            return defaultUnidimensionalValue;
        }
        return function(property) {
            if (!property) return defaultGetter;
            if (property.propType === 'unidimensional') return UnidimensionalPropertyInterface(property);
            return MultidimensionalPropertyInterface(property);
        };
    }();
    var TransformExpressionInterface = function() {
        return function(transform) {
            function _thisFunction(name) {
                switch(name){
                    case 'scale':
                    case 'Scale':
                    case 'ADBE Scale':
                    case 6:
                        return _thisFunction.scale;
                    case 'rotation':
                    case 'Rotation':
                    case 'ADBE Rotation':
                    case 'ADBE Rotate Z':
                    case 10:
                        return _thisFunction.rotation;
                    case 'ADBE Rotate X':
                        return _thisFunction.xRotation;
                    case 'ADBE Rotate Y':
                        return _thisFunction.yRotation;
                    case 'position':
                    case 'Position':
                    case 'ADBE Position':
                    case 2:
                        return _thisFunction.position;
                    case 'ADBE Position_0':
                        return _thisFunction.xPosition;
                    case 'ADBE Position_1':
                        return _thisFunction.yPosition;
                    case 'ADBE Position_2':
                        return _thisFunction.zPosition;
                    case 'anchorPoint':
                    case 'AnchorPoint':
                    case 'Anchor Point':
                    case 'ADBE AnchorPoint':
                    case 1:
                        return _thisFunction.anchorPoint;
                    case 'opacity':
                    case 'Opacity':
                    case 11:
                        return _thisFunction.opacity;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisFunction, 'rotation', {
                get: ExpressionPropertyInterface(transform.r || transform.rz)
            });
            Object.defineProperty(_thisFunction, 'zRotation', {
                get: ExpressionPropertyInterface(transform.rz || transform.r)
            });
            Object.defineProperty(_thisFunction, 'xRotation', {
                get: ExpressionPropertyInterface(transform.rx)
            });
            Object.defineProperty(_thisFunction, 'yRotation', {
                get: ExpressionPropertyInterface(transform.ry)
            });
            Object.defineProperty(_thisFunction, 'scale', {
                get: ExpressionPropertyInterface(transform.s)
            });
            var _px;
            var _py;
            var _pz;
            var _transformFactory;
            if (transform.p) _transformFactory = ExpressionPropertyInterface(transform.p);
            else {
                _px = ExpressionPropertyInterface(transform.px);
                _py = ExpressionPropertyInterface(transform.py);
                if (transform.pz) _pz = ExpressionPropertyInterface(transform.pz);
            }
            Object.defineProperty(_thisFunction, 'position', {
                get: function get() {
                    if (transform.p) return _transformFactory();
                    return [
                        _px(),
                        _py(),
                        _pz ? _pz() : 0
                    ];
                }
            });
            Object.defineProperty(_thisFunction, 'xPosition', {
                get: ExpressionPropertyInterface(transform.px)
            });
            Object.defineProperty(_thisFunction, 'yPosition', {
                get: ExpressionPropertyInterface(transform.py)
            });
            Object.defineProperty(_thisFunction, 'zPosition', {
                get: ExpressionPropertyInterface(transform.pz)
            });
            Object.defineProperty(_thisFunction, 'anchorPoint', {
                get: ExpressionPropertyInterface(transform.a)
            });
            Object.defineProperty(_thisFunction, 'opacity', {
                get: ExpressionPropertyInterface(transform.o)
            });
            Object.defineProperty(_thisFunction, 'skew', {
                get: ExpressionPropertyInterface(transform.sk)
            });
            Object.defineProperty(_thisFunction, 'skewAxis', {
                get: ExpressionPropertyInterface(transform.sa)
            });
            Object.defineProperty(_thisFunction, 'orientation', {
                get: ExpressionPropertyInterface(transform.or)
            });
            return _thisFunction;
        };
    }();
    var LayerExpressionInterface = function() {
        function getMatrix(time) {
            var toWorldMat = new Matrix();
            if (time !== undefined) {
                var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);
                propMatrix.clone(toWorldMat);
            } else {
                var transformMat = this._elem.finalTransform.mProp;
                transformMat.applyToMatrix(toWorldMat);
            }
            return toWorldMat;
        }
        function toWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.applyPoint(toWorldMat, arr);
        }
        function toWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.applyPoint(toWorldMat, arr);
        }
        function fromWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.invertPoint(toWorldMat, arr);
        }
        function fromWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.invertPoint(toWorldMat, arr);
        }
        function applyPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
        }
        function invertPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.inversePoint(arr);
        }
        function fromComp(arr) {
            var toWorldMat = new Matrix();
            toWorldMat.reset();
            this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
                return toWorldMat.inversePoint(arr);
            }
            return toWorldMat.inversePoint(arr);
        }
        function sampleImage() {
            return [
                1,
                1,
                1,
                1
            ];
        }
        return function(elem) {
            var transformInterface;
            function _registerMaskInterface(maskManager) {
                _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
            }
            function _registerEffectsInterface(effects) {
                _thisLayerFunction.effect = effects;
            }
            function _thisLayerFunction(name) {
                switch(name){
                    case 'ADBE Root Vectors Group':
                    case 'Contents':
                    case 2:
                        return _thisLayerFunction.shapeInterface;
                    case 1:
                    case 6:
                    case 'Transform':
                    case 'transform':
                    case 'ADBE Transform Group':
                        return transformInterface;
                    case 4:
                    case 'ADBE Effect Parade':
                    case 'effects':
                    case 'Effects':
                        return _thisLayerFunction.effect;
                    case 'ADBE Text Properties':
                        return _thisLayerFunction.textInterface;
                    default:
                        return null;
                }
            }
            _thisLayerFunction.getMatrix = getMatrix;
            _thisLayerFunction.invertPoint = invertPoint;
            _thisLayerFunction.applyPoint = applyPoint;
            _thisLayerFunction.toWorld = toWorld;
            _thisLayerFunction.toWorldVec = toWorldVec;
            _thisLayerFunction.fromWorld = fromWorld;
            _thisLayerFunction.fromWorldVec = fromWorldVec;
            _thisLayerFunction.toComp = toWorld;
            _thisLayerFunction.fromComp = fromComp;
            _thisLayerFunction.sampleImage = sampleImage;
            _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
            _thisLayerFunction._elem = elem;
            transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
            var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
            Object.defineProperties(_thisLayerFunction, {
                hasParent: {
                    get: function get() {
                        return elem.hierarchy.length;
                    }
                },
                parent: {
                    get: function get() {
                        return elem.hierarchy[0].layerInterface;
                    }
                },
                rotation: getDescriptor(transformInterface, 'rotation'),
                scale: getDescriptor(transformInterface, 'scale'),
                position: getDescriptor(transformInterface, 'position'),
                opacity: getDescriptor(transformInterface, 'opacity'),
                anchorPoint: anchorPointDescriptor,
                anchor_point: anchorPointDescriptor,
                transform: {
                    get: function get() {
                        return transformInterface;
                    }
                },
                active: {
                    get: function get() {
                        return elem.isInRange;
                    }
                }
            });
            _thisLayerFunction.startTime = elem.data.st;
            _thisLayerFunction.index = elem.data.ind;
            _thisLayerFunction.source = elem.data.refId;
            _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
            _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
            _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
            _thisLayerFunction._name = elem.data.nm;
            _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
            _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
            return _thisLayerFunction;
        };
    }();
    var propertyGroupFactory = function() {
        return function(interfaceFunction, parentPropertyGroup) {
            return function(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return parentPropertyGroup(val - 1);
            };
        };
    }();
    var PropertyInterface = function() {
        return function(propertyName, propertyGroup) {
            var interfaceFunction = {
                _name: propertyName
            };
            function _propertyGroup(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return propertyGroup(val - 1);
            }
            return _propertyGroup;
        };
    }();
    var EffectsExpressionInterface = function() {
        var ob = {
            createEffectsInterface: createEffectsInterface
        };
        function createEffectsInterface(elem, propertyGroup) {
            if (elem.effectsManager) {
                var effectElements = [];
                var effectsData = elem.data.ef;
                var i;
                var len = elem.effectsManager.effectElements.length;
                for(i = 0; i < len; i += 1)effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
                var effects = elem.data.ef || [];
                var groupInterface = function groupInterface(name) {
                    i = 0;
                    len = effects.length;
                    while(i < len){
                        if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) return effectElements[i];
                        i += 1;
                    }
                    return null;
                };
                Object.defineProperty(groupInterface, 'numProperties', {
                    get: function get() {
                        return effects.length;
                    }
                });
                return groupInterface;
            }
            return null;
        }
        function createGroupInterface(data, elements, propertyGroup, elem) {
            function groupInterface(name) {
                var effects = data.ef;
                var i = 0;
                var len = effects.length;
                while(i < len){
                    if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
                        if (effects[i].ty === 5) return effectElements[i];
                        return effectElements[i]();
                    }
                    i += 1;
                }
                throw new Error();
            }
            var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);
            var effectElements = [];
            var i;
            var len = data.ef.length;
            for(i = 0; i < len; i += 1)if (data.ef[i].ty === 5) effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
            else effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
            if (data.mn === 'ADBE Color Control') Object.defineProperty(groupInterface, 'color', {
                get: function get() {
                    return effectElements[0]();
                }
            });
            Object.defineProperties(groupInterface, {
                numProperties: {
                    get: function get() {
                        return data.np;
                    }
                },
                _name: {
                    value: data.nm
                },
                propertyGroup: {
                    value: _propertyGroup
                }
            });
            groupInterface.enabled = data.en !== 0;
            groupInterface.active = groupInterface.enabled;
            return groupInterface;
        }
        function createValueInterface(element, type, elem, propertyGroup) {
            var expressionProperty = ExpressionPropertyInterface(element.p);
            function interfaceFunction() {
                if (type === 10) return elem.comp.compInterface(element.p.v);
                return expressionProperty();
            }
            if (element.p.setGroupProperty) element.p.setGroupProperty(PropertyInterface('', propertyGroup));
            return interfaceFunction;
        }
        return ob;
    }();
    var ShapePathInterface = function() {
        return function pathInterfaceFactory(shape, view, propertyGroup) {
            var prop = view.sh;
            function interfaceFunction(val) {
                if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) return interfaceFunction.path;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                path: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                shape: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                _name: {
                    value: shape.nm
                },
                ix: {
                    value: shape.ix
                },
                propertyIndex: {
                    value: shape.ix
                },
                mn: {
                    value: shape.mn
                },
                propertyGroup: {
                    value: propertyGroup
                }
            });
            return interfaceFunction;
        };
    }();
    var ShapeExpressionInterface = function() {
        function iterateElements(shapes, view, propertyGroup) {
            var arr = [];
            var i;
            var len = shapes ? shapes.length : 0;
            for(i = 0; i < len; i += 1){
                if (shapes[i].ty === 'gr') arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'fl') arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'st') arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'tm') arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'tr') ;
                else if (shapes[i].ty === 'el') arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'sr') arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'sh') arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rc') arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rd') arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rp') arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'gf') arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else arr.push(defaultInterfaceFactory(shapes[i], view[i], propertyGroup));
            }
            return arr;
        }
        function contentsInterfaceFactory(shape, view, propertyGroup) {
            var interfaces;
            var interfaceFunction = function _interfaceFunction(value) {
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) return interfaces[i];
                    i += 1;
                }
                if (typeof value === 'number') return interfaces[value - 1];
                return null;
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
            interfaceFunction.numProperties = interfaces.length;
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.transform = transformInterface;
            interfaceFunction.propertyIndex = shape.cix;
            interfaceFunction._name = shape.nm;
            return interfaceFunction;
        }
        function groupInterfaceFactory(shape, view, propertyGroup) {
            var interfaceFunction = function _interfaceFunction(value) {
                switch(value){
                    case 'ADBE Vectors Group':
                    case 'Contents':
                    case 2:
                        return interfaceFunction.content;
                    // Not necessary for now. Keeping them here in case a new case appears
                    // case 'ADBE Vector Transform Group':
                    // case 3:
                    default:
                        return interfaceFunction.transform;
                }
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.content = content;
            interfaceFunction.transform = transformInterface;
            Object.defineProperty(interfaceFunction, '_name', {
                get: function get() {
                    return shape.nm;
                }
            });
            // interfaceFunction.content = interfaceFunction;
            interfaceFunction.numProperties = shape.np;
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.nm = shape.nm;
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function fillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === 'Color' || val === 'color') return interfaceFunction.color;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
            return interfaceFunction;
        }
        function gradientFillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === 'Start Point' || val === 'start point') return interfaceFunction.startPoint;
                if (val === 'End Point' || val === 'end point') return interfaceFunction.endPoint;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                startPoint: {
                    get: ExpressionPropertyInterface(view.s)
                },
                endPoint: {
                    get: ExpressionPropertyInterface(view.e)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                type: {
                    get: function get() {
                        return 'a';
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.s.setGroupProperty(PropertyInterface('Start Point', propertyGroup));
            view.e.setGroupProperty(PropertyInterface('End Point', propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
            return interfaceFunction;
        }
        function defaultInterfaceFactory() {
            function interfaceFunction() {
                return null;
            }
            return interfaceFunction;
        }
        function strokeInterfaceFactory(shape, view, propertyGroup) {
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);
            function addPropertyToDashOb(i) {
                Object.defineProperty(dashOb, shape.d[i].nm, {
                    get: ExpressionPropertyInterface(view.d.dataProps[i].p)
                });
            }
            var i;
            var len = shape.d ? shape.d.length : 0;
            var dashOb = {};
            for(i = 0; i < len; i += 1){
                addPropertyToDashOb(i);
                view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
            }
            function interfaceFunction(val) {
                if (val === 'Color' || val === 'color') return interfaceFunction.color;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                if (val === 'Stroke Width' || val === 'stroke width') return interfaceFunction.strokeWidth;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                strokeWidth: {
                    get: ExpressionPropertyInterface(view.w)
                },
                dash: {
                    get: function get() {
                        return dashOb;
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
            return interfaceFunction;
        }
        function trimInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === shape.e.ix || val === 'End' || val === 'end') return interfaceFunction.end;
                if (val === shape.s.ix) return interfaceFunction.start;
                if (val === shape.o.ix) return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
            view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.propertyGroup = propertyGroup;
            Object.defineProperties(interfaceFunction, {
                start: {
                    get: ExpressionPropertyInterface(view.s)
                },
                end: {
                    get: ExpressionPropertyInterface(view.e)
                },
                offset: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function transformInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.a.ix === value || value === 'Anchor Point') return interfaceFunction.anchorPoint;
                if (shape.o.ix === value || value === 'Opacity') return interfaceFunction.opacity;
                if (shape.p.ix === value || value === 'Position') return interfaceFunction.position;
                if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') return interfaceFunction.rotation;
                if (shape.s.ix === value || value === 'Scale') return interfaceFunction.scale;
                if (shape.sk && shape.sk.ix === value || value === 'Skew') return interfaceFunction.skew;
                if (shape.sa && shape.sa.ix === value || value === 'Skew Axis') return interfaceFunction.skewAxis;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
            view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
            view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            if (view.transform.mProps.sk) {
                view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
                view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
            }
            view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                opacity: {
                    get: ExpressionPropertyInterface(view.transform.mProps.o)
                },
                position: {
                    get: ExpressionPropertyInterface(view.transform.mProps.p)
                },
                anchorPoint: {
                    get: ExpressionPropertyInterface(view.transform.mProps.a)
                },
                scale: {
                    get: ExpressionPropertyInterface(view.transform.mProps.s)
                },
                rotation: {
                    get: ExpressionPropertyInterface(view.transform.mProps.r)
                },
                skew: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sk)
                },
                skewAxis: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sa)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.ty = 'tr';
            interfaceFunction.mn = shape.mn;
            interfaceFunction.propertyGroup = propertyGroup;
            return interfaceFunction;
        }
        function ellipseInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.s.ix === value) return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function starInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.rotation;
                if (shape.pt.ix === value) return interfaceFunction.points;
                if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') return interfaceFunction.outerRadius;
                if (shape.os.ix === value) return interfaceFunction.outerRoundness;
                if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) return interfaceFunction.innerRadius;
                if (shape.is && shape.is.ix === value) return interfaceFunction.innerRoundness;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
            prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
            prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            if (shape.ir) {
                prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
                prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
            }
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                rotation: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                points: {
                    get: ExpressionPropertyInterface(prop.pt)
                },
                outerRadius: {
                    get: ExpressionPropertyInterface(prop.or)
                },
                outerRoundness: {
                    get: ExpressionPropertyInterface(prop.os)
                },
                innerRadius: {
                    get: ExpressionPropertyInterface(prop.ir)
                },
                innerRoundness: {
                    get: ExpressionPropertyInterface(prop.is)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function rectInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.roundness;
                if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                roundness: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function roundedInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.r.ix === value || value === 'Round Corners 1') return interfaceFunction.radius;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                radius: {
                    get: ExpressionPropertyInterface(prop.rd)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function repeaterInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.c.ix === value || value === 'Copies') return interfaceFunction.copies;
                if (shape.o.ix === value || value === 'Offset') return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
            prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                copies: {
                    get: ExpressionPropertyInterface(prop.c)
                },
                offset: {
                    get: ExpressionPropertyInterface(prop.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        return function(shapes, view, propertyGroup) {
            var interfaces;
            function _interfaceFunction(value) {
                if (typeof value === 'number') {
                    value = value === undefined ? 1 : value;
                    if (value === 0) return propertyGroup;
                    return interfaces[value - 1];
                }
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value) return interfaces[i];
                    i += 1;
                }
                return null;
            }
            function parentGroupWrapper() {
                return propertyGroup;
            }
            _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
            interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
            _interfaceFunction.numProperties = interfaces.length;
            _interfaceFunction._name = 'Contents';
            return _interfaceFunction;
        };
    }();
    var TextExpressionInterface = function() {
        return function(elem) {
            var _sourceText;
            function _thisLayerFunction(name) {
                switch(name){
                    case 'ADBE Text Document':
                        return _thisLayerFunction.sourceText;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisLayerFunction, 'sourceText', {
                get: function get() {
                    elem.textProperty.getValue();
                    var stringValue = elem.textProperty.currentData.t;
                    if (!_sourceText || stringValue !== _sourceText.value) {
                        _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
                        // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
                        _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers
                        Object.defineProperty(_sourceText, 'style', {
                            get: function get() {
                                return {
                                    fillColor: elem.textProperty.currentData.fc
                                };
                            }
                        });
                    }
                    return _sourceText;
                }
            });
            return _thisLayerFunction;
        };
    }();
    function _typeof(o) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof(o);
    }
    var FootageInterface = function() {
        var outlineInterfaceFactory = function outlineInterfaceFactory(elem) {
            var currentPropertyName = '';
            var currentProperty = elem.getFootageData();
            function init() {
                currentPropertyName = '';
                currentProperty = elem.getFootageData();
                return searchProperty;
            }
            function searchProperty(value) {
                if (currentProperty[value]) {
                    currentPropertyName = value;
                    currentProperty = currentProperty[value];
                    if (_typeof(currentProperty) === 'object') return searchProperty;
                    return currentProperty;
                }
                var propertyNameIndex = value.indexOf(currentPropertyName);
                if (propertyNameIndex !== -1) {
                    var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
                    currentProperty = currentProperty[index];
                    if (_typeof(currentProperty) === 'object') return searchProperty;
                    return currentProperty;
                }
                return '';
            }
            return init;
        };
        var dataInterfaceFactory = function dataInterfaceFactory(elem) {
            function interfaceFunction(value) {
                if (value === 'Outline') return interfaceFunction.outlineInterface();
                return null;
            }
            interfaceFunction._name = 'Outline';
            interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
            return interfaceFunction;
        };
        return function(elem) {
            function _interfaceFunction(value) {
                if (value === 'Data') return _interfaceFunction.dataInterface;
                return null;
            }
            _interfaceFunction._name = 'Data';
            _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
            return _interfaceFunction;
        };
    }();
    var interfaces = {
        layer: LayerExpressionInterface,
        effects: EffectsExpressionInterface,
        comp: CompExpressionInterface,
        shape: ShapeExpressionInterface,
        text: TextExpressionInterface,
        footage: FootageInterface
    };
    function getInterface(type) {
        return interfaces[type] || null;
    }
    var expressionHelpers = function() {
        function searchExpressions(elem, data, prop) {
            if (data.x) {
                prop.k = true;
                prop.x = true;
                prop.initiateExpression = ExpressionManager.initiateExpression;
                prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
            }
        }
        function getValueAtTime(frameNum) {
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastFrame) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
                this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
                this._cachingAtTime.lastFrame = frameNum;
            }
            return this._cachingAtTime.value;
        }
        function getSpeedAtTime(frameNum) {
            var delta = -0.01;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var speed = 0;
            if (v1.length) {
                var i;
                for(i = 0; i < v1.length; i += 1)speed += Math.pow(v2[i] - v1[i], 2);
                speed = Math.sqrt(speed) * 100;
            } else speed = 0;
            return speed;
        }
        function getVelocityAtTime(frameNum) {
            if (this.vel !== undefined) return this.vel;
            var delta = -0.001;
            // frameNum += this.elem.data.st;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var velocity;
            if (v1.length) {
                velocity = createTypedArray('float32', v1.length);
                var i;
                for(i = 0; i < v1.length; i += 1)// removing frameRate
                // if needed, don't add it here
                // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
                velocity[i] = (v2[i] - v1[i]) / delta;
            } else velocity = (v2 - v1) / delta;
            return velocity;
        }
        function getStaticValueAtTime() {
            return this.pv;
        }
        function setGroupProperty(propertyGroup) {
            this.propertyGroup = propertyGroup;
        }
        return {
            searchExpressions: searchExpressions,
            getSpeedAtTime: getSpeedAtTime,
            getVelocityAtTime: getVelocityAtTime,
            getValueAtTime: getValueAtTime,
            getStaticValueAtTime: getStaticValueAtTime,
            setGroupProperty: setGroupProperty
        };
    }();
    function addPropertyDecorator() {
        function loopOut(type, duration, durationFlag) {
            if (!this.k || !this.keyframes) return this.pv;
            type = type ? type.toLowerCase() : '';
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var lastKeyFrame = keyframes[keyframes.length - 1].t;
            if (currentFrame <= lastKeyFrame) return this.pv;
            var cycleDuration;
            var firstKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
                else cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
                firstKeyFrame = lastKeyFrame - cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === 'pingpong') {
                var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (iterations % 2 !== 0) return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === 'offset') {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
                var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = (endV[i] - initV[i]) * repeats + current[i];
                    return ret;
                }
                return (endV - initV) * repeats + current;
            } else if (type === 'continue') {
                var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(lastValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
                    return ret;
                }
                return lastValue + (lastValue - nextLastValue) * ((currentFrame - lastKeyFrame) / 0.001);
            }
            return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function loopIn(type, duration, durationFlag) {
            if (!this.k) return this.pv;
            type = type ? type.toLowerCase() : '';
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var firstKeyFrame = keyframes[0].t;
            if (currentFrame >= firstKeyFrame) return this.pv;
            var cycleDuration;
            var lastKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                lastKeyFrame = keyframes[duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
                else cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
                lastKeyFrame = firstKeyFrame + cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === 'pingpong') {
                var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);
                if (iterations % 2 === 0) return this.getValueAtTime(((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === 'offset') {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
                var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
                    return ret;
                }
                return current - (endV - initV) * repeats;
            } else if (type === 'continue') {
                var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(firstValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = firstValue[i] + (firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame) / 0.001;
                    return ret;
                }
                return firstValue + (firstValue - nextFirstValue) * (firstKeyFrame - currentFrame) / 0.001;
            }
            return this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function smooth(width, samples) {
            if (!this.k) return this.pv;
            width = (width || 0.4) * 0.5;
            samples = Math.floor(samples || 5);
            if (samples <= 1) return this.pv;
            var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
            var initFrame = currentTime - width;
            var endFrame = currentTime + width;
            var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
            var i = 0;
            var j = 0;
            var value;
            if (this.pv.length) value = createTypedArray('float32', this.pv.length);
            else value = 0;
            var sampleValue;
            while(i < samples){
                sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);
                if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] += sampleValue[j];
                else value += sampleValue;
                i += 1;
            }
            if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] /= samples;
            else value /= samples;
            return value;
        }
        function getTransformValueAtTime(time) {
            if (!this._transformCachingAtTime) this._transformCachingAtTime = {
                v: new Matrix()
            };
            /// /
            var matrix = this._transformCachingAtTime.v;
            matrix.cloneFromProps(this.pre.props);
            if (this.appliedTransformations < 1) {
                var anchor = this.a.getValueAtTime(time);
                matrix.translate(-anchor[0] * this.a.mult, -anchor[1] * this.a.mult, anchor[2] * this.a.mult);
            }
            if (this.appliedTransformations < 2) {
                var scale = this.s.getValueAtTime(time);
                matrix.scale(scale[0] * this.s.mult, scale[1] * this.s.mult, scale[2] * this.s.mult);
            }
            if (this.sk && this.appliedTransformations < 3) {
                var skew = this.sk.getValueAtTime(time);
                var skewAxis = this.sa.getValueAtTime(time);
                matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
            }
            if (this.r && this.appliedTransformations < 4) {
                var rotation = this.r.getValueAtTime(time);
                matrix.rotate(-rotation * this.r.mult);
            } else if (!this.r && this.appliedTransformations < 4) {
                var rotationZ = this.rz.getValueAtTime(time);
                var rotationY = this.ry.getValueAtTime(time);
                var rotationX = this.rx.getValueAtTime(time);
                var orientation = this.or.getValueAtTime(time);
                matrix.rotateZ(-rotationZ * this.rz.mult).rotateY(rotationY * this.ry.mult).rotateX(rotationX * this.rx.mult).rotateZ(-orientation[2] * this.or.mult).rotateY(orientation[1] * this.or.mult).rotateX(orientation[0] * this.or.mult);
            }
            if (this.data.p && this.data.p.s) {
                var positionX = this.px.getValueAtTime(time);
                var positionY = this.py.getValueAtTime(time);
                if (this.data.p.z) {
                    var positionZ = this.pz.getValueAtTime(time);
                    matrix.translate(positionX * this.px.mult, positionY * this.py.mult, -positionZ * this.pz.mult);
                } else matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
            } else {
                var position = this.p.getValueAtTime(time);
                matrix.translate(position[0] * this.p.mult, position[1] * this.p.mult, -position[2] * this.p.mult);
            }
            return matrix;
        /// /
        }
        function getTransformStaticValueAtTime() {
            return this.v.clone(new Matrix());
        }
        var getTransformProperty = TransformPropertyFactory.getTransformProperty;
        TransformPropertyFactory.getTransformProperty = function(elem, data, container) {
            var prop = getTransformProperty(elem, data, container);
            if (prop.dynamicProperties.length) prop.getValueAtTime = getTransformValueAtTime.bind(prop);
            else prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            return prop;
        };
        var propertyGetProp = PropertyFactory.getProp;
        PropertyFactory.getProp = function(elem, data, type, mult, container) {
            var prop = propertyGetProp(elem, data, type, mult, container);
            // prop.getVelocityAtTime = getVelocityAtTime;
            // prop.loopOut = loopOut;
            // prop.loopIn = loopIn;
            if (prop.kf) prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
            else prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            prop.loopOut = loopOut;
            prop.loopIn = loopIn;
            prop.smooth = smooth;
            prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
            prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
            prop.numKeys = data.a === 1 ? data.k.length : 0;
            prop.propertyIndex = data.ix;
            var value = 0;
            if (type !== 0) value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
            prop._cachingAtTime = {
                lastFrame: initialDefaultFrame,
                lastIndex: 0,
                value: value
            };
            expressionHelpers.searchExpressions(elem, data, prop);
            if (prop.k) container.addDynamicProperty(prop);
            return prop;
        };
        function getShapeValueAtTime(frameNum) {
            // For now this caching object is created only when needed instead of creating it when the shape is initialized.
            if (!this._cachingAtTime) this._cachingAtTime = {
                shapeValue: shapePool.clone(this.pv),
                lastIndex: 0,
                lastTime: initialDefaultFrame
            };
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastTime) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
                this._cachingAtTime.lastTime = frameNum;
                this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
            }
            return this._cachingAtTime.shapeValue;
        }
        var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
        var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
        function ShapeExpressions() {}
        ShapeExpressions.prototype = {
            vertices: function vertices(prop, time) {
                if (this.k) this.getValue();
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                var i;
                var len = shapePath._length;
                var vertices = shapePath[prop];
                var points = shapePath.v;
                var arr = createSizedArray(len);
                for(i = 0; i < len; i += 1)if (prop === 'i' || prop === 'o') arr[i] = [
                    vertices[i][0] - points[i][0],
                    vertices[i][1] - points[i][1]
                ];
                else arr[i] = [
                    vertices[i][0],
                    vertices[i][1]
                ];
                return arr;
            },
            points: function points(time) {
                return this.vertices('v', time);
            },
            inTangents: function inTangents(time) {
                return this.vertices('i', time);
            },
            outTangents: function outTangents(time) {
                return this.vertices('o', time);
            },
            isClosed: function isClosed() {
                return this.v.c;
            },
            pointOnPath: function pointOnPath(perc, time) {
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                if (!this._segmentsLength) this._segmentsLength = bez.getSegmentsLength(shapePath);
                var segmentsLength = this._segmentsLength;
                var lengths = segmentsLength.lengths;
                var lengthPos = segmentsLength.totalLength * perc;
                var i = 0;
                var len = lengths.length;
                var accumulatedLength = 0;
                var pt;
                while(i < len){
                    if (accumulatedLength + lengths[i].addedLength > lengthPos) {
                        var initIndex = i;
                        var endIndex = shapePath.c && i === len - 1 ? 0 : i + 1;
                        var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
                        pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
                        break;
                    } else accumulatedLength += lengths[i].addedLength;
                    i += 1;
                }
                if (!pt) pt = shapePath.c ? [
                    shapePath.v[0][0],
                    shapePath.v[0][1]
                ] : [
                    shapePath.v[shapePath._length - 1][0],
                    shapePath.v[shapePath._length - 1][1]
                ];
                return pt;
            },
            vectorOnPath: function vectorOnPath(perc, time, vectorType) {
                // perc doesn't use triple equality because it can be a Number object as well as a primitive.
                if (perc == 1) // eslint-disable-line eqeqeq
                perc = this.v.c;
                else if (perc == 0) // eslint-disable-line eqeqeq
                perc = 0.999;
                var pt1 = this.pointOnPath(perc, time);
                var pt2 = this.pointOnPath(perc + 0.001, time);
                var xLength = pt2[0] - pt1[0];
                var yLength = pt2[1] - pt1[1];
                var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));
                if (magnitude === 0) return [
                    0,
                    0
                ];
                var unitVector = vectorType === 'tangent' ? [
                    xLength / magnitude,
                    yLength / magnitude
                ] : [
                    -yLength / magnitude,
                    xLength / magnitude
                ];
                return unitVector;
            },
            tangentOnPath: function tangentOnPath(perc, time) {
                return this.vectorOnPath(perc, time, 'tangent');
            },
            normalOnPath: function normalOnPath(perc, time) {
                return this.vectorOnPath(perc, time, 'normal');
            },
            setGroupProperty: expressionHelpers.setGroupProperty,
            getValueAtTime: expressionHelpers.getStaticValueAtTime
        };
        extendPrototype([
            ShapeExpressions
        ], ShapePropertyConstructorFunction);
        extendPrototype([
            ShapeExpressions
        ], KeyframedShapePropertyConstructorFunction);
        KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
        KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
        var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
        ShapePropertyFactory.getShapeProp = function(elem, data, type, arr, trims) {
            var prop = propertyGetShapeProp(elem, data, type, arr, trims);
            prop.propertyIndex = data.ix;
            prop.lock = false;
            if (type === 3) expressionHelpers.searchExpressions(elem, data.pt, prop);
            else if (type === 4) expressionHelpers.searchExpressions(elem, data.ks, prop);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        };
    }
    function initialize$1() {
        addPropertyDecorator();
    }
    function addDecorator() {
        function searchExpressions() {
            if (this.data.d.x) {
                this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
                this.addEffect(this.getExpressionValue.bind(this));
                return true;
            }
            return null;
        }
        TextProperty.prototype.getExpressionValue = function(currentValue, text) {
            var newValue = this.calculateExpression(text);
            if (currentValue.t !== newValue) {
                var newData = {};
                this.copyData(newData, currentValue);
                newData.t = newValue.toString();
                newData.__complete = false;
                return newData;
            }
            return currentValue;
        };
        TextProperty.prototype.searchProperty = function() {
            var isKeyframed = this.searchKeyframes();
            var hasExpressions = this.searchExpressions();
            this.kf = isKeyframed || hasExpressions;
            return this.kf;
        };
        TextProperty.prototype.searchExpressions = searchExpressions;
    }
    function initialize() {
        addDecorator();
    }
    function SVGComposableEffect() {}
    SVGComposableEffect.prototype = {
        createMergeNode: function createMergeNode(resultId, ins) {
            var feMerge = createNS('feMerge');
            feMerge.setAttribute('result', resultId);
            var feMergeNode;
            var i;
            for(i = 0; i < ins.length; i += 1){
                feMergeNode = createNS('feMergeNode');
                feMergeNode.setAttribute('in', ins[i]);
                feMerge.appendChild(feMergeNode);
                feMerge.appendChild(feMergeNode);
            }
            return feMerge;
        }
    };
    var linearFilterValue = '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0';
    function SVGTintFilter(filter, filterManager, elem, id, source) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
        feColorMatrix.setAttribute('values', linearFilterValue + ' 1 0');
        this.linearFilter = feColorMatrix;
        feColorMatrix.setAttribute('result', id + '_tint_1');
        filter.appendChild(feColorMatrix);
        feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
        feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
        feColorMatrix.setAttribute('result', id + '_tint_2');
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
        var feMerge = this.createMergeNode(id, [
            source,
            id + '_tint_1',
            id + '_tint_2'
        ]);
        filter.appendChild(feMerge);
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGTintFilter);
    SVGTintFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var colorBlack = this.filterManager.effectElements[0].p.v;
            var colorWhite = this.filterManager.effectElements[1].p.v;
            var opacity = this.filterManager.effectElements[2].p.v / 100;
            this.linearFilter.setAttribute('values', linearFilterValue + ' ' + opacity + ' 0');
            this.matrixFilter.setAttribute('values', colorWhite[0] - colorBlack[0] + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 1 0');
        }
    };
    function SVGFillFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
        feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
        feColorMatrix.setAttribute('result', id);
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
    }
    SVGFillFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color = this.filterManager.effectElements[2].p.v;
            var opacity = this.filterManager.effectElements[6].p.v;
            this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
        }
    };
    function SVGStrokeEffect(fil, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.elem = elem;
        this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
        var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
        var path;
        var groupPath;
        var i;
        var len;
        if (this.filterManager.effectElements[1].p.v === 1) {
            len = this.elem.maskManager.masksProperties.length;
            i = 0;
        } else {
            i = this.filterManager.effectElements[0].p.v - 1;
            len = i + 1;
        }
        groupPath = createNS('g');
        groupPath.setAttribute('fill', 'none');
        groupPath.setAttribute('stroke-linecap', 'round');
        groupPath.setAttribute('stroke-dashoffset', 1);
        for(i; i < len; i += 1){
            path = createNS('path');
            groupPath.appendChild(path);
            this.paths.push({
                p: path,
                m: i
            });
        }
        if (this.filterManager.effectElements[10].p.v === 3) {
            var mask = createNS('mask');
            var id = createElementID();
            mask.setAttribute('id', id);
            mask.setAttribute('mask-type', 'alpha');
            mask.appendChild(groupPath);
            this.elem.globalData.defs.appendChild(mask);
            var g = createNS('g');
            g.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
            while(elemChildren[0])g.appendChild(elemChildren[0]);
            this.elem.layerElement.appendChild(g);
            this.masker = mask;
            groupPath.setAttribute('stroke', '#fff');
        } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (this.filterManager.effectElements[10].p.v === 2) {
                elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
                while(elemChildren.length)this.elem.layerElement.removeChild(elemChildren[0]);
            }
            this.elem.layerElement.appendChild(groupPath);
            this.elem.layerElement.removeAttribute('mask');
            groupPath.setAttribute('stroke', '#fff');
        }
        this.initialized = true;
        this.pathMasker = groupPath;
    };
    SVGStrokeEffect.prototype.renderFrame = function(forceRender) {
        if (!this.initialized) this.initialize();
        var i;
        var len = this.paths.length;
        var mask;
        var path;
        for(i = 0; i < len; i += 1)if (this.paths[i].m !== -1) {
            mask = this.elem.maskManager.viewData[this.paths[i].m];
            path = this.paths[i].p;
            if (forceRender || this.filterManager._mdf || mask.prop._mdf) path.setAttribute('d', mask.lastPath);
            if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
                var dasharrayValue;
                if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
                    var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var l = path.getTotalLength();
                    dasharrayValue = '0 0 0 ' + l * s + ' ';
                    var lineLength = l * (e - s);
                    var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                    var units = Math.floor(lineLength / segment);
                    var j;
                    for(j = 0; j < units; j += 1)dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
                    dasharrayValue += '0 ' + l * 10 + ' 0 0';
                } else dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                path.setAttribute('stroke-dasharray', dasharrayValue);
            }
        }
        if (forceRender || this.filterManager.effectElements[4].p._mdf) this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
        if (forceRender || this.filterManager.effectElements[6].p._mdf) this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
        if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (forceRender || this.filterManager.effectElements[3].p._mdf) {
                var color = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
            }
        }
    };
    function SVGTritoneFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
        feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
        filter.appendChild(feColorMatrix);
        var feComponentTransfer = createNS('feComponentTransfer');
        feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
        feComponentTransfer.setAttribute('result', id);
        this.matrixFilter = feComponentTransfer;
        var feFuncR = createNS('feFuncR');
        feFuncR.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncR);
        this.feFuncR = feFuncR;
        var feFuncG = createNS('feFuncG');
        feFuncG.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncG);
        this.feFuncG = feFuncG;
        var feFuncB = createNS('feFuncB');
        feFuncB.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncB);
        this.feFuncB = feFuncB;
        filter.appendChild(feComponentTransfer);
    }
    SVGTritoneFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color1 = this.filterManager.effectElements[0].p.v;
            var color2 = this.filterManager.effectElements[1].p.v;
            var color3 = this.filterManager.effectElements[2].p.v;
            var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
            var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
            var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
            this.feFuncR.setAttribute('tableValues', tableR);
            this.feFuncG.setAttribute('tableValues', tableG);
            this.feFuncB.setAttribute('tableValues', tableB);
        }
    };
    function SVGProLevelsFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var effectElements = this.filterManager.effectElements;
        var feComponentTransfer = createNS('feComponentTransfer');
        // Red
        if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
        // Green
        if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
        // Blue
        if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
        // Alpha
        if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
        // RGB
        if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
            feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
            filter.appendChild(feComponentTransfer);
        }
        if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
            feComponentTransfer = createNS('feComponentTransfer');
            feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
            feComponentTransfer.setAttribute('result', id);
            filter.appendChild(feComponentTransfer);
            this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
            this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
            this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
        }
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
        var feFunc = createNS(type);
        feFunc.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFunc);
        return feFunc;
    };
    SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
        var cnt = 0;
        var segments = 256;
        var perc;
        var min = Math.min(inputBlack, inputWhite);
        var max = Math.max(inputBlack, inputWhite);
        var table = Array.call(null, {
            length: segments
        });
        var colorValue;
        var pos = 0;
        var outputDelta = outputWhite - outputBlack;
        var inputDelta = inputWhite - inputBlack;
        while(cnt <= 256){
            perc = cnt / 256;
            if (perc <= min) colorValue = inputDelta < 0 ? outputWhite : outputBlack;
            else if (perc >= max) colorValue = inputDelta < 0 ? outputBlack : outputWhite;
            else colorValue = outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma);
            table[pos] = colorValue;
            pos += 1;
            cnt += 256 / (segments - 1);
        }
        return table.join(' ');
    };
    SVGProLevelsFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var val;
            var effectElements = this.filterManager.effectElements;
            if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
                val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
                this.feFuncRComposed.setAttribute('tableValues', val);
                this.feFuncGComposed.setAttribute('tableValues', val);
                this.feFuncBComposed.setAttribute('tableValues', val);
            }
            if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
                val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
                this.feFuncR.setAttribute('tableValues', val);
            }
            if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
                val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
                this.feFuncG.setAttribute('tableValues', val);
            }
            if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
                val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
                this.feFuncB.setAttribute('tableValues', val);
            }
            if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
                val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
                this.feFuncA.setAttribute('tableValues', val);
            }
        }
    };
    function SVGDropShadowEffect(filter, filterManager, elem, id, source) {
        var globalFilterSize = filterManager.container.globalData.renderConfig.filterSize;
        var filterSize = filterManager.data.fs || globalFilterSize;
        filter.setAttribute('x', filterSize.x || globalFilterSize.x);
        filter.setAttribute('y', filterSize.y || globalFilterSize.y);
        filter.setAttribute('width', filterSize.width || globalFilterSize.width);
        filter.setAttribute('height', filterSize.height || globalFilterSize.height);
        this.filterManager = filterManager;
        var feGaussianBlur = createNS('feGaussianBlur');
        feGaussianBlur.setAttribute('in', 'SourceAlpha');
        feGaussianBlur.setAttribute('result', id + '_drop_shadow_1');
        feGaussianBlur.setAttribute('stdDeviation', '0');
        this.feGaussianBlur = feGaussianBlur;
        filter.appendChild(feGaussianBlur);
        var feOffset = createNS('feOffset');
        feOffset.setAttribute('dx', '25');
        feOffset.setAttribute('dy', '0');
        feOffset.setAttribute('in', id + '_drop_shadow_1');
        feOffset.setAttribute('result', id + '_drop_shadow_2');
        this.feOffset = feOffset;
        filter.appendChild(feOffset);
        var feFlood = createNS('feFlood');
        feFlood.setAttribute('flood-color', '#00ff00');
        feFlood.setAttribute('flood-opacity', '1');
        feFlood.setAttribute('result', id + '_drop_shadow_3');
        this.feFlood = feFlood;
        filter.appendChild(feFlood);
        var feComposite = createNS('feComposite');
        feComposite.setAttribute('in', id + '_drop_shadow_3');
        feComposite.setAttribute('in2', id + '_drop_shadow_2');
        feComposite.setAttribute('operator', 'in');
        feComposite.setAttribute('result', id + '_drop_shadow_4');
        filter.appendChild(feComposite);
        var feMerge = this.createMergeNode(id, [
            id + '_drop_shadow_4',
            source
        ]);
        filter.appendChild(feMerge);
    //
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGDropShadowEffect);
    SVGDropShadowEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            if (forceRender || this.filterManager.effectElements[4].p._mdf) this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
            if (forceRender || this.filterManager.effectElements[0].p._mdf) {
                var col = this.filterManager.effectElements[0].p.v;
                this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
            }
            if (forceRender || this.filterManager.effectElements[1].p._mdf) this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
            if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                var distance = this.filterManager.effectElements[3].p.v;
                var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
                var x = distance * Math.cos(angle);
                var y = distance * Math.sin(angle);
                this.feOffset.setAttribute('dx', x);
                this.feOffset.setAttribute('dy', y);
            }
        }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(filterElem, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.filterElem = filterElem;
        this.elem = elem;
        elem.matteElement = createNS('g');
        elem.matteElement.appendChild(elem.layerElement);
        elem.matteElement.appendChild(elem.transformedElement);
        elem.baseElement = elem.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(mask) {
        var i = 0;
        var len = _svgMatteSymbols.length;
        while(i < len){
            if (_svgMatteSymbols[i] === mask) return _svgMatteSymbols[i];
            i += 1;
        }
        return null;
    };
    SVGMatte3Effect.prototype.replaceInParent = function(mask, symbolId) {
        var parentNode = mask.layerElement.parentNode;
        if (!parentNode) return;
        var children = parentNode.children;
        var i = 0;
        var len = children.length;
        while(i < len){
            if (children[i] === mask.layerElement) break;
            i += 1;
        }
        var nextChild;
        if (i <= len - 2) nextChild = children[i + 1];
        var useElem = createNS('use');
        useElem.setAttribute('href', '#' + symbolId);
        if (nextChild) parentNode.insertBefore(useElem, nextChild);
        else parentNode.appendChild(useElem);
    };
    SVGMatte3Effect.prototype.setElementAsMask = function(elem, mask) {
        if (!this.findSymbol(mask)) {
            var symbolId = createElementID();
            var masker = createNS('mask');
            masker.setAttribute('id', mask.layerId);
            masker.setAttribute('mask-type', 'alpha');
            _svgMatteSymbols.push(mask);
            var defs = elem.globalData.defs;
            defs.appendChild(masker);
            var symbol = createNS('symbol');
            symbol.setAttribute('id', symbolId);
            this.replaceInParent(mask, symbolId);
            symbol.appendChild(mask.layerElement);
            defs.appendChild(symbol);
            var useElem = createNS('use');
            useElem.setAttribute('href', '#' + symbolId);
            masker.appendChild(useElem);
            mask.data.hd = false;
            mask.show();
        }
        elem.setMatte(mask.layerId);
    };
    SVGMatte3Effect.prototype.initialize = function() {
        var ind = this.filterManager.effectElements[0].p.v;
        var elements = this.elem.comp.elements;
        var i = 0;
        var len = elements.length;
        while(i < len){
            if (elements[i] && elements[i].data.ind === ind) this.setElementAsMask(this.elem, elements[i]);
            i += 1;
        }
        this.initialized = true;
    };
    SVGMatte3Effect.prototype.renderFrame = function() {
        if (!this.initialized) this.initialize();
    };
    function SVGGaussianBlurEffect(filter, filterManager, elem, id) {
        // Outset the filter region by 100% on all sides to accommodate blur expansion.
        filter.setAttribute('x', '-100%');
        filter.setAttribute('y', '-100%');
        filter.setAttribute('width', '300%');
        filter.setAttribute('height', '300%');
        this.filterManager = filterManager;
        var feGaussianBlur = createNS('feGaussianBlur');
        feGaussianBlur.setAttribute('result', id);
        filter.appendChild(feGaussianBlur);
        this.feGaussianBlur = feGaussianBlur;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            // Empirical value, matching AE's blur appearance.
            var kBlurrinessToSigma = 0.3;
            var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma;
            // Dimensions mapping:
            //
            //   1 -> horizontal & vertical
            //   2 -> horizontal only
            //   3 -> vertical only
            //
            var dimensions = this.filterManager.effectElements[1].p.v;
            var sigmaX = dimensions == 3 ? 0 : sigma; // eslint-disable-line eqeqeq
            var sigmaY = dimensions == 2 ? 0 : sigma; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY);
            // Repeat edges mapping:
            //
            //   0 -> off -> duplicate
            //   1 -> on  -> wrap
            var edgeMode = this.filterManager.effectElements[2].p.v == 1 ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
        }
    };
    function TransformEffect() {}
    TransformEffect.prototype.init = function(effectsManager) {
        this.effectsManager = effectsManager;
        this.type = effectTypes.TRANSFORM_EFFECT;
        this.matrix = new Matrix();
        this.opacity = -1;
        this._mdf = false;
        this._opMdf = false;
    };
    TransformEffect.prototype.renderFrame = function(forceFrame) {
        this._opMdf = false;
        this._mdf = false;
        if (forceFrame || this.effectsManager._mdf) {
            var effectElements = this.effectsManager.effectElements;
            var anchor = effectElements[0].p.v;
            var position = effectElements[1].p.v;
            var isUniformScale = effectElements[2].p.v === 1;
            var scaleHeight = effectElements[3].p.v;
            var scaleWidth = isUniformScale ? scaleHeight : effectElements[4].p.v;
            var skew = effectElements[5].p.v;
            var skewAxis = effectElements[6].p.v;
            var rotation = effectElements[7].p.v;
            this.matrix.reset();
            this.matrix.translate(-anchor[0], -anchor[1], anchor[2]);
            this.matrix.scale(scaleWidth * 0.01, scaleHeight * 0.01, 1);
            this.matrix.rotate(-rotation * degToRads);
            this.matrix.skewFromAxis(-skew * degToRads, (skewAxis + 90) * degToRads);
            this.matrix.translate(position[0], position[1], 0);
            this._mdf = true;
            if (this.opacity !== effectElements[8].p.v) {
                this.opacity = effectElements[8].p.v;
                this._opMdf = true;
            }
        }
    };
    function SVGTransformEffect(_, filterManager) {
        this.init(filterManager);
    }
    extendPrototype([
        TransformEffect
    ], SVGTransformEffect);
    function CVTransformEffect(effectsManager) {
        this.init(effectsManager);
    }
    extendPrototype([
        TransformEffect
    ], CVTransformEffect);
    // Registering renderers
    registerRenderer('canvas', CanvasRenderer);
    registerRenderer('html', HybridRenderer);
    registerRenderer('svg', SVGRenderer);
    // Registering shape modifiers
    ShapeModifiers.registerModifier('tm', TrimModifier);
    ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);
    ShapeModifiers.registerModifier('rp', RepeaterModifier);
    ShapeModifiers.registerModifier('rd', RoundCornersModifier);
    ShapeModifiers.registerModifier('zz', ZigZagModifier);
    ShapeModifiers.registerModifier('op', OffsetPathModifier);
    // Registering expression plugin
    setExpressionsPlugin(Expressions);
    setExpressionInterfaces(getInterface);
    initialize$1();
    initialize();
    // Registering svg effects
    registerEffect$1(20, SVGTintFilter, true);
    registerEffect$1(21, SVGFillFilter, true);
    registerEffect$1(22, SVGStrokeEffect, false);
    registerEffect$1(23, SVGTritoneFilter, true);
    registerEffect$1(24, SVGProLevelsFilter, true);
    registerEffect$1(25, SVGDropShadowEffect, true);
    registerEffect$1(28, SVGMatte3Effect, false);
    registerEffect$1(29, SVGGaussianBlurEffect, true);
    registerEffect$1(35, SVGTransformEffect, false);
    registerEffect(35, CVTransformEffect);
    return lottie;
});

});

parcelRegister("dNre6", function(module, exports) {
!function(r) {
    "use strict";
    function n(r, n, e) {
        return e.a = r, e.f = n, e;
    }
    function F2(r) {
        return n(2, r, function(n) {
            return function(e) {
                return r(n, e);
            };
        });
    }
    function F3(r) {
        return n(3, r, function(n) {
            return function(e) {
                return function(t) {
                    return r(n, e, t);
                };
            };
        });
    }
    function F4(r) {
        return n(4, r, function(n) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return r(n, e, t, a);
                    };
                };
            };
        });
    }
    function F5(r) {
        return n(5, r, function(n) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(u) {
                            return r(n, e, t, a, u);
                        };
                    };
                };
            };
        });
    }
    function F6(r) {
        return n(6, r, function(n) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(u) {
                            return function(c) {
                                return r(n, e, t, a, u, c);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(r) {
        return n(7, r, function(n) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(u) {
                            return function(c) {
                                return function(o) {
                                    return r(n, e, t, a, u, c, o);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(r) {
        return n(8, r, function(n) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(u) {
                            return function(c) {
                                return function(o) {
                                    return function(i) {
                                        return r(n, e, t, a, u, c, o, i);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F9(r) {
        return n(9, r, function(n) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(u) {
                            return function(c) {
                                return function(o) {
                                    return function(i) {
                                        return function(f) {
                                            return r(n, e, t, a, u, c, o, i, f);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(r, n, e) {
        return 2 === r.a ? r.f(n, e) : r(n)(e);
    }
    function A3(r, n, e, t) {
        return 3 === r.a ? r.f(n, e, t) : r(n)(e)(t);
    }
    function A4(r, n, e, t, a) {
        return 4 === r.a ? r.f(n, e, t, a) : r(n)(e)(t)(a);
    }
    function A5(r, n, e, t, a, u) {
        return 5 === r.a ? r.f(n, e, t, a, u) : r(n)(e)(t)(a)(u);
    }
    function A6(r, n, e, t, a, u, c) {
        return 6 === r.a ? r.f(n, e, t, a, u, c) : r(n)(e)(t)(a)(u)(c);
    }
    function A7(r, n, e, t, a, u, c, o) {
        return 7 === r.a ? r.f(n, e, t, a, u, c, o) : r(n)(e)(t)(a)(u)(c)(o);
    }
    function A8(r, n, e, t, a, u, c, o, i) {
        return 8 === r.a ? r.f(n, e, t, a, u, c, o, i) : r(n)(e)(t)(a)(u)(c)(o)(i);
    }
    function A9(r, n, e, t, a, u, c, o, i, f) {
        return 9 === r.a ? r.f(n, e, t, a, u, c, o, i, f) : r(n)(e)(t)(a)(u)(c)(o)(i)(f);
    }
    function e(r, n) {
        for(var e, a = [], u = t(r, n, 0, a); u && (e = a.pop()); u = t(e.a, e.b, 0, a));
        return u;
    }
    function t(r, n, e, a) {
        if (r === n) return !0;
        if ("object" != typeof r || null === r || null === n) return "function" == typeof r && j(5), !1;
        if (e > 100) return a.push(i(r, n)), !0;
        for(var u in 0 > r.$ && (r = Le(r), n = Le(n)), r)if (!t(r[u], n[u], e + 1, a)) return !1;
        return !0;
    }
    var a = F2(e), u = F2(function(r, n) {
        return !e(r, n);
    });
    function c(r, n, e) {
        if ("object" != typeof r) return r === n ? 0 : n > r ? -1 : 1;
        if (void 0 === r.$) return (e = c(r.a, n.a)) || (e = c(r.b, n.b)) ? e : c(r.c, n.c);
        for(; r.b && n.b && !(e = c(r.a, n.a)); r = r.b, n = n.b);
        return e || (r.b ? 1 : n.b ? -1 : 0);
    }
    var o = F2(function(r, n) {
        var e = c(r, n);
        return 0 > e ? ke : e ? Ce : we;
    });
    function i(r, n) {
        return {
            a: r,
            b: n
        };
    }
    function f(r, n, e) {
        return {
            a: r,
            b: n,
            c: e
        };
    }
    function s(r, n) {
        var e = {};
        for(var t in r)e[t] = r[t];
        for(var t in n)e[t] = n[t];
        return e;
    }
    function l(r, n) {
        if ("string" == typeof r) return r + n;
        if (!r.b) return n;
        var e = d(r.a, n);
        r = r.b;
        for(var t = e; r.b; r = r.b)t = t.b = d(r.a, n);
        return e;
    }
    var b = {
        $: 0
    };
    function d(r, n) {
        return {
            $: 1,
            a: r,
            b: n
        };
    }
    var v = F2(d);
    function m(r) {
        for(var n = b, e = r.length; e--;)n = d(r[e], n);
        return n;
    }
    function g(r) {
        for(var n = []; r.b; r = r.b)n.push(r.a);
        return n;
    }
    var p = F3(function(r, n, e) {
        for(var t = []; n.b && e.b; n = n.b, e = e.b)t.push(A2(r, n.a, e.a));
        return m(t);
    }), $ = F2(function(r, n) {
        return m(g(n).sort(function(n, e) {
            return c(r(n), r(e));
        }));
    }), h = F2(function(r, n) {
        return m(g(n).sort(function(n, e) {
            var t = A2(r, n, e);
            return t === we ? 0 : t === ke ? -1 : 1;
        }));
    }), w = F3(function(r, n, e) {
        for(var t = Array(r), a = 0; r > a; a++)t[a] = e(n + a);
        return t;
    }), C = F2(function(r, n) {
        for(var e = Array(r), t = 0; r > t && n.b; t++)e[t] = n.a, n = n.b;
        return e.length = t, i(e, n);
    }), k = F2(function(r, n) {
        return n[r];
    }), y = F3(function(r, n, e) {
        for(var t = e.length, a = Array(t), u = 0; t > u; u++)a[u] = e[u];
        return a[r] = n, a;
    }), x = F3(function(r, n, e) {
        for(var t = e.length - 1; t >= 0; t--)n = A2(r, e[t], n);
        return n;
    }), L = F2(function(r, n) {
        for(var e = n.length, t = Array(e), a = 0; e > a; a++)t[a] = r(n[a]);
        return t;
    });
    function j(r) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + r + ".md");
    }
    var A = F2(function(r, n) {
        return r + n;
    }), M = F2(Math.pow), F = F2(function(r, n) {
        var e = n % r;
        return 0 === r ? j(11) : e > 0 && 0 > r || 0 > e && r > 0 ? e + r : e;
    }), H = Math.PI, T = Math.cos, S = Math.sin, E = Math.ceil, z = Math.floor, R = Math.round, V = Math.log, W = F2(function(r, n) {
        return r + n;
    }), P = F2(function(r, n) {
        for(var e = n.length, t = Array(e), a = 0; e > a;){
            var u = n.charCodeAt(a);
            55296 > u || u > 56319 ? (t[a] = r(n[a]), a++) : (t[a] = r(n[a] + n[a + 1]), a += 2);
        }
        return t.join("");
    }), G = F3(function(r, n, e) {
        for(var t = e.length; t--;){
            var a = e[t], u = e.charCodeAt(t);
            56320 > u || u > 57343 || (a = e[--t] + a), n = A2(r, a, n);
        }
        return n;
    }), I = F2(function(r, n) {
        return n.split(r);
    }), N = F2(function(r, n) {
        return n.join(r);
    }), Z = F3(function(r, n, e) {
        return e.slice(r, n);
    }), D = F2(function(r, n) {
        for(var e = n.length; e--;){
            var t = n[e], a = n.charCodeAt(e);
            if (56320 > a || a > 57343 || (t = n[--e] + t), !r(t)) return !1;
        }
        return !0;
    }), _ = F2(function(r, n) {
        return n.indexOf(r) > -1;
    }), O = F2(function(r, n) {
        return 0 === n.indexOf(r);
    }), q = F2(function(r, n) {
        var e = r.length;
        if (1 > e) return b;
        for(var t = 0, a = []; (t = n.indexOf(r, t)) > -1;)a.push(t), t += e;
        return m(a);
    });
    function K(r) {
        return r + "";
    }
    function U(r) {
        return {
            $: 2,
            b: r
        };
    }
    var B = U(function(r) {
        return "number" != typeof r ? $r("an INT", r) : r > -2147483647 && 2147483647 > r && (0 | r) === r ? Ee(r) : !isFinite(r) || r % 1 ? $r("an INT", r) : Ee(r);
    }), Q = U(function(r) {
        return "boolean" == typeof r ? Ee(r) : $r("a BOOL", r);
    }), Y = U(function(r) {
        return "number" == typeof r ? Ee(r) : $r("a FLOAT", r);
    }), J = U(function(r) {
        return Ee(r);
    }), X = U(function(r) {
        return "string" == typeof r ? Ee(r) : r instanceof String ? Ee(r + "") : $r("a STRING", r);
    }), rr = F2(function(r, n) {
        return {
            $: 6,
            d: r,
            b: n
        };
    }), nr = F2(function(r, n) {
        return {
            $: 7,
            e: r,
            b: n
        };
    });
    function er(r, n) {
        return {
            $: 9,
            f: r,
            g: n
        };
    }
    var tr = F2(function(r, n) {
        return {
            $: 10,
            b: n,
            h: r
        };
    }), ar = F2(function(r, n) {
        return er(r, [
            n
        ]);
    }), ur = F3(function(r, n, e) {
        return er(r, [
            n,
            e
        ]);
    }), cr = F4(function(r, n, e, t) {
        return er(r, [
            n,
            e,
            t
        ]);
    }), or = F5(function(r, n, e, t, a) {
        return er(r, [
            n,
            e,
            t,
            a
        ]);
    }), ir = F6(function(r, n, e, t, a, u) {
        return er(r, [
            n,
            e,
            t,
            a,
            u
        ]);
    }), fr = F7(function(r, n, e, t, a, u, c) {
        return er(r, [
            n,
            e,
            t,
            a,
            u,
            c
        ]);
    }), sr = F8(function(r, n, e, t, a, u, c, o) {
        return er(r, [
            n,
            e,
            t,
            a,
            u,
            c,
            o
        ]);
    }), lr = F9(function(r, n, e, t, a, u, c, o, i) {
        return er(r, [
            n,
            e,
            t,
            a,
            u,
            c,
            o,
            i
        ]);
    }), br = F2(function(r, n) {
        try {
            return vr(r, JSON.parse(n));
        } catch (r) {
            return Fe(A2(He, "This is not valid JSON! " + r.message, n));
        }
    }), dr = F2(function(r, n) {
        return vr(r, n);
    });
    function vr(r, n) {
        switch(r.$){
            case 2:
                return r.b(n);
            case 5:
                return null === n ? Ee(r.c) : $r("null", n);
            case 3:
                return gr(n) ? mr(r.b, n, m) : $r("a LIST", n);
            case 4:
                return gr(n) ? mr(r.b, n, pr) : $r("an ARRAY", n);
            case 6:
                var e = r.d;
                if ("object" != typeof n || null === n || !(e in n)) return $r("an OBJECT with a field named `" + e + "`", n);
                var t = vr(r.b, n[e]);
                return Tt(t) ? t : Fe(A2(Te, e, t.a));
            case 7:
                var a = r.e;
                return gr(n) ? n.length > a ? (t = vr(r.b, n[a]), Tt(t) ? t : Fe(A2(Se, a, t.a))) : $r("a LONGER array. Need index " + a + " but only see " + n.length + " entries", n) : $r("an ARRAY", n);
            case 8:
                if ("object" != typeof n || null === n || gr(n)) return $r("an OBJECT", n);
                var u = b;
                for(var c in n)if (Object.prototype.hasOwnProperty.call(n, c)) {
                    if (t = vr(r.b, n[c]), !Tt(t)) return Fe(A2(Te, c, t.a));
                    u = d(i(c, t.a), u);
                }
                return Ee(et(u));
            case 9:
                for(var o = r.f, f = r.g, s = 0; f.length > s; s++){
                    if (t = vr(f[s], n), !Tt(t)) return t;
                    o = o(t.a);
                }
                return Ee(o);
            case 10:
                return t = vr(r.b, n), Tt(t) ? vr(r.h(t.a), n) : t;
            case 11:
                for(var l = b, v = r.g; v.b; v = v.b){
                    if (t = vr(v.a, n), Tt(t)) return t;
                    l = d(t.a, l);
                }
                return Fe(ze(et(l)));
            case 1:
                return Fe(A2(He, r.a, n));
            case 0:
                return Ee(r.a);
        }
    }
    function mr(r, n, e) {
        for(var t = n.length, a = Array(t), u = 0; t > u; u++){
            var c = vr(r, n[u]);
            if (!Tt(c)) return Fe(A2(Se, u, c.a));
            a[u] = c.a;
        }
        return Ee(e(a));
    }
    function gr(r) {
        return Array.isArray(r) || "undefined" != typeof FileList && r instanceof FileList;
    }
    function pr(r) {
        return A2(Ht, r.length, function(n) {
            return r[n];
        });
    }
    function $r(r, n) {
        return Fe(A2(He, "Expecting " + r, n));
    }
    function hr(r, n) {
        if (r === n) return !0;
        if (r.$ !== n.$) return !1;
        switch(r.$){
            case 0:
            case 1:
                return r.a === n.a;
            case 2:
                return r.b === n.b;
            case 5:
                return r.c === n.c;
            case 3:
            case 4:
            case 8:
                return hr(r.b, n.b);
            case 6:
                return r.d === n.d && hr(r.b, n.b);
            case 7:
                return r.e === n.e && hr(r.b, n.b);
            case 9:
                return r.f === n.f && wr(r.g, n.g);
            case 10:
                return r.h === n.h && hr(r.b, n.b);
            case 11:
                return wr(r.g, n.g);
        }
    }
    function wr(r, n) {
        var e = r.length;
        if (e !== n.length) return !1;
        for(var t = 0; e > t; t++)if (!hr(r[t], n[t])) return !1;
        return !0;
    }
    var Cr = F2(function(r, n) {
        return JSON.stringify(n, null, r) + "";
    });
    function kr(r) {
        return r;
    }
    var yr = F3(function(r, n, e) {
        return "toJSON" === r && "function" == typeof n || (e[r] = n), e;
    });
    function xr(r) {
        return {
            $: 0,
            a: r
        };
    }
    function Lr(r) {
        return {
            $: 1,
            a: r
        };
    }
    function jr(r) {
        return {
            $: 2,
            b: r,
            c: null
        };
    }
    var Ar = F2(function(r, n) {
        return {
            $: 3,
            b: r,
            d: n
        };
    }), Mr = F2(function(r, n) {
        return {
            $: 4,
            b: r,
            d: n
        };
    }), Fr = 0;
    function Hr(r) {
        var n = {
            $: 0,
            e: Fr++,
            f: r,
            g: null,
            h: []
        };
        return Vr(n), n;
    }
    function Tr(r) {
        return jr(function(n) {
            n(xr(Hr(r)));
        });
    }
    function Sr(r, n) {
        r.h.push(n), Vr(r);
    }
    var Er = F2(function(r, n) {
        return jr(function(e) {
            Sr(r, n), e(xr(0));
        });
    }), zr = !1, Rr = [];
    function Vr(r) {
        if (Rr.push(r), !zr) {
            for(zr = !0; r = Rr.shift();)Wr(r);
            zr = !1;
        }
    }
    function Wr(r) {
        for(; r.f;){
            var n = r.f.$;
            if (0 === n || 1 === n) {
                for(; r.g && r.g.$ !== n;)r.g = r.g.i;
                if (!r.g) return;
                r.f = r.g.b(r.f.a), r.g = r.g.i;
            } else {
                if (2 === n) return void (r.f.c = r.f.b(function(n) {
                    r.f = n, Vr(r);
                }));
                if (5 === n) {
                    if (0 === r.h.length) return;
                    r.f = r.f.b(r.h.shift());
                } else r.g = {
                    $: 3 === n ? 0 : 1,
                    b: r.f.b,
                    i: r.g
                }, r.f = r.f.d;
            }
        }
    }
    function Pr(r) {
        return jr(function(n) {
            var e = setTimeout(function() {
                n(xr(0));
            }, r);
            return function() {
                clearTimeout(e);
            };
        });
    }
    var Gr = {};
    function Ir(r, n, e, t, a) {
        return {
            b: r,
            c: n,
            d: e,
            e: t,
            f: a
        };
    }
    function Nr(r, n) {
        var e = {
            g: n,
            h: void 0
        }, t = r.c, a = r.d, u = r.e, c = r.f;
        function o(r) {
            return A2(Ar, o, {
                $: 5,
                b: function(n) {
                    var o = n.a;
                    return 0 === n.$ ? A3(a, e, o, r) : u && c ? A4(t, e, o.i, o.j, r) : A3(t, e, u ? o.i : o.j, r);
                }
            });
        }
        return e.h = Hr(A2(Ar, o, r.b));
    }
    var Zr = F2(function(r, n) {
        return jr(function(e) {
            r.g(n), e(xr(0));
        });
    }), Dr = F2(function(r, n) {
        return A2(Er, r.h, {
            $: 0,
            a: n
        });
    });
    function _r(r) {
        return function(n) {
            return {
                $: 1,
                k: r,
                l: n
            };
        };
    }
    function Or(r) {
        return {
            $: 2,
            m: r
        };
    }
    var qr = F2(function(r, n) {
        return {
            $: 3,
            n: r,
            o: n
        };
    }), Kr = [], Ur = !1;
    function Br(r, n, e) {
        if (Kr.push({
            p: r,
            q: n,
            r: e
        }), !Ur) {
            Ur = !0;
            for(var t; t = Kr.shift();)Qr(t.p, t.q, t.r);
            Ur = !1;
        }
    }
    function Qr(r, n, e) {
        var t = {};
        for(var a in Yr(!0, n, t, null), Yr(!1, e, t, null), r)Sr(r[a], {
            $: "fx",
            a: t[a] || {
                i: b,
                j: b
            }
        });
    }
    function Yr(r, n, e, t) {
        switch(n.$){
            case 1:
                var a = n.k, u = function(r, n, e, t) {
                    function a(r) {
                        for(var n = e; n; n = n.t)r = n.s(r);
                        return r;
                    }
                    return A2(r ? Gr[n].e : Gr[n].f, a, t);
                }(r, a, t, n.l);
                return void (e[a] = function(r, n, e) {
                    return e = e || {
                        i: b,
                        j: b
                    }, r ? e.i = d(n, e.i) : e.j = d(n, e.j), e;
                }(r, u, e[a]));
            case 2:
                for(var c = n.m; c.b; c = c.b)Yr(r, c.a, e, t);
                return;
            case 3:
                return void Yr(r, n.o, e, {
                    s: n.n,
                    t: t
                });
        }
    }
    function Jr(r) {
        Gr[r] && j(3);
    }
    function Xr(r, n) {
        return Jr(r), Gr[r] = {
            e: rn,
            u: n,
            a: nn
        }, _r(r);
    }
    var rn = F2(function(r, n) {
        return n;
    });
    function nn(r) {
        var n = [], e = Gr[r].u, t = Pr(0);
        return Gr[r].b = t, Gr[r].c = F3(function(r, a) {
            for(; a.b; a = a.b)for(var u = n, c = e(a.a), o = 0; u.length > o; o++)u[o](c);
            return t;
        }), {
            subscribe: function(r) {
                n.push(r);
            },
            unsubscribe: function(r) {
                var e = (n = n.slice()).indexOf(r);
                0 > e || n.splice(e, 1);
            }
        };
    }
    function en(r, n) {
        return Jr(r), Gr[r] = {
            f: an,
            u: n,
            a: un
        }, _r(r);
    }
    var tn, an = F2(function(r, n) {
        return function(e) {
            return r(n(e));
        };
    });
    function un(r, n) {
        var e = b, t = Gr[r].u, a = xr(null);
        return Gr[r].b = a, Gr[r].c = F3(function(r, n) {
            return e = n, a;
        }), {
            send: function(r) {
                var a = A2(dr, t, r);
                Tt(a) || j(4);
                for(var u = a.a, c = e; c.b; c = c.b)n(c.a(u));
            }
        };
    }
    var cn = "undefined" != typeof document ? document : {};
    function on(r, n) {
        r.appendChild(n);
    }
    function fn(r) {
        return {
            $: 0,
            a: r
        };
    }
    var sn, ln = F2(function(r, n) {
        return F2(function(e, t) {
            for(var a = [], u = 0; t.b; t = t.b){
                var c = t.a;
                u += c.b || 0, a.push(c);
            }
            return u += a.length, {
                $: 1,
                c: n,
                d: wn(e),
                e: a,
                f: r,
                b: u
            };
        });
    }), bn = ln(void 0), dn = F2(function(r, n) {
        return F2(function(e, t) {
            for(var a = [], u = 0; t.b; t = t.b){
                var c = t.a;
                u += c.b.b || 0, a.push(c);
            }
            return u += a.length, {
                $: 2,
                c: n,
                d: wn(e),
                e: a,
                f: r,
                b: u
            };
        });
    })(void 0), vn = F2(function(r, n) {
        return {
            $: 4,
            j: r,
            k: n,
            b: 1 + (n.b || 0)
        };
    }), mn = F2(function(r, n) {
        return {
            $: "a0",
            n: r,
            o: n
        };
    }), gn = F2(function(r, n) {
        return {
            $: "a1",
            n: r,
            o: n
        };
    }), pn = F2(function(r, n) {
        return {
            $: "a2",
            n: r,
            o: n
        };
    }), $n = F2(function(r, n) {
        return {
            $: "a3",
            n: r,
            o: n
        };
    });
    function hn(r) {
        return /^\s*(javascript:|data:text\/html)/i.test(r) ? "" : r;
    }
    function wn(r) {
        for(var n = {}; r.b; r = r.b){
            var e = r.a, t = e.$, a = e.n, u = e.o;
            if ("a2" !== t) {
                var c = n[t] || (n[t] = {});
                "a3" === t && "class" === a ? Cn(c, a, u) : c[a] = u;
            } else "className" === a ? Cn(n, a, u) : n[a] = u;
        }
        return n;
    }
    function Cn(r, n, e) {
        var t = r[n];
        r[n] = t ? t + " " + e : e;
    }
    function kn(r, n) {
        var e = r.$;
        if (5 === e) return kn(r.k || (r.k = r.m()), n);
        if (0 === e) return cn.createTextNode(r.a);
        if (4 === e) {
            for(var t = r.k, a = r.j; 4 === t.$;)"object" != typeof a ? a = [
                a,
                t.j
            ] : a.push(t.j), t = t.k;
            var u = {
                j: a,
                p: n
            };
            return (c = kn(t, u)).elm_event_node_ref = u, c;
        }
        if (3 === e) return yn(c = r.h(r.g), n, r.d), c;
        var c = r.f ? cn.createElementNS(r.f, r.c) : cn.createElement(r.c);
        tn && "a" == r.c && c.addEventListener("click", tn(c)), yn(c, n, r.d);
        for(var o = r.e, i = 0; o.length > i; i++)on(c, kn(1 === e ? o[i] : o[i].b, n));
        return c;
    }
    function yn(r, n, e) {
        for(var t in e){
            var a = e[t];
            "a1" === t ? xn(r, a) : "a0" === t ? An(r, n, a) : "a3" === t ? Ln(r, a) : "a4" === t ? jn(r, a) : ("value" !== t && "checked" !== t || r[t] !== a) && (r[t] = a);
        }
    }
    function xn(r, n) {
        var e = r.style;
        for(var t in n)e[t] = n[t];
    }
    function Ln(r, n) {
        for(var e in n){
            var t = n[e];
            void 0 !== t ? r.setAttribute(e, t) : r.removeAttribute(e);
        }
    }
    function jn(r, n) {
        for(var e in n){
            var t = n[e], a = t.f, u = t.o;
            void 0 !== u ? r.setAttributeNS(a, e, u) : r.removeAttributeNS(a, e);
        }
    }
    function An(r, n, e) {
        var t = r.elmFs || (r.elmFs = {});
        for(var a in e){
            var u = e[a], c = t[a];
            if (u) {
                if (c) {
                    if (c.q.$ === u.$) {
                        c.q = u;
                        continue;
                    }
                    r.removeEventListener(a, c);
                }
                c = Mn(n, u), r.addEventListener(a, c, sn && {
                    passive: 2 > Rt(u)
                }), t[a] = c;
            } else r.removeEventListener(a, c), t[a] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                sn = !0;
            }
        }));
    } catch (r) {}
    function Mn(r, n) {
        function e(n) {
            var t = e.q, a = vr(t.a, n);
            if (Tt(a)) {
                for(var u, c = Rt(t), o = a.a, i = c ? 3 > c ? o.a : o.km : o, f = 1 == c ? o.b : 3 == c && o.k8, s = (f && n.stopPropagation(), (2 == c ? o.b : 3 == c && o.kM) && n.preventDefault(), r); u = s.j;){
                    if ("function" == typeof u) i = u(i);
                    else for(var l = u.length; l--;)i = u[l](i);
                    s = s.p;
                }
                s(i, f);
            }
        }
        return e.q = n, e;
    }
    function Fn(r, n) {
        return r.$ == n.$ && hr(r.a, n.a);
    }
    function Hn(r, n, e, t) {
        var a = {
            $: n,
            r: e,
            s: t,
            t: void 0,
            u: void 0
        };
        return r.push(a), a;
    }
    function Tn(r, n, e, t) {
        if (r !== n) {
            var a = r.$, u = n.$;
            if (a !== u) {
                if (1 !== a || 2 !== u) return void Hn(e, 0, t, n);
                n = function(r) {
                    for(var n = r.e, e = n.length, t = Array(e), a = 0; e > a; a++)t[a] = n[a].b;
                    return {
                        $: 1,
                        c: r.c,
                        d: r.d,
                        e: t,
                        f: r.f,
                        b: r.b
                    };
                }(n), u = 1;
            }
            switch(u){
                case 5:
                    for(var c = r.l, o = n.l, i = c.length, f = i === o.length; f && i--;)f = c[i] === o[i];
                    if (f) return void (n.k = r.k);
                    n.k = n.m();
                    var s = [];
                    return Tn(r.k, n.k, s, 0), void (s.length > 0 && Hn(e, 1, t, s));
                case 4:
                    for(var l = r.j, b = n.j, d = !1, v = r.k; 4 === v.$;)d = !0, "object" != typeof l ? l = [
                        l,
                        v.j
                    ] : l.push(v.j), v = v.k;
                    for(var m = n.k; 4 === m.$;)d = !0, "object" != typeof b ? b = [
                        b,
                        m.j
                    ] : b.push(m.j), m = m.k;
                    return d && l.length !== b.length ? void Hn(e, 0, t, n) : ((d ? function(r, n) {
                        for(var e = 0; r.length > e; e++)if (r[e] !== n[e]) return !1;
                        return !0;
                    }(l, b) : l === b) || Hn(e, 2, t, b), void Tn(v, m, e, t + 1));
                case 0:
                    return void (r.a !== n.a && Hn(e, 3, t, n.a));
                case 1:
                    return void Sn(r, n, e, t, zn);
                case 2:
                    return void Sn(r, n, e, t, Rn);
                case 3:
                    if (r.h !== n.h) return void Hn(e, 0, t, n);
                    var g = En(r.d, n.d);
                    g && Hn(e, 4, t, g);
                    var p = n.i(r.g, n.g);
                    return void (p && Hn(e, 5, t, p));
            }
        }
    }
    function Sn(r, n, e, t, a) {
        if (r.c === n.c && r.f === n.f) {
            var u = En(r.d, n.d);
            u && Hn(e, 4, t, u), a(r, n, e, t);
        } else Hn(e, 0, t, n);
    }
    function En(r, n, e) {
        var t;
        for(var a in r)if ("a1" !== a && "a0" !== a && "a3" !== a && "a4" !== a) {
            if (a in n) {
                var u = r[a], c = n[a];
                u === c && "value" !== a && "checked" !== a || "a0" === e && Fn(u, c) || ((t = t || {})[a] = c);
            } else (t = t || {})[a] = e ? "a1" === e ? "" : "a0" === e || "a3" === e ? void 0 : {
                f: r[a].f,
                o: void 0
            } : "string" == typeof r[a] ? "" : null;
        } else {
            var o = En(r[a], n[a] || {}, a);
            o && ((t = t || {})[a] = o);
        }
        for(var i in n)i in r || ((t = t || {})[i] = n[i]);
        return t;
    }
    function zn(r, n, e, t) {
        var a = r.e, u = n.e, c = a.length, o = u.length;
        c > o ? Hn(e, 6, t, {
            v: o,
            i: c - o
        }) : o > c && Hn(e, 7, t, {
            v: c,
            e: u
        });
        for(var i = o > c ? c : o, f = 0; i > f; f++){
            var s = a[f];
            Tn(s, u[f], e, ++t), t += s.b || 0;
        }
    }
    function Rn(r, n, e, t) {
        for(var a = [], u = {}, c = [], o = r.e, i = n.e, f = o.length, s = i.length, l = 0, b = 0, d = t; f > l && s > b;){
            var v = (j = o[l]).a, m = (A = i[b]).a, g = j.b, p = A.b, $ = void 0, h = void 0;
            if (v !== m) {
                var w = o[l + 1], C = i[b + 1];
                if (w) {
                    var k = w.a, y = w.b;
                    h = m === k;
                }
                if (C) {
                    var x = C.a, L = C.b;
                    $ = v === x;
                }
                if ($ && h) Tn(g, L, a, ++d), Wn(u, a, v, p, b, c), d += g.b || 0, Pn(u, a, v, y, ++d), d += y.b || 0, l += 2, b += 2;
                else if ($) d++, Wn(u, a, m, p, b, c), Tn(g, L, a, d), d += g.b || 0, l += 1, b += 2;
                else if (h) Pn(u, a, v, g, ++d), d += g.b || 0, Tn(y, p, a, ++d), d += y.b || 0, l += 2, b += 1;
                else {
                    if (!w || k !== x) break;
                    Pn(u, a, v, g, ++d), Wn(u, a, m, p, b, c), d += g.b || 0, Tn(y, L, a, ++d), d += y.b || 0, l += 2, b += 2;
                }
            } else Tn(g, p, a, ++d), d += g.b || 0, l++, b++;
        }
        for(; f > l;){
            var j;
            d++, Pn(u, a, (j = o[l]).a, g = j.b, d), d += g.b || 0, l++;
        }
        for(; s > b;){
            var A, M = M || [];
            Wn(u, a, (A = i[b]).a, A.b, void 0, M), b++;
        }
        (a.length > 0 || c.length > 0 || M) && Hn(e, 8, t, {
            w: a,
            x: c,
            y: M
        });
    }
    var Vn = "_elmW6BL";
    function Wn(r, n, e, t, a, u) {
        var c = r[e];
        if (!c) return u.push({
            r: a,
            A: c = {
                c: 0,
                z: t,
                r: a,
                s: void 0
            }
        }), void (r[e] = c);
        if (1 === c.c) {
            u.push({
                r: a,
                A: c
            }), c.c = 2;
            var o = [];
            return Tn(c.z, t, o, c.r), c.r = a, void (c.s.s = {
                w: o,
                A: c
            });
        }
        Wn(r, n, e + Vn, t, a, u);
    }
    function Pn(r, n, e, t, a) {
        var u = r[e];
        if (u) {
            if (0 === u.c) {
                u.c = 2;
                var c = [];
                return Tn(t, u.z, c, a), void Hn(n, 9, a, {
                    w: c,
                    A: u
                });
            }
            Pn(r, n, e + Vn, t, a);
        } else {
            var o = Hn(n, 9, a, void 0);
            r[e] = {
                c: 1,
                z: t,
                r: a,
                s: o
            };
        }
    }
    function Gn(r, n, e, t) {
        In(r, n, e, 0, 0, n.b, t);
    }
    function In(r, n, e, t, a, u, c) {
        for(var o = e[t], i = o.r; i === a;){
            var f = o.$;
            if (1 === f) Gn(r, n.k, o.s, c);
            else if (8 === f) o.t = r, o.u = c, (s = o.s.w).length > 0 && In(r, n, s, 0, a, u, c);
            else if (9 === f) {
                o.t = r, o.u = c;
                var s, l = o.s;
                l && (l.A.s = r, (s = l.w).length > 0 && In(r, n, s, 0, a, u, c));
            } else o.t = r, o.u = c;
            if (!(o = e[++t]) || (i = o.r) > u) return t;
        }
        var b = n.$;
        if (4 === b) {
            for(var d = n.k; 4 === d.$;)d = d.k;
            return In(r, d, e, t, a + 1, u, r.elm_event_node_ref);
        }
        for(var v = n.e, m = r.childNodes, g = 0; v.length > g; g++){
            a++;
            var p = 1 === b ? v[g] : v[g].b, $ = a + (p.b || 0);
            if (!(a > i || i > $ || (o = e[t = In(m[g], p, e, t, a, $, c)]) && (i = o.r) <= u)) return t;
            a = $;
        }
        return t;
    }
    function Nn(r, n) {
        for(var e = 0; n.length > e; e++){
            var t = n[e], a = t.t, u = Zn(a, t);
            a === r && (r = u);
        }
        return r;
    }
    function Zn(r, n) {
        switch(n.$){
            case 0:
                return function(r, n, e) {
                    var t = r.parentNode, a = kn(n, e);
                    return a.elm_event_node_ref || (a.elm_event_node_ref = r.elm_event_node_ref), t && a !== r && t.replaceChild(a, r), a;
                }(r, n.s, n.u);
            case 4:
                return yn(r, n.u, n.s), r;
            case 3:
                return r.replaceData(0, r.length, n.s), r;
            case 1:
                return Nn(r, n.s);
            case 2:
                return r.elm_event_node_ref ? r.elm_event_node_ref.j = n.s : r.elm_event_node_ref = {
                    j: n.s,
                    p: n.u
                }, r;
            case 6:
                for(var e = n.s, t = 0; e.i > t; t++)r.removeChild(r.childNodes[e.v]);
                return r;
            case 7:
                for(var a = (e = n.s).e, u = r.childNodes[t = e.v]; a.length > t; t++)r.insertBefore(kn(a[t], n.u), u);
                return r;
            case 9:
                if (!(e = n.s)) return r.parentNode.removeChild(r), r;
                var c = e.A;
                return void 0 !== c.r && r.parentNode.removeChild(r), c.s = Nn(r, e.w), r;
            case 8:
                return function(r, n) {
                    var e = n.s, t = function(r, n) {
                        if (r) {
                            for(var e = cn.createDocumentFragment(), t = 0; r.length > t; t++){
                                var a = r[t].A;
                                on(e, 2 === a.c ? a.s : kn(a.z, n.u));
                            }
                            return e;
                        }
                    }(e.y, n);
                    r = Nn(r, e.w);
                    for(var a = e.x, u = 0; a.length > u; u++){
                        var c = a[u], o = c.A, i = 2 === o.c ? o.s : kn(o.z, n.u);
                        r.insertBefore(i, r.childNodes[c.r]);
                    }
                    return t && on(r, t), r;
                }(r, n);
            case 5:
                return n.s(r);
            default:
                j(10);
        }
    }
    function Dn(r) {
        if (3 === r.nodeType) return fn(r.textContent);
        if (1 !== r.nodeType) return fn("");
        for(var n = b, e = r.attributes, t = e.length; t--;){
            var a = e[t];
            n = d(A2($n, a.name, a.value), n);
        }
        var u = r.tagName.toLowerCase(), c = b, o = r.childNodes;
        for(t = o.length; t--;)c = d(Dn(o[t]), c);
        return A3(bn, u, n, c);
    }
    var _n = F4(function(r, n, e, t) {
        return function(r, n, e, t, a, u) {
            var c = A2(dr, r, n ? n.flags : void 0);
            Tt(c) || j(2);
            var o = {}, i = e(c.a), f = i.a, s = u(b, f), l = function(r, n) {
                var e;
                for(var t in Gr){
                    var a = Gr[t];
                    a.a && ((e = e || {})[t] = a.a(t, n)), r[t] = Nr(a, n);
                }
                return e;
            }(o, b);
            function b(r, n) {
                var e = A2(t, r, f);
                s(f = e.a, n), Br(o, e.b, a(f));
            }
            return Br(o, i.b, a(f)), l ? {
                ports: l
            } : {};
        }(n, t, r.jZ, r.ln, r.la, function(n, e) {
            var t = r.ge && r.ge(n), a = r.lr, u = cn.title, c = cn.body, o = Dn(c);
            return function(r, n) {
                n(r);
                var e = 0;
                function t() {
                    e = 1 === e ? 0 : (qn(t), n(r), 1);
                }
                return function(a, u) {
                    r = a, u ? (n(r), 2 === e && (e = 1)) : (0 === e && qn(t), e = 2);
                };
            }(e, function(r) {
                tn = t;
                var e = a(r), i = bn("body")(b)(e.bv), f = function(r, n) {
                    var e = [];
                    return Tn(r, n, e, 0), e;
                }(o, i);
                c = function(r, n, e, t) {
                    return 0 === e.length ? r : (Gn(r, n, e, t), Nn(r, e));
                }(c, o, f, n), o = i, tn = 0, u !== e.z && (cn.title = u = e.z);
            });
        });
    }), On = "undefined" != typeof cancelAnimationFrame ? cancelAnimationFrame : function(r) {
        clearTimeout(r);
    }, qn = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(r) {
        return setTimeout(r, 1e3 / 60);
    };
    function Kn() {
        return Jt(cn.location.href).a || j(1);
    }
    var Un = F2(function(r, n) {
        return A2(da, Xt, jr(function() {
            history.pushState({}, "", n), r();
        }));
    }), Bn = ("undefined" != typeof document && document, "undefined" != typeof window ? window : {
        addEventListener: function() {},
        removeEventListener: function() {}
    });
    var Qn = F2(function(r, n) {
        return function(r, n) {
            return jr(function(e) {
                qn(function() {
                    var t = document.getElementById(r);
                    e(t ? xr(n(t)) : Lr(Wt(r)));
                });
            });
        }(n, function(n) {
            return n[r](), 0;
        });
    });
    function Yn(r) {
        return r.byteLength;
    }
    var Jn = F3(function(r, n, e) {
        return r.setInt8(n, e), n + 1;
    }), Xn = F4(function(r, n, e, t) {
        return r.setInt16(n, e, t), n + 2;
    }), re = F4(function(r, n, e, t) {
        return r.setInt32(n, e, t), n + 4;
    }), ne = F3(function(r, n, e) {
        return r.setUint8(n, e), n + 1;
    }), ee = F4(function(r, n, e, t) {
        return r.setUint16(n, e, t), n + 2;
    }), te = F4(function(r, n, e, t) {
        return r.setUint32(n, e, t), n + 4;
    }), ae = F4(function(r, n, e, t) {
        return r.setFloat32(n, e, t), n + 4;
    }), ue = F4(function(r, n, e, t) {
        return r.setFloat64(n, e, t), n + 8;
    }), ce = F3(function(r, n, e) {
        for(var t = 0, a = e.byteLength, u = a - 4; u >= t; t += 4)r.setUint32(n + t, e.getUint32(t));
        for(; a > t; t++)r.setUint8(n + t, e.getUint8(t));
        return n + a;
    }), oe = F3(function(r, n, e) {
        for(var t = 0; e.length > t; t++){
            var a = e.charCodeAt(t);
            n += 128 > a ? (r.setUint8(n, a), 1) : 2048 > a ? (r.setUint16(n, 49280 | (a >>> 6 & 31) << 8 | 63 & a), 2) : 55296 > a || a > 56319 ? (r.setUint16(n, 57472 | (a >>> 12 & 15) << 8 | a >>> 6 & 63), r.setUint8(n + 2, 128 | 63 & a), 3) : (a = 1024 * (a - 55296) + e.charCodeAt(++t) - 56320 + 65536, r.setUint32(n, 4034953344 | (a >>> 18 & 7) << 24 | (a >>> 12 & 63) << 16 | (a >>> 6 & 63) << 8 | 63 & a), 4);
        }
        return n;
    }), ie = F2(function(r, n) {
        try {
            return Ve(A2(r, n, 0).b);
        } catch (r) {
            return We;
        }
    }), fe = F3(function(r, n, e) {
        for(var t = "", a = e + r; a > e;){
            var u = n.getUint8(e++);
            t += 128 > u ? String.fromCharCode(u) : 192 == (224 & u) ? String.fromCharCode((31 & u) << 6 | 63 & n.getUint8(e++)) : 224 == (240 & u) ? String.fromCharCode((15 & u) << 12 | (63 & n.getUint8(e++)) << 6 | 63 & n.getUint8(e++)) : (u = ((7 & u) << 18 | (63 & n.getUint8(e++)) << 12 | (63 & n.getUint8(e++)) << 6 | 63 & n.getUint8(e++)) - 65536, String.fromCharCode(Math.floor(u / 1024) + 55296, u % 1024 + 56320));
        }
        return i(e, t);
    }), se = F2(function(r, n) {
        var e = "g";
        r.ku && (e += "m"), r.jf && (e += "i");
        try {
            return Ve(RegExp(n, e));
        } catch (r) {
            return We;
        }
    }), le = F2(function(r, n) {
        return null !== n.match(r);
    }), be = F3(function(r, n, e) {
        return jr(function(t) {
            function a(r) {
                t(n(e.fJ.a(r)));
            }
            var u = new XMLHttpRequest;
            u.addEventListener("error", function() {
                a(Xi);
            }), u.addEventListener("timeout", function() {
                a(ef);
            }), u.addEventListener("load", function() {
                a(function(r, n) {
                    return A2(n.status >= 200 && 300 > n.status ? Ji : Qi, function(r) {
                        return {
                            b5: r.responseURL,
                            k6: r.status,
                            k7: r.statusText,
                            bH: de(r.getAllResponseHeaders())
                        };
                    }(n), r(n.response));
                }(e.fJ.b, u));
            }), tf(e.gq) && function(r, n, e) {
                n.upload.addEventListener("progress", function(t) {
                    n.c || Hr(A2(af, r, i(e, nf({
                        k3: t.loaded,
                        eT: t.total
                    }))));
                }), n.addEventListener("progress", function(t) {
                    n.c || Hr(A2(af, r, i(e, rf({
                        kS: t.loaded,
                        eT: t.lengthComputable ? Ve(t.total) : We
                    }))));
                });
            }(r, u, e.gq.a);
            try {
                u.open(e.bS, e.b5, !0);
            } catch (r) {
                return a(Yi(e.b5));
            }
            return function(r, n) {
                for(var e = n.bH; e.b; e = e.b)r.setRequestHeader(e.a.a, e.a.b);
                r.timeout = n.b4.a || 0, r.responseType = n.fJ.d, r.withCredentials = n.iW;
            }(u, e), e.bv.a && u.setRequestHeader("Content-Type", e.bv.a), u.send(e.bv.b), function() {
                u.c = !0, u.abort();
            };
        });
    });
    function de(r) {
        if (!r) return ko;
        for(var n = ko, e = r.split("\r\n"), t = e.length; t--;){
            var a = e[t], u = a.indexOf(": ");
            if (u > 0) {
                var c = a.substring(0, u), o = a.substring(u + 2);
                n = A3(wo, c, function(r) {
                    return Ve(tf(r) ? o + ", " + r.a : o);
                }, n);
            }
        }
        return n;
    }
    var ve = F3(function(r, n, e) {
        return {
            $: 0,
            d: r,
            b: n,
            a: e
        };
    }), me = F2(function(r, n) {
        return {
            $: 0,
            d: n.d,
            b: n.b,
            a: function(e) {
                return r(n.a(e));
            }
        };
    });
    function ge(r) {
        return new DataView(r);
    }
    var pe = F2(function(r, n) {
        return {
            $: 0,
            a: r,
            b: n
        };
    }), $e = F5(function(r, n, e, t, a) {
        for(var u = r.length, c = a.length >= n + u, o = 0; c && u > o;){
            var i = a.charCodeAt(n);
            c = r[o++] === a[n++] && (10 === i ? (e++, t = 1) : (t++, 55296 == (63488 & i) ? r[o++] === a[n++] : 1));
        }
        return f(c ? n : -1, e, t);
    }), he = F3(function(r, n, e) {
        return e.length > n ? 55296 == (63488 & e.charCodeAt(n)) ? r(e.substr(n, 2)) ? n + 2 : -1 : r(e[n]) ? "\n" === e[n] ? -2 : n + 1 : -1 : -1;
    }), we = 1, Ce = 2, ke = 0, ye = v, xe = F3(function(r, n, e) {
        for(;;){
            if (-2 === e.$) return n;
            var t = e.d, a = r, u = A3(r, e.b, e.c, A3(xe, r, n, e.e));
            r = a, n = u, e = t;
        }
    }), Le = function(r) {
        return A3(xe, F3(function(r, n, e) {
            return A2(ye, i(r, n), e);
        }), b, r);
    }, je = x, Ae = F3(function(r, n, e) {
        var t = e.c, a = e.d, u = F2(function(n, e) {
            return A3(je, n.$ ? r : u, e, n.a);
        });
        return A3(je, u, A3(je, r, n, a), t);
    }), Me = function(r) {
        return A3(Ae, ye, b, r);
    }, Fe = function(r) {
        return {
            $: 1,
            a: r
        };
    }, He = F2(function(r, n) {
        return {
            $: 3,
            a: r,
            b: n
        };
    }), Te = F2(function(r, n) {
        return {
            $: 0,
            a: r,
            b: n
        };
    }), Se = F2(function(r, n) {
        return {
            $: 1,
            a: r,
            b: n
        };
    }), Ee = function(r) {
        return {
            $: 0,
            a: r
        };
    }, ze = function(r) {
        return {
            $: 2,
            a: r
        };
    }, Re = A, Ve = function(r) {
        return {
            $: 0,
            a: r
        };
    }, We = {
        $: 1
    }, Pe = D, Ge = Cr, Ie = K, Ne = F2(function(r, n) {
        return A2(N, r, g(n));
    }), Ze = F2(function(r, n) {
        return m(A2(I, r, n));
    }), De = function(r) {
        return A2(Ne, "\n    ", A2(Ze, "\n", r));
    }, _e = F3(function(r, n, e) {
        for(;;){
            if (!e.b) return n;
            var t = e.b, a = r, u = A2(r, e.a, n);
            r = a, n = u, e = t;
        }
    }), Oe = function(r) {
        return A3(_e, F2(function(r, n) {
            return n + 1;
        }), 0, r);
    }, qe = p, Ke = F3(function(r, n, e) {
        for(;;){
            if (c(r, n) >= 1) return e;
            var t = r, a = n - 1, u = A2(ye, n, e);
            r = t, n = a, e = u;
        }
    }), Ue = F2(function(r, n) {
        return A3(Ke, r, n, b);
    }), Be = F2(function(r, n) {
        return A3(qe, r, A2(Ue, 0, Oe(n) - 1), n);
    }), Qe = function(r) {
        var n = r.charCodeAt(0);
        return 55296 > n || n > 56319 ? n : 1024 * (n - 55296) + r.charCodeAt(1) - 56320 + 65536;
    }, Ye = function(r) {
        var n = Qe(r);
        return n >= 97 && 122 >= n;
    }, Je = function(r) {
        var n = Qe(r);
        return 90 >= n && n >= 65;
    }, Xe = function(r) {
        return Ye(r) || Je(r);
    }, rt = function(r) {
        var n = Qe(r);
        return 57 >= n && n >= 48;
    }, nt = function(r) {
        return Ye(r) || Je(r) || rt(r);
    }, et = function(r) {
        return A3(_e, ye, b, r);
    }, tt = function(r) {
        var n = r.charCodeAt(0);
        return isNaN(n) ? We : Ve(55296 > n || n > 56319 ? i(r[0], r.slice(1)) : i(r[0] + r[1], r.slice(2)));
    }, at = F2(function(r, n) {
        return "\n\n(" + Ie(r + 1) + ") " + De(ut(n));
    }), ut = function(r) {
        return A2(ct, r, b);
    }, ct = F2(function(r, n) {
        r: for(;;)switch(r.$){
            case 0:
                var e = r.a, t = r.b, a = function() {
                    var r = tt(e);
                    if (1 === r.$) return !1;
                    var n = r.a, t = n.b;
                    return Xe(n.a) && A2(Pe, nt, t);
                }();
                r = t, n = A2(ye, a ? "." + e : "['" + e + "']", n);
                continue r;
            case 1:
                t = r.b;
                var u = "[" + Ie(r.a) + "]";
                r = t, n = A2(ye, u, n);
                continue r;
            case 2:
                var c = r.a;
                if (c.b) {
                    if (c.b.b) {
                        var o = (n.b ? "The Json.Decode.oneOf at json" + A2(Ne, "", et(n)) : "Json.Decode.oneOf") + " failed in the following " + Ie(Oe(c)) + " ways:";
                        return A2(Ne, "\n\n", A2(ye, o, A2(Be, at, c)));
                    }
                    r = t = c.a;
                    continue r;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (n.b ? " at json" + A2(Ne, "", et(n)) : "!");
            default:
                var i = r.a, f = r.b;
                return (o = n.b ? "Problem with the value at json" + A2(Ne, "", et(n)) + ":\n\n    " : "Problem with the given value:\n\n") + De(A2(Ge, 4, f)) + "\n\n" + i;
        }
    }), ot = 32, it = F4(function(r, n, e, t) {
        return {
            $: 0,
            a: r,
            b: n,
            c: e,
            d: t
        };
    }), ft = [], st = E, lt = F2(function(r, n) {
        return V(n) / V(r);
    }), bt = function(r) {
        return r;
    }, dt = st(A2(lt, 2, ot)), vt = A4(it, 0, dt, ft, ft), mt = w, gt = function(r) {
        return {
            $: 1,
            a: r
        };
    }, pt = F2(function(r, n) {
        return r(n);
    }), $t = F2(function(r, n) {
        return n(r);
    }), ht = a, wt = z, Ct = function(r) {
        return r.length;
    }, kt = F2(function(r, n) {
        return c(r, n) > 0 ? r : n;
    }), yt = function(r) {
        return {
            $: 0,
            a: r
        };
    }, xt = C, Lt = F2(function(r, n) {
        for(;;){
            var e = A2(xt, ot, r), t = e.b, a = A2(ye, yt(e.a), n);
            if (!t.b) return et(a);
            r = t, n = a;
        }
    }), jt = function(r) {
        return r.a;
    }, At = F2(function(r, n) {
        for(;;){
            var e = st(n / ot);
            if (1 === e) return A2(xt, ot, r).a;
            r = A2(Lt, r, b), n = e;
        }
    }), Mt = F2(function(r, n) {
        if (n.k) {
            var e = n.k * ot, t = wt(A2(lt, ot, e - 1)), a = r ? et(n.p) : n.p, u = A2(At, a, n.k);
            return A4(it, Ct(n.m) + e, A2(kt, 5, t * dt), u, n.m);
        }
        return A4(it, Ct(n.m), dt, ft, n.m);
    }), Ft = F5(function(r, n, e, t, a) {
        for(;;){
            if (0 > n) return A2(Mt, !1, {
                p: t,
                k: e / ot | 0,
                m: a
            });
            var u = gt(A3(mt, ot, n, r));
            n -= ot, t = A2(ye, u, t);
        }
    }), Ht = F2(function(r, n) {
        if (r > 0) {
            var e = r % ot;
            return A5(Ft, n, r - e - ot, r, b, A3(mt, e, r - e, n));
        }
        return vt;
    }), Tt = function(r) {
        return !r.$;
    }, St = ar, Et = ur, zt = function(r) {
        return {
            $: 0,
            a: r
        };
    }, Rt = function(r) {
        switch(r.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Vt = function(r) {
        return r;
    }, Wt = Vt, Pt = F6(function(r, n, e, t, a, u) {
        return {
            ha: u,
            hg: n,
            hT: t,
            hW: e,
            h$: r,
            h0: a
        };
    }), Gt = _, It = function(r) {
        return r.length;
    }, Nt = Z, Zt = F2(function(r, n) {
        return 1 > r ? n : A3(Nt, r, It(n), n);
    }), Dt = q, _t = function(r) {
        return "" === r;
    }, Ot = F2(function(r, n) {
        return 1 > r ? "" : A3(Nt, 0, r, n);
    }), qt = function(r) {
        for(var n = 0, e = r.charCodeAt(0), t = 43 == e || 45 == e ? 1 : 0, a = t; r.length > a; ++a){
            var u = r.charCodeAt(a);
            if (48 > u || u > 57) return We;
            n = 10 * n + u - 48;
        }
        return a == t ? We : Ve(45 == e ? -n : n);
    }, Kt = F5(function(r, n, e, t, a) {
        if (_t(a) || A2(Gt, "@", a)) return We;
        var u = A2(Dt, ":", a);
        if (u.b) {
            if (u.b.b) return We;
            var c = u.a, o = qt(A2(Zt, c + 1, a));
            if (1 === o.$) return We;
            var i = o;
            return Ve(A6(Pt, r, A2(Ot, c, a), i, n, e, t));
        }
        return Ve(A6(Pt, r, a, We, n, e, t));
    }), Ut = F4(function(r, n, e, t) {
        if (_t(t)) return We;
        var a = A2(Dt, "/", t);
        if (a.b) {
            var u = a.a;
            return A5(Kt, r, A2(Zt, u, t), n, e, A2(Ot, u, t));
        }
        return A5(Kt, r, "/", n, e, t);
    }), Bt = F3(function(r, n, e) {
        if (_t(e)) return We;
        var t = A2(Dt, "?", e);
        if (t.b) {
            var a = t.a;
            return A4(Ut, r, Ve(A2(Zt, a + 1, e)), n, A2(Ot, a, e));
        }
        return A4(Ut, r, We, n, e);
    }), Qt = F2(function(r, n) {
        if (_t(n)) return We;
        var e = A2(Dt, "#", n);
        if (e.b) {
            var t = e.a;
            return A3(Bt, r, Ve(A2(Zt, t + 1, n)), A2(Ot, t, n));
        }
        return A3(Bt, r, We, n);
    }), Yt = O, Jt = function(r) {
        return A2(Yt, "http://", r) ? A2(Qt, 0, A2(Zt, 7, r)) : A2(Yt, "https://", r) ? A2(Qt, 1, A2(Zt, 8, r)) : We;
    }, Xt = function() {
        for(;;);
    }, ra = xr, na = ra(0), ea = F4(function(r, n, e, t) {
        if (t.b) {
            var a = t.a, u = t.b;
            if (u.b) {
                var c = u.a, o = u.b;
                if (o.b) {
                    var i = o.a, f = o.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(r, a, A2(r, c, A2(r, i, A2(r, f.a, e > 500 ? A3(_e, r, n, et(s)) : A4(ea, r, n, e + 1, s)))));
                    }
                    return A2(r, a, A2(r, c, A2(r, i, n)));
                }
                return A2(r, a, A2(r, c, n));
            }
            return A2(r, a, n);
        }
        return n;
    }), ta = F3(function(r, n, e) {
        return A4(ea, r, n, 0, e);
    }), aa = F2(function(r, n) {
        return A3(ta, F2(function(n, e) {
            return A2(ye, r(n), e);
        }), b, n);
    }), ua = Ar, ca = F2(function(r, n) {
        return A2(ua, function(n) {
            return ra(r(n));
        }, n);
    }), oa = F3(function(r, n, e) {
        return A2(ua, function(n) {
            return A2(ua, function(e) {
                return ra(A2(r, n, e));
            }, e);
        }, n);
    }), ia = function(r) {
        return A3(ta, oa(ye), ra(b), r);
    }, fa = Zr, sa = F2(function(r, n) {
        var e = n;
        return Tr(A2(ua, fa(r), e));
    });
    Gr.Task = Ir(na, F3(function(r, n) {
        return A2(ca, function() {
            return 0;
        }, ia(A2(aa, sa(r), n)));
    }), F3(function() {
        return ra(0);
    }), F2(function(r, n) {
        return A2(ca, r, n);
    }));
    var la, ba = _r("Task"), da = F2(function(r, n) {
        return ba(A2(ca, r, n));
    }), va = F4(function(r, n, e, t) {
        return {
            js: n,
            jP: e,
            gp: r,
            lv: t
        };
    }), ma = Or, ga = {
        $: 10
    }, pa = {
        $: 26
    }, $a = function(r) {
        return {
            $: 1,
            a: r
        };
    }, ha = F2(function(r, n) {
        return n.$ ? Fe(n.a) : r(n.a);
    }), wa = F3(function(r, n, e) {
        return n(r(e));
    }), Ca = br, ka = {
        $: 2
    }, ya = function(r) {
        return {
            $: 0,
            a: r
        };
    }, xa = function(r) {
        return A2(Ne, "", r);
    }, La = F, ja = function(r) {
        switch(A2(La, 4, It(r))){
            case 0:
                return Ee(r);
            case 2:
                return Ee(xa(m([
                    r,
                    "=="
                ])));
            case 3:
                return Ee(xa(m([
                    r,
                    "="
                ])));
            default:
                return Fe(ya("Wrong length"));
        }
    }, Aa = F2(function(r, n) {
        return n.$ ? Fe(r) : Ee(n.a);
    }), Ma = F2(function(r, n) {
        return n.$ ? Fe(n.a) : Ee(r(n.a));
    }), Fa = F3(function(r, n, e) {
        if (1 === n.$) return Fe(n.a);
        var t = n.a;
        return 1 === e.$ ? Fe(e.a) : Ee(A2(r, t, e.a));
    }), Ha = F2(function(r, n) {
        return n.$ ? Fe(r(n.a)) : Ee(n.a);
    }), Ta = function(r) {
        switch(r.$){
            case 0:
            case 3:
                return 1;
            case 1:
            case 4:
                return 2;
            case 2:
            case 5:
            case 6:
                return 4;
            case 7:
                return 8;
            case 8:
            case 9:
                return r.a;
            default:
                return Yn(r.a);
        }
    }, Sa = F3(function(r, n, e) {
        switch(r.$){
            case 0:
                return A3(Jn, n, e, r.a);
            case 1:
                return A4(Xn, n, e, r.b, !r.a);
            case 2:
                return A4(re, n, e, r.b, !r.a);
            case 3:
                return A3(ne, n, e, r.a);
            case 4:
                return A4(ee, n, e, r.b, !r.a);
            case 5:
                return A4(te, n, e, r.b, !r.a);
            case 6:
                return A4(ae, n, e, r.b, !r.a);
            case 7:
                return A4(ue, n, e, r.b, !r.a);
            case 8:
                return A3(Ea, r.b, n, e);
            case 9:
                return A3(oe, n, e, r.b);
            default:
                return A3(ce, n, e, r.a);
        }
    }), Ea = F3(function(r, n, e) {
        for(;;){
            if (!r.b) return e;
            var t = r.b, a = n, u = A3(Sa, r.a, n, e);
            r = t, n = a, e = u;
        }
    }), za = F2(function(r, n) {
        return A2(ie, r, n);
    }), Ra = function(r) {
        var n = new DataView(new ArrayBuffer(Ta(r)));
        return Sa(r)(n)(0), n;
    }, Va = function(r) {
        if (nt(r)) return !0;
        switch(r){
            case "+":
            case "/":
                return !0;
            default:
                return !1;
        }
    }, Wa = F2(function(r, n) {
        return {
            $: 8,
            a: r,
            b: n
        };
    }), Pa = F2(function(r, n) {
        for(;;){
            if (!n.b) return r;
            var e = n.b;
            r += Ta(n.a), n = e;
        }
    }), Ga = function(r) {
        return A2(Wa, A2(Pa, 0, r), r);
    }, Ia = function(r) {
        return -r;
    }, Na = function(r) {
        var n = Qe(r);
        if (n >= 65 && 90 >= n) return n - 65;
        if (n >= 97 && 122 >= n) return n - 97 + 26;
        if (n >= 48 && 57 >= n) return n - 48 + 26 + 26;
        switch(r){
            case "+":
                return 62;
            case "/":
                return 63;
            default:
                return -1;
        }
    }, Za = F2(function(r, n) {
        return {
            $: 4,
            a: r,
            b: n
        };
    }), Da = Za, _a = function(r) {
        return {
            $: 3,
            a: r
        };
    }, Oa = F4(function(r, n, e, t) {
        if (Va(r) && Va(n)) {
            var a = Na(n), u = Na(r);
            if ("=" === t) {
                if ("=" === e) return Ve(_a((o = u << 18 | a << 12) >> 16));
                if (Va(e)) {
                    var c = Na(e);
                    return Ve(A2(Da, 1, (o = u << 18 | a << 12 | c << 6) >> 8));
                }
                return We;
            }
            if (Va(e) && Va(t)) {
                var o, i = Na(t), f = o = u << 18 | a << 12 | (c = Na(e)) << 6 | i;
                return Ve(Ga(m([
                    A2(Da, 1, o >> 8),
                    _a(f)
                ])));
            }
            return We;
        }
        return We;
    }), qa = G, Ka = function(r) {
        return A3(qa, ye, b, r);
    }, Ua = F2(function(r, n) {
        r: for(;;){
            var e = Ka(A2(Ot, 4, r));
            n: for(;;){
                if (e.b) {
                    if (e.b.b) {
                        if (e.b.b.b) {
                            if (e.b.b.b.b) {
                                if (e.b.b.b.b.b) break n;
                                var t = e.b, a = t.b, u = A4(Oa, e.a, t.a, a.a, a.b.a);
                                if (u.$) return We;
                                var c = u.a;
                                r = A2(Zt, 4, r), n = A2(ye, c, n);
                                continue r;
                            }
                            var o = e.b, i = A4(Oa, e.a, o.a, o.b.a, "=");
                            return 1 === i.$ ? We : Ve(A2(ye, c = i.a, n));
                        }
                        var f = A4(Oa, e.a, e.b.a, "=", "=");
                        return 1 === f.$ ? We : Ve(A2(ye, c = f.a, n));
                    }
                    break n;
                }
                return Ve(n);
            }
            return We;
        }
    }), Ba = F2(function(r, n) {
        return n.$ ? We : Ve(r(n.a));
    }), Qa = Yn, Ya = function(r) {
        var n = A2(Ba, Ra, function(r) {
            return A2(Ba, A2(wa, et, Ga), A2(Ua, r, b));
        }(r));
        if (1 === n.$) return We;
        var e, t = n.a;
        return A2(za, (e = Qa(t), fe(e)), t);
    }, Ja = P, Xa = Ja(function(r) {
        switch(r){
            case "-":
                return "+";
            case "_":
                return "/";
            default:
                return r;
        }
    }), ru = J, nu = function(r) {
        return r.b;
    }, eu = F2(function(r, n) {
        return A2(ha, A2(wa, Ca(r), Ha($a)), A2(Ma, nu, function(r) {
            var n = F2(function(r, n) {
                return A2(Ha, r, A2(Ma, function() {
                    return n;
                }, A2(Ca, ru, n)));
            }), e = A2(wa, Xa, A2(wa, Ze("."), aa(ja)))(r);
            r: for(;;){
                if (e.b && e.b.b && e.b.b.b && !e.b.b.b.b) {
                    if (e.a.$) {
                        if (1 === e.b.a.$) break r;
                        return Fe(e.a.a);
                    }
                    if (e.b.a.$) break r;
                    var t = e.a.a, a = e.b.a.a, u = A2(ha, n(function() {
                        return ka;
                    }), A2(Aa, ka, Ya(t))), c = A2(ha, n($a), A2(Aa, ya("Invalid UTF-16"), Ya(a)));
                    return A3(Fa, F2(function(r, n) {
                        return i(r, n);
                    }), u, c);
                }
                return Fe(ya("Token has invalid shape"));
            }
            return Fe(e.b.a.a);
        }(n)));
    }), tu = rr, au = Y, uu = B, cu = function(r) {
        return {
            $: 11,
            g: r
        };
    }, ou = R, iu = function(r) {
        return r;
    }, fu = F2(function(r, n) {
        return A2(Ma, function(n) {
            return c(r, n) > 0;
        }, function(r) {
            var n = cu(m([
                uu,
                A2(St, ou, au)
            ]));
            return A2(Ma, function(r) {
                return 1e3 * r;
            }, A2(eu, A2(tu, "exp", n), r));
        }(n));
    }), su = ma(b), lu = F2(function(r, n) {
        return {
            $: 0,
            a: r,
            b: n
        };
    }), bu = lu, du = Vt, vu = (la = du, jr(function(r) {
        r(xr(la(Date.now())));
    })), mu = F2(function(r, n) {
        return n.$ ? r : n.a;
    }), gu = function(r) {
        if (1 === r.$) return su;
        var n = r.a;
        return A2(da, Vt, A2(ca, function(r) {
            return A2(mu, !0, A2(fu, r, n)) ? ga : pa;
        }, vu));
    }, pu = dr, $u = F9(function(r, n, e, t, a, u, c, o, i) {
        return {
            fk: u,
            js: n,
            jt: c,
            jL: a,
            jP: e,
            kH: i,
            gn: o,
            gp: r,
            lv: t
        };
    }), hu = Et($t), wu = Q, Cu = F6(function(r, n, e, t, a, u) {
        return {
            aU: e,
            aZ: a,
            a7: n,
            en: u,
            bi: t,
            bj: r
        };
    }), ku = fr, yu = F4(function(r, n, e, t) {
        return {
            aW: t,
            aX: r,
            l: n,
            z: e
        };
    }), xu = tr, Lu = F4(function(r, n, e, t) {
        return {
            $: 5,
            a: r,
            b: n,
            c: e,
            d: t
        };
    }), ju = function(r) {
        return {
            $: 0,
            a: r
        };
    }, Au = F2(function(r, n) {
        return {
            bJ: ju({
                gX: 26,
                io: 170
            }),
            j1: We,
            kL: r,
            lf: r,
            lm: n,
            lq: 0
        };
    }), Mu = F3(function(r, n, e) {
        return A4(Lu, "scale3d", A2(Au, r, ""), A2(Au, n, ""), A2(Au, e, ""));
    }), Fu = function(r) {
        return {
            $: 1,
            a: r
        };
    }, Hu = H, Tu = function(r) {
        return {
            $: 2,
            a: r
        };
    }, Su = F2(function(r, n) {
        return {
            $: 7,
            a: r,
            b: n
        };
    }), Eu = F5(function(r, n, e, t, a) {
        return {
            $: 1,
            a: r,
            b: n,
            c: e,
            d: t,
            e: a
        };
    }), zu = F2(function(r, n) {
        return {
            $: 0,
            a: r,
            b: n
        };
    }), Ru = function(r) {
        return {
            $: 9,
            a: r
        };
    }, Vu = function(r) {
        return {
            $: 8,
            a: r
        };
    }, Wu = F2(function(r, n) {
        return {
            $: 3,
            a: r,
            b: n
        };
    }), Pu = F3(function(r, n, e) {
        return {
            $: 4,
            a: r,
            b: n,
            c: e
        };
    }), Gu = F5(function(r, n, e, t, a) {
        return {
            $: 6,
            a: r,
            b: n,
            c: e,
            d: t,
            e: a
        };
    }), Iu = F3(function(r, n, e) {
        return {
            $: 2,
            a: r,
            b: n,
            c: e
        };
    }), Nu = function(r) {
        return {
            $: 17,
            a: r
        };
    }, Zu = function(r) {
        return {
            $: 16,
            a: r
        };
    }, Du = {
        $: 18
    }, _u = function(r) {
        return {
            $: 8,
            a: r
        };
    }, Ou = function(r) {
        return {
            $: 9,
            a: r
        };
    }, qu = function(r) {
        return {
            $: 4,
            a: r
        };
    }, Ku = function(r) {
        return {
            $: 5,
            a: r
        };
    }, Uu = F2(function(r, n) {
        return {
            $: 2,
            a: r,
            b: n
        };
    }), Bu = F2(function(r, n) {
        return {
            $: 3,
            a: r,
            b: n
        };
    }), Qu = F2(function(r, n) {
        return {
            $: 0,
            a: r,
            b: n
        };
    }), Yu = F2(function(r, n) {
        return {
            $: 1,
            a: r,
            b: n
        };
    }), Ju = function(r) {
        return {
            $: 10,
            a: r
        };
    }, Xu = function(r) {
        return {
            $: 11,
            a: r
        };
    }, rc = function(r) {
        return {
            $: 14,
            a: r
        };
    }, nc = function(r) {
        return {
            $: 12,
            a: r
        };
    }, ec = function(r) {
        return {
            $: 13,
            a: r
        };
    }, tc = function(r) {
        return {
            $: 15,
            a: r
        };
    }, ac = function(r) {
        return {
            $: 6,
            a: r
        };
    }, uc = function(r) {
        return {
            $: 7,
            a: r
        };
    }, cc = F2(function(r, n) {
        var e, t, a, u, c = function(n) {
            return A2(aa, function(n) {
                var e = n.b;
                return i(r(n.a), r(e));
            }, n);
        };
        switch(n.$){
            case 0:
                var o = n.b;
                return A2(Qu, r(n.a), r(o));
            case 1:
                return o = n.b, A2(Yu, r(n.a), r(o));
            case 2:
                return o = n.b, A2(Uu, r(n.a), r(o));
            case 3:
                return o = n.b, A2(Bu, r(n.a), r(o));
            case 4:
                return qu(r(n.a));
            case 5:
                return Ku(r(n.a));
            case 6:
                return ac(r(n.a));
            case 7:
                return uc(r(n.a));
            case 8:
                var f = n.a.co, l = n.a.al;
                return _u({
                    cn: i(r((b = n.a.cn).a), r(b.b)),
                    co: i(r(f.a), r(f.b)),
                    al: i(r(l.a), r(l.b))
                });
            case 9:
                var b;
                return f = n.a.co, l = n.a.al, Ou({
                    cn: i(r((b = n.a.cn).a), r(b.b)),
                    co: i(r(f.a), r(f.b)),
                    al: i(r(l.a), r(l.b))
                });
            case 10:
                return l = n.a.al, Ju({
                    cm: i(r((d = n.a.cm).a), r(d.b)),
                    al: i(r(l.a), r(l.b))
                });
            case 11:
                var d;
                return l = n.a.al, Xu({
                    cm: i(r((d = n.a.cm).a), r(d.b)),
                    al: i(r(l.a), r(l.b))
                });
            case 12:
                return nc(c(n.a));
            case 13:
                return ec(c(n.a));
            case 14:
                return rc(c(n.a));
            case 15:
                return tc(c(n.a));
            case 16:
                return Zu((e = (v = n.a).iT, t = v.iS, a = v.cZ, u = v.cR, s(v, {
                    cx: r(v.cx),
                    cR: r(u),
                    cZ: r(a),
                    iS: r(t),
                    iT: r(e)
                })));
            case 17:
                var v = n.a;
                return Nu(function() {
                    var n = v.iT, e = v.iS, t = v.cZ, a = v.cR;
                    return s(v, {
                        cx: r(v.cx),
                        cR: r(a),
                        cZ: r(t),
                        iS: r(e),
                        iT: r(n)
                    });
                }());
            default:
                return Du;
        }
    }), oc = F2(function(r, n) {
        switch(n.$){
            case 0:
                return A2(zu, n.a, n.b);
            case 1:
                var e = n.c, t = n.d, a = n.e;
                return A5(Eu, n.a, r(n.b), r(e), r(t), r(a));
            case 2:
                var u = n.c, c = u.eT, o = u.ga, f = u.aj, s = u.ai, l = u.fO, b = u.aa, d = u.fm;
                return A3(Iu, n.a, n.b, {
                    bs: r(u.bs),
                    fm: r(d),
                    aa: r(b),
                    fO: r(l),
                    ai: r(s),
                    aj: r(f),
                    ga: r(o),
                    eT: r(c)
                });
            case 3:
                return A2(Wu, n.a, r(n.b));
            case 4:
                return e = n.c, A3(Pu, n.a, r(n.b), r(e));
            case 5:
                return e = n.c, t = n.d, A4(Lu, n.a, r(n.b), r(e), r(t));
            case 6:
                return e = n.c, t = n.d, a = n.e, A5(Gu, n.a, r(n.b), r(e), r(t), r(a));
            case 7:
                return A2(Su, n.a, r(n.b));
            case 8:
                return Vu(A2(aa, function(n) {
                    var e = n.b;
                    return i(r(n.a), r(e));
                }, n.a));
            default:
                var v = n.a;
                return Ru(A2(aa, cc(r), v));
        }
    }), ic = function(r) {
        var n = function(r) {
            var n, e = ju({
                gX: 26,
                io: 170
            });
            switch(r.$){
                case 0:
                case 2:
                case 3:
                case 4:
                case 6:
                case 8:
                default:
                    return e;
                case 1:
                    return n = du(400), Fu({
                        fF: n,
                        fG: Vt,
                        kO: 1,
                        gf: 0
                    });
                case 5:
                    return "rotate3d" === r.a ? Tu({
                        hU: Hu
                    }) : e;
                case 7:
                    return Tu({
                        hU: Hu
                    });
            }
        }(r);
        return A2(oc, function(r) {
            return s(r, {
                bJ: n
            });
        }, r);
    }, fc = F2(function(r, n) {
        return A3(ta, F2(function(n, e) {
            return r(n) ? A2(ye, n, e) : e;
        }), b, n);
    }), sc = function(r) {
        return r.b ? Ve(r.a) : We;
    }, lc = F2(function(r, n) {
        for(;;){
            if (!n.b) return !1;
            var e = n.b;
            if (r(n.a)) return !0;
            n = e;
        }
    }), bc = F2(function(r, n) {
        return A2(lc, function(n) {
            return e(n, r);
        }, n);
    }), dc = function(r) {
        switch(r.$){
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                return r.a;
            case 8:
                return "points";
            default:
                return "path";
        }
    }, vc = function(r) {
        return !r;
    }, mc = $, gc = function(r) {
        var n;
        return n = m(r ? [
            A3(Mu, 1, 0, 1)
        ] : [
            A3(Mu, 1, 1, 1)
        ]), {
            fU: b,
            eN: !1,
            $9: b,
            iq: A2(aa, ic, n),
            iy: {
                gU: du(0),
                jz: du(0)
            }
        };
    }, pc = function(r) {
        return zt(gc(r));
    }, $c = function(r) {
        var n = function() {
            switch(r){
                case "Assigned Seats | Viewing Activity":
                    return 0;
                case "User Engagement":
                    return 1;
                case "Assignments | Labs & Exams":
                    return 2;
                case "Recently Added Courses":
                    return 3;
                default:
                    return 4;
            }
        }();
        return zt(n);
    }, hc = or, wc = X, Cc = A5(hc, yu, A2(tu, "collapsed", wu), A2(tu, "order", au), A2(xu, $c, A2(tu, "title", wc)), A2(xu, pc, A2(tu, "collapsed", wu))), kc = A7(ku, Cu, A2(tu, "seatsRow", Cc), A2(tu, "engagementRow", Cc), A2(tu, "assignmentRow", Cc), A2(tu, "recentlyAddedRow", Cc), A2(tu, "completionsRow", Cc), zt(!0)), yc = Vt, xc = A2(St, yc, wc), Lc = {
        aU: A4(yu, !1, 2, 2, gc(!1)),
        aZ: A4(yu, !1, 4, 4, gc(!1)),
        a7: A4(yu, !1, 1, 1, gc(!1)),
        en: !0,
        bi: A4(yu, !1, 3, 3, gc(!1)),
        bj: A4(yu, !1, 0, 0, gc(!1))
    }, jc = function(r) {
        return cu(m([
            A2(St, Ve, r),
            zt(We)
        ]));
    }, Ac = A2(hu, A2(tu, "onboardToggle", jc(wu)), A2(hu, A2(tu, "thumbnailACILearning", wc), A2(hu, A2(tu, "dashboardConfig", cu(m([
        kc,
        zt(Lc)
    ]))), A2(hu, A2(tu, "appSite", xc), A2(hu, A2(tu, "features", jc(wc)), A2(hu, A2(tu, "zendeskToken", jc(wc)), A2(hu, A2(tu, "hasInsights", jc(wu)), A2(hu, A2(tu, "customerSuccess", jc(wu)), A2(hu, A2(tu, "token", jc(wc)), zt($u)))))))))), Mc = "https://app.acilearning.com", Fc = {
        $: 4
    }, Hc = function(r) {
        return {
            $: 17,
            a: r
        };
    }, Tc = function(r) {
        return {
            $: 1,
            a: r
        };
    }, Sc = {
        $: 2
    }, Ec = function(r) {
        return {
            $: 0,
            a: r
        };
    }, zc = function(r) {
        return {
            $: 4,
            a: r
        };
    }, Rc = function(r) {
        return {
            $: 6,
            a: r
        };
    }, Vc = {
        $: 0
    }, Wc = function(r) {
        return {
            $: 19,
            a: r
        };
    }, Pc = function(r) {
        return {
            $: 11,
            a: r
        };
    }, Gc = {
        $: 0
    }, Ic = {
        fD: {
            f$: 0,
            ef: 0,
            f9: {
                bI: 0,
                be: 0,
                bm: 0,
                fh: 0
            }
        },
        bL: !1
    }, Nc = F3(function(r, n, e) {
        return {
            cd: 3,
            by: r,
            cr: 1,
            fN: n,
            bG: e,
            dV: We,
            h3: 2,
            bX: We,
            cT: !1,
            eG: Ic,
            V: Gc,
            aP: We,
            c7: b
        };
    }), Zc = {
        $: 0
    }, Dc = F2(function(r, n) {
        return {
            by: r,
            E: n,
            kq: "",
            bT: We,
            bU: Zc
        };
    }), _c = {
        $: 0
    }, Oc = F2(function(r, n) {
        return {
            by: r,
            E: n,
            b2: We,
            eY: _c
        };
    }), qc = {
        Z: "#f4b43a",
        _: "#1b1b1a",
        aC: "8px",
        ad: "#262937",
        ae: "#ffffff",
        Q: "",
        am: "#262937",
        an: "#ffffff",
        cb: ""
    }, Kc = F2(function(r, n) {
        return {
            as: 3,
            by: r,
            cw: n,
            gp: "",
            n: Ve(qc)
        };
    }), Uc = {
        $: 0
    }, Bc = {
        $: 0
    }, Qc = {
        $: 0
    }, Yc = {
        $: 0
    }, Jc = {
        i4: 0,
        jC: "",
        jM: "",
        ka: "",
        il: Yc,
        lg: We
    }, Xc = function(r) {
        return function(r) {
            return {
                jW: r,
                j5: !1
            };
        }(r);
    }, ro = function(r) {
        return {
            ar: We,
            $7: Jc,
            aT: We,
            by: r,
            a_: Ve(0),
            g2: Xc("filterDropdown"),
            dG: Uc,
            dX: 0,
            cD: !1,
            aK: Qc,
            cY: We,
            c0: Xc("teamsDropdown"),
            c1: We,
            eY: _c,
            f: Bc,
            c7: b
        };
    }, no = F5(function(r, n, e, t, a) {
        return {
            ba: t,
            bf: e,
            aQ: n,
            fe: a,
            bo: r
        };
    }), eo = function(r) {
        return r.b && ("" !== r.a || r.b.b) ? A2(ye, r.a, eo(r.b)) : b;
    }, to = F2(function(r, n) {
        return Ve(1 === n.$ ? m([
            r
        ]) : A2(ye, r, n.a));
    }), ao = function(r) {
        try {
            return Ve(decodeURIComponent(r));
        } catch (r) {
            return We;
        }
    }, uo = o, co = F2(function(r, n) {
        r: for(;;){
            if (-2 === n.$) return We;
            var e = n.c, t = n.d, a = n.e;
            switch(A2(uo, r, n.b)){
                case 0:
                    n = t;
                    continue r;
                case 1:
                    return Ve(e);
                default:
                    n = a;
                    continue r;
            }
        }
    }), oo = F5(function(r, n, e, t, a) {
        return {
            $: -1,
            a: r,
            b: n,
            c: e,
            d: t,
            e: a
        };
    }), io = {
        $: -2
    }, fo = F5(function(r, n, e, t, a) {
        if (-1 !== a.$ || a.a) {
            if (-1 !== t.$ || t.a || -1 !== t.d.$ || t.d.a) return A5(oo, r, n, e, t, a);
            var u = t.d;
            return c = t.e, A5(oo, 0, t.b, t.c, A5(oo, 1, u.b, u.c, u.d, u.e), A5(oo, 1, n, e, c, a));
        }
        var c, o = a.b, i = a.c, f = a.d, s = a.e;
        return -1 !== t.$ || t.a ? A5(oo, r, o, i, A5(oo, 0, n, e, t, f), s) : A5(oo, 0, n, e, A5(oo, 1, t.b, t.c, t.d, c = t.e), A5(oo, 1, o, i, f, s));
    }), so = F3(function(r, n, e) {
        if (-2 === e.$) return A5(oo, 0, r, n, io, io);
        var t = e.a, a = e.b, u = e.c, c = e.d, o = e.e;
        switch(A2(uo, r, a)){
            case 0:
                return A5(fo, t, a, u, A3(so, r, n, c), o);
            case 1:
                return A5(oo, t, a, n, c, o);
            default:
                return A5(fo, t, a, u, c, A3(so, r, n, o));
        }
    }), lo = F3(function(r, n, e) {
        var t = A3(so, r, n, e);
        return -1 !== t.$ || t.a ? t : A5(oo, 1, t.b, t.c, t.d, t.e);
    }), bo = function(r) {
        if (-1 === r.$ && -1 === r.d.$ && -1 === r.e.$) {
            if (-1 !== r.e.d.$ || r.e.d.a) {
                var n = r.d, e = r.e;
                return c = e.b, o = e.c, t = e.d, s = e.e, A5(oo, 1, r.b, r.c, A5(oo, 0, n.b, n.c, n.d, n.e), A5(oo, 0, c, o, t, s));
            }
            var t, a = r.d, u = r.e, c = u.b, o = u.c, i = (t = u.d).d, f = t.e, s = u.e;
            return A5(oo, 0, t.b, t.c, A5(oo, 1, r.b, r.c, A5(oo, 0, a.b, a.c, a.d, a.e), i), A5(oo, 1, c, o, f, s));
        }
        return r;
    }, vo = function(r) {
        if (-1 === r.$ && -1 === r.d.$ && -1 === r.e.$) {
            if (-1 !== r.d.d.$ || r.d.d.a) {
                var n = r.d, e = r.e;
                return f = e.b, s = e.c, l = e.d, b = e.e, A5(oo, 1, t = r.b, a = r.c, A5(oo, 0, n.b, n.c, n.d, o = n.e), A5(oo, 0, f, s, l, b));
            }
            var t = r.b, a = r.c, u = r.d, c = u.d, o = u.e, i = r.e, f = i.b, s = i.c, l = i.d, b = i.e;
            return A5(oo, 0, u.b, u.c, A5(oo, 1, c.b, c.c, c.d, c.e), A5(oo, 1, t, a, o, A5(oo, 0, f, s, l, b)));
        }
        return r;
    }, mo = F7(function(r, n, e, t, a, u, c) {
        if (-1 !== u.$ || u.a) {
            r: for(;;){
                if (-1 === c.$ && 1 === c.a) {
                    if (-1 === c.d.$) {
                        if (1 === c.d.a) return vo(n);
                        break r;
                    }
                    return vo(n);
                }
                break r;
            }
            return n;
        }
        return A5(oo, e, u.b, u.c, u.d, A5(oo, 0, t, a, u.e, c));
    }), go = function(r) {
        if (-1 === r.$ && -1 === r.d.$) {
            var n = r.a, e = r.b, t = r.c, a = r.d, u = a.d, c = r.e;
            if (1 === a.a) {
                if (-1 !== u.$ || u.a) {
                    var o = bo(r);
                    if (-1 === o.$) {
                        var i = o.e;
                        return A5(fo, o.a, o.b, o.c, go(o.d), i);
                    }
                    return io;
                }
                return A5(oo, n, e, t, go(a), c);
            }
            return A5(oo, n, e, t, go(a), c);
        }
        return io;
    }, po = F2(function(r, n) {
        if (-2 === n.$) return io;
        var e = n.a, t = n.b, a = n.c, u = n.d, o = n.e;
        if (0 > c(r, t)) {
            if (-1 === u.$ && 1 === u.a) {
                var i = u.d;
                if (-1 !== i.$ || i.a) {
                    var f = bo(n);
                    if (-1 === f.$) {
                        var s = f.e;
                        return A5(fo, f.a, f.b, f.c, A2(po, r, f.d), s);
                    }
                    return io;
                }
                return A5(oo, e, t, a, A2(po, r, u), o);
            }
            return A5(oo, e, t, a, A2(po, r, u), o);
        }
        return A2($o, r, A7(mo, r, n, e, t, a, u, o));
    }), $o = F2(function(r, n) {
        if (-1 === n.$) {
            var t = n.a, a = n.b, u = n.c, c = n.d, o = n.e;
            if (e(r, a)) {
                var i = function(r) {
                    for(;;){
                        if (-1 !== r.$ || -1 !== r.d.$) return r;
                        r = r.d;
                    }
                }(o);
                return -1 === i.$ ? A5(fo, t, i.b, i.c, c, go(o)) : io;
            }
            return A5(fo, t, a, u, c, A2(po, r, o));
        }
        return io;
    }), ho = F2(function(r, n) {
        var e = A2(po, r, n);
        return -1 !== e.$ || e.a ? e : A5(oo, 1, e.b, e.c, e.d, e.e);
    }), wo = F3(function(r, n, e) {
        var t = n(A2(co, r, e));
        return t.$ ? A2(ho, r, e) : A3(lo, r, t.a, e);
    }), Co = F2(function(r, n) {
        var e = A2(Ze, "=", r);
        if (e.b && e.b.b && !e.b.b.b) {
            var t = e.b.a, a = ao(e.a);
            if (1 === a.$) return n;
            var u = a.a, c = ao(t);
            return 1 === c.$ ? n : A3(wo, u, to(c.a), n);
        }
        return n;
    }), ko = io, yo = F2(function(r, n) {
        var e;
        return function(r) {
            r: for(;;){
                if (r.b) {
                    var n = r.a, e = n.aQ;
                    if (e.b) {
                        if ("" !== e.a || e.b.b) {
                            r = r.b;
                            continue r;
                        }
                        return Ve(n.fe);
                    }
                    return Ve(n.fe);
                }
                return We;
            }
        }(r(A5(no, b, function(r) {
            var n = A2(Ze, "/", r);
            return eo(n.b && "" === n.a ? n.b : n);
        }(n.hT), 1 === (e = n.h0).$ ? ko : A3(ta, Co, ko, A2(Ze, "&", e.a)), n.ha, Vt)));
    }), xo = {
        $: 2
    }, Lo = F3(function(r, n, e) {
        return {
            $: 4,
            a: r,
            b: n,
            c: e
        };
    }), jo = F2(function(r, n) {
        return {
            $: 3,
            a: r,
            b: n
        };
    }), Ao = function(r) {
        return {
            $: 1,
            a: r
        };
    }, Mo = {
        $: 0
    }, Fo = F2(function(r, n) {
        return A5(no, n.bo, n.aQ, n.bf, n.ba, r(n.fe));
    }), Ho = F2(function(r, n) {
        var e = n;
        return function(n) {
            var t = n.bo, a = n.aQ, u = n.bf, c = n.ba;
            return A2(aa, Fo(n.fe), e(A5(no, t, a, u, c, r)));
        };
    }), To = F2(function(r, n) {
        return function(r) {
            var e = r.bo, t = r.aQ, a = r.bf, u = r.ba, c = r.fe;
            if (t.b) {
                var o = t.a, i = t.b, f = n(o);
                if (f.$) return b;
                var s = f.a;
                return m([
                    A5(no, A2(ye, o, e), i, a, u, c(s))
                ]);
            }
            return b;
        };
    }), So = A2(To, "STRING", Ve), Eo = A2(Ho, Vt, So), zo = Vt, Ro = A2(Ho, zo, So), Vo = {
        $: 15
    }, Wo = function(r) {
        return {
            $: 3,
            a: r
        };
    }, Po = {
        $: 9
    }, Go = function(r) {
        return {
            $: 4,
            a: r
        };
    }, Io = {
        $: 6
    }, No = {
        $: 18
    }, Zo = {
        $: 17
    }, Do = function(r) {
        return {
            $: 12,
            a: r
        };
    }, _o = {
        $: 13
    }, Oo = function(r) {
        return {
            $: 1,
            a: r
        };
    }, qo = {
        $: 0
    }, Ko = {
        $: 16
    }, Uo = function(r) {
        return {
            $: 10,
            a: r
        };
    }, Bo = {
        $: 19
    }, Qo = function(r) {
        return {
            $: 5,
            a: r
        };
    }, Yo = F2(function(r, n) {
        return {
            $: 8,
            a: r,
            b: n
        };
    }), Jo = {
        $: 14
    }, Xo = function(r) {
        return {
            $: 11,
            a: r
        };
    }, ri = function(r) {
        return {
            $: 2,
            a: r
        };
    }, ni = function(r) {
        return {
            $: 7,
            a: r
        };
    }, ei = A2(Ho, Vt, So), ti = A2(Ho, Vt, So), ai = F2(function(r, n) {
        return n.b ? A3(ta, ye, n, r) : r;
    }), ui = function(r) {
        return A3(ta, ai, b, r);
    }, ci = F2(function(r, n) {
        return ui(A2(aa, r, n));
    }), oi = function(r) {
        return function(n) {
            return A2(ci, function(r) {
                return r(n);
            }, r);
        };
    }, ii = function(r) {
        return function(n) {
            var t = n.bo, a = n.aQ, u = n.bf, c = n.ba, o = n.fe;
            if (a.b) {
                var i = a.a, f = a.b;
                return e(i, r) ? m([
                    A5(no, A2(ye, i, t), f, u, c, o)
                ]) : b;
            }
            return b;
        };
    }, fi = F2(function(r, n) {
        var e = r, t = n;
        return function(r) {
            return A2(ci, t, e(r));
        };
    }), si = le, li = se, bi = /.^/, di = F2(function(r, n) {
        return n.$ ? r : n.a;
    }), vi = A2(di, bi, A2(li, {
        jf: !1,
        ku: !1
    }, "^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[1-5][0-9A-Fa-f]{3,3}-[8-9A-Ba-b][0-9A-Fa-f]{3,3}-[0-9A-Fa-f]{12,12}$")), mi = function(r) {
        return r.toLowerCase();
    }, gi = function(r) {
        return A2(si, vi, r) ? Ve(mi(r)) : We;
    }, pi = A2(To, "UUID", gi), $i = A2(Ho, Vt, pi), hi = A2(Ho, Vt, So), wi = oi(m([
        A2(Ho, qo, A2(fi, ii("modules"), ii("new"))),
        A2(Ho, Oo, A2(fi, ii("modules"), ti)),
        A2(Ho, ri, A2(fi, ii("modules"), A2(fi, ti, ii("update")))),
        A2(Ho, Wo, A2(fi, ii("modules"), A2(fi, ti, ii("clone")))),
        A2(Ho, Go, A2(fi, ii("modules"), A2(fi, ti, ii("create-new-assignment")))),
        A2(Ho, Qo, A2(fi, ii("team"), $i)),
        A2(Ho, Io, A2(fi, ii("team"), ii("new"))),
        A2(Ho, ni, A2(fi, ii("team"), A2(fi, $i, ii("update")))),
        A2(Ho, Yo, A2(fi, ii("team"), A2(fi, $i, A2(fi, ii("member-activity"), hi)))),
        A2(Ho, Po, A2(fi, ii("reports"), ii("new"))),
        A2(Ho, Uo, A2(fi, ii("reports"), A2(fi, ei, ii("schedule")))),
        A2(Ho, Xo, A2(fi, ii("reports"), A2(fi, ei, ii("update")))),
        A2(Ho, Do, A2(fi, ii("user"), hi)),
        A2(Ho, _o, ii("users")),
        A2(Ho, Jo, ii("teams")),
        A2(Ho, Vo, ii("assignments")),
        A2(Ho, Ko, ii("reports")),
        A2(Ho, Zo, A2(fi, ii("users"), ii("learning-reminders"))),
        A2(Ho, No, ii("dashboard")),
        A2(Ho, Bo, ii("settings"))
    ])), Ci = A2(Ho, Vt, pi), ki = function(r) {
        return m([
            r
        ]);
    }, yi = oi(m([
        A2(Ho, xo, ii("companies")),
        A2(Ho, jo, A2(fi, ii("enterpriseGrants"), A2(fi, Ro, wi))),
        A2(Ho, Lo, A2(fi, ii("company"), A2(fi, Eo, A2(fi, ii("enterpriseGrants"), A2(fi, Ro, wi))))),
        A2(Ho, Ao, A2(fi, ii("account-setup"), Ci)),
        A2(Ho, Mo, ki)
    ])), xi = 4294967295 >>> 32 - dt, Li = k, ji = F3(function(r, n, e) {
        for(;;){
            var t = A2(Li, xi & n >>> r, e);
            if (t.$) return A2(Li, xi & n, t.a);
            r -= dt, e = t.a;
        }
    }), Ai = function(r) {
        return r >>> 5 << 5;
    }, Mi = F2(function(r, n) {
        var e = n.a, t = n.b, a = n.c, u = n.d;
        return 0 > r || c(r, e) > -1 ? We : c(r, Ai(e)) > -1 ? Ve(A2(Li, xi & r, u)) : Ve(A3(ji, t, r, a));
    }), Fi = {
        bR: We,
        hQ: A3(F3(function(r, n, e) {
            return {
                cQ: r,
                il: n,
                $9: e
            };
        }), !1, 1, b)
    }, Hi = F3(function(r, n, e) {
        return {
            fj: n,
            gB: We,
            by: r,
            bG: e,
            bU: A2(Dc, r, e.jW)
        };
    }), Ti = L, Si = F2(function(r, n) {
        var e = n.d, t = function(n) {
            return n.$ ? gt(A2(Ti, r, n.a)) : yt(A2(Ti, t, n.a));
        };
        return A4(it, n.a, n.b, A2(Ti, t, n.c), A2(Ti, r, e));
    }), Ei = F8(function(r, n, e, t, a, u, c, o) {
        var f = {
            i9: Ve(!0),
            kb: We,
            iK: ""
        }, s = function(r) {
            var n = i(Sc, Vc), e = A2(yo, yi, r);
            r: for(; !e.$;)switch(e.a.$){
                case 3:
                    switch(e.a.b.$){
                        case 13:
                            return i(zc(ro(Vc)), Vc);
                        case 14:
                            return i(Pc(A2(Oc, Vc, a = e.a.a)), Vc);
                        case 15:
                            return i(Rc(A2(Dc, Vc, a = e.a.a)), Vc);
                        case 16:
                            return i(Hc(A3(Nc, Vc, We, Ec(a = e.a.a))), Vc);
                        case 19:
                            return i(Wc(A2(Kc, Vc, a = e.a.a)), Vc);
                        default:
                            return n;
                    }
                case 4:
                    switch(e.a.c.$){
                        case 13:
                            return i(zc(ro(Tc(f = e.a.a))), Tc(f));
                        case 14:
                            var t = e.a, a = t.b;
                            return i(Pc(A2(Oc, Tc(f = t.a), a)), Tc(f));
                        case 15:
                            var u = e.a;
                            return a = u.b, i(Rc(A2(Dc, Tc(f = u.a), a)), Tc(f));
                        case 16:
                            var c = e.a;
                            return a = c.b, i(Hc(A3(Nc, Tc(f = c.a), We, Ec(a))), Tc(f));
                        case 19:
                            var o = e.a;
                            return a = o.b, i(Wc(A2(Kc, Tc(f = o.a), a)), Tc(f));
                        default:
                            var f;
                            return i(Sc, Tc(f = e.a.a));
                    }
                default:
                    break r;
            }
            return n;
        }(e), l = s.a, b = s.b, d = A2(Si, A2(Hi, b, Fc), a);
        return {
            fk: n,
            gy: 3,
            by: b,
            gQ: u,
            gW: A2(Mi, 0, d),
            jt: c,
            g2: Xc("filterSubscriptions"),
            fI: d,
            g8: We,
            he: 3,
            hf: !1,
            hr: r,
            hy: t,
            hQ: We,
            hR: 1,
            kK: l,
            h9: We,
            ih: Fi,
            it: 3,
            gn: o,
            iJ: f
        };
    }), zi = F5(function(r, n, e, t, a) {
        return 1 === n.$ || 1 === e.$ || 1 === t.$ || 1 === a.$ ? We : Ve(A4(r, n.a, e.a, t.a, a.a));
    }), Ri = function(r) {
        return {
            $: 12,
            a: r
        };
    }, Vi = function(r) {
        return {
            $: 9,
            a: r
        };
    }, Wi = function(r) {
        return {
            $: 0,
            a: r
        };
    }, Pi = function(r) {
        return {
            $: 6,
            a: r
        };
    }, Gi = function(r) {
        return {
            $: 43,
            a: r
        };
    }, Ii = F4(function(r, n, e, t) {
        return {
            $: 3,
            a: r,
            b: n,
            c: e,
            d: t
        };
    }), Ni = kr, Zi = Xr("call", Vt), Di = function(r) {
        return A3(_e, F2(function(r, n) {
            return A3(yr, r.a, r.b, n);
        }), {}, r);
    }, _i = kr, Oi = function(r) {
        var n = "message", e = function() {
            switch(r.$){
                case 0:
                    return Di(m([
                        i(n, _i("RECAPTCHA_RENDER"))
                    ]));
                case 1:
                    return Di(m([
                        i(n, _i("RECAPTCHA_EXECUTE"))
                    ]));
                case 2:
                    return Di(m([
                        i(n, _i("RECAPTCHA_RESET"))
                    ]));
                default:
                    var e = r.a, t = r.b, a = r.c, u = r.d;
                    return Di(m([
                        i(n, _i("SET_LOGIN_VARIABLES")),
                        i("token", _i(e)),
                        i("customerSuccess", Ni(t)),
                        i("hasInsights", Ni(a)),
                        i("zendeskToken", _i(u))
                    ]));
            }
        }();
        return Zi(e);
    }, qi = F3(function(r, n, e) {
        return {
            i9: n,
            kb: e,
            iK: r
        };
    }), Ki = A2(St, Vt, wc), Ui = cr, Bi = A4(Ui, qi, zt(""), jc(A2(tu, "bannerConfig", wu)), jc(A2(tu, "lastSelectedEnterpriseGrant", Ki))), Qi = F2(function(r, n) {
        return {
            $: 3,
            a: r,
            b: n
        };
    }), Yi = function(r) {
        return {
            $: 0,
            a: r
        };
    }, Ji = F2(function(r, n) {
        return {
            $: 4,
            a: r,
            b: n
        };
    }), Xi = {
        $: 2
    }, rf = function(r) {
        return {
            $: 1,
            a: r
        };
    }, nf = function(r) {
        return {
            $: 0,
            a: r
        };
    }, ef = {
        $: 1
    }, tf = function(r) {
        return !r.$;
    }, af = Dr, uf = F2(function(r, n) {
        return A3(ve, "", Vt, A2(wa, n, r));
    }), cf = function(r) {
        return {
            $: 4,
            a: r
        };
    }, of = {
        $: 2
    }, ff = {
        $: 1
    }, sf = F2(function(r, n) {
        switch(n.$){
            case 0:
                return Fe({
                    $: 0,
                    a: n.a
                });
            case 1:
                return Fe(ff);
            case 2:
                return Fe(of);
            case 3:
                return Fe({
                    $: 3,
                    a: n.a.k6
                });
            default:
                return A2(Ha, cf, r(n.b));
        }
    }), lf = F2(function(r, n) {
        return A2(uf, r, sf(function(r) {
            return A2(Ha, ut, A2(Ca, n, r));
        }));
    }), bf = {
        $: 0
    }, df = F2(function(r, n) {
        return {
            $: 0,
            a: r,
            b: n
        };
    }), vf = function(r) {
        return r;
    }, mf = A2(wa, aa(vf), A2(wa, Ne("/"), Vt)), gf = mf(A2(aa, Vt, m([
        "api",
        "urza",
        "v3",
        "proportal"
    ]))), pf = W, $f = A2(wa, ye(gf), A2(wa, mf, A2(wa, vf, pf("/")))), hf = function(r) {
        return {
            $: 1,
            a: r
        };
    }, wf = F2(function(r, n) {
        return {
            h6: r,
            is: n
        };
    }), Cf = ra(A2(wf, ko, b)), kf = function(r) {
        return jr(function(n) {
            var e = r.f;
            2 === e.$ && e.c && e.c(), r.f = null, n(xr(0));
        });
    }, yf = Tr, xf = F3(function(r, n, e) {
        r: for(;;){
            if (n.b) {
                var t = n.a, a = n.b;
                if (t.$) {
                    var u = t.a;
                    return A2(ua, function(n) {
                        var t = u.gq;
                        return A3(xf, r, a, 1 === t.$ ? e : A3(lo, t.a, n, e));
                    }, yf(A3(be, r, fa(r), u)));
                }
                var c = t.a, o = A2(co, c, e);
                if (1 === o.$) {
                    n = a;
                    continue r;
                }
                return A2(ua, function() {
                    return A3(xf, r, a, A2(ho, c, e));
                }, kf(o.a));
            }
            return ra(e);
        }
    }), Lf = F4(function(r, n, e, t) {
        return A2(ua, function(r) {
            return ra(A2(wf, r, e));
        }, A3(xf, r, n, t.h6));
    }), jf = F3(function(r, n, e) {
        var t = r(n);
        return t.$ ? e : A2(ye, t.a, e);
    }), Af = F2(function(r, n) {
        return A3(ta, jf(r), b, n);
    }), Mf = F4(function(r, n, t, a) {
        var u = a.b;
        return e(n, a.a) ? Ve(A2(fa, r, u(t))) : We;
    }), Ff = F3(function(r, n, e) {
        return A2(ua, function() {
            return ra(e);
        }, ia(A2(Af, A3(Mf, r, n.a, n.b), e.is)));
    }), Hf = F2(function(r, n) {
        if (n.$) {
            var e = n.a;
            return hf({
                iW: e.iW,
                bv: e.bv,
                fJ: A2(me, r, e.fJ),
                bH: e.bH,
                bS: e.bS,
                b4: e.b4,
                gq: e.gq,
                b5: e.b5
            });
        }
        return {
            $: 0,
            a: n.a
        };
    }), Tf = F2(function(r, n) {
        return {
            $: 0,
            a: r,
            b: n
        };
    });
    Gr.Http = Ir(Cf, Lf, Ff, Hf, F2(function(r, n) {
        return A2(Tf, n.a, A2(wa, n.b, r));
    }));
    var Sf, Ef, zf = _r("Http"), Rf = (_r("Http"), function(r) {
        return zf(hf({
            iW: !1,
            bv: r.bv,
            fJ: r.fJ,
            bH: r.bH,
            bS: r.bS,
            b4: r.b4,
            gq: r.gq,
            b5: r.b5
        }));
    }), Vf = Ve(3e4), Wf = F3(function(r, n, e) {
        return Rf({
            bv: bf,
            fJ: e,
            bH: m([
                A2(df, "Authorization", "Bearer " + r)
            ]),
            bS: "GET",
            b4: Vf,
            gq: We,
            b5: $f(m([
                n
            ]))
        });
    }), Pf = F2(function(r, n) {
        return A3(Wf, r, "user-config", n);
    }), Gf = F2(function(r, n) {
        var e = Oi(A4(Ii, n.gp, n.js, n.jP, n.lv)), t = A2(Pf, n.gp, A2(lf, Gi, Bi));
        return i(s(r, {
            hy: Ve(n),
            kK: Sc
        }), ma(m([
            e,
            t
        ])));
    }), If = null, Nf = Xr("initLottie", function() {
        return If;
    }), Zf = function(r) {
        return A2(da, Xt, jr(function() {
            try {
                Bn.location = r;
            } catch (r) {
                cn.location.reload(!1);
            }
        }));
    }, Df = {
        $: 3
    }, _f = function(r) {
        return {
            $: 21,
            a: r
        };
    }, Of = function(r) {
        return {
            $: 3,
            a: r
        };
    }, qf = function(r) {
        return {
            $: 9,
            a: r
        };
    }, Kf = function(r) {
        return {
            $: 22,
            a: r
        };
    }, Uf = function(r) {
        return {
            $: 19,
            a: r
        };
    }, Bf = function(r) {
        return {
            $: 16,
            a: r
        };
    }, Qf = function(r) {
        return {
            $: 14,
            a: r
        };
    }, Yf = function(r) {
        return {
            $: 11,
            a: r
        };
    }, Jf = function(r) {
        return {
            $: 1,
            a: r
        };
    }, Xf = {
        $: 0
    }, rs = function(r) {
        return {
            $: 25,
            a: r
        };
    }, ns = function(r) {
        return {
            $: 1,
            a: r
        };
    }, es = function(r) {
        return {
            $: 1,
            a: r
        };
    }, ts = function(r) {
        return {
            $: 27,
            a: r
        };
    }, as = function(r) {
        return {
            $: 15,
            a: r
        };
    }, us = function(r) {
        return {
            $: 18,
            a: r
        };
    }, cs = {
        $: 6
    }, os = function(r) {
        return {
            $: 24,
            a: r
        };
    }, is = function(r) {
        return {
            $: 5,
            a: r
        };
    }, fs = function(r) {
        return {
            $: 7,
            a: r
        };
    }, ss = function(r) {
        return {
            $: 8,
            a: r
        };
    }, ls = function(r) {
        return {
            $: 10,
            a: r
        };
    }, bs = function(r) {
        return {
            $: 16,
            a: r
        };
    }, ds = function(r) {
        return {
            $: 7,
            a: r
        };
    }, vs = function(r) {
        return {
            $: 15,
            a: r
        };
    }, ms = function(r) {
        return {
            $: 8,
            a: r
        };
    }, gs = function(r) {
        return {
            $: 13,
            a: r
        };
    }, ps = function(r) {
        return {
            $: 42,
            a: r
        };
    }, $s = {
        $: 5
    }, hs = function(r) {
        return {
            $: 23,
            a: r
        };
    }, ws = {
        $: 8
    }, Cs = function(r) {
        return {
            $: 47,
            a: r
        };
    }, ks = function(r) {
        return {
            $: 12,
            a: r
        };
    }, ys = function(r) {
        return {
            $: 18,
            a: r
        };
    }, xs = function(r) {
        return {
            $: 13,
            a: r
        };
    }, Ls = {
        $: 2
    }, js = function(r) {
        return {
            $: 17,
            a: r
        };
    }, As = function(r) {
        return {
            $: 20,
            a: r
        };
    }, Ms = {
        $: 1
    }, Fs = function(r) {
        return {
            $: 38,
            a: r
        };
    }, Hs = {
        $: 37
    }, Ts = function(r) {
        return {
            $: 2,
            a: r
        };
    }, Ss = {
        $: 0
    }, Es = F2(function(r) {
        return r;
    }), zs = Lr, Rs = function(r) {
        return r.$ ? zs(r.a) : ra(r.a);
    }, Vs = function(r) {
        return A3(be, 0, Rs, {
            iW: !1,
            bv: r.bv,
            fJ: r.gc,
            bH: r.bH,
            bS: r.bS,
            b4: r.b4,
            gq: We,
            b5: r.b5
        });
    }, Ws = F5(function(r, n, e, t, a) {
        return Vs({
            bv: n,
            bH: m([
                A2(df, "Authorization", "Bearer " + e)
            ]),
            bS: r,
            gc: a,
            b4: Vf,
            b5: $f(m([
                t
            ]))
        });
    }), Ps = F2(function(r, n) {
        return {
            $: 4,
            a: r,
            b: n
        };
    }), Gs = F2(function(r, n) {
        return {
            $: 3,
            a: r,
            b: n
        };
    }), Is = function(r) {
        return {
            $: 0,
            a: r
        };
    }, Ns = {
        $: 2
    }, Zs = {
        $: 1
    }, Ds = F2(function(r, n) {
        switch(n.$){
            case 0:
                return Fe(Is(n.a));
            case 1:
                return Fe(Zs);
            case 2:
                return Fe(Ns);
            case 3:
                return Fe(A2(Gs, n.a, e = n.b));
            default:
                var e, t = A2(Ca, r, e = n.b);
                return t.$ ? Fe(A2(Ps, ut(t.a), e)) : Ee(t.a);
        }
    }), _s = A2(ve, "", Vt), Os = F5(function(r, n, e, t, a) {
        return A5(Ws, r, n, e, t, _s(Ds(a)));
    }), qs = function(r) {
        return A2(pe, "application/json", A2(Ge, 0, r));
    }, Ks = function(r) {
        return A2(Os, "POST", qs(r));
    }, Us = function(r) {
        return {
            $: 1,
            a: r
        };
    }, Bs = A2(xu, function(r) {
        switch(r){
            case "archived":
                return zt(0);
            case "notArchived":
                return zt(1);
            default:
                return Us("Invalid archival status: " + r);
        }
    }, wc), Qs = A2(St, Vt, uu), Ys = A4(Ui, F3(function(r, n, e) {
        return f(r, n, e);
    }), A2(tu, "beginsAtYear", uu), A2(tu, "beginsAtMonth", uu), A2(tu, "beginsAtDay", uu)), Js = Et($t), Xs = F3(function(r, n, e) {
        return {
            j3: r,
            kv: n,
            iI: e
        };
    }), rl = function(r) {
        return r.$ ? Us(r.a) : zt(r.a);
    }, nl = m([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16
    ]), el = F2(function(r, n) {
        return A3(_e, F2(function(n, e) {
            return A3(lo, r(n), n, e);
        }), ko, n);
    }), tl = function(r) {
        switch(r){
            case 0:
                return "allCourses";
            case 1:
                return "assessmentsIncluded";
            case 2:
                return "chatPostIncluded";
            case 3:
                return "chatViewIncluded";
            case 4:
                return "downloadAudioIncluded";
            case 5:
                return "downloadVideoIncluded";
            case 6:
                return "forumPostIncluded";
            case 7:
                return "freeCourses";
            case 8:
                return "freeInTagCategory";
            case 9:
                return "insightsIncluded";
            case 10:
                return "labsIncluded";
            case 11:
                return "liveViewIncluded";
            case 12:
                return "oneCourse";
            case 13:
                return "oneProductPackage";
            case 14:
                return "oneTag";
            case 15:
                return "oneTagCategory";
            default:
                return "testsIncluded";
        }
    }, al = function(r) {
        var n = A2(co, r, A2(el, tl, nl));
        return n.$ ? Fe("unknown ContentType: " + r) : Ee(n.a);
    }, ul = A2(xu, A2(wa, al, rl), wc), cl = A4(Ui, Xs, A2(tu, "isAddOn", wu), A2(tu, "name", wc), A2(tu, "type", ul)), ol = A2(St, Vt, wc), il = A4(Ui, F3(function(r, n, e) {
        return f(r, n, e);
    }), A2(tu, "expiresAtYear", uu), A2(tu, "expiresAtMonth", uu), A2(tu, "expiresAtDay", uu)), fl = A2(St, Vt, uu), sl = function(r) {
        return {
            $: 3,
            b: r
        };
    }, ll = jc(A2(St, Vt, wc)), bl = F3(function(r, n, e) {
        return A2(Js, A2(tu, r, n), e);
    }), dl = A2(St, Vt, wc), vl = function(r) {
        switch(r){
            case "SSOUser":
                return 0;
            case "SeatAdmin":
                return 1;
            case "CustomerSuccess":
                return 2;
            case "BillingAdmin":
                return 3;
            default:
                return 4;
        }
    }, ml = A2(St, vl, wc), gl = A3(bl, "userGroups", sl(ml), A3(bl, "userExternalId", dl, A3(bl, "archivalStatus", Bs, A3(bl, "contents", sl(cl), A2(Js, il, A2(Js, Ys, A3(bl, "productName", ll, A3(bl, "assignedSeatCount", Qs, A3(bl, "grantedSeatCount", fl, A3(bl, "externalId", ol, zt(function(r) {
        return function(n) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(u) {
                            return function(c) {
                                return function(o) {
                                    return function(i) {
                                        return function(f) {
                                            return {
                                                iY: o,
                                                i1: e,
                                                ja: a,
                                                jl: c,
                                                jH: u,
                                                jN: n,
                                                jW: r,
                                                kN: t,
                                                iK: i,
                                                lo: f
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))), pl = F2(function(r, n) {
        var e = mf(A2(aa, Vt, m([
            "enterprise-grant",
            n,
            "archive"
        ])));
        return A4(Ks, If, r, e, gl);
    }), $l = F3(function(r, n, e) {
        return r(n(e));
    }), hl = Mr, wl = F2(function(r, n) {
        return ba(A2(hl, A2($l, A2($l, ra, r), Fe), A2(ua, A2($l, A2($l, ra, r), Ee), n)));
    }), Cl = F4(function(r, n, e, t) {
        if (t.$) {
            var a = t.a;
            return 3 === a.$ && 403 === a.a.k6 ? e : n(a);
        }
        return r(t.a);
    }), kl = F2(function(r, n) {
        return A2(wl, A3(Cl, Es(Hs), A2($l, Fs, Ts), Fs(Ss)), A2(pl, r, n));
    }), yl = function(r) {
        return {
            $: 45,
            a: r
        };
    }, xl = function(r) {
        return {
            $: 46,
            a: r
        };
    }, Ll = Xr("logoutZendesk", function() {
        return If;
    }), jl = Ll(0), Al = function(r) {
        return r.a + "=" + r.b;
    }, Ml = function(r) {
        return r.b ? "?" + A2(Ne, "&", A2(aa, Al, r)) : "";
    }, Fl = F2(function(r, n) {
        return "/" + (A2(Ne, "/", r) + Ml(n));
    }), Hl = F3(function(r, n, e) {
        var t = function(r) {
            switch(r.$){
                case 0:
                    return m([
                        "dashboard"
                    ]);
                case 1:
                    return m([
                        "users"
                    ]);
                case 2:
                    return m([
                        "teams"
                    ]);
                case 3:
                    return m([
                        "assignments"
                    ]);
                case 4:
                    return m([
                        "modules",
                        "new"
                    ]);
                case 5:
                    return m([
                        "reports"
                    ]);
                case 6:
                    return m([
                        "users",
                        "learning-reminders"
                    ]);
                case 7:
                    return m([
                        "modules",
                        r.a
                    ]);
                default:
                    return m([
                        "settings"
                    ]);
            }
        }(r), a = l(m([
            "enterpriseGrants",
            e
        ]), t), u = n.$ ? l(m([
            "company",
            n.a
        ]), a) : a;
        return A2(Fl, u, b);
    }), Tl = "ACI Learning", Sl = function(r) {
        return {
            fk: r,
            kv: Tl
        };
    }, El = {
        $: 2
    }, zl = {
        $: 0
    }, Rl = {
        $: 1
    }, Vl = function(r) {
        return {
            $: 3,
            a: r
        };
    }, Wl = {
        $: 5
    }, Pl = {
        $: 2
    }, Gl = function(r) {
        return {
            $: 1,
            a: r
        };
    }, Il = function(r) {
        return {
            $: 18,
            a: r
        };
    }, Nl = function(r) {
        return {
            $: 17,
            a: r
        };
    }, Zl = function(r) {
        return {
            $: 19,
            a: r
        };
    }, Dl = function(r) {
        return {
            $: 27,
            a: r
        };
    }, _l = function(r) {
        return {
            $: 26,
            a: r
        };
    }, Ol = A2(Os, "GET", bf), ql = mf(m([
        "user-info"
    ])), Kl = A2(St, vl, wc), Ul = A2(tu, "userGroups", sl(Kl)), Bl = function(r) {
        return A3(Ol, r, ql, Ul);
    }, Ql = function(r) {
        var n = Bl(r), e = A3(Cl, _l, Es(Dl(We)), Dl(Ve(Ss)));
        return A2(wl, e, n);
    }, Yl = function(r) {
        return {
            $: 0,
            a: r
        };
    }, Jl = F3(function(r, n, e) {
        return 0 > c(e, r) ? r : c(e, n) > 0 ? n : e;
    }), Xl = u, rb = function(r) {
        return !A2(La, 4, r) && !!A2(La, 100, r) || !A2(La, 400, r);
    }, nb = F2(function(r, n) {
        var e = rb(r) ? 1 : 0;
        switch(n){
            case 0:
                return 0;
            case 1:
                return 31;
            case 2:
                return 59 + e;
            case 3:
                return 90 + e;
            case 4:
                return 120 + e;
            case 5:
                return 151 + e;
            case 6:
                return 181 + e;
            case 7:
                return 212 + e;
            case 8:
                return 243 + e;
            case 9:
                return 273 + e;
            case 10:
                return 304 + e;
            default:
                return 334 + e;
        }
    }), eb = F2(function(r, n) {
        return wt(r / n);
    }), tb = function(r) {
        var n = r - 1;
        return 365 * n + (A2(eb, n, 4) - A2(eb, n, 100) + A2(eb, n, 400));
    }, ab = F2(function(r, n) {
        switch(n){
            case 0:
            case 2:
            case 4:
            case 6:
            case 7:
            case 9:
            default:
                return 31;
            case 1:
                return rb(r) ? 29 : 28;
            case 3:
            case 5:
            case 8:
            case 10:
                return 30;
        }
    }), ub = F3(function(r, n, e) {
        return tb(r) + A2(nb, r, n) + A3(Jl, 1, A2(ab, r, n), e);
    }), cb = A3(ub, 1992, 4, 31), ob = F2(function(r, n) {
        return wt(r / n);
    }), ib = F3(function(r, n, e) {
        for(;;){
            if (!e.b) return n + r;
            var t = e.a, a = e.b;
            if (0 > c(t.gf, n)) return n + t.b;
            e = a;
        }
    }), fb = F2(function(r, n) {
        var e = r.b;
        return A3(ib, r.a, A2(ob, n, 6e4), e);
    }), sb = function(r) {
        var n = A2(ob, r, 1440) + 719468, e = (0 > n ? n - 146096 : n) / 146097 | 0, t = n - 146097 * e, a = (t - (t / 1460 | 0) + (t / 36524 | 0) - (t / 146096 | 0)) / 365 | 0, u = t - (365 * a + (a / 4 | 0) - (a / 100 | 0)), c = (5 * u + 2) / 153 | 0, o = c + (10 > c ? 3 : -9);
        return {
            gZ: u - ((153 * c + 2) / 5 | 0) + 1,
            hG: o,
            iU: a + 400 * e + (o > 2 ? 0 : 1)
        };
    }, lb = F2(function(r, n) {
        return sb(A2(fb, r, n)).gZ;
    }), bb = F2(function(r, n) {
        switch(sb(A2(fb, r, n)).hG){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }), db = F2(function(r, n) {
        return sb(A2(fb, r, n)).iU;
    }), vb = F2(function(r, n) {
        return A3(ub, A2(db, r, n), A2(bb, r, n), A2(lb, r, n));
    }), mb = jr(function(r) {
        r(xr(A2(bu, -(new Date).getTimezoneOffset(), b)));
    }), gb = A3(oa, vb, mb, vu), pb = i({
        P: Ve(cb),
        aG: !1,
        af: We,
        cQ: !1,
        aO: cb
    }, A2(da, Yl, gb)), $b = {
        $: 0
    }, hb = function(r) {
        return {
            $: 0,
            a: r
        };
    }, wb = function(r) {
        switch(r){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            case 6:
                return 7;
            case 7:
                return 8;
            case 8:
                return 9;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 12;
        }
    }, Cb = function(r) {
        switch(A2(kt, 1, r)){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }, kb = F3(function(r, n, e) {
        for(;;){
            var t = A2(ab, r, n), a = wb(n);
            if (a >= 12 || 0 >= c(e, t)) return {
                gZ: e,
                hG: n,
                iU: r
            };
            n = Cb(a + 1), e -= t;
        }
    }), yb = F2(function(r, n) {
        return i(A2(eb, r, n), A2(La, n, r));
    }), xb = function(r) {
        var n = A2(yb, r, 146097), e = n.a, t = A2(yb, n.b, 36524), a = t.a, u = A2(yb, t.b, 1461), c = u.a, o = A2(yb, u.b, 365);
        return 400 * e + 100 * a + 4 * c + o.a + (o.b ? 1 : 0);
    }, Lb = function(r) {
        var n = r, e = xb(n);
        return {
            f1: n - tb(e),
            iU: e
        };
    }, jb = function(r) {
        var n = Lb(r);
        return A3(kb, n.iU, 0, n.f1);
    }, Ab = A2(wa, jb, function(r) {
        return r.gZ;
    }), Mb = A2(wa, jb, function(r) {
        return r.hG;
    }), Fb = A2(wa, Mb, wb), Hb = A2(wa, Lb, function(r) {
        return r.f1;
    }), Tb = function(r) {
        return A2(pf, r, "");
    }, Sb = F3(function(r, n, e) {
        return r > 0 ? A3(Sb, r >> 1, l(n, n), 1 & r ? l(e, n) : e) : e;
    }), Eb = F2(function(r, n) {
        return A3(Sb, r, n, "");
    }), zb = F3(function(r, n, e) {
        return l(A2(Eb, r - It(e), Tb(n)), e);
    }), Rb = function(r) {
        return 0 > r ? -r : r;
    }, Vb = F2(function(r, n) {
        return l(0 > n ? "-" : "", A3(zb, r, "0", Ie(Rb(n))));
    }), Wb = function(r) {
        return (wb(r) + 2) / 3 | 0;
    }, Pb = A2(wa, Mb, Wb), Gb = F2(function(r, n) {
        return 1 > r ? "" : A3(Nt, -r, It(n), n);
    }), Ib = function(r) {
        return A2(La, 7, r) || 7;
    }, Nb = function(r) {
        var n = tb(r) + 4;
        return n - Ib(n);
    }, Zb = function(r) {
        switch(A2(kt, 1, r)){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            default:
                return 6;
        }
    }, Db = function(r) {
        var n = r, e = Ib(n), t = xb(n + (4 - e));
        return {
            iO: 1 + ((n - (Nb(t) + 1)) / 7 | 0),
            iP: t,
            lu: Zb(e)
        };
    }, _b = A2(wa, Db, function(r) {
        return r.iO;
    }), Ob = A2(wa, Db, function(r) {
        return r.iP;
    }), qb = A2(wa, Ib, Zb), Kb = F2(function(r, n) {
        return 0 > c(r, n) ? r : n;
    }), Ub = function(r) {
        return l(Ie(r), function(r) {
            var n = A2(La, 100, r);
            switch(A2(Kb, 20 > n ? n : A2(La, 10, n), 4)){
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        }(r));
    }, Bb = F4(function(r, n, e, t) {
        switch(n){
            case "y":
                return 2 === e ? A2(Gb, 2, A3(zb, 2, "0", Ie(xb(t)))) : A2(Vb, e, xb(t));
            case "Y":
                return 2 === e ? A2(Gb, 2, A3(zb, 2, "0", Ie(Ob(t)))) : A2(Vb, e, Ob(t));
            case "Q":
                switch(e){
                    case 1:
                    case 2:
                    case 5:
                        return Ie(Pb(t));
                    case 3:
                        return "Q" + Ie(Pb(t));
                    case 4:
                        return Ub(Pb(t));
                    default:
                        return "";
                }
            case "M":
                switch(e){
                    case 1:
                        return Ie(Fb(t));
                    case 2:
                        return A3(zb, 2, "0", Ie(Fb(t)));
                    case 3:
                        return r.eb(Mb(t));
                    case 4:
                        return r.fY(Mb(t));
                    case 5:
                        return A2(Ot, 1, r.eb(Mb(t)));
                    default:
                        return "";
                }
            case "w":
                switch(e){
                    case 1:
                        return Ie(_b(t));
                    case 2:
                        return A3(zb, 2, "0", Ie(_b(t)));
                    default:
                        return "";
                }
            case "d":
                switch(e){
                    case 1:
                        return Ie(Ab(t));
                    case 2:
                        return A3(zb, 2, "0", Ie(Ab(t)));
                    case 3:
                        return r.fB(Ab(t));
                    default:
                        return "";
                }
            case "D":
                switch(e){
                    case 1:
                        return Ie(Hb(t));
                    case 2:
                        return A3(zb, 2, "0", Ie(Hb(t)));
                    case 3:
                        return A3(zb, 3, "0", Ie(Hb(t)));
                    default:
                        return "";
                }
            case "E":
                switch(e){
                    case 1:
                    case 2:
                    case 3:
                        return r.bp(qb(t));
                    case 4:
                        return r.gs(qb(t));
                    case 5:
                        return A2(Ot, 1, r.bp(qb(t)));
                    case 6:
                        return A2(Ot, 2, r.bp(qb(t)));
                    default:
                        return "";
                }
            case "e":
                switch(e){
                    case 1:
                    case 2:
                        return Ie(Ib(t));
                    default:
                        return A4(Bb, r, "E", e, t);
                }
            default:
                return "";
        }
    }), Qb = F3(function(r, n, e) {
        return A3(_e, F2(function(n, t) {
            return l(n.$ ? n.a : A4(Bb, r, n.a, n.b, e), t);
        }), "", n);
    }), Yb = function(r) {
        return {
            $: 1,
            a: r
        };
    }, Jb = F2(function(r, n) {
        return {
            $: 1,
            a: r,
            b: n
        };
    }), Xb = F3(function(r, n, e) {
        return {
            $: 0,
            a: r,
            b: n,
            c: e
        };
    }), rd = F2(function(r, n) {
        var e = n;
        return function(n) {
            var t = e(n);
            if (1 === t.$) return A2(Jb, t.a, t.b);
            var a = t.a, u = t.c, c = r(t.b)(u);
            if (1 === c.$) {
                var o = c.a;
                return A2(Jb, a || o, c.b);
            }
            return o = c.a, A3(Xb, a || o, c.b, c.c);
        };
    }), nd = rd, ed = F3(function(r, n, e) {
        var t = n, a = e;
        return function(n) {
            var e = t(n);
            if (1 === e.$) return A2(Jb, e.a, e.b);
            var u = e.a, c = e.b, o = a(e.c);
            if (1 === o.$) {
                var i = o.a;
                return A2(Jb, u || i, o.b);
            }
            i = o.a;
            var f = o.c;
            return A3(Xb, u || i, A2(r, c, o.b), f);
        };
    }), td = F2(function(r, n) {
        return A3(ed, Es, r, n);
    }), ad = td, ud = function(r) {
        return function(n) {
            return A3(Xb, !1, r, n);
        };
    }, cd = F2(function(r, n) {
        return {
            $: 0,
            a: r,
            b: n
        };
    }), od = F2(function(r, n) {
        return {
            $: 1,
            a: r,
            b: n
        };
    }), id = F4(function(r, n, e, t) {
        return {
            gO: n,
            jm: t,
            hY: e,
            ia: r
        };
    }), fd = {
        $: 0
    }, sd = F2(function(r, n) {
        return A2(od, fd, A4(id, r.ia, r.gO, n, r.e));
    }), ld = $e, bd = function(r) {
        var n = r.a, t = r.b, a = !_t(n);
        return function(r) {
            var u = A5(ld, n, r.b, r.ia, r.gO, r.k5), c = u.a, o = u.b, i = u.c;
            return e(c, -1) ? A2(Jb, !1, A2(sd, r, t)) : A3(Xb, a, 0, {
                gO: i,
                e: r.e,
                g: r.g,
                b: c,
                ia: o,
                k5: r.k5
            });
        };
    }, dd = function(r) {
        return bd(function(r) {
            return A2(cd, r, {
                $: 0,
                a: r
            });
        }(r));
    }, vd = A2(ad, ud(Yb("'")), dd("''")), md = {
        $: 11
    }, gd = he, pd = F2(function(r, n) {
        return function(t) {
            var a = A3(gd, r, t.b, t.k5);
            return e(a, -1) ? A2(Jb, !1, A2(sd, t, n)) : e(a, -2) ? A3(Xb, !0, 0, {
                gO: 1,
                e: t.e,
                g: t.g,
                b: t.b + 1,
                ia: t.ia + 1,
                k5: t.k5
            }) : A3(Xb, !0, 0, {
                gO: t.gO + 1,
                e: t.e,
                g: t.g,
                b: a,
                ia: t.ia,
                k5: t.k5
            });
        };
    }), $d = function(r) {
        return A2(pd, r, md);
    }, hd = F2(function(r, n) {
        return {
            $: 0,
            a: r,
            b: n
        };
    }), wd = F5(function(r, n, t, a, u) {
        for(;;){
            var o = A3(gd, r, n, u.k5);
            if (e(o, -1)) return A3(Xb, 0 > c(u.b, n), 0, {
                gO: a,
                e: u.e,
                g: u.g,
                b: n,
                ia: t,
                k5: u.k5
            });
            e(o, -2) ? (n += 1, t += 1, a = 1) : (n = o, a += 1);
        }
    }), Cd = function(r) {
        return function(n) {
            return A5(wd, r, n.b, n.ia, n.gO, n);
        };
    }, kd = function(r) {
        return A3(Xb, !1, r.b, r);
    }, yd = F2(function(r, n) {
        return A3(ed, pt, r, n);
    }), xd = yd, Ld = function(r) {
        var n;
        return n = {
            $: 12,
            a: r
        }, function(r) {
            return A2(Jb, !1, A2(sd, r, n));
        };
    }, jd = function(r) {
        var n = Ka(r);
        if (n.b && !n.b.b) {
            var e = n.a;
            return A2(xd, A2(xd, ud(F2(function(r, n) {
                return A2(hd, e, n - r + 1);
            })), A2(ad, kd, Cd(ht(e)))), kd);
        }
        return Ld("expected exactly one char");
    }, Ad = F2(function(r, n) {
        var e = n;
        return function(n) {
            var t = e(n);
            if (1 === t.$) return A2(Jb, t.a, t.b);
            var a = t.b, u = t.c;
            return A3(Xb, t.a, A2(r, A3(Nt, n.b, u.b, n.k5), a), u);
        };
    }), Md = function(r) {
        return A2(Ad, Es, r);
    }, Fd = A2(nd, jd, Md($d(Xe))), Hd = A2(_e, F2(function(r, n) {
        var e = i(r, n);
        if (1 === e.a.$ && e.b.b && 1 === e.b.a.$) {
            var t = e.b, a = t.b;
            return A2(ye, Yb(l(e.a.a, t.a.a)), a);
        }
        return A2(ye, r, n);
    }), b), Td = function(r) {
        return "'" !== r && !Xe(r);
    }, Sd = F2(function(r, n) {
        var e = n;
        return function(n) {
            var t = e(n);
            if (t.$) return A2(Jb, t.a, t.b);
            var a = t.c;
            return A3(Xb, t.a, r(t.b), a);
        };
    }), Ed = Sd, zd = A2(Ed, Yb, Md(A2(ad, A2(ad, ud(0), $d(Td)), Cd(Td)))), Rd = F2(function(r, n) {
        return {
            $: 2,
            a: r,
            b: n
        };
    }), Vd = F3(function(r, n, e) {
        r: for(;;){
            if (e.b) {
                var t = e.b, a = (0, e.a)(r);
                if (a.$) {
                    var u;
                    if ((u = a).a) return u;
                    n = A2(Rd, n, u.b), e = t;
                    continue r;
                }
                return a;
            }
            return A2(Jb, !1, n);
        }
    }), Wd = function(r) {
        return function(n) {
            return A3(Vd, n, fd, r);
        };
    }, Pd = (Sf = {
        $: 10
    }, function(r) {
        return e(It(r.k5), r.b) ? A3(Xb, !1, 0, r) : A2(Jb, !1, A2(sd, r, Sf));
    }), Gd = function(r) {
        return Wd(m([
            A2(nd, function(n) {
                return Gd(l(r, n));
            }, Md(A2(ad, A2(ad, ud(0), $d(Xl("'"))), Cd(Xl("'"))))),
            A2(nd, function() {
                return Gd(r + "'");
            }, dd("''")),
            ud(r)
        ]));
    }, Id = A2(xd, A2(ad, ud(Yb), $d(ht("'"))), A2(ad, Gd(""), Wd(m([
        $d(ht("'")),
        Pd
    ])))), Nd = function(r) {
        var n;
        return Wd(m([
            A2(nd, function(n) {
                return Nd(A2(ye, n, r));
            }, Wd(m([
                Fd,
                zd,
                vd,
                Id
            ]))),
            (n = function() {
                return ud(Hd(r));
            }, function(r) {
                return n(0)(r);
            })
        ]));
    }, Zd = F3(function(r, n, e) {
        return {
            gO: n,
            hY: e,
            ia: r
        };
    }), Dd = function(r) {
        return A3(Zd, r.ia, r.gO, r.hY);
    }, _d = F2(function(r, n) {
        r: for(;;)switch(r.$){
            case 0:
                return n;
            case 1:
                var e = r.b;
                r = r.a, n = A2(ye, e, n);
                continue r;
            default:
                var t = r.b;
                r = r.a, n = A2(_d, t, n);
                continue r;
        }
    }), Od = F2(function(r, n) {
        var e = r({
            gO: 1,
            e: b,
            g: 1,
            b: 0,
            ia: 1,
            k5: n
        });
        return e.$ ? Fe(A2(_d, e.b, b)) : Ee(e.b);
    }), qd = F2(function(r, n) {
        var e = A2(Od, r, n);
        return e.$ ? Fe(A2(aa, Dd, e.a)) : Ee(e.a);
    }), Kd = F2(function(r, n) {
        var e, t = et(A2(mu, m([
            Yb(e = n)
        ]), A2(qd, Nd(b), e)));
        return A2(Qb, r, t);
    }), Ud = function(r) {
        switch(r){
            case 0:
                return "January";
            case 1:
                return "February";
            case 2:
                return "March";
            case 3:
                return "April";
            case 4:
                return "May";
            case 5:
                return "June";
            case 6:
                return "July";
            case 7:
                return "August";
            case 8:
                return "September";
            case 9:
                return "October";
            case 10:
                return "November";
            default:
                return "December";
        }
    }, Bd = function(r) {
        switch(r){
            case 0:
                return "Monday";
            case 1:
                return "Tuesday";
            case 2:
                return "Wednesday";
            case 3:
                return "Thursday";
            case 4:
                return "Friday";
            case 5:
                return "Saturday";
            default:
                return "Sunday";
        }
    }, Qd = {
        fB: Ub,
        fY: Ud,
        eb: A2(wa, Ud, Ot(3)),
        gs: Bd,
        bp: A2(wa, Bd, Ot(3))
    }, Yd = function(r) {
        return A2(Kd, Qd, r);
    }, Jd = fn, Xd = Jd, rv = F2(function(r, n) {
        return {
            $: 0,
            a: r,
            b: n
        };
    }), nv = function(r) {
        return {
            $: 2,
            a: r
        };
    }, ev = F2(function(r, n) {
        return {
            $: 1,
            a: r,
            b: n
        };
    }), tv = function(r) {
        var n = r;
        return function(r) {
            var e = n(r);
            return 1 === e.$ ? A2(Jb, !1, e.b) : A3(Xb, !1, e.b, e.c);
        };
    }, av = function(r) {
        return function(n) {
            return A3(Xb, !0, r, n);
        };
    }, uv = Ad, cv = A2(uv, F2(function(r) {
        return A2(di, 0, qt(r));
    }), $d(rt)), ov = A2(uv, F2(function(r) {
        return A2(di, 0, qt(r));
    }), A2(ad, A2(ad, ud(0), $d(rt)), $d(rt))), iv = A2(uv, F2(function(r) {
        return A2(di, 0, qt(r));
    }), A2(ad, A2(ad, A2(ad, ud(0), $d(rt)), $d(rt)), $d(rt))), fv = Wd(m([
        A2(xd, A2(ad, ud(Vt), dd("-")), Wd(m([
            tv(A2(nd, av, A2(Ed, nv, iv))),
            A2(xd, A2(xd, ud(rv), ov), Wd(m([
                A2(xd, A2(ad, ud(Vt), dd("-")), ov),
                ud(1)
            ]))),
            A2(xd, A2(xd, A2(ad, ud(ev), dd("W")), ov), Wd(m([
                A2(xd, A2(ad, ud(Vt), dd("-")), cv),
                ud(1)
            ])))
        ]))),
        tv(A2(nd, av, A2(xd, A2(xd, ud(rv), ov), Wd(m([
            ov,
            ud(1)
        ]))))),
        A2(Ed, nv, iv),
        A2(xd, A2(xd, A2(ad, ud(ev), dd("W")), ov), Wd(m([
            cv,
            ud(1)
        ]))),
        ud(nv(1))
    ])), sv = F3(function(r, n, e) {
        return 1 > c(r, e) && 1 > c(e, n);
    }), lv = F3(function(r, n, e) {
        return A3(sv, 1, 12, n) && A3(sv, 1, A2(ab, r, Cb(n)), e) ? Ee(tb(r) + A2(nb, r, Cb(n)) + e) : Fe("Invalid calendar date (" + Ie(r) + ", " + Ie(n) + ", " + Ie(e) + ")");
    }), bv = F2(function(r, n) {
        return A3(sv, 1, 365, n) || 366 === n && rb(r) ? Ee(tb(r) + n) : Fe("Invalid ordinal date (" + Ie(r) + ", " + Ie(n) + ")");
    }), dv = function(r) {
        return tb(r) + 1;
    }, vv = function(r) {
        var n = Ib(dv(r));
        return 4 === n || 3 === n && rb(r);
    }, mv = F3(function(r, n, e) {
        return A3(sv, 1, 7, e) && (A3(sv, 1, 52, n) || 53 === n && vv(r)) ? Ee(Nb(r) + 7 * (n - 1) + e) : Fe("Invalid week date (" + Ie(r) + ", " + Ie(n) + ", " + Ie(e) + ")");
    }), gv = function(r) {
        var n = r.a, e = r.b;
        switch(e.$){
            case 0:
                return A3(lv, n, e.a, e.b);
            case 1:
                return A3(mv, n, e.a, e.b);
            default:
                return A2(bv, n, e.a);
        }
    }, pv = A2(uv, F2(function(r) {
        return A2(di, 0, qt(r));
    }), A2(ad, A2(ad, A2(ad, A2(ad, A2(ad, ud(0), Wd(m([
        $d(function(r) {
            return "-" === r;
        }),
        ud(0)
    ]))), $d(rt)), $d(rt)), $d(rt)), $d(rt))), $v = F2(function(r, n) {
        return i(r, n);
    }), hv = function(r) {
        return r.$ ? Ld(r.a) : ud(r.a);
    }, wv = A2(nd, A2(wa, gv, hv), A2(xd, A2(xd, ud($v), pv), fv)), Cv = A2(wa, qd(A2(xd, ud(Vt), A2(ad, wv, A2(nd, hv, Wd(m([
        A2(Ed, Ee, Pd),
        A2(Ed, Es(Fe("Expected a date only, not a date and time")), $d(ht("T"))),
        ud(Fe("Expected a date only"))
    ])))))), Ha(A2(wa, sc, A2(wa, Ba(function(r) {
        var n = r.hY;
        return 12 === n.$ ? n.a : "Expected a date in ISO 8601 format";
    }), di(""))))), kv = {
        $: 0
    }, yv = kv, xv = F2(function(r, n) {
        return A2(pn, r, Ni(n));
    }), Lv = xv("required"), jv = {
        fo: function(r) {
            return Xd(r);
        },
        cj: yv,
        bx: "elm-datepicker--",
        fr: b,
        fz: Yd("yyyy-MM-dd"),
        fA: function(r) {
            switch(r){
                case 0:
                    return "Mo";
                case 1:
                    return "Tu";
                case 2:
                    return "We";
                case 3:
                    return "Th";
                case 4:
                    return "Fr";
                case 5:
                    return "Sa";
                default:
                    return "Su";
            }
        },
        dJ: 6,
        fT: m([
            Lv(!1)
        ]),
        j_: b,
        j$: We,
        j0: We,
        j4: Es(!1),
        fX: function(r) {
            switch(r){
                case 0:
                    return "January";
                case 1:
                    return "February";
                case 2:
                    return "March";
                case 3:
                    return "April";
                case 4:
                    return "May";
                case 5:
                    return "June";
                case 6:
                    return "July";
                case 7:
                    return "August";
                case 8:
                    return "September";
                case 9:
                    return "October";
                case 10:
                    return "November";
                default:
                    return "December";
            }
        },
        f2: Cv,
        f5: "Please pick a date...",
        gv: Ie
    }, Av = s(jv, {
        j_: m([
            i("form-control", !0)
        ]),
        j0: Ve("CustomDatePicker")
    }), Mv = F2(function(r, n) {
        return {
            bI: n,
            B: r
        };
    }), Fv = function(r) {
        var n;
        return n = m([
            i(r, A2(Mv, 3, We))
        ]), A3(_e, F2(function(r, n) {
            return A3(lo, r.a, r.b, n);
        }), ko, n);
    }, Hv = function(r) {
        switch(r){
            case 0:
                return "SelectReportType";
            case 1:
                return "SelectReportNameAndTimeRangeStep";
            default:
                return "NameAndSaveStep";
        }
    }, Tv = F4(function(r, n, e, t) {
        return {
            cc: Fv(Hv(0)),
            by: n,
            a0: 0,
            a1: We,
            a2: t,
            a3: We,
            cq: e,
            aE: $b,
            ju: 2,
            dC: Av,
            E: r,
            a8: "",
            g7: We,
            dV: We,
            d0: !1,
            kv: "",
            fZ: 3,
            eI: We,
            h5: Ve(hb(We)),
            aP: A3(ub, 2020, 0, 1),
            c7: b,
            aq: 0
        };
    }), Sv = qr, Ev = F3(function(r, n, e) {
        var t = pb.b, a = pb.b;
        return i(A4(Tv, n, e, pb.a, pb.a), ma(m([
            A2(Sv, Nl, t),
            A2(Sv, Il, a),
            A2(da, Zl, gb),
            Ql(r)
        ])));
    }), zv = F4(function(r, n, e, t) {
        var a = A3(Ev, n, e, t), u = a.b;
        return i(s(r, {
            kK: Qf(a.a)
        }), A2(Sv, Kf, u));
    }), Rv = function(r) {
        return {
            $: 4,
            a: r
        };
    }, Vv = function(r) {
        return {
            $: 3,
            a: r
        };
    }, Wv = {
        $: 1
    }, Pv = F9(function(r, n, e, t, a, u, c, o, i) {
        return {
            g7: a,
            jM: n,
            j9: t,
            ka: e,
            kf: i,
            eK: u,
            gh: c,
            iL: r,
            A: o
        };
    }), Gv = A2(xu, function(r) {
        switch(r){
            case "admin":
                return zt(0);
            case "user":
                return zt(2);
            case "billing":
                return zt(1);
            default:
                return Us("Invalid TeamMemberRole: " + r);
        }
    }, wc), Iv = A2(xu, function(r) {
        switch(r){
            case "active":
                return zt(0);
            case "inactive":
                return zt(1);
            default:
                return Us("Invalid TeamMemberStatus: " + r);
        }
    }, wc), Nv = function(r) {
        return zt(r.$ ? "" : r.a);
    }, Zv = function(r) {
        return zt(r.$ ? "" : r.a);
    }, Dv = F2(function(r, n) {
        return n.$ ? We : r(n.a);
    }), _v = A2(tu, "lastLogin", A2(xu, function(r) {
        var n = function(r) {
            return A2(Ba, Cv, A2(Dv, sc, A2(Ba, Ze("T"), r)));
        }(r);
        if (n.$) return zt(We);
        var e = n.a;
        return 1 === e.$ ? Us(e.a) : zt(Ve(e.a));
    }, jc(wc))), Ov = F2(function(r, n) {
        return A3(ta, tu, n, r);
    }), qv = function(r) {
        return {
            $: 5,
            c: r
        };
    }, Kv = F3(function(r, n, e) {
        var t = function(r) {
            return cu(m([
                r,
                qv(e)
            ]));
        };
        return A2(xu, function(a) {
            var u = A2(pu, A2(Ov, r, ru), a);
            if (u.$) return zt(e);
            var c = u.a, o = A2(pu, t(n), c);
            return o.$ ? A2(Ov, r, t(n)) : zt(o.a);
        }, ru);
    }), Uv = F4(function(r, n, e, t) {
        return A2(Js, A3(Kv, m([
            r
        ]), n, e), t);
    }), Bv = A2(St, Vt, wc), Qv = A2(St, Vt, wc), Yv = A2(St, Vt, wc), Jv = A2(St, Vt, wc), Xv = A3(bl, "loginReminderEnabled", wu, A2(Js, zt(Wv), A3(bl, "status", Iv, A3(bl, "role", Gv, A3(bl, "userExternalId", Bv, A2(Js, _v, A4(Uv, "lastName", A2(xu, Zv, jc(Yv)), "", A4(Uv, "firstName", A2(xu, Nv, jc(Qv)), "", A3(bl, "username", Jv, zt(Pv)))))))))), rm = A2(tu, "members", sl(Xv)), nm = F2(function(r, n) {
        var e = mf(m([
            "enterprise-grant",
            n,
            "people"
        ]));
        return A3(Ol, r, e, rm);
    }), em = F2(function(r, n) {
        var e = A2(nm, r, n), t = A3(Cl, Vv, Es(Rv(We)), Rv(Ve(Ss)));
        return A2(wl, t, e);
    }), tm = {
        $: 0
    }, am = function(r) {
        switch(r){
            case 0:
                return "team-name-step";
            case 1:
                return "select-members-step";
            default:
                return "review-and-save-step";
        }
    }, um = F2(function(r, n) {
        return {
            cc: Fv(am(0)),
            by: n,
            a0: 0,
            E: r,
            aw: tm,
            a8: "",
            a9: "",
            ax: b,
            iw: We,
            y: b,
            lh: "",
            b3: 3
        };
    }), cm = F4(function(r, n, e, t) {
        return i(s(r, {
            kK: xs(A2(um, e, t))
        }), A2(Sv, Uf, A2(em, n, e)));
    }), om = function(r) {
        return r;
    }, im = function(r) {
        return r;
    }, fm = A2($l, im, om), sm = function(r) {
        return r;
    }, lm = F2(function(r, n) {
        switch(r.$){
            case 0:
                return n + "/modules/new";
            case 1:
                return n + "/modules/" + r.a;
            case 2:
                return n + "/modules/" + r.a + "/update";
            case 3:
                return n + "/modules/" + r.a + "/clone";
            case 4:
                return n + "/modules/" + r.a + "/create-new-assignment";
            case 5:
                return n + "/team/" + r.a;
            case 6:
                return n + "/team/new";
            case 7:
                return n + "/team/" + fm(r.a) + "/update";
            case 8:
                var e = r.b;
                return n + "/team/" + fm(r.a) + "/member-activity/" + e;
            case 9:
                return n + "/reports/new";
            case 10:
                return n + "/reports/" + r.a + "/schedule";
            case 11:
                return n + "/reports/" + r.a + "/update";
            case 12:
                return n + "/user/" + r.a;
            case 13:
                return n + "/users";
            case 14:
                return n + "/teams";
            case 15:
                return n + "/assignments";
            case 16:
                return n + "/reports";
            case 17:
                return n + "/users/learning-reminders";
            case 18:
                return n + "/dashboard";
            default:
                return n + "/settings";
        }
    }), bm = function(r) {
        switch(r.$){
            case 0:
                return "/";
            case 1:
                return "/account-setup/" + r.a;
            case 2:
                return "/companies";
            case 3:
                return A2(lm, r.b, "/enterpriseGrants/" + r.a);
            default:
                return A2(lm, r.c, "/company/" + r.a + "/enterpriseGrants/" + r.b);
        }
    }, dm = Un, vm = F2(function(r, n) {
        return A2(dm, r, bm(n));
    }), mm = {
        aY: We,
        eR: "",
        cV: We,
        b1: 1
    }, gm = function(r) {
        return {
            $: 12,
            a: r
        };
    }, pm = function(r) {
        return {
            $: 14,
            a: r
        };
    }, $m = function(r) {
        return {
            $: 0,
            a: r
        };
    }, hm = function(r) {
        return {
            $: 1,
            a: r
        };
    }, wm = F2(function(r, n) {
        return {
            kv: r,
            b5: n
        };
    }), Cm = function(r) {
        return r;
    }, km = A2(St, Cm, wc), ym = function(r) {
        return r;
    }, xm = A2(St, ym, wc), Lm = A3(Et, wm, A2(tu, "name", km), A2(tu, "url", xm)), jm = A2(tu, "tags", sl(Lm)), Am = F2(function(r, n) {
        return A3(Ol, r, mf(A2(aa, Vt, m([
            "enterprise-grant",
            n,
            "tags"
        ]))), jm);
    }), Mm = F2(function(r, n) {
        var e = A3(Cl, hm, A2($l, $m, Ts), $m(Ss));
        return A2(wl, e, A2(Am, r, n));
    }), Fm = F2(function(r, n) {
        return e(n.bG.jW, r) ? Ve(n.bU.kq) : We;
    }), Hm = F2(function(r, n) {
        return sc(A2(Af, Fm(n), Me(r)));
    }), Tm = {
        $: 0
    }, Sm = {
        $: 0
    }, Em = {
        fj: We,
        B: 2
    }, zm = F2(function(r, n) {
        return {
            ch: 3,
            ci: {
                bA: 0,
                jQ: 0
            },
            gC: Tm,
            by: r,
            cs: 1,
            E: n,
            ea: Ic,
            cM: Sm,
            eW: Em
        };
    }), Rm = {
        $: 0
    }, Vm = {
        fs: b,
        bz: "",
        kv: ""
    }, Wm = {
        $: 0
    }, Pm = {
        fk: yc(Mc),
        R: We,
        cN: !1,
        W: 0,
        w: Wm,
        aL: "",
        bZ: b,
        b_: We,
        X: i(!1, ""),
        Y: i(!1, ""),
        le: b
    }, Gm = ko, Im = function(r) {
        switch(r){
            case 0:
                return "module-info-step";
            case 1:
                return "select-content-step";
            default:
                return "review-and-save-step";
        }
    }, Nm = F3(function(r, n, e) {
        return {
            cc: e.$ ? Gm : Fv(Im(e.a)),
            fk: yc(Mc),
            by: r,
            C: Pm,
            a0: e,
            E: n,
            bQ: 1,
            ea: Ic,
            F: Vm,
            az: Rm,
            bY: 1,
            c5: Ic
        };
    }), Zm = function(r) {
        return {
            $: 8,
            a: r
        };
    }, Dm = function(r) {
        return {
            $: 7,
            a: r
        };
    }, _m = F7(function(r, n, e, t, a, u, c) {
        return {
            gz: e,
            gA: n,
            gR: a,
            jA: t,
            g7: c,
            u: r,
            kO: u
        };
    }), Om = function(r) {
        return cu(m([
            qv(We),
            A2(St, Ve, r)
        ]));
    }, qm = Om(A2(St, Vt, wc)), Km = A2(St, Vt, wc), Um = A2(St, Vt, wc), Bm = F3(function(r, n, e) {
        return {
            jM: r,
            ka: n,
            iL: e
        };
    }), Qm = A2(St, Vt, wc), Ym = A2(St, Vt, wc), Jm = A2(St, Vt, wc), Xm = A4(Ui, Bm, A2(tu, "firstName", Qm), A2(tu, "lastName", Ym), A2(tu, "userName", Jm)), rg = A2(St, Vt, au), ng = sr, eg = A8(ng, _m, A2(tu, "member", Xm), A2(tu, "assignedBy", Xm), A2(tu, "assignedAt", Km), A2(tu, "dueDate", Km), A2(tu, "completionDate", qm), A2(tu, "progress", rg), A2(tu, "externalId", Um)), tg = A2(tu, "assignments", sl(eg)), ag = F3(function(r, n, e) {
        var t = mf(A2(aa, Vt, m([
            "enterprise-grant",
            n,
            "module",
            e,
            "assignments"
        ])));
        return A3(Ol, r, t, tg);
    }), ug = F3(function(r, n, e) {
        return A2(wl, A3(Cl, Dm, Es(Zm(We)), Zm(Ve(Ss))), A3(ag, r, n, e));
    }), cg = function(r) {
        return {
            $: 0,
            a: r
        };
    }, og = function(r) {
        return {
            $: 1,
            a: r
        };
    }, ig = F4(function(r, n, e, t) {
        return {
            g7: r,
            hE: t,
            kr: e,
            hF: n
        };
    }), fg = function(r) {
        return {
            $: 0,
            a: r
        };
    }, sg = function(r) {
        return {
            $: 1,
            a: r
        };
    }, lg = F6(function(r, n, e, t, a, u) {
        return {
            g7: a,
            cC: u,
            hv: e,
            kv: r,
            lb: n,
            b5: t
        };
    }), bg = function(r) {
        return {
            $: 0,
            a: r
        };
    }, dg = A2(St, bg, wc), vg = A2(St, Vt, uu), mg = A2(St, Vt, wu), gg = A2(St, Vt, wc), pg = Om(A2(St, Vt, wc)), $g = A2(St, Vt, wc), hg = A7(ku, lg, A2(tu, "name", gg), A2(tu, "subtitle", pg), A2(tu, "length", vg), A2(tu, "url", $g), A2(tu, "externalId", dg), A2(tu, "licensed", mg)), wg = F5(function(r, n, e, t, a) {
        return {
            gT: t,
            g7: e,
            cC: a,
            hv: n,
            z: r
        };
    }), Cg = function(r) {
        return {
            $: 1,
            a: r
        };
    }, kg = A2(St, Cg, wc), yg = A2(St, Vt, uu), xg = A2(St, Vt, wu), Lg = A2(St, Vt, wc), jg = ir, Ag = A6(jg, wg, A2(tu, "title", Lg), A2(tu, "length", Om(yg)), A2(tu, "externalId", kg), A2(tu, "courseName", gg), A2(tu, "licensed", xg)), Mg = A2(xu, function(r) {
        switch(r){
            case "course":
                return A2(St, fg, A2(tu, "value", hg));
            case "episode":
                return A2(St, sg, A2(tu, "value", Ag));
            default:
                return Us("Trying to decode a module content, but type " + r + " is not supported.");
        }
    }, A2(tu, "type", wc)), Fg = A2(St, Vt, wc), Hg = A2(St, Vt, wc), Tg = A2(St, Vt, wc), Sg = A5(hc, ig, A2(tu, "moduleExternalId", Hg), A2(tu, "moduleName", Tg), A2(tu, "moduleDescription", Fg), A2(St, di(b), jc(A2(tu, "contents", sl(Mg))))), Eg = function(r) {
        return mf(A2(aa, Vt, m([
            "enterprise-grant",
            r,
            "module"
        ])));
    }, zg = F2(function(r, n) {
        var e = n;
        return mf(m([
            Eg(r),
            e
        ]));
    }), Rg = F3(function(r, n, e) {
        return A3(Ol, r, A2(zg, n, e), Sg);
    }), Vg = F3(function(r, n, e) {
        return A2(wl, A3(Cl, cg, Es(og(We)), og(Ve(Ss))), A3(Rg, r, n, e));
    }), Wg = function(r) {
        return {
            $: 13,
            a: r
        };
    }, Pg = function(r) {
        return {
            $: 14,
            a: r
        };
    }, Gg = F3(function(r, n, e) {
        return A2(wl, A3(Cl, Wg, Es(Pg(We)), Pg(Ve(Ss))), A3(Rg, r, n, e));
    }), Ig = F5(function(r, n, e, t, a) {
        return {
            cc: t.$ ? Gm : Fv(Im(t.a)),
            fk: r,
            by: n,
            C: Pm,
            a0: t,
            E: e,
            bQ: 0,
            ea: Ic,
            F: Vm,
            az: a,
            bY: 1,
            c5: Ic
        };
    }), Ng = F7(function(r, n, e, t, a, u, c) {
        var o = A2(di, "", t);
        switch(u){
            case 0:
                var f = function(r) {
                    var n = A2(Hm, a.fI, e);
                    if (n.$) return r;
                    var t = s(r.F, {
                        kv: n.a
                    });
                    return s(r, {
                        F: t
                    });
                }(A3(Nm, n, e, Ve(0)));
                return i(s(a, {
                    kK: ds(f)
                }), A2(Sv, A2($l, gs, gm), A2(Mm, r, e)));
            case 1:
                return i(s(a, {
                    kK: ls(A2(zm, n, e))
                }), A2(Sv, bs, ma(m([
                    A3(Vg, r, e, o),
                    A3(ug, r, e, o)
                ]))));
            case 2:
                var l = A5(Ig, a.fk, n, e, Ve(0), c);
                return i(s(a, {
                    kK: ds(l)
                }), A2(Sv, pm, A3(Gg, r, e, o)));
            default:
                return l = A5(Ig, a.fk, n, e, Ve(0), c), i(s(a, {
                    kK: ds(l)
                }), A2(Sv, pm, ma(m([
                    A2(Sv, gm, A2(Mm, r, e)),
                    A3(Gg, r, e, o)
                ]))));
        }
    }), Zg = F5(function(r, n, e, t, a) {
        return A6(Ng, r, n, e, Ve(t), a, 3);
    }), Dg = {
        $: 0
    }, _g = F2(function(r, n) {
        return {
            g1: r,
            fE: n
        };
    }), Og = F6(function(r, n, e, t, a, u) {
        return {
            fk: r,
            by: t,
            c: a,
            D: Dg,
            av: A2(_g, We, We),
            E: e,
            dL: b,
            gn: u,
            gp: n,
            fg: We
        };
    }), qg = function(r) {
        return {
            $: 0,
            a: r
        };
    }, Kg = function(r) {
        return {
            $: 1,
            a: r
        };
    }, Ug = A2(St, Vt, uu), Bg = F2(function(r, n) {
        return {
            au: r,
            aH: n
        };
    }), Qg = F4(function(r, n, e, t) {
        return {
            gR: e,
            kt: t,
            hF: n,
            b7: r
        };
    }), Yg = A5(hc, Qg, A2(tu, "userFullName", wc), A2(tu, "moduleName", Tg), A2(tu, "completionDate", Km), A2(tu, "moduleExternalId", Hg)), Jg = A3(Et, Bg, zt(1), sl(Yg)), Xg = F3(function(r, n, e) {
        return {
            $7: n,
            dz: e,
            il: r
        };
    }), rp = F2(function(r, n) {
        return {
            au: r,
            aH: n
        };
    }), np = F3(function(r, n, e) {
        return {
            gR: e,
            gT: n,
            b7: r
        };
    }), ep = A2(St, Vt, A2(St, function(r) {
        var n = A2(Ze, "T", r);
        return n.b ? n.a : r;
    }, wc)), tp = A4(Ui, np, A2(tu, "userFullName", wc), A2(tu, "courseName", gg), A2(tu, "completionDate", ep)), ap = A3(Et, rp, zt(1), sl(tp)), up = A4(Ui, Xg, zt(1), A2(tu, "assignmentCompletions", Jg), A2(tu, "courseCompletions", ap)), cp = F3(function(r, n, e) {
        return {
            jT: e,
            lt: n,
            iN: r
        };
    }), op = function(r) {
        switch(r){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }, ip = (Ef = Us("Invalid date from serve."), A2(xu, function(r) {
        var n = A2(Ze, "T", r);
        if (n.b) {
            var e = A2(Ze, "-", n.a);
            if (e.b && e.b.b) {
                var t = qt(e.b.a);
                return t.$ ? Ef : zt(op(t.a));
            }
            return Ef;
        }
        return Ef;
    }, wc)), fp = function() {
        var r = Us("Invalid date from serve.");
        return A2(xu, function(n) {
            var e = A2(Ze, "T", n);
            if (e.b) {
                var t = A2(Ze, "-", e.a);
                return t.b && t.b.b && t.b.b.b ? zt(t.b.b.a) : r;
            }
            return r;
        }, wc);
    }(), sp = A4(Ui, cp, A2(tu, "week", ip), A2(tu, "week", fp), A2(tu, "hours", au)), lp = A2(tu, "metrics", sl(sp)), bp = F3(function(r, n, e) {
        return {
            aS: r,
            fn: n,
            fx: e
        };
    }), dp = F4(function(r, n, e, t) {
        return {
            gT: r,
            jo: n,
            jp: t,
            jq: e
        };
    }), vp = A5(hc, dp, A2(tu, "courseName", gg), A2(tu, "courseSubtitle", pg), A2(tu, "courseUrl", $g), A2(tu, "courseThumbnail", Om(wc))), mp = A4(Ui, bp, zt(0), sl(vp), zt(!1)), gp = A2(St, Vt, uu), pp = A2(St, Vt, uu), $p = {
        $: 1
    }, hp = {
        $: 0
    }, wp = function(r) {
        return r ? hp : $p;
    }, Cp = A2(St, wp, wu), kp = F2(function(r, n) {
        return {
            kv: r,
            iM: n
        };
    }), yp = A3(Et, kp, A2(tu, "name", gg), A2(tu, "viewCount", uu)), xp = sl(yp), Lp = F2(function(r, n) {
        return {
            kv: r,
            iM: n
        };
    }), jp = A3(Et, Lp, A2(tu, "name", km), A2(tu, "viewCount", uu)), Ap = sl(jp), Mp = F2(function(r, n) {
        return {
            au: r,
            aH: n
        };
    }), Fp = F6(function(r, n, e, t, a, u) {
        return {
            dp: t,
            ks: u,
            hF: n,
            kO: e,
            k4: a,
            b7: r
        };
    }), Hp = A7(ku, Fp, A2(tu, "userFullName", wc), A2(tu, "moduleName", Tg), A2(tu, "progress", au), A2(tu, "assignmentDueDate", Km), zt(!1), A2(tu, "moduleExternalId", Hg)), Tp = A3(Et, Mp, zt(1), sl(Hp)), Sp = F3(function(r, n, e) {
        return {
            bB: r,
            bO: e,
            bW: n
        };
    }), Ep = F2(function(r, n) {
        return {
            aH: n,
            x: r
        };
    }), zp = F2(function(r, n) {
        return {
            gS: n,
            b7: r
        };
    }), Rp = A3(Et, zp, A2(tu, "userFullName", wc), A2(tu, "count", uu)), Vp = A3(Et, Ep, zt(0), A2(tu, "downloads", sl(Rp))), Wp = F2(function(r, n) {
        return {
            aH: n,
            x: r
        };
    }), Pp = F2(function(r, n) {
        return {
            hh: n,
            b7: r
        };
    }), Gp = A3(Et, Pp, A2(tu, "userFullName", wc), A2(tu, "hoursPerWeek", au)), Ip = A3(Et, Wp, zt(0), A2(tu, "learningPace", sl(Gp))), Np = F2(function(r, n) {
        return {
            aH: n,
            x: r
        };
    }), Zp = F2(function(r, n) {
        return {
            gY: n,
            b7: r
        };
    }), Dp = A3(Et, Zp, A2(tu, "userFullName", wc), A2(tu, "date", ep)), _p = A3(Et, Np, zt(0), A2(tu, "recentLogins", sl(Dp))), Op = A4(Ui, Sp, Vp, _p, Ip), qp = A3(bl, "snapshotEmail", Cp, A3(bl, "seatSwaps", gp, A3(bl, "topTagsWatchedPastThirtyDays", Ap, A3(bl, "topCoursesWatchedPastThirtyDays", xp, A2(Js, lp, A3(bl, "examsLaunched", uu, A3(bl, "labsLaunched", uu, A3(bl, "upcomingAssignments", Tp, A3(bl, "recentlyAddedCourses", mp, A3(bl, "assignmentCompletions", Jg, A3(bl, "averageAssignmentsPerModule", uu, A3(bl, "totalSeats", pp, A3(bl, "totalModulesCreated", uu, A3(bl, "totalActiveAssignments", uu, A2(Js, up, A2(Js, zt(1), A3(bl, "courseCompletions", ap, A3(bl, "userEngagement", Op, A3(bl, "assignedUsers", Ug, zt(function(r) {
        return function(n) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(u) {
                            return function(c) {
                                return function(o) {
                                    return function(i) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(b) {
                                                        return function(d) {
                                                            return function(v) {
                                                                return function(m) {
                                                                    return function(g) {
                                                                        return function(p) {
                                                                            return function($) {
                                                                                return {
                                                                                    i2: r,
                                                                                    i3: f,
                                                                                    i6: i,
                                                                                    at: a,
                                                                                    jk: t,
                                                                                    jn: e,
                                                                                    jE: d,
                                                                                    j8: b,
                                                                                    kn: v,
                                                                                    cS: s,
                                                                                    k$: p,
                                                                                    b$: $,
                                                                                    li: m,
                                                                                    iF: g,
                                                                                    e3: u,
                                                                                    e4: c,
                                                                                    lj: o,
                                                                                    aR: l,
                                                                                    gr: n
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))), Kp = F2(function(r, n) {
        var e = mf(A2(aa, Vt, m([
            "dashboard",
            "enterprise-grant",
            n
        ])));
        return A3(Ol, r, e, qp);
    }), Up = F2(function(r, n) {
        var e = A2(Kp, r, n), t = A3(Cl, function(r) {
            return qg({
                $: 0,
                a: r
            });
        }, function(r) {
            return qg(Kg(Ts(r)));
        }, qg(Kg(Ss)));
        return A2(wl, t, e);
    }), Bp = F6(function(r, n, e, t, a, u) {
        return i(A6(Og, r, n, t, e, a, u), A2(Up, n, t));
    }), Qp = F5(function(r, n, e, t, a) {
        var u = A6(Bp, e, n, a, t, r.jt, r.gn), c = u.b;
        return i(s(r, {
            kK: Jf(u.a)
        }), A2(Sv, rs, c));
    }), Yp = F5(function(r, n, e, t, a) {
        return A6(Ng, r, n, e, Ve(t), a, 2);
    }), Jp = function(r) {
        return {
            $: 5,
            a: r
        };
    }, Xp = F3(function(r, n, e) {
        return {
            $: 3,
            a: r,
            b: n,
            c: e
        };
    }), r$ = function(r) {
        return {
            $: 4,
            b: r
        };
    }, n$ = A2(St, Vt, wc), e$ = A3(Et, $v, A2(tu, "companyName", n$), A2(tu, "enterpriseGrants", r$(gl))), t$ = F3(function(r, n, e) {
        return A2(wl, A3(Cl, A2(Xp, n, e), Jp, ga), function(r) {
            return A3(Ol, r, "enterprise-grant", e$);
        }(r));
    }), a$ = F4(function(r, n, e, t) {
        return {
            $: 4,
            a: r,
            b: n,
            c: e,
            d: t
        };
    }), u$ = F2(function(r, n) {
        var e = mf(A2(aa, Vt, m([
            "enterprise-grant",
            "company",
            n
        ])));
        return A3(Ol, r, e, e$);
    }), c$ = F4(function(r, n, e, t) {
        return A2(wl, A3(Cl, A3(a$, n, e, t), Jp, ga), A2(u$, r, n));
    }), o$ = {
        $: 0
    }, i$ = F8(function(r, n, e, t, a, u, c, o) {
        return {
            fq: c,
            hA: e,
            hB: t,
            hC: r,
            cI: a,
            hD: n,
            kn: u,
            e7: o
        };
    }), f$ = {
        gD: b,
        i5: b
    }, s$ = A8(i$, We, 0, 0, 0, b, b, b, f$), l$ = F2(function(r, n) {
        return {
            by: n,
            E: r,
            dV: We,
            j: s$,
            hz: We,
            cI: We,
            lg: We,
            aP: A3(ub, 2020, 0, 1),
            b6: o$
        };
    }), b$ = function(r) {
        return {
            $: 3,
            a: r
        };
    }, d$ = function(r) {
        return {
            $: 2,
            a: r
        };
    }, v$ = F4(function(r, n, e, t) {
        return {
            g7: n,
            kj: e,
            kv: r,
            bl: t
        };
    }), m$ = A2(xu, function(r) {
        var n = gi(r);
        return n.$ ? Us("Not a valid UUID") : zt(n.a);
    }, wc), g$ = A2(St, Vt, m$), p$ = F5(function(r, n, e, t, a) {
        return {
            g7: t,
            jM: r,
            ka: n,
            eX: a,
            iL: e
        };
    }), $$ = A2(St, Vt, wc), h$ = A2(St, Vt, wc), w$ = A2(St, Vt, wc), C$ = A2(St, Vt, wc), k$ = A6(jg, p$, A2(tu, "firstName", h$), A2(tu, "lastName", w$), A2(tu, "username", C$), A2(tu, "externalId", $$), zt(1)), y$ = A2(St, Vt, wc), x$ = A5(hc, v$, A2(tu, "name", y$), A2(tu, "externalId", g$), A2(tu, "members", sl(k$)), zt(1)), L$ = F2(function(r, n) {
        return mf(A2(aa, Vt, m([
            "enterprise-grant",
            r,
            "team",
            n
        ])));
    }), j$ = F3(function(r, n, e) {
        return A3(Ol, r, A2(L$, n, e), x$);
    }), A$ = F3(function(r, n, e) {
        return A2(wl, A3(Cl, d$, Es(b$(We)), b$(Ve(Ss))), A3(j$, r, n, e));
    }), M$ = function(r) {
        return {
            $: 1,
            a: r
        };
    }, F$ = function(r) {
        return {
            $: 0,
            a: r
        };
    }, H$ = F4(function(r, n, e, t) {
        return {
            g7: t,
            jM: n,
            ka: e,
            iL: r
        };
    }), T$ = A5(hc, H$, A2(tu, "username", Jv), A2(tu, "firstName", Qv), A2(tu, "lastName", Yv), A2(tu, "externalId", Bv)), S$ = F2(function(r, n) {
        return l(A2(Ne, "/", r), Ml(n));
    }), E$ = F2(function(r, n) {
        return {
            $: 0,
            a: r,
            b: n
        };
    }), z$ = function(r) {
        return encodeURIComponent(r);
    }, R$ = F2(function(r, n) {
        return A2(E$, z$(r), z$(n));
    }), V$ = F3(function(r, n, e) {
        var t = e, a = A2(S$, m([
            "enterprise-grant",
            n,
            "user"
        ]), m([
            A2(R$, "user", t)
        ]));
        return A3(Ol, r, a, T$);
    }), W$ = F3(function(r, n, e) {
        return A2(wl, A3(Cl, F$, Es(M$(We)), M$(Ve(Ss))), A3(V$, r, n, e));
    }), P$ = F6(function(r, n, e, t, a, u) {
        var c = u.$ ? su : A3(A$, n, a, u.a);
        return i(s(r, {
            kK: is(A2(l$, a, e))
        }), A2(Sv, fs, ma(m([
            A3(W$, n, a, t),
            c
        ]))));
    }), G$ = F5(function(r, n, e, t, a) {
        return A7(Ng, r, n, e, Ve(t), a, 1, Rm);
    }), I$ = function(r) {
        return {
            $: 5,
            a: r
        };
    }, N$ = function(r) {
        return {
            $: 6,
            a: r
        };
    }, Z$ = {
        $: 0
    }, D$ = {
        $: 0
    }, _$ = {
        $: 0
    }, O$ = {
        $: 0
    }, q$ = s(jv, {
        j_: m([
            i("form-control", !0)
        ]),
        j$: Ve("due-date-picker-input"),
        j0: Ve("DueDatePicker")
    }), K$ = F4(function(r, n, e, t) {
        return {
            dq: Ic,
            by: r,
            a_: Z$,
            dC: q$,
            jA: We,
            cv: t,
            cw: n,
            aF: !1,
            ac: b,
            ki: D$,
            cK: e,
            cM: _$,
            cW: "",
            k2: 0,
            eY: O$,
            aP: We
        };
    }), U$ = function(r) {
        return {
            $: 3,
            a: r
        };
    }, B$ = function(r) {
        return {
            $: 2,
            a: r
        };
    }, Q$ = F2(function(r, n) {
        var e = A2(nm, r, n), t = A3(Cl, B$, Es(U$(We)), U$(Ve(Ss)));
        return A2(wl, t, e);
    }), Y$ = function(r) {
        return {
            $: 1,
            a: r
        };
    }, J$ = function(r) {
        return {
            $: 0,
            a: r
        };
    }, X$ = F3(function(r, n, e) {
        var t = A3(Rg, r, n, e), a = A3(Cl, J$, Es(Y$(We)), Y$(Ve(Ss)));
        return A2(wl, a, t);
    }), rh = function(r) {
        return {
            $: 15,
            a: r
        };
    }, nh = function(r) {
        return {
            $: 14,
            a: r
        };
    }, eh = A2(tu, "teams", r$(x$)), th = F2(function(r, n) {
        return A3(Ol, r, mf(A2(aa, Vt, m([
            "enterprise-grant",
            n,
            "teams"
        ]))), eh);
    }), ah = F2(function(r, n) {
        var e = A2(th, r, n), t = A3(Cl, nh, Es(rh(We)), rh(Ve(Ss)));
        return A2(wl, t, e);
    }), uh = F4(function(r, n, e, t) {
        var a = pb.b;
        return i(A4(K$, n, e, t, pb.a), ma(m([
            A3(X$, r, e, t),
            A2(Q$, r, e),
            A2(ah, r, e),
            A2(da, N$, gb),
            A2(Sv, I$, a)
        ])));
    }), ch = F5(function(r, n, e, t, a) {
        var u = A4(uh, r, n, e, t), c = u.b;
        return i(s(a, {
            kK: ms(u.a)
        }), A2(Sv, _f, c));
    }), oh = F4(function(r, n, e, t) {
        return A7(Ng, r, n, e, We, t, 0, Rm);
    }), ih = function(r) {
        return {
            $: 8,
            a: r
        };
    }, fh = function(r) {
        return {
            $: 7,
            a: r
        };
    }, sh = F9(function(r, n, e, t, a, u, c, o, i) {
        return {
            Z: a,
            _: u,
            aC: o,
            ad: r,
            ae: n,
            Q: c,
            am: e,
            an: t,
            cb: i
        };
    }), lh = A2(St, Vt, wc), bh = A2(tu, "whiteLabel", jc(A3(bl, "externalId", lh, A3(bl, "borderRadius", wc, A3(bl, "logoString", wc, A3(bl, "accentColor", wc, A3(bl, "accentBG", wc, A3(bl, "primaryColor", wc, A3(bl, "primaryBG", wc, A3(bl, "headerColor", wc, A3(bl, "headerBG", wc, zt(sh)))))))))))), dh = F2(function(r, n) {
        return A3(Ol, r, mf(A2(aa, Vt, m([
            "white-label",
            "enterprise-grant",
            n
        ]))), bh);
    }), vh = F2(function(r, n) {
        var e = A2(dh, r, n), t = A3(Cl, fh, Es(ih(We)), ih(Ve(Ss)));
        return A2(wl, t, e);
    }), mh = F3(function(r, n, e) {
        return i({
            as: 3,
            by: r,
            cw: n,
            gp: e,
            n: Ve(qc)
        }, A2(vh, e, n));
    }), gh = F4(function(r, n, e, t) {
        var a = A3(mh, e, n, t), u = a.b;
        return i(s(r, {
            kK: Wc(a.a)
        }), A2(Sv, Cs, u));
    }), ph = {
        $: 0
    }, $h = F2(function(r, n) {
        return {
            by: n,
            a4: 3,
            ct: 1,
            E: r,
            ax: b,
            lg: ph,
            c$: 3,
            bk: We
        };
    }), hh = function(r) {
        return {
            $: 1,
            a: r
        };
    }, wh = function(r) {
        return {
            $: 0,
            a: r
        };
    }, Ch = F3(function(r, n, e) {
        return A2(wl, A3(Cl, wh, Es(hh(We)), hh(Ve(Ss))), A3(j$, r, n, e));
    }), kh = F5(function(r, n, e, t, a) {
        return i(s(a, {
            kK: ks(A2($h, e, n))
        }), A2(Sv, ys, A3(Ch, r, e, t)));
    }), yh = function(r) {
        return {
            $: 16,
            a: r
        };
    }, xh = function(r) {
        return {
            $: 15,
            a: r
        };
    }, Lh = F3(function(r, n, e) {
        var t = A3(j$, r, n, e), a = A3(Cl, xh, A2($l, yh, Ts), yh(Ss));
        return A2(wl, a, t);
    }), jh = F5(function(r, n, e, t, a) {
        return i(s(a, {
            kK: xs(A2(um, e, n))
        }), A2(Sv, As, ma(m([
            A3(Lh, r, e, t),
            A2(em, r, e)
        ]))));
    }), Ah = {
        $: 0
    }, Mh = F2(function(r, n) {
        return {
            r: b,
            by: n,
            cl: !1,
            a_: Ah,
            g2: Xc("by-team-dropdown"),
            E: r,
            bD: We,
            aF: !1,
            s: b,
            d$: Ic,
            cH: We,
            cW: "",
            eY: vt
        };
    }), Fh = function(r) {
        return {
            $: 3,
            a: r
        };
    }, Hh = function(r) {
        return {
            $: 2,
            a: r
        };
    }, Th = F6(function(r, n, e, t, a, u) {
        return {
            g7: t,
            jM: n,
            ka: e,
            cF: u,
            T: a,
            iL: r
        };
    }), Sh = function(r) {
        return zt(r.$ ? 3 : r.a);
    }, Eh = function(r) {
        return r ? 0 : 1;
    }, zh = A2(St, Eh, wu), Rh = A7(ku, Th, A2(tu, "username", Jv), A2(xu, Nv, jc(A2(tu, "userFirstName", Qv))), A2(xu, Zv, jc(A2(tu, "userLastName", Yv))), A2(tu, "userExternalId", $$), A2(tu, "loginReminderEnabled", zh), A2(xu, Sh, jc(A2(tu, "loginReminderCadence", uu)))), Vh = A2(tu, "users", sl(Rh)), Wh = F2(function(r, n) {
        var e = mf(m([
            "enterprise-grant",
            n,
            "login-reminders"
        ]));
        return A3(Ol, r, e, Vh);
    }), Ph = F2(function(r, n) {
        var e = A2(Wh, r, n), t = A3(Cl, Hh, Es(Fh(We)), Fh(Ve(Ss)));
        return A2(wl, t, e);
    }), Gh = function(r) {
        return {
            $: 1,
            a: r
        };
    }, Ih = function(r) {
        return {
            $: 0,
            a: r
        };
    }, Nh = F2(function(r, n) {
        var e = A2(th, r, n), t = A3(Cl, Ih, Es(Gh(We)), Gh(Ve(Ss)));
        return A2(wl, t, e);
    }), Zh = F3(function(r, n, e) {
        return i(A2(Mh, e, n), ma(m([
            A2(Ph, r, e),
            A2(Nh, r, e)
        ])));
    }), Dh = F4(function(r, n, e, t) {
        var a = A3(Zh, n, t, e), u = a.b;
        return i(s(r, {
            kK: us(a.a)
        }), A2(Sv, os, u));
    }), _h = {
        $: 0
    }, Oh = {
        bw: 1,
        a8: We,
        bg: "",
        cU: We,
        c8: "",
        ap: _h
    }, qh = function(r) {
        return s(r, {
            gW: We,
            fI: vt,
            hy: We,
            kK: Wi(Oh)
        });
    }, Kh = function(r) {
        return {
            $: 3,
            a: r
        };
    }, Uh = function(r) {
        return {
            $: 2,
            a: r
        };
    }, Bh = F4(function(r, n, e, t) {
        return {
            g7: t,
            jM: r,
            d_: e,
            ka: n
        };
    }), Qh = A5(hc, Bh, A2(tu, "firstName", wc), A2(tu, "lastName", wc), A2(tu, "isRecipient", wu), A2(tu, "externalId", $$)), Yh = A2(tu, "seatAdmins", sl(Qh)), Jh = F2(function(r, n) {
        return mf(A2(aa, Vt, m([
            "enterprise-grant",
            r,
            "recipients",
            n
        ])));
    }), Xh = F3(function(r, n, e) {
        return A3(Ol, r, A2(Jh, n, e), Yh);
    }), rw = F3(function(r, n, e) {
        var t = A3(Xh, r, n, e), a = A3(Cl, Uh, Es(Kh(We)), Kh(Ve(Ss)));
        return A2(wl, a, t);
    }), nw = function(r) {
        return {
            $: 9,
            a: r
        };
    }, ew = function(r) {
        return {
            $: 8,
            a: r
        };
    }, tw = F8(function(r, n, e, t, a, u, c, o) {
        return {
            g7: n,
            kv: r,
            kV: a,
            h5: t,
            kW: e,
            k_: o,
            bl: u,
            b9: c
        };
    }), aw = A2(St, Vt, wc), uw = A2(St, Vt, wc), cw = lr, ow = sl(wc), iw = A2(St, Vt, wc), fw = function(r) {
        switch(r){
            case "monthly":
                return 1;
            case "quarterly":
                return 2;
            default:
                return 0;
        }
    }, sw = A2(St, fw, wc), lw = function(r) {
        return {
            $: 1,
            a: r
        };
    }, bw = A2(St, function(r) {
        switch(r){
            case "static":
            default:
                return hb(We);
            case "recurring":
                return lw(We);
        }
    }, A2(tu, "reportType", wc)), dw = A9(cw, tw, A2(tu, "reportName", aw), A2(tu, "reportExternalId", uw), jc(A2(tu, "reportResultId", iw)), bw, A2(tu, "reportRecipients", Om(ow)), zt(1), zt({
        $: 0
    }), jc(A2(tu, "reportSchedule", sw))), vw = F2(function(r, n) {
        return mf(A2(aa, Vt, m([
            "enterprise-grant",
            r,
            "custom-report",
            n
        ])));
    }), mw = F3(function(r, n, e) {
        return A3(Ol, r, A2(vw, n, e), dw);
    }), gw = F3(function(r, n, e) {
        var t = A3(mw, r, n, e), a = A3(Cl, ew, Es(nw(We)), nw(Ve(Ss)));
        return A2(wl, a, t);
    }), pw = {
        $: 0
    }, $w = F4(function(r, n, e, t) {
        return {
            by: e,
            E: n,
            h4: 2,
            gb: t,
            eH: We,
            eJ: 0,
            ao: pw,
            gp: r,
            fi: 0
        };
    }), hw = F4(function(r, n, e, t) {
        return i(A4($w, r, n, e, t), ma(m([
            A3(gw, r, n, t),
            A3(rw, r, n, t)
        ])));
    }), ww = F5(function(r, n, e, t, a) {
        var u, c = A4(hw, n, e, t, a), o = c.b, f = 16 === (u = r.kK).$ ? u.a : c.a;
        return i(s(r, {
            kK: Bf(f)
        }), A2(Sv, hs, o));
    }), Cw = F3(function(r, n, e) {
        var t = s(n, {
            fj: e
        });
        return i(s(r, {
            gW: Ve(t),
            kK: Sc
        }), su);
    }), kw = function(r) {
        return {
            $: 25,
            a: r
        };
    }, yw = function(r) {
        return {
            $: 24,
            a: r
        };
    }, xw = F3(function(r, n, e) {
        var t = A3(mw, r, n, e), a = A3(Cl, yw, Es(kw(We)), kw(Ve(Ss)));
        return A2(wl, a, t);
    }), Lw = F5(function(r, n, e, t, a) {
        var u, c = A3(Ev, n, e, t), o = c.b, f = 14 === (u = r.kK).$ ? u.a : c.a;
        return i(s(r, {
            kK: Qf(f)
        }), A2(Sv, Kf, ma(m([
            o,
            A3(xw, n, e, a)
        ]))));
    }), jw = F3(function(r, n, e) {
        var t = F4(function(r, t, a, u) {
            var c, o = u.a, f = u.b, s = 1 === (c = i(n.gW, r)).a.$ ? c.b.$ ? A3(t$, e.gp, t, a) : A4(c$, e.gp, c.b.a, t, a) : su;
            return i(o, ma(m([
                s,
                f
            ])));
        }), a = A2(yo, yi, r);
        if (a.$) return i(qh(n), Nf(0));
        var u = i(a.a, e.js);
        switch(u.a.$){
            case 0:
                return i(n, u.b ? A2(vm, n.hr, xo) : A3(t$, e.gp, We, Fc));
            case 2:
                return i(s(n, {
                    kK: Of(mm)
                }), su);
            case 1:
                return i(n, A2(vm, n.hr, Mo));
            case 3:
                switch(u.a.b.$){
                    case 13:
                        var c = u.a.a, o = i(n.gW, n.kK);
                        return o.a.$ || 2 !== o.b.$ ? i(s(n, {
                            kK: zc(ro(Vc))
                        }), A3(t$, e.gp, Ve(c), zl)) : A3(Cw, n, o.a.a, zl);
                    case 14:
                        return i(s(n, {
                            kK: Pc(A2(Oc, Vc, c = u.a.a))
                        }), A3(t$, e.gp, Ve(c), Pl));
                    case 15:
                        return i(s(n, {
                            kK: Rc(A2(Dc, Vc, c = u.a.a))
                        }), A3(t$, e.gp, Ve(c), Rl));
                    case 16:
                        return i(s(n, {
                            kK: Hc(A3(Nc, Vc, We, Ec(c = u.a.a)))
                        }), A3(t$, e.gp, Ve(c), Vl(We)));
                    case 0:
                        return A4(t, We, Ve(c = u.a.a), Rl, A4(oh, e.gp, Vc, c, n));
                    case 1:
                        var f = u.a, l = f.b.a;
                        return A4(t, We, Ve(c = f.a), Rl, A5(G$, e.gp, Vc, c, l, n));
                    case 2:
                        var b = u.a;
                        return l = b.b.a, A4(t, We, Ve(c = b.a), Rl, A6(Yp, e.gp, Vc, c, l, n, Gl(l)));
                    case 3:
                        var d = u.a;
                        return l = d.b.a, A4(t, We, Ve(c = d.a), Rl, A6(Zg, e.gp, Vc, c, l, n, El));
                    case 4:
                        var v = u.a, g = v.b.a;
                        return A4(t, We, Ve(c = v.a), Rl, A5(ch, e.gp, Vc, c, g, n));
                    case 5:
                        var p = u.a, $ = p.b.a;
                        return A4(t, We, Ve(c = p.a), Pl, A5(kh, e.gp, Vc, c, $, n));
                    case 6:
                        return A4(t, We, Ve(c = u.a.a), Pl, A4(cm, n, e.gp, c, Vc));
                    case 7:
                        var h = u.a;
                        return $ = h.b.a, A4(t, We, Ve(c = h.a), Pl, A5(jh, e.gp, Vc, c, $, n));
                    case 8:
                        var w = u.a, C = w.b, k = ($ = C.a, C.b);
                        return A4(t, We, Ve(c = w.a), Pl, A6(P$, n, e.gp, Vc, k, c, Ve($)));
                    case 12:
                        var y = u.a;
                        return k = y.b.a, A4(t, We, Ve(c = y.a), zl, A6(P$, n, e.gp, Vc, k, c, We));
                    case 9:
                        return A4(t, We, Ve(c = u.a.a), Vl(We), A4(zv, n, e.gp, c, Vc));
                    case 10:
                        var x = u.a, L = x.b.a;
                        return A4(t, We, Ve(c = x.a), Vl(Ve(L)), A5(ww, n, e.gp, c, Vc, L));
                    case 11:
                        var j = u.a;
                        return L = j.b.a, A4(t, We, Ve(c = j.a), Vl(Ve(L)), A5(Lw, n, e.gp, c, Vc, L));
                    case 17:
                        return A4(t, We, Ve(c = u.a.a), zl, A4(Dh, n, e.gp, c, Vc));
                    case 18:
                        return c = u.a.a, n.gW.$ ? A4(t, We, Ve(c), Fc, A5(Qp, n, e.gp, n.fk, c, Vc)) : A5(Qp, n, e.gp, n.fk, c, Vc);
                    default:
                        return A4(t, We, Ve(c = u.a.a), Wl, A4(gh, n, c, Vc, e.gp));
                }
            default:
                switch(u.a.c.$){
                    case 0:
                        var A = u.a;
                        return c = A.b, A4(t, Ve(G = A.a), Ve(c), Rl, A4(oh, e.gp, Tc(G), c, n));
                    case 1:
                        var M = u.a;
                        return c = M.b, l = M.c.a, A4(t, Ve(G = M.a), Ve(c), Rl, A5(G$, e.gp, Tc(G), c, l, n));
                    case 2:
                        var F = u.a;
                        return c = F.b, l = F.c.a, A4(t, Ve(G = F.a), Ve(c), Rl, A6(Yp, e.gp, Tc(G), c, l, n, Gl(l)));
                    case 3:
                        var H = u.a;
                        return c = H.b, l = H.c.a, A4(t, Ve(G = H.a), Ve(c), Rl, A6(Zg, e.gp, Tc(G), c, l, n, El));
                    case 4:
                        var T = u.a;
                        return c = T.b, g = T.c.a, A4(t, Ve(G = T.a), Ve(c), Rl, A5(ch, e.gp, Tc(G), c, g, n));
                    case 5:
                        var S = u.a;
                        return c = S.b, $ = S.c.a, A4(t, Ve(G = S.a), Ve(c), Pl, A5(kh, e.gp, Tc(G), c, $, n));
                    case 6:
                        var E = u.a;
                        return c = E.b, A4(t, Ve(G = E.a), Ve(c), Pl, A4(cm, n, e.gp, c, Tc(G)));
                    case 7:
                        var z = u.a;
                        return c = z.b, $ = z.c.a, A4(t, Ve(G = z.a), Ve(c), Pl, A5(jh, e.gp, Tc(G), c, $, n));
                    case 8:
                        var R = u.a, V = (c = R.b, R.c);
                        return $ = V.a, k = V.b, A4(t, Ve(G = R.a), Ve(c), Pl, A6(P$, n, e.gp, Tc(G), k, c, Ve($)));
                    case 12:
                        var W = u.a;
                        return c = W.b, k = W.c.a, A4(t, Ve(G = W.a), Ve(c), zl, A6(P$, n, e.gp, Tc(G), k, c, We));
                    case 13:
                        var P = u.a, G = P.a, I = (c = P.b, i(n.gW, n.kK));
                        return I.a.$ || 2 !== I.b.$ ? i(s(n, {
                            kK: zc(ro(Tc(G)))
                        }), A4(c$, e.gp, G, Ve(c), zl)) : A3(Cw, n, I.a.a, zl);
                    case 14:
                        var N = u.a;
                        return c = N.b, i(s(n, {
                            kK: Pc(A2(Oc, Tc(G = N.a), c))
                        }), A4(c$, e.gp, G, Ve(c), Pl));
                    case 15:
                        var Z = u.a;
                        return c = Z.b, i(s(n, {
                            kK: Rc(A2(Dc, Tc(G = Z.a), c))
                        }), A4(c$, e.gp, G, Ve(c), Rl));
                    case 16:
                        var D = u.a;
                        return c = D.b, i(s(n, {
                            kK: Hc(A3(Nc, Tc(G = D.a), We, Ec(c)))
                        }), A4(c$, e.gp, G, Ve(c), Vl(We)));
                    case 9:
                        var _ = u.a;
                        return c = _.b, A4(t, Ve(G = _.a), Ve(c), Vl(We), A4(zv, n, e.gp, c, Tc(G)));
                    case 10:
                        var O = u.a;
                        return c = O.b, L = O.c.a, A4(t, Ve(G = O.a), Ve(c), Vl(Ve(L)), A5(ww, n, e.gp, c, Tc(G), L));
                    case 11:
                        var q = u.a;
                        return c = q.b, L = q.c.a, A4(t, Ve(G = q.a), Ve(c), Vl(Ve(L)), A5(Lw, n, e.gp, c, Tc(G), L));
                    case 17:
                        var K = u.a;
                        return c = K.b, A4(t, Ve(G = K.a), Ve(c), zl, A4(Dh, n, e.gp, c, Tc(G)));
                    case 18:
                        var U = u.a;
                        return c = U.b, A4(t, Ve(G = U.a), Ve(c), Fc, A5(Qp, n, e.gp, n.fk, c, Tc(G)));
                    default:
                        var B = u.a;
                        return c = B.b, A4(t, Ve(G = B.a), Ve(c), Wl, A4(gh, n, c, Tc(G), e.gp));
                }
        }
    }), Aw = function(r) {
        return {
            $: 29,
            a: r
        };
    }, Mw = function(r) {
        switch(r){
            case 0:
                return "All";
            case 1:
                return "Active";
            default:
                return "Archived";
        }
    }, Fw = F2(function(r, n) {
        return {
            i_: "",
            i$: b,
            i0: "",
            jh: "",
            ji: b,
            jj: "",
            jO: !0,
            j6: "",
            j7: b,
            kk: "",
            kl: b,
            hP: r,
            kP: " ",
            kQ: "",
            kR: b,
            k0: "",
            k1: b,
            iz: n,
            lk: "",
            ll: b
        };
    }), Hw = F2(function(r, n) {
        return A2(Fw, r, n);
    }), Tw = F2(function(r, n) {
        return r(n);
    }), Sw = F2(function(r, n) {
        return A2(Tw, function(n) {
            return s(n, {
                jO: r
            });
        }, n);
    }), Ew = F2(function(r, n) {
        return A2(Tw, function(n) {
            return s(n, {
                j6: r
            });
        }, n);
    }), zw = F2(function(r, n) {
        return A2(Tw, function(n) {
            return s(n, {
                kk: r
            });
        }, n);
    }), Rw = F2(function(r, n) {
        return A2(Tw, function(n) {
            return s(n, {
                kP: r
            });
        }, n);
    }), Vw = F2(function(r, n) {
        return A2(Tw, function(n) {
            return s(n, {
                lk: r
            });
        }, n);
    }), Ww = A2(Vw, "btn btn-secondary dropdown-toggle text-left elm-dropdown-trigger", A2(zw, "elm-dropdown-menu", A2(Ew, "elm-dropdown-item", A2(Sw, !1, A2(Rw, "Filter Subscriptions", A2(Hw, Aw, Mw)))))), Pw = F3(function(r, n, e) {
        for(;;){
            var t = A2(xt, ot, r), a = t.a, u = t.b;
            if (0 > c(Ct(a), ot)) return A2(Mt, !0, {
                p: n,
                k: e,
                m: a
            });
            r = u, n = A2(ye, gt(a), n), e += 1;
        }
    }), Gw = function(r) {
        return r.b ? A3(Pw, r, b, 0) : vt;
    }, Iw = F2(function(r, n) {
        return Gw(A3(Ae, F2(function(n, e) {
            return r(n) ? A2(ye, n, e) : e;
        }), b, n));
    }), Nw = F2(function(r, n) {
        if (1 === r.$) return n;
        switch(r.a){
            case 0:
                return n;
            case 2:
                return A2(Iw, function(r) {
                    return !r.bG.iY;
                }, n);
            default:
                return A2(Iw, function(r) {
                    return 1 === r.bG.iY;
                }, n);
        }
    }), Zw = F2(function(r, n) {
        for(;;){
            if (!n.b) return We;
            var e = n.a, t = n.b;
            if (r(e)) return Ve(e);
            n = t;
        }
    }), Dw = function(r) {
        return A2(wa, Be($v), Zw(A2(wa, nu, r)));
    }, _w = function(r) {
        return A2(wa, Me, Dw(r));
    }, Ow = A2(tu, "message", wc), qw = function(r) {
        switch(r.$){
            case 0:
                return r.a;
            case 1:
                return "Request Timeout. Please contact support.";
            case 2:
                return "Network Error. Please contact support.";
            default:
                return A2(mu, "An unknown error occured. Please contact support.", A2(Ca, Ow, r.b));
        }
    }, Kw = Xr("captureException", _i), Uw = Xr("logout", function() {
        return If;
    }), Bw = F3(function(r, n, e) {
        if (1 !== n.$) return e(n.a);
        switch(n.a.$){
            case 0:
                return i(qh(r), Uw(0));
            case 2:
                var t = n.a.a;
                return i(s(r, {
                    kK: as(t)
                }), Kw(qw(t)));
            default:
                return i(r, su);
        }
    }), Qw = function(r) {
        return {
            $: 4,
            a: r
        };
    }, Yw = F3(function(r, n, e) {
        return {
            cX: n,
            gh: e,
            im: r
        };
    }), Jw = A2(xu, function(r) {
        switch(r){
            case "complete":
                return zt(1);
            case "incomplete":
                return zt(0);
            case "skipped":
                return zt(2);
            default:
                return Us("Unknown step status string of " + r);
        }
    }, wc), Xw = A7(ku, F6(function(r, n, e, t, a, u) {
        return m([
            A3(Yw, 0, !1, r),
            A3(Yw, 2, !1, e),
            A3(Yw, 1, !1, n),
            A3(Yw, 3, !1, t),
            A3(Yw, 4, !1, a),
            A3(Yw, 5, !1, u)
        ]);
    }), A2(tu, "createTeamStatus", Jw), A2(tu, "buildModuleStatus", Jw), A2(tu, "inviteUserStatus", Jw), A2(tu, "enableLearningRemindersStatus", Jw), A2(tu, "assignModuleStatus", Jw), A2(tu, "establishCustomReportStatus", Jw)), rC = F4(function(r, n, e, t) {
        var a = {
            gJ: e,
            by: n,
            dM: t,
            gp: r.gp
        }, u = Ml(m([
            A2(R$, "enterprise-grant", t)
        ]));
        return i(a, A3(Wf, r.gp, "onboard-status" + u, A2(lf, Qw, Xw)));
    }), nC = F4(function(r, n, e, t) {
        var a = A2(Si, A2(Hi, Vc, Fc), t), u = A2(Mi, 0, a);
        if (u.$) return i(r, su);
        var c = u.a, o = r.iJ, f = A2(dm, r.hr, A3(Hl, Xf, Vc, c.bG.jW)), l = s(o, {
            iK: c.bG.iK
        }), b = A4(rC, n, r.by, Sl(r.fk), c.bG.jW), d = b.a, v = b.b, g = A5(Qp, r, n.gp, r.fk, c.bG.jW, Vc), p = g.b;
        return i(s(g.a, {
            by: Vc,
            gQ: e,
            gW: Ve(c),
            fI: a,
            hy: Ve(n),
            hQ: Ve(d),
            iJ: l
        }), ma(m([
            p,
            f,
            A2(Sv, ps, v)
        ])));
    }), eC = F2(function(r, n) {
        return i(r, n.js ? A2(vm, r.hr, xo) : A3(t$, n.gp, r.iJ.kb, Fc));
    }), tC = function(r) {
        return {
            $: 23,
            a: r
        };
    }, aC = function(r) {
        return {
            $: 22,
            a: r
        };
    }, uC = function(r) {
        return {
            $: 21,
            a: r
        };
    }, cC = function(r) {
        var n = Bl(r), e = A3(Cl, uC, Es(aC(We)), aC(Ve(Ss)));
        return A2(wl, e, n);
    }, oC = function(r) {
        return {
            $: 4,
            a: r
        };
    }, iC = function(r) {
        return {
            $: 3,
            a: r
        };
    }, fC = function(r) {
        return mf(A2(aa, Vt, m([
            "enterprise-grant",
            r,
            "custom-report"
        ])));
    }, sC = A2(tu, "customReportResponse", sl(dw)), lC = F2(function(r, n) {
        return A3(Ol, r, fC(n), sC);
    }), bC = function(r) {
        return r.$ ? r.a.jW : r.a;
    }, dC = F2(function(r, n) {
        var e = A2(lC, r, bC(n)), t = A3(Cl, iC, Es(oC(We)), oC(Ve(Ss)));
        return A2(wl, t, e);
    }), vC = F4(function(r, n, e, t) {
        return i(A3(Nc, n, t, e), ma(m([
            A2(dC, r, e),
            cC(r),
            A2(da, tC, gb)
        ])));
    }), mC = function(r) {
        return {
            $: 3,
            a: r
        };
    }, gC = function(r) {
        return {
            $: 2,
            a: r
        };
    }, pC = A2(tu, "modules", sl(Sg)), $C = F2(function(r, n) {
        return A3(Ol, r, mf(A2(aa, Vt, m([
            "enterprise-grant",
            n,
            "modules"
        ]))), pC);
    }), hC = F2(function(r, n) {
        var e = A2($C, r, n.E), t = A3(Cl, gC, Es(mC(We)), mC(Ve(Ss)));
        return A2(wl, t, e);
    }), wC = F3(function(r, n, e) {
        var t = A2(Dc, n, e);
        return i(t, A2(hC, r, t));
    }), CC = function(r) {
        return {
            $: 2,
            a: r
        };
    }, kC = function(r) {
        return {
            $: 1,
            a: r
        };
    }, yC = F2(function(r, n) {
        var e = A2(th, r, n), t = A3(Cl, kC, Es(CC(We)), CC(Ve(Ss)));
        return A2(wl, t, e);
    }), xC = F3(function(r, n, e) {
        var t = A2(Oc, n, e.jW);
        return i(t, A2(yC, r, t.E));
    }), LC = function(r) {
        return {
            $: 0,
            a: r
        };
    }, jC = function(r) {
        return {
            $: 2,
            a: r
        };
    }, AC = {
        $: 1
    }, MC = function(r) {
        switch(r.$){
            case 0:
                return Fe(Is(r.a));
            case 1:
                return Fe(Zs);
            case 2:
                return Fe(Ns);
            case 3:
                return Fe(A2(Gs, r.a, r.b));
            default:
                return Ee(0);
        }
    }, FC = F2(function(r, n) {
        return A5(Ws, "PATCH", bf, r, n, _s(MC));
    }), HC = F2(function(r, n) {
        var e = mf(m([
            "enterprise-grant",
            n,
            "user-config"
        ]));
        return A2(FC, r, e);
    }), TC = F2(function(r, n) {
        var e = A2(HC, r, n), t = A3(Cl, Es(AC), A2($l, jC, Ts), jC(Ss));
        return A2(wl, t, e);
    }), SC = F3(function(r, n, e) {
        var t = n.bG.jW, a = A3(wC, r, n.by, t), u = a.b;
        return i(s(n, {
            fj: e,
            bU: a.a
        }), ma(m([
            A2(Sv, LC, u),
            A2(TC, r, t)
        ])));
    }), EC = F3(function(r, n, e) {
        return r.$ ? A3(Lo, r.a, n, e) : A2(jo, n, e);
    }), zC = F2(function(r, n) {
        switch(n.fj.$){
            case 0:
                return A2(vm, r.hr, A3(EC, r.by, n.bG.jW, _o));
            case 2:
                return A2(vm, r.hr, A3(EC, r.by, n.bG.jW, Jo));
            case 1:
                return A2(vm, r.hr, A3(EC, r.by, n.bG.jW, Vo));
            case 4:
                return A2(vm, r.hr, A3(EC, r.by, n.bG.jW, No));
            case 3:
                return A2(vm, r.hr, A3(EC, r.by, n.bG.jW, Ko));
            default:
                return A2(vm, r.hr, A3(EC, r.by, n.bG.jW, Bo));
        }
    }), RC = y, VC = F4(function(r, n, e, t) {
        var a = xi & n >>> r, u = A2(Li, a, t);
        return A3(RC, a, u.$ ? gt(A3(RC, xi & n, e, u.a)) : yt(A4(VC, r - dt, n, e, u.a)), t);
    }), WC = F3(function(r, n, e) {
        var t = e.a, a = e.b, u = e.c, o = e.d;
        return 0 > r || c(r, t) > -1 ? e : c(r, Ai(t)) > -1 ? A4(it, t, a, u, A3(RC, xi & r, n, o)) : A4(it, t, a, A4(VC, a, r, n, u), o);
    }), PC = F5(function(r, n, t, a, u) {
        var c = A2(_w, function(r) {
            return 1 === t.$ || e(r.bG.jW, t.a);
        }, u.fI);
        if (c.$) return i(u, su);
        var o = c.a, f = o.a, l = A3(SC, n, o.b, a), b = l.a, d = A2(Sv, ts, l.b), v = A3(WC, f, b, u.fI), g = function() {
            var t = i(u.gW, u.kK);
            if (t.a.$ || 2 !== t.b.$) {
                var c = i(a, u.kK);
                if (4 === c.a.$ && 1 === c.b.$) {
                    var o = c.b.a, f = A2(dm, u.hr, A3(Hl, Xf, u.by, b.bG.jW)), l = s(o, {
                        dL: b.bG.jl
                    }), v = s(u, {
                        kK: Jf(l)
                    }), g = A5(Qp, v, n, r, b.bG.jW, v.by);
                    return i(g.a.kK, ma(m([
                        g.b,
                        f
                    ])));
                }
                return i(u.kK, d);
            }
            return e(t.a.a.bG.jW, b.bG.jW) ? i(Sc, d) : i(Sc, ma(m([
                A2(zC, u, b),
                d
            ])));
        }(), p = g.a, $ = g.b;
        return i(s(u, {
            gW: Ve(b),
            fI: v,
            kK: p
        }), $);
    }), GC = F8(function(r, n, e, t, a, u, c, o) {
        var i = s(o, {
            by: e,
            gQ: c,
            fI: A2(Si, A2(Hi, e, u), t)
        });
        return A5(PC, r, n, a, u, i);
    }), IC = Xr("newTab", _i), NC = Xr("openZendesk", function() {
        return If;
    }), ZC = NC(0), DC = function(r) {
        return {
            $: 1,
            a: r
        };
    }, _C = function(r) {
        return {
            $: 0,
            a: r
        };
    }, OC = F2(function(r, n) {
        var e = A2(nm, r, n), t = A3(Cl, _C, function(r) {
            return DC(Ve(Ts(r)));
        }, DC(Ve(Ss)));
        return A2(wl, t, e);
    }), qC = function(r) {
        return s(r, {
            hR: 1
        });
    }, KC = F3(function(r, n, e) {
        return 1 === e.$ ? r : n(e.a);
    }), UC = function(r) {
        return {
            $: 3,
            a: r
        };
    }, BC = function(r) {
        return {
            $: 2,
            a: r
        };
    }, QC = function(r) {
        return {
            $: 0,
            a: r
        };
    }, YC = {
        $: 4
    }, JC = function(r) {
        return {
            $: 1,
            a: r
        };
    }, XC = function(r) {
        return {
            $: 7,
            a: r
        };
    }, rk = function(r) {
        return {
            $: 8,
            a: r
        };
    }, nk = F2(function(r, n) {
        return {
            g7: n,
            kv: r
        };
    }), ek = A2(St, Vt, wc), tk = A2(St, Vt, wc), ak = A3(Et, nk, cu(m([
        A2(tu, "companyName", tk),
        A2(tu, "name", tk)
    ])), A2(tu, "externalId", ek)), uk = r$(ak), ck = function(r) {
        return r;
    }, ok = F2(function(r, n) {
        return mf(m([
            A2(S$, m([
                r,
                "search"
            ]), m([
                A2(R$, "query", n)
            ]))
        ]));
    }), ik = F2(function(r, n) {
        var e = A3(Et, F2(function(r, n) {
            return i(r, n);
        }), A2(tu, "results", uk), A2(tu, "moreResults", uk));
        return A3(Ol, r, A2(ok, "companies", n), e);
    }), fk = F4(function(r, n, e, t) {
        switch(e.$){
            case 0:
                return QC(e.a);
            case 1:
                var a = e.a;
                return JC(i(s(t, {
                    b1: a
                }), (o = i(a, t.aY)).a || 1 !== o.b.$ ? su : A2(wl, A3(Cl, BC, UC, YC), function(r) {
                    return A3(Ol, r, "companies", uk);
                }(n))));
            case 2:
                return JC(i(s(t, {
                    aY: Ve(JC(A2(Si, ck, e.a)))
                }), su));
            case 3:
                return JC(i(s(t, {
                    aY: Ve(QC(e.a))
                }), su));
            case 4:
                return JC(i(s(t, {
                    aY: We
                }), A2(vm, r, Mo)));
            case 5:
                return JC(i(s(t, {
                    eR: e.a
                }), su));
            case 6:
                return JC(i(t, A2(wl, A3(Cl, XC, rk, YC), A2(ik, n, t.eR))));
            case 7:
                var u = e.a, c = u.b;
                return JC(i(s(t, {
                    cV: Ve(JC(i(A2(Si, ck, u.a), A2(Si, ck, c))))
                }), su));
            default:
                return JC(i(s(t, {
                    cV: Ve(QC(e.a))
                }), su));
        }
        var o;
    }), sk = {
        $: 11
    }, lk = function(r) {
        return {
            $: 10,
            a: r
        };
    }, bk = F2(function(r, n) {
        return {
            $: 3,
            a: r,
            b: n
        };
    }), dk = function(r) {
        return {
            $: 22,
            a: r
        };
    }, vk = function(r) {
        return {
            $: 23,
            a: r
        };
    }, mk = {
        $: 2
    }, gk = {
        $: 1
    }, pk = function(r) {
        return r;
    }, $k = F2(function(r, n) {
        return A3(_e, function(r) {
            return F2(function(n, e) {
                return e.push(r(n)), e;
            });
        }(r), [], n);
    }), hk = Xr("downloadCsv", function(r) {
        var n = r.b;
        return A2($k, Vt, m([
            _i(r.a),
            _i(n)
        ]));
    }), wk = F2(function(r, n) {
        return hk(i(r + ".csv", n));
    }), Ck = function(r) {
        switch(r.$){
            case 0:
                return Fe(Is(r.a));
            case 1:
                return Fe(Zs);
            case 2:
                return Fe(Ns);
            case 3:
                return Fe(A2(Gs, r.a, r.b));
            default:
                return Ee(r.b);
        }
    }, kk = F4(function(r, n, e, t) {
        return Vs({
            bv: n,
            bH: m([
                A2(df, "Authorization", "Bearer " + e),
                A2(df, "accept", "text/csv")
            ]),
            bS: r,
            gc: _s(Ck),
            b4: Vf,
            b5: $f(m([
                t
            ]))
        });
    }), yk = F2(function(r, n) {
        return mf(A2(aa, Vt, m([
            "enterprise-grant",
            r,
            "custom-report",
            "download",
            n
        ])));
    }), xk = F3(function(r, n, e) {
        return A4(kk, "GET", bf, r, A2(yk, n, e));
    }), Lk = F3(function(r, n, e) {
        var t = e;
        switch(r){
            case 0:
                return A3(Lk, 1, 12 * n, t);
            case 1:
                var a = jb(t), u = 12 * (a.iU - 1) + (wb(a.hG) - 1) + n, c = Cb(A2(La, 12, u) + 1), o = A2(eb, u, 12) + 1;
                return tb(o) + A2(nb, o, c) + A2(Kb, a.gZ, A2(ab, o, c));
            case 2:
                return t + 7 * n;
            default:
                return t + n;
        }
    }), jk = function(r) {
        switch(r){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            default:
                return 7;
        }
    }, Ak = F2(function(r, n) {
        return A2(La, 7, Ib(n) + 7 - jk(r));
    }), Mk = F2(function(r, n) {
        return tb(r) + A2(nb, r, n) + 1;
    }), Fk = F2(function(r, n) {
        var e, t = n;
        switch(r){
            case 0:
                return dv(xb(n));
            case 1:
                return A2(Mk, xb(n), (e = Pb(n), Cb(3 * e - 2)));
            case 2:
                return A2(Mk, xb(n), Mb(n));
            case 3:
            case 4:
                return t - A2(Ak, 0, n);
            case 5:
                return t - A2(Ak, 1, n);
            case 6:
                return t - A2(Ak, 2, n);
            case 7:
                return t - A2(Ak, 3, n);
            case 8:
                return t - A2(Ak, 4, n);
            case 9:
                return t - A2(Ak, 5, n);
            case 10:
                return t - A2(Ak, 6, n);
            default:
                return n;
        }
    }), Hk = function(r) {
        switch(r){
            case 0:
                return i(1, 0);
            case 1:
                return i(3, 1);
            case 2:
                return i(1, 1);
            case 11:
                return i(1, 3);
            default:
                return i(1, 2);
        }
    }, Tk = F2(function(r, n) {
        var t = A2(Fk, r, n);
        if (e(n, t)) return n;
        var a = Hk(r);
        return A3(Lk, a.b, a.a, t);
    }), Sk = function(r) {
        return A2(Yd, "yyyy-MM-dd", r);
    }, Ek = F3(function(r, n, e) {
        var t = vv(r) ? 53 : 52;
        return Nb(r) + 7 * (A3(Jl, 1, t, n) - 1) + jk(e);
    }), zk = function(r) {
        return r;
    }, Rk = function(r) {
        return r;
    }, Vk = F2(function(r, n) {
        if (n.$) return "";
        var e = n.a;
        if (e.$) return "";
        var t = e.a, a = xb(r);
        switch(t.$){
            case 0:
                var u = _b(r), c = u - 1 ? i(a, u - 1) : i(a - 1, 52);
                return Sk(s = A3(Lk, 3, 1, A3(Lk, 2, -1, l = A3(Ek, c.a, c.b, 6)))) + " to " + Sk(l);
            case 1:
                var o = Mb(r), f = A2(Tk, 2, b = A3(ub, a, o, 1)), s = A3(Lk, 1, -1, b), l = A3(Lk, 3, -1, f);
                return Sk(s) + " to " + Sk(l);
            case 2:
                var b;
                return s = A3(Lk, 1, -3, b = A2(Fk, 1, r)), l = A3(Lk, 3, -1, A2(Tk, 1, b)), Sk(s) + " to " + Sk(l);
            default:
                s = t.a, l = t.b;
                var d = A2(Ba, A2($l, Sk, Rk), s), v = A2(Ba, A2($l, Sk, zk), l);
                return A2(di, "", d) + " to " + A2(di, "", v);
        }
    }), Wk = function(r) {
        switch(r){
            case 0:
                return "Learning Pace";
            case 1:
                return "Login";
            case 2:
                return "Viewing Activity";
            case 3:
                return "Assignments";
            case 4:
                return "Assessments";
            case 5:
                return "Course Completions";
            default:
                return "Practice Labs";
        }
    }, Pk = F3(function(r, n, e) {
        return A2(di, "", A2(Ba, Vk(r), n)) + " " + Wk(e);
    }), Gk = F3(function(r, n, e) {
        return A2(vm, r, A3(EC, n, e, Ko));
    }), Ik = F4(function(r, n, e, t) {
        return A2(vm, r, A3(EC, n, e, Uo(t)));
    }), Nk = function(r) {
        switch(r){
            case 0:
                return "Weekly";
            case 1:
                return "Monthly";
            default:
                return "Quarterly";
        }
    }, Zk = {
        $: 9
    }, Dk = F2(function(r, n) {
        return {
            $: 8,
            a: r,
            b: n
        };
    }), _k = F2(function(r, n) {
        return {
            g7: r,
            kW: n
        };
    }), Ok = A2(St, Vt, wc), qk = A3(Et, _k, A2(tu, "reportExternalId", uw), A2(tu, "reportResultExternalId", Om(Ok))), Kk = function(r) {
        return _i(function() {
            switch(r){
                case 0:
                    return "learning-pace-report";
                case 1:
                    return "login-report";
                case 2:
                    return "viewing-activity-report";
                case 3:
                    return "assignments-report";
                case 4:
                    return "assessments-report";
                case 5:
                    return "course-completions-report";
                default:
                    return "practice-labs-report";
            }
        }());
    }, Uk = A2($l, _i, pk), Bk = {
        $: 0
    }, Qk = Yd("yyyy-MM-dd"), Yk = function(r) {
        return Qk(r) + "T00:00:00Z";
    }, Jk = function(r) {
        return r.$ ? "recurring" : "static";
    }, Xk = A2($l, _i, Jk), ry = F3(function(r, n, e) {
        return A4(Ks, function(r) {
            var n, e, t;
            return Di(m([
                i("timeRange", (n = r.h5, t = n.$ ? i(function(r) {
                    switch(r){
                        case 0:
                            return "past_week";
                        case 1:
                            return "past_month";
                        default:
                            return "past_quarter";
                    }
                }(A2(di, 0, e = n.a)), b) : i(function(r) {
                    switch(r.$){
                        case 2:
                            return "past_quarter";
                        case 1:
                            return "past_month";
                        case 0:
                            return "past_week";
                        default:
                            return "interval";
                    }
                }(A2(di, Bk, e = n.a)), function() {
                    if (e.$ || 3 !== e.a.$ || e.a.a.$ || e.a.b.$) return b;
                    var r = e.a, n = r.b.a;
                    return m([
                        Yk(r.a.a),
                        Yk(A3(Lk, 3, 1, n))
                    ]);
                }()), Di(m([
                    i(t.a, A2($k, _i, t.b))
                ])))),
                i("type", Xk(r.h5)),
                i("dataSet", Kk(r.ju)),
                i("reportName", Uk(r.kv))
            ]));
        }(e), r, fC(n), qk);
    }), ny = F3(function(r, n, e) {
        var t = A3(ry, r, n, e), a = A3(Cl, function(r) {
            return A2(Dk, r.g7, r.kW);
        }, Es(Zk), Zk);
        return A2(wl, a, t);
    }), ey = {
        $: 1
    }, ty = function(r) {
        return {
            $: 1,
            a: r
        };
    }, ay = {
        $: 0
    }, uy = function(r) {
        return {
            $: 2,
            a: r
        };
    }, cy = F3(function(r, n, e) {
        var t = e, a = t.aG;
        switch(n.$){
            case 0:
                return i(s(t, {
                    P: Ve(u = n.a),
                    aO: u
                }), ay);
            case 1:
                return i(s(t, {
                    P: Ve(u = n.a)
                }), ay);
            case 2:
                var u = n.a;
                return i(s(t, {
                    P: We,
                    af: We,
                    cQ: !1
                }), uy(u));
            case 3:
                return i(s(t, {
                    af: Ve(n.a)
                }), ay);
            case 4:
                if (a) return i(t, ay);
                var c = function() {
                    var n = t.af;
                    if (1 === n.$) return ty(ey);
                    if ("" === n.a) return ty(ey);
                    var e = r.f2(n.a);
                    if (e.$) return ty({
                        $: 0,
                        a: e.a
                    });
                    var a = e.a;
                    return r.j4(a) ? ty({
                        $: 2,
                        a: a
                    }) : uy(a);
                }();
                return i(s(t, {
                    P: 2 === c.$ ? Ve(c.a) : t.P,
                    af: 2 === c.$ ? We : t.af
                }), c);
            case 5:
                return i(s(t, {
                    aG: !1,
                    cQ: !0
                }), ay);
            case 6:
                return i(s(t, {
                    cQ: a
                }), ay);
            case 7:
                return i(s(t, {
                    aG: !0
                }), ay);
            default:
                return i(s(t, {
                    aG: !1
                }), ay);
        }
    }), oy = function(r) {
        return {
            $: 6,
            a: r
        };
    }, iy = {
        $: 5
    }, fy = F3(function(r, n, e) {
        return A5(Ws, "PUT", qs(r), n, e, _s(MC));
    }), sy = F2(function(r, n) {
        return mf(A2(aa, Vt, m([
            "enterprise-grant",
            r,
            "custom-report",
            n,
            "name"
        ])));
    }), ly = F4(function(r, n, e, t) {
        return A3(fy, function(r) {
            return Di(m([
                i("reportName", Uk(r))
            ]));
        }(t), r, A2(sy, n, e));
    }), by = F4(function(r, n, e, t) {
        var a = A4(ly, r, n, e, t), u = A3(Cl, Es(iy), A2($l, oy, Ts), oy(Ss));
        return A2(wl, u, a);
    }), dy = Pr, vy = function(r) {
        return F3(function(n, e) {
            return A2(ua, function() {
                return ra(e);
            }, dy(r));
        });
    }, my = F3(function(r, n, e) {
        return 3 === e.$ && 404 === e.a.k6 && '"PROCESSING"' === e.b ? ra(n) : zs(e);
    }), gy = F3(function(r, n, e) {
        return mf(A2(aa, Vt, m([
            "enterprise-grant",
            r,
            "custom-report",
            "analyze",
            n,
            "result",
            e
        ])));
    }), py = F3(function(r, n, e) {
        return {
            iX: r,
            g7: n,
            kv: e
        };
    }), $y = function(r) {
        return {
            $: 4,
            a: r
        };
    }, hy = function(r) {
        return {
            $: 3,
            a: r
        };
    }, wy = function(r) {
        return {
            $: 5,
            a: r
        };
    }, Cy = function(r) {
        return {
            $: 0,
            a: r
        };
    }, ky = function(r) {
        return {
            $: 1,
            a: r
        };
    }, yy = function(r) {
        return {
            $: 6,
            a: r
        };
    }, xy = function(r) {
        return {
            $: 2,
            a: r
        };
    }, Ly = F2(function(r, n) {
        return {
            at: n,
            gY: r
        };
    }), jy = A2(xu, A2(wa, Cv, rl), wc), Ay = nr, My = A3(Et, Ly, A2(Ay, 0, jy), A2(Ay, 1, au)), Fy = F2(function(r, n) {
        return {
            at: n,
            gY: r
        };
    }), Hy = A3(Et, Fy, A2(Ay, 0, jy), A2(Ay, 1, au)), Ty = F2(function(r, n) {
        return {
            at: n,
            gY: r
        };
    }), Sy = A3(Et, Ty, A2(Ay, 0, jy), A2(Ay, 1, au)), Ey = F2(function(r, n) {
        return {
            gY: r,
            kJ: n
        };
    }), zy = A3(Et, Ey, A2(Ay, 0, jy), A2(Ay, 1, au)), Ry = F2(function(r, n) {
        return {
            gS: n,
            gY: r
        };
    }), Vy = A3(Et, Ry, A2(Ay, 0, jy), A2(Ay, 1, uu)), Wy = F2(function(r, n) {
        return {
            at: n,
            gY: r
        };
    }), Py = A3(Et, Wy, A2(Ay, 0, jy), A2(Ay, 1, au)), Gy = F2(function(r, n) {
        return {
            gY: r,
            jT: n
        };
    }), Iy = A3(Et, Gy, A2(Ay, 0, jy), A2(Ay, 1, au)), Ny = function(r) {
        var n = function(r) {
            return A2(wa, sl, A2(wa, tu("contents"), St(r)));
        };
        switch(r){
            case "LearningPaceAnalysis":
                return A2(n, Cy, zy);
            case "LoginAnalysis":
                return A2(n, ky, Vy);
            case "ViewingActivityAnalysis":
                return A2(n, xy, Iy);
            case "AssignmentCompletionAnalysis":
                return A2(n, hy, Hy);
            case "AssessmentCompletionAnalysis":
                return A2(n, $y, My);
            case "CourseCompletionAnalysis":
                return A2(n, wy, Sy);
            case "PracticeLabCompletionAnalysis":
                return A2(n, yy, Py);
            default:
                return Us("unknown report analysis: " + r);
        }
    }, Zy = A2(xu, Ny, A2(tu, "tag", wc)), Dy = A4(Ui, py, A2(tu, "reportAnalysis", Zy), A2(tu, "reportResultExternalId", m$), A2(tu, "reportResultName", wc)), _y = F4(function(r, n, e, t) {
        return A3(Ol, r, A3(gy, n, e, t), Dy);
    }), Oy = F2(function(r, n) {
        var e = F3(function(r, t, a) {
            return A2(ua, function(t) {
                return A2(hl, A2(e, r, t), n);
            }, ia(A2(aa, function(n) {
                return A3(n, r, n, a);
            }, t)));
        });
        return A2(ua, function(t) {
            return A2(hl, A2(e, t, r), n);
        }, A2(ca, iu, vu));
    }), qy = F5(function(r, n, e, t, a) {
        var u = A2(Oy, m([
            my,
            F3(function(r, n, e) {
                return A2(ua, function(t) {
                    return c(t - r, 3e5) > -1 ? zs(e) : ra(n);
                }, A2(ca, iu, vu));
            }),
            vy(5e3)
        ]), A4(_y, e, n, t, a));
        return A2(wl, r, u);
    }), Ky = F4(function(r, n, e, t) {
        switch(e.$){
            case 0:
            case 5:
                return Ee(i(t, A3(Gk, r, t.by, t.E)));
            case 1:
            case 12:
                return Ee(i(t, su));
            case 2:
                var a = e.a, u = "" === t.kv ? A3(Pk, t.aP, t.h5, t.ju) : t.kv;
                return Ee(i(s(t, {
                    cc: Fv(Hv(a)),
                    a0: a,
                    kv: u
                }), su));
            case 3:
                return Ee(i(s(t, {
                    kv: e.a
                }), su));
            case 7:
                var c = t.h5;
                if (c.$) return Ee(i(t, su));
                if (c.a.$) return (C = c.a.a).$ ? Ee(i(t, su)) : (o = {
                    ju: t.ju,
                    kv: t.kv,
                    h5: lw(Ve(C.a))
                }, Ee(i(t, A3(ny, n, t.E, o))));
                if ((C = c.a.a).$) return Ee(i(t, su));
                var o = {
                    ju: t.ju,
                    kv: t.kv,
                    h5: hb(Ve(C.a))
                };
                return Ee(i(s(t, {
                    aE: gk
                }), A3(ny, n, t.E, o)));
            case 8:
                var f = e.a, l = i(t.h5, e.b);
                r: for(; !l.a.$;){
                    if (l.a.a.$) return Ee(i(s(t, {
                        d0: !0
                    }), A2(bc, 0, t.c7) ? A3(Gk, r, t.by, t.E) : A4(Ik, r, t.by, t.E, f)));
                    if (l.b.$) break r;
                    var b = l.b.a, d = A3(Cl, lk, Es(sk), sk);
                    return Ee(i(s(t, {
                        aE: gk,
                        eI: Ve(b)
                    }), A5(qy, d, t.E, n, f, b)));
                }
                return Ee(i(t, su));
            case 9:
            case 11:
                return Ee(i(s(t, {
                    aE: mk
                }), su));
            case 13:
                return Ee(i(s(t, {
                    h5: Ve(e.a)
                }), su));
            case 14:
                var v = e.a;
                return Ee(i(s(t, {
                    ju: v,
                    kv: u = A3(Pk, t.aP, t.h5, v)
                }), su));
            case 15:
                var g = e.a, p = t.h5;
                if (p.$ || p.a.$) return Ee(i(t, su));
                var $ = Ve(hb(Ve(g)));
                return Ee(i(s(t, {
                    kv: u = A3(Pk, t.aP, $, t.ju),
                    h5: $
                }), su));
            case 17:
                var h = e.a, w = t.h5;
                if (w.$ || w.a.$) return Ee(i(t, su));
                var C = w.a.a, k = A3(cy, jv, h, t.cq), y = k.a, x = k.b, L = function() {
                    if (2 === x.$) {
                        var r = x.a;
                        return i(Ve(r), function(r) {
                            return {
                                P: Ve(r),
                                aG: !1,
                                af: We,
                                cQ: !1,
                                aO: r
                            };
                        }(r));
                    }
                    return i(t.a3, t.a2);
                }(), j = L.a, A = L.b, M = C.$ || 3 !== C.a.$ ? C : Ve(A2(bk, j, We));
                return $ = Ve(hb(M)), Ee(i(s(t, {
                    a1: We,
                    a2: A,
                    a3: j,
                    cq: y,
                    kv: u = A3(Pk, t.aP, $, t.ju),
                    h5: $
                }), su));
            case 18:
                h = e.a;
                var F = t.h5;
                if (F.$ || F.a.$) return Ee(i(t, su));
                C = F.a.a;
                var H = A3(cy, jv, h, t.a2), T = H.a, S = H.b, E = 2 === S.$ ? Ve(S.a) : t.a1;
                return M = C.$ || 3 !== C.a.$ ? C : Ve(A2(bk, C.a.a, E)), $ = Ve(hb(M)), Ee(i(s(t, {
                    a1: E,
                    a2: T,
                    kv: u = A3(Pk, t.aP, $, t.ju),
                    h5: $
                }), su));
            case 19:
                return Ee(i(s(t, {
                    aP: e.a
                }), su));
            case 16:
                g = e.a;
                var z = t.h5;
                return z.$ || 1 !== z.a.$ ? Ee(i(t, su)) : ($ = Ve(lw(Ve(g))), u = A2(Ne, " ", m([
                    Nk(g),
                    Wk(t.ju)
                ])), Ee(i(s(t, {
                    kv: u,
                    h5: $
                }), su)));
            case 20:
                return Ee(i(s(t, {
                    dV: Ve(e.a)
                }), su));
            case 10:
                return Ee(i(s(t, {
                    aE: (P = e.a, {
                        $: 3,
                        a: P
                    })
                }), su));
            case 21:
                var R = A3(xk, n, t.E, e.a);
                return d = A3(Cl, vk, A2($l, dk, Ts), dk(Ss)), Ee(i(t, A2(wl, d, R)));
            case 23:
                return Ee(i(t, A2(wk, t.kv, e.a)));
            case 22:
            case 6:
                return Fe(e.a);
            case 24:
                var V = e.a;
                return Ee(i(s(t, {
                    cc: Fv(Hv(2)),
                    a0: 2,
                    g7: Ve(V.g7),
                    kv: V.kv,
                    aq: 1
                }), su));
            case 25:
            default:
                return e.a.$ ? Ee(i(t, su)) : Fe(e.a.a);
            case 4:
                var W = t.g7;
                return Ee(i(t, W.$ ? su : A4(by, n, t.E, W.a, t.kv)));
            case 26:
                return Ee(i(s(t, {
                    c7: e.a
                }), su));
        }
        var P;
    }), Uy = function(r) {
        return {
            $: 1,
            a: r
        };
    }, By = {
        $: 2
    }, Qy = F3(function(r, n, e) {
        return A2(vm, r, A3(EC, n, e, Ko));
    }), Yy = {
        $: 6
    }, Jy = function(r) {
        return {
            $: 7,
            a: r
        };
    }, Xy = function(r) {
        return A2(Os, "PUT", qs(r));
    }, rx = F2(function(r, n) {
        return mf(A2(aa, Vt, m([
            "enterprise-grant",
            r,
            "custom-report",
            n,
            "recipients"
        ])));
    }), nx = F4(function(r, n, e, t) {
        return A4(Xy, Di(m([
            i("recipients", A2($k, function(r) {
                return _i(r);
            }, t))
        ])), r, A2(rx, n, e), zt(0));
    }), ex = F4(function(r, n, e, t) {
        var a = A4(nx, r, n, e, t), u = A3(Cl, Es(Yy), Es(Jy(We)), Jy(Ve(Ss)));
        return A2(wl, u, a);
    }), tx = F2(function(r, n) {
        r: for(;;){
            if (r > 0) {
                if (n.b) {
                    r -= 1, n = n.b;
                    continue r;
                }
                return n;
            }
            return n;
        }
    }), ax = F3(function(r, n, e) {
        r: for(;;){
            if (r > 0) {
                if (n.b) {
                    var t = n.a;
                    r -= 1, n = n.b, e = A2(ye, t, e);
                    continue r;
                }
                return e;
            }
            return e;
        }
    }), ux = F2(function(r, n) {
        return et(A3(ax, r, n, b));
    }), cx = F3(function(r, n, e) {
        if (n > 0) {
            var t = i(n, e);
            r: for(;;){
                n: for(;;){
                    if (!t.b.b) return e;
                    if (!t.b.b.b) {
                        if (1 === t.a) break r;
                        break n;
                    }
                    switch(t.a){
                        case 1:
                            break r;
                        case 2:
                            var a = t.b;
                            return m([
                                a.a,
                                a.b.a
                            ]);
                        case 3:
                            if (t.b.b.b.b) {
                                var u = t.b, c = u.b;
                                return m([
                                    u.a,
                                    c.a,
                                    c.b.a
                                ]);
                            }
                            break n;
                        default:
                            if (t.b.b.b.b && t.b.b.b.b.b) {
                                var o = t.b, f = o.b, s = f.b, l = s.b, d = l.b;
                                return A2(ye, o.a, A2(ye, f.a, A2(ye, s.a, A2(ye, l.a, r > 1e3 ? A2(ux, n - 4, d) : A3(cx, r + 1, n - 4, d)))));
                            }
                            break n;
                    }
                }
                return e;
            }
            return m([
                t.b.a
            ]);
        }
        return b;
    }), ox = F2(function(r, n) {
        return A3(cx, 0, r, n);
    }), ix = F3(function(r, n, e) {
        var t = A2(tx, r, e), a = A2(ox, 1, t), u = a.b ? m([
            n(a.a)
        ]) : b;
        return l(A2(ox, r, e), l(u, A2(tx, 1, t)));
    }), fx = F3(function(r, n, t) {
        switch(n.$){
            case 0:
            case 6:
                return Ee(i(t, A3(Qy, r, t.by, t.E)));
            case 1:
                return Ee(i(s(t, {
                    fi: n.a
                }), su));
            case 2:
                return Ee(i(s(t, {
                    ao: Uy(n.a)
                }), su));
            case 3:
                return n.a.$ ? Ee(i(s(t, {
                    ao: By
                }), su)) : Fe(n.a.a);
            case 4:
                var a = n.a, u = function() {
                    var r = t.ao;
                    if (1 === r.$) {
                        var n = r.a, u = A2(Dw, function(r) {
                            return e(r.g7, a);
                        }, n);
                        return u.$ ? t.ao : Uy(A3(ix, u.a.a, function(r) {
                            return s(r, {
                                d_: !r.d_
                            });
                        }, n));
                    }
                    return t.ao;
                }();
                return Ee(i(s(t, {
                    ao: u
                }), su));
            case 5:
                var c = 1 === (f = t.ao).$ ? A2(aa, function(r) {
                    return r.g7;
                }, A2(fc, function(r) {
                    return r.d_;
                }, f.a)) : b;
                return Ee(i(t, A4(ex, t.gp, t.E, t.gb, c)));
            case 7:
            default:
                return n.a.$ ? Ee(i(t, su)) : Fe(n.a.a);
            case 8:
                var o = n.a;
                return Ee(i(s(t, {
                    eH: Ve(o.kv),
                    eJ: A2(di, 0, o.k_)
                }), su));
        }
        var f;
    }), sx = function(r) {
        return {
            $: 1,
            a: r
        };
    }, lx = function(r) {
        return {
            $: 1,
            a: r
        };
    }, bx = F2(function(r, n) {
        return {
            $: 3,
            a: r,
            b: n
        };
    }), dx = {
        $: 3
    }, vx = function(r) {
        return {
            $: 2,
            a: r
        };
    }, mx = kr, gx = function(r) {
        switch(r){
            case 0:
                return "Assigned Seats | Viewing Activity";
            case 1:
                return "User Engagement";
            case 2:
                return "Assignments | Labs & Exams";
            case 3:
                return "Recently Added Courses";
            default:
                return "Completions | Top Viewed Content";
        }
    }, px = function(r) {
        return Di(m([
            i("collapsed", Ni(r.aX)),
            i("order", mx(r.l)),
            i("title", _i(gx(r.z)))
        ]));
    }, $x = function(r) {
        switch(r){
            case 0:
                return "seatsRow";
            case 1:
                return "engagementRow";
            case 2:
                return "assignmentRow";
            case 3:
                return "recentlyAddedRow";
            default:
                return "completionsRow";
        }
    }, hx = Xr("setDashboardConfig", Vt), wx = function(r) {
        return hx(function(r) {
            return Di(m([
                i($x(0), px(r.bj)),
                i($x(1), px(r.a7)),
                i($x(2), px(r.aU)),
                i($x(3), px(r.bi)),
                i($x(4), px(r.aZ))
            ]));
        }(r));
    }, Cx = function(r) {
        return r;
    }, kx = F2(function(r, n) {
        return A3(ve, "arraybuffer", ge, A2(wa, n, r));
    }), yx = function(r) {
        return A2(kx, r, sf(function() {
            return Ee(0);
        }));
    }, xx = function(r) {
        return r ? 0 : 1;
    }, Lx = F3(function(r, n, e) {
        var t = F2(function(n, e) {
            var t = e.a;
            return i(t + 1, A3(r, t, n, e.b));
        });
        return A3(_e, t, i(0, n), e).b;
    }), jx = F3(function(r, n, e) {
        switch(r){
            case 0:
                return s(e, {
                    bj: n
                });
            case 1:
                return s(e, {
                    a7: n
                });
            case 2:
                return s(e, {
                    aU: n
                });
            case 3:
                return s(e, {
                    bi: n
                });
            default:
                return s(e, {
                    aZ: n
                });
        }
    }), Ax = F2(function(r, n) {
        return A3(Lx, F2(function(r, n) {
            return A2(jx, n.z, s(n, {
                l: r
            }));
        }), r, n);
    }), Mx = F2(function(r, n) {
        switch(r){
            case 0:
                return n.bj;
            case 1:
                return n.a7;
            case 2:
                return n.aU;
            case 3:
                return n.bi;
            default:
                return n.aZ;
        }
    }), Fx = F4(function(r, n, e, t) {
        var a = r;
        return Rf({
            bv: qs(e),
            fJ: t,
            bH: m([
                A2(df, "Authorization", "Bearer " + a)
            ]),
            bS: "POST",
            b4: Vf,
            gq: We,
            b5: $f(m([
                n
            ]))
        });
    }), Hx = F2(function(r, n) {
        return s(n, {
            eN: !0,
            $9: l(n.$9, r)
        });
    }), Tx = function(r) {
        return {
            $: 5,
            a: r
        };
    }, Sx = function(r) {
        return {
            $: 3,
            a: r
        };
    }, Ex = function(r) {
        return e(r, hp);
    }, zx = function(r) {
        return {
            $: 1,
            a: r
        };
    }, Rx = F2(function(r, n) {
        var e = F2(function(n, e) {
            var t = e.a, a = e.b;
            return r(n) ? i(A2(ye, n, t), a) : i(t, A2(ye, n, a));
        });
        return A3(ta, e, i(b, b), n);
    }), Vx = F2(function(r, n) {
        var e = r - n.gU;
        return {
            gU: r,
            jz: du(e > 34 || !n.gU ? ou(16.666) : e)
        };
    }), Wx = F2(function(r, n) {
        return {
            $: 6,
            a: r,
            b: n
        };
    }), Px = {
        $: 0
    }, Gx = F2(function(r, n) {
        return !A2(lc, A2($l, vc, r), n);
    }), Ix = function(r) {
        var n = function(r) {
            return !r.lq && e(r.kL, r.lf);
        };
        switch(r.$){
            case 0:
                var t = r.b;
                return n(r.a) && n(t);
            case 1:
            case 2:
            case 3:
                return t = r.b, n(r.a) && n(t);
            case 4:
            case 5:
            case 6:
            case 7:
                return n(r.a);
            case 8:
                var a = r.a.co, u = r.a.al;
                return n((c = r.a.cn).a) && n(c.b) && n(a.a) && n(a.b) && n(u.a) && n(u.b);
            case 9:
                var c;
                return a = r.a.co, u = r.a.al, n((c = r.a.cn).a) && n(c.b) && n(a.a) && n(a.b) && n(u.a) && n(u.b);
            case 10:
                return u = r.a.al, n((o = r.a.cm).a) && n(o.b) && n(u.a) && n(u.b);
            case 11:
                var o;
                return u = r.a.al, n((o = r.a.cm).a) && n(o.b) && n(u.a) && n(u.b);
            case 12:
                return A2(Gx, function(r) {
                    var e = r.b;
                    return n(r.a) && n(e);
                }, r.a);
            case 13:
                return A2(Gx, function(r) {
                    var e = r.b;
                    return n(r.a) && n(e);
                }, r.a);
            case 14:
                return A2(Gx, function(r) {
                    var e = r.b;
                    return n(r.a) && n(e);
                }, r.a);
            case 15:
                return A2(Gx, function(r) {
                    var e = r.b;
                    return n(r.a) && n(e);
                }, r.a);
            case 16:
            case 17:
                var i;
                return n((i = r.a).iS) && n(i.iT) && n(i.cR) && n(i.cZ) && n(i.cx);
            default:
                return !0;
        }
    }, Nx = function(r) {
        var n = function(r) {
            var n = A2(di, r.bJ, r.j1);
            switch(n.$){
                case 0:
                    return !r.lq && e(r.kL, r.lf);
                case 1:
                    var t = n.a;
                    return 1 === t.kO || !t.kO && e(r.kL, r.lf);
                default:
                    return e(r.kL, r.lf);
            }
        };
        switch(r.$){
            case 0:
                return !0;
            case 1:
            case 6:
                return A2(Gx, n, m([
                    r.b,
                    a = r.c,
                    r.d,
                    r.e
                ]));
            case 2:
                var t = r.c;
                return A2(Gx, n, m([
                    t.ai,
                    t.aj,
                    t.eT,
                    t.aa,
                    t.ga,
                    t.fO,
                    t.fm,
                    t.bs
                ]));
            case 3:
            case 7:
                return n(r.b);
            case 4:
                var a = r.c;
                return n(r.b) && n(a);
            case 5:
                return A2(Gx, n, m([
                    r.b,
                    a = r.c,
                    r.d
                ]));
            case 8:
                return A2(Gx, function(r) {
                    var e = r.b;
                    return n(r.a) && n(e);
                }, r.a);
            default:
                return A2(Gx, Ix, r.a);
        }
    }, Zx = F3(function(r, n, e) {
        for(;;){
            if (0 >= n) return r;
            r = A2(ye, e, r), n -= 1;
        }
    }), Dx = F2(function(r, n) {
        return A3(Zx, b, r, n);
    }), _x = F2(function(r, n) {
        var e = Oe(r) - Oe(n);
        if (e > 0) {
            var t = sc(et(n));
            if (1 === t.$) return i(r, n);
            var a = t.a;
            return i(r, l(n, A2(Dx, Rb(e), a)));
        }
        if (0 > e) {
            var u = sc(et(r));
            if (1 === u.$) return i(r, n);
            var c = u.a;
            return i(l(r, A2(Dx, Rb(e), c)), n);
        }
        return i(r, n);
    }), Ox = F2(function(r, n) {
        var e = F2(function(r, n) {
            var e = r.bJ;
            return s(r, 1 === e.$ ? {
                bJ: Fu(s(e.a, {
                    gf: r.kL
                })),
                lf: n.kL
            } : {
                lf: n.kL
            });
        });
        switch(r.$){
            case 0:
                var t = r.b;
                if (n.$) return r;
                var a = n.b;
                return A2(Qu, A2(e, u = r.a, n.a), A2(e, t, a));
            case 1:
                var u = r.a;
                return t = r.b, 1 === n.$ ? (a = n.b, A2(Yu, A2(e, u, n.a), A2(e, t, a))) : r;
            case 2:
                return u = r.a, t = r.b, 2 === n.$ ? (a = n.b, A2(Uu, A2(e, u, n.a), A2(e, t, a))) : r;
            case 3:
                return u = r.a, t = r.b, 3 === n.$ ? (a = n.b, A2(Bu, A2(e, u, n.a), A2(e, t, a))) : r;
            case 4:
                return u = r.a, 4 === n.$ ? qu(A2(e, u, n.a)) : r;
            case 5:
                return u = r.a, 5 === n.$ ? Ku(A2(e, u, n.a)) : r;
            case 6:
                return u = r.a, 6 === n.$ ? ac(A2(e, u, n.a)) : r;
            case 7:
                return u = r.a, 7 === n.$ ? uc(A2(e, u, n.a)) : r;
            case 8:
                var c = r.a;
                return 8 === n.$ ? _u({
                    cn: i(A2(e, c.cn.a, (o = n.a).cn.a), A2(e, c.cn.b, o.cn.b)),
                    co: i(A2(e, c.co.a, o.co.a), A2(e, c.co.b, o.co.b)),
                    al: i(A2(e, c.al.a, o.al.a), A2(e, c.al.b, o.al.b))
                }) : r;
            case 9:
                return c = r.a, 9 === n.$ ? Ou({
                    cn: i(A2(e, c.cn.a, (o = n.a).cn.a), A2(e, c.cn.b, o.cn.b)),
                    co: i(A2(e, c.co.a, o.co.a), A2(e, c.co.b, o.co.b)),
                    al: i(A2(e, c.al.a, o.al.a), A2(e, c.al.b, o.al.b))
                }) : r;
            case 10:
                return c = r.a, 10 === n.$ ? Ju({
                    cm: i(A2(e, c.cm.a, (o = n.a).cm.a), A2(e, c.cm.b, o.cm.b)),
                    al: i(A2(e, c.al.a, o.al.a), A2(e, c.al.b, o.al.b))
                }) : r;
            case 11:
                var o;
                return c = r.a, 11 === n.$ ? Xu({
                    cm: i(A2(e, c.cm.a, (o = n.a).cm.a), A2(e, c.cm.b, o.cm.b)),
                    al: i(A2(e, c.al.a, o.al.a), A2(e, c.al.b, o.al.b))
                }) : r;
            case 12:
                var f = r.a;
                if (12 === n.$) {
                    var l = n.a;
                    return nc(A3(qe, F2(function(r, n) {
                        var t = r.b, a = n.b;
                        return i(A2(e, r.a, n.a), A2(e, t, a));
                    }), f, l));
                }
                return r;
            case 13:
                return f = r.a, 13 === n.$ ? (l = n.a, ec(A3(qe, F2(function(r, n) {
                    var t = r.b, a = n.b;
                    return i(A2(e, r.a, n.a), A2(e, t, a));
                }), f, l))) : r;
            case 14:
                return f = r.a, 14 === n.$ ? (l = n.a, rc(A3(qe, F2(function(r, n) {
                    var t = r.b, a = n.b;
                    return i(A2(e, r.a, n.a), A2(e, t, a));
                }), f, l))) : r;
            case 15:
                return f = r.a, 15 === n.$ ? (l = n.a, tc(A3(qe, F2(function(r, n) {
                    var t = r.b, a = n.b;
                    return i(A2(e, r.a, n.a), A2(e, t, a));
                }), f, l))) : r;
            case 16:
                var b = r.a;
                if (16 === n.$) {
                    var d = n.a;
                    return Zu(function() {
                        var r = b.iT, n = b.iS, t = b.cZ, a = b.cR;
                        return s(b, {
                            cx: A2(e, b.cx, d.cx),
                            cR: A2(e, a, d.cR),
                            cZ: A2(e, t, d.cZ),
                            iS: A2(e, n, d.iS),
                            iT: A2(e, r, d.iT)
                        });
                    }());
                }
                return r;
            case 17:
                return b = r.a, 17 === n.$ ? (d = n.a, Nu(function() {
                    var r = b.iT, n = b.iS, t = b.cZ, a = b.cR;
                    return s(b, {
                        cx: A2(e, b.cx, d.cx),
                        cR: A2(e, a, d.cR),
                        cZ: A2(e, t, d.cZ),
                        iS: A2(e, n, d.iS),
                        iT: A2(e, r, d.iT)
                    });
                }())) : r;
            default:
                return Du;
        }
    }), qx = F3(function(r, n, e) {
        var t = F2(function(n, e) {
            var t = r ? s(n, {
                j1: Ve(e.bJ)
            }) : n, a = t.j1;
            if (1 === a.$) {
                var u = t.bJ;
                return s(t, 1 === u.$ ? {
                    bJ: Fu(s(u.a, {
                        kO: 0,
                        gf: n.kL
                    })),
                    lf: e.kL
                } : {
                    lf: e.kL
                });
            }
            var c = a.a;
            return s(t, 1 === c.$ ? {
                j1: Ve(Fu(s(c.a, {
                    kO: 0,
                    gf: n.kL
                }))),
                lf: e.kL
            } : {
                lf: e.kL
            });
        });
        switch(n.$){
            case 0:
                return A2(zu, a = n.a, n.b);
            case 1:
                var a = n.a, u = n.b, c = n.c, o = n.d, f = n.e;
                if (1 === e.$) {
                    var l = e.c, b = e.d, d = e.e;
                    return A5(Eu, a, A2(t, u, e.b), A2(t, c, l), A2(t, o, b), A2(t, f, d));
                }
                return n;
            case 2:
                a = n.a;
                var v = n.c;
                if (2 === e.$) {
                    var m = e.c;
                    return A3(Iu, a, n.b, {
                        bs: A2(t, v.bs, m.bs),
                        fm: A2(t, v.fm, m.fm),
                        aa: A2(t, v.aa, m.aa),
                        fO: A2(t, v.fO, m.fO),
                        ai: A2(t, v.ai, m.ai),
                        aj: A2(t, v.aj, m.aj),
                        ga: A2(t, v.ga, m.ga),
                        eT: A2(t, v.eT, m.eT)
                    });
                }
                return n;
            case 3:
                return a = n.a, u = n.b, 3 === e.$ ? A2(Wu, a, A2(t, u, e.b)) : n;
            case 4:
                return a = n.a, u = n.b, c = n.c, 4 === e.$ ? (l = e.c, A3(Pu, a, A2(t, u, e.b), A2(t, c, l))) : n;
            case 5:
                return a = n.a, u = n.b, c = n.c, o = n.d, 5 === e.$ ? (l = e.c, b = e.d, A4(Lu, a, A2(t, u, e.b), A2(t, c, l), A2(t, o, b))) : n;
            case 6:
                return a = n.a, u = n.b, c = n.c, o = n.d, f = n.e, 6 === e.$ ? (l = e.c, b = e.d, d = e.e, A5(Gu, a, A2(t, u, e.b), A2(t, c, l), A2(t, o, b), A2(t, f, d))) : n;
            case 7:
                return a = n.a, u = n.b, 7 === e.$ ? A2(Su, a, A2(t, u, e.b)) : n;
            case 8:
                if (8 === e.$) {
                    var g = A2(_x, n.a, e.a), p = g.a, $ = g.b;
                    return Vu(A3(qe, F2(function(r, n) {
                        var e = r.b, a = n.b;
                        return i(A2(t, r.a, n.a), A2(t, e, a));
                    }), p, $));
                }
                return n;
            default:
                return 9 === e.$ ? Ru(A3(qe, Ox, n.a, e.a)) : n;
        }
    }), Kx = F2(function(r, n) {
        var t = F2(function(r, n) {
            return e(dc(r), dc(n));
        }), a = A3(_e, F2(function(r, n) {
            var e = n.a, a = n.b, u = n.c, c = sc(e);
            if (1 === c.$) return f(e, a, u);
            var o = c.a, s = A2(Rx, t(o), a), b = s.a, d = s.b;
            return f(A2(tx, 1, e), b.b ? l(b.b, d) : d, A2(ye, i(o, sc(b)), u));
        }), f(r, n, b), A2(Dx, Oe(r), 0));
        return et(a.c);
    }), Ux = F3(function(r, n, e) {
        return A2(Af, function(n) {
            return Ve(n.b.$ ? n.a : A3(qx, r, n.a, n.b.a));
        }, A2(Kx, n, e));
    }), Bx = F2(function(r, n) {
        var e, t = A2(di, n.bJ, n.j1), a = r;
        switch(t.$){
            case 2:
                var u = t.a.hU, o = 0 > c(n.kL, n.lf) ? i(e = n.kL + u * (a / 1e3), c(e, n.lf) > -1) : i(e = n.kL - u * (a / 1e3), 1 > c(e, n.lf)), f = o.a;
                return s(n, o.b ? {
                    kL: n.lf,
                    lq: 0
                } : {
                    kL: f,
                    lq: 1e3 * u
                });
            case 0:
                var l = a / 1e3;
                return 0 > c(Rb(n.lf - (f = n.kL + (p = n.lq + (t.a.io * (n.lf - n.kL) + -1 * t.a.gX * n.lq) * l) * l)), .01) && 0 > c(Rb(p), .1) ? s(n, {
                    kL: n.lf,
                    lq: 0
                }) : s(n, {
                    kL: f,
                    lq: p
                });
            default:
                var b = t.a.kO, d = t.a.fF, v = t.a.fG, m = t.a.gf, g = 1 > a / d + b ? a / d + b : 1, p = (f = (1e4 * (v(g) * (n.lf - m) + m) | 0) / 1e4, 1 === g ? 0 : (f - n.kL) / a);
                return s(n, 1 === n.j1.$ ? {
                    bJ: Fu({
                        fF: d,
                        fG: v,
                        kO: g,
                        gf: m
                    }),
                    kL: f,
                    lq: p
                } : {
                    j1: Ve(Fu({
                        fF: d,
                        fG: v,
                        kO: g,
                        gf: m
                    })),
                    kL: f,
                    lq: p
                });
        }
    }), Qx = F2(function(r, n) {
        var e = function(n) {
            return A2(aa, function(n) {
                var e = n.b;
                return i(A2(Bx, r, n.a), A2(Bx, r, e));
            }, n);
        };
        switch(n.$){
            case 0:
                var t = n.b;
                return A2(Qu, A2(Bx, r, n.a), A2(Bx, r, t));
            case 1:
                return t = n.b, A2(Yu, A2(Bx, r, n.a), A2(Bx, r, t));
            case 2:
                return t = n.b, A2(Uu, A2(Bx, r, n.a), A2(Bx, r, t));
            case 3:
                return t = n.b, A2(Bu, A2(Bx, r, n.a), A2(Bx, r, t));
            case 4:
                return qu(A2(Bx, r, n.a));
            case 5:
                return Ku(A2(Bx, r, n.a));
            case 6:
                return ac(A2(Bx, r, n.a));
            case 7:
                return uc(A2(Bx, r, n.a));
            case 8:
                var a = n.a.co, u = n.a.al;
                return _u({
                    cn: i(A2(Bx, r, (c = n.a.cn).a), A2(Bx, r, c.b)),
                    co: i(A2(Bx, r, a.a), A2(Bx, r, a.b)),
                    al: i(A2(Bx, r, u.a), A2(Bx, r, u.b))
                });
            case 9:
                var c;
                return a = n.a.co, u = n.a.al, Ou({
                    cn: i(A2(Bx, r, (c = n.a.cn).a), A2(Bx, r, c.b)),
                    co: i(A2(Bx, r, a.a), A2(Bx, r, a.b)),
                    al: i(A2(Bx, r, u.a), A2(Bx, r, u.b))
                });
            case 10:
                return u = n.a.al, Ju({
                    cm: i(A2(Bx, r, (o = n.a.cm).a), A2(Bx, r, o.b)),
                    al: i(A2(Bx, r, u.a), A2(Bx, r, u.b))
                });
            case 11:
                var o;
                return u = n.a.al, Xu({
                    cm: i(A2(Bx, r, (o = n.a.cm).a), A2(Bx, r, o.b)),
                    al: i(A2(Bx, r, u.a), A2(Bx, r, u.b))
                });
            case 12:
                return nc(e(n.a));
            case 13:
                return ec(e(n.a));
            case 14:
                return rc(e(n.a));
            case 15:
                return tc(e(n.a));
            case 16:
                return Zu(s(f = n.a, {
                    cx: A2(Bx, r, f.cx),
                    cR: A2(Bx, r, f.cR),
                    cZ: A2(Bx, r, f.cZ),
                    iS: A2(Bx, r, f.iS),
                    iT: A2(Bx, r, f.iT)
                }));
            case 17:
                var f;
                return Nu(s(f = n.a, {
                    cx: A2(Bx, r, f.cx),
                    cR: A2(Bx, r, f.cR),
                    cZ: A2(Bx, r, f.cZ),
                    iS: A2(Bx, r, f.iS),
                    iT: A2(Bx, r, f.iT)
                }));
            default:
                return Du;
        }
    }), Yx = F2(function(r, n) {
        return A2(aa, function(n) {
            switch(n.$){
                case 0:
                    return A2(zu, n.a, n.b);
                case 3:
                    return A2(Wu, n.a, A2(Bx, r, n.b));
                case 4:
                    var e = n.c;
                    return A3(Pu, n.a, A2(Bx, r, n.b), A2(Bx, r, e));
                case 5:
                    e = n.c;
                    var t = n.d;
                    return A4(Lu, n.a, A2(Bx, r, n.b), A2(Bx, r, e), A2(Bx, r, t));
                case 6:
                    e = n.c, t = n.d;
                    var a = n.e;
                    return A5(Gu, n.a, A2(Bx, r, n.b), A2(Bx, r, e), A2(Bx, r, t), A2(Bx, r, a));
                case 7:
                    return A2(Su, n.a, A2(Bx, r, n.b));
                case 1:
                    var u = n.c, c = n.d, o = n.e;
                    return A5(Eu, n.a, A2(Bx, r, n.b), A2(Bx, r, u), A2(Bx, r, c), A2(Bx, r, o));
                case 2:
                    var f = n.c;
                    return A3(Iu, n.a, n.b, {
                        bs: A2(Bx, r, f.bs),
                        fm: A2(Bx, r, f.fm),
                        aa: A2(Bx, r, f.aa),
                        fO: A2(Bx, r, f.fO),
                        ai: A2(Bx, r, f.ai),
                        aj: A2(Bx, r, f.aj),
                        ga: A2(Bx, r, f.ga),
                        eT: A2(Bx, r, f.eT)
                    });
                case 8:
                    return Vu(A2(aa, function(n) {
                        var e = n.b;
                        return i(A2(Bx, r, n.a), A2(Bx, r, e));
                    }, n.a));
                default:
                    var s = n.a;
                    return Ru(A2(aa, Qx(r), s));
            }
        }, n);
    }), Jx = F2(function(r, n) {
        return A2(Gx, Nx, A2(Yx, du(0), A3(Ux, !1, r, n)));
    }), Xx = F2(function(r, n) {
        var e = A2(aa, dc, n);
        return l(A2(fc, function(r) {
            return !A2(bc, dc(r), e);
        }, r), n);
    }), rL = F3(function(r, n, e) {
        r: for(;;){
            var t = sc(n);
            if (1 === t.$) return f(r, b, b);
            var a = t.a;
            switch(a.$){
                case 4:
                    if ((v = a.a) > 0) return f(r, b, A2(ye, {
                        $: 4,
                        a: du(v - e)
                    }, A2(tx, 1, n)));
                    n = A2(tx, 1, n);
                    continue r;
                case 5:
                    var u = a.a, c = A3(rL, r, A2(tx, 1, n), e), o = c.c;
                    return f(c.a, A2(ye, u, c.b), o);
                case 1:
                    if (A2(Jx, r, i = a.a)) return f(r, b, A2(tx, 1, n));
                    r = A3(Ux, !1, r, i), n = A2(ye, Px, A2(tx, 1, n));
                    continue r;
                case 2:
                    var i;
                    if (A2(Jx, r, i = a.a)) return f(r, b, A2(tx, 1, n));
                    r = A3(Ux, !0, r, i), n = A2(ye, Px, A2(tx, 1, n));
                    continue r;
                case 3:
                    r = A2(Xx, r, a.a), n = A2(tx, 1, n);
                    continue r;
                case 0:
                    var d = A2(Yx, e, r);
                    return A2(Gx, Nx, d) ? f(A2(aa, oc(function(r) {
                        return s(r, {
                            j1: We
                        });
                    }), d), b, A2(tx, 1, n)) : f(d, b, n);
                case 7:
                    n = l(g = a.a, m([
                        (p = g, {
                            $: 7,
                            a: p
                        })
                    ]));
                    continue r;
                default:
                    var v, g = a.b;
                    if ((v = a.a) > 0) {
                        n = l(g, l(m([
                            A2(Wx, v - 1, g)
                        ]), A2(tx, 1, n)));
                        continue r;
                    }
                    n = A2(tx, 1, n);
                    continue r;
            }
        }
        var p;
    }), nL = F2(function(r, n) {
        var e, t = n, a = A2(Vx, r, t.iy), u = A2(Rx, function(r) {
            return 0 >= r.a;
        }, A2(aa, function(r) {
            var n = r.b;
            return i(du(r.a - a.jz), n);
        }, t.fU)), c = u.b, o = (e = sc(u.a)).$ ? i(t.$9, t.iq) : i(e.a.b, A2(aa, oc(function(r) {
            return s(r, {
                j1: We
            });
        }), t.iq)), f = A3(rL, o.b, o.a, a.jz), l = f.a, b = f.b, d = f.c;
        return i(s(t, {
            fU: c,
            eN: !!Oe(d) || !!Oe(c),
            $9: d,
            iq: l,
            iy: a
        }), ma(A2(aa, function(r) {
            return A2(da, Vt, ra(r));
        }, b)));
    }), eL = F2(function(r, n) {
        return A2(nL, r, n);
    }), tL = F3(function(r, n, e) {
        var t = e.c, a = A2(Mx, r, t), u = A2(eL, n, a.aW), c = u.b, o = s(a, {
            aW: u.a
        });
        return i(s(e, {
            c: A3(jx, r, o, t)
        }), c);
    }), aL = F2(function(r, n) {
        var t, a = i(r, n.D);
        switch(a.a.$){
            case 2:
                var u = m((l = A2(Mx, g = a.a.a, f = n.c)).aX ? [
                    Tx(A2(bx, g, !1)),
                    Sx(m([
                        A3(Mu, 1, 0, 1)
                    ])),
                    zx(m([
                        A3(Mu, 1, 1, 1)
                    ]))
                ] : [
                    Sx(m([
                        A3(Mu, 1, 1, 1)
                    ])),
                    zx(m([
                        A3(Mu, 1, 0, 1)
                    ])),
                    Tx(A2(bx, g, !0))
                ]), o = s(l, {
                    aW: A2(Hx, u, l.aW)
                });
                return Ee(i(s(n, {
                    c: w = A3(jx, g, o, f)
                }), su));
            case 3:
                var f, l, b = a.a, d = b.b, v = s(l = A2(Mx, g = b.a, f = n.c), {
                    aX: d
                });
                return Ee(i(s(n, {
                    c: w = A3(jx, g, v, f)
                }), wx(w)));
            case 4:
                return Ee(A3(tL, 0, a.a.a, n));
            case 5:
                return Ee(A3(tL, 1, a.a.a, n));
            case 6:
                return Ee(A3(tL, 2, a.a.a, n));
            case 7:
                return Ee(A3(tL, 3, a.a.a, n));
            case 8:
                return Ee(A3(tL, 4, a.a.a, n));
            case 9:
                return Ee(i(s(n, {
                    c: a.a.a
                }), su));
            case 11:
                return Ee(i(n, ZC));
            case 12:
                var g;
                return Ee(i(s(n, {
                    av: A2(_g, Ve(g = a.a.a), We)
                }), su));
            case 13:
                var p = s(n.av, {
                    fE: Ve(a.a.a)
                });
                return Ee(i(s(n, {
                    av: p
                }), su));
            case 14:
                return Ee(i(s(n, {
                    av: A2(_g, We, We)
                }), su));
            case 15:
                var $ = n.c, h = function(r) {
                    return m([
                        r.bj,
                        r.a7,
                        r.aU,
                        r.bi,
                        r.aZ
                    ]);
                }($), w = function() {
                    var r = i(n.av.g1, n.av.fE);
                    if (r.a.$ || r.b.$) return $;
                    if (r.b.a.$) {
                        a = r.a.a;
                        var t = Oe(h);
                        return A2(Ax, $, A2(mc, function(r) {
                            return r.l;
                        }, A2(aa, function(r) {
                            return e(r.z, a) ? s(r, {
                                l: r.l + t + 1
                            }) : r;
                        }, h)));
                    }
                    var a = r.a.a, u = r.b.a.a, o = A2(Mx, u, $), f = A2(Mx, a, $);
                    return A2(Ax, $, A2(mc, function(r) {
                        return r.l;
                    }, A2(aa, function(r) {
                        return c(f.l, o.l) > 0 ? e(r.z, u) ? s(r, {
                            l: r.l + .5
                        }) : e(r.z, a) ? s(r, {
                            l: o.l
                        }) : r : e(r.z, u) ? s(r, {
                            l: r.l - .5
                        }) : e(r.z, a) ? s(r, {
                            l: o.l
                        }) : r;
                    }, h)));
                }();
                return Ee(i(s(n, {
                    c: w,
                    av: A2(_g, We, We)
                }), wx(w)));
            case 0:
                return a.a.a.$ ? Fe(a.a.a.a) : Ee(i(s(n, {
                    D: sx(s(z = a.a.a.a, {
                        aR: j = {
                            au: 1,
                            aH: A2(mc, function(r) {
                                return r.dp;
                            }, z.aR.aH)
                        }
                    }))
                }), su));
            case 1:
                if (1 !== a.b.$) return Ee(i(n, su));
                switch(a.a.a.$){
                    case 0:
                        return Ee(i(s(n, {
                            fg: Ve(a.a.a.a)
                        }), su));
                    case 1:
                        var C = s((z = a.b.a).cS, {
                            fx: a.a.a.a
                        }), k = s(z, {
                            cS: C
                        });
                        return Ee(i(s(n, {
                            D: sx(k)
                        }), su));
                    case 2:
                        var y = a.a.a.a, x = (z = a.b.a).gr, L = function() {
                            switch(y){
                                case 2:
                                    var r = xx(x.bB.x), n = s(x.bB, {
                                        x: r
                                    });
                                    return s(x, {
                                        bB: n
                                    });
                                case 1:
                                    r = xx(x.bW.x);
                                    var e = s(x.bW, {
                                        x: r
                                    });
                                    return s(x, {
                                        bW: e
                                    });
                                default:
                                    r = xx(x.bO.x);
                                    var t = s(x.bO, {
                                        x: r
                                    });
                                    return s(x, {
                                        bO: t
                                    });
                            }
                        }();
                        return k = s(z, {
                            gr: L
                        }), Ee(i(s(n, {
                            D: sx(k)
                        }), su));
                    case 3:
                        return C = s((z = a.b.a).cS, {
                            aS: a.a.a.a
                        }), k = s(z, {
                            cS: C
                        }), Ee(i(s(n, {
                            D: sx(k)
                        }), su));
                    case 4:
                        var j = s((z = a.b.a).aR, {
                            au: H = a.a.a.a
                        });
                        return k = s(z, {
                            aR: j
                        }), Ee(i(s(n, {
                            D: sx(k)
                        }), su));
                    case 5:
                        var A = s(M = (z = a.b.a).at, {
                            il: (t = a.a.a.a, "Assignments" === t ? 0 : 1)
                        });
                        return k = s(z, {
                            at: A
                        }), Ee(i(s(n, {
                            D: sx(k)
                        }), su));
                    case 6:
                        var M, F = a.a.a, H = F.b, T = (M = (z = a.b.a).at).dz, S = M.$7, E = F.a ? i(S, s(T, {
                            au: H
                        })) : i(s(S, {
                            au: H
                        }), T);
                        return A = s(M, {
                            $7: E.a,
                            dz: E.b
                        }), k = s(z, {
                            at: A
                        }), Ee(i(s(n, {
                            D: sx(k)
                        }), su));
                    case 7:
                        var z = a.b.a, R = A2(Ne, "/", m([
                            "enterprise-grant",
                            n.E,
                            "custom-report",
                            "monthly-snapshot"
                        ])), V = !Ex(z.b$), W = Di(m([
                            i("user", Ni(V))
                        ])), P = (k = s(z, {
                            b$: vx(V)
                        }), yx(function(r) {
                            return lx({
                                $: 8,
                                a: r
                            });
                        }));
                        return Ee(i(s(n, {
                            D: sx(k)
                        }), A4(Fx, n.gp, R, W, P)));
                    case 8:
                        var G = i(a.a.a.a, (z = a.b.a).b$);
                        if (G.a.$ || 2 !== G.b.$) return k = s(z, {
                            b$: dx
                        }), Ee(i(s(n, {
                            D: sx(k)
                        }), su));
                        k = s(z, {
                            b$: wp(G.b.a)
                        });
                        return Ee(i(s(n, {
                            D: sx(k)
                        }), su));
                    default:
                        var I = n.c, N = (w = s(I, {
                            en: !I.en
                        }), s(n, {
                            c: w
                        }));
                        return Ee(i(N, su));
                }
            default:
                return Ee(i(n, su));
        }
    }), uL = {
        $: 1
    }, cL = function(r) {
        return {
            $: 1,
            a: r
        };
    }, oL = {
        $: 2
    }, iL = function(r) {
        return {
            $: 7,
            a: r
        };
    }, fL = F2(function(r, n) {
        return A5(Ws, "DELETE", bf, r, n, _s(MC));
    }), sL = F3(function(r, n, e) {
        return A2(fL, r, A2(zg, n, e));
    }), lL = F2(function(r, n) {
        switch(n.$){
            case 0:
            case 2:
                return n;
            default:
                return cL(A2(fc, function(n) {
                    return !e(n.g7, r);
                }, n.a));
        }
    }), bL = F4(function(r, n, e, t) {
        switch(e.$){
            case 0:
                return Ee(i(t, A2(vm, r, A3(EC, t.by, t.E, qo))));
            case 1:
                return Ee(i(s(t, {
                    kq: e.a
                }), su));
            case 2:
                return Ee(i(s(t, {
                    bU: cL(e.a)
                }), su));
            case 3:
                var a = e.a;
                return a.$ ? Ee(i(s(t, {
                    bU: oL
                }), su)) : Fe(a.a);
            case 4:
                var u = A3(EC, t.by, t.E, Oo(e.a));
                return Ee(i(t, A2(vm, r, u)));
            case 10:
                var c = A3(EC, t.by, t.E, Go(e.a));
                return Ee(i(t, A2(vm, r, c)));
            case 5:
                return Ee(i(s(t, {
                    bT: Ve(e.a)
                }), su));
            case 6:
                return Ee(i(s(t, {
                    bT: We
                }), su));
            case 7:
                return Fe(e.a);
            case 8:
                var o = A3(sL, n, t.E, l = e.a), f = A3(Cl, Es({
                    $: 9,
                    a: l
                }), A2($l, iL, Ts), iL(Ss));
                return Ee(i(t, A2(wl, f, o)));
            case 9:
                var l;
                return Ee(i(s(t, {
                    bT: We,
                    bU: A2(lL, l = e.a, t.bU)
                }), su));
            default:
                var b = A3(EC, t.by, t.E, Wo(e.a));
                return Ee(i(t, A2(vm, r, b)));
        }
    }), dL = F4(function(r, n, e, t) {
        if (1 === t.$) return Fe(uL);
        var a = t.a;
        switch(e.$){
            case 0:
                var u = A4(bL, r, n, e.a, a.bU);
                if (u.$) return Fe(u.a);
                var c = u.a, o = c.b;
                return Ee(i(s(a, {
                    bU: c.a
                }), A2(Sv, LC, o)));
            case 2:
                return Fe(e.a);
            default:
                return Ee(i(a, su));
        }
    }), vL = function(r) {
        return {
            $: 13,
            a: r
        };
    }, mL = function(r) {
        return {
            $: 8,
            a: r
        };
    }, gL = F2(function(r, n) {
        return {
            $: 9,
            a: r,
            b: n
        };
    }), pL = function(r) {
        return {
            $: 7,
            a: r
        };
    }, $L = function(r) {
        return {
            $: 1,
            a: r
        };
    }, hL = {
        $: 1
    }, wL = {
        $: 2
    }, CL = {
        $: 3
    }, kL = {
        $: 29
    }, yL = F2(function(r, n) {
        var e = "Activity Download", t = function() {
            if (r.$) {
                var n = r.a.kN;
                return 1 === n.$ ? e : n.a;
            }
            return e;
        }();
        return A2(Ne, " ", m([
            t,
            n,
            "Activity.csv"
        ]));
    }), xL = A2(Os, "DELETE", bf), LL = F2(function(r, n) {
        return mf(A2(aa, Vt, m([
            "enterprise-grant",
            r,
            "custom-report",
            n,
            "delete"
        ])));
    }), jL = F3(function(r, n, e) {
        return A3(xL, r, A2(LL, n, e), zt(0));
    }), AL = F2(function(r, n) {
        return 0 > r ? We : sc(A2(tx, r, n));
    }), ML = function(r) {
        return {
            $: 26,
            a: r
        };
    }, FL = F2(function(r, n) {
        return {
            $: 25,
            a: r,
            b: n
        };
    }), HL = {
        $: 28
    }, TL = F4(function(r, n, e, t) {
        return Vs({
            bv: n,
            bH: m([
                A2(df, "Authorization", "Bearer " + e)
            ]),
            bS: r,
            gc: _s(Ck),
            b4: Vf,
            b5: $f(m([
                t
            ]))
        });
    }), SL = A2(TL, "GET", bf), EL = F3(function(r, n, e) {
        var t = n;
        switch(e){
            case 0:
                return A2(SL, r, mf(A2(aa, Vt, m([
                    "enterprise-grant",
                    t,
                    "viewing-activity"
                ]))));
            case 1:
                return A2(SL, r, mf(A2(aa, Vt, m([
                    "enterprise-grant",
                    t,
                    "practice-lab-activity"
                ]))));
            case 4:
                return A2(SL, r, mf(A2(aa, Vt, m([
                    "enterprise-grant",
                    t,
                    "assessment-activity"
                ]))));
            case 2:
                return A2(SL, r, mf(A2(aa, Vt, m([
                    "enterprise-grant",
                    t,
                    "last-login-activity"
                ]))));
            case 3:
                return A2(SL, r, mf(A2(aa, Vt, m([
                    "enterprise-grant",
                    t,
                    "assignments-activity"
                ]))));
            case 5:
                return A2(SL, r, mf(A2(aa, Vt, m([
                    "enterprise-grant",
                    t,
                    "learning-pace-report"
                ]))));
            default:
                return A2(SL, r, mf(A2(aa, Vt, m([
                    "enterprise-grant",
                    t,
                    "course-completion"
                ]))));
        }
    }), zL = F3(function(r, n, e) {
        return A2(wl, A3(Cl, FL(function(r) {
            switch(r){
                case 0:
                    return "Viewing";
                case 1:
                    return "Lab";
                case 2:
                    return "Login Activity";
                case 3:
                    return "Assignment Activity";
                case 4:
                    return "Assessment";
                case 5:
                    return "Learning Pace";
                default:
                    return "Course Completions";
            }
        }(e)), ML, HL), A3(EL, r, n, e));
    }), RL = F2(function(r, n) {
        switch(n.$){
            case 0:
            case 2:
                return n;
            default:
                return $L(A2(fc, function(n) {
                    return !e(n.g7, r);
                }, n.a));
        }
    }), VL = F2(function(r, n) {
        return A5(Ws, "POST", bf, r, n, _s(MC));
    }), WL = F2(function(r, n) {
        return mf(A2(aa, Vt, m([
            "enterprise-grant",
            r,
            "custom-report",
            n,
            "run-now"
        ])));
    }), PL = F3(function(r, n, e) {
        return A2(VL, r, A2(WL, n, e));
    }), GL = F3(function(r, n, e) {
        return A2(aa, function(e) {
            return r(e) ? n(e) : e;
        }, e);
    }), IL = F2(function(r, n) {
        var e = r.V;
        if (1 === e.$) {
            var t = A2(aa, function(r) {
                return r.bl ? r : s(r, {
                    b9: n
                });
            }, e.a);
            return s(r, {
                V: $L(t)
            });
        }
        return r;
    }), NL = function(r) {
        return {
            $: 18,
            a: r
        };
    }, ZL = A3(Cl, NL, Es({
        $: 19
    }), HL), DL = F4(function(r, n, t, a) {
        switch(t.$){
            case 0:
                var u = A3(EC, a.by, bC(a.bG), Po);
                return Ee(i(a, A2(vm, r, u)));
            case 1:
                var c = t.a, o = A3(EC, a.by, bC(a.bG), Uo(c));
                return Ee(i(a, A2(vm, r, o)));
            case 2:
                return c = t.a, o = A3(EC, a.by, bC(a.bG), Xo(c)), Ee(i(a, A2(vm, r, o)));
            case 3:
                var f = t.a, l = function(r) {
                    var t = function(n) {
                        return e(n.kW, Ve(r));
                    };
                    return i(A3(GL, t, function(r) {
                        return s(r, {
                            bl: 0,
                            b9: hL
                        });
                    }, f), function() {
                        var e = A2(Zw, t, f);
                        if (e.$) return su;
                        var u = e.a;
                        return A5(qy, ZL, bC(a.bG), n, u.g7, r);
                    }());
                }, b = function() {
                    var r = a.fN;
                    if (r.$) {
                        if (f.b) {
                            var n = f.a.kW;
                            return n.$ ? i(f, su) : l(n.a);
                        }
                        return i(f, su);
                    }
                    return l(r.a);
                }(), d = b.b;
                return Ee(i(s(a, {
                    V: $L(b.a)
                }), d));
            case 4:
                return (H = t.a).$ ? Ee(i(s(a, {
                    V: wL
                }), su)) : Fe(H.a);
            case 5:
                var v = t.a, m = v.a, g = v.b, p = A3(xk, n, bC(a.bG), m), $ = A3(Cl, gL(g), A2($l, mL, Ts), mL(Ss));
                return Ee(i(s(a, {
                    cT: !0
                }), A2(wl, $, p)));
            case 6:
                var h = t.a;
                return p = A3(PL, n, bC(a.bG), h), $ = A3(Cl, Es(kL), A2($l, pL, Ts), pL(Ss)), Ee(i(a, A2(wl, $, p)));
            case 7:
            case 8:
            case 13:
                return Fe(t.a);
            case 9:
                return Ee(i(a, A2(wk, g = t.a, t.b)));
            case 10:
                return Ee(i(s(a, {
                    cT: !1
                }), su));
            case 11:
                return Ee(i(s(a, {
                    bX: Ve(t.a)
                }), su));
            case 12:
                return Ee(i(s(a, {
                    bX: We
                }), su));
            case 14:
                var w = t.a;
                return p = A3(jL, n, bC(a.bG), w), $ = A3(Cl, Es({
                    $: 15,
                    a: w
                }), A2($l, vL, Ts), vL(Ss)), Ee(i(a, A2(wl, $, p)));
            case 15:
                return Ee(i(s(a, {
                    bX: We,
                    V: A2(RL, w = t.a, a.V)
                }), su));
            case 16:
                var C = t.a, k = C.a, y = (h = C.b, C.c), x = a.V;
                if (1 === x.$) {
                    var L = function(r) {
                        return 2 === r.$;
                    }, j = A2(aa, function(r) {
                        return s(r, {
                            bl: 1
                        });
                    }, x.a), A = A3(ix, k, function(r) {
                        return s(r, 2 === r.b9.$ ? {
                            bl: 0
                        } : {
                            bl: 0,
                            b9: hL
                        });
                    }, j), M = !A2(di, !1, A2(Ba, A2($l, L, function(r) {
                        return r.b9;
                    }), A2(AL, k, j)));
                    return Ee(i(s(a, {
                        V: $L(A)
                    }), M ? A5(qy, ZL, bC(a.bG), n, h, y) : su));
                }
                return Ee(i(a, su));
            case 17:
                return Ee(i(s(a, {
                    dV: Ve(k = t.a)
                }), su));
            case 18:
                var F = A2(IL, a, {
                    $: 2,
                    a: t.a
                });
                return Ee(i(F, su));
            case 19:
                return Ee(i(F = A2(IL, a, CL), su));
            case 20:
                return Ee(i(s(a, {
                    eG: t.a
                }), su));
            case 21:
                return Ee(i(s(a, {
                    c7: t.a
                }), su));
            case 22:
                var H;
                return t.a.$ ? Ee(i(a, su)) : Fe(H = t.a.a);
            case 23:
                return Ee(i(s(a, {
                    aP: Ve(t.a)
                }), su));
            case 24:
                var T = t.a, S = t.b;
                return Ee(i(s(a, {
                    cd: 0,
                    cr: 0
                }), A3(zL, n, T, S)));
            case 25:
                var E = t.a, z = t.b;
                return Ee(i(s(a, {
                    cr: 1
                }), A2(wk, A2(yL, a.bG, E), z)));
            case 26:
                return Fe(Ts(t.a));
            case 27:
                return Ee(i(s(a, {
                    cd: 3
                }), su));
            case 28:
                return Fe(Ss);
            default:
                return Ee(i(a, su));
        }
    }), _L = F2(function(r, n) {
        return Ve(r.$ ? n : r.a + ", " + n);
    }), OL = function(r) {
        return {
            $: 11,
            a: r
        };
    }, qL = {
        $: 10
    }, KL = F3(function(r, n, e) {
        return A5(Ws, "POST", qs(r), n, e, _s(MC));
    }), UL = kr, BL = function(r) {
        return !r;
    }, QL = function(r) {
        var n, e;
        return Di(m([
            i("loginReminderEnabled", (e = BL(r.T), Ni(e))),
            i("userExternalId", (n = r.g7, _i(n))),
            i("loginReminderCadence", UL(r.cF))
        ]));
    }, YL = F3(function(r, n, e) {
        var t = mf(m([
            "enterprise-grant",
            n,
            "login-reminders"
        ]));
        return A3(KL, Di(m([
            i("users", A2($k, QL, e))
        ])), r, t);
    }), JL = F3(function(r, n, e) {
        return A2(wl, A3(Cl, Es(qL), A2($l, OL, Ts), OL(Ss)), A3(YL, r, n, e));
    }), XL = F4(function(r, n, e, t) {
        for(;;){
            if (!e.b) return et(t);
            var a = e.a, u = e.b, c = r(a);
            A2(bc, c, n) ? e = u : (n = A2(ye, c, n), e = u, t = A2(ye, a, t));
        }
    }), rj = F4(function(r, n, t, a) {
        switch(t.$){
            case 0:
                return Ee(i(s(a, {
                    eY: t.a
                }), su));
            case 1:
                return (o = t.a).$ ? Ee(i(s(a, {
                    bD: A2(_L, a.bD, "Teams fetch returned nothing.")
                }), su)) : Fe(o.a);
            case 2:
                var u = A2(aa, function(r) {
                    return r.cF;
                }, $ = t.a), c = 1 === Oe(A4(XL, Vt, b, u, b)) ? sc(u) : We;
                return Ee(i(s(a, {
                    s: $,
                    cH: c
                }), su));
            case 3:
                var o;
                return (o = t.a).$ ? Ee(i(s(a, {
                    bD: A2(_L, a.bD, "Learning Reminders fetch returned nothing.")
                }), su)) : Fe(o.a);
            case 4:
                return Ee(i(s(a, {
                    a_: t.a,
                    aF: !1
                }), su));
            case 5:
                return Ee(i(s(a, {
                    cW: t.a
                }), su));
            case 6:
                return Ee(i(s(a, {
                    aF: !a.aF
                }), su));
            case 7:
                var f = t.a, d = t.b, v = function(r) {
                    return e(r.g7, d);
                }, m = function(r) {
                    return s(r, {
                        T: f
                    });
                }, g = A3(GL, v, m, a.s), p = A2(lc, v, a.r) ? A3(GL, v, m, a.r) : l(A2(fc, v, g), a.r);
                return Ee(i(s(a, {
                    r: p,
                    s: g
                }), su));
            case 8:
                return Ee(i(s(a, {
                    d$: t.a
                }), su));
            case 9:
                var $;
                return Ee(i(a, A3(JL, n, a.E, $ = t.a)));
            case 10:
            case 13:
                return Ee(i(a, A2(vm, r, A3(EC, a.by, a.E, _o))));
            case 11:
                return Fe(t.a);
            case 12:
                f = t.a;
                var h = t.b;
                if (h.$) {
                    var w = A2(aa, function(r) {
                        return r.g7;
                    }, h.a.kj);
                    return p = l(g = A3(GL, function(r) {
                        return A2(bc, r.g7, w);
                    }, function(r) {
                        return s(r, {
                            T: f
                        });
                    }, a.s), a.r), Ee(i(s(a, {
                        r: p,
                        s: g
                    }), su));
                }
                p = l(g = A2(aa, function(r) {
                    return s(r, {
                        T: f
                    });
                }, a.s), a.r);
                return Ee(i(s(a, {
                    r: p,
                    s: g
                }), su));
            case 14:
                var C = t.a, k = function() {
                    var r = A2(Ze, " ", C);
                    if (r.b && r.b.b && !r.b.b.b) {
                        var n = r.b.a;
                        return i(A2(di, 3, qt(r.a)), n);
                    }
                    return i(3, "");
                }(), y = function(r) {
                    return s(r, {
                        cF: k.a
                    });
                }, x = function(r) {
                    return e(r.g7, k.b);
                }, L = (g = A3(GL, x, y, a.s), s(a, {
                    r: p = A2(lc, x, a.r) ? A3(GL, x, y, a.r) : l(A2(fc, x, g), a.r),
                    s: g
                }));
                return Ee(i(L, su));
            case 15:
                var j = qt(t.a), A = A2(aa, function(r) {
                    return s(r, {
                        cF: A2(di, 3, j)
                    });
                }, a.s);
                return L = s(a, {
                    r: A,
                    s: A,
                    cH: j
                }), Ee(i(L, su));
            case 16:
                return Ee(i(s(a, {
                    cl: !0
                }), su));
            default:
                return Ee(i(s(a, {
                    cl: !1
                }), su));
        }
    }), nj = {
        $: 2
    }, ej = function(r) {
        return {
            $: 21,
            a: r
        };
    }, tj = {
        $: 18
    }, aj = function(r) {
        return {
            $: 6,
            a: r
        };
    }, uj = function(r) {
        return {
            $: 17,
            a: r
        };
    }, cj = F2(function(r, n) {
        return {
            gD: r,
            i5: n
        };
    }), oj = F2(function(r, n) {
        return {
            g7: r,
            hF: n
        };
    }), ij = A3(Et, oj, A2(tu, "externalId", Um), A2(tu, "moduleName", wc)), fj = sl(ij), sj = F4(function(r, n, e, t) {
        return {
            jA: e,
            g7: t,
            kv: r,
            kO: n
        };
    }), lj = A5(hc, sj, A2(tu, "moduleName", Tg), A2(tu, "percentage", rg), A2(tu, "dueDate", Km), A2(tu, "externalId", Um)), bj = sl(lj), dj = A3(Et, cj, A2(tu, "assignmentsCompleted", fj), A2(tu, "assignmentsInProgress", bj)), vj = F3(function(r, n, e) {
        var t = mf(A2(aa, Vt, m([
            "enterprise-grant",
            n,
            "user",
            e,
            "assignments"
        ])));
        return A3(Ol, r, t, dj);
    }), mj = F3(function(r, n, e) {
        return A2(wl, A3(Cl, aj, uj, tj), A3(vj, r, n, e));
    }), gj = function(r) {
        return {
            $: 5,
            a: r
        };
    }, pj = function(r) {
        return {
            $: 4,
            a: r
        };
    }, $j = F2(function(r, n) {
        return {
            g7: n,
            kv: r
        };
    }), hj = A3(Et, $j, A2(tu, "teamName", y$), A2(tu, "teamExternalId", g$)), wj = A2(tu, "teams", sl(hj)), Cj = F3(function(r, n, e) {
        var t = mf(A2(aa, Vt, m([
            "enterprise-grant",
            n,
            "user",
            e,
            "teams"
        ])));
        return A3(Ol, r, t, wj);
    }), kj = F3(function(r, n, e) {
        return A2(wl, A3(Cl, pj, A2($l, gj, Ts), gj(Ss)), A3(Cj, r, n, e));
    }), yj = function(r) {
        return {
            $: 10,
            a: r
        };
    }, xj = A2(tu, "courses", sl(wc)), Lj = F3(function(r, n, e) {
        var t = mf(A2(aa, Vt, m([
            "enterprise-grant",
            n,
            "user",
            e,
            "course-completion"
        ])));
        return A3(Ol, r, t, xj);
    }), jj = F3(function(r, n, e) {
        return A2(wl, A3(Cl, yj, uj, tj), A3(Lj, r, n, e));
    }), Aj = function(r) {
        return {
            $: 14,
            a: r
        };
    }, Mj = A2(St, Vt, A2(tu, "episodesViewed", uu)), Fj = F2(function(r, n) {
        return mf(l(A2(aa, Vt, m([
            "metrics",
            "enterprise-grant",
            r
        ])), n));
    }), Hj = F3(function(r, n, e) {
        return A2(Fj, r, A2(aa, Vt, m([
            "user",
            n,
            e
        ])));
    }), Tj = F3(function(r, n, e) {
        return A3(Ol, r, A3(Hj, n, e, "episodes-viewed"), Mj);
    }), Sj = F3(function(r, n, e) {
        return A2(wl, A3(Cl, Aj, uj, tj), A3(Tj, r, n, e));
    }), Ej = function(r) {
        return {
            $: 16,
            a: r
        };
    }, zj = A2(St, Vt, A2(tu, "episodesViewedCompletely", uu)), Rj = F3(function(r, n, e) {
        return A3(Ol, r, A3(Hj, n, e, "episodes-viewed-completely"), zj);
    }), Vj = F3(function(r, n, e) {
        return A2(wl, A3(Cl, Ej, uj, tj), A3(Rj, r, n, e));
    }), Wj = function(r) {
        return {
            $: 7,
            a: r
        };
    }, Pj = F3(function(r, n, e) {
        return A3(Ol, r, A3(Hj, n, e, "last-login"), _v);
    }), Gj = F3(function(r, n, e) {
        return A2(wl, A3(Cl, Wj, uj, tj), A3(Pj, r, n, e));
    }), Ij = function(r) {
        return {
            $: 13,
            a: r
        };
    }, Nj = A2(St, Vt, A2(tu, "totalViewingTimeSeconds", uu)), Zj = F3(function(r, n, e) {
        return A3(Ol, r, A3(Hj, n, e, "total-viewing-time"), Nj);
    }), Dj = F3(function(r, n, e) {
        return A2(wl, A3(Cl, Ij, uj, tj), A3(Zj, r, n, e));
    }), _j = function(r) {
        return {
            $: 15,
            a: r
        };
    }, Oj = F2(function(r, n) {
        return {
            iw: r,
            lh: n
        };
    }), qj = A3(Et, Oj, A2(tu, "teamExternalId", g$), A2(tu, "teamName", wc)), Kj = A2(tu, "teams", sl(qj)), Uj = F3(function(r, n, e) {
        var t = mf(A2(aa, Vt, m([
            "enterprise-grant",
            n,
            "user",
            e,
            "teams"
        ])));
        return A3(Ol, r, t, Kj);
    }), Bj = F3(function(r, n, e) {
        return A2(wl, A3(Cl, _j, uj, tj), A3(Uj, r, n, e));
    }), Qj = function(r) {
        return {
            $: 9,
            a: r
        };
    }, Yj = F3(function(r, n, e) {
        var t = mf(A2(aa, Vt, m([
            "enterprise-grant",
            n,
            "user",
            e,
            "weekly-metrics"
        ])));
        return A3(Ol, r, t, lp);
    }), Jj = F3(function(r, n, e) {
        return A2(wl, A3(Cl, Qj, uj, tj), A3(Yj, r, n, e));
    }), Xj = F3(function(r, n, e) {
        return ma(m([
            A3(Gj, r, n, e),
            A3(Dj, r, n, e),
            A3(Sj, r, n, e),
            A3(Vj, r, n, e),
            A3(kj, r, n, e),
            A3(mj, r, n, e),
            A3(Bj, r, n, e),
            A3(Jj, r, n, e),
            A3(jj, r, n, e)
        ]));
    }), rA = function(r) {
        return {
            $: 12,
            a: r
        };
    }, nA = function(r) {
        return {
            $: 11,
            a: r
        };
    }, eA = F3(function(r, n, e) {
        var t = mf(A2(aa, Vt, m([
            "enterprise-grant",
            n,
            "user-activity",
            e
        ])));
        return A4(kk, "GET", bf, r, t);
    }), tA = F3(function(r, n, e) {
        return A2(wl, A3(Cl, nA, A2($l, rA, Ts), rA(Ss)), A3(eA, r, n, e));
    }), aA = F3(function(r, n, e) {
        switch(n.$){
            case 0:
                var t = n.a;
                return Ee(i(s(e, {
                    b6: (o = t, {
                        $: 1,
                        a: o
                    })
                }), ma(m([
                    A3(Xj, r, e.E, t.g7),
                    A2(da, ej, gb)
                ]))));
            case 1:
                return (a = n.a).$ ? Ee(i(s(e, {
                    b6: nj
                }), su)) : Fe(a.a);
            case 2:
                return Ee(i(s(e, {
                    lg: Ve(n.a)
                }), su));
            case 3:
                return (a = n.a).$ ? Ee(i(e, su)) : Fe(a.a);
            case 4:
                return Ee(i(s(e, {
                    cI: Ve(n.a)
                }), su));
            case 5:
            case 12:
                var a;
                return Fe(a = n.a);
            case 6:
                var u = s(e.j, {
                    e7: n.a
                });
                return Ee(i(s(e, {
                    j: u
                }), su));
            case 7:
                return u = s(e.j, {
                    hC: n.a
                }), Ee(i(s(e, {
                    j: u
                }), su));
            case 8:
                return Ee(i(e, A3(tA, r, n.a, n.b)));
            case 11:
                return Ee(i(e, A2(wk, 1 === (c = e.b6).$ ? c.a.iL + " Activity" : "Anonymous User Activity", n.a)));
            case 13:
                return u = s(e.j, {
                    hD: n.a
                }), Ee(i(s(e, {
                    j: u
                }), su));
            case 14:
                return u = s(e.j, {
                    hA: n.a
                }), Ee(i(s(e, {
                    j: u
                }), su));
            case 9:
                return u = s(e.j, {
                    kn: n.a
                }), Ee(i(s(e, {
                    j: u
                }), su));
            case 15:
                return u = s(e.j, {
                    cI: n.a
                }), Ee(i(s(e, {
                    j: u
                }), su));
            case 10:
                return u = s(e.j, {
                    fq: n.a
                }), Ee(i(s(e, {
                    j: u
                }), su));
            case 16:
                return u = s(e.j, {
                    hB: n.a
                }), Ee(i(s(e, {
                    j: u
                }), su));
            case 17:
                return Fe(Ts(n.a));
            case 18:
                return Fe(Ss);
            case 19:
                return Ee(i(e, su));
            case 20:
                return Ee(i(s(e, {
                    dV: Ve(n.a)
                }), su));
            default:
                return Ee(i(s(e, {
                    aP: n.a
                }), su));
        }
        var c, o;
    }), uA = function(r) {
        return {
            $: 1,
            a: r
        };
    }, cA = function(r) {
        return {
            $: 0,
            a: r
        };
    }, oA = {
        $: 35
    }, iA = {
        $: 4
    }, fA = function(r) {
        return {
            $: 2,
            a: r
        };
    }, sA = {
        $: 0
    }, lA = {
        $: 34
    }, bA = {
        $: 3
    }, dA = {
        $: 1
    }, vA = function(r) {
        return {
            $: 9,
            a: r
        };
    }, mA = {
        $: 8
    }, gA = function(r) {
        return {
            $: 3,
            a: r
        };
    }, pA = {
        $: 2
    }, $A = function(r) {
        return {
            $: 0,
            a: r
        };
    }, hA = function(r) {
        return {
            $: 4,
            a: r
        };
    }, wA = {
        $: 2
    }, CA = function(r) {
        return {
            $: 1,
            a: r
        };
    }, kA = function(r) {
        return {
            $: 1,
            a: r
        };
    }, yA = {
        $: 2
    }, xA = {
        $: 40
    }, LA = function(r) {
        return {
            $: 0,
            a: r
        };
    }, jA = function(r) {
        return {
            $: 38,
            a: r
        };
    }, AA = function(r) {
        return {
            $: 1,
            a: r
        };
    }, MA = function(r) {
        return {
            $: 30,
            a: r
        };
    }, FA = {
        $: 29
    }, HA = function(r) {
        return {
            $: 12,
            a: r
        };
    }, TA = function(r) {
        return {
            $: 1,
            a: r
        };
    }, SA = function(r) {
        return {
            $: 2,
            a: r
        };
    }, EA = function(r) {
        return {
            $: 19,
            a: r
        };
    }, zA = function(r) {
        return {
            $: 1,
            a: r
        };
    }, RA = function(r) {
        return {
            $: 16,
            a: r
        };
    }, VA = {
        $: 13
    }, WA = {
        $: 3
    }, PA = function(r) {
        return {
            $: 6,
            a: r
        };
    }, GA = function(r) {
        return {
            $: 0,
            a: r
        };
    }, IA = function(r) {
        return A2(Ne, "-", m([
            r.a,
            r.b,
            r.c,
            r.d
        ]));
    }, NA = F2(function(r, n) {
        return Di(m([
            i("userExternalId", _i(r)),
            i("accessCode", _i(IA(n)))
        ]));
    }), ZA = F4(function(r, n, e, t) {
        var a = mf(m([
            "enterprise-grant",
            n,
            "access-code",
            "redeem"
        ]));
        return A4(Ks, A2(NA, e, t), r, a, zt(0));
    }), DA = function(r) {
        switch(r){
            case 0:
                return _i("subscriber");
            case 1:
                return _i("seatAdmin");
            default:
                return _i("subscriberAndSeatAdmin");
        }
    }, _A = function(r) {
        return _i(r);
    }, OA = function(r) {
        return _i(r);
    }, qA = function(r) {
        return _i(r);
    }, KA = F3(function(r, n, e) {
        var t = mf(m([
            "enterprise-grant",
            n,
            "assign"
        ]));
        return A3(KL, function(r) {
            var n = r.jM, e = r.ka, t = r.jC, a = r.lg, u = r.i4;
            if (a.$) return Di(m([
                i("email", _A(t)),
                i("firstName", OA(n)),
                i("lastName", qA(e)),
                i("assignmentType", DA(u))
            ]));
            var c, o = a.a;
            return Di(m([
                i("email", _A(t)),
                i("firstName", OA(n)),
                i("lastName", qA(e)),
                i("team", (c = o, _i(c))),
                i("assignmentType", DA(u))
            ]));
        }(e), r, t);
    }), UA = function(r) {
        return {
            $: 21,
            a: r
        };
    }, BA = function(r) {
        switch(r){
            case 0:
                return "Active";
            case 1:
                return "Inactive";
            case 2:
                return "Seat Admins";
            case 3:
                return "Billing Admins";
            default:
                return "All";
        }
    }, QA = A2(Vw, "btn btn-secondary dropdown-toggle text-left elm-dropdown-trigger", A2(zw, "elm-dropdown-menu", A2(Ew, "elm-dropdown-item", A2(Sw, !1, A2(Rw, "Active", A2(Hw, UA, BA)))))), YA = function(r) {
        return {
            $: 3,
            a: r
        };
    }, JA = function(r) {
        return {
            $: 2,
            a: r
        };
    }, XA = F2(function(r, n) {
        var e = A2(th, r, n), t = A3(Cl, JA, function(r) {
            return YA(Ve(Ts(r)));
        }, YA(Ve(Ss)));
        return A2(wl, t, e);
    }), rM = F2(function(r, n) {
        return s(n, {
            jC: r
        });
    }), nM = function(r) {
        return _i(r);
    }, eM = F3(function(r, n, e) {
        var t = e, a = mf(m([
            "enterprise-grant",
            n,
            "admin-access",
            t
        ]));
        return A4(Xy, nM(t), r, a, zt(0));
    }), tM = function(r) {
        switch(r){
            case "different_company":
                return 1;
            case "no_seats_available":
                return 2;
            case "user_already_assigned":
                return 0;
            case "failed_to_make_grant_admin":
                return 3;
            case "not_a_registered_grant_admin":
                return 4;
            default:
                return 5;
        }
    }, aM = A2(St, tM, wc), uM = function(r) {
        switch(r.$){
            case 4:
                var n = A2(Ca, aM, r.b);
                return n.$ ? Fe(ut(n.a)) : Ee(n.a);
            case 3:
                var e = A2(Ca, aM, r.b);
                return e.$ ? Fe(ut(e.a)) : Ee(e.a);
            default:
                return Fe("Unknown network failure");
        }
    }, cM = F4(function(r, n, e, t) {
        return {
            $: 0,
            a: r,
            b: n,
            c: e,
            d: t
        };
    }), oM = function(r) {
        return 4 === It(r) ? ud(r) : Ld("a codePart has exactly 4 alphanumeric characters");
    }, iM = A2(nd, oM, Md(Cd(nt))), fM = bd, sM = function(r) {
        return fM(A2(cd, r, {
            $: 8,
            a: r
        }));
    }, lM = A2(xd, A2(xd, A2(xd, A2(xd, ud(cM), A2(ad, iM, sM("-"))), A2(ad, iM, sM("-"))), A2(ad, iM, sM("-"))), iM), bM = F3(function(r, n, e) {
        var t = mf(m([
            "enterprise-grant",
            n,
            "reactivate",
            e
        ]));
        return A2(VL, r, t);
    }), dM = F3(function(r, n, e) {
        var t = e, a = mf(m([
            "enterprise-grant",
            n,
            "revoke-billing-admin",
            t
        ]));
        return A4(Ks, nM(t), r, a, zt(0));
    }), vM = F3(function(r, n, e) {
        var t = e, a = mf(m([
            "enterprise-grant",
            n,
            "revoke-seat-admin",
            t
        ]));
        return A4(Ks, nM(t), r, a, zt(0));
    }), mM = A2(Os, "POST", bf), gM = F3(function(r, n, e) {
        var t = mf(m([
            "enterprise-grant",
            n,
            "reset-password",
            e
        ]));
        return A3(mM, r, t, zt(0));
    }), pM = s(Jc, {
        il: {
            $: 1
        }
    }), $M = function(r) {
        return {
            $: 22,
            a: r
        };
    }, hM = function(r) {
        return r;
    }, wM = function(r) {
        return r.kv;
    }, CM = A2(Vw, "btn btn-secondary dropdown-toggle text-left elm-dropdown-trigger", A2(zw, "elm-dropdown-menu", A2(Ew, "elm-dropdown-item", A2(Sw, !0, A2(Rw, "Add to Team", A2(Hw, $M, wM)))))), kM = F2(function(r, n) {
        return A2(Af, function(n) {
            var t;
            return e(r, n.g7) ? Ve(s(n, {
                A: (t = n.A, e(t, Wv) ? $A(uA(sA)) : Wv)
            })) : Ve(n);
        }, n);
    }), yM = F3(function(r, n, e) {
        var t, a = mf(m([
            "enterprise-grant",
            n,
            "unassign"
        ]));
        return A3(KL, (t = function(r) {
            return {
                iK: r
            };
        }(e), Di(m([
            i("userExternalId", nM(t.iK))
        ]))), r, a);
    }), xM = F3(function(r, n, e) {
        switch(n.$){
            case 0:
                return i(e, su);
            case 1:
            case 4:
                return i(s(e, {
                    j5: !1
                }), su);
            case 2:
                var t = A2(da, r.hP, ra(We));
                return i(s(e, {
                    j5: !1
                }), t);
            case 3:
                return i(s(e, {
                    j5: !e.j5
                }), su);
            default:
                return t = A2(da, r.hP, ra(Ve(n.a))), i(s(e, {
                    j5: !1
                }), t);
        }
    }), LM = F3(function(r, n, e) {
        var t = A3(xM, r, n, e);
        return i(t.a, t.b);
    }), jM = F2(function(r, n) {
        return s(n, {
            i4: r
        });
    }), AM = F2(function(r, n) {
        var e;
        return s(n, {
            il: (e = r, {
                $: 2,
                a: e
            })
        });
    }), MM = F2(function(r, n) {
        return s(n, {
            jM: r
        });
    }), FM = F2(function(r, n) {
        return s(n, {
            ka: r
        });
    }), HM = F2(function(r, n) {
        return r.$ ? n : s(n, {
            lg: Ve(r.a.g7)
        });
    }), TM = F4(function(r, n, t, a) {
        var u = a.dG;
        if (1 !== u.$) return Ee(i(a, su));
        var c, o = u.a;
        switch(t.$){
            case 0:
                return Ee(i(s(a, {
                    f: kA(t.a)
                }), su));
            case 1:
                return t.a.$ ? Ee(i(s(a, {
                    f: yA
                }), su)) : Fe(t.a.a);
            case 2:
                return Ee(i(s(a, {
                    eY: CA(t.a)
                }), su));
            case 3:
                return t.a.$ ? Ee(i(s(a, {
                    eY: wA
                }), su)) : Fe(t.a.a);
            case 4:
                var f = A3(yM, n, o.jW, (b = t.a).g7), l = A3(Cl, Es({
                    $: 5,
                    a: b
                }), Es(PA(JC(b))), PA(QC(Ss)));
                return Ee(i(a, A2(wl, l, f)));
            case 6:
                return t.a.$ ? Ee(i(s(a, {
                    aT: Ve(GA(Fe(b = t.a.a)))
                }), su)) : Fe(t.a.a);
            case 5:
                var b = t.a, d = a.f;
                if (1 === d.$) {
                    var v = A2(aa, function(r) {
                        return e(r.g7, b.g7) ? s(r, {
                            gh: 1
                        }) : r;
                    }, d.a);
                    return Ee(i(s(a, {
                        aT: Ve(GA(Ee(b))),
                        f: kA(v)
                    }), su));
                }
                return Ee(i(a, su));
            case 7:
                return f = A3(bM, n, o.jW, (b = t.a).g7), l = A3(Cl, Es({
                    $: 11,
                    a: b
                }), Es(HA(JC(b))), HA(QC(Ss))), Ee(i(a, A2(wl, l, f)));
            case 8:
                var g = function(r) {
                    return A2(da, Es(r), dy(75));
                }(VA), p = ma(m([
                    g,
                    A2(OC, n, o.jW)
                ]));
                return Ee(i(s(a, {
                    $7: pM,
                    cY: We
                }), p));
            case 9:
                return Ee(i(s(a, {
                    $7: A2(AM, t.a, a.$7)
                }), su));
            case 10:
                var $ = t.a;
                if (1 === $.$) {
                    var h = function(r) {
                        return rM(mi(r));
                    }(a.$7.jC);
                    return f = A3(KA, n, o.jW, h(a.$7)), l = A3(Cl, Es(mA), A2($l, vA, uM), xA), Ee(i(a, A2(wl, l, f)));
                }
                var w = s(a.$7, {
                    il: gA($.a)
                });
                return Ee(i(s(a, {
                    $7: w
                }), su));
            case 12:
                return t.a.$ ? Ee(i(s(a, {
                    aT: Ve(TA(Fe(b = t.a.a)))
                }), su)) : Fe(t.a.a);
            case 13:
                return Ee(i(s(a, {
                    $7: (c = a.$7, 1 === c.il.$ ? s(c, {
                        il: Yc
                    }) : c)
                }), su));
            case 11:
                b = t.a;
                var C = a.f;
                return 1 === C.$ ? (v = A2(aa, function(r) {
                    return e(r.g7, b.g7) ? s(r, {
                        gh: 0
                    }) : r;
                }, C.a), Ee(i(s(a, {
                    aT: Ve(TA(Ee(b))),
                    f: kA(v)
                }), su))) : Ee(i(a, su));
            case 14:
                return f = A3(vM, n, o.jW, (b = t.a).g7), l = A3(Cl, Es(function(r) {
                    return {
                        $: 15,
                        a: r
                    };
                }(b)), Es(RA(JC(b))), RA(QC(Ss))), Ee(i(a, A2(wl, l, f)));
            case 16:
                return t.a.$ ? Ee(i(s(a, {
                    ar: Ve(zA(Fe(b = t.a.a)))
                }), su)) : Fe(t.a.a);
            case 17:
                return f = A3(dM, n, o.jW, (b = t.a).g7), l = A3(Cl, Es(function(r) {
                    return {
                        $: 18,
                        a: r
                    };
                }(b)), Es(EA(JC(b))), EA(QC(Ss))), Ee(i(a, A2(wl, l, f)));
            case 19:
                return t.a.$ ? Ee(i(s(a, {
                    ar: Ve(SA(Fe(b = t.a.a)))
                }), su)) : Fe(t.a.a);
            case 15:
                b = t.a;
                var k = a.f;
                return 1 === k.$ ? (v = A2(aa, function(r) {
                    return e(r.g7, b.g7) ? s(r, {
                        eK: 2
                    }) : r;
                }, k.a), Ee(i(s(a, {
                    ar: Ve(zA(Ee(b))),
                    f: kA(v)
                }), su))) : Ee(i(a, su));
            case 18:
                b = t.a;
                var y = a.f;
                return 1 === y.$ ? (v = A2(aa, function(r) {
                    return e(r.g7, b.g7) ? s(r, {
                        eK: 2
                    }) : r;
                }, y.a), Ee(i(s(a, {
                    ar: Ve(SA(Ee(b))),
                    f: kA(v)
                }), su))) : Ee(i(a, su));
            case 20:
                var x = t.a, L = a.by;
                return Ee(i(a, A2(vm, r, L.$ ? A3(Lo, L.a, o.jW, Do(x.g7)) : A2(jo, o.jW, Do(x.g7)))));
            case 21:
                return Ee(i(s(a, {
                    a_: t.a
                }), su));
            case 22:
                var j = t.a;
                return Ee(i(s(a, {
                    $7: A2(HM, j, a.$7),
                    cY: j
                }), su));
            case 23:
                var A = A3(LM, QA, t.a, a.g2);
                return p = A.b, Ee(i(s(a, {
                    g2: A.a
                }), p));
            case 24:
                var M = t.a;
                return _t(M) ? Ee(i(s(a, {
                    c1: We
                }), su)) : Ee(i(s(a, {
                    c1: Ve(M)
                }), su));
            case 25:
                var F = a.f;
                return Ee(i(1 === F.$ ? s(a, {
                    f: kA(E = A2(kM, t.a, G = F.a))
                }) : a, su));
            case 26:
                var H = s(a, {
                    aK: AA(b = t.a)
                });
                return Ee(i(H, su));
            case 27:
                return H = s(a, {
                    aK: Qc
                }), Ee(i(H, su));
            case 28:
                return b = t.a, H = s(a, {
                    aK: pA
                }), f = A3(gM, n, o.jW, b.g7), l = A3(Cl, Es(FA), Es(MA(JC(b))), MA(QC(Ss))), Ee(i(H, A2(wl, l, f)));
            case 29:
                return H = s(a, {
                    aK: WA
                }), Ee(i(H, su));
            case 30:
                return t.a.$ ? Ee(i(s(a, {
                    aK: hA(b = t.a.a)
                }), su)) : Fe(t.a.a);
            case 31:
                var T = t.a, S = a.f;
                if (1 === S.$) {
                    var E = A2(aa, function(r) {
                        if (e(r.g7, T)) return s(r, {
                            A: $A(cA(fA("")))
                        });
                        var n = r.A;
                        return n.$ || n.a.$ ? r : s(r, {
                            A: $A(uA(sA))
                        });
                    }, G = S.a);
                    return Ee(i(s(a, {
                        f: kA(E)
                    }), su));
                }
                return Ee(i(a, su));
            case 32:
                var z = t.a, R = a.f;
                return 1 === R.$ ? (E = A2(aa, function(r) {
                    var n = r.A;
                    return n.$ || n.a.$ ? r : s(r, {
                        A: $A(cA(fA(z)))
                    });
                }, G = R.a), Ee(i(s(a, {
                    f: kA(E)
                }), su))) : Ee(i(a, su));
            case 33:
                var V = t.a, W = V.a, P = (z = V.b, a.f);
                if (1 === P.$) {
                    var G = P.a, I = A2(qd, lM, z);
                    if (I.$) return Ee(i(a, su));
                    var N = I.a;
                    return E = A2(aa, function(r) {
                        var n = r.A;
                        return n.$ || n.a.$ ? r : s(r, {
                            A: $A(cA(dA))
                        });
                    }, G), H = s(a, {
                        f: kA(E)
                    }), f = A4(ZA, n, o.jW, W, N), l = A3(Cl, Es(lA), Es(oA), oA), Ee(i(H, A2(wl, l, f)));
                }
                return Ee(i(a, su));
            case 34:
                var Z = a.f;
                return 1 === Z.$ ? (E = A2(aa, function(r) {
                    var n = r.A;
                    return n.$ || n.a.$ ? r : s(r, {
                        A: $A(uA(bA))
                    });
                }, G = Z.a), Ee(i(s(a, {
                    f: kA(E)
                }), su))) : Ee(i(a, su));
            case 35:
                var D = a.f;
                return 1 === D.$ ? (E = A2(aa, function(r) {
                    var n = r.A;
                    return n.$ || n.a.$ ? r : s(r, {
                        A: $A(cA(iA))
                    });
                }, G = D.a), Ee(i(s(a, {
                    f: kA(E)
                }), su))) : Ee(i(a, su));
            case 36:
                return f = A3(eM, n, o.jW, (b = t.a).g7), l = A3(Cl, Es(function(r) {
                    return {
                        $: 37,
                        a: r
                    };
                }(b)), Es(jA(JC(b))), jA(QC(Ss))), Ee(i(a, A2(wl, l, f)));
            case 38:
                return t.a.$ ? Ee(i(s(a, {
                    ar: Ve(LA(Fe(b = t.a.a)))
                }), su)) : Fe(t.a.a);
            case 37:
                b = t.a;
                var _ = a.f;
                return 1 === _.$ ? (v = A2(aa, function(r) {
                    return e(r.g7, b.g7) ? s(r, {
                        eK: 0
                    }) : r;
                }, _.a), Ee(i(s(a, {
                    ar: Ve(LA(Ee(b))),
                    f: kA(v)
                }), su))) : Ee(i(a, su));
            case 39:
                return Ee(i(s(a, {
                    dX: 1
                }), A2(XA, n, o.jW)));
            case 40:
                return Fe(Ss);
            case 42:
                return Ee(i(s(a, {
                    $7: A2(MM, t.a, a.$7)
                }), su));
            case 43:
                return Ee(i(s(a, {
                    $7: A2(FM, t.a, a.$7)
                }), su));
            case 41:
                return Ee(i(s(a, {
                    $7: A2(rM, t.a, a.$7)
                }), su));
            case 44:
                return Ee(i(s(a, {
                    $7: A2(jM, t.a, a.$7)
                }), su));
            case 45:
                var O = A3(LM, CM, t.a, a.c0);
                return p = O.b, Ee(i(s(a, {
                    c0: O.a
                }), p));
            case 46:
                return Ee(i(s(a, {
                    cD: !0
                }), su));
            default:
                return Ee(i(s(a, {
                    cD: !1
                }), su));
        }
    }), SM = function(r) {
        return {
            $: 8,
            a: r
        };
    }, EM = function(r) {
        return {
            $: 9,
            a: r
        };
    }, zM = F3(function(r, n, e) {
        return A3(xL, r, A2(L$, n, e), A2(tu, "teamExternalId", g$));
    }), RM = F3(function(r, n, e) {
        return A2(wl, A3(Cl, SM, Es(EM(We)), EM(Ve(Ss))), A3(zM, r, n, e));
    }), VM = F2(function(r, n) {
        var t, a, u = (a = (t = n).a, A3(Ae, F2(function(r, n) {
            var e = n.a, t = n.b;
            return i(e - 1, A2(ye, i(e, r), t));
        }), i(a - 1, b), t).b), c = sc(A2(fc, function(n) {
            return e(r, n.b.g7);
        }, u));
        if (c.$) return n;
        var o = c.a, f = o.b;
        return A3(WC, o.a, A4(v$, f.kv, f.g7, f.kj, 1 === f.bl ? 0 : 1), n);
    }), WM = F4(function(r, n, t, a) {
        switch(t.$){
            case 1:
                return Ee(i(s(a, {
                    eY: CA(o = t.a)
                }), su));
            case 2:
                return (f = t.a).$ ? Ee(i(s(a, {
                    eY: wA
                }), su)) : Fe(f.a);
            case 0:
                var u = t.a, c = a.eY;
                switch(c.$){
                    case 0:
                    default:
                        return Ee(i(a, su));
                    case 1:
                        return Ee(i(s(a, {
                            eY: CA(A2(VM, u, o = c.a))
                        }), su));
                }
            case 3:
                return Ee(i(a, A2(vm, r, A3(EC, a.by, a.E, Qo(u = t.a)))));
            case 4:
                return Ee(i(a, A2(vm, r, A3(EC, a.by, a.E, Io))));
            case 5:
                return Ee(i(s(a, {
                    b2: Ve(t.a)
                }), su));
            case 6:
                return Ee(i(s(a, {
                    b2: We
                }), su));
            case 7:
                return Ee(i(a, A3(RM, n, a.E, u = t.a)));
            case 8:
                u = t.a;
                var o = 1 === (l = a.eY).$ ? CA(A2(Iw, function(r) {
                    return !e(r.g7, u);
                }, l.a)) : a.eY;
                return Ee(i(s(a, {
                    b2: We,
                    eY: o
                }), su));
            default:
                var f;
                return (f = t.a).$ ? Ee(i(a, su)) : Fe(f.a);
        }
        var l;
    }), PM = {
        $: 1
    }, GM = {
        $: 0
    }, IM = {
        $: 2
    }, NM = function(r) {
        return {
            $: 1,
            a: r
        };
    }, ZM = function(r) {
        return {
            $: 6,
            a: r
        };
    }, DM = F2(function(r, n) {
        return JC(i(s(r, {
            a8: Ve(n)
        }), Oi(IM)));
    }), _M = function(r) {
        return {
            $: 1,
            a: r
        };
    }, OM = cu(m([
        A2(tu, "RECAPTCHA_LOADED", zt({
            $: 0
        })),
        A2(St, _M, A2(St, Vt, A2(tu, "RECAPTCHA_TOKEN", wc))),
        A2(tu, "RECAPTCHA_EXPIRED", zt({
            $: 2
        })),
        A2(tu, "RECAPTCHA_ERROR", zt({
            $: 3
        }))
    ])), qM = F2(function(r, n) {
        var e = n;
        return Di(m([
            i("username", _i(r)),
            i("reCaptchaToken", _i(e))
        ]));
    }), KM = function(r) {
        return {
            $: 2,
            a: r
        };
    }, UM = function(r) {
        var n;
        return 3 === r.$ && (n = r.a.k6) >= 400 && 500 > n ? 0 : 1;
    }, BM = A2(St, Vt, A2(tu, "token", wc)), QM = A5(hc, va, BM, A2(tu, "customerSuccess", wu), A2(tu, "hasInsights", wu), A2(tu, "zendeskToken", wc)), YM = F3(function(r, n, e) {
        var t = n, a = e, u = Di(m([
            i("username", _i(r)),
            i("password", _i(t)),
            i("reCaptchaToken", _i(a))
        ]));
        return A2(wl, A2($l, KM, Ha(UM)), A4(Ks, u, "not-used", "login-recaptcha", QM));
    }), JM = "An unknown error has occurred, please try again.", XM = F2(function(r, n) {
        switch(r.$){
            case 0:
                return JC(i(s(n, {
                    a8: We,
                    c8: r.a
                }), su));
            case 1:
                return JC(i(s(n, {
                    a8: We,
                    bg: r.a
                }), su));
            case 2:
                if (1 === (b = r.a).$) {
                    var e = b.a;
                    return A2(DM, s(n, {
                        bw: 1
                    }), e);
                }
                return QC(b.a);
            case 4:
                return JC(i(s(n, n.ap.$ ? {
                    cU: We,
                    ap: NM(0)
                } : {
                    a8: We
                }), Oi(PM)));
            case 3:
                var t = A2(pu, OM, r.a);
                if (1 === t.$) return JC(i(n, su));
                var a = i(n.ap, t.a);
                switch(a.b.$){
                    case 3:
                    case 2:
                        return JC(i(n, su));
                    case 0:
                        return JC(a.a.$ ? i(s(n, {
                            ap: NM(0)
                        }), Oi(GM)) : i(n, Oi(GM)));
                    default:
                        if (a.a.$) {
                            var u = a.b.a;
                            if (a.a.a) return JC(i(n, su));
                            var c = A2(qM, n.c8, u), o = yx(ZM);
                            return JC(i(n, A4(Fx, "not-used", "password-reset", c, o)));
                        }
                        var f = a.b.a;
                        return JC(i(s(n, {
                            bw: 0
                        }), A3(YM, n.c8, n.bg, f)));
                }
            case 5:
                var l = s(n, {
                    ap: r.a
                });
                return JC(i(l, su));
            default:
                var b;
                if ((b = r.a).$) {
                    var d = b.a, v = function() {
                        switch(d.$){
                            case 4:
                                return d.a;
                            case 3:
                                return Ie(d.a) + " error";
                            default:
                                return JM;
                        }
                    }();
                    return l = s(n, {
                        cU: Ve(v),
                        ap: NM(2)
                    }), JC(i(l, Oi(IM)));
                }
                l = s(n, {
                    ap: NM(1)
                });
                return JC(i(l, su));
        }
    }), rF = F4(function(r, n, e, t) {
        return {
            jA: t,
            ki: r,
            kt: n,
            k2: e
        };
    }), nF = function(r) {
        return {
            $: 13,
            a: r
        };
    }, eF = {
        $: 12
    }, tF = function(r) {
        return {
            $: 1,
            a: r
        };
    }, aF = {
        $: 2
    }, uF = {
        $: 1
    }, cF = function(r) {
        return {
            $: 2,
            a: r
        };
    }, oF = function(r) {
        return r ? 0 : 1;
    }, iF = function(r) {
        return _i(r);
    }, fF = F3(function(r, n, e) {
        return A4(Ks, function(r) {
            var n, e, t, a;
            return Di(m([
                i("assignedTo", (a = r.ki, A2($k, iF, a))),
                i("module", (t = r.kt, _i(t))),
                i("dueDate", (e = r.jA, _i(Sk(e)))),
                i("sendEmails", (n = r.k2, Ni(!n)))
            ]));
        }(e), r, mf(A2(aa, Vt, m([
            "enterprise-grant",
            n,
            "assignment"
        ]))), zt(0));
    }), sF = ko, lF = F2(function(r, n) {
        return A3(lo, r, 0, n);
    }), bF = function(r) {
        return A3(_e, lF, sF, r);
    }, dF = F2(function(r, n) {
        return !A2(co, r, n).$;
    }), vF = F2(function(r, n) {
        return A2(dF, r, n);
    }), mF = F2(function(r, n) {
        if (1 === r.$) {
            var e = r.a, t = bF(A2(aa, A2($l, sm, function(r) {
                return r.g7;
            }), e.kj));
            return A2(fc, function(r) {
                return A2(vF, r.u.g7, t);
            }, n);
        }
        return n;
    }), gF = F4(function(r, n, e, t) {
        return A2(vm, r, A3(EC, n, e, Oo(t)));
    }), pF = function(r) {
        return !r.b;
    }, $F = function(r) {
        return !r;
    }, hF = function(r) {
        return $F(r.aM);
    }, wF = function(r) {
        return !r.gh;
    }, CF = function(r) {
        return {
            u: r,
            aM: 1
        };
    }, kF = function(r) {
        return r;
    }, yF = F4(function(r, n, t, a) {
        switch(t.$){
            case 0:
                return Ee(i(s(a, {
                    cM: (M = t.a, {
                        $: 1,
                        a: M
                    })
                }), su));
            case 1:
            case 3:
                return t.a.$ ? Ee(i(s(a, {
                    ki: aF
                }), su)) : Fe(t.a.a);
            case 2:
                var u = A2(aa, CF, A2(fc, wF, t.a));
                return Ee(i(s(a, {
                    ac: u,
                    ki: tF(u)
                }), su));
            case 4:
                return Ee(i(s(a, {
                    dq: t.a
                }), su));
            case 5:
                var c = A3(cy, jv, t.a, a.cv), o = c.a, f = c.b, l = 2 === f.$ ? Ve(f.a) : a.jA;
                return Ee(i(s(a, {
                    jA: l,
                    cv: o
                }), su));
            case 6:
                return Ee(i(s(a, {
                    aP: Ve(t.a)
                }), su));
            case 7:
                var b = t.a, d = a.ki;
                if (1 === d.$) {
                    var v = d.a, m = A2(aa, function(r) {
                        return s(r, {
                            aM: oF(b)
                        });
                    }, a.ac), g = bF(A2(aa, function(r) {
                        return r.u.g7;
                    }, a.ac)), p = A3(GL, function(r) {
                        return A2(vF, r.u.g7, g);
                    }, function(r) {
                        return s(r, {
                            aM: oF(b)
                        });
                    }, v);
                    return Ee(i(s(a, {
                        ac: m,
                        ki: tF(p)
                    }), su));
                }
                return Ee(i(a, su));
            case 8:
                var $ = t.a, h = (b = t.b, a.ki);
                return 1 === h.$ ? (p = A3(GL, function(r) {
                    return e(r.u.g7, $);
                }, function(r) {
                    return s(r, {
                        aM: oF(b)
                    });
                }, v = h.a), m = A3(GL, function(r) {
                    return e(r.u.g7, $);
                }, function(r) {
                    return s(r, {
                        aM: oF(b)
                    });
                }, a.ac), Ee(i(s(a, {
                    ac: m,
                    ki: tF(p)
                }), su))) : Ee(i(a, su));
            case 9:
                return Ee(i(s(a, {
                    k2: (A = t.a, A ? 0 : 1)
                }), su));
            case 10:
            case 12:
                return Ee(i(a, A4(gF, r, a.by, a.cw, a.cK)));
            case 11:
                var w = i(a.ki, a.jA);
                if (1 !== w.a.$ || w.b.$) return Ee(i(a, su));
                var C = w.b.a, k = A2(aa, function(r) {
                    return r.u.g7;
                }, A2(fc, hF, w.a.a)), y = function() {
                    if (pF(k)) return su;
                    var r = A3(Cl, Es(eF), function(r) {
                        return nF(Ts(r));
                    }, nF(Ss));
                    return A2(wl, r, A3(fF, n, a.cw, A4(rF, k, a.cK, a.k2, C)));
                }();
                return Ee(i(a, y));
            case 13:
                return Fe(t.a);
            case 14:
                return Ee(i(s(a, {
                    eY: cF(t.a)
                }), su));
            case 15:
                var x = t.a;
                return x.$ ? Ee(i(s(a, {
                    eY: uF
                }), su)) : Fe(x.a);
            case 16:
                return Ee(i(s(a, {
                    cW: t.a
                }), su));
            case 17:
                return Ee(i(s(a, {
                    aF: !a.aF
                }), su));
            default:
                var L = t.a, j = a.ki;
                return Ee(i(1 === j.$ ? s(a, {
                    a_: L,
                    aF: !1,
                    ac: A2(mF, L, v = j.a)
                }) : a, su));
        }
        var A, M;
    }), xF = function(r) {
        return {
            $: 14,
            a: r
        };
    }, LF = function(r) {
        return {
            $: 13,
            a: r
        };
    }, jF = function(r) {
        return {
            $: 1,
            a: r
        };
    }, AF = {
        $: 2
    }, MF = {
        $: 2
    }, FF = function(r) {
        return {
            $: 11,
            a: r
        };
    }, HF = function(r) {
        return {
            $: 10,
            a: r
        };
    }, TF = F2(function(r, n) {
        return A3(xL, r, function(r) {
            return mf(A2(aa, Vt, m([
                "assignment",
                r
            ])));
        }(n), A2(tu, "assignmentExternalId", Um));
    }), SF = F2(function(r, n) {
        return A2(wl, A3(Cl, HF, A2($l, FF, Ts), FF(Ss)), A2(TF, r, n));
    }), EF = F3(function(r, n, e) {
        var t = mf(A2(aa, Vt, m([
            "enterprise-grant",
            n,
            "module",
            e,
            "assignment-activity"
        ])));
        return A4(kk, "GET", bf, r, t);
    }), zF = function(r) {
        return {
            $7: r,
            dD: 0
        };
    }, RF = F3(function(r, n, t) {
        return 1 === t.$ ? jF(A3(GL, function(n) {
            return e(n.$7.g7, r);
        }, function(r) {
            return s(r, {
                dD: n
            });
        }, t.a)) : t;
    }), VF = F4(function(r, n, e, t) {
        switch(e.$){
            case 0:
                return Ee(i(s(t, {
                    cM: ($ = e.a, {
                        $: 1,
                        a: $
                    })
                }), su));
            case 1:
                return (d = e.a).$ ? Ee(i(s(t, {
                    cM: MF
                }), su)) : Fe(d.a);
            case 2:
                return Ee(i(s(t, {
                    ea: e.a
                }), su));
            case 3:
                return Ee(i(s(t, {
                    eW: e.a
                }), su));
            case 4:
                var a = A3(EC, t.by, t.E, ri(e.a));
                return Ee(i(t, A2(vm, r, a)));
            case 5:
                return Ee(i(t, A2(vm, r, A3(EC, t.by, t.E, Vo))));
            case 6:
                var u = A3(EC, t.by, t.E, Go(e.a));
                return Ee(i(t, A2(vm, r, u)));
            case 7:
                return Ee(i(s(t, {
                    gC: jF(A2(aa, zF, e.a))
                }), su));
            case 8:
                return (d = e.a).$ ? Ee(i(s(t, {
                    gC: AF
                }), su)) : Fe(d.a);
            case 9:
                return Ee(i(s(t, {
                    gC: A3(RF, c = e.a, 1, t.gC)
                }), A2(SF, n, c)));
            case 10:
                var c;
                return Ee(i(s(t, {
                    gC: A3(RF, c = e.a, 2, t.gC)
                }), su));
            case 11:
                return Fe(e.a);
            case 12:
                var o = t.cM;
                if (1 === o.$) {
                    var f = A3(EF, n, t.E, o.a.g7), l = A3(Cl, LF, A2($l, xF, Ts), xF(Ss));
                    return Ee(i(s(t, {
                        ch: 0,
                        cs: 0
                    }), A2(wl, l, f)));
                }
                return Ee(i(t, su));
            case 13:
                var b = e.a;
                return Ee(i(s(t, {
                    cs: 1
                }), A2(wk, 1 === (p = t.cM).$ ? p.a.hF + " Activity" : "No Module Name Activity", b)));
            case 14:
                var d;
                return Fe(d = e.a);
            case 15:
                return Ee(i(s(t, {
                    ch: 3
                }), su));
            default:
                var v = e.a, m = t.ci, g = s(m, {
                    bA: xx(m.bA),
                    jQ: v
                });
                return Ee(i(s(t, {
                    ci: g
                }), su));
        }
        var p, $;
    }), WF = function(r) {
        return {
            $: 7,
            a: r
        };
    }, PF = function(r) {
        return {
            $: 6,
            a: r
        };
    }, GF = function(r) {
        return {
            $: 11,
            a: r
        };
    }, IF = function(r) {
        return {
            $: 9,
            a: r
        };
    }, NF = {
        $: 10
    }, ZF = {
        $: 16
    }, DF = Qn("blur"), _F = function(r) {
        return r.a;
    }, OF = function(r) {
        var n, e;
        return r.$ ? (n = r.a.g7, Di(m([
            i("type", _i("episode")),
            i("externalId", _i(_F(n)))
        ]))) : (e = r.a.g7, Di(m([
            i("type", _i("course")),
            i("externalId", _i(_F(e)))
        ])));
    }, qF = function(r) {
        return A2($k, OF, r);
    }, KF = function(r) {
        return _i(r);
    }, UF = function(r) {
        return _i(r);
    }, BF = F3(function(r, n, e) {
        return Di(m([
            i("moduleName", UF(r)),
            i("moduleDescription", KF(n)),
            i("courses", A2($k, _i, b)),
            i("moduleTeams", A2($k, _i, b)),
            i("contents", qF(e))
        ]));
    }), QF = A2(tu, "externalId", Hg), YF = F5(function(r, n, e, t, a) {
        return A4(Ks, A3(BF, e, t, a), r, Eg(n), QF);
    }), JF = F2(function(r, n) {
        return {
            $: 3,
            a: r,
            b: n
        };
    }), XF = F2(function(r, n) {
        var e = A3(Cl, n, A2($l, $m, Ts), $m(Ss));
        return A2(wl, e, r);
    }), rH = F7(function(r, n, e, t, a, u, c) {
        return {
            bz: c,
            g7: a,
            hv: e,
            bP: u,
            kv: r,
            lb: n,
            b5: t
        };
    }), nH = A2(St, Vt, wc), eH = A8(ng, rH, A2(tu, "name", gg), A2(tu, "subtitle", pg), A2(tu, "length", vg), A2(tu, "url", $g), A2(tu, "externalId", dg), A2(tu, "licensed", mg), A2(tu, "description", Om(nH))), tH = A2(tu, "courses", sl(eH)), aH = F2(function(r, n) {
        var e = n;
        return A2(S$, m([
            "enterprise-grant",
            r,
            "tag",
            "courses"
        ]), m([
            A2(R$, "url", e)
        ]));
    }), uH = F3(function(r, n, e) {
        return A3(Ol, r, A2(aH, n, e), tH);
    }), cH = F3(function(r, n, e) {
        return A2(XF, A3(uH, r, n, e), JF(e));
    }), oH = F4(function(r, n, e, t) {
        return A2(vm, r, A3(EC, n, e, Go(t)));
    }), iH = F3(function(r, n, e) {
        return A2(vm, r, A3(EC, n, e, Vo));
    }), fH = function(r) {
        return 1 !== r.$;
    }, sH = function(r) {
        return r.trim();
    }, lH = function(r) {
        return "" !== sH(r.kv) && "" !== sH(r.bz);
    }, bH = function(r) {
        return !pF(r);
    }, dH = F4(function(r, n, e, t) {
        switch(t){
            case 0:
                return !0;
            case 1:
                return lH(n) && fH(r);
            default:
                return fH(r) ? lH(n) && bH(e) : lH(n);
        }
    }), vH = F3(function(r, n, e) {
        var t = i(A2(Mi, r, e), A2(Mi, n, e));
        return t.a.$ || t.b.$ ? e : A3(WC, n, t.a.a, A3(WC, r, t.b.a, e));
    }), mH = F3(function(r, n, e) {
        var t = Gw(e.bZ);
        return s(e, {
            bZ: Me(A3(vH, r, n, t))
        });
    }), gH = F2(function(r, n) {
        return {
            fk: r,
            R: We,
            cN: !1,
            W: 0,
            w: Wm,
            aL: "",
            bZ: n.hE,
            b_: We,
            X: i(!1, ""),
            Y: i(!1, ""),
            le: b
        };
    }), pH = F2(function(r, n) {
        return i(s(n, r.$ ? {
            bz: r.a
        } : {
            kv: r.a
        }), su);
    }), $H = function(r) {
        return {
            $: 1,
            a: r
        };
    }, hH = {
        $: 4
    }, wH = F3(function(r, n, e) {
        return {
            $: 3,
            a: r,
            b: n,
            c: e
        };
    }), CH = F2(function(r, n) {
        return {
            $: 0,
            a: r,
            b: n
        };
    }), kH = {
        $: 1
    }, yH = {
        $: 2
    }, xH = F2(function(r, n) {
        return A2(Gx, function(n) {
            return A2(bc, n, r);
        }, n);
    }), LH = F3(function(r, n, t) {
        var a;
        return e(t.dz.b5, r) ? s(t, {
            e1: (a = t.e1, a ? 0 : 1),
            e2: Ve(n)
        }) : t;
    }), jH = F3(function(r, n, e) {
        var t = e.a, a = e.b;
        if (1 === a.$) {
            var u = a.a;
            return A2(CH, t, $H(A2(aa, A2(LH, r, n), u)));
        }
        return A2(CH, t, a);
    }), AH = {
        $: 0
    }, MH = function(r) {
        return A2(CH, r, AH);
    }, FH = function(r) {
        var n = function(r) {
            return {
                g7: r.g7,
                cC: r.bP,
                hv: r.hv,
                kv: r.kv,
                lb: r.lb,
                b5: r.b5
            };
        }(r);
        return fg(n);
    }, HH = F3(function(r, n, e) {
        return {
            gT: n,
            g7: r.g7,
            cC: e,
            hv: r.hv,
            z: r.z
        };
    }), TH = F2(function(r, n) {
        return sg(A3(HH, r, n.kv, r.bP));
    }), SH = function(r) {
        return ui(A3(_e, F2(function(r, n) {
            return A2(ye, r.dH, n);
        }), b, r));
    }, EH = function(r) {
        return {
            $: 5,
            a: r
        };
    }, zH = F2(function(r, n) {
        return A2(S$, m([
            "enterprise-grant",
            r,
            "search"
        ]), m([
            A2(R$, "query", n)
        ]));
    }), RH = F3(function(r, n, e) {
        return {
            jc: e,
            jr: r,
            dH: n
        };
    }), VH = A7(ku, F6(function(r, n, e, t, a, u) {
        return {
            g7: a,
            hv: t,
            bP: u,
            kv: r,
            lb: n,
            b5: e
        };
    }), A2(tu, "name", gg), A2(tu, "subtitle", pg), A2(tu, "url", $g), A2(tu, "length", vg), A2(tu, "externalId", dg), A2(tu, "licensed", mg)), WH = A6(jg, F5(function(r, n, e, t, a) {
        return {
            gT: t,
            g7: e,
            cC: a,
            hv: n,
            z: r
        };
    }), A2(tu, "title", Lg), A2(tu, "length", Om(yg)), A2(tu, "externalId", kg), A2(Ov, m([
        "course",
        "name"
    ]), gg), A2(tu, "licensed", xg)), PH = A4(Ui, RH, A2(tu, "contentCourses", sl(VH)), A2(tu, "contentEpisodes", sl(WH)), A2(tu, "marketingEpisodes", sl(WH))), GH = F3(function(r, n, e) {
        return A3(Ol, r, A2(zH, n, e), PH);
    }), IH = F3(function(r, n, e) {
        return A2(XF, A3(GH, r, n, e), EH);
    }), NH = F3(function(r, n, e) {
        return {
            $: 16,
            a: r,
            b: n,
            c: e
        };
    }), ZH = F2(function(r, n) {
        var e = n;
        return A2(S$, m([
            "enterprise-grant",
            r,
            "courses",
            "topics"
        ]), m([
            A2(R$, "url", e)
        ]));
    }), DH = F2(function(r, n) {
        return {
            dH: n,
            z: r
        };
    }), _H = A6(jg, F5(function(r, n, e, t, a) {
        return {
            bz: r,
            g7: t,
            hv: e,
            bP: a,
            z: n
        };
    }), A2(tu, "description", Om(wc)), A2(tu, "title", Lg), A2(tu, "length", Om(yg)), A2(tu, "externalId", kg), A2(tu, "licensed", xg)), OH = A3(Et, DH, A2(tu, "title", A2(St, Vt, wc)), A2(tu, "episodes", sl(_H))), qH = A2(tu, "topics", sl(OH)), KH = F3(function(r, n, e) {
        return A3(Ol, r, A2(ZH, n, e), qH);
    }), UH = F4(function(r, n, e, t) {
        return A2(XF, A3(KH, r, n, e), A2(NH, e, t));
    }), BH = F2(function(r, n) {
        var t = i(r, n);
        r: for(;;){
            if (1 === t.a.$) {
                if (1 === t.b.$) return e(t.a.a.g7, t.b.a.g7);
                break r;
            }
            if (t.b.$) break r;
            return e(t.a.a.g7, t.b.a.g7);
        }
        return !1;
    }), QH = F2(function(r, n) {
        return A2(fc, function(n) {
            return !A2(BH, n, r);
        }, n);
    }), YH = F2(function(r, n) {
        return A3(_e, QH, n, r);
    }), JH = F4(function(r, n, e, t) {
        return {
            dz: r,
            ke: t,
            e1: e,
            e2: n
        };
    }), XH = function(r) {
        return A4(JH, r, We, 1, 0);
    }, rT = F2(function(r, n) {
        return {
            dH: n,
            z: r
        };
    }), nT = function(r) {
        return A2(rT, r.z, r.dH);
    }, eT = F2(function(r, n) {
        return sc(A2(fc, r, n));
    }), tT = F2(function(r, n) {
        return A2(eT, function(n) {
            return e(n.a.b5, r);
        }, n);
    }), aT = function(r) {
        return s(r, {
            w: Wm,
            aL: ""
        });
    }, uT = F3(function(r, n, e) {
        return l(A2(fc, function(r) {
            return !A2(bc, r, n);
        }, e), m([
            FH(r)
        ]));
    }), cT = function(r) {
        return {
            dz: {
                bz: We,
                g7: r.g7,
                hv: r.hv,
                bP: r.bP,
                kv: r.kv,
                lb: r.lb,
                b5: r.b5
            },
            ke: 1,
            e1: 1,
            e2: We
        };
    }, oT = F2(function(r, n) {
        return A4(XL, r, b, n, b);
    }), iT = F4(function(r, n, t, a) {
        switch(t.$){
            case 0:
                return Fe(t.a);
            case 1:
                var u = t.a;
                return Ee(i(s(a, {
                    le: A2(aa, MH, u)
                }), u.b ? A3(cH, r, n, u.a.b5) : su));
            case 2:
                var c = A2(tT, d = t.a, a.le);
                if (c.$) return Ee(i(aT(a), su));
                if (c.a.b.$) {
                    var o = aT(a);
                    return Ee(i(s(o, {
                        b_: Ve(d)
                    }), su));
                }
                return Ee(i(aT(a), A3(cH, r, n, d)));
            case 3:
                var d = t.a, v = t.b, g = A3(GL, function(r) {
                    return e(r.a.b5, d);
                }, function(r) {
                    return A2(CH, r.a, $H(A2(aa, XH, v)));
                }, a.le);
                return Ee(i(s(a, {
                    b_: Ve(d),
                    le: g
                }), su));
            case 4:
                switch(o = s(a, {
                    aL: p = t.a
                }), It(p)){
                    case 0:
                        return Ee(i(s(o, {
                            w: Wm
                        }), su));
                    case 1:
                        return Ee(i(s(o, {
                            w: kH
                        }), su));
                    default:
                        return Ee(i(s(o, {
                            w: yH
                        }), A2(da, function() {
                            return {
                                $: 18,
                                a: p
                            };
                        }, dy(200))));
                }
            case 18:
                var p;
                return e(p = t.a, a.aL) ? Ee(i(a, A3(IH, r, n, p))) : Ee(i(a, su));
            case 5:
                var $ = t.a, h = $.dH, w = A2(aa, cT, $.jr), C = $.jc, k = (tr = f(w, h, C)).a.b || tr.b.b || tr.c.b ? A3(wH, w, h, C) : hH;
                return Ee(i(s(a, {
                    w: k
                }), su));
            case 6:
                return Ee(i(aT(a), su));
            case 7:
                return Ee(i(s(a, {
                    cN: !0
                }), su));
            case 15:
                var y = t.a, x = t.b, L = t.c;
                if (x.$) return Ee(i(a, A4(UH, r, n, y, L)));
                var j = x.a;
                if (L) {
                    var A = a.w;
                    if (3 === A.$) {
                        var M = A.a, F = A.b, H = A.c;
                        return Ee(i(s(a, {
                            w: A3(wH, T = A2(aa, A2(LH, y, j), M), F, H)
                        }), su));
                    }
                    return Ee(i(a, su));
                }
                return Ee(i(s(a, {
                    le: A2(aa, A2(jH, y, j), a.le)
                }), su));
            case 16:
                if (y = t.a, L = t.b, j = A2(aa, nT, E = t.c), L) {
                    var T = function() {
                        var r = a.w;
                        if (3 === r.$) {
                            var n = r.a, e = r.b, t = r.c;
                            return A3(wH, A2(aa, A2(LH, y, j), n), e, t);
                        }
                        return a.w;
                    }();
                    return Ee(i(s(a, {
                        w: T
                    }), su));
                }
                return Ee(i(s(a, {
                    le: A2(aa, A2(jH, y, j), a.le)
                }), su));
            case 8:
                var S = t.a, E = t.c, z = A2(ai, a.bZ, m([
                    t.b
                ])), R = SH(E), V = A2(aa, function(r) {
                    return A2(TH, r, S);
                }, R), W = (er = z, A3(_e, F2(function(r, n) {
                    return 1 === r.$ ? A2(ye, sg(r.a), n) : n;
                }), b, er));
                return Ee(i(s(a, A2(xH, W, V) ? {
                    R: We,
                    bZ: A3(uT, S, V, z)
                } : {
                    R: We,
                    bZ: z
                }), su));
            case 10:
                S = t.a, E = t.c;
                var P = A2(aa, function(r) {
                    return sg(A3(HH, r, S.kv, r.bP));
                }, t.b.dH), G = A2(fc, function(r) {
                    return !!r.$;
                }, a.bZ), I = A2(fc, function(r) {
                    return !r.$;
                }, a.bZ), N = (R = SH(E), V = A2(aa, function(r) {
                    return A2(TH, r, S);
                }, R), l(G, P)), Z = l(I, A2(oT, function(r) {
                    return _F(r.a.g7);
                }, N));
                return Ee(i(s(a, A2(xH, Z, V) ? {
                    R: We,
                    bZ: A3(uT, S, V, Z)
                } : {
                    R: We,
                    bZ: Z
                }), su));
            case 9:
                var D = t.a, _ = D.dz, O = FH(_), q = (R = (nr = D.e2).$ ? b : SH(nr.a), A2(ai, A2(YH, A2(aa, function(r) {
                    return A2(TH, r, _);
                }, R), a.bZ), m([
                    O
                ])));
                return Ee(i(s(a, {
                    R: We,
                    bZ: q
                }), su));
            case 11:
                return Ee(i(s(a, {
                    R: We,
                    bZ: A2(ye, t.a, a.bZ)
                }), su));
            case 12:
                return Ee(i(s(a, {
                    bZ: A2(YH, t.a, a.bZ)
                }), su));
            case 13:
                var K = t.a, U = t.b, B = (R = SH(E = t.c), A2(QH, U, A2(aa, function(r) {
                    return A2(TH, r, K);
                }, R))), Q = FH(K);
                return Ee(i(s(a, {
                    bZ: X = A2(ai, A2(QH, Q, a.bZ), B)
                }), su));
            case 14:
                K = t.a, E = t.c;
                var Y = A2(aa, function(r) {
                    return sg(A3(HH, r, K.kv, r.bP));
                }, t.b.dH), J = (R = SH(E), A2(YH, Y, A2(aa, function(r) {
                    return A2(TH, r, K);
                }, R))), X = (Q = FH(K), l(A2(QH, Q, a.bZ), J));
                return Ee(i(s(a, {
                    bZ: X
                }), su));
            case 17:
                return Ee(i(s(a, {
                    W: t.a
                }), su));
            case 19:
                return Ee(i(s(a, {
                    R: Ve(t.a)
                }), su));
            case 20:
                return Ee(i(s(a, {
                    R: We
                }), su));
            case 21:
                var rr = t.a;
                return o = function() {
                    var r = a.X;
                    if (r.a) return t = e(n = r.b, rr) ? i(!1, n) : i(!0, rr), s(a, {
                        X: t
                    });
                    if ("" === r.b) return s(a, {
                        X: i(!0, rr)
                    });
                    var n, t = e(n = r.b, rr) ? i(!0, n) : i(!0, rr);
                    return s(a, {
                        X: t
                    });
                }(), Ee(i(o, su));
            default:
                return rr = t.a, o = function() {
                    var r = a.Y;
                    if (r.a) return t = e(n = r.b, rr) ? i(!1, n) : i(!0, rr), s(a, {
                        Y: t
                    });
                    if ("" === r.b) return s(a, {
                        Y: i(!0, rr)
                    });
                    var n, t = e(n = r.b, rr) ? i(!0, n) : i(!0, rr);
                    return s(a, {
                        Y: t
                    });
                }(), Ee(i(o, su));
        }
        var nr, er, tr;
    }), fT = F2(function(r, n) {
        return Di(m([
            i("moduleName", UF(r)),
            i("moduleDescription", KF(n))
        ]));
    }), sT = F5(function(r, n, e, t, a) {
        return A3(fy, A2(fT, t, a), r, A2(zg, n, e));
    }), lT = F4(function(r, n, t, a) {
        switch(t.$){
            case 0:
            case 10:
                return Ee(i(a, A3(iH, r, a.by, a.E)));
            case 1:
                return Ee(i(s(a, {
                    ea: t.a
                }), su));
            case 2:
                return Ee(i(s(a, {
                    c5: t.a
                }), su));
            case 3:
            default:
                return Ee(i(a, su));
            case 4:
                var u = t.a, c = t.b;
                if (A4(dH, a.az, a.F, a.C.bZ, u)) {
                    var o = function() {
                        var r = a.C.le;
                        if (r.b) {
                            var e = r.a;
                            return e.b.$ ? su : A2(Sv, gm, A3(cH, n, c, e.a.b5));
                        }
                        return su;
                    }();
                    return Ee(i(e(a.a0, Ve(u)) ? s(a, {
                        cc: Gm,
                        a0: We
                    }) : s(a, {
                        cc: Fv(Im(u)),
                        a0: Ve(u)
                    }), o));
                }
                return Ee(i(a, su));
            case 5:
                var f = A5(YF, n, a.E, a.F.kv, a.F.bz, a.C.bZ), l = A3(Cl, WF, A2($l, PF, Ts), PF(Ss));
                return Ee(i(s(a, {
                    bY: 0
                }), A2(wl, l, f)));
            case 8:
                return f = A5(sT, n, a.E, t.a, a.F.kv, a.F.bz), l = A3(Cl, Es(NF), A2($l, IF, Ts), IF(Ss)), Ee(i(s(a, {
                    bY: 0
                }), A2(wl, l, f)));
            case 9:
            case 6:
                return Fe(t.a);
            case 7:
                return Ee(i(a, A4(oH, r, a.by, a.E, t.a)));
            case 11:
                var b = a.F, d = A2(pH, t.a, a.F), v = d.a, m = (o = d.b, s(b, {
                    bz: v.bz,
                    kv: v.kv
                }));
                return Ee(i(s(a, {
                    F: m
                }), A2(Sv, GF, o)));
            case 12:
                var g = A4(iT, n, a.E, t.a, a.C);
                if (g.$) return Fe(g.a);
                var p = g.a;
                return o = p.b, Ee(i(s(a, {
                    C: p.a
                }), A2(Sv, gm, o)));
            case 13:
                var $ = t.a, h = function(r) {
                    return {
                        fs: r.hE,
                        bz: r.kr,
                        kv: r.hF
                    };
                }($);
                return m = 2 === a.az.$ ? s(h, {
                    kv: h.kv + " Clone"
                }) : h, Ee(i(s(a, {
                    C: A2(gH, a.fk, $),
                    bQ: 1,
                    F: m
                }), su));
            case 14:
                var w = t.a;
                return w.$ ? Ee(i(s(a, {
                    bQ: 2
                }), su)) : Fe(w.a);
            case 15:
                var C = t.c;
                return Ee(i(s(a, {
                    C: A3(mH, t.a, t.b, a.C)
                }), function(r) {
                    return A2(wl, function() {
                        return ZF;
                    }, DF(r));
                }(C)));
        }
    }), bT = {
        $: 3
    }, dT = {
        $: 5
    }, vT = function(r) {
        return {
            $: 5,
            a: r
        };
    }, mT = {
        $: 4
    }, gT = {
        $: 1
    }, pT = function(r) {
        return {
            $: 0,
            a: r
        };
    }, $T = function(r) {
        return i(function() {
            switch(r.im){
                case 0:
                    return "createTeamSkipped";
                case 1:
                    return "buildModuleSkipped";
                case 2:
                    return "inviteUserSkipped";
                case 3:
                    return "enableLearningRemindersSkipped";
                case 4:
                    return "assignModuleSkipped";
                default:
                    return "establishCustomReportSkipped";
            }
        }(), Ni(2 === r.gh));
    }, hT = F4(function(r, n, e, t) {
        var a = r;
        return Rf({
            bv: qs(e),
            fJ: t,
            bH: m([
                A2(df, "Authorization", "Bearer " + a)
            ]),
            bS: "PATCH",
            b4: Vf,
            gq: We,
            b5: $f(m([
                n
            ]))
        });
    }), wT = F2(function(r, n) {
        var t, a = (t = A2(tx, function(r) {
            switch(r){
                case 0:
                    return 1;
                case 2:
                    return 2;
                case 1:
                    return 3;
                case 3:
                    return 4;
                case 4:
                    return 5;
                default:
                    return 6;
            }
        }(r), n), A3(_e, F2(function(r, n) {
            return n.$ ? r.gh ? We : Ve(r.im) : n;
        }), We, t));
        if (a.$) return n;
        var u = a.a;
        return A2(aa, function(r) {
            return s(r, {
                cX: e(u, r.im)
            });
        }, n);
    }), CT = Xr("setOnboardToggle", Ni), kT = F3(function(r, n, t) {
        switch(r.$){
            case 0:
                return i(n, i(CT(!t.hQ.cQ), Ve(gT)));
            case 1:
                var a = r.a;
                return i(n, i(su, Ve(pT(A2(aa, function(r) {
                    return s(r, {
                        cX: e(a, r.im)
                    });
                }, t.hQ.$9)))));
            case 2:
                return i(n, i(su, Ve({
                    $: 2,
                    a: r.a
                })));
            case 3:
                a = r.a;
                var u = r.b, c = A2(aa, function(r) {
                    var n = i(r.cX, u);
                    return n.a ? s(r, n.b ? {
                        cX: !u,
                        gh: 2
                    } : {
                        cX: !u,
                        gh: 0
                    }) : r;
                }, t.hQ.$9), o = Di(A2(aa, $T, c)), f = A2(wT, a, c), l = yx(vT), b = Ml(m([
                    A2(R$, "enterprise-grant", n.dM)
                ]));
                return i(n, i(A4(hT, n.gp, "onboard-status" + b, o, l), Ve(pT(f))));
            case 4:
                return i(n, i(su, Ve((d = r.a).$ ? bT : pT(d.a))));
            default:
                var d;
                return i(n, i(su, Ve((d = r.a).$ ? dT : mT)));
        }
    }), yT = function(r) {
        return {
            $: 1,
            a: r
        };
    }, xT = function(r) {
        return {
            $: 8,
            a: r
        };
    }, LT = function(r) {
        return {
            $: 9,
            a: r
        };
    }, jT = {
        $: 2
    }, AT = F2(function(r, n) {
        return r.$ ? Ee(i(s(n, {
            a4: 3,
            lg: jT,
            bk: We
        }), su)) : Fe(r.a);
    }), MT = function(r) {
        return {
            $: 12,
            a: r
        };
    }, FT = function(r) {
        return {
            $: 11,
            a: r
        };
    }, HT = A2($l, $k(A2($l, _i, sm)), aa(function(r) {
        return r.g7;
    })), TT = F3(function(r, n, e) {
        var t = mf(A2(aa, Vt, m([
            "enterprise-grant",
            n,
            "team-activity"
        ])));
        return A4(kk, "POST", qs(HT(e)), r, t);
    }), ST = F3(function(r, n, e) {
        return A2(wl, A3(Cl, FT, A2($l, MT, Ts), MT(Ss)), A3(TT, r, n, e));
    }), ET = A2($l, _i, hM), zT = F2(function(r, n) {
        return Di(m([
            i("name", ET(r)),
            i("members", HT(n))
        ]));
    }), RT = F3(function(r, n, e) {
        return A4(Xy, A2(zT, e.kv, e.kj), r, A2(L$, n, e.g7), x$);
    }), VT = function(r) {
        return r;
    }, WT = mc(A2($l, VT, function(r) {
        return r.jM;
    })), PT = function(r) {
        return m(r.trim().split(/\s+/g));
    }, GT = F3(function(r, n, e) {
        var t = A2(aa, mi, PT(e));
        return A2(lc, function(n) {
            return A2(Gt, n, r);
        }, t) || A2(Gt, mi(e), mi(n));
    }), IT = F2(function(r, n) {
        var e = mi(l(n.jM, n.ka));
        return A3(GT, e, n.iL, r);
    }), NT = F2(function(r, n) {
        return A2(Af, function(n) {
            var t;
            return e(r, n.g7) ? Ve(s(n, {
                eX: (t = n.eX, 1 === t ? 0 : 1)
            })) : Ve(n);
        }, n);
    }), ZT = F4(function(r, n, t, a) {
        switch(t.$){
            case 0:
                var u = WT(($ = t.a).kj);
                return Ee(i(s(a, {
                    ax: u,
                    lg: yT($)
                }), su));
            case 1:
            case 8:
                return A2(AT, t.a, a);
            case 2:
                return Ee(i(a, A2(vm, r, A3(EC, a.by, a.E, Jo))));
            case 3:
                var c = a.lg;
                return Ee(i(a, 1 === c.$ ? A2(vm, r, A3(EC, a.by, a.E, A2(Yo, (l = c.a).g7, t.a.g7))) : su));
            case 4:
                var o = A3(EC, a.by, t.a, ni(t.b));
                return Ee(i(a, A2(vm, r, o)));
            case 5:
                var f = a.lg;
                if (1 === f.$) {
                    var l = f.a, b = WT(A2(fc, IT(t.a), l.kj));
                    return Ee(i(s(a, {
                        ax: b
                    }), su));
                }
                return Ee(i(a, su));
            case 6:
                return Ee(i(s(a, {
                    ax: A2(NT, t.a, a.ax)
                }), su));
            case 7:
                var d = t.a, v = a.lg;
                if (1 === v.$) {
                    var m = s($ = v.a, {
                        kj: A2(fc, function(r) {
                            return !e(r.g7, d);
                        }, $.kj)
                    }), g = A3(RT, n, a.E, m), p = A3(Cl, LT, Es(xT(We)), xT(Ve(Ss)));
                    return Ee(i(a, A2(wl, p, g)));
                }
                return Ee(i(a, su));
            case 9:
                var $ = t.a, h = WT(A2(fc, function(r) {
                    return A2(bc, r.g7, A2(aa, function(r) {
                        return r.g7;
                    }, $.kj));
                }, a.ax));
                return Ee(i(s(a, {
                    a4: 3,
                    ax: h,
                    lg: yT($),
                    bk: We
                }), su));
            case 10:
                var w = a.lg;
                return 1 === w.$ ? (l = w.a, Ee(i(s(a, {
                    ct: 0,
                    c$: 0
                }), A3(ST, n, a.E, l.kj)))) : Ee(i(a, su));
            case 11:
                var C = t.a;
                return Ee(i(s(a, {
                    ct: 1
                }), A2(wk, 1 === (k = a.lg).$ ? k.a.kv + " Activity" : "No Team Activity", C)));
            case 12:
                return Fe(t.a);
            case 13:
                return Ee(i(s(a, {
                    c$: 3
                }), su));
            case 15:
                return Ee(i(s(a, {
                    a4: 3,
                    bk: We
                }), su));
            default:
                return Ee(i(s(a, {
                    a4: 0,
                    bk: Ve(t.a)
                }), su));
        }
        var k;
    }), DT = {
        $: 2
    }, _T = function(r) {
        return {
            $: 1,
            a: r
        };
    }, OT = function(r) {
        return {
            g7: r.g7,
            jM: r.jM,
            ka: r.ka,
            eX: 1,
            iL: r.iL
        };
    }, qT = F2(function(r, n) {
        return !A2(bc, n, r);
    }), KT = function(r) {
        return {
            $: 10,
            a: r
        };
    }, UT = function(r) {
        return {
            $: 9,
            a: r
        };
    }, BT = F4(function(r, n, e, t) {
        return A4(Ks, A2(zT, e, t), r, mf(A2(aa, Vt, m([
            "enterprise-grant",
            n,
            "team"
        ]))), x$);
    }), QT = F4(function(r, n, e, t) {
        var a = A4(BT, r, n, e, t), u = A3(Cl, UT, A2($l, KT, Ts), KT(Ss));
        return A2(wl, u, a);
    }), YT = function(r) {
        return {
            $: 13,
            a: r
        };
    }, JT = function(r) {
        return {
            $: 12,
            a: r
        };
    }, XT = F5(function(r, n, e, t, a) {
        return A4(Xy, A2(zT, e, t), r, A2(L$, n, a), x$);
    }), rS = F5(function(r, n, e, t, a) {
        var u = A5(XT, r, n, e, t, a), c = A3(Cl, JT, A2($l, YT, Ts), YT(Ss));
        return A2(wl, c, u);
    }), nS = F4(function(r, n, t, a) {
        switch(t.$){
            case 3:
                var u = t.a, c = WT(A2(fc, qT(a.y), A2(aa, OT, A2(fc, wF, u))));
                return Ee(i(s(a, {
                    aw: _T(c)
                }), su));
            case 4:
                var o = t.a;
                return o.$ ? Ee(i(s(a, {
                    aw: DT
                }), su)) : Fe(o.a);
            case 5:
                var f = t.a;
                if (_t(f)) return Ee(i(s(a, {
                    a9: f,
                    ax: b
                }), su));
                var l = a.aw;
                if (1 === l.$) {
                    u = l.a;
                    var d = WT(A2(fc, IT(f), A2(fc, qT(a.y), u)));
                    return Ee(i(s(a, {
                        a9: f,
                        ax: d
                    }), su));
                }
                return Ee(i(a, su));
            case 0:
                return Ee(i(a, su));
            case 1:
                return Ee(i(s(a, {
                    lh: t.a
                }), su));
            case 2:
                var v = t.a;
                return Ee(i(s(a, {
                    cc: Fv(am(v)),
                    a0: v
                }), su));
            case 6:
                var m = WT(A2(ye, g = t.a, a.y));
                return d = function() {
                    var r = a.aw;
                    if (1 === r.$) {
                        var n = r.a;
                        return WT(A2(fc, IT(a.a9), A2(fc, qT(m), n)));
                    }
                    return b;
                }(), Ee(i(s(a, {
                    ax: d,
                    y: m
                }), su));
            case 7:
                var g = t.a, p = (m = WT(A2(fc, function(r) {
                    return !e(r, g);
                }, a.y)), WT(A2(ye, g, a.ax))), $ = 1 === (k = a.aw).$ ? WT(A2(ye, g, k.a)) : b;
                return Ee(i(s(a, {
                    aw: _T($),
                    ax: p,
                    y: m
                }), su));
            case 8:
                return Ee(i(a, A4(QT, n, a.E, a.lh, a.y)));
            case 11:
                return Ee(i(a, A5(rS, n, a.E, a.lh, a.y, t.a)));
            case 9:
            case 12:
                return Ee(i(a, A2(vm, r, A3(EC, a.by, a.E, Qo((C = t.a).g7)))));
            case 10:
                if (2 === (w = t.a).$) {
                    var h = w.a;
                    return Ee(i(s(a, {
                        cc: Fv(am(0)),
                        a0: 0,
                        a8: qw(h),
                        b3: 0
                    }), su));
                }
                return Fe(w);
            case 13:
                var w;
                return 2 === (w = t.a).$ ? (h = w.a, Ee(i(s(a, {
                    cc: Fv(am(0)),
                    a0: 0,
                    a8: qw(h),
                    b3: 0
                }), su))) : Fe(w);
            case 14:
                return Ee(i(a, A2(vm, r, A3(EC, a.by, a.E, Jo))));
            case 15:
                var C;
                return p = WT(A2(fc, qT((C = t.a).kj), a.ax)), Ee(i(s(a, {
                    cc: Fv(am(1)),
                    a0: 1,
                    ax: p,
                    iw: Ve(C.g7),
                    y: WT(C.kj),
                    lh: C.kv
                }), su));
            case 16:
                return Fe(t.a);
            default:
                return Ee(i(s(a, {
                    b3: 3
                }), su));
        }
        var k;
    }), eS = function(r) {
        return {
            $: 12,
            a: r
        };
    }, tS = {
        $: 11
    }, aS = function(r) {
        return {
            $: 10,
            a: r
        };
    }, uS = {
        $: 9
    }, cS = function(r) {
        return Di(m([
            i("accentBG", _i(r.Z)),
            i("accentColor", _i(r._)),
            i("borderRadius", _i(r.aC)),
            i("enterpriseGrant", _i(r.fH)),
            i("headerBG", _i(r.ad)),
            i("headerColor", _i(r.ae)),
            i("logoString", _i(r.Q)),
            i("primaryBG", _i(r.am)),
            i("primaryColor", _i(r.an))
        ]));
    }, oS = mf(m([
        "company-white-label"
    ])), iS = F2(function(r, n) {
        return A4(Ks, cS(n), r, oS, lh);
    }), fS = A2(da, Xt, jr(function() {
        cn.location.reload(false);
    })), sS = F3(function(r, n, e) {
        if (r.$) switch(n){
            case 0:
                return s(qc, {
                    ad: e
                });
            case 1:
                return s(qc, {
                    ae: e
                });
            case 2:
                return s(qc, {
                    am: e
                });
            case 3:
                return s(qc, {
                    an: e
                });
            case 4:
                return s(qc, {
                    Z: e
                });
            default:
                return s(qc, {
                    _: e
                });
        }
        else {
            var t = r.a;
            switch(n){
                case 0:
                    return s(t, {
                        ad: e
                    });
                case 1:
                    return s(t, {
                        ae: e
                    });
                case 2:
                    return s(t, {
                        am: e
                    });
                case 3:
                    return s(t, {
                        an: e
                    });
                case 4:
                    return s(t, {
                        Z: e
                    });
                default:
                    return s(t, {
                        _: e
                    });
            }
        }
    }), lS = F3(function(r, n, e) {
        return A3(fy, cS(n), r, mf(A2(aa, Vt, m([
            "company-white-label",
            e
        ]))));
    }), bS = F2(function(r, n) {
        return {
            Z: r.Z,
            _: r._,
            aC: r.aC,
            fH: n,
            ad: r.ad,
            ae: r.ae,
            Q: r.Q,
            am: r.am,
            an: r.an
        };
    }), dS = F2(function(r, n) {
        switch(n.$){
            case 0:
                var e = s(r, {
                    n: Ve(t = A3(sS, r.n, n.a, n.b))
                });
                return Ee(i(e, su));
            case 1:
                var t = s((d = r.n).$ ? qc : d.a, {
                    Q: n.a
                });
                return e = s(r, {
                    n: Ve(t)
                }), Ee(i(e, su));
            case 2:
                return t = s((b = r.n).$ ? qc : b.a, {
                    aC: n.a
                }), e = s(r, {
                    n: Ve(t)
                }), Ee(i(e, su));
            case 3:
                var a = (u = n.a).$ ? qc : s(qc, {
                    cb: u.a
                });
                return e = s(r, {
                    n: Ve(a)
                }), Ee(i(e, su));
            case 4:
                return Ee(i(s(r, {
                    as: 0
                }), su));
            case 5:
            case 9:
                return Ee(i(s(r, {
                    as: 3
                }), su));
            case 6:
                var u = n.b, c = A2(bS, n.a, r.cw);
                if (u.$) return o = A2(iS, r.gp, c), f = A3(Cl, Es(tS), A2($l, eS, Ts), eS(Ss)), Ee(i(r, A2(wl, f, o)));
                var o = A3(lS, r.gp, c, u.a), f = A3(Cl, Es(uS), A2($l, aS, Ts), aS(Ss));
                return Ee(i(r, A2(wl, f, o)));
            case 7:
                return Ee(i(s(r, {
                    n: n.a
                }), su));
            case 8:
                var l = n.a;
                return l.$ ? Ee(i(s(r, {
                    n: Ve(qc)
                }), su)) : Fe(l.a);
            case 10:
            case 12:
                return Fe(n.a);
            default:
                return Ee(i(s(r, {
                    as: 3
                }), fS));
        }
        var b, d;
    }), vS = F2(function(r, n) {
        switch(r.$){
            case 0:
                var e = s(t = n.hQ, {
                    il: 2,
                    $9: r.a
                });
                return s(n, {
                    bR: We,
                    hQ: e
                });
            case 1:
                return e = s(t = n.hQ, {
                    cQ: !t.cQ
                }), s(n, {
                    hQ: e
                });
            case 2:
                return e = s(t = n.hQ, {
                    cQ: r.a
                }), s(n, {
                    hQ: e
                });
            case 3:
                return e = s(t = n.hQ, {
                    il: 0
                }), s(n, {
                    bR: Ve(0),
                    hQ: e
                });
            case 4:
                return s(n, {
                    bR: We
                });
            default:
                var t;
                return e = s(t = n.hQ, {
                    il: 0
                }), s(n, {
                    bR: Ve(1),
                    hQ: e
                });
        }
    }), mS = F3(function(r, n, t) {
        var a, u, c, o = function() {
            switch(n.kK.$){
                case 1:
                default:
                    return Xf;
                case 4:
                case 5:
                    return Ms;
                case 6:
                case 7:
                case 8:
                case 10:
                    return Df;
                case 11:
                case 12:
                case 13:
                    return Ls;
                case 17:
                case 14:
                case 16:
                    return $s;
                case 18:
                    return cs;
                case 19:
                    return ws;
            }
        }(), l = i(r, n.kK);
        r: for(;;)switch(l.a.$){
            case 2:
                return A3(jw, l.a.a, n, t);
            case 43:
                var b = l.a.a, d = function() {
                    if (b.$) return n;
                    var r = b.a, e = "" === n.iJ.iK ? r : s(n.iJ, {
                        i9: r.i9,
                        kb: r.kb,
                        iK: n.iJ.iK
                    });
                    return s(n, {
                        iJ: e
                    });
                }();
                return A2(eC, d, t);
            case 6:
                if (l.b.$) break r;
                var v = A2(XM, l.a.a, l.b.a);
                if (v.$) {
                    var g = v.a, p = g.b;
                    return i(s(n, {
                        kK: Wi(g.a)
                    }), A2(Sv, Pi, p));
                }
                return i(s(n, {
                    hy: Ve(b = v.a)
                }), su);
            case 8:
                if (4 === l.b.$) {
                    var $ = function(r) {
                        var e = r.b;
                        return i(s(n, {
                            kK: zc(r.a)
                        }), A2(Sv, ss, e));
                    };
                    return A3(Bw, n, A4(TM, n.hr, t.gp, l.a.a, l.b.a), $);
                }
                break r;
            case 17:
                if (11 === l.b.$) return $ = function(r) {
                    var e = r.b;
                    return i(s(n, {
                        kK: Pc(r.a)
                    }), A2(Sv, js, e));
                }, A3(Bw, n, A4(WM, n.hr, t.gp, l.a.a, l.b.a), $);
                break r;
            case 15:
                if (6 === l.b.$) return $ = function(r) {
                    var e = r.b;
                    return i(s(n, {
                        kK: Rc(r.a)
                    }), A2(Sv, vs, e));
                }, A3(Bw, n, A4(bL, n.hr, t.gp, l.a.a, l.b.a), $);
                break r;
            case 47:
                if (19 === l.b.$) return $ = function(r) {
                    var e = r.b;
                    return i(s(n, {
                        kK: Wc(r.a)
                    }), A2(Sv, Cs, e));
                }, A3(Bw, n, A2(dS, l.b.a, l.a.a), $);
                break r;
            case 11:
                if (17 === l.b.$) return $ = function(r) {
                    var e = r.b;
                    return i(s(n, {
                        kK: Hc(r.a)
                    }), A2(Sv, Yf, e));
                }, A3(Bw, n, A4(DL, n.hr, t.gp, l.a.a, l.b.a), $);
                break r;
            case 3:
                if (l.a.a.$) {
                    var h = l.a.c;
                    return A4(nC, n, t, y = h.a, x = h.b);
                }
                var w = l.a, C = w.a.a, k = w.c, y = k.a, x = k.b, L = l.b, j = Me(O = A2(Si, A2(Hi, Vc, U = w.b), x));
                if ((q = A3(_e, F2(function(r, n) {
                    return e(r.bG.jW, C) ? Ve(r) : n;
                }), sc(j), j)).$) return A4(nC, n, t, y, x);
                var A = s(J = n.iJ, {
                    iK: (Y = q.a).bG.iK
                }), M = Sl(n.fk), F = function() {
                    var r = i(U, L);
                    n: for(;;)switch(r.a.$){
                        case 0:
                            if (4 === r.b.$) {
                                var e = s(r.b.a, {
                                    dG: es(Y.bG)
                                }), a = A2(OC, t.gp, C);
                                return i(zc(e), A2(Sv, ss, a));
                            }
                            break n;
                        case 2:
                            if (11 === r.b.$) {
                                var u = A3(xC, t.gp, Vc, Y.bG), c = u.b;
                                return i(Pc(u.a), A2(Sv, js, c));
                            }
                            break n;
                        case 1:
                            if (6 === r.b.$) {
                                var o = A3(wC, t.gp, Vc, C), f = o.b;
                                return i(Rc(o.a), A2(Sv, vs, f));
                            }
                            break n;
                        case 3:
                            if (1 === r.a.a.$ && 17 === r.b.$) {
                                var l = A4(vC, t.gp, Vc, ns(Y.bG), We), b = l.b;
                                return i(Hc(l.a), A2(Sv, Yf, b));
                            }
                            break n;
                        case 4:
                            if (1 === r.b.$) {
                                var d = A6(Bp, n.fk, t.gp, Vc, C, n.jt, n.gn), v = d.b;
                                return i(Jf(d.a), A2(Sv, rs, v));
                            }
                            break n;
                        default:
                            break n;
                    }
                    var m = A8(GC, n.fk, t.gp, Vc, x, We, U, y, n);
                    return i(m.a.kK, m.b);
                }(), H = F.a, T = F.b, S = A4(rC, t, Vc, M, C), E = S.a, z = S.b, R = function(r) {
                    return ma(m([
                        r,
                        A2(Sv, ps, z)
                    ]));
                };
                return d = s(n, {
                    gQ: y,
                    gW: Ve(Y),
                    fI: O,
                    hQ: Ve(E),
                    iJ: A
                }), i(s(d, {
                    kK: H
                }), R(T));
            case 4:
                if (l.a.b.$) {
                    var V = l.a, W = V.d, P = (y = W.a, x = W.b, Q = Tc(_ = V.a), A2(Mi, 0, O = A2(Si, A2(Hi, Q, Fc), x)));
                    if (P.$) return i(n, su);
                    var G = P.a, I = (J = n.iJ, A2(dm, n.hr, A3(Hl, Xf, Q, G.bG.jW))), N = (A = s(J, {
                        iK: G.bG.iK
                    }), A4(rC, t, Q, Sl(n.fk), G.bG.jW)), Z = (E = N.a, z = N.b, A5(Qp, n, t.gp, n.fk, G.bG.jW, Q)), D = Z.b;
                    return i(s(Z.a, {
                        by: Tc(_),
                        gQ: y,
                        gW: Ve(G),
                        fI: O,
                        hy: Ve(t),
                        hQ: Ve(E),
                        iJ: A
                    }), ma(m([
                        D,
                        I,
                        A2(Sv, ps, z)
                    ])));
                }
                var _, O, q, K = l.a, U = (C = K.b.a, K.c), B = K.d, Q = (y = B.a, x = B.b, L = l.b, Tc(_ = K.a));
                if (j = Me(O = A2(Si, A2(Hi, Q, U), x)), (q = A3(_e, F2(function(r, n) {
                    return e(r.bG.jW, C) ? Ve(r) : n;
                }), sc(j), j)).$) return i(n, su);
                A = s(J = n.iJ, {
                    iK: (Y = q.a).bG.iK
                });
                var Y, J, X = (M = Sl(n.fk), A4(rC, t, Q, M, C)), rr = (E = X.a, z = X.b, R = function(r) {
                    return ma(m([
                        r,
                        A2(Sv, ps, z)
                    ]));
                }, function() {
                    var r = i(U, L);
                    n: for(;;)switch(r.a.$){
                        case 0:
                            if (4 === r.b.$) {
                                var e = s(r.b.a, {
                                    dG: es(Y.bG)
                                }), a = A2(OC, t.gp, C);
                                return i(zc(e), R(A2(Sv, ss, a)));
                            }
                            break n;
                        case 2:
                            if (11 === r.b.$) {
                                var u = A3(xC, t.gp, Q, Y.bG), c = u.b;
                                return i(Pc(u.a), R(A2(Sv, js, c)));
                            }
                            break n;
                        case 1:
                            if (6 === r.b.$) {
                                var o = A3(wC, t.gp, Q, C), f = o.b;
                                return i(Rc(o.a), R(A2(Sv, vs, f)));
                            }
                            break n;
                        case 3:
                            if (1 === r.a.a.$ && 17 === r.b.$) {
                                var l = A4(vC, t.gp, Q, ns(Y.bG), We), b = l.b;
                                return i(Hc(l.a), R(A2(Sv, Yf, b)));
                            }
                            break n;
                        case 4:
                            if (1 === r.b.$) {
                                var d = A6(Bp, n.fk, t.gp, Q, C, n.jt, n.gn), v = d.b;
                                return i(Jf(d.a), R(A2(Sv, rs, v)));
                            }
                            break n;
                        default:
                            break n;
                    }
                    var m = A8(GC, n.fk, t.gp, Q, x, Ve(C), U, y, n);
                    return i(m.a.kK, m.b);
                }());
                return H = rr.a, T = rr.b, d = s(n, {
                    gQ: y,
                    gW: Ve(Y),
                    fI: O,
                    hQ: Ve(E),
                    iJ: A
                }), i(s(d, {
                    kK: H
                }), R(T));
            case 7:
                if (5 === l.b.$) return $ = function(r) {
                    var e = r.b;
                    return i(s(n, {
                        kK: is(r.a)
                    }), A2(Sv, fs, e));
                }, A3(Bw, n, b = A3(aA, t.gp, l.a.a, l.b.a), $);
                break r;
            case 9:
                if (3 === l.b.$) {
                    var nr = A4(fk, n.hr, t.gp, l.a.a, l.b.a);
                    if (nr.$) {
                        var er = nr.a;
                        return p = er.b, i(s(n, {
                            kK: Of(er.a)
                        }), A2(Sv, qf, p));
                    }
                    return i(n, A4(c$, t.gp, nr.a.g7, We, Fc));
                }
                break r;
            case 13:
                if (7 === l.b.$) return $ = function(r) {
                    var e = r.b;
                    return i(s(n, {
                        kK: ds(r.a)
                    }), A2(Sv, gs, e));
                }, A3(Bw, n, b = A4(lT, n.hr, t.gp, l.a.a, l.b.a), $);
                break r;
            case 16:
                if (10 === l.b.$) return $ = function(r) {
                    var e = r.b;
                    return i(s(n, {
                        kK: ls(r.a)
                    }), A2(Sv, bs, e));
                }, A3(Bw, n, b = A4(VF, n.hr, t.gp, l.a.a, l.b.a), $);
                break r;
            case 14:
                if (7 === l.b.$) return $ = function(r) {
                    var e = r.b;
                    return i(s(n, {
                        kK: ds(r.a)
                    }), A2(Sv, gs, e));
                }, A3(Bw, n, b = A4(lT, n.hr, t.gp, l.a.a, l.b.a), $);
                break r;
            case 21:
                if (8 === l.b.$) return $ = function(r) {
                    var e = r.b;
                    return i(s(n, {
                        kK: ms(r.a)
                    }), A2(Sv, _f, e));
                }, A3(Bw, n, b = A4(yF, n.hr, t.gp, l.a.a, l.b.a), $);
                break r;
            case 18:
                if (12 === l.b.$) return $ = function(r) {
                    var e = r.b;
                    return i(s(n, {
                        kK: ks(r.a)
                    }), A2(Sv, ys, e));
                }, A3(Bw, n, b = A4(ZT, n.hr, t.gp, l.a.a, l.b.a), $);
                break r;
            case 19:
                if (13 === l.b.$) return $ = function(r) {
                    var e = r.b;
                    return i(s(n, {
                        kK: xs(r.a)
                    }), A2(Sv, Uf, e));
                }, A3(Bw, n, b = A4(nS, n.hr, t.gp, l.a.a, l.b.a), $);
                break r;
            case 22:
                if (14 === l.b.$) return $ = function(r) {
                    var e = r.a, a = r.b, u = function() {
                        var r = f(e.h5, e.d0, e.g7);
                        if (r.a.$ || 1 !== r.a.a.$ || r.a.a.a.$ || !r.b || r.c.$) return Qf(e);
                        var n = r.a.a.a.a, a = s(A4($w, t.gp, e.E, e.by, r.c.a), {
                            h4: e.ju,
                            eJ: n
                        });
                        return Bf(a);
                    }();
                    return i(s(n, {
                        kK: u
                    }), A2(Sv, Kf, a));
                }, A3(Bw, n, b = A4(Ky, n.hr, t.gp, l.a.a, l.b.a), $);
                break r;
            case 23:
                if (16 === l.b.$) return $ = function(r) {
                    var e = r.b;
                    return i(s(n, {
                        kK: Bf(r.a)
                    }), A2(Sv, hs, e));
                }, A3(Bw, n, b = A3(fx, n.hr, l.a.a, l.b.a), $);
                break r;
            case 20:
                if (13 === l.b.$) return $ = function(r) {
                    var e = r.b;
                    return i(s(n, {
                        kK: xs(r.a)
                    }), A2(Sv, As, e));
                }, A3(Bw, n, b = A4(nS, n.hr, t.gp, l.a.a, l.b.a), $);
                break r;
            case 24:
                if (18 === l.b.$) return $ = function(r) {
                    var e = r.b;
                    return i(s(n, {
                        kK: us(r.a)
                    }), A2(Sv, os, e));
                }, A3(Bw, n, b = A4(rj, n.hr, t.gp, l.a.a, l.b.a), $);
                break r;
            case 25:
                if (1 === l.b.$) {
                    var tr = l.a.a, ar = l.b.a;
                    if (1 === tr.$ && 9 === tr.a.$) {
                        var ur = n.ih, cr = s(Lr = ur.hQ, {
                            cQ: !Lr.cQ
                        }), or = s(ur, {
                            hQ: cr
                        });
                        return i(d = s(n, {
                            ih: or
                        }), su);
                    }
                    return $ = function(r) {
                        var e = r.b;
                        return i(s(n, {
                            kK: Jf(r.a)
                        }), A2(Sv, rs, e));
                    }, A3(Bw, n, b = A2(aL, tr, ar), $);
                }
                break r;
            case 5:
                return i(s(n, {
                    kK: as(Tr = l.a.a)
                }), su);
            case 10:
                return i(qh(n), ma(m([
                    Uw(0),
                    A2(vm, n.hr, Mo),
                    jl
                ])));
            case 0:
                var ir = l.a.a;
                return 1 === ir.$ ? i(n, Zf(ir.a)) : A3(jw, ir.a, n, t);
            case 1:
                return A3(jw, l.a.a, n, t);
            case 27:
                return $ = function(r) {
                    var t = r.a, a = r.b, u = A3(KC, !1, function(r) {
                        return !e(r.fj, t.fj);
                    }, n.gW) ? A2(zC, n, t) : su, c = A3(WC, A3(KC, 0, jt, A2(_w, function(r) {
                        return e(t.bG.jW, r.bG.jW);
                    }, n.fI)), t, n.fI);
                    return i(s(n, {
                        gW: Ve(t),
                        fI: c
                    }), ma(m([
                        u,
                        A2(Sv, ts, a)
                    ])));
                }, A3(Bw, n, b = A4(dL, n.hr, t.gp, l.a.a, n.gW), $);
            case 28:
                var fr = A3(LM, Ww, l.a.a, n.g2), sr = fr.b;
                return i(s(n, {
                    g2: fr.a
                }), sr);
            case 29:
                var lr = l.a.a, br = A2(Mi, 0, A2(Nw, lr, n.fI)), dr = br.$ ? zo("") : br.a.bG.jW, vr = (M = Sl(n.fk), A4(rC, t, n.by, M, dr)), mr = (E = vr.a, vr.b);
                return i(d = function() {
                    if (1 === lr.$) return n;
                    var r = lr, e = br.$ ? n.gW : Ve(br.a);
                    return s(n, {
                        gW: e,
                        g8: r,
                        hQ: Ve(E)
                    });
                }(), ma(m([
                    A2(dm, n.hr, A3(Hl, o, n.by, dr)),
                    A2(Sv, ps, mr)
                ])));
            case 30:
                var gr = zo(l.a.a), pr = A2(TC, t.gp, gr), $r = A2(Zw, function(r) {
                    return e(r.bG.jW, gr);
                }, Me(n.fI)), hr = (A = s(n.iJ, {
                    kb: Ve(gr)
                }), M = Sl(n.fk), A4(rC, t, n.by, M, gr));
                return mr = hr.b, i(d = s(n, {
                    gW: $r,
                    hQ: Ve(E = hr.a),
                    iJ: A
                }), ma(m([
                    A2(dm, n.hr, A3(Hl, o, n.by, gr)),
                    A2(Sv, ps, mr),
                    A2(Sv, ts, pr)
                ])));
            case 31:
                return i(n.hR ? s(n, {
                    hR: 0
                }) : qC(n), su);
            case 32:
                return i(s(n, {
                    hf: l.a.a
                }), su);
            case 33:
                return i(s(n, {
                    hf: !n.hf
                }), su);
            case 34:
                return i(s(n, {
                    gy: 0,
                    he: 3
                }), su);
            case 35:
                return i(s(n, {
                    gy: 3
                }), su);
            case 36:
                var wr = l.a.a;
                return i(s(n, {
                    gy: 3
                }), A2(kl, t.gp, wr));
            case 37:
                return i(n, su);
            case 38:
                switch((Tr = l.a.a).$){
                    case 0:
                        return i(qh(n), Uw(0));
                    case 2:
                        return i(s(n, {
                            kK: as(Tr.a)
                        }), su);
                    default:
                        return i(n, su);
                }
            case 39:
                return i(s(n, {
                    he: 0
                }), su);
            case 40:
                return i(s(n, {
                    he: 3
                }), su);
            case 41:
                var Cr = l.a.a, kr = 1 === (a = n.kK).$ ? Jf(s(a.a, {
                    c: Cr
                })) : n.kK;
                return i(s(n, {
                    jt: Cr,
                    kK: kr
                }), su);
            case 42:
                var yr = l.a.a, xr = n.hQ;
                if (xr.$) return i(n, su);
                Cr = n.jt;
                var Lr, jr = A3(kT, yr, Lr = xr.a, n.ih), Ar = (cr = jr.a, jr.b), Mr = Ar.a, Fr = A2(di, n.ih, A2(Ba, function(r) {
                    return A2(vS, r, n.ih);
                }, Ar.b)), Hr = s(Cr, {
                    en: Fr.hQ.cQ
                });
                return i(s(n, {
                    jt: Hr,
                    hQ: Ve(cr),
                    ih: Fr
                }), A2(Sv, ps, Mr));
            case 44:
                return i(n, (u = void 0, c = void 0, u = function(r) {
                    var n = mf(A2(aa, Vt, m([
                        "insights",
                        "generate-link"
                    ])));
                    return A4(Ks, _i(""), r, n, A2(tu, "url", wc));
                }(t.gp), c = A3(Cl, xl, A2($l, yl, Ts), yl(Ss)), A2(wl, c, u)));
            case 45:
                var Tr;
                switch((Tr = l.a.a).$){
                    case 0:
                        return i(qh(n), Uw(0));
                    case 2:
                        return i(s(n, {
                            kK: as(Tr.a)
                        }), su);
                    default:
                        return i(n, su);
                }
            case 46:
                return i(n, IC(l.a.a));
            case 48:
                return i(s(n, {
                    it: 0
                }), su);
            case 49:
                return i(s(n, {
                    it: 3
                }), su);
            case 50:
                return i(s(n, {
                    it: 3
                }), ZC);
            default:
                break r;
        }
        return i(n, su);
    }), gS = F2(function(r, n) {
        var e, t = A2(yo, yi, r);
        return t.$ || 1 !== t.a.$ ? i(n, A2(vm, n.hr, Mo)) : i(s(n, {
            kK: Vi((e = t.a.a, {
                dy: "",
                a8: We,
                bg: "",
                f3: e,
                gj: We
            }))
        }), su);
    }), pS = F2(function(r, n) {
        return JC(i(s(r, {
            a8: Ve(n)
        }), su));
    }), $S = function(r) {
        return {
            $: 3,
            a: r
        };
    }, hS = function(r) {
        return {
            $: 0,
            a: r
        };
    }, wS = {
        $: 1
    }, CS = A2(tu, "message", wc), kS = A2($l, $S, Ha(function(r) {
        var n;
        return 3 === r.$ && (n = r.a.k6) >= 400 && 500 > n ? A2(mu, wS, A2(Ma, hS, A2(Ca, CS, r.b))) : wS;
    })), yS = F2(function(r, n) {
        var e = n, t = Di(m([
            i("password", _i(r)),
            i("uuid", _i(e))
        ]));
        return A2(wl, kS, A4(Ks, t, "not-used", "user/set-password", QM));
    }), xS = F2(function(r, n) {
        switch(r.$){
            case 0:
                return (e = r.a).$ ? JC(i(n, A2(yS, n.bg, n.f3))) : A2(pS, n, {
                    $: 1,
                    a: e.a
                });
            case 1:
                return JC(i(s(n, {
                    a8: We,
                    bg: r.a
                }), su));
            case 2:
                return JC(i(s(n, {
                    dy: r.a,
                    a8: We
                }), su));
            default:
                var e;
                return 1 === (e = r.a).$ ? A2(pS, n, {
                    $: 0,
                    a: e.a
                }) : QC(e.a);
        }
    }), LS = F2(function(r, n) {
        var e = n.hy;
        if (e.$) {
            var t = i(r, n.kK);
            r: for(;;)switch(t.a.$){
                case 12:
                    if (9 === t.b.$) {
                        var a = A2(xS, t.a.a, t.b.a);
                        if (a.$) {
                            var u = a.a, c = u.b;
                            return i(s(n, {
                                kK: Vi(u.a)
                            }), A2(Sv, Ri, c));
                        }
                        return A2(Gf, n, a.a);
                    }
                    break r;
                case 6:
                    if (t.b.$) break r;
                    var o = A2(XM, t.a.a, t.b.a);
                    if (o.$) {
                        var f = o.a, l = f.b;
                        return i(s(n, {
                            kK: Wi(f.a)
                        }), A2(Sv, Pi, l));
                    }
                    return A2(Gf, n, o.a);
                case 2:
                    return A2(gS, t.a.a, n);
                case 26:
                    return i(n, Zf("/"));
                default:
                    break r;
            }
            return i(qh(n), Nf(0));
        }
        return A3(mS, r, n, e.a);
    }), jS = F3(function(r, n, e) {
        var t, a = {
            $: 2,
            a: n
        }, u = (t = A2(pu, Ac, r)).$ ? {
            fk: yc(Mc),
            js: We,
            jt: Lc,
            jL: We,
            jP: We,
            kH: We,
            gn: "/default-aci-learning-thumbnail.jpg",
            gp: We,
            lv: We
        } : t.a, c = A2(Ba, Vt, u.gp), o = A2(LS, a, A8(Ei, e, u.fk, n, A5(zi, va, c, u.js, u.jP, u.lv), vt, "", u.jt, u.gn));
        return i(o.a, ma(m([
            o.b,
            gu(c)
        ])));
    }), AS = Or, MS = en("configUpdate", ru), FS = qr, HS = AS(b), TS = function(r) {
        return {
            $: 4,
            a: r
        };
    }, SS = function(r) {
        return {
            $: 6,
            a: r
        };
    }, ES = function(r) {
        return {
            $: 8,
            a: r
        };
    }, zS = function(r) {
        return {
            $: 7,
            a: r
        };
    }, RS = function(r) {
        return {
            $: 5,
            a: r
        };
    }, VS = F2(function(r, n) {
        return A2(Mx, r, n).aW;
    }), WS = function(r) {
        return r.eN;
    }, PS = function(r) {
        return {
            $: 0,
            a: r
        };
    }, GS = F3(function(r, n, e) {
        return {
            f0: e,
            h7: n,
            is: r
        };
    }), IS = ra(A3(GS, b, We, 0)), NS = jr(function(r) {
        r(xr(Date.now()));
    }), ZS = jr(function(r) {
        var n = qn(function() {
            r(xr(Date.now()));
        });
        return function() {
            On(n);
        };
    });
    Gr["Browser.AnimationManager"] = Ir(IS, F3(function(r, n, e) {
        var t = e.h7, a = e.f0, u = i(t, n);
        return 1 === u.a.$ ? u.b.b ? A2(ua, function(r) {
            return A2(ua, function(e) {
                return ra(A3(GS, n, Ve(r), e));
            }, NS);
        }, yf(A2(ua, af(r), ZS))) : IS : u.b.b ? ra(A3(GS, n, t, a)) : A2(ua, function() {
            return IS;
        }, kf(u.a.a));
    }), F3(function(r, n, e) {
        var t = e.is, a = e.f0, u = function(e) {
            return A2(fa, r, (0, e.a)(e.$ ? n - a : du(n)));
        };
        return A2(ua, function(r) {
            return A2(ua, function() {
                return ra(A3(GS, t, Ve(r), n));
            }, ia(A2(aa, u, t)));
        }, yf(A2(ua, af(r), ZS)));
    }), 0, F2(function(r, n) {
        return n.$ ? {
            $: 1,
            a: A2($l, r, n.a)
        } : PS(A2($l, r, n.a));
    }));
    var DS, _S, OS, qS, KS, US, BS, QS, YS = _r("Browser.AnimationManager"), JS = F2(function(r, n) {
        return A2(lc, WS, n) ? A2(FS, r, YS(PS(Vt))) : HS;
    }), XS = {
        $: 10
    }, rE = function(r) {
        var n = A2(pu, kc, r);
        return n.$ ? XS : {
            $: 9,
            a: n.a
        };
    }, nE = function(r) {
        return AS(m([
            A2(JS, TS, m([
                A2(VS, 0, r.c)
            ])),
            A2(JS, RS, m([
                A2(VS, 1, r.c)
            ])),
            A2(JS, SS, m([
                A2(VS, 2, r.c)
            ])),
            A2(JS, zS, m([
                A2(VS, 3, r.c)
            ])),
            A2(JS, ES, m([
                A2(VS, 4, r.c)
            ])),
            MS(rE)
        ]));
    }, eE = en("receive", ru), tE = eE(function(r) {
        return {
            $: 3,
            a: r
        };
    }), aE = en("onboardToggleUpdate", wu), uE = aE(function(r) {
        return {
            $: 2,
            a: r
        };
    }), cE = function(r) {
        var n = A2(pu, kc, r);
        return n.$ ? pa : {
            $: 41,
            a: n.a
        };
    }, oE = vn, iE = oE, fE = function(r) {
        return {
            $: 2,
            a: r
        };
    }, sE = function(r) {
        return {
            $: 1,
            a: r
        };
    }, lE = bn("a"), bE = F2(function(r, n) {
        for(;;){
            if (!r.b) return b;
            var e = r.b, t = (0, r.a)(n);
            if (t.b) return t;
            r = e;
        }
    }), dE = function(r) {
        return function(n) {
            return A2(bE, r, n);
        };
    }, vE = F2(function(r, n) {
        return function(e) {
            return r(e) ? m([
                n
            ]) : b;
        };
    }), mE = F2(function(r, n) {
        return A2(vE, function(n) {
            return function(r) {
                for(;;){
                    var n = tt(r);
                    if (n.$) return !0;
                    var e = n.a;
                    if (" " !== (t = e.a) && "\n" !== t && "\t" !== t && "\r" !== t) return !1;
                    r = e.b;
                }
                var t;
            }(r(n));
        }, n);
    }), gE = F2(function(r, n) {
        return function(e) {
            return r(e) ? b : m([
                n
            ]);
        };
    }), pE = function(r) {
        return e(r.bg, r.dy);
    }, $E = function(r) {
        return 8 > It(r.bg);
    }, hE = F2(function(r, n) {
        var e = r(n);
        return e.b ? Fe(e) : Ee(n);
    }), wE = bn("br"), CE = bn("button"), kE = F2(function(r, n) {
        return A2(pn, r, _i(n));
    }), yE = kE("className"), xE = xv("disabled"), LE = bn("div"), jE = function(r) {
        var n;
        if (!r.$) return (n = r.a).$ ? "Sorry, something unexpected happened. Please try again in a few moments." : n.a;
        switch(n = r.a){
            case 0:
                return "Password cannot be blank.";
            case 1:
                return "Password must be at least 8 characters.";
            default:
                return "Passwords do not match.";
        }
    }, AE = kE("htmlFor"), ME = bn("form"), FE = function(r) {
        var n;
        return A2(kE, "href", /^javascript:/i.test((n = r).replace(/\s/g, "")) ? "" : n);
    }, HE = bn("i"), TE = bn("input"), SE = bn("label"), EE = kE("id"), zE = function(r) {
        return i(r, !0);
    }, RE = mn, VE = F2(function(r, n) {
        return A2(RE, r, {
            $: 1,
            a: n
        });
    }), WE = A2(Ov, m([
        "target",
        "value"
    ]), wc), PE = function(r) {
        return A2(VE, "input", A2(St, zE, A2(St, r, WE)));
    }, GE = F3(function(r, n, e) {
        return l(r, m([
            EE(n + "-input"),
            PE(e)
        ]));
    }), IE = function(r) {
        return i(r, !0);
    }, NE = F2(function(r, n) {
        return A2(RE, r, {
            $: 2,
            a: n
        });
    }), ZE = function(r) {
        return A2(NE, "submit", A2(St, IE, zt(r)));
    }, DE = F3(function(r, n, e) {
        return l(r, m([
            EE(n + "-submit"),
            ZE(e)
        ]));
    }), _E = kE("placeholder"), OE = ln("http://www.w3.org/2000/svg"), qE = OE("circle"), KE = $n("cx"), UE = $n("cy"), BE = $n("d"), QE = OE("desc"), YE = $n("fill"), JE = $n("height"), XE = OE("path"), rz = $n("r"), nz = $n("stroke"), ez = $n("stroke-linecap"), tz = $n("stroke-width"), az = OE("svg"), uz = Jd, cz = $n("viewBox"), oz = $n("width"), iz = F2(function(r, n) {
        return A2(az, l(m([
            oz("264"),
            JE("56"),
            cz("0 0 264 56"),
            YE("none")
        ]), n), m([
            A2(QE, b, m([
                uz(r)
            ])),
            A2(XE, m([
                BE("M76 45.8354L76 7.47514"),
                nz("#F0F0EA"),
                tz("3.94"),
                ez("square")
            ]), b),
            A2(XE, m([
                BE("M76 45.8354L80.3962 45.8355"),
                nz("#F0F0EA"),
                tz("3.94"),
                ez("square")
            ]), b),
            A2(XE, m([
                BE("M76 7.47534L80.3962 7.47534"),
                nz("#F0F0EA"),
                tz("3.94"),
                ez("square")
            ]), b),
            A2(XE, m([
                BE("M93.4969 34.6553V19.0888H100.213C101.191 19.0888 102.058 19.3111 102.815 19.7559C103.585 20.2007 104.193 20.8085 104.638 21.5794C105.098 22.3503 105.327 23.2176 105.327 24.1812C105.327 25.1894 105.098 26.0937 104.638 26.8943C104.193 27.68 103.585 28.3027 102.815 28.7622C102.058 29.2218 101.191 29.4516 100.213 29.4516H97.2773V34.6553H93.4969ZM97.2106 26.1382H99.679C100.005 26.1382 100.302 26.0566 100.569 25.8936C100.835 25.7305 101.05 25.5081 101.213 25.2264C101.377 24.9447 101.458 24.6186 101.458 24.248C101.458 23.8625 101.377 23.5363 101.213 23.2695C101.05 23.0026 100.835 22.7951 100.569 22.6468C100.302 22.4986 100.005 22.4244 99.679 22.4244H97.2106V26.1382ZM109.555 34.6553V19.0888H116.56C117.553 19.0888 118.45 19.3037 119.251 19.7337C120.066 20.1636 120.704 20.7566 121.163 21.5127C121.623 22.254 121.853 23.099 121.853 24.0478C121.853 25.0263 121.623 25.9084 121.163 26.6941C120.704 27.465 120.074 28.0729 119.273 28.5176C118.472 28.9624 117.568 29.1848 116.56 29.1848H113.158V34.6553H109.555ZM118.183 34.6553L114.225 27.6281L118.094 27.0722L122.497 34.6553H118.183ZM113.158 26.2938H116.226C116.612 26.2938 116.945 26.2123 117.227 26.0492C117.524 25.8713 117.746 25.6267 117.894 25.3154C118.057 25.004 118.139 24.6482 118.139 24.248C118.139 23.8477 118.05 23.4993 117.872 23.2028C117.694 22.8914 117.435 22.6542 117.094 22.4912C116.768 22.3281 116.367 22.2465 115.893 22.2465H113.158V26.2938ZM133.38 34.8777C132.194 34.8777 131.112 34.6775 130.134 34.2772C129.155 33.8769 128.303 33.3136 127.576 32.5872C126.85 31.8607 126.286 31.0083 125.886 30.0298C125.486 29.0513 125.286 27.9765 125.286 26.8053C125.286 25.6341 125.486 24.5593 125.886 23.5808C126.286 22.6024 126.85 21.7499 127.576 21.0235C128.303 20.297 129.155 19.7337 130.134 19.3334C131.112 18.9331 132.187 18.733 133.358 18.733C134.529 18.733 135.604 18.9331 136.583 19.3334C137.561 19.7337 138.413 20.297 139.14 21.0235C139.866 21.7499 140.422 22.6024 140.808 23.5808C141.208 24.5593 141.408 25.6341 141.408 26.8053C141.408 27.9617 141.208 29.0365 140.808 30.0298C140.422 31.0083 139.866 31.8607 139.14 32.5872C138.413 33.3136 137.561 33.8769 136.583 34.2772C135.604 34.6775 134.537 34.8777 133.38 34.8777ZM133.358 31.3196C133.966 31.3196 134.522 31.2084 135.026 30.986C135.545 30.7636 135.99 30.4523 136.36 30.052C136.746 29.6369 137.042 29.1551 137.25 28.6066C137.457 28.058 137.561 27.4576 137.561 26.8053C137.561 26.153 137.457 25.5526 137.25 25.004C137.042 24.4555 136.746 23.9811 136.36 23.5808C135.99 23.1657 135.545 22.847 135.026 22.6246C134.522 22.4022 133.966 22.291 133.358 22.291C132.75 22.291 132.187 22.4022 131.668 22.6246C131.164 22.847 130.719 23.1657 130.334 23.5808C129.948 23.9811 129.652 24.4555 129.444 25.004C129.251 25.5526 129.155 26.153 129.155 26.8053C129.155 27.4576 129.251 28.0655 129.444 28.6288C129.652 29.1773 129.948 29.6518 130.334 30.052C130.719 30.4523 131.164 30.7636 131.668 30.986C132.187 31.2084 132.75 31.3196 133.358 31.3196ZM146.001 34.6553V19.0888H152.161C152.976 19.0888 153.71 19.2889 154.362 19.6892C155.015 20.0895 155.533 20.6454 155.919 21.357C156.304 22.0538 156.497 22.8396 156.497 23.7142C156.497 24.6334 156.304 25.4562 155.919 26.1826C155.533 26.8943 155.015 27.465 154.362 27.895C153.71 28.3101 152.976 28.5176 152.161 28.5176H147.735V34.6553H146.001ZM147.735 26.8275H152.25C152.709 26.8275 153.117 26.6941 153.473 26.4273C153.843 26.1456 154.14 25.775 154.362 25.3154C154.585 24.841 154.696 24.2998 154.696 23.692C154.696 23.1435 154.585 22.6542 154.362 22.2243C154.14 21.7796 153.843 21.4312 153.473 21.1791C153.117 20.9123 152.709 20.7788 152.25 20.7788H147.735V26.8275ZM167.595 34.8777C166.498 34.8777 165.483 34.6849 164.549 34.2995C163.63 33.8992 162.822 33.3432 162.125 32.6316C161.443 31.92 160.909 31.0824 160.524 30.1187C160.153 29.1403 159.968 28.0729 159.968 26.9165C159.968 25.7601 160.153 24.7001 160.524 23.7365C160.909 22.758 161.443 21.913 162.125 21.2014C162.822 20.4749 163.63 19.919 164.549 19.5335C165.483 19.1332 166.498 18.9331 167.595 18.9331C168.707 18.9331 169.723 19.1332 170.642 19.5335C171.576 19.919 172.384 20.4749 173.066 21.2014C173.763 21.913 174.296 22.758 174.667 23.7365C175.052 24.7001 175.245 25.7601 175.245 26.9165C175.245 28.058 175.052 29.118 174.667 30.0965C174.296 31.0602 173.763 31.9052 173.066 32.6316C172.384 33.3432 171.576 33.8992 170.642 34.2995C169.723 34.6849 168.707 34.8777 167.595 34.8777ZM167.595 33.1653C168.44 33.1653 169.219 33.0171 169.93 32.7206C170.657 32.4092 171.279 31.9719 171.798 31.4085C172.317 30.8452 172.717 30.1855 172.999 29.4294C173.296 28.6585 173.444 27.8208 173.444 26.9165C173.444 25.9973 173.296 25.1597 172.999 24.4036C172.717 23.6327 172.317 22.9656 171.798 22.4022C171.279 21.8389 170.657 21.4015 169.93 21.0902C169.219 20.7788 168.44 20.6232 167.595 20.6232C166.75 20.6232 165.965 20.7788 165.238 21.0902C164.527 21.4015 163.911 21.8389 163.392 22.4022C162.874 22.9656 162.473 23.6327 162.192 24.4036C161.91 25.1597 161.769 25.9973 161.769 26.9165C161.769 27.8208 161.91 28.6585 162.192 29.4294C162.473 30.1855 162.874 30.8452 163.392 31.4085C163.911 31.9719 164.527 32.4092 165.238 32.7206C165.965 33.0171 166.75 33.1653 167.595 33.1653ZM179.963 34.6553V19.0888H186.056C186.961 19.0888 187.776 19.3037 188.502 19.7337C189.244 20.1488 189.829 20.7195 190.259 21.446C190.689 22.1724 190.904 22.9952 190.904 23.9144C190.904 24.7742 190.697 25.5526 190.281 26.2494C189.866 26.9461 189.303 27.5021 188.591 27.9172C187.88 28.3175 187.079 28.5176 186.19 28.5176H181.698V34.6553H179.963ZM189.459 34.6553L185.545 27.806L187.213 27.2278L191.527 34.6553H189.459ZM181.698 26.8275H186.345C186.894 26.8275 187.376 26.7015 187.791 26.4495C188.206 26.1975 188.532 25.8565 188.769 25.4266C189.006 24.9818 189.125 24.4777 189.125 23.9144C189.125 23.3066 188.984 22.7654 188.703 22.291C188.421 21.8166 188.028 21.446 187.524 21.1791C187.035 20.9123 186.471 20.7788 185.834 20.7788H181.698V26.8275ZM198.368 34.6553V20.7788H193.92V19.0888H204.728V20.7788H200.102V34.6553H198.368ZM206.154 34.6553L212.113 19.0888H214.092L220.008 34.6553H218.118L214.315 24.5593C214.211 24.2776 214.092 23.9514 213.959 23.5808C213.84 23.1954 213.707 22.8025 213.559 22.4022C213.425 21.9871 213.292 21.5868 213.158 21.2014C213.04 20.8159 212.929 20.4749 212.825 20.1784H213.27C213.151 20.5491 213.025 20.9271 212.892 21.3126C212.773 21.6832 212.647 22.0612 212.514 22.4467C212.38 22.8173 212.247 23.1879 212.113 23.5586C211.98 23.9292 211.846 24.2998 211.713 24.6705L207.933 34.6553H206.154ZM208.689 30.3634L209.334 28.6733H216.694L217.406 30.3634H208.689ZM224.185 34.6553V19.0888H225.92V32.9652H233.392V34.6553H224.185Z"),
                YE("#F8F8F6")
            ]), b),
            A2(XE, m([
                BE("M250.03 7.4751L250.03 45.8354"),
                nz("#F0F0EA"),
                tz("3.94"),
                ez("square")
            ]), b),
            A2(XE, m([
                BE("M250.03 7.4751L245.634 7.4751"),
                nz("#F0F0EA"),
                tz("3.94"),
                ez("square")
            ]), b),
            A2(XE, m([
                BE("M250.03 45.835L245.634 45.835"),
                nz("#F0F0EA"),
                tz("3.94"),
                ez("square")
            ]), b),
            A2(XE, m([
                BE("M57.3957 37.3678V15.3859H54.3667H51.3376V37.3678H57.3957Z"),
                YE("#F8F8F6")
            ]), b),
            A2(XE, m([
                BE("M27.791 37.1156H21.9577V35.8212C19.5247 37.4222 17.8947 37.5623 15.3663 37.4222C12.6456 37.4222 8 35.2307 8 30.6695C8 24.6529 14.4189 20.8922 21.7214 24.2965V22.6846C21.7821 19.4252 18.13 19.6536 17.1485 19.7816C14.4158 20.138 12.9345 21.1767 10.8612 22.283L8.71287 18.5935C11.5643 16.0985 14.3574 15.0238 18.1383 15.0238C24.0396 15.0238 27.791 18.5935 27.791 21.9386V37.1156ZM21.7191 29.1034C17.718 26.2473 13.4653 27.1908 13.4653 30.3559C13.4653 32.2479 15.3663 33.0885 16.7898 33.0885C18.693 33.0885 20.6432 31.9025 21.7191 30.5934V29.1034Z"),
                YE("#F8F8F6")
            ]), b),
            A2(XE, m([
                BE("M40.2481 37.6994C38.1694 37.6994 36.3066 37.2085 34.6598 36.2266C33.0131 35.2448 31.7037 33.9084 30.7319 32.2175C29.787 30.4993 29.3146 28.5629 29.3146 26.4083C29.3146 24.2538 29.787 22.331 30.7319 20.6401C31.7037 18.9219 33.0131 17.5719 34.6598 16.5901C36.3066 15.6082 38.1694 15.1173 40.2481 15.1173C42.1648 15.1173 43.9196 15.4582 45.5124 16.14C47.1321 16.8219 48.4145 17.7764 49.3593 19.0037L45.8363 23.2583C45.4584 22.8219 45.0129 22.4128 44.5 22.031C43.9871 21.6492 43.4201 21.3492 42.7992 21.131C42.1783 20.9128 41.5304 20.8037 40.8555 20.8037C39.8296 20.8037 38.9253 21.0492 38.1424 21.5401C37.3595 22.0038 36.7521 22.6583 36.3201 23.5038C35.8882 24.3492 35.6722 25.3174 35.6722 26.4083C35.6722 27.4447 35.8882 28.3856 36.3201 29.2311C36.7791 30.0766 37.4 30.7448 38.1829 31.2357C38.9658 31.7266 39.8566 31.972 40.8555 31.972C41.5574 31.972 42.2053 31.8902 42.7992 31.7266C43.3931 31.5357 43.9331 31.2629 44.419 30.9084C44.9319 30.5538 45.4044 30.1175 45.8363 29.5993L49.3188 33.8948C48.401 35.0675 47.1186 35.9948 45.4719 36.6766C43.8521 37.3585 42.1108 37.6994 40.2481 37.6994Z"),
                YE("#F8F8F6")
            ]), b),
            A2(qE, m([
                KE("54.3347"),
                UE("9.32672"),
                rz("3.32672"),
                YE("#F4B43A")
            ]), b),
            A2(XE, m([
                BE("M9.09729 47.4612V42.6374H9.84153V46.7445H12.1018V47.4612H9.09729Z"),
                YE("#F8F8F6")
            ]), b),
            A2(XE, m([
                BE("M14.8764 47.4612V42.6374H17.9153V43.3541H15.6206V46.7445H17.9153V47.4612H14.8764ZM15.214 45.3456V44.6289H17.5363V45.3456H15.214Z"),
                YE("#F8F8F6")
            ]), b),
            A2(XE, m([
                BE("M20.2601 47.4612L22.1275 42.6374H22.8856L24.7393 47.4612H23.9468L22.8442 44.5531C22.8304 44.521 22.8029 44.4429 22.7615 44.3188C22.7248 44.1948 22.6811 44.057 22.6306 43.9054C22.5801 43.7538 22.5341 43.6159 22.4928 43.4919C22.4514 43.3633 22.4239 43.2806 22.4101 43.2438L22.5686 43.2369C22.541 43.315 22.5065 43.4138 22.4652 43.5333C22.4285 43.6527 22.3871 43.779 22.3412 43.9123C22.2998 44.0455 22.2585 44.1718 22.2171 44.2913C22.1758 44.4061 22.1413 44.5026 22.1138 44.5807L21.0181 47.4612H20.2601ZM21.087 46.2621L21.3626 45.5454H23.554L23.871 46.2621H21.087Z"),
                YE("#F8F8F6")
            ]), b),
            A2(XE, m([
                BE("M27.2421 47.4612V42.6374H29.2956C29.5712 42.6374 29.8239 42.7063 30.0536 42.8441C30.2879 42.9774 30.474 43.1611 30.6118 43.3954C30.7496 43.6251 30.8185 43.8847 30.8185 44.1741C30.8185 44.436 30.7496 44.6795 30.6118 44.9046C30.474 45.1297 30.2902 45.3111 30.0605 45.449C29.8308 45.5822 29.5758 45.6488 29.2956 45.6488H27.9863V47.4612H27.2421ZM30.1087 47.4612L28.8821 45.2836L29.647 45.1113L31.0115 47.4681L30.1087 47.4612ZM27.9863 44.9321H29.3645C29.4977 44.9321 29.6172 44.9 29.7228 44.8357C29.8285 44.7668 29.9112 44.6749 29.9709 44.56C30.0306 44.4406 30.0605 44.3096 30.0605 44.1672C30.0605 44.0064 30.0215 43.8663 29.9434 43.7469C29.8699 43.6228 29.7642 43.5264 29.6264 43.4575C29.4931 43.3885 29.3415 43.3541 29.1716 43.3541H27.9863V44.9321Z"),
                YE("#F8F8F6")
            ]), b),
            A2(XE, m([
                BE("M33.6874 47.4612V42.6374H34.3558L37.3052 46.586L37.1949 46.648C37.1765 46.5332 37.1605 46.4091 37.1467 46.2759C37.1329 46.1381 37.1191 45.9934 37.1053 45.8418C37.0961 45.6856 37.087 45.5225 37.0778 45.3525C37.0732 45.1779 37.0686 44.9965 37.064 44.8081C37.0594 44.6197 37.0571 44.4245 37.0571 44.2224V42.6374H37.8013V47.4612H37.1191L34.218 43.6573L34.2938 43.5608C34.3167 43.8411 34.3351 44.0799 34.3489 44.2775C34.3673 44.4704 34.3811 44.6358 34.3902 44.7736C34.404 44.9069 34.4132 45.0171 34.4178 45.1044C34.4224 45.1871 34.4247 45.256 34.4247 45.3111C34.4293 45.3663 34.4316 45.4145 34.4316 45.4559V47.4612H33.6874Z"),
                YE("#F8F8F6")
            ]), b),
            A2(XE, m([
                BE("M40.6264 47.4612V46.7721H41.4051V43.3265H40.6264V42.6374H42.9281V43.3265H42.1494V46.7721H42.9281V47.4612H40.6264Z"),
                YE("#F8F8F6")
            ]), b),
            A2(XE, m([
                BE("M45.7502 47.4612V42.6374H46.4187L49.368 46.586L49.2578 46.648C49.2394 46.5332 49.2233 46.4091 49.2095 46.2759C49.1958 46.1381 49.182 45.9934 49.1682 45.8418C49.159 45.6856 49.1498 45.5225 49.1406 45.3525C49.136 45.1779 49.1314 44.9965 49.1268 44.8081C49.1222 44.6197 49.12 44.4245 49.12 44.2224V42.6374H49.8642V47.4612H49.182L46.2808 43.6573L46.3566 43.5608C46.3796 43.8411 46.398 44.0799 46.4118 44.2775C46.4301 44.4704 46.4439 44.6358 46.4531 44.7736C46.4669 44.9069 46.4761 45.0171 46.4807 45.1044C46.4853 45.1871 46.4876 45.256 46.4876 45.3111C46.4922 45.3663 46.4945 45.4145 46.4945 45.4559V47.4612H45.7502Z"),
                YE("#F8F8F6")
            ]), b),
            A2(XE, m([
                BE("M55.0254 47.5301C54.6762 47.5301 54.3501 47.4681 54.0469 47.344C53.7436 47.2154 53.4772 47.0385 53.2475 46.8134C53.0178 46.5883 52.8386 46.3264 52.71 46.0278C52.5859 45.7246 52.5239 45.3984 52.5239 45.0493C52.5239 44.7047 52.5859 44.3832 52.71 44.0845C52.8386 43.7859 53.0155 43.5264 53.2406 43.3058C53.4703 43.0807 53.7368 42.9062 54.04 42.7821C54.3432 42.6581 54.6693 42.5961 55.0185 42.5961C55.262 42.5961 55.4986 42.6305 55.7283 42.6994C55.9626 42.7683 56.1739 42.8648 56.3622 42.9889C56.5506 43.1129 56.7045 43.2553 56.824 43.4161L56.3416 43.9192C56.2038 43.7859 56.0613 43.6757 55.9143 43.5884C55.7719 43.5011 55.6249 43.4345 55.4733 43.3885C55.3217 43.3426 55.1701 43.3196 55.0185 43.3196C54.7704 43.3196 54.5407 43.3633 54.3294 43.4506C54.1227 43.5378 53.9389 43.6596 53.7781 43.8158C53.6219 43.972 53.5002 44.1557 53.4129 44.3671C53.3256 44.5738 53.2819 44.8012 53.2819 45.0493C53.2819 45.2882 53.3279 45.5156 53.4198 45.7315C53.5116 45.9428 53.638 46.1289 53.7988 46.2897C53.9642 46.4505 54.1525 46.5768 54.3638 46.6687C54.5798 46.7606 54.8072 46.8065 55.0461 46.8065C55.2252 46.8065 55.3952 46.7812 55.556 46.7307C55.7168 46.6756 55.8592 46.5998 55.9832 46.5033C56.1073 46.4068 56.2038 46.2966 56.2727 46.1725C56.3416 46.0439 56.376 45.9084 56.376 45.766V45.6281L56.4794 45.7246H55.0047V44.9873H57.1409C57.1501 45.0378 57.157 45.0883 57.1616 45.1389C57.1662 45.1848 57.1685 45.2308 57.1685 45.2767C57.1731 45.318 57.1754 45.3594 57.1754 45.4007C57.1754 45.7177 57.1203 46.0071 57.01 46.269C56.8998 46.5263 56.7459 46.7491 56.5483 46.9374C56.3554 47.1258 56.128 47.2728 55.8661 47.3785C55.6088 47.4795 55.3286 47.5301 55.0254 47.5301Z"),
                YE("#F8F8F6")
            ]), b)
        ]));
    }), fz = bn("span"), sz = kE("type"), lz = function(r) {
        return A2($n, "width", Ie(r));
    }, bz = bn("h2"), dz = F2(function(r, n) {
        return {
            $: 0,
            a: r,
            b: n
        };
    }), vz = function(r) {
        return Xd(r);
    }, mz = F2(function(r, n) {
        return A2(RE, r, {
            $: 0,
            a: n
        });
    }), gz = function(r) {
        return A2(mz, "click", zt(r));
    }, pz = F3(function(r, n, e) {
        return l(r, m([
            yE("cursor-pointer"),
            EE(n + "-click"),
            gz(e)
        ]));
    }), $z = bn("td"), hz = bn("tr"), wz = function(r) {
        return A2(iE, dz(r), function(r) {
            var n, e = r;
            return A2(hz, b, m([
                A2($z, b, m([
                    vz(e.kv)
                ])),
                A2($z, b, m([
                    (n = e.g7, A2(CE, A3(pz, m([
                        yE("btn btn-primary float-right")
                    ]), "company-select-" + n, 0), m([
                        Xd("View Enterprise Grants")
                    ])))
                ]))
            ]));
        }(r));
    }, Cz = bn("table"), kz = bn("tbody"), yz = bn("th"), xz = bn("thead"), Lz = F2(function(r, n) {
        return A2(Cz, m([
            yE("table")
        ]), m([
            A2(xz, b, m([
                A2(hz, b, m([
                    A2(yz, b, m([
                        Xd(r)
                    ])),
                    A2(yz, b, b)
                ]))
            ])),
            A2(kz, b, Me(A2(Si, wz, n)))
        ]));
    }), jz = {
        $: 6
    }, Az = function(r) {
        return {
            $: 5,
            a: r
        };
    }, Mz = function(r) {
        return r.b1 ? function(r) {
            return A2(LE, b, m([
                A2(ME, A3(DE, m([
                    yE("form-row")
                ]), "search", jz), m([
                    A2(LE, m([
                        yE("form-group col-12 col-lg-4")
                    ]), m([
                        A2(TE, A3(GE, m([
                            yE("form-control"),
                            _E("Company Name")
                        ]), "search-company", Az), b)
                    ])),
                    A2(LE, m([
                        yE("form-group col-12 col-lg-2")
                    ]), m([
                        A2(CE, m([
                            yE("form-control btn btn-block btn-primary"),
                            sz("submit")
                        ]), m([
                            Xd("Search")
                        ]))
                    ]))
                ])),
                function() {
                    var n = r.cV;
                    if (1 === n.$) return A2(LE, b, b);
                    if (n.a.$) {
                        var e = n.a.a, t = e.b;
                        return A2(LE, b, m([
                            A2(Lz, "Results", e.a),
                            A2(Lz, "More Results", t)
                        ]));
                    }
                    return Xd("Failed to search. Please try again.");
                }()
            ]));
        }(r) : function(r) {
            var n = r.aY;
            return 1 === n.$ ? Xd("Loading ...") : n.a.$ ? A2(Lz, "Company Name", n.a.a) : Xd("Failed to load. Please try again.");
        }(r);
    }, Fz = function(r) {
        return yE(A2(Ne, " ", A2(aa, jt, A2(fc, nu, r))));
    }, Hz = bn("li"), Tz = F3(function(r, n, t) {
        var a;
        return A2(Hz, m([
            yE("nav-item")
        ]), m([
            A2(CE, A3(pz, m([
                Fz(m([
                    i("nav-link btn btn-link", !0),
                    i("active", e(r, n))
                ]))
            ]), "tab-" + mi(t), (a = n, {
                $: 1,
                a: a
            })), m([
                Xd(t)
            ]))
        ]));
    }), Sz = bn("ul"), Ez = {
        $: 0
    }, zz = {
        $: 12
    }, Rz = function(r) {
        return {
            $: 20,
            a: r
        };
    }, Vz = $n("fill-rule"), Wz = OE("g"), Pz = $n("id"), Gz = $n("version"), Iz = A2(az, m([
        oz("28px"),
        JE("26px"),
        cz("0 0 28 26"),
        Gz("1.1")
    ]), m([
        A2(Wz, m([
            Pz("alert-icon"),
            YE("#CC0000")
        ]), m([
            A2(XE, m([
                BE("M12.8758123,3.00379946 L9.5769932,8.91644748 C9.12269327,9.73050013 8.67252216,10.5372476 7.59456087,12.4691087 C6.5165932,14.4009811 6.06639551,15.2077762 5.61205808,16.0218961 L2.31245114,21.9341795 C1.60424994,23.2043484 2.01963496,23.9487778 3.43631643,23.9487778 L24.563429,23.9487778 C25.9806777,23.9487778 26.3957074,23.2047285 25.6874332,21.9344285 L22.3888654,16.0222307 C21.3723453,14.2023993 19.6162175,11.0551667 18.4237518,8.91646234 L15.1239331,3.00379946 C14.4151163,1.73368216 13.5846291,1.73368216 12.8758123,3.00379946 Z M11.1589501,1.97818572 C12.6308992,-0.659375982 15.3688462,-0.659375982 16.8407308,1.97807017 L20.1407446,7.89108282 C21.3331705,10.0297156 23.089045,13.1764941 24.1055325,14.9962675 L27.4044905,20.9091646 C28.8751859,23.5468776 27.5068373,26 24.563429,26 L3.43631643,26 C0.49363979,26 -0.875310653,23.5466448 0.595458299,20.9088 L3.89526035,14.9961668 C4.34956028,14.1821141 4.79973139,13.3753666 5.87769269,11.4435056 C6.95566035,9.51163319 7.40585804,8.70483804 7.86013099,7.89083374 L11.1589501,1.97818572 Z"),
                Pz("Stroke-1"),
                Vz("nonzero")
            ]), b),
            A2(XE, m([
                BE("M15.4166667,18 L16,6 L12,6 L12.5833333,18 L15.4166667,18 Z M14,23 C15.220339,23 16,22.1290323 16,21 C16,19.8387097 15.220339,19 14,19 C12.8474576,19 12,19.8387097 12,21 C12,22.1290323 12.8135593,23 14,23 Z"),
                Pz("!")
            ]), b)
        ]))
    ])), Nz = $n("fill-opacity"), Zz = $n("font-family"), Dz = $n("font-size"), _z = $n("font-weight"), Oz = K, qz = OE("rect"), Kz = M, Uz = F2(function(r, n) {
        var e = A2(Kz, 10, r);
        return function(r) {
            return r / e;
        }(ou(n * e));
    }), Bz = OE("text"), Qz = $n("transform"), Yz = OE("tspan"), Jz = $n("x"), Xz = $n("y"), rR = F5(function(r, n, e, t, a) {
        var u = Oz(7), c = Oz(12), o = Oz(A2(Uz, 2, n)), i = A2(Bz, m([
            Pz("Hours_viewed:_48"),
            Qz("translate(10 21)"),
            YE("#262937"),
            Dz("11"),
            Zz("Lexend, Roboto, sans-serif"),
            _z("600")
        ]), m([
            A2(Yz, m([
                Jz("0"),
                Xz("0")
            ]), m([
                uz(a + ": " + o)
            ]))
        ])), f = Oz(108), s = Oz(36), l = Oz(48), d = xa(m([
            "M0,0v",
            l
        ])), v = "#FFFFFF", g = Oz(r - 50), p = function() {
            if (e || t) {
                var r = Oz(101);
                return {
                    fP: xa(m([
                        "translate(-",
                        f,
                        " ",
                        g,
                        ")"
                    ])),
                    fV: xa(m([
                        "translate(",
                        f,
                        " 0)"
                    ])),
                    f6: xa(m([
                        "M",
                        u,
                        ",",
                        c,
                        "V0H0Z"
                    ])),
                    f7: xa(m([
                        "translate(",
                        r,
                        " ",
                        s,
                        ")"
                    ]))
                };
            }
            return {
                fP: "translate(0 " + g + ")",
                fV: "translate(0 0)",
                f6: xa(m([
                    "M",
                    u,
                    ",0V",
                    c,
                    "H0Z"
                ])),
                f7: xa(m([
                    "translate(",
                    u,
                    " ",
                    l,
                    ") rotate(180)"
                ]))
            };
        }(), $ = p.fP, h = p.fV, w = p.f7, C = p.f6;
        return A2(Wz, m([
            Pz("flagGroup"),
            Qz($)
        ]), m([
            A2(qz, m([
                Pz("flagBg"),
                oz(f),
                JE(s),
                YE(v),
                Nz(".8")
            ]), b),
            A2(XE, m([
                Pz("flagPntr"),
                BE(C),
                Qz(w),
                YE(v),
                Nz(".8")
            ]), b),
            A2(XE, m([
                Pz("flagHlt"),
                BE(d),
                Qz(h),
                YE("none"),
                nz("#00a3e0"),
                tz("3")
            ]), b),
            i
        ]));
    }), nR = function(r) {
        return A2(mz, "mouseenter", zt(r));
    }, eR = $n("opacity"), tR = F9(function(r, n, t, a, u, c, o, i, f) {
        var s = a, l = c, d = Oz(s.a), v = t.$ ? b : e(t.a, n) ? m([
            A5(rR, s.b, u, o, i, f)
        ]) : b;
        return A2(Wz, m([
            Qz("translate(" + d + ")"),
            Pz("hoverSector" + Ie(n))
        ]), A2(ye, A2(qz, m([
            nR(r(n)),
            oz(Oz(l.a)),
            JE(Oz(l.b)),
            YE("#fff"),
            eR("0")
        ]), b), v));
    }), aR = $n("class"), uR = function(r) {
        switch(r){
            case 0:
                return "Jan";
            case 1:
                return "Feb";
            case 2:
                return "Mar";
            case 3:
                return "Apr";
            case 4:
                return "May";
            case 5:
                return "Jun";
            case 6:
                return "Jul";
            case 7:
                return "Aug";
            case 8:
                return "Sep";
            case 9:
                return "Oct";
            case 10:
                return "Nov";
            default:
                return "Dec";
        }
    }, cR = F3(function(r, n, e) {
        var t = Oz(e + 10), a = F2(function(r, n) {
            return A2(Bz, m([
                Jz(Oz(n)),
                Xz(t),
                YE("#fff"),
                aR("chartAxisTextX")
            ]), m([
                uz(r)
            ]));
        }), u = A2(aa, function(r) {
            return r.gY;
        }, n.iX.a);
        return A2(aa, function(r) {
            var n, e = r.a, t = r.b, u = t.a, c = (n = qt(t.b)).$ ? "00" : Ie(n.a);
            return A2(a, u + " " + c, e);
        }, A2(oT, function(r) {
            return r.b.a;
        }, A3(qe, F2(function(r, n) {
            return i(r, i(uR(Mb(n)), Ie(Ab(n))));
        }), r, u)));
    }), oR = "#00A5E1", iR = OE("line"), fR = $n("x1"), sR = $n("x2"), lR = $n("y1"), bR = $n("y2"), dR = function(r) {
        var n = Oz(r);
        return A2(iR, m([
            fR("0"),
            lR(n),
            sR("-5"),
            bR(n),
            nz(oR),
            tz("1")
        ]), b);
    }, vR = F2(function(r, n) {
        var e = Oz(r);
        return A2(Bz, m([
            Jz("-8"),
            Xz(e),
            YE("#fff"),
            aR("chartAxisTextY")
        ]), m([
            uz(n)
        ]));
    }), mR = $n("gradientUnits"), gR = OE("linearGradient"), pR = $n("offset"), $R = OE("stop"), hR = $n("stop-color"), wR = $n("stop-opacity"), CR = function(r) {
        return A2(gR, m([
            Pz(r),
            fR("0.5"),
            sR("0.5"),
            bR("1"),
            mR("objectBoundingBox")
        ]), m([
            A2($R, m([
                pR("0"),
                hR(oR)
            ]), b),
            A2($R, m([
                pR("0.995"),
                hR(oR),
                wR("0.031")
            ]), b),
            A2($R, m([
                pR("1"),
                hR(oR),
                wR("0")
            ]), b)
        ]));
    }, kR = F4(function(r, n, e, t) {
        return m([
            A2(Bz, m([
                Jz(Oz(e - 2 * r)),
                Xz(Ie(-(n / 2 | 0))),
                YE("#fff")
            ]), m([
                uz(t)
            ])),
            A2(qE, m([
                KE(Oz(e)),
                UE(Ie(-(n / 2 | 0))),
                rz(Oz(r)),
                YE(oR)
            ]), b)
        ]);
    }), yR = F2(function(r, n) {
        return pF(r) ? b : A2(aa, function(r) {
            var e = r.b;
            return A2(qE, m([
                KE(Oz(r.a)),
                UE(Oz(e)),
                rz(Oz(n)),
                YE(oR)
            ]), b);
        }, r);
    }), xR = OE("defs"), LR = function(r) {
        return A2(aa, function(r) {
            return r.a;
        }, r);
    }, jR = function(r) {
        var n = r, e = Oz(n.b);
        return Oz(n.a) + "," + e;
    }, AR = F4(function(r, n, e, t) {
        var a = n, u = e, c = t ? i(m([
            "0," + Oz(a)
        ]), m([
            Oz(u) + ", " + Oz(a)
        ])) : i(b, b), o = c.b;
        return A2(Ne, " ", ui(m([
            c.a,
            A2(aa, jR, r),
            o
        ])));
    }), MR = $n("points"), FR = OE("polyline"), HR = $n("stroke-linejoin"), TR = F5(function(r, n, e, t, a) {
        var u = t ? "1" : "3", c = pF(r) ? "0,0" : A4(AR, r, n, e, t);
        return A2(FR, m([
            MR(c),
            nz(oR),
            tz(u),
            ez("round"),
            HR("round"),
            YE(a)
        ]), b);
    }), SR = function(r) {
        return r.b ? Ve(A3(_e, kt, r.a, r.b)) : We;
    }, ER = F2(function(r, n) {
        var e = Oz(n + 5), t = Oz(n), a = Oz(r);
        return A2(iR, m([
            fR(a),
            lR(t),
            sR(a),
            bR(e),
            nz(oR),
            tz("1")
        ]), b);
    }), zR = F2(function(r, n) {
        return A2(aa, function(r) {
            return A2(ER, r, n);
        }, r);
    }), RR = F6(function(r, n, t, a, u, o) {
        var f, s = a, l = u, d = function() {
            var r = n.iX;
            switch(r.$){
                case 0:
                    return A2(aa, function(r) {
                        return r.kJ;
                    }, r.a);
                case 1:
                    var e = r.a;
                    return A2(aa, A2(wa, function(r) {
                        return r.gS;
                    }, bt), e);
                case 2:
                    return A2(aa, function(r) {
                        return r.jT;
                    }, r.a);
                default:
                    return A2(aa, function(r) {
                        return r.at;
                    }, r.a);
            }
        }(), v = Oe(d), g = v ? l / (v - 1) : l, p = (f = SR(d)).$ ? 0 : f.a, $ = p ? s / p : 0, h = 10 + 12 * It(Ie(wt(p))), w = A2(Ne, " ", m([
            Ie(-h),
            Ie(-50),
            Oz(l + 2 * h + 3),
            Oz(s + 40 + 50)
        ])), C = A2(Be, F2(function(r, n) {
            return i(r * g, s - n * $);
        }), d), k = LR(C), y = A3(qe, F2(function(r, n) {
            return i(r, n);
        }), C, d);
        return A2(az, m([
            oz("100%"),
            cz(w)
        ]), m([
            A2(xR, b, m([
                CR("blueToClear")
            ])),
            A2(Wz, m([
                aR("chartlegend")
            ]), A4(kR, 3, 50, l, o)),
            A5(TR, C, s, l, 1, "url(#blueToClear)"),
            A2(Wz, b, m([
                dR(0),
                A2(vR, 0, Oz(p)),
                dR(s),
                A2(vR, s, "0")
            ])),
            A2(Wz, m([
                aR("dateLabels")
            ]), A3(cR, k, n, s)),
            A2(Wz, b, A2(zR, k, s)),
            A2(Wz, b, A2(yR, C, 3)),
            A2(Wz, b, A2(Be, F2(function(n, a) {
                var u = a.a, f = a.b, l = v > 28 && 1 > c(n + 1, v) && c(n + 1, v - 8) > -1, b = e(n + 1, v), d = i(g, s);
                return A9(tR, r, n, t, u, f, d, b, l, o);
            }), y))
        ]));
    }), VR = bn("h4"), WR = function(r) {
        return A2(az, m([
            cz("0 0 512 512"),
            Pz("information-icon"),
            oz(r),
            YE("#00A3E0")
        ]), m([
            A2(XE, m([
                BE("M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM296 336h-16V248C280 234.8 269.3 224 256 224H224C210.8 224 200 234.8 200 248S210.8 272 224 272h8v64h-16C202.8 336 192 346.8 192 360S202.8 384 216 384h80c13.25 0 24-10.75 24-24S309.3 336 296 336zM256 192c17.67 0 32-14.33 32-32c0-17.67-14.33-32-32-32S224 142.3 224 160C224 177.7 238.3 192 256 192z")
            ]), b)
        ]));
    }, PR = function(r) {
        switch(r.$){
            case 0:
                return "Learning pace";
            case 1:
                return "Logins";
            case 2:
                return "Hours viewed";
            case 3:
                return "Assignments Completed";
            case 4:
            default:
                return "Assessments Completed";
            case 5:
                return "Courses Completed";
        }
    }, GR = $n("preserveAspectRatio"), IR = (DS = m([
        "10",
        "30",
        "50",
        "70",
        "90"
    ]), _S = A2(aa, function(r) {
        return A2(qE, m([
            KE(r),
            UE("9"),
            rz("5"),
            aR("waitCircle")
        ]), b);
    }, DS), A2(az, m([
        oz("100px"),
        JE("18px"),
        cz("0 0 100 18"),
        GR("xMidYMid"),
        aR("waiting")
    ]), _S)), NR = {
        $: 1
    }, ZR = F2(function(r, n) {
        return s(n, {
            dt: r
        });
    }), DR = function(r) {
        return {
            dt: b,
            cP: !1,
            go: r,
            bq: !1
        };
    }, _R = yE("mt-4"), OR = F2(function(r, n) {
        return {
            gG: r,
            gM: n
        };
    }), qR = function(r) {
        return {
            $: 3,
            a: r
        };
    }, KR = function(r) {
        return {
            $: 3,
            a: r
        };
    }, UR = F2(function(r, n) {
        switch(r.$){
            case 0:
                return s(n, {
                    aA: Ve(r.a)
                });
            case 1:
                return s(n, {
                    aD: Ve(r.a)
                });
            case 2:
                return s(n, {
                    aN: Ve(r.a)
                });
            default:
                return s(n, {
                    gG: l(n.gG, r.a)
                });
        }
    }), BR = {
        aA: We,
        gG: b,
        aD: We,
        aN: We
    }, QR = function(r) {
        switch(r){
            case 0:
                return We;
            case 1:
                return Ve("sm");
            case 2:
                return Ve("md");
            case 3:
                return Ve("lg");
            default:
                return Ve("xl");
        }
    }, YR = function(r) {
        var n = r.g$;
        return yE("text" + (A2(di, "-", A2(Ba, function(r) {
            return "-" + r + "-";
        }, QR(r.eT))) + function(r) {
            switch(r){
                case 1:
                    return "center";
                case 0:
                    return "left";
                default:
                    return "right";
            }
        }(n)));
    }, JR = F2(function(r, n) {
        return yE(r + "-" + function() {
            switch(n){
                case 0:
                    return "primary";
                case 1:
                    return "secondary";
                case 2:
                    return "success";
                case 3:
                    return "info";
                case 4:
                    return "warning";
                case 5:
                    return "danger";
                case 6:
                    return "light";
                default:
                    return "dark";
            }
        }());
    }), XR = function(r) {
        return 1 === r.$ ? yE("text-white") : A2(JR, "text", r.a);
    }, rV = F2(function(r, n) {
        var e;
        return e = A2(LE, function(r) {
            var n, e, t, a = A3(_e, UR, BR, r);
            return l(m([
                yE("card-body")
            ]), l((t = a.aA).$ ? b : m([
                YR(t.a)
            ]), l((e = a.aD).$ ? b : m([
                A2(JR, "bg", e.a)
            ]), l((n = a.aN).$ ? b : m([
                XR(n.a)
            ]), a.gG))));
        }(r), A2(aa, function(r) {
            return r;
        }, n)), {
            $: 0,
            a: e
        };
    }), nV = rV, eV = function(r) {
        return {
            jb: r.jb,
            jQ: r.jQ,
            jW: r.jW,
            kI: r.kI
        };
    }, tV = bn("h5"), aV = F3(function(r, n, e) {
        return {
            gG: n,
            dv: b,
            dw: b,
            g3: r,
            iB: e
        };
    }), uV = aV(tV), cV = yE("border-0"), oV = yE("px-0"), iV = yE("py-3"), fV = F3(function(r, n, e) {
        var t;
        return eV({
            jb: m([
                A2(nV, m([
                    KR(m([
                        iV,
                        oV
                    ]))
                ]), m([
                    A2(LE, m([
                        yE("wizard-content-row")
                    ]), m([
                        A2(LE, m([
                            yE("wizard-content-col")
                        ]), e)
                    ]))
                ]))
            ]),
            jQ: A2(uV, m([
                cV,
                yE("wizard-header")
            ]), (t = n, A2(OR, m([
                _R,
                yE("card-subtitle")
            ]), m([
                A2(fz, b, m([
                    t
                ]))
            ])))),
            jW: Hv(r),
            kI: m([
                qR(m([
                    cV
                ]))
            ])
        });
    }), sV = F2(function(r, n) {
        return !r.$ && (0 === n || !r.a.a.$);
    }), lV = F3(function(r, n, e) {
        if (n) return !1;
        switch(e){
            case 0:
                return A2(sV, r, 0);
            case 1:
                return A2(sV, r, 1);
            default:
                return A2(sV, r, 2);
        }
    }), bV = function(r) {
        return {
            $: 3,
            a: r
        };
    }, dV = {
        $: 7
    }, vV = {
        $: 4
    }, mV = function(r) {
        return {
            $: 1,
            a: r
        };
    }, gV = function(r) {
        return {
            $: 0,
            a: r
        };
    }, pV = mV(gV(0)), $V = function(r) {
        return {
            $: 4,
            a: r
        };
    }, hV = {
        $: 2
    }, wV = function(r) {
        return $V(m([
            A2(NE, "click", zt(i(r, !0)))
        ]));
    }, CV = F3(function(r, n, e) {
        return l(r, m([
            $V(m([
                yE("cursor-pointer"),
                EE(n + "-click")
            ])),
            wV(e)
        ]));
    }), kV = F2(function(r, n) {
        switch(r.$){
            case 0:
                return s(n, {
                    eT: Ve(r.a)
                });
            case 1:
                return s(n, {
                    aD: Ve(r.a)
                });
            case 2:
                return s(n, {
                    ds: !0
                });
            case 3:
                return s(n, {
                    dF: r.a
                });
            default:
                return s(n, {
                    gG: l(n.gG, r.a)
                });
        }
    }), yV = {
        gG: b,
        ds: !1,
        aD: We,
        dF: !1,
        eT: We
    }, xV = function(r) {
        switch(r){
            case 0:
                return "primary";
            case 1:
                return "secondary";
            case 2:
                return "success";
            case 3:
                return "info";
            case 4:
                return "warning";
            case 5:
                return "danger";
            case 6:
                return "dark";
            case 7:
                return "light";
            default:
                return "link";
        }
    }, LV = F2(function(r, n) {
        return A2(CE, function(r) {
            var n, e, t = A3(_e, kV, yV, r);
            return l(m([
                Fz(m([
                    i("btn", !0),
                    i("btn-block", t.ds),
                    i("disabled", t.dF)
                ])),
                xE(t.dF)
            ]), l((e = A2(Dv, QR, t.eT)).$ ? b : m([
                yE("btn-" + e.a)
            ]), l((n = t.aD).$ ? b : m(n.a.$ ? [
                yE("btn-outline-" + xV(n.a.a))
            ] : [
                yE("btn-" + xV(n.a.a))
            ]), t.gG)));
        }(r), n);
    }), jV = function(r) {
        return {
            $: 3,
            a: r
        };
    }, AV = function(r) {
        return !r;
    }, MV = F5(function(r, n, e, t, a) {
        return A2(LV, A3(CV, l(n, m([
            hV,
            $V(m([
                yE("float-right")
            ])),
            jV(AV(r))
        ])), a, e), m([
            t
        ]));
    }), FV = F4(function(r, n, e, t) {
        var a, u = t ? vV : dV, c = 1 === (a = i(e, t)).b ? "Save and Return to Reports" : a.a.$ ? "" : a.a.a.$ ? A2(bc, 0, n) ? "Save Report" : "Save and Schedule Report" : "Save Report";
        return A5(MV, _t(r) ? 0 : 1, m([
            pV
        ]), u, Xd(c), "save-customReport-button");
    }), HV = kE("value"), TV = F4(function(r, n, e, t) {
        return A2(LE, b, m([
            A2(LE, m([
                yE("row card-body")
            ]), m([
                A2(LE, m([
                    yE("col-12 col-md-6")
                ]), m([
                    A2(TE, m([
                        yE("form-control"),
                        sz("text"),
                        HV(r),
                        PE(bV)
                    ]), b)
                ]))
            ])),
            A2(LE, m([
                yE("row card-body mt-3")
            ]), m([
                A2(LE, m([
                    yE("col-12 col-md-6")
                ]), m([
                    A4(FV, r, n, e, t)
                ]))
            ]))
        ]));
    }), SV = function(r) {
        return {
            $: 2,
            a: r
        };
    }, EV = yE("pr-2"), zV = F2(function(r, n) {
        return A2($n, function(r) {
            return /^(on|formAction$)/i.test(r) ? "data-" + r : r;
        }(r), hn(n));
    }), RV = zV, VV = F2(function(r, n) {
        return A2(RV, "aria-" + r, n);
    }), WV = A2(az, m([
        cz("0 0 448 512"),
        oz("21px"),
        YE("#fff")
    ]), m([
        A2(XE, m([
            BE("M432.6 209.3l-191.1 183.1C235.1 397.8 229.1 400 224 400s-11.97-2.219-16.59-6.688L15.41 209.3C5.814 200.2 5.502 184.1 14.69 175.4c9.125-9.625 24.38-9.938 33.91-.7187L224 342.8l175.4-168c9.5-9.219 24.78-8.906 33.91 .7187C442.5 184.1 442.2 200.2 432.6 209.3z")
        ]), b)
    ])), PV = F2(function(r, n) {
        return e(r, n) ? A2(fz, m([
            EV,
            A2(VV, "expanded", "false"),
            yE("toggle")
        ]), m([
            A2(fz, m([
                yE("sr-only")
            ]), m([
                Xd("Open collapsed content")
            ])),
            WV
        ])) : A2(fz, m([
            EV,
            A2(VV, "expanded", "true"),
            yE("toggle rotate-right")
        ]), m([
            A2(fz, m([
                yE("sr-only")
            ]), m([
                Xd("Collapse content")
            ])),
            WV
        ]));
    }), GV = F6(function(r, n, e, t, a, u) {
        var c = e ? m([
            gz(SV(n))
        ]) : b;
        return A2(fz, c, m([
            A2(fz, m([
                EV
            ]), m([
                A2(PV, r, n)
            ])),
            A2(fz, m([
                yE("font-weight-bold"),
                EV
            ]), m([
                t
            ])),
            A2(fz, b, m([
                a
            ])),
            u
        ]));
    }), IV = F2(function(r, n) {
        return A6(GV, r, 2, n, Xd("Step 3:"), Xd("Name and Save"), Xd(""));
    }), NV = function(r) {
        return A3(fV, 2, A2(IV, r.a0, A3(lV, r.h5, r.aq, 2)), m([
            A4(TV, r.kv, r.c7, r.h5, r.aq)
        ]));
    }, ZV = F4(function(r, n, e, t) {
        return A2(LV, A3(CV, l(r, m([
            $V(m([
                yE("float-right")
            ]))
        ])), t, n), m([
            e
        ]));
    }), DV = F3(function(r, n, e) {
        return A4(ZV, m([
            pV,
            hV,
            jV(!r)
        ]), n, Xd("Next"), e);
    }), _V = F3(function(r, n, e) {
        return A3(DV, r, SV(n), Hv(n) + "-" + e);
    }), OV = {
        $: 1
    }, qV = {
        $: 2
    }, KV = function(r) {
        return {
            $: 16,
            a: r
        };
    }, UV = function(r) {
        return {
            $: 15,
            a: r
        };
    }, BV = m([
        2,
        0,
        3,
        4,
        6,
        5,
        1
    ]), QV = F2(function(r, n) {
        return e(r, n) ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action";
    }), YV = F2(function(r, n) {
        return e(r, Ve(n)) ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action";
    }), JV = F2(function(r, n) {
        return e(r, Ve(n)) ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action";
    }), XV = F2(function(r, n) {
        return A2(uo, r, n);
    }), rW = F2(function(r, n) {
        return !A2(XV, A2(Fk, 11, n), A2(Fk, 11, r));
    }), nW = {
        $: 6
    }, eW = {
        $: 5
    }, tW = {
        $: 4
    }, aW = function(r) {
        return {
            $: 3,
            a: r
        };
    }, uW = function(r) {
        return {
            $: 1,
            a: r
        };
    }, cW = {
        $: 7
    }, oW = {
        $: 8
    }, iW = F2(function(r, n) {
        var e = qt(n);
        return e.$ ? r : A3(ub, e.a, Mb(r), Ab(r));
    }), fW = F2(function(r, n) {
        return n.$ ? r : n;
    }), sW = F2(function(r, n) {
        return yE(l(r.bx, n));
    }), lW = function(r) {
        return dn(function(r) {
            return "script" == r ? "p" : r;
        }(r));
    }, bW = bn("option"), dW = F5(function(r, n, e, t, a) {
        for(;;){
            if (c(a, e) >= 0) return et(t);
            var u = A3(Lk, r, n, a);
            t = A2(ye, a, t), a = u;
        }
    }), vW = F4(function(r, n, e, t) {
        var a = e, u = t, o = Hk(r), i = o.a, f = o.b, s = A2(Tk, r, a);
        return 0 > c(s, u) ? A5(dW, f, A2(kt, 1, n) * i, u, b, s) : b;
    }), mW = F2(function(r, n) {
        var e = function(r) {
            switch(r){
                case 0:
                    return 4;
                case 1:
                    return 5;
                case 2:
                    return 6;
                case 3:
                    return 7;
                case 4:
                    return 8;
                case 5:
                    return 9;
                default:
                    return 10;
            }
        }(n), t = A2(Fk, e, A3(ub, xb(r), Mb(r), 1)), a = A3(ub, xb(r), Mb(r), 1);
        return {
            gV: A4(vW, 11, 1, t, A2(Tk, e, A3(Lk, 1, 1, a))),
            fy: r
        };
    }), gW = xv("selected"), pW = function(r) {
        return A2($n, "tabIndex", Ie(r));
    }, $W = F2(function(r, n) {
        var e = r.bx;
        return Fz(A2(aa, function(r) {
            var n = r.b;
            return i(l(e, r.a), n);
        }, n));
    }), hW = F5(function(r, n, e, t, a) {
        var u, c = r.j4(a), o = c ? b : m([
            gz((u = a, {
                $: 2,
                a: u
            }))
        ]), f = $W(r);
        return A2($z, l(m([
            f(m([
                i("day", !0),
                i("disabled", c),
                i("picked", n(a)),
                i("today", t(a)),
                i("other-month", e(a))
            ]))
        ]), o), m([
            r.fo(Ie(Ab(a)))
        ]));
    }), wW = F2(function(r, n) {
        var e = r.fy, t = r.aO;
        switch(n.$){
            case 1:
                var a = n.a;
                return A2(Ue, xb(e) - a, xb(e) + a);
            case 2:
                return A2(Ue, n.a, n.b);
            case 3:
                return A2(Ue, u = n.a, xb(t));
            case 4:
                var u = n.a;
                return A2(Ue, xb(t), u);
            default:
                return b;
        }
    }), CW = F3(function(r, n, t) {
        var a, u, c, o, f = t.P, s = t.aO, l = function(n) {
            return A2(di, !1, A2(Ba, function(r) {
                return e(r, n);
            }, r));
        }, d = function(r) {
            return e(r, s);
        }, v = jk(n.dJ) - 1, g = sW(n), p = A2(di, s, A2(fW, r, f)), $ = function(r) {
            return !e(Mb(p), Mb(r));
        }, h = F2(function(r, n) {
            return A2(CE, m([
                g(r),
                gz(n),
                pW(-1),
                sz("button")
            ]), b);
        }), w = A2(mW, p, n.dJ), C = w.fy, k = A2(aa, function(r) {
            return A2(hz, m([
                g("row")
            ]), A2(aa, A4(hW, n, l, $, d), r));
        }, (a = w.gV, u = F4(function(r, n, e, t) {
            for(;;){
                if (!n.b) return et(t);
                var a = n.a, u = n.b;
                if (6 !== r) r = c = r + 1, n = o = u, e = i = A2(ye, a, e), t = f = t;
                else {
                    var c = 0, o = u, i = b, f = A2(ye, et(A2(ye, a, e)), t);
                    r = c, n = o, e = i, t = f;
                }
            }
        }), A4(u, 0, a, b, b))), y = function(r) {
            return e(xb(C), r);
        }, x = F2(function(r, n) {
            return i(Ie(r), A2(bW, m([
                HV(Ie(n)),
                gW(y(n))
            ]), m([
                Xd(Ie(n))
            ])));
        }), L = function() {
            var r = function(r) {
                return A2(Ue, xb(C), r);
            }, e = function(r) {
                return A2(Ue, r, xb(C));
            }, t = n.cj;
            switch(t.$){
                case 3:
                    return i(r(t.a - 1), e(xb(s) + 1));
                case 4:
                    var a = t.a;
                    return i(r(xb(s) - 1), e(a + 1));
                case 2:
                    return a = t.b, i(r(t.a - 1), e(a + 1));
                default:
                    return i(b, b);
            }
        }(), j = L.a, A = L.b, M = A3(lW, "select", m([
            (c = A2(wa, iW(p), uW), A2(mz, "change", A2(St, c, WE))),
            g("year-menu")
        ]), A2(Be, x, ui(m([
            j,
            A2(wW, {
                fy: C,
                aO: s
            }, n.cj),
            A
        ]))));
        return A2(LE, m([
            g("picker"),
            A2(VE, "mousedown", zt(i(cW, !0))),
            A2(VE, "mouseup", zt(i(oW, !0)))
        ]), m([
            A2(LE, m([
                g("picker-header")
            ]), m([
                A2(LE, m([
                    g("prev-container")
                ]), m([
                    A2(h, "prev", uW(A3(Lk, 1, -1, p)))
                ])),
                A2(LE, m([
                    g("month-container")
                ]), m([
                    A2(fz, m([
                        g("month")
                    ]), m([
                        Xd(n.fX(Mb(C)))
                    ])),
                    A2(fz, m([
                        g("year")
                    ]), m([
                        (o = n.cj, e(o, kv) ? Xd(n.gv(xb(C))) : A3(lW, "span", b, m([
                            i(Ie(xb(C)), M)
                        ])))
                    ]))
                ])),
                A2(LE, m([
                    g("next-container")
                ]), m([
                    A2(h, "next", uW(A3(Lk, 1, 1, p)))
                ]))
            ])),
            A2(Cz, m([
                g("table")
            ]), m([
                A2(xz, m([
                    g("weekdays")
                ]), m([
                    A2(hz, b, A2(aa, function(r) {
                        return A2($z, m([
                            g("dow")
                        ]), m([
                            Xd(n.fA(r))
                        ]));
                    }, A2(ox, 7, A2(tx, v, ui(A2(Dx, 2, m([
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6
                    ])))))))
                ])),
                A2(kz, m([
                    g("days")
                ]), k)
            ]))
        ]));
    }), kW = kE("name"), yW = function(r) {
        return A2(mz, "focus", zt(r));
    }, xW = function(r) {
        return m([
            r
        ]);
    }, LW = F3(function(r, n, e) {
        var t, a, u = e, c = A3(wa, xW, Af(Vt), A2(Ba, EE, n.j$)), o = l(m([
            i(n.bx + "input", !0)
        ]), n.j_), f = (t = m([
            _E(n.f5),
            HV(A2(di, A2(di, "", A2(Ba, n.fz, r)), u.af))
        ]), A2(TE, l(m([
            Fz(o),
            kW(A2(di, "", n.j0)),
            sz("text"),
            A2(mz, "change", zt(tW)),
            PE(aW),
            (a = nW, A2(mz, "blur", zt(a))),
            gz(eW),
            yW(eW)
        ]), l(n.fT, l(c, t))), b)), s = A2(ye, i(n.bx + "container", !0), n.fr);
        return A2(LE, m([
            Fz(s)
        ]), m([
            f,
            u.cQ ? A3(CW, r, n, u) : Xd("")
        ]));
    }), jW = F4(function(r, n, e, t) {
        var a = t;
        return A2(iE, Il, A2(ME, m([
            yE("form-inline mt-2 d-flex justify-content-end py-3 date-picker")
        ]), m([
            A2(SE, m([
                yE("mr-2")
            ]), m([
                Xd("To")
            ])),
            A3(LW, A2(Ba, zk, r), s(e, {
                j4: rW(a)
            }), n)
        ])));
    }), AW = F3(function(r, n, e) {
        return A2(iE, Nl, A2(ME, m([
            yE("form-inline mt-2 d-flex justify-content-end pt-5 pb-3")
        ]), m([
            A2(SE, m([
                yE("mr-2")
            ]), m([
                Xd("From")
            ])),
            A3(LW, A2(Ba, Rk, r), e, n)
        ])));
    }), MW = function(r) {
        var n, e = (n = r.a3).$ ? b : m([
            A4(jW, r.a1, r.a2, r.dC, n.a)
        ]), t = A2(LE, b, b), a = r.h5;
        if (a.$ || a.a.$) return t;
        var u = a.a.a;
        return u.$ || 3 !== u.a.$ ? t : A2(LE, m([
            yE("row")
        ]), m([
            A2(LE, m([
                yE("col-12 col-md-4 pb-5")
            ]), A2(ye, A3(AW, r.a3, r.cq, r.dC), e))
        ]));
    }, FW = function(r) {
        var n = function() {
            var n = r.h5;
            if (n.$) return b;
            if (n.a.$) {
                var e = (t = r.h5).$ || 1 !== t.a.$ ? We : t.a.a;
                return m([
                    A2(CE, m([
                        yE(A2(JV, e, 0)),
                        gz(KV(0))
                    ]), m([
                        Xd("Weekly")
                    ])),
                    A2(CE, m([
                        yE(A2(JV, e, 1)),
                        gz(KV(1))
                    ]), m([
                        Xd("Monthly")
                    ])),
                    A2(CE, m([
                        yE(A2(JV, e, 2)),
                        gz(KV(2))
                    ]), m([
                        Xd("Quarterly")
                    ]))
                ]);
            }
            var t, a, u = (a = r.h5).$ || a.a.$ ? We : a.a.a;
            return m([
                A2(CE, m([
                    yE(A2(YV, u, Bk)),
                    gz(UV(Bk))
                ]), m([
                    Xd("Previous Calendar Week")
                ])),
                A2(CE, m([
                    yE(A2(YV, u, OV)),
                    gz(UV(OV))
                ]), m([
                    Xd("Previous Calendar Month")
                ])),
                A2(CE, m([
                    yE(A2(YV, u, qV)),
                    gz(UV(qV))
                ]), m([
                    Xd("Previous Calendar Quarter")
                ])),
                A2(CE, m([
                    yE(A2(YV, u, A2(bk, r.a3, r.a1))),
                    gz(UV(A2(bk, We, We)))
                ]), m([
                    Xd("Custom Date Range")
                ]))
            ]);
        }(), e = r.ju;
        return A2(LE, m([
            yE("row pb-5")
        ]), m([
            A2(LE, m([
                yE("col-12")
            ]), m([
                A2(LE, m([
                    yE("row")
                ]), m([
                    A2(LE, m([
                        yE("col-12 col-md-4")
                    ]), m([
                        A2(LE, m([
                            yE("list-group")
                        ]), A2(aa, function(r) {
                            var n;
                            return A2(CE, m([
                                yE(A2(QV, e, r)),
                                gz((n = r, {
                                    $: 14,
                                    a: n
                                }))
                            ]), m([
                                Xd(Wk(r))
                            ]));
                        }, BV))
                    ]))
                ])),
                A2(LE, m([
                    yE("row mt-3")
                ]), m([
                    A2(LE, m([
                        yE("col-12 col-md-4")
                    ]), m([
                        A2(LE, m([
                            yE("list-group")
                        ]), n)
                    ]))
                ])),
                MW(r)
            ]))
        ]));
    }, HW = yE("pl-2"), TW = A2(az, m([
        cz("0 0 512 512"),
        oz("18px"),
        Pz("edit"),
        YE("#00A3e0")
    ]), m([
        A2(XE, m([
            BE("M373.1 24.97C401.2-3.147 446.8-3.147 474.9 24.97L487 37.09C515.1 65.21 515.1 110.8 487 138.9L289.8 336.2C281.1 344.8 270.4 351.1 258.6 354.5L158.6 383.1C150.2 385.5 141.2 383.1 135 376.1C128.9 370.8 126.5 361.8 128.9 353.4L157.5 253.4C160.9 241.6 167.2 230.9 175.8 222.2L373.1 24.97zM440.1 58.91C431.6 49.54 416.4 49.54 407 58.91L377.9 88L424 134.1L453.1 104.1C462.5 95.6 462.5 80.4 453.1 71.03L440.1 58.91zM203.7 266.6L186.9 325.1L245.4 308.3C249.4 307.2 252.9 305.1 255.8 302.2L390.1 168L344 121.9L209.8 256.2C206.9 259.1 204.8 262.6 203.7 266.6zM200 64C213.3 64 224 74.75 224 88C224 101.3 213.3 112 200 112H88C65.91 112 48 129.9 48 152V424C48 446.1 65.91 464 88 464H360C382.1 464 400 446.1 400 424V312C400 298.7 410.7 288 424 288C437.3 288 448 298.7 448 312V424C448 472.6 408.6 512 360 512H88C39.4 512 0 472.6 0 424V152C0 103.4 39.4 64 88 64H200z")
        ]), b)
    ])), SW = function(r) {
        return A2(HE, A2(ye, A2(VV, "label", "Edit icon"), r), m([
            A2(fz, m([
                yE("sr-only")
            ]), m([
                Xd("Edit content")
            ])),
            TW
        ]));
    }, EW = F2(function(r, n) {
        var e = 1 !== r && n ? SW(m([
            yE("icon")
        ])) : Xd("");
        return A6(GV, r, 1, n, Xd("Step 2:"), Xd("Select Data Set and Time Frame"), A2(fz, m([
            HW
        ]), m([
            e
        ])));
    }), zW = function(r) {
        return A3(fV, 1, A2(EW, r.a0, A3(lV, r.h5, r.aq, 1)), function(r) {
            return m([
                FW(r),
                A2(LE, m([
                    yE("row mt-5 pb-5")
                ]), m([
                    A2(LE, m([
                        yE("col-12 col-md-4")
                    ]), m([
                        A3(_V, A3(lV, r.h5, r.aq, 1), 2, r.E)
                    ]))
                ]))
            ]);
        }(r));
    }, RW = function(r) {
        return {
            $: 13,
            a: r
        };
    }, VW = F2(function(r, n) {
        return e(r, Ve(n)) ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action";
    }), WW = function(r) {
        var n = r.h5, e = function() {
            r: for(; !n.$;){
                if (n.a.$) {
                    if (1 === n.a.a.$) return "A Recurring report will provide an ongoing, dynamic snapshot of data for the specific time frame you select; i.e. Monthly. This report will be saved in your Saved Reports with a scheduled send date.";
                    break r;
                }
                if (1 === n.a.a.$) return "A Static report will provide a one-time snapshot of data for the specific time frame you select, i.e. Previous Calendar Quarter. This report will be saved in your Saved Reports and available for download.";
                break r;
            }
            return "";
        }();
        return A2(LE, m([
            yE("row")
        ]), m([
            A2(LE, m([
                yE("col-12")
            ]), m([
                A2(LE, m([
                    yE("row mt-3")
                ]), m([
                    A2(LE, m([
                        yE("col-12 col-md-4")
                    ]), m([
                        A2(LE, m([
                            yE("list-group")
                        ]), m([
                            A2(CE, m([
                                yE(A2(VW, n, hb(We))),
                                gz(RW(hb(We)))
                            ]), m([
                                Xd("Static")
                            ])),
                            A2(CE, m([
                                yE(A2(VW, n, lw(We))),
                                gz(RW(lw(We)))
                            ]), m([
                                Xd("Recurring")
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            A2(LE, m([
                yE("col-12 mt-5")
            ]), m([
                Xd(e)
            ]))
        ]));
    }, PW = F3(function(r, n, e) {
        var t = n ? Xd("") : r ? SW(m([
            yE("icon")
        ])) : Xd("");
        return A6(GV, r, 0, e, Xd("Step 1:"), Xd("Select Report Type"), A2(fz, m([
            HW
        ]), m([
            t
        ])));
    }), GW = function(r) {
        return A3(fV, 0, A3(PW, r.a0, r.aq, A3(lV, r.h5, r.aq, 0)), function(r) {
            return m([
                WW(r),
                A2(LE, m([
                    yE("row mt-5 pb-5")
                ]), m([
                    A2(LE, m([
                        yE("col-12 col-md-4")
                    ]), m([
                        A3(_V, A3(lV, r.h5, r.aq, 0), 1, r.E)
                    ]))
                ]))
            ]);
        }(r));
    }, IW = F2(function(r, n) {
        switch(r.$){
            case 0:
                return s(n, {
                    aA: Ve(r.a)
                });
            case 1:
                return s(n, {
                    aD: Ve(r.a)
                });
            case 2:
                return s(n, {
                    aN: Ve(r.a)
                });
            default:
                return s(n, {
                    gG: l(n.gG, r.a)
                });
        }
    }), NW = {
        aA: We,
        gG: b,
        aD: We,
        aN: We
    }, ZW = F2(function(r, n) {
        return A2(di, {
            bI: We,
            B: 0
        }, A2(co, r, n));
    }), DW = gn, _W = DW, OW = F2(function(r, n) {
        return l(m([
            A2(_W, "position", "relative"),
            A2(_W, "height", n),
            A2(_W, "overflow", "hidden")
        ]), r ? m([
            A2(_W, "-webkit-transition-timing-function", "ease"),
            A2(_W, "-o-transition-timing-function", "ease"),
            A2(_W, "transition-timing-function", "ease"),
            A2(_W, "-webkit-transition-duration", "0.35s"),
            A2(_W, "-o-transition-duration", "0.35s"),
            A2(_W, "transition-duration", "0.35s"),
            A2(_W, "-webkit-transition-property", "height"),
            A2(_W, "-o-transition-property", "height"),
            A2(_W, "transition-property", "height")
        ]) : b);
    }), qW = F3(function(r, n, e) {
        var t = e.jW, a = OW(n.bq), u = A2(ZW, t, r), c = A2(di, "0", A2(Ba, function(r) {
            return Oz(r) + "px";
        }, u.bI));
        switch(u.B){
            case 0:
            case 1:
                return a("0px");
            case 2:
                return a(c);
            default:
                return a(u.bI.$ ? "100%" : c);
        }
    }), KW = function(r) {
        return A2(aa, function(r) {
            return r.a;
        }, r);
    }, UW = F3(function(r, n, e) {
        var t = e.jb;
        return A2(LE, l(m([
            EE(e.jW)
        ]), A3(qW, r, n, e)), m([
            A2(LE, b, KW(t))
        ]));
    }), BW = F2(function(r, n) {
        if (-2 === n.$) return io;
        var e = n.b, t = n.d, a = n.e;
        return A5(oo, n.a, e, A2(r, e, n.c), A2(BW, r, t), A2(BW, r, a));
    }), QW = F2(function(r, n) {
        var e = i(r, n);
        if (e.a) switch(e.b){
            case 0:
                return 1;
            case 1:
                return 3;
            case 3:
                return 2;
            default:
                return 0;
        }
        else switch(e.b){
            case 0:
            default:
                return 3;
            case 3:
                return 0;
        }
    }), YW = F4(function(r, n, t, a) {
        var u = r, c = a.jW, o = A3(lo, c, A2(di, {
            bI: We,
            B: 0
        }, A2(co, c, u)), u);
        return A2(xu, function(r) {
            var t;
            return zt({
                km: n.go((t = r, A2(BW, F2(function(r, a) {
                    return e(r, c) ? {
                        bI: Ve(t),
                        B: A2(QW, n.bq, a.B)
                    } : 3 === a.B && n.bq && n.cP ? s(a, {
                        B: 2
                    }) : 3 === a.B && !n.bq && n.cP ? s(a, {
                        B: 0
                    }) : a;
                }), o))),
                kM: !0,
                k8: !0
            });
        }, t);
    }), JW = F2(function(r, n) {
        return A2(RE, r, {
            $: 3,
            a: n
        });
    }), XW = function(r) {
        return Ov(m([
            "childNodes",
            Ie(r)
        ]));
    }, rP = A2(tu, "offsetHeight", au), nP = A2(tu, "currentTarget", function(r) {
        return A2(tu, "parentElement", r);
    }((OS = A2(XW, 0, rP), A2(tu, "nextSibling", OS)))), eP = F3(function(r, n, e) {
        var t = e.jQ.iB, a = t.gG, u = t.gM;
        return A2(CE, l(m([
            yE("btn btn-link"),
            A2(JW, "click", A4(YW, r, n, nP, e))
        ]), a), u);
    }), tP = F3(function(r, n, e) {
        var t = e.jQ;
        return A2(t.g3, l(t.gG, m([
            yE("card-header")
        ])), l(t.dw, l(m([
            A3(eP, r, n, e)
        ]), t.dv)));
    }), aP = F3(function(r, n, e) {
        var t, a, u, c;
        return A2(LE, l((c = A3(_e, IW, NW, e.kI), l(m([
            yE("card")
        ]), l((u = c.aD).$ ? b : m(u.a.$ ? [
            A2(JR, "border", u.a.a)
        ] : [
            A2(JR, "bg", u.a.a)
        ]), l((a = c.aN).$ ? b : m([
            XR(a.a)
        ]), l((t = c.aA).$ ? b : m([
            YR(t.a)
        ]), c.gG))))), m([
            yE("card")
        ])), m([
            A3(tP, r, n, e),
            A3(UW, r, n, e)
        ]));
    }), uP = F2(function(r, n) {
        var e = n;
        return A2(LE, b, A2(aa, A2(aP, r, e), e.dt));
    }), cP = function(r) {
        return A2(uP, r.cc, A2(ZR, m([
            GW(r),
            zW(r),
            NV(r)
        ]), DR(Es(NR))));
    }, oP = F3(function(r, n, e) {
        return s(e, {
            bv: Ve({
                gG: r,
                gM: n
            })
        });
    }), iP = function(r) {
        return {
            bv: We,
            ck: r,
            dK: We,
            jQ: We,
            kI: {
                fp: !0,
                cy: !0,
                cL: We
            },
            bq: We
        };
    }, fP = F3(function(r, n, e) {
        return s(e, {
            dK: Ve({
                gG: r,
                gM: n
            })
        });
    }), sP = F3(function(r, n, e) {
        return s(e, {
            jQ: Ve({
                gG: r,
                gM: n
            })
        });
    }), lP = F3(function(r, n, e) {
        return A2(sP, b, m([
            A2(r, A2(ye, yE("modal-title"), n), e)
        ]));
    }), bP = lP(VR), dP = function(r) {
        var n = r.bq;
        return n.$ ? r.ck : (0, n.a)(1);
    }, vP = function(r) {
        return A2(di, !1, A2(Ba, function() {
            return !0;
        }, r.bq));
    }, mP = F2(function(r, n) {
        var e = function() {
            switch(r){
                case 0:
                    return l(m([
                        Fz(m([
                            i("modal-backdrop", !0),
                            i("fade", vP(n)),
                            i("show", !0)
                        ]))
                    ]), n.kI.cy ? m([
                        gz(dP(n))
                    ]) : b);
                case 1:
                    return m([
                        Fz(m([
                            i("modal-backdrop", !0),
                            i("fade", !0),
                            i("show", !0)
                        ]))
                    ]);
                case 2:
                    return m([
                        Fz(m([
                            i("modal-backdrop", !0),
                            i("fade", !0),
                            i("show", !1)
                        ]))
                    ]);
                default:
                    return m([
                        Fz(m([
                            i("modal-backdrop", !1),
                            i("fade", vP(n)),
                            i("show", !1)
                        ]))
                    ]);
            }
        }();
        return m([
            A2(LE, e, b)
        ]);
    }), gP = A2(Ov, m([
        "className"
    ]), wc), pP = F2(function(r, n) {
        switch(r){
            case 0:
                return m([
                    A2(_W, "pointer-events", "none"),
                    A2(_W, "display", "block"),
                    Fz(m([
                        i("modal", !0),
                        i("fade", vP(n)),
                        i("show", !0)
                    ]))
                ]);
            case 1:
                return m([
                    A2(_W, "pointer-events", "none"),
                    A2(_W, "display", "block"),
                    Fz(m([
                        i("modal", !0),
                        i("fade", !0),
                        i("show", !0)
                    ]))
                ]);
            case 2:
                return m([
                    A2(_W, "pointer-events", "none"),
                    A2(_W, "display", "block"),
                    Fz(m([
                        i("modal", !0),
                        i("fade", !0),
                        i("show", !1)
                    ])),
                    A2(mz, "transitionend", zt(n.ck))
                ]);
            default:
                return m([
                    A2(_W, "height", "0px"),
                    A2(_W, "display", "block"),
                    Fz(m([
                        i("modal", !0),
                        i("fade", vP(n)),
                        i("show", !1)
                    ]))
                ]);
        }
    }), $P = function(r) {
        var n = QR(r);
        return n.$ ? b : m([
            yE("modal-" + n.a)
        ]);
    }, hP = function(r) {
        if (r.$) return We;
        var n = r.a;
        return Ve(A2(LE, A2(ye, yE("modal-body"), n.gG), n.gM));
    }, wP = function(r) {
        if (r.$) return We;
        var n = r.a;
        return Ve(A2(LE, A2(ye, yE("modal-footer"), n.gG), n.gM));
    }, CP = function(r) {
        var n = r.jQ;
        if (n.$) return We;
        var e, t = n.a;
        return Ve(A2(LE, A2(ye, yE("modal-header"), t.gG), l(t.gM, m([
            (e = dP(r), A2(CE, m([
                yE("close"),
                gz(e)
            ]), m([
                Xd("\xd7")
            ])))
        ]))));
    }, kP = F2(function(r, n) {
        var e, t, a = n;
        return A2(LE, b, l(m([
            A2(LE, l(m([
                pW(-1)
            ]), A2(pP, r, a)), m([
                A2(LE, l(m([
                    A2(RV, "role", "document"),
                    yE("elm-bootstrap-modal")
                ]), l((e = a.kI, l(m([
                    Fz(m([
                        i("modal-dialog", !0),
                        i("modal-dialog-centered", e.fp)
                    ])),
                    A2(_W, "pointer-events", "auto")
                ]), A2(di, b, A2(Ba, $P, e.cL)))), a.kI.cy ? m([
                    A2(mz, "click", (t = a.ck, A2(xu, function(r) {
                        return A2(Gt, "elm-bootstrap-modal", r) ? zt(t) : Us("ignoring");
                    }, function(r) {
                        return A2(tu, "target", r);
                    }(gP))))
                ]) : b)), m([
                    A2(LE, m([
                        yE("modal-content")
                    ]), A2(Af, Vt, m([
                        CP(a),
                        hP(a.bv),
                        wP(a.dK)
                    ])))
                ]))
            ]))
        ]), A2(mP, r, a)));
    }), yP = F6(function(r, n, e, t, a, u) {
        if (e.$) return A2(LE, b, m([
            A2(kP, a, A3(fP, b, m([
                A4(ZV, m([
                    pV
                ]), u, Xd("Ok"), "hide-activity-" + t)
            ]), A3(oP, b, m([
                Xd(n)
            ]), A3(bP, b, m([
                Xd(r)
            ]), iP(u)))))
        ]));
        var c = e.a;
        return A2(LE, b, m([
            A2(kP, a, A3(fP, b, m([
                A4(ZV, m([
                    pV
                ]), u, Xd("Ok"), "hide-activity-" + t)
            ]), A3(oP, b, m([
                c
            ]), A3(oP, b, m([
                Xd(n)
            ]), A3(bP, b, m([
                Xd(r)
            ]), iP(u))))))
        ]));
    }), xP = {
        $: 0
    }, LP = {
        $: 5
    }, jP = xv("checked"), AP = function(r) {
        return g(r).join("");
    }, MP = function(r) {
        return r.toLowerCase();
    }, FP = function(r) {
        return r.toUpperCase();
    }, HP = function(r) {
        var n = PT(r);
        return xa(A2(Be, F2(function(r, n) {
            if (r) {
                var e = Ka(n);
                return e.b ? e.b.b ? (a = e.b, AP(A2(ye, FP(e.a), a))) : Tb(FP(e.a)) : n;
            }
            var t = Ka(n);
            if (t.b) {
                if (t.b.b) {
                    var a = t.b;
                    return AP(A2(ye, MP(t.a), a));
                }
                return Tb(MP(t.a));
            }
            return n;
        }), n));
    }, TP = function(r) {
        return {
            $: 1,
            a: r
        };
    }, SP = bn("p"), EP = function(r) {
        var n = r.b;
        return m([
            A2(SP, b, m([
                Xd(r.a)
            ])),
            A2(SP, b, m([
                A2(fz, m([
                    yE("mr-2")
                ]), m([
                    WR("20px")
                ])),
                Xd(n)
            ])),
            A2(LE, m([
                yE("row")
            ]), m([
                A2(LE, m([
                    yE("col-12 col-md-4 pt-5")
                ]), m([
                    A2(CE, m([
                        yE("btn btn-block btn-primary cursor-pointer"),
                        gz(TP(1))
                    ]), m([
                        Xd("Next")
                    ]))
                ]))
            ]))
        ]);
    }, zP = F2(function(r, n) {
        var e = function() {
            if (n) {
                var e = function() {
                    var n = r.ao;
                    switch(n.$){
                        case 0:
                            return Xd("loading seat admins");
                        case 1:
                            return A2(Sz, b, A2(aa, function(r) {
                                var n, e = r.jM + " " + r.ka;
                                return A2(Hz, m([
                                    yE("form-check py-2")
                                ]), m([
                                    A2(TE, m([
                                        yE("form-check-input"),
                                        sz("checkbox"),
                                        EE(HP(e)),
                                        jP(r.d_),
                                        gz((n = r.g7, {
                                            $: 4,
                                            a: n
                                        }))
                                    ]), b),
                                    A2(SE, m([
                                        yE("form-check-label"),
                                        AE(HP(e))
                                    ]), m([
                                        Xd(e)
                                    ]))
                                ]));
                            }, A2(mc, function(r) {
                                return r.jM;
                            }, n.a)));
                        default:
                            return Xd("error");
                    }
                }();
                return m([
                    e,
                    A2(LE, m([
                        yE("row")
                    ]), m([
                        A2(LE, m([
                            yE("col-12 col-md-4 pt-5")
                        ]), m([
                            A2(CE, m([
                                yE("btn btn-block btn-primary cursor-pointer"),
                                gz(LP)
                            ]), m([
                                Xd("Schedule Report")
                            ]))
                        ]))
                    ]))
                ]);
            }
            switch(r.eJ){
                case 0:
                    return EP(i("Previous calendar week\u2019s data will be sent every Monday of the next week at 12:00 p.m. UTC.", "A calendar week is defined as Monday to Sunday"));
                case 1:
                    return EP(i("Previous calendar month\u2019s data will be sent every first day of the next month.", "Reports will be sent at 12:00 p.m. UTC."));
                default:
                    return EP(i("Previous calendar quarter\u2019s data will be sent every first day of the next quarter.", "Reports will be sent at 12:00 p.m. UTC."));
            }
        }();
        return A2(LE, m([
            yE("card-body py-3 px-0")
        ]), m([
            A2(LE, m([
                yE("wizard-content-row")
            ]), m([
                A2(LE, m([
                    yE("wizard-content-col")
                ]), e)
            ]))
        ]));
    }), RP = F2(function(r, n) {
        var e = r ? i(2, "Select Recipients") : i(1, "Cadence"), t = e.a, a = e.b;
        return A2(tV, m([
            yE("border-0 wizard-header card-header")
        ]), m([
            A2(CE, m([
                yE("btn btn-link mt-4 card-subtitle"),
                gz(TP(r))
            ]), m([
                A2(fz, m([
                    yE("pr-4 toggle"),
                    Fz(m([
                        i("rotate-right", n)
                    ])),
                    A2(VV, "expanded", "false")
                ]), m([
                    A2(fz, m([
                        yE("sr-only")
                    ]), m([
                        Xd("Open collapsed content")
                    ])),
                    WV
                ])),
                A2(fz, m([
                    yE("font-weight-bold pr-2")
                ]), m([
                    Xd("Step " + Ie(t) + ":")
                ])),
                A2(fz, b, m([
                    Xd(a)
                ]))
            ]))
        ]));
    }), VP = F2(function(r, n) {
        var t = e(r.fi, n) ? i(m([
            A2(zP, r, n)
        ]), !1) : i(b, !0), a = t.a, u = A2(ye, A2(RP, n, t.b), a);
        return A2(LE, m([
            yE("card border-0 card")
        ]), u);
    }), WP = F2(function(r, n) {
        return {
            c: r,
            iR: n
        };
    }), PP = {
        $: 11
    }, GP = F4(function(r, n, e, t) {
        return {
            gG: r,
            bv: e,
            dK: t,
            z: n
        };
    }), IP = "#00A5E1", NP = $n("stroke-dasharray"), ZP = $n("stroke-dashoffset"), DP = $n("text-anchor"), _P = function(r) {
        var n = r.a, e = r.b, t = xa(m([
            Ie(n),
            "/",
            Ie(e)
        ])), a = n / e, u = 1 - a, c = A2(Ne, " ", m([
            Oz(100 * a),
            Oz(100 * u)
        ]));
        return A2(az, m([
            oz("100%"),
            JE("100%"),
            cz("0 0 42 42"),
            aR("donut")
        ]), m([
            A2(qE, m([
                aR("donut-ring"),
                KE("21"),
                UE("21"),
                rz("15.91549430918954"),
                YE("transparent"),
                nz("#f4b43a"),
                tz("2")
            ]), b),
            A2(qE, m([
                aR("donut-segment"),
                KE("21"),
                UE("21"),
                rz("15.91549430918954"),
                YE("transparent"),
                nz(IP),
                tz("2"),
                NP(c),
                ZP("25")
            ]), b),
            A2(Bz, m([
                YE(IP),
                Jz("21"),
                Xz("23"),
                Dz("6"),
                DP("middle")
            ]), m([
                uz(t)
            ]))
        ]));
    }, OP = F5(function(r, n, e, t, a) {
        var u = r, c = n, o = e, f = Ie(c - u), s = function() {
            if (c - u) {
                var r = A2(Ne, " ", m([
                    f,
                    "seats available"
                ]));
                return m([
                    A2(fz, m([
                        yE("mr-2")
                    ]), m([
                        Xd(r)
                    ])),
                    A2(lE, m([
                        yE("btn btn-sm btn-primary"),
                        FE(A3(Hl, Ms, t, a))
                    ]), m([
                        Xd("ASSIGN SEATS")
                    ]))
                ]);
            }
            var n = Ie(o), e = A2(Ne, " ", m([
                f,
                "seats available, ",
                n,
                "swapped"
            ]));
            return m([
                A2(fz, m([
                    yE("mr-2")
                ]), m([
                    Xd(e)
                ])),
                A2(CE, m([
                    yE("btn btn-sm btn-primary"),
                    gz(PP)
                ]), m([
                    Xd("ADD ADDITIONAL SEATS")
                ]))
            ]);
        }();
        return A4(GP, m([
            yE("col-12 col-md-4 col-lg-3")
        ]), "Assigned Seats", i(m([
            A2(LE, m([
                yE("donutWrapper m-auto position-relative")
            ]), m([
                _P(i(u, c))
            ]))
        ]), We), m([
            A2(SP, m([
                yE("mb-0")
            ]), s)
        ]));
    }), qP = function(r) {
        var n = jb(r);
        return 12 * (n.iU - 1) + (wb(n.hG) - 1) + n.gZ / 100;
    }, KP = F3(function(r, n, e) {
        var t = n, a = e;
        switch(r){
            case 0:
                return (qP(a) - qP(t) | 0) / 12 | 0;
            case 1:
                return qP(a) - qP(t) | 0;
            case 2:
                return (a - t) / 7 | 0;
            default:
                return a - t;
        }
    }), UP = F3(function(r, n, e) {
        return r > 0 && n > 0 ? A2(F2(function(e, t) {
            for(;;){
                if (pF(e)) return et(t);
                var a = A2(tx, n, e), u = A2(ye, A2(ox, r, e), t);
                e = a, t = u;
            }
        }), e, b) : b;
    }), BP = F2(function(r, n) {
        return A3(UP, r, r, n);
    }), QP = function(r) {
        var n = A2(Ba, aa(qt), A2(Ba, Ze("-"), sc(A2(Ze, "T", r))));
        if (n.$ || !n.a.b || n.a.a.$ || !n.a.b.b || n.a.b.a.$ || !n.a.b.b.b || n.a.b.b.a.$ || n.a.b.b.b.b) return We;
        var e = n.a, t = e.b, a = t.b.a.a;
        return Ve(A3(ub, e.a.a, op(t.a.a), a));
    }, YP = function(r) {
        return {
            $: 7,
            a: r
        };
    }, JP = function(r) {
        var n = Ie(xb(r));
        return uR(Mb(r)) + " " + Ie(Ab(r)) + ", " + n;
    }, XP = function(r) {
        return A2(RV, "role", r);
    }, rG = kE("target"), nG = F4(function(r, n, e, t) {
        var a, u = t.a, c = t.b, o = Ie(ou(100 * u.kO)), f = o + "%", s = Oz(100 * (c + .5 / 1.5)), l = u.dp, b = (a = QP(l)).$ ? A2(di, l, sc(A2(Ze, "T", l))) : JP(a.a);
        return A2(LE, m([
            yE("row")
        ]), m([
            A2(LE, m([
                yE("col-6 col-xl-9")
            ]), m([
                A2(LE, m([
                    yE("row")
                ]), m([
                    A2(LE, m([
                        yE("col-12 col-xl-4")
                    ]), m([
                        A2(SP, m([
                            yE("mb-0 mb-xl-3"),
                            Fz(m([
                                i("pt-3", !e)
                            ]))
                        ]), m([
                            Xd(u.b7)
                        ]))
                    ])),
                    A2(LE, m([
                        yE("col-12 col-xl-4")
                    ]), m([
                        A2(SP, m([
                            yE("mb-3"),
                            Fz(m([
                                i("pt-0 pt-xl-3", !e)
                            ]))
                        ]), m([
                            A2(lE, m([
                                FE(A3(Hl, YP(u.ks), r, n)),
                                rG("_self")
                            ]), m([
                                Xd(u.hF)
                            ]))
                        ]))
                    ])),
                    A2(LE, m([
                        yE("col-12 col-xl-4")
                    ]), m([
                        A2(SP, m([
                            yE("mb-3"),
                            Fz(m([
                                i("pt-0 pt-xl-3", !e)
                            ]))
                        ]), m([
                            Xd(b)
                        ]))
                    ]))
                ]))
            ])),
            A2(LE, m([
                yE("col-6 col-xl-3 pb-3 d-flex align-items-center assignment-progress"),
                Fz(m([
                    i("pt-0 pt-xl-3", !e)
                ]))
            ]), m([
                A2(LE, m([
                    yE("progress"),
                    A2(_W, "width", s + "%")
                ]), m([
                    A2(LE, m([
                        yE("progress-bar pl-1 font-weight-bold"),
                        XP("progressbar"),
                        A2(_W, "width", f),
                        A2(VV, "valuenow", o),
                        A2(VV, "valuemin", "0"),
                        A2(VV, "valuemax", "100")
                    ]), m([
                        Xd(f)
                    ]))
                ]))
            ]))
        ]));
    }), eG = F4(function(r, n, t, a) {
        var u = {
            gC: n.aR.aH,
            gE: Ie(n.e3 / n.e4 | 0),
            e3: Ie(n.e3),
            e4: Ie(n.e4)
        }, c = u.gC, o = u.e3, f = u.e4, s = u.gE, l = pF(c) ? i("Assignment progress for assignments due within the next 30 days will be shown here.", m([
            A2(SP, m([
                yE("mb-0")
            ]), m([
                A2(fz, m([
                    yE("mr-2")
                ]), m([
                    Xd("Assigning learning modules to users helps improve engagement and ensures your users are learning the\n                    skills you want them to. Create a learning module, select users, and choose a due date. Users will be\n                        notified of their assignment and can start learning.")
                ])),
                A2(lE, m([
                    yE("btn btn-sm btn-primary"),
                    FE(A3(Hl, Df, t, a)),
                    rG("_self")
                ]), m([
                    Xd("CREATE AN ASSIGNMENT")
                ]))
            ]))
        ])) : i("Upcoming due dates \u2014 ", b), d = l.a, v = l.b, g = A2(Dv, function(r) {
            return QP(r.dp);
        }, sc(c)), p = A2(aa, function(r) {
            var n = QP(r.dp), e = i(g, n);
            return i(r, e.a.$ || e.b.$ ? 1 : A3(KP, 3, e.a.a, e.b.a) / 30);
        }, c), $ = A2(BP, 10, A2(Be, A2(nG, t, a), p)), h = Oe($), w = function() {
            switch(h){
                case 1:
                    return A2(Be, A2(nG, t, a), p);
                case 2:
                    switch(n.aR.au){
                        case 1:
                            return ui(A2(ox, 1, $));
                        case 2:
                            return ui(A2(tx, 1, $));
                        default:
                            return b;
                    }
                default:
                    var r = n.aR.au;
                    switch(r){
                        case 1:
                            return ui(A2(ox, 1, $));
                        case 2:
                            return ui(A2(tx, 1, A2(ox, 2, $)));
                        default:
                            return ui(A2(tx, r - 1, A2(ox, r, $)));
                    }
            }
        }(), C = ou(A3(Jl, 0, 5, h)), k = A2(aa, function(r) {
            var t, a = e(r, n.aR.au) ? "pageNumber btn btn-link btn-sm activePage" : "pageNumber btn btn-link btn-sm";
            return A2(CE, m([
                gz(lx((t = r, {
                    $: 4,
                    a: t
                }))),
                yE(a)
            ]), m([
                Xd(" " + Ie(r))
            ]));
        }, A2(Ue, 1, C)), y = h > 1 ? A2(fz, m([
            yE("row mt-3")
        ]), m([
            A2(LE, m([
                yE("col-12 col-xl-9 d-flex")
            ]), m([
                A2(tV, b, m([
                    Xd(d)
                ])),
                A2(fz, m([
                    yE("pl-2")
                ]), m([
                    Xd("Next 30 Days")
                ]))
            ])),
            A2(SP, m([
                yE("col-12 col-xl-3 d-flex justify-content-end")
            ]), A2(ye, A2(fz, m([
                yE("pt-1")
            ]), m([
                Xd("Page")
            ])), k))
        ])) : A2(tV, m([
            yE("mt-3")
        ]), m([
            Xd(d)
        ]));
        return A4(GP, r, "Assignments", i(m([
            y,
            A2(LE, m([
                yE("container-fluid")
            ]), w)
        ]), Ve(A2(aa, function(r) {
            var n = r.a, e = r.b;
            return A2(tV, m([
                yE("d-flex flex-row flex-lg-column flex-xl-row justify-content-between align-items-center text-left px-md-5 px-lg-0")
            ]), m([
                A2(fz, b, m([
                    Xd(n)
                ])),
                A2(fz, m([
                    yE("dashboard-light-green-color pl-3")
                ]), m([
                    Xd(e)
                ]))
            ]));
        }, m([
            i("Total Active Assignments", o),
            i("Total Modules Created", f),
            i("Average Assignments/Module", s)
        ])))), v);
    }), tG = function(r) {
        return {
            $: 3,
            a: r
        };
    }, aG = function(r) {
        return {
            $: 1,
            a: r
        };
    }, uG = A2(az, m([
        JE("63.02"),
        cz("0 0 38.382 63.02")
    ]), m([
        A2(XE, m([
            Pz("Path_347"),
            BE("M2345.956,378.5l-32.726-32.725,5.657-5.657,26.836,26.835,24.646-26.719,5.88,5.424Z"),
            Qz("translate(-340.117 2376.25) rotate(-90)"),
            YE("#fff"),
            eR("0.475")
        ]), b)
    ])), cG = function(r) {
        return A2(mz, "mouseout", zt(r));
    }, oG = F2(function(r, n) {
        return A2(RV, "aria-" + r, n ? "true" : "false");
    }), iG = F3(function(r, n, e) {
        return r + "/" + (A2(Ne, "/", n) + Ml(e));
    }), fG = bn("h6"), sG = bn("img"), lG = OE("polygon"), bG = $n("rel"), dG = function(r) {
        return A2(kE, "src", hn(r));
    }, vG = F4(function(r, n, e, t) {
        var a = A2(di, A2(S$, m([
            r.gn
        ]), b), t.jp), u = 0 > c(e, n) || c(e, n + 4) > 0, o = yE("carouselItemLink position-relative"), i = m([
            FE(A3(iG, r.fk, m([
                "course",
                t.jq
            ]), b)),
            o,
            rG("_blank"),
            bG("noopener")
        ]);
        return A2(LE, m([
            yE("col-3"),
            A2(oG, "hidden", u)
        ]), m([
            A2(LE, m([
                yE("carouselItem")
            ]), m([
                A2(lE, i, m([
                    A2(LE, m([
                        yE("position-relative")
                    ]), m([
                        A2(az, m([
                            aR("playOverlay"),
                            oz("100%"),
                            cz("0 0 1600 900"),
                            Gz("1.1")
                        ]), m([
                            A2(qz, m([
                                Nz("0.25"),
                                YE("#000000"),
                                Jz("0"),
                                Xz("0"),
                                oz("1600"),
                                JE("900")
                            ]), b),
                            A2(lG, m([
                                YE("transparent"),
                                Qz("translate(800.000000, 450.000000) rotate(90.000000) translate(-800.000000, -450.000000) "),
                                MR("800 352 898 548 702 548")
                            ]), b)
                        ]))
                    ])),
                    A2(sG, m([
                        yE("img-fluid"),
                        dG(a)
                    ]), b)
                ])),
                A2(LE, m([
                    yE("belowThumbnail position-relative")
                ]), m([
                    A2(fG, m([
                        yE("mt-2 position-absolute text-truncate mw-100")
                    ]), m([
                        Xd(t.gT)
                    ]))
                ]))
            ]))
        ]));
    }), mG = F2(function(r, n) {
        var e, t = Oz(-100 * n.aS / 4), a = pF(n.fn), u = 0 >= n.aS, o = c(n.aS, Oe(n.fn) - 4) > -1;
        return A4(GP, m([
            Fz(m([
                i("col-12", !a),
                i("d-none", a),
                i("showControls", n.fx),
                i("hideControls", !n.fx)
            ])),
            (e = lx(aG(!0)), A2(mz, "mouseover", zt(e))),
            cG(lx(aG(!1)))
        ]), "Recently Added Courses", i(m([
            A2(LE, m([
                yE("showControls mt-4")
            ]), m([
                A2(LE, m([
                    yE("row no-gutters mobileOverflowScroll")
                ]), m([
                    A2(LE, m([
                        yE("col d-flex controlRow")
                    ]), m([
                        A2(LE, m([
                            yE("flex-shrink-1 d-none d-md-flex")
                        ]), m([
                            A2(LE, m([
                                yE("wrapShuffle")
                            ]), m([
                                A2(CE, m([
                                    yE("sliderArrow previous"),
                                    Fz(m([
                                        i("disabled", u)
                                    ])),
                                    xE(u),
                                    gz(lx(tG(n.aS - 1)))
                                ]), m([
                                    uG
                                ]))
                            ]))
                        ])),
                        A2(LE, m([
                            yE("sliderWindow w-100")
                        ]), m([
                            A2(LE, m([
                                yE("row previewRow no-gutters"),
                                A2(_W, "transform", "translate(" + t + "%, 0)")
                            ]), A2(Be, A2(vG, r, n.aS), n.fn))
                        ])),
                        A2(LE, m([
                            yE("flex-shrink-1 d-none d-md-flex")
                        ]), m([
                            A2(LE, m([
                                yE("wrapShuffle")
                            ]), m([
                                A2(CE, m([
                                    yE("sliderArrow next"),
                                    Fz(m([
                                        i("disabled", o)
                                    ])),
                                    xE(o),
                                    gz(lx(tG(n.aS + 1)))
                                ]), m([
                                    uG
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]), We), b);
    }), gG = F2(function(r, n) {
        return {
            $: 6,
            a: r,
            b: n
        };
    }), pG = function(r) {
        return r;
    }, $G = bn("select"), hG = F4(function(r, n, t, a) {
        var u = function(r) {
            var n = QP(r);
            return n.$ ? A2(di, r, sc(A2(Ze, "T", r))) : JP(n.a);
        }, c = aa(function(r) {
            var n = r.gR;
            return A2(LE, m([
                yE("row")
            ]), m([
                A2(LE, m([
                    yE("col-12 col-xl-4")
                ]), m([
                    A2(SP, m([
                        yE("mb-0 mb-xl-3")
                    ]), m([
                        Xd(r.b7)
                    ]))
                ])),
                A2(LE, m([
                    yE("col-12 col-xl-4")
                ]), m([
                    A2(SP, m([
                        yE("mb-3")
                    ]), m([
                        A2(lE, m([
                            FE(A3(Hl, YP(r.kt), t, a)),
                            rG("_self")
                        ]), m([
                            Xd(r.hF)
                        ]))
                    ]))
                ])),
                A2(LE, m([
                    yE("col-12 col-xl-4")
                ]), m([
                    A2(SP, m([
                        yE("mb-3")
                    ]), m([
                        Xd(u(n))
                    ]))
                ]))
            ]));
        }), o = aa(function(r) {
            var n = r.gR;
            return A2(LE, m([
                yE("row")
            ]), m([
                A2(LE, m([
                    yE("col-12 col-xl-4")
                ]), m([
                    A2(SP, m([
                        yE("mb-0 mb-xl-3")
                    ]), m([
                        Xd(r.b7)
                    ]))
                ])),
                A2(LE, m([
                    yE("col-12 col-xl-4")
                ]), m([
                    A2(SP, m([
                        yE("mb-3")
                    ]), m([
                        Xd(r.gT)
                    ]))
                ])),
                A2(LE, m([
                    yE("col-12 col-xl-4")
                ]), m([
                    A2(SP, m([
                        yE("mb-3")
                    ]), m([
                        Xd(u(n))
                    ]))
                ]))
            ]));
        }), f = n.at.il, s = 1 === f, l = A2(LE, m([
            yE("select-wrapper mr-1")
        ]), m([
            A2($G, m([
                PE(function(r) {
                    return lx({
                        $: 5,
                        a: r
                    });
                })
            ]), m([
                A2(bW, m([
                    gW(s),
                    HV("Assignments")
                ]), m([
                    Xd("Assignments")
                ])),
                A2(bW, m([
                    gW(s),
                    HV("Courses")
                ]), m([
                    Xd("Courses")
                ]))
            ]))
        ])), d = n.at.dz.au, v = n.at.dz.aH, g = A2(BP, 10, v), p = n.at.$7.au, $ = n.at.$7.aH, h = Oe(f ? v : $), w = function() {
            switch(h){
                case 1:
                    return v;
                case 2:
                    switch(d){
                        case 1:
                            return ui(A2(ox, 1, g));
                        case 2:
                            return ui(A2(tx, 1, g));
                        default:
                            return b;
                    }
                default:
                    switch(d){
                        case 1:
                            return ui(A2(ox, 1, g));
                        case 2:
                            return ui(A2(tx, 1, A2(ox, 2, g)));
                        default:
                            return ui(A2(tx, d - 1, A2(ox, d, g)));
                    }
            }
        }(), C = aa(f ? function(r) {
            var n = e(r, d) ? "pageNumber btn btn-link btn-sm activePage" : "pageNumber btn btn-link btn-sm";
            return A2(CE, m([
                gz(lx(A2(gG, f, r))),
                yE(n)
            ]), m([
                Xd(" " + Ie(r))
            ]));
        } : function(r) {
            var n = e(r, p) ? "pageNumber btn btn-link btn-sm activePage" : "pageNumber btn btn-link btn-sm";
            return A2(CE, m([
                gz(lx(A2(gG, f, r))),
                yE(n)
            ]), m([
                Xd(" " + Ie(r))
            ]));
        })(A2(Ue, 1, ou(A3(Jl, 0, 5, h)))), k = A2(BP, 10, $), y = function() {
            switch(h){
                case 1:
                    return $;
                case 2:
                    switch(p){
                        case 1:
                            return ui(A2(ox, 1, k));
                        case 2:
                            return ui(A2(tx, 1, k));
                        default:
                            return b;
                    }
                default:
                    switch(p){
                        case 1:
                            return ui(A2(ox, 1, k));
                        case 2:
                            return ui(A2(tx, 1, A2(ox, 2, k)));
                        default:
                            return ui(A2(tx, p - 1, A2(ox, p, k)));
                    }
            }
        }(), x = 1 === f ? o(w) : c(y), L = function() {
            if (pF($) && pF(v)) return i(m([
                A2(tV, m([
                    yE("align-self-start")
                ]), m([
                    Xd("Completed course and assignment data will be shown here.")
                ]))
            ]), b);
            if (pF($) && !f) return i(m([
                l,
                A2(tV, m([
                    yE("mt-2 align-self-start")
                ]), m([
                    Xd("Completed assignment data will be shown here.")
                ]))
            ]), b);
            if (pF(v) && 1 === f) return i(m([
                l,
                A2(tV, m([
                    yE("mt-2 align-self-start")
                ]), m([
                    Xd("Completed course data will be shown here.")
                ]))
            ]), b);
            if (1 === h) return i(m([
                l
            ]), b);
            if (h > 1) {
                var r = A2(fz, m([
                    yE("d-flex justify-content-between align-items-center py-2")
                ]), A2(ye, A2(fz, b, m([
                    Xd("Page")
                ])), C));
                return i(m([
                    A2(LE, b, m([
                        l
                    ])),
                    A2(LE, b, m([
                        r
                    ]))
                ]), b);
            }
            return i(m([
                l
            ]), b);
        }(), j = L.a, A = L.b;
        return A4(GP, r, "Completions", i(m([
            A2(LE, m([
                yE("container-fluid")
            ]), m([
                A2(LE, m([
                    yE("d-flex flex-column align-items-end mb-2")
                ]), j),
                A2(LE, b, x)
            ]))
        ]), We), A);
    }), wG = function(r) {
        return {
            $: 2,
            a: r
        };
    }, CG = "col-12 col-lg-4", kG = F3(function(r, n, e) {
        return A2(uo, r(n), r(e));
    }), yG = F4(function(r, n, e, t) {
        return r ? A3(kG, n, t, e) : A3(kG, n, e, t);
    }), xG = bn("small"), LG = h, jG = F2(function(r, n) {
        var e = function() {
            switch(n){
                case 0:
                    var e = A2(yG, xx((t = r.bO).x), function(r) {
                        return r.hh;
                    });
                    return A2(aa, function(r) {
                        var n = ou(10 * r.hh) / 10;
                        return i(r.b7, m([
                            Xd(Oz(n)),
                            A2(xG, m([
                                yE("ml-2")
                            ]), m([
                                Xd(" hrs/wk")
                            ]))
                        ]));
                    }, A2(LG, e, t.aH));
                case 1:
                    return e = A2(yG, xx((t = r.bW).x), A2($l, pG, function(r) {
                        return r.gY;
                    })), A2(aa, function(r) {
                        return i(r.b7, m([
                            Xd(r.gY)
                        ]));
                    }, A2(LG, e, t.aH));
                default:
                    var t;
                    return e = A2(yG, xx((t = r.bB).x), function(r) {
                        return r.gS;
                    }), A2(aa, function(r) {
                        return i(r.b7, m([
                            Xd(Ie(r.gS))
                        ]));
                    }, A2(LG, e, t.aH));
            }
        }();
        return A2(aa, function(r) {
            var n = r.a, e = r.b;
            return A2(LE, m([
                yE("d-flex flex-row justify-content-between")
            ]), m([
                A2(SP, b, m([
                    Xd(n)
                ])),
                A2(SP, b, e)
            ]));
        }, A2(ox, 5, e));
    }), AG = F2(function(r, n) {
        var e = r || n ? i(YE(1 !== r || n ? "#fff" : "#00A5E1"), YE("#fff")) : i(YE("#fff"), YE("#00A5E1")), t = e.a, a = e.b;
        return A2(az, m([
            cz("0 0 448 542")
        ]), m([
            A2(XE, m([
                BE("M432.6,343.3L241.5,526.4c-6.4,5.4-12.4,7.6-17.5,7.6s-12-2.2-16.6-6.7l-192-184c-9.6-9.1-9.9-25.2-0.7-33.9c9.1-9.6,24.4-9.9,33.9-0.7L224,476.8l175.4-168c9.5-9.2,24.8-8.9,33.9,0.7C442.5,318.1,442.2,334.2,432.6,343.3z"),
                t
            ]), b),
            A2(XE, m([
                BE("M15.9,197.9L207,14.8c5.5-5.4,11.5-8.5,17.5-8.5s12,2.2,16.6,6.7l191.1,183.1c9.6,9.2,9.9,24.3,0.7,33.9c-9.1,9.6-24.4,9.9-33.9,0.7L224.5,64.4l-175.4,168c-8.9,7.7-24.8,8.9-33.9-0.7C6,222.2,6.3,207,15.9,197.9z"),
                a
            ]), b)
        ]));
    }), MG = function(r) {
        var n;
        return A4(GP, m([
            yE(CG)
        ]), "Downloads", i(A2(ye, A2(LE, m([
            yE("d-flex flex-row justify-content-between align-items-end mb-4")
        ]), m([
            A2(CE, m([
                yE("pl-0 btn btn-link d-flex flex-row"),
                gz(lx(wG(2)))
            ]), m([
                A2(fz, b, m([
                    Xd((n = r.bB.x, n ? "Least Downloads" : "Most Downloads"))
                ])),
                A2(fz, m([
                    yE("ml-2 toggleSort")
                ]), m([
                    A2(AG, r.bB.x, !1)
                ]))
            ])),
            A2(fG, b, m([
                Xd("Last 30 days")
            ]))
        ])), A2(jG, r, 2)), We), b);
    }, FG = $n("enable-background"), HG = A2(az, m([
        Gz("1.1"),
        Pz("Layer_1"),
        Jz("0px"),
        Xz("0px"),
        cz("0 0 20 22"),
        JE("35px"),
        FG("new 0 0 20 22;")
    ]), m([
        A2(XE, m([
            Pz("ballot-check"),
            YE("#fff"),
            BE("M15.1,15.4H9c-0.2,0-0.3,0.2-0.3,0.3v1.4c0,0.2,0.2,0.3,0.3,0.3h6.1c0.2,0,0.3-0.2,0.3-0.3 v-1.4C15.4,15.5,15.2,15.4,15.1,15.4z M5.3,17.7h1.4c0.4,0,0.7-0.3,0.7-0.7v-1.4C7.3,15.3,7,15,6.6,15H5.3c-0.4,0-0.7,0.3-0.7,0.7 v1.4C4.6,17.4,4.9,17.7,5.3,17.7z M5.3,7h1.4C7,7,7.3,6.7,7.3,6.3V4.9c0-0.4-0.3-0.7-0.7-0.7H5.3c-0.4,0-0.7,0.3-0.7,0.7v1.4 C4.6,6.7,4.9,7,5.3,7z M9,6.6h6.1c0.2,0,0.3-0.2,0.3-0.3V4.9c0-0.2-0.2-0.3-0.3-0.3H9c-0.2,0-0.3,0.2-0.3,0.3v1.4 C8.7,6.5,8.8,6.6,9,6.6L9,6.6z M18.1,0.2H1.9c-0.7,0-1.4,0.6-1.4,1.4c0,0,0,0,0,0v18.9c0,0.7,0.6,1.4,1.4,1.4h16.2 c0.7,0,1.4-0.6,1.4-1.4V1.6C19.4,0.8,18.8,0.2,18.1,0.2z M17.4,19.8H2.6V2.2h14.8V19.8z M6.2,12.3c0.1,0.1,0.2,0.1,0.3,0l2.7-2.7 c0.1-0.1,0.1-0.2,0-0.3L8.7,8.7c-0.1-0.1-0.2-0.1-0.3,0l-2,2L5.5,9.9c-0.1-0.1-0.2-0.1-0.3,0l-0.5,0.5c-0.1,0.1-0.1,0.2,0,0.3 L6.2,12.3z M15.1,10h-4.5c-0.1,0.2-0.2,0.4-0.4,0.6L8.7,12h6.3c0.2,0,0.3-0.2,0.3-0.3v-1.4C15.4,10.1,15.2,10,15.1,10L15.1,10z")
        ]), b)
    ])), TG = A2(az, m([
        Gz("1.1"),
        Pz("Group_29"),
        Jz("0px"),
        Xz("0px"),
        cz("0 0 26 19"),
        JE("30px"),
        FG("new 0 0 26 19;")
    ]), m([
        A2(Wz, m([
            Pz("Group_29-2")
        ]), m([
            A2(XE, m([
                Pz("Path_3231"),
                YE("#fff"),
                BE("M21.9,7.3c-0.2-2.4-2.3-4.3-4.7-4.1c-0.2,0-0.4,0-0.6,0.1c-2.4-3-6.8-3.5-9.8-1.1 c-1.3,1-2.2,2.4-2.5,4c-3.3,1.3-4.8,5-3.5,8.3c1,2.4,3.3,4,5.9,4H20c3.2,0,5.7-2.6,5.7-5.7C25.7,10.2,24.2,8.1,21.9,7.3 M20,16.5 H6.6c-2.5,0-4.4-2-4.4-4.5c0-2.2,1.6-4,3.8-4.4v0c0-2.8,2.3-5.1,5.1-5.1c2.1,0,3.9,1.2,4.7,3.2c1.1-0.9,2.7-0.8,3.6,0.3 c0.7,0.8,0.8,2,0.3,2.9c0.1,0,0.2,0,0.3,0c2.1,0,3.8,1.6,3.9,3.8c0,2.1-1.6,3.8-3.8,3.9C20.1,16.5,20,16.5,20,16.5 M10.9,14.9h0.8 c0.2,0,0.4-0.2,0.5-0.5V6.2c0-0.2-0.2-0.4-0.5-0.5h-0.8c-0.2,0-0.4,0.2-0.5,0.5v8.3C10.4,14.7,10.6,14.9,10.9,14.9 M14.3,14.9h0.8 c0.2,0,0.4-0.2,0.5-0.5V7.3c0-0.2-0.2-0.4-0.5-0.5h-0.8c-0.2,0-0.4,0.2-0.5,0.5v7.2C13.9,14.7,14.1,14.9,14.3,14.9 M7.4,14.9h0.8 c0.2,0,0.4-0.2,0.5-0.5V9.6c0-0.2-0.2-0.4-0.5-0.5H7.4c-0.2,0-0.4,0.2-0.5,0.5v4.8C6.9,14.7,7.1,14.9,7.4,14.9 M17.8,14.9h0.8 c0.2,0,0.4-0.2,0.5-0.5v-2.5c0-0.2-0.2-0.4-0.5-0.5h-0.8c-0.2,0-0.4,0.2-0.5,0.5v2.5C17.4,14.7,17.6,14.9,17.8,14.9")
            ]), b)
        ]))
    ])), SG = F3(function(r, n, e) {
        return A4(GP, r, "Labs & Exams", i(m([
            A2(fG, b, m([
                Xd("Last 30 days")
            ])),
            A2(LE, m([
                yE("d-flex flex-row justify-content-around")
            ]), m([
                A2(LE, m([
                    yE("text-center d-flex flex-column")
                ]), m([
                    A2(LE, m([
                        yE("my-4")
                    ]), m([
                        HG
                    ])),
                    A2(bz, m([
                        yE("dashboard-light-blue-color mt-1")
                    ]), m([
                        Xd(Ie(n))
                    ])),
                    A2(SP, m([
                        yE("mt-2")
                    ]), m([
                        Xd("Exams launched")
                    ]))
                ])),
                A2(LE, m([
                    yE("text-center d-flex flex-column")
                ]), m([
                    A2(LE, m([
                        yE("my-4")
                    ]), m([
                        TG
                    ])),
                    A2(bz, m([
                        yE("dashboard-light-blue-color mt-1")
                    ]), m([
                        Xd(Ie(e))
                    ])),
                    A2(SP, m([
                        yE("mt-2")
                    ]), m([
                        Xd("Labs launched")
                    ]))
                ]))
            ]))
        ]), We), b);
    }), EG = F3(function(r, n, e) {
        var t;
        return A4(GP, m([
            yE(CG)
        ]), "Learning Pace", i(A2(ye, A2(LE, m([
            yE("d-flex flex-row justify-content-between align-items-end mb-4")
        ]), m([
            A2(CE, m([
                yE("pl-0 btn btn-link d-flex flex-row"),
                gz(lx(wG(0)))
            ]), m([
                A2(fz, b, m([
                    Xd((t = r.bO.x, t ? "Least Engaged" : "Most Engaged"))
                ])),
                A2(fz, m([
                    yE("ml-2 toggleSort")
                ]), m([
                    A2(AG, r.bO.x, !1)
                ]))
            ])),
            A2(fG, b, m([
                Xd("Last 30 days")
            ]))
        ])), A2(jG, r, 0)), We), m([
            A2(SP, m([
                yE("mb-0")
            ]), m([
                A2(fz, m([
                    yE("mr-2")
                ]), m([
                    Xd("Enable Learning Reminders to improve user engagement")
                ])),
                A2(lE, m([
                    yE("btn btn-sm btn-primary"),
                    FE(A3(Hl, cs, n, e))
                ]), m([
                    Xd("LEARN MORE")
                ]))
            ]))
        ]));
    }), zG = function(r) {
        var n;
        return A4(GP, m([
            yE(CG)
        ]), "Logins", i(A2(ye, A2(LE, m([
            yE("d-flex flex-row justify-content-between align-items-end mb-4")
        ]), m([
            A2(CE, m([
                yE("pl-0 btn btn-link d-flex flex-row"),
                gz(lx(wG(1)))
            ]), m([
                A2(fz, b, m([
                    Xd((n = r.bW.x, n ? "Least Recent" : "Most Recent"))
                ])),
                A2(fz, m([
                    yE("ml-2 toggleSort")
                ]), m([
                    A2(AG, r.bW.x, !1)
                ]))
            ])),
            A2(fG, b, m([
                Xd("Last 30 days")
            ]))
        ])), A2(jG, r, 1)), We), b);
    }, RG = {
        $: 1
    }, VG = {
        $: 15
    }, WG = function(r) {
        return {
            $: 13,
            a: r
        };
    }, PG = {
        $: 9
    }, GG = {
        $: 7
    }, IG = kE("dropzone"), NG = function(r) {
        return A2(NE, "drop", zt(i(r, !0)));
    }, ZG = function(r) {
        return A2(NE, "dragover", zt(i(r, !0)));
    }, DG = {
        $: 14
    }, _G = function(r) {
        return {
            $: 0,
            a: r
        };
    }, OG = function(r) {
        return {
            $: 2,
            a: r
        };
    }, qG = A2(az, m([
        cz("0 0 448 512"),
        Pz("add_white"),
        YE("#fff"),
        oz("18px")
    ]), m([
        A2(XE, m([
            BE("M432 256C432 269.3 421.3 280 408 280h-160v160c0 13.25-10.75 24.01-24 24.01S200 453.3 200 440v-160h-160c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h160v-160c0-13.25 10.75-23.99 24-23.99S248 58.75 248 72v160h160C421.3 232 432 242.8 432 256z"),
            Pz("cancel")
        ]), b)
    ])), KG = $n("draggable"), UG = A2(az, m([
        oz("18px"),
        JE("10px"),
        cz("0 0 18 10"),
        Gz("1.1")
    ]), m([
        A2(qE, m([
            YE("#FFFFFF"),
            rz("2"),
            KE("2"),
            UE("2")
        ]), b),
        A2(qE, m([
            YE("#FFFFFF"),
            rz("2"),
            KE("9"),
            UE("2")
        ]), b),
        A2(qE, m([
            YE("#FFFFFF"),
            rz("2"),
            KE("16"),
            UE("2")
        ]), b),
        A2(qE, m([
            YE("#FFFFFF"),
            rz("2"),
            KE("2"),
            UE("8")
        ]), b),
        A2(qE, m([
            YE("#FFFFFF"),
            rz("2"),
            KE("9"),
            UE("8")
        ]), b),
        A2(qE, m([
            YE("#FFFFFF"),
            rz("2"),
            KE("16"),
            UE("8")
        ]), b)
    ])), BG = A2(az, m([
        cz("0 0 448 512"),
        YE("#fff"),
        oz("18px"),
        Pz("add_white")
    ]), m([
        A2(XE, m([
            BE("M432 256C432 269.3 421.3 280 408 280H40c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h368C421.3 232 432 242.8 432 256z"),
            Pz("cancel")
        ]), b)
    ])), QG = function(r) {
        return A2(mz, "dragend", zt(r));
    }, YG = function(r) {
        var n = r.b, e = r.a;
        switch(e){
            case "transform":
            case "transform-origin":
            case "filter":
                return m([
                    r,
                    i(l("-ms-", e), n),
                    i(l("-webkit-", e), n)
                ]);
            default:
                return m([
                    r
                ]);
        }
    }, JG = T, XG = function(r) {
        return r * Hu / 180;
    }, rI = S, nI = function(r) {
        var n = function(r) {
            return A2(Ne, " ", A2(aa, function(r) {
                var n = r.b;
                return Oz(r.a.kL) + "," + Oz(n.kL);
            }, r));
        };
        switch(r.$){
            case 0:
                var e = r.b;
                return "m " + Oz(r.a.kL) + "," + Oz(e.kL);
            case 1:
                return e = r.b, "M " + Oz(r.a.kL) + "," + Oz(e.kL);
            case 2:
                return e = r.b, "l " + Oz(r.a.kL) + "," + Oz(e.kL);
            case 3:
                return e = r.b, "L " + Oz(r.a.kL) + "," + Oz(e.kL);
            case 4:
                return "h " + Oz(r.a.kL);
            case 5:
                return "H " + Oz(r.a.kL);
            case 6:
                return "v " + Oz(r.a.kL);
            case 7:
                return "V " + Oz(r.a.kL);
            case 8:
                var t = (b = r.a.al).a, a = b.b, u = (s = r.a.co).a, o = s.b, i = (f = r.a.cn).b;
                return "c " + Oz(f.a.kL) + " " + Oz(i.kL) + ", " + Oz(u.kL) + " " + Oz(o.kL) + ", " + Oz(t.kL) + " " + Oz(a.kL);
            case 9:
                var f, s;
                return t = (b = r.a.al).a, a = b.b, u = (s = r.a.co).a, o = s.b, i = (f = r.a.cn).b, "C " + Oz(f.a.kL) + " " + Oz(i.kL) + ", " + Oz(u.kL) + " " + Oz(o.kL) + ", " + Oz(t.kL) + " " + Oz(a.kL);
            case 10:
                return t = (b = r.a.al).a, a = b.b, i = (l = r.a.cm).b, "q " + Oz(l.a.kL) + " " + Oz(i.kL) + ", " + Oz(t.kL) + " " + Oz(a.kL);
            case 11:
                var l, b;
                return t = (b = r.a.al).a, a = b.b, i = (l = r.a.cm).b, "Q " + Oz(l.a.kL) + " " + Oz(i.kL) + ", " + Oz(t.kL) + " " + Oz(a.kL);
            case 12:
                return "t " + n(r.a);
            case 13:
                return "T " + n(r.a);
            case 14:
                return "s " + n(r.a);
            case 15:
                return "S " + n(r.a);
            case 16:
                if (c(g = (m = r.a).cx.kL - m.cZ.kL, 359.999999) > 0) {
                    var d = m.cR.kL * rI(XG(m.cZ.kL)), v = m.cR.kL * JG(XG(m.cZ.kL));
                    return "A " + Oz(m.cR.kL) + "," + Oz(m.cR.kL) + ",0,1,1," + Oz(m.iS.kL - v) + "," + Oz(m.iT.kL - d) + " A " + Oz(m.cR.kL) + "," + Oz(m.cR.kL) + ",0,1,1," + Oz(m.iS.kL + v) + "," + Oz(m.iT.kL + d);
                }
                return "A " + Oz(m.cR.kL) + "," + Oz(m.cR.kL) + " 0 " + (180 > g ? "0" : "1") + " 1 " + Oz(m.iS.kL + m.cR.kL * JG(XG(m.cx.kL))) + "," + Oz(m.iT.kL + m.cR.kL * rI(XG(m.cx.kL)));
            case 17:
                var m, g;
                return c(g = (m = r.a).cx.kL - m.cZ.kL, 359.999999) > 0 ? (d = m.cR.kL * rI(XG(m.cZ.kL)), v = m.cR.kL * JG(XG(m.cZ.kL)), "A " + Oz(m.cR.kL) + "," + Oz(m.cR.kL) + ",0,1,0," + Oz(m.iS.kL - v) + "," + Oz(m.iT.kL - d) + " A " + Oz(m.cR.kL) + "," + Oz(m.cR.kL) + ",0,1,1," + Oz(m.iS.kL + v) + "," + Oz(m.iT.kL + d)) : "A " + Oz(m.cR.kL) + "," + Oz(m.cR.kL) + " 0 " + (180 > m.cZ.kL - m.cx.kL ? "0" : "1") + " 0 " + Oz(m.iS.kL + m.cR.kL * JG(m.cx.kL)) + "," + Oz(m.iT.kL + m.cR.kL * rI(m.cx.kL));
            default:
                return "z";
        }
    }, eI = F2(function(r, n) {
        switch(r.$){
            case 0:
                return r.b;
            case 1:
                var e = r.c, t = r.d, a = r.e;
                return "rgba(" + Ie(ou(r.b.kL)) + "," + Ie(ou(e.kL)) + "," + Ie(ou(t.kL)) + "," + Oz(a.kL) + ")";
            case 2:
                var u = r.a, c = r.c;
                return (r.b ? "inset " : "") + Oz(c.ai.kL) + "px " + Oz(c.aj.kL) + "px " + Oz(c.aa.kL) + "px " + ("text-shadow" === u || "drop-shadow" === u ? "" : Oz(c.eT.kL) + "px ") + "rgba(" + Ie(ou(c.ga.kL)) + ", " + Ie(ou(c.fO.kL)) + ", " + Ie(ou(c.fm.kL)) + ", " + Oz(c.bs.kL) + ")";
            case 3:
            case 7:
                return l(Oz((s = r.b).kL), s.lm);
            case 4:
                var o = r.c;
                return l(Oz((s = r.b).kL), l(s.lm, l(n, l(Oz(o.kL), o.lm))));
            case 5:
                o = r.c;
                var i = r.d;
                return l(Oz((s = r.b).kL), l(s.lm, l(n, l(Oz(o.kL), l(o.lm, l(n, l(Oz(i.kL), i.lm)))))));
            case 6:
                var f = r.b, s = r.c;
                return o = r.d, i = r.e, l(Oz(f.kL), l(f.lm, l(n, l(Oz(s.kL), l(s.lm, l(n, l(Oz(o.kL), l(o.lm, l(n, l(Oz(i.kL), i.lm))))))))));
            case 8:
                return A2(Ne, " ", A2(aa, function(r) {
                    var n = r.b;
                    return Oz(r.a.kL) + "," + Oz(n.kL);
                }, r.a));
            default:
                return A2(Ne, " ", A2(aa, nI, r.a));
        }
    }), tI = $n("rx"), aI = $n("ry"), uI = function(r) {
        if (A2(Yt, "attr:", dc(r))) return Ve(A2(RV, A2(Zt, 5, dc(r)), A2(eI, r, " ")));
        switch(r.$){
            case 8:
                return Ve(MR(A2(eI, r, " ")));
            case 9:
                return Ve(BE(A2(eI, r, " ")));
            case 3:
                switch(r.a){
                    case "x":
                        return Ve(Jz(A2(eI, r, " ")));
                    case "y":
                        return Ve(Xz(A2(eI, r, " ")));
                    case "cx":
                        return Ve(KE(A2(eI, r, " ")));
                    case "cy":
                        return Ve(UE(A2(eI, r, " ")));
                    case "rx":
                        return Ve(tI(A2(eI, r, " ")));
                    case "ry":
                        return Ve(aI(A2(eI, r, " ")));
                    case "r":
                        return Ve(rz(A2(eI, r, " ")));
                    case "offset":
                        return Ve(pR(A2(eI, r, " ")));
                    default:
                        return We;
                }
            case 6:
                return "viewBox" === r.a ? Ve(cz(A2(eI, r, " "))) : We;
            default:
                return We;
        }
    }, cI = function(r) {
        return A2(Yt, "attr:", dc(r)) || function() {
            switch(r.$){
                case 8:
                case 9:
                    return !0;
                case 3:
                    return "cx" === (n = r.a) || "cy" === n || "x" === n || "y" === n || "rx" === n || "ry" === n || "r" === n || "offset" === n;
                case 6:
                    var n;
                    return "viewBox" === r.a;
                default:
                    return !1;
            }
        }();
    }, oI = function(r) {
        var n = A2(Rx, cI, r.iq), e = n.a, t = n.b, a = A3(_e, F2(function(r, n) {
            var e = n.a, t = n.b, a = n.c;
            return function(r) {
                return A2(bc, dc(r), m([
                    "rotate",
                    "rotateX",
                    "rotateY",
                    "rotateZ",
                    "rotate3d",
                    "translate",
                    "translate3d",
                    "scale",
                    "scale3d"
                ]));
            }(r) ? f(e, l(t, m([
                r
            ])), a) : function(r) {
                return A2(bc, dc(r), m([
                    "filter-url",
                    "blur",
                    "brightness",
                    "contrast",
                    "grayscale",
                    "hue-rotate",
                    "invert",
                    "saturate",
                    "sepia",
                    "drop-shadow"
                ]));
            }(r) ? f(e, t, l(a, m([
                r
            ]))) : f(l(e, m([
                r
            ])), t, a);
        }), f(b, b, b), t), u = a.a, c = a.b, o = a.c, s = pF(o) ? b : m([
            i("filter", A2(Ne, " ", A2(aa, function(r) {
                return "filter-url" === dc(r) ? 'url("' + A2(eI, r, ", ") + '")' : dc(r) + "(" + A2(eI, r, ", ") + ")";
            }, o)))
        ]), d = A2(aa, function(r) {
            return i(dc(r), A2(eI, r, " "));
        }, u), v = pF(c) ? b : m([
            i("transform", A2(Ne, " ", A2(aa, function(r) {
                return "rotate3d" === dc(r) ? function(r) {
                    if (5 === r.$) {
                        var n = r.b, e = r.c, t = r.d;
                        return "rotateX(" + Oz(n.kL) + n.lm + ") rotateY(" + Oz(e.kL) + e.lm + ") rotateZ(" + Oz(t.kL) + t.lm + ")";
                    }
                    return "";
                }(r) : dc(r) + "(" + A2(eI, r, ", ") + ")";
            }, c)))
        ]);
        return i(l(v, l(s, d)), e);
    }, iI = function(r) {
        var n = function(r) {
            return i(r.a, r.b);
        }, e = n(r.bv).a, t = A2(ye, yE("widget"), r.gG), a = n(r.bv).b, u = pF(r.dK) ? r.dK : m([
            A2(LE, m([
                yE("widgetFooter")
            ]), r.dK)
        ]), c = function() {
            if (a.$) return A2(LE, m([
                yE("widgetWrapper d-flex flex-column")
            ]), A2(ye, A2(LE, m([
                yE("flex-md-grow-1 widgetBackground")
            ]), A2(ye, A2(VR, m([
                yE("widgetTitle")
            ]), m([
                Xd(r.z)
            ])), e)), u));
            var n = a.a;
            return A2(LE, m([
                yE("widgetWrapper d-flex flex-column flex-lg-row")
            ]), m([
                A2(LE, m([
                    yE("widget-content flex-md-grow-1")
                ]), m([
                    A2(LE, m([
                        yE("widgetWrapper d-flex flex-column")
                    ]), A2(ye, A2(LE, m([
                        yE("flex-md-grow-1 widgetContentBackground")
                    ]), A2(ye, A2(VR, m([
                        yE("widgetTitle")
                    ]), m([
                        Xd(r.z)
                    ])), e)), u))
                ])),
                A2(LE, m([
                    yE("widgetPanel d-flex flex-column justify-content-around pt-lg-5")
                ]), n)
            ]));
        }();
        return A2(LE, t, m([
            A2(LE, m([
                yE("widgetBar")
            ]), b),
            c
        ]));
    }, fI = bn("section"), sI = function(r) {
        var n, e, t, a, u, c, o = r.c.aX ? qG : BG;
        return A2(fI, m([
            yE("row widgetSection mb-4"),
            Fz(m([
                i("collapsed mb-3", r.c.aX)
            ])),
            KG("true"),
            IG("true"),
            (e = r.c.z, n = {
                $: 12,
                a: e
            }, A2(mz, "dragstart", zt(n))),
            QG(DG),
            ZG(WG(_G(r.c.z))),
            NG(VG)
        ]), m([
            A2(LE, m([
                yE("col-12")
            ]), m([
                A2(LE, m([
                    yE("row")
                ]), m([
                    A2(LE, m([
                        yE("col-12")
                    ]), m([
                        A2(LE, m([
                            yE("widgetRow d-flex align-items-center justify-content-between")
                        ]), m([
                            A2(fz, b, m([
                                A2(CE, m([
                                    yE("btn btn-link draggable")
                                ]), m([
                                    UG
                                ])),
                                A2(fz, m([
                                    Fz(m([
                                        i("d-none", !r.c.aX)
                                    ])),
                                    yE("title")
                                ]), m([
                                    Xd(gx(r.c.z))
                                ]))
                            ])),
                            A2(CE, m([
                                yE("btn btn-link"),
                                gz(OG(r.c.z))
                            ]), m([
                                o
                            ]))
                        ]))
                    ]))
                ])),
                A2(LE, l(m([
                    yE("row widgets"),
                    A2(_W, "transform-origin", "top")
                ]), (t = r.c.aW, a = oI(t), u = a.a, c = A2(Af, uI, a.b), l(A2(aa, function(r) {
                    return A2(_W, r.a, r.b);
                }, A2(ci, YG, u)), c))), A2(aa, iI, r.iR))
            ]))
        ]));
    }, lI = F3(function(r, n, e) {
        var t, a = Oe(r.hQ.$9), u = (t = r.hQ.$9, A3(_e, F2(function(r, n) {
            return 1 === r.gh ? n + 1 : n;
        }), 0, t)), c = u / a, o = 2 === n.$ ? A2(LE, m([
            yE("spinner-border spinner-border-sm text-info ml-2 ")
        ]), m([
            A2(fz, m([
                yE("sr-only")
            ]), m([
                Xd("Loading...")
            ]))
        ])) : A2(LE, b, b), f = A2(mc, function(r) {
            return r.c.l;
        }, e), s = A2(Ne, "/", m([
            Ie(u),
            Ie(a)
        ])), l = A2(Ne, " ", m([
            "Onboarding:",
            s,
            "complete"
        ])), d = A2(CE, m([
            yE("btn btn-block btn-outline-secondary mt-4 mt-md-0 ml-md-4 py-2"),
            A2(_W, "max-width", "300px"),
            gz(lx(PG))
        ]), m([
            A2(LE, m([
                yE("text-left pb-2")
            ]), m([
                Xd(l)
            ])),
            A2(LE, m([
                yE("w-100")
            ]), m([
                A2(LE, m([
                    yE("onboardingProgress w-100")
                ]), m([
                    A2(LE, m([
                        yE("onboardingProgress-bar pl-1"),
                        XP("progressbar"),
                        A2(_W, "width", Oz(100 * c) + "%"),
                        A2(VV, "valuenow", Oz(c)),
                        A2(VV, "valuemin", "0"),
                        A2(VV, "valuemax", "100")
                    ]), b)
                ]))
            ]))
        ])), v = Ex(n), g = yE(v ? "on active" : "on"), p = A2(SP, m([
            yE("d-inline mb-2 mb-md-0 font-weight-light text-nowrap learningReminderToggle")
        ]), m([
            Xd("Send Monthly Snapshot Email"),
            A2(CE, m([
                yE("ml-2 toggleBtn sm-font selectAllToggle"),
                Fz(m([
                    i("onState", v)
                ])),
                A2(VV, "label", "Turn on snapshot eamils"),
                A2(oG, "pressed", v),
                gz(lx(GG))
            ]), m([
                A2(fz, m([
                    yE("off default active")
                ]), m([
                    Xd("Off")
                ])),
                A2(fz, m([
                    g
                ]), m([
                    Xd("On")
                ]))
            ])),
            o
        ])), $ = A2(LE, m([
            yE("col-12")
        ]), m([
            A2(LE, m([
                yE("d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3")
            ]), m([
                p,
                d
            ]))
        ]));
        return A2(LE, m([
            yE("row pt-3"),
            EE("dashboard")
        ]), m([
            $,
            A2(LE, m([
                yE("col-12")
            ]), A2(aa, sI, f)),
            A2(LE, m([
                yE("col-12 py-5"),
                IG("true"),
                ZG(WG(RG)),
                NG(VG)
            ]), b)
        ]));
    }), bI = $n("style"), dI = F2(function(r, n) {
        var e = Ie(r) + "%";
        return A2(az, m([
            Gz("1.1"),
            Pz("Layer_1"),
            Jz("0px"),
            Xz("0px"),
            cz("0 0 500 36"),
            bI("max-height: 36px")
        ]), m([
            A2(qz, m([
                Pz("Rectangle_328"),
                YE(n),
                oz(e),
                JE("36px")
            ]), b)
        ]));
    }), vI = function(r) {
        return r.kv;
    }, mI = F2(function(r, n) {
        var e = A2(aa, function(r) {
            return r.iM;
        }, n.iF), t = A2(ox, 5, A2(LG, kG(Ia), e)), a = A2(di, 1e5, sc(t)), u = A2(aa, function(r) {
            return r.kv;
        }, A2(ox, 5, A2(LG, A2(yG, 1, function(r) {
            return r.iM;
        }), n.iF))), c = A2(di, "", A2(AL, 2, u)), o = A2(di, "", A2(AL, 1, u)), f = "col-6 col-xl-4 mt-3 text-right label", s = A2(di, "", A2(AL, 3, u)), d = A2(di, "", A2(AL, 0, u)), v = A2(di, "", A2(AL, 4, u)), g = A2(aa, function(r) {
            return ou(function(r) {
                return function(r) {
                    return 500 * r / a | 0;
                }(r);
            }(r) / 500 * 100);
        }, t), p = A2(di, 10, A2(AL, 4, g)), $ = A2(di, 100, A2(AL, 0, g)), h = A2(di, 20, A2(AL, 3, g)), w = A2(di, 80, A2(AL, 1, g)), C = A2(di, 30, A2(AL, 2, g)), k = "col-6 mt-3", y = A2(LE, b, l(m([
            A2(tV, m([
                yE("font-weight-bold")
            ]), m([
                Xd("Top Categories")
            ])),
            A2(LE, m([
                yE("container")
            ]), m([
                A2(LE, m([
                    yE("row")
                ]), m([
                    A2(LE, m([
                        yE(f)
                    ]), m([
                        Xd(d)
                    ])),
                    A2(LE, m([
                        yE(k)
                    ]), m([
                        A2(dI, $, "#00A5E1")
                    ]))
                ])),
                A2(LE, m([
                    yE("row")
                ]), m([
                    A2(LE, m([
                        yE(f)
                    ]), m([
                        Xd(o)
                    ])),
                    A2(LE, m([
                        yE(k)
                    ]), m([
                        A2(dI, w, "#80D2F0")
                    ]))
                ])),
                A2(LE, m([
                    yE("row")
                ]), m([
                    A2(LE, m([
                        yE(f)
                    ]), m([
                        Xd(c)
                    ])),
                    A2(LE, m([
                        yE(k)
                    ]), m([
                        A2(dI, C, "#00A5E1")
                    ]))
                ])),
                A2(LE, m([
                    yE("row")
                ]), m([
                    A2(LE, m([
                        yE(f)
                    ]), m([
                        Xd(s)
                    ])),
                    A2(LE, m([
                        yE(k)
                    ]), m([
                        A2(dI, h, "#80D2F0")
                    ]))
                ])),
                A2(LE, m([
                    yE("row")
                ]), m([
                    A2(LE, m([
                        yE(f)
                    ]), m([
                        Xd(v)
                    ])),
                    A2(LE, m([
                        yE(k)
                    ]), m([
                        A2(dI, p, "#00A5E1")
                    ]))
                ]))
            ])),
            A2(tV, m([
                yE("mt-5 font-weight-bold mb-4")
            ]), m([
                Xd("Top Courses")
            ]))
        ]), A2(aa, function(r) {
            return A2(SP, b, m([
                Xd(vI(r))
            ]));
        }, n.li)));
        return A4(GP, r, "Top Viewed Content", i(m([
            A2(LE, m([
                yE("container-fluid")
            ]), m([
                A2(fG, b, m([
                    Xd("Last 30 days")
                ])),
                A2(LE, m([
                    yE("d-flex flex-column align-items-end mb-2")
                ]), b),
                y
            ]))
        ]), We), b);
    }), gI = F3(function(r, n, e) {
        var t = Oz(e + 10), a = A2(oT, function(r) {
            return r.b.a;
        }, A3(qe, F2(function(r, n) {
            var e = function(r) {
                return uR(r.iN);
            }(n);
            return i(r, i(e, n.lt));
        }), r, n)), u = F2(function(r, n) {
            return A2(Bz, m([
                Jz(Oz(n)),
                Xz(t),
                YE("#fff"),
                aR("chartAxisTextX")
            ]), m([
                uz(r)
            ]));
        });
        return A2(aa, function(r) {
            var n, e = r.a, t = r.b, a = t.a, c = (n = qt(t.b)).$ ? "00" : Ie(n.a);
            return A2(u, a + " " + c, e);
        }, a);
    }), pI = F9(function(r, n, t, a, u, c, o, i, f) {
        var s = a, l = c, d = Oz(s.a), v = t.$ ? b : e(t.a, n) ? m([
            A5(rR, s.b, u, o, i, f)
        ]) : b;
        return A2(Wz, m([
            Qz("translate(" + d + ")"),
            Pz("hoverSector" + Ie(n))
        ]), A2(ye, A2(qz, m([
            nR(r(n)),
            oz(Oz(l.a)),
            JE(Oz(l.b)),
            YE("#fff"),
            eR("0")
        ]), b), v));
    }), $I = F6(function(r, n, t, a, u, o) {
        var f, s = a, l = u, d = Oe(n), v = d ? l / (d - 1) : l, g = "Hours viewed", p = "transparent", $ = A2(aa, function(r) {
            return r.jT;
        }, n), h = (f = SR($)).$ ? 0 : f.a, w = h ? s / h : 0, C = 10 + 12 * It(Ie(wt(h))), k = -C, y = A2(Be, F2(function(r, n) {
            return i(r * v, s - n * w);
        }), $), x = LR(y), L = A3(qe, F2(function(r, n) {
            return i(r, n);
        }), y, $), j = o ? i(m([
            CR(p)
        ]), 3) : i(b, 5), A = j.a, M = j.b, F = A2(Ne, " ", m([
            Ie(k),
            Ie(-50),
            Oz(l + 2 * C + M),
            Oz(s + 40 + 50)
        ]));
        return A2(az, m([
            oz("100%"),
            cz(F)
        ]), m([
            A2(xR, b, A),
            A2(Wz, m([
                aR("chartlegend")
            ]), A4(kR, M, 50, l, g)),
            A5(TR, y, s, l, o, p),
            A2(Wz, b, m([
                dR(0),
                A2(vR, 0, Oz(h)),
                dR(s),
                A2(vR, s, "0")
            ])),
            A2(Wz, m([
                aR("dateLabels")
            ]), A3(gI, x, n, s)),
            A2(Wz, b, A2(zR, x, s)),
            A2(Wz, b, A2(yR, y, M)),
            A2(Wz, b, A2(Be, F2(function(n, a) {
                var u = a.a, o = a.b, f = d > 28 && 1 > c(n + 1, d) && c(n + 1, d - 8) > -1, l = e(n + 1, d), b = i(v, s);
                return A9(pI, r, n, t, u, o, b, l, f, g);
            }), L))
        ]));
    }), hI = F4(function(r, n, e, t) {
        return A4(GP, m([
            yE("col-12 col-md-8 col-lg-9")
        ]), "Viewing Activity", i(m([
            A2(LE, m([
                yE("mt-1 graph")
            ]), m([
                A6($I, function(r) {
                    return lx({
                        $: 0,
                        a: r
                    });
                }, r, n, 150, 1e3, 0)
            ]))
        ]), We), m([
            A2(SP, m([
                yE("mb-0")
            ]), m([
                A2(fz, m([
                    yE("mr-2")
                ]), m([
                    Xd("Create a Custom Static or Recurring Report to find out more about your users are engaging with content")
                ])),
                A2(lE, m([
                    yE("btn btn-sm btn-primary"),
                    FE(A3(Hl, $s, e, t)),
                    rG("_self")
                ]), m([
                    Xd("CREATE A REPORT")
                ]))
            ]))
        ]));
    }), wI = F2(function(r, n) {
        var e = r.D;
        if (e.$) {
            var t = e.a, a = t.gr, u = A2(lc, function(r) {
                return 16 === r.iI;
            }, r.dL), c = A2(lc, function(r) {
                return 10 === r.iI;
            }, r.dL), o = m([
                yE("col-12 col-xl-6")
            ]), f = c || u ? i(m([
                yE("col-12 col-lg-9 col-xl-10")
            ]), m([
                yE("col-12 col-lg-3 col-xl-2")
            ])) : i(m([
                yE("col-12")
            ]), m([
                yE("d-none")
            ])), s = f.a, l = f.b;
            return A3(lI, n, t.b$, m([
                A2(WP, r.c.bj, m([
                    A5(OP, t.i2, t.lj, t.k$, r.by, r.E),
                    A4(hI, t.kn, r.fg, r.by, r.E)
                ])),
                A2(WP, r.c.a7, m([
                    A3(EG, a, r.by, r.E),
                    zG(a),
                    MG(a)
                ])),
                A2(WP, r.c.aU, m([
                    A4(eG, s, t, r.by, r.E),
                    A3(SG, l, t.jE, t.j8)
                ])),
                A2(WP, r.c.bi, m([
                    A2(mG, r, t.cS)
                ])),
                A2(WP, r.c.aZ, m([
                    A4(hG, o, t, r.by, r.E),
                    A2(mI, o, t)
                ]))
            ]));
        }
        return A3(lI, n, vx(!1), b);
    }), CI = A2(LE, b, m([
        Xd("Loading...")
    ])), kI = {
        $: 27
    }, yI = bn("hr"), xI = function(r) {
        return {
            $: 16,
            a: r
        };
    }, LI = function(r) {
        return {
            $: 17,
            a: r
        };
    }, jI = mV(gV(8)), AI = bn("u"), MI = F2(function(r, n) {
        return A2(LV, A3(CV, m([
            jI,
            $V(m([
                yE("col-3")
            ]))
        ]), "show-report-delete-modal-button-" + n, {
            $: 11,
            a: r
        }), m([
            A2(AI, b, m([
                Xd("Delete")
            ]))
        ]));
    }), FI = function(r) {
        return {
            $: 5,
            a: r
        };
    }, HI = function(r) {
        return {
            $: 1,
            a: r
        };
    }, TI = mV(HI(1)), SI = F2(function(r, n) {
        return A2(LE, m([
            yE("col-3")
        ]), m([
            A2(LV, A3(CV, m([
                TI,
                $V(m([
                    yE("btn-block")
                ]))
            ]), "report-download-button-" + r, FI(i(r, n))), m([
                Xd("Download")
            ]))
        ]));
    }), EI = F2(function(r, n) {
        return A2(LE, m([
            yE("col-3")
        ]), m([
            A2(LV, A3(CV, m([
                jI
            ]), "report-download-link-" + r, FI(i(r, n))), m([
                A2(AI, b, m([
                    Xd("Download")
                ]))
            ]))
        ]));
    }), zI = F3(function(r, n, e) {
        return n.$ ? A2(bc, 0, e) ? A2(fz, m([
            yE("col-3")
        ]), b) : A2(LV, A3(CV, m([
            jI,
            $V(m([
                yE("col-3")
            ]))
        ]), "select-recipients-button-" + r, {
            $: 1,
            a: r
        }), m([
            A2(AI, b, m([
                Xd("Add Recipients")
            ]))
        ])) : A2(fz, m([
            yE("col-3")
        ]), b);
    }), RI = function(r) {
        var n = r;
        return It(n) > 50 ? A2(Ot, 50, n) + "..." : n;
    }, VI = F3(function(r, n, e) {
        var t, a = function() {
            var t = n.kW;
            if (1 === t.$) return A2(fz, m([
                yE("pl-2")
            ]), m([
                Xd(RI(n.kv))
            ]));
            var a = t.a;
            return A2(LV, A3(CV, m([
                jI,
                $V(m([
                    yE("text-left visualize pr-0"),
                    Fz(m([
                        i("active", e)
                    ]))
                ]))
            ]), "visualize-report-button-" + n.g7, xI(f(r, n.g7, a))), m([
                Xd(RI(n.kv))
            ]));
        }();
        return A2(LE, m([
            yE("mt-2")
        ]), m([
            a,
            A2(CE, m([
                yE("btn btn-link pl-0 pt-0"),
                gz((t = n.g7, {
                    $: 2,
                    a: t
                }))
            ]), m([
                SW(m([
                    yE("align-center ml-1")
                ]))
            ]))
        ]));
    }), WI = F3(function(r, n, e) {
        var t, a, u, c, o, s, d = function() {
            var r = e.kW;
            if (r.$) return b;
            var t = r.a, a = function(r) {
                return r.bl ? "false" : "true";
            }(e);
            return m([
                A2(HE, m([
                    gz(xI(f(n, e.g7, t))),
                    yE("toggle-report pb-4 pt-1 toggle pressed-" + a),
                    XP("button"),
                    A2(VV, "pressed", a)
                ]), m([
                    WV
                ]))
            ]);
        }(), v = (t = e.h5, A2(SP, m([
            yE("font-italic col-3 mt-3 text-left")
        ]), m(t.$ ? [
            Xd("Recurring")
        ] : [
            Xd("Static")
        ]))), g = m([
            A2(LE, m([
                yE("row d-flex align-items-center")
            ]), m([
                (u = e.kW, u.$ ? A2(LE, m([
                    yE("col-3")
                ]), b) : A2(MI, e, u.a)),
                v,
                A3(zI, e.g7, e.h5, r.c7),
                (a = e.kW, a.$ ? Xd("") : A2(EI, a.a, e.kv))
            ]))
        ]), p = m([
            A2(LE, m([
                yE("row d-flex align-items-center")
            ]), m([
                (o = e.kW, o.$ ? A2(LE, m([
                    yE("col-3")
                ]), b) : A2(MI, e, o.a)),
                v,
                A3(zI, e.g7, e.h5, r.c7),
                (c = e.kW, c.$ ? Xd("") : A2(SI, c.a, e.kv))
            ]))
        ]), $ = function() {
            var n = i(e.bl, e.b9);
            r: for(; !n.a;)switch(n.b.$){
                case 1:
                    return i(m([
                        A2(LE, m([
                            yE("graphContainer expanded")
                        ]), m([
                            A2(LE, m([
                                yE("col-12 d-flex justify-content-center d-lg-none report-options py-3")
                            ]), g),
                            A2(LE, m([
                                yE("row my-5 py-5")
                            ]), m([
                                A2(LE, m([
                                    yE("col-12 text-center mb-5")
                                ]), m([
                                    IR
                                ])),
                                A2(LE, m([
                                    yE("col-12 text-center")
                                ]), m([
                                    A2(fz, m([
                                        yE("mr-2")
                                    ]), m([
                                        WR("20px")
                                    ])),
                                    A2(fz, b, m([
                                        Xd("This may take a few moments to generate. Please do not refresh your browser.")
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]), !0);
                case 2:
                    var t = n.b.a;
                    return i(m([
                        A2(LE, m([
                            yE("col-12 d-flex justify-content-center d-lg-none report-options py-3")
                        ]), g),
                        A2(LE, m([
                            yE("graphContainer container-custom mt-3 mt-md-5 my-lg-5 expanded")
                        ]), m([
                            A2(LE, m([
                                yE("graph")
                            ]), m([
                                A6(RR, LI, t, r.dV, 150, 1e3, PR(t.iX))
                            ]))
                        ]))
                    ]), !0);
                case 3:
                    return i(m([
                        A2(LE, m([
                            yE("col-12 d-flex justify-content-center d-lg-none report-options py-3")
                        ]), g),
                        A2(LE, m([
                            yE("graphContainer expanded")
                        ]), m([
                            A2(LE, m([
                                yE("row my-5 py-5")
                            ]), m([
                                A2(LE, m([
                                    yE("col-12 text-center")
                                ]), m([
                                    A2(fz, m([
                                        yE("mr-2")
                                    ]), m([
                                        Iz
                                    ])),
                                    A2(fz, b, m([
                                        Xd("An error has occurred while generating this report. Please try refreshing your browser.")
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]), !0);
                default:
                    break r;
            }
            return i(m([
                A2(LE, m([
                    yE("graphContainer")
                ]), m([
                    A2(LE, m([
                        yE("graph")
                    ]), b)
                ]))
            ]), !1);
        }(), h = $.a, w = $.b;
        return A2(LE, m([
            yE("mt-3")
        ]), l(m([
            A2(yI, b, b),
            A2(LE, m([
                yE("row")
            ]), l(m([
                A2(LE, m([
                    yE("col-2 col-sm-1 text-right mt-2")
                ]), d),
                A2(LE, m([
                    yE("col-10 col-sm-11 col-lg-4 col-xl-5 pl-0")
                ]), m([
                    A3(VI, n, e, w)
                ])),
                A2(LE, m([
                    yE("d-none d-lg-block col-lg-7 col-xl-6")
                ]), p)
            ]), 1 === r.by.$ ? m([
                A2(LE, m([
                    yE("col-12 col-lg-2 offset-lg-10 customer-success")
                ]), m([
                    (s = e.g7, A2(LV, A3(CV, m([
                        TI,
                        $V(m([
                            yE("float-right btn-block")
                        ]))
                    ]), "report-run-button-" + s, {
                        $: 6,
                        a: s
                    }), m([
                        Xd("Rerun report")
                    ])))
                ]))
            ]) : b))
        ]), h));
    }), PI = {
        $: 12
    }, GI = bn("h3"), II = lP(GI), NI = mV(HI(6)), ZI = function(r) {
        if (1 === r.$) return A2(LE, b, b);
        var n = r.a, e = n.kW;
        if (1 === e.$) return Xd("cannot currently delete report with no results");
        var t, a = e.a;
        return A2(LE, b, m([
            A2(kP, 0, A3(fP, b, m([
                A2(LV, A3(CV, m([
                    NI
                ]), "hide-report-delete-modal-button-" + a, PI), m([
                    Xd("Cancel")
                ])),
                A2(LV, A3(CV, m([
                    pV
                ]), "confirm-report-delete-button-" + a, (t = n.g7, {
                    $: 14,
                    a: t
                })), m([
                    Xd("Confirm")
                ]))
            ]), A3(oP, b, m([
                A2(SP, b, m([
                    Xd("Once deleted, report '" + RI(n.kv) + "' will no longer be able to be visualized.")
                ]))
            ]), A3(II, b, m([
                Xd("Are You Sure?")
            ]), iP(PI)))))
        ]));
    }, DI = {
        $: 10
    }, _I = function(r) {
        return A2(LE, b, r.cT ? m([
            A2(kP, 0, A3(fP, b, m([
                A2(LV, A3(CV, m([
                    pV
                ]), "hide-report-download-modal-button", DI), m([
                    Xd("Ok")
                ]))
            ]), A3(oP, b, m([
                A2(SP, b, m([
                    Xd("This report may take a few moments to download.")
                ]))
            ]), A3(II, b, m([
                Xd("Report Downloading")
            ]), iP(DI)))))
        ]) : b);
    }, OI = function(r) {
        return {
            $: 20,
            a: r
        };
    }, qI = {
        $: 0
    }, KI = yE("ml-md-2"), UI = A2(LV, A3(CV, m([
        pV,
        $V(m([
            yE("btn-block"),
            KI
        ]))
    ]), "request-a-new-report-button", qI), m([
        Xd("Create New Report")
    ])), BI = F2(function(r, n) {
        return {
            $: 24,
            a: r,
            b: n
        };
    }), QI = A2(az, m([
        cz("0 0 512 512"),
        oz("14px"),
        YE("#00a3e0")
    ]), m([
        A2(XE, m([
            BE("M448 304h-53.5l-48 48H448c8.822 0 16 7.178 16 16V448c0 8.822-7.178 16-16 16H64c-8.822 0-16-7.178-16-16v-80C48 359.2 55.18 352 64 352h101.5l-48-48H64c-35.35 0-64 28.65-64 64V448c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64v-80C512 332.7 483.3 304 448 304zM432 408c0-13.26-10.75-24-24-24S384 394.7 384 408c0 13.25 10.75 24 24 24S432 421.3 432 408zM239 368.1C243.7 373.7 249.8 376 256 376s12.28-2.344 16.97-7.031l136-136c9.375-9.375 9.375-24.56 0-33.94s-24.56-9.375-33.94 0L280 294.1V24C280 10.75 269.3 0 256 0S232 10.75 232 24v270.1L136.1 199c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94L239 368.1z")
        ]), b)
    ])), YI = F2(function(r, n) {
        var e = A2(lc, function(r) {
            return 1 === r.iI;
        }, r.jl), t = r.jW;
        return A2(LE, m([
            yE("col-12")
        ]), m([
            A2(LE, m([
                yE("text-left mb-3")
            ]), m([
                A2(fz, m([
                    yE("d-block d-md-inline-block mr-3")
                ]), m([
                    Xd("Download Activity Reports: ")
                ])),
                A2(fz, m([
                    yE("d-flex flex-wrap d-md-inline-block")
                ]), m([
                    A2(CE, A3(pz, m([
                        yE("btn btn-outline-secondary px-1 px-md-2 mr-3 my-2"),
                        xE(AV(n))
                    ]), "download-viewing-activity-" + t, A2(BI, t, 0)), m([
                        A2(fz, m([
                            yE("mr-1")
                        ]), m([
                            Xd("Viewing")
                        ])),
                        A2(HE, m([
                            A2(VV, "label", "Download icon")
                        ]), m([
                            A2(fz, m([
                                yE("sr-only")
                            ]), m([
                                Xd("Download icon")
                            ])),
                            QI
                        ]))
                    ])),
                    A2(CE, A3(pz, m([
                        yE("btn btn-outline-secondary px-1 px-md-2 mr-3 my-2"),
                        xE(AV(n))
                    ]), "download-assignment-activity-" + t, A2(BI, t, 3)), m([
                        A2(fz, m([
                            yE("mr-1")
                        ]), m([
                            Xd("Assignments")
                        ])),
                        A2(HE, m([
                            A2(VV, "label", "Download icon")
                        ]), m([
                            A2(fz, m([
                                yE("sr-only")
                            ]), m([
                                Xd("Download icon")
                            ])),
                            QI
                        ]))
                    ])),
                    A2(CE, A3(pz, m([
                        yE("btn btn-outline-secondary px-1 px-md-2 mr-3 my-2"),
                        xE(AV(n))
                    ]), "download-labs-activity-" + t, A2(BI, t, 1)), m([
                        A2(fz, m([
                            yE("mr-1")
                        ]), m([
                            Xd("Lab")
                        ])),
                        A2(HE, m([
                            A2(VV, "label", "Download icon")
                        ]), m([
                            A2(fz, m([
                                yE("sr-only")
                            ]), m([
                                Xd("Download icon")
                            ])),
                            QI
                        ]))
                    ])),
                    e ? A2(CE, A3(pz, m([
                        yE("btn btn-outline-secondary px-1 px-md-2 mr-3 my-2"),
                        xE(AV(n))
                    ]), "download-assessments-activity-" + t, A2(BI, t, 4)), m([
                        A2(fz, m([
                            yE("mr-1")
                        ]), m([
                            Xd("Assessments")
                        ])),
                        A2(HE, m([
                            A2(VV, "label", "Download icon")
                        ]), m([
                            A2(fz, m([
                                yE("sr-only")
                            ]), m([
                                Xd("Download icon")
                            ])),
                            QI
                        ]))
                    ])) : A2(fz, b, b),
                    A2(CE, A3(pz, m([
                        yE("btn btn-outline-secondary px-1 px-md-2 mr-3 my-2"),
                        xE(AV(n))
                    ]), "download-login-activity-" + t, A2(BI, t, 2)), m([
                        A2(fz, m([
                            yE("mr-1")
                        ]), m([
                            Xd("Login")
                        ])),
                        A2(HE, m([
                            A2(VV, "label", "Download icon")
                        ]), m([
                            A2(fz, m([
                                yE("sr-only")
                            ]), m([
                                Xd("Download icon")
                            ])),
                            QI
                        ]))
                    ])),
                    A2(CE, A3(pz, m([
                        yE("btn btn-outline-secondary px-1 px-md-2 mr-3 my-2"),
                        xE(AV(n))
                    ]), "download-learning-pace-" + t, A2(BI, t, 5)), m([
                        A2(fz, m([
                            yE("mr-1")
                        ]), m([
                            Xd("Learning Pace")
                        ])),
                        A2(HE, m([
                            A2(VV, "label", "Download icon")
                        ]), m([
                            A2(fz, m([
                                yE("sr-only")
                            ]), m([
                                Xd("Download icon")
                            ])),
                            QI
                        ]))
                    ])),
                    A2(CE, A3(pz, m([
                        yE("btn btn-outline-secondary px-1 px-md-2 mr-3 my-2"),
                        xE(AV(n))
                    ]), "download-completions-" + t, A2(BI, t, 6)), m([
                        A2(fz, m([
                            yE("mr-1")
                        ]), m([
                            Xd("Course Completions")
                        ])),
                        A2(HE, m([
                            A2(VV, "label", "Download icon")
                        ]), m([
                            A2(fz, m([
                                yE("sr-only")
                            ]), m([
                                Xd("Download icon")
                            ])),
                            QI
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), JI = F3(function(r, n, e) {
        return s(e, {
            fs: Ve(A2(LE, A2(ye, yE("popover-body"), r), n))
        });
    }), XI = F2(function(r, n) {
        return zt(n(s(r, {
            bL: !1
        })));
    }), rN = F3(function(r, n, e) {
        return {
            f$: e,
            ef: n,
            f9: r
        };
    }), nN = A2(tu, "offsetWidth", au), eN = A2(xu, function(r) {
        return zt(!!A2(Gt, "popover", r));
    }, gP), tN = F2(function(r, n) {
        return cu(m([
            A2(xu, function(e) {
                return e ? A2(Ov, l(r, m([
                    "nextSibling"
                ])), n) : Us("");
            }, A2(Ov, l(r, m([
                "nextSibling"
            ])), eN)),
            A2(xu, function() {
                return A2(tN, l(r, m([
                    "parentElement"
                ])), n);
            }, A2(Ov, l(r, m([
                "parentElement"
            ])), gP)),
            Us("No popover found")
        ]));
    }), aN = A2(tu, "offsetLeft", au), uN = F2(function(r, n) {
        return cu(m([
            A2(tu, "offsetParent", qv(r)),
            A2(tu, "offsetParent", n)
        ]));
    }), cN = A2(tu, "offsetTop", au), oN = A2(tu, "scrollLeft", au), iN = A2(tu, "scrollTop", au), fN = F2(function(r, n) {
        return A2(xu, function(r) {
            var n = r.a, e = r.b;
            return A2(uN, i(n, e), A2(fN, n, e));
        }, A5(hc, F4(function(e, t, a, u) {
            return i(r + a - e, n + u - t);
        }), oN, iN, aN, cN));
    }), sN = A4(Ui, F3(function(r, n, e) {
        return {
            bI: e,
            be: r.a,
            bm: r.b,
            fh: n
        };
    }), A2(fN, 0, 0), nN, rP), lN = A2(xu, function(r) {
        return zt(!!A2(Gt, "popover-trigger", r));
    }, gP), bN = function(r) {
        return cu(m([
            A2(xu, function(n) {
                return n ? A2(Ov, r, sN) : Us("");
            }, A2(Ov, r, lN)),
            A2(xu, function() {
                return bN(l(r, m([
                    "parentElement"
                ])));
            }, A2(Ov, l(r, m([
                "parentElement"
            ])), gP)),
            Us("No trigger found")
        ]));
    }, dN = A4(Ui, rN, bN(m([
        "target"
    ])), A2(tN, m([
        "target"
    ]), nN), A2(tN, m([
        "target"
    ]), rP)), vN = F2(function(r, n) {
        var e = r, t = e.bL;
        return A2(xu, function(r) {
            return zt(n(t ? s(e, {
                bL: !1
            }) : {
                fD: r,
                bL: !0
            }));
        }, dN);
    }), mN = F2(function(r, n) {
        return m([
            yE("popover-trigger"),
            A2(mz, "mouseenter", A2(vN, r, n)),
            A2(mz, "mouseleave", A2(XI, r, n))
        ]);
    }), gN = F2(function(r, n) {
        var e = n.f9, t = n.ef, a = n.f$;
        switch(r){
            case 3:
                return {
                    bt: We,
                    bu: Ve(a / 2 - 12),
                    be: -t - 10,
                    bm: e.bI / 2 - a / 2
                };
            case 1:
                return {
                    bt: We,
                    bu: Ve(a / 2 - 12),
                    be: e.fh,
                    bm: e.bI / 2 - a / 2
                };
            case 0:
                return {
                    bt: Ve(t / 2 - 12),
                    bu: We,
                    be: e.fh / 2 - t / 2,
                    bm: -a - 10
                };
            default:
                return {
                    bt: Ve(t / 2 - 12),
                    bu: We,
                    be: e.fh / 2 - t / 2,
                    bm: e.bI
                };
        }
    }), pN = function(r) {
        switch(r){
            case 3:
                return i("bs-popover-left", !0);
            case 1:
                return i("bs-popover-right", !0);
            case 0:
                return i("bs-popover-top", !0);
            default:
                return i("bs-popover-bottom", !0);
        }
    }, $N = F2(function(r, n) {
        var e, t = r.bL, a = r.fD, u = n, c = function(r) {
            return Oz(r) + "px";
        }, o = A2(gN, u.bA, a), f = m(t ? [
            A2(_W, "left", c(o.be)),
            A2(_W, "top", c(o.bm)),
            A2(_W, "display", "inline-block"),
            A2(_W, "width", c(a.ef))
        ] : [
            A2(_W, "left", "-5000px"),
            A2(_W, "top", "-5000px")
        ]), s = A2(Af, Vt, m([
            A2(Ba, function(r) {
                return A2(_W, "top", c(r));
            }, o.bu),
            A2(Ba, function(r) {
                return A2(_W, "left", c(r));
            }, o.bt)
        ]));
        return A2(LE, l(m([
            Fz(m([
                i("popover", !0),
                i("fade", !0),
                i("show", t),
                pN(u.bA)
            ])),
            (e = u.bA, A2(RV, "x-placement", function() {
                switch(e){
                    case 3:
                        return "left";
                    case 1:
                        return "right";
                    case 0:
                        return "top";
                    default:
                        return "bottom";
                }
            }()))
        ]), f), A2(Af, Vt, m([
            Ve(A2(LE, A2(ye, yE("arrow"), s), b)),
            A2(Ba, function(r) {
                return r;
            }, u.z),
            A2(Ba, function(r) {
                return r;
            }, u.fs)
        ])));
    }), hN = F2(function(r, n) {
        var e = n.iH;
        return A2(LE, m([
            A2(_W, "position", "relative"),
            A2(_W, "display", "inline-block")
        ]), m([
            e,
            A2($N, r, n)
        ]));
    }), wN = F3(function(r, n, e) {
        var t;
        return A2(hN, r, A3(JI, b, m([
            n
        ]), (t = A2(HE, A2(ye, yE("info-icon icon cursor-help"), A2(mN, r, e)), m([
            A2(fz, m([
                yE("sr-only")
            ]), m([
                Xd("Information popover icon")
            ])),
            WR("20px")
        ])), s({
            fs: We,
            bA: 0,
            z: We,
            iH: t
        }, {
            bA: 2
        }))));
    }), CN = F2(function(r, n) {
        var e = Xd("Reports are the best way to visualize your team\u2019s activity and learning progress. Static reports can be generated using a preset or custom time frame. The chart allows you to see your team\u2019s utilization at a glance over the period of time you select. Have dynamic reports sent directly to your inbox by creating a Recurring report. All reports are available for download as a CSV file.");
        return A3(wN, r, e, n);
    }), kN = F2(function(r, n) {
        var e = function() {
            var e = r.aP;
            if (1 === e.$) return !0;
            var t, a, u = e.a;
            return 2 !== A2(XV, (a = (t = n.jH).c, A3(ub, t.a, Cb(t.b), a)), u);
        }(), t = !(!n.iY || e), a = r.cr;
        return A2(LE, b, m([
            A2(LE, m([
                yE("row")
            ]), m([
                A2(YI, n, a),
                A2(LE, m([
                    yE("col-12 col-md-8 col-lg-9")
                ]), m([
                    A2(tV, m([
                        yE("card-title d-inline-block  mr-2")
                    ]), m([
                        Xd("Saved Reports")
                    ])),
                    A2(CN, r.eG, OI)
                ])),
                t ? A2(LE, m([
                    yE("col-12 col-md-4 col-lg-3")
                ]), m([
                    UI
                ])) : A2(LE, b, b)
            ]))
        ]));
    }), yN = F2(function(r, n) {
        var e = r.V;
        switch(e.$){
            case 1:
                var t = e.a;
                return A2(LE, b, m([
                    A2(kN, r, n),
                    A2(LE, m([
                        yE("row")
                    ]), m([
                        A2(LE, m([
                            yE("col-12 mt-3")
                        ]), m([
                            A2(LE, b, A2(Be, WI(r), t)),
                            ZI(r.bX),
                            _I(r),
                            A2(yI, b, b)
                        ]))
                    ]))
                ]));
            case 0:
                return A2(LE, m([
                    yE("row")
                ]), m([
                    A2(LE, m([
                        yE("col-12")
                    ]), m([
                        Xd("Loading...")
                    ]))
                ]));
            default:
                return A2(LE, m([
                    yE("row")
                ]), m([
                    A2(LE, m([
                        yE("col-12")
                    ]), m([
                        Xd("An error occurred while loading reports for this grant.")
                    ]))
                ]));
        }
    }), xN = "success@acilearning.com", LN = function(r) {
        return {
            $: 5,
            a: r
        };
    }, jN = {
        $: 13
    }, AN = function(r) {
        return {
            $: 8,
            a: r
        };
    }, MN = function(r) {
        return {
            $: 4,
            a: r
        };
    }, FN = function(r) {
        return {
            $: 15,
            a: r
        };
    }, HN = {
        $: 16
    }, TN = {
        $: 6
    }, SN = F2(function(r, n) {
        return {
            $: 12,
            a: r,
            b: n
        };
    }), EN = F2(function(r, n) {
        var e = mi(l(n.jM, n.ka));
        return A3(GT, e, n.iL, r);
    }), zN = F3(function(r, n, t) {
        var a;
        return function(r) {
            if (n.$) {
                var t = n.a;
                return A2(fc, function(r) {
                    return A2(lc, function(n) {
                        return e(n.g7, r.g7);
                    }, t.kj);
                }, r);
            }
            return r;
        }((a = r, A2(fc, EN(t), a)));
    }), RN = function(r) {
        return r.$ ? r.a.kv : "All Users";
    }, VN = F2(function(r, n) {
        var e = Xd("Learning Reminders help staff stay on top of their learning goals. You can enable notifications to remind them to log in and learn at regular intervals. Every 3 days, an email will be sent with a prompt to log in and resume watching.");
        return A3(wN, r, e, n);
    }), WN = {
        $: 17
    }, PN = F2(function(r, n) {
        var e;
        return A2(LE, b, n ? m([
            A2(kP, 0, A3(fP, b, m([
                A2(LV, A3(CV, m([
                    NI
                ]), "hide-lr-modal-button", WN), m([
                    Xd("Cancel")
                ])),
                A2(LV, A3(CV, m([
                    pV
                ]), "confim-lr-button", (e = r, {
                    $: 9,
                    a: e
                })), m([
                    Xd("Confirm")
                ]))
            ]), A3(oP, b, m([
                A2(SP, b, m([
                    Xd("You're about to email the selected users a notification that Learning Reminders have been turned on. They will begin to receive log in reminder emails at the frequency you set.")
                ]))
            ]), A3(II, b, m([
                Xd("Are You Sure?")
            ]), iP(WN)))))
        ]) : b);
    }), GN = function(r) {
        return {
            $: 14,
            a: r
        };
    }, IN = F2(function(r, n) {
        return {
            $: 7,
            a: r,
            b: n
        };
    }), NN = function(r) {
        return Xd(r.jM + " " + r.ka);
    }, ZN = function(r) {
        var n, t = 1 === r.T ? 0 : 1, a = m([
            A2($G, m([
                yE("overflow-y-scroll overflow-hidden cadenceSelect"),
                PE(GN)
            ]), A2(aa, function(n) {
                var t;
                return A2(bW, m([
                    gW(e(n, r.cF)),
                    HV((t = n, Ie(t) + " " + r.g7))
                ]), m([
                    Xd(Ie(n))
                ]));
            }, A2(Ue, 2, 31)))
        ]), u = BL(r.T) ? m([
            A2(LE, m([
                yE("d-flex col-3 col-md-3 col-lg-2 align-items-center")
            ]), a)
        ]) : b;
        return A2(LE, m([
            yE("row border-top py-1 mx-0")
        ]), l(m([
            A2(LE, m([
                yE("col-6 col-md-6 col-lg-4 px-0")
            ]), m([
                A2(fG, m([
                    yE("member-name truncate pt-2")
                ]), m([
                    NN(r)
                ]))
            ])),
            A2(LE, m([
                yE("d-none d-lg-block col-lg-4")
            ]), m([
                A2(fG, m([
                    yE("truncate pt-2")
                ]), m([
                    (n = r.iL, Xd(n))
                ]))
            ])),
            A2(LE, m([
                yE("col-3 col-md-3 col-lg-2 d-flex align-items-center")
            ]), m([
                A2(SP, m([
                    yE("d-inline mb-0 font-weight-light text-nowrap learningReminderToggle")
                ]), m([
                    A2(CE, m([
                        yE("ml-2 toggleBtn sm-font"),
                        Fz(m([
                            i("onState", !r.T)
                        ])),
                        A2(VV, "label", "Turn on learning reminders"),
                        A2(oG, "pressed", !1),
                        gz(A2(IN, t, r.g7))
                    ]), m([
                        A2(fz, m([
                            yE("off"),
                            Fz(m([
                                i("active", 1 === r.T)
                            ]))
                        ]), m([
                            Xd("Off")
                        ])),
                        A2(fz, m([
                            yE("on"),
                            Fz(m([
                                i("active", !r.T)
                            ]))
                        ]), m([
                            Xd("On")
                        ]))
                    ]))
                ]))
            ]))
        ]), u));
    }, DN = function(r) {
        return A2(aa, function(r) {
            var n = {
                $: 1,
                a: r
            };
            return A2(CE, m([
                yE("dropdown-item"),
                gz(MN(n))
            ]), m([
                Xd(RN(n))
            ]));
        }, r);
    }, _N = mc(A2($l, VT, function(r) {
        return r.jM;
    })), ON = function(r) {
        return A2(LE, m([
            yE("row mt-4")
        ]), m([
            A2(LE, m([
                yE("col")
            ]), m([
                A2(tV, b, m([
                    Xd("Loading Message:")
                ])),
                A2(SP, b, m([
                    Xd(r)
                ]))
            ]))
        ]));
    }, qN = F2(function(r, n) {
        return {
            $: 8,
            a: r,
            b: n
        };
    }), KN = {
        $: 19
    }, UN = F3(function(r, n, e) {
        var t = n.$ ? KN : A2(qN, r, n.a);
        return A2(CE, A3(pz, m([
            yE("btn btn-link-underline text-info pt-0 pr-0"),
            xE(AV(e))
        ]), "download-activity-" + r, t), m([
            A2(fz, m([
                yE("text-info text-underline mr-2")
            ]), m([
                Xd("Download Activity")
            ])),
            A2(HE, m([
                A2(VV, "label", "Download icon")
            ]), m([
                A2(fz, m([
                    yE("sr-only")
                ]), m([
                    Xd("Download icon")
                ])),
                QI
            ]))
        ]));
    }), BN = function(r) {
        return A3(_e, Re, 0, r);
    }, QN = function(r) {
        return {
            $: 20,
            a: r
        };
    }, YN = F2(function(r, n) {
        return A2(LE, m([
            yE("mt-3 p-4")
        ]), m([
            A2(LE, m([
                yE("metricTitle text-left")
            ]), m([
                Xd("Viewing Activity")
            ])),
            A2(LE, m([
                yE("graphContainer container-custom mt-3 expanded")
            ]), m([
                A2(LE, m([
                    yE("graph pl-3")
                ]), m([
                    A6($I, QN, r, n, 150, 1e3, 1)
                ]))
            ]))
        ]));
    }), JN = F2(function(r, n) {
        var e, t, a, u;
        return A2(LE, m([
            yE("row mt-2 no-gutters metricsRow")
        ]), m([
            A2(LE, m([
                yE("col-md-10 text-md-center")
            ]), m([
                A2(LE, m([
                    yE("metricsCard")
                ]), m([
                    A2(YN, r.kn, n)
                ]))
            ])),
            A2(LE, m([
                yE("col-md-2 text-md-center")
            ]), m([
                A2(LE, m([
                    yE("metricsCard")
                ]), m([
                    (e = r.kn, t = A2(ox, 4, et(e)), a = BN(A2(aa, function(r) {
                        return r.jT;
                    }, t)) / 4, u = Oz(a) + "hrs", A2(LE, m([
                        yE("mt-3 p-4")
                    ]), m([
                        A2(LE, m([
                            yE("metricTitle")
                        ]), m([
                            Xd("Learning Pace")
                        ])),
                        A2(LE, m([
                            yE("pace mt-3")
                        ]), m([
                            Xd(u)
                        ])),
                        A2(LE, m([
                            yE("font-weight-light hrsLabel")
                        ]), m([
                            Xd("Per week")
                        ])),
                        A2(LE, m([
                            yE("font-weight-light mt-4")
                        ]), m([
                            Xd("Averaged over the last 30 days")
                        ]))
                    ])))
                ]))
            ]))
        ]));
    }), XN = function(r) {
        return A2(Uz, 1, 100 * r);
    }, rZ = function(r) {
        return wt(100 * r);
    }, nZ = A2($l, Ie, rZ), eZ = F3(function(r, n, e) {
        var t = Ie(ou(XN(e.kO))), a = t + "%", u = nZ(e.kO) + "%", c = n, o = "Due: " + e.jA, i = e.kv, f = e.g7, s = bm(A3(EC, r, n, Oo(f)));
        return A2(LE, m([
            yE("mt-4 mt-md-0")
        ]), m([
            A2(LE, b, m([
                A2(lE, m([
                    FE(s),
                    yE("ml-md-2 my-1"),
                    rG("_self"),
                    EE("activity-module-link-" + (c + f))
                ]), m([
                    A2(SP, m([
                        yE("mb-2 text-truncate")
                    ]), m([
                        Xd(i),
                        Xd(" \u2013 "),
                        Xd(u),
                        A2(wE, b, b)
                    ])),
                    A2(SP, m([
                        yE("mt-0 text-truncate")
                    ]), m([
                        A2(xG, b, m([
                            Xd(o)
                        ]))
                    ]))
                ]))
            ])),
            A2(LE, m([
                yE("progress"),
                A2(_W, "width", "100%")
            ]), m([
                A2(LE, m([
                    yE("progress-bar pl-1 font-weight-bold"),
                    XP("progressbar"),
                    A2(_W, "width", a),
                    A2(VV, "valuenow", t),
                    A2(VV, "valuemin", "0"),
                    A2(VV, "valuemax", "100")
                ]), b)
            ]))
        ]));
    }), tZ = F3(function(r, n, e) {
        return A3(sv, r, n, e);
    }), aZ = F2(function(r, n) {
        var t = n.jA, a = A2(di, 0, qt(A2(Gb, 2, t))), u = A2(di, 0, qt(A3(Nt, 5, 7, t))), o = A2(di, 0, qt(A2(Ot, 4, t))), f = r.jA, s = A2(di, 0, qt(A2(Gb, 2, f))), l = A2(di, 0, qt(A3(Nt, 5, 7, f))), b = A2(di, 0, qt(A2(Ot, 4, f))), d = i(0 > c(b, o), e(b, o)), v = d.a, m = d.b, g = i(0 > c(l, u), e(l, u)), p = g.a, $ = g.b, h = i(0 > c(s, a), e(s, a));
        return v || m && p || m && $ && h.a ? 0 : m && $ && h.b ? 1 : 2;
    }), uZ = F4(function(r, n, e, t) {
        var a = A2(fc, function(r) {
            return 100 !== rZ(r.kO);
        }, A2(fc, function(r) {
            var n = A2(di, 0, qt(A2(Ot, 4, r.jA))), e = Cb(A2(di, 1, qt(A3(Nt, 5, 7, r.jA)))), a = A2(di, 0, qt(A2(Gb, 2, r.jA))), u = A3(ub, n, e, a);
            return A3(tZ, A3(Lk, 0, -1, u), u, t);
        }, e)), u = function() {
            if (pF(a)) return m([
                Xd("Assign Learning Modules to your learners to keep them on track."),
                A2(LE, m([
                    yE("mt-3")
                ]), m([
                    A2(lE, m([
                        yE("btn btn-sm btn-primary"),
                        FE(A3(Hl, Df, r, n)),
                        rG("_self")
                    ]), m([
                        Xd("CREATE AN ASSIGNMENT")
                    ]))
                ]))
            ]);
            var e = A2(LG, aZ, a);
            return A2(aa, A2(eZ, r, n), e);
        }();
        return A2(LE, m([
            yE("mt-3 p-4 text-left")
        ]), m([
            A2(LE, m([
                yE("metricTitle mb-2")
            ]), m([
                Xd("Assignments")
            ])),
            A2(LE, b, u)
        ]));
    }), cZ = A2(az, m([
        cz("0 0 512 512"),
        JE("16px"),
        YE("#F4B43A")
    ]), m([
        A2(XE, m([
            BE("M243.8 339.8C232.9 350.7 215.1 350.7 204.2 339.8L140.2 275.8C129.3 264.9 129.3 247.1 140.2 236.2C151.1 225.3 168.9 225.3 179.8 236.2L224 280.4L332.2 172.2C343.1 161.3 360.9 161.3 371.8 172.2C382.7 183.1 382.7 200.9 371.8 211.8L243.8 339.8zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z")
        ]), b)
    ])), oZ = function(r) {
        var n = pF(r.fq), e = pF(r.e7.gD), t = n && !e ? m([
            A2(LE, m([
                yE("pl-2")
            ]), m([
                Xd("Completed courses will be shown here.")
            ]))
        ]) : A2(aa, function(r) {
            return A2(LE, b, m([
                Xd(r)
            ]));
        }, r.fq), a = e && !n ? m([
            A2(LE, m([
                yE("pl-2")
            ]), m([
                Xd("Completed assignments will be shown here.")
            ]))
        ]) : A2(aa, function(r) {
            return A2(LE, b, m([
                Xd(r.hF)
            ]));
        }, r.e7.gD), u = m(e && n ? [
            A2(LE, m([
                yE("pl-2")
            ]), m([
                Xd("Completed assignments and courses will be shown here")
            ]))
        ] : [
            A2(LE, m([
                yE("col-12 col-md-4 text-left")
            ]), m([
                A2(LE, m([
                    yE("completionsTitle")
                ]), m([
                    A2(HE, m([
                        yE("icon pr-2"),
                        A2(VV, "label", "Completions icon")
                    ]), m([
                        cZ
                    ])),
                    Xd("Assignments")
                ])),
                A2(LE, b, a)
            ])),
            A2(LE, m([
                yE("col-12 col-md-6 text-left mt-3 mt-md-0")
            ]), m([
                A2(LE, m([
                    yE("completionsTitle")
                ]), m([
                    A2(HE, m([
                        yE("icon pr-2"),
                        A2(VV, "label", "Completions icon")
                    ]), m([
                        cZ
                    ])),
                    Xd("Courses")
                ])),
                A2(LE, b, t)
            ]))
        ]);
        return A2(LE, m([
            yE("mt-3 p-4 row")
        ]), A2(ye, A2(LE, m([
            yE("metricTitle text-left mb-2 col-12")
        ]), m([
            Xd("Completions")
        ])), u));
    }, iZ = F4(function(r, n, e, t) {
        return A2(LE, m([
            yE("row mt-2 no-gutters metricsRow")
        ]), m([
            A2(LE, m([
                yE("col-md-5 text-md-center")
            ]), m([
                A2(LE, m([
                    yE("metricsCard")
                ]), m([
                    A4(uZ, n, e, r.e7.i5, t)
                ]))
            ])),
            A2(LE, m([
                yE("col-md-7 text-md-center")
            ]), m([
                A2(LE, m([
                    yE("metricsCard")
                ]), m([
                    oZ(r)
                ]))
            ]))
        ]));
    }), fZ = A2(az, m([
        cz("0 0 512 512"),
        JE("20px"),
        YE("#00A3E0")
    ]), m([
        A2(XE, m([
            BE("M188.3 147.1C195.8 142.8 205.1 142.1 212.5 147.5L356.5 235.5C363.6 239.9 368 247.6 368 256C368 264.4 363.6 272.1 356.5 276.5L212.5 364.5C205.1 369 195.8 369.2 188.3 364.9C180.7 360.7 176 352.7 176 344V167.1C176 159.3 180.7 151.3 188.3 147.1V147.1zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z")
        ]), b)
    ])), sZ = F2(function(r, n) {
        var e = r, t = n, a = !e && !t, u = a ? A2(LE, b, b) : A2(LE, m([
            yE("mt-2 font-weight-light labelText")
        ]), m([
            A2(fz, b, m([
                Xd("Viewed Completely /")
            ])),
            A2(fz, b, m([
                Xd(" Total Views")
            ]))
        ])), c = a ? "No Activity" : Ie(t) + " / " + Ie(e);
        return A2(LE, m([
            yE("my-3 mx-3 mx-md-0 pt-md-4")
        ]), m([
            A2(HE, m([
                yE("icon"),
                A2(VV, "label", "Episodes Viewed icon")
            ]), m([
                fZ
            ])),
            A2(fz, m([
                yE("ml-2 ml-md-1 ml-lg-2 metricTitle pb-3")
            ]), m([
                Xd("Episodes Viewed")
            ])),
            A2(fz, m([
                yE("d-md-none metricTitle mr-2")
            ]), m([
                Xd(": ")
            ])),
            A2(LE, m([
                yE("mt-3 font-weight-bold metricText")
            ]), m([
                A2(fz, b, m([
                    Xd(c)
                ]))
            ])),
            u
        ]));
    }), lZ = A2(az, m([
        cz("0 0 512 512"),
        YE("#6CC24A"),
        JE("20px")
    ]), m([
        A2(XE, m([
            BE("M512 128v256c0 53.02-42.98 96-96 96h-72C330.7 480 320 469.3 320 456c0-13.26 10.75-24 24-24H416c26.4 0 48-21.6 48-48V128c0-26.4-21.6-48-48-48h-72C330.7 80 320 69.25 320 56C320 42.74 330.7 32 344 32H416C469 32 512 74.98 512 128zM345.5 239.6l-128-136C208.4 93.88 193.2 93.44 183.6 102.5C173.9 111.6 173.4 126.8 182.5 136.4L272.4 232H24C10.75 232 0 242.8 0 256s10.75 24 24 24h248.4l-89.92 95.56c-9.094 9.656-8.625 24.84 1.031 33.91C188.2 413.8 194.1 416 200 416c6.375 0 12.75-2.531 17.47-7.562l128-136C354.2 263.2 354.2 248.8 345.5 239.6z")
        ]), b)
    ])), bZ = F3(function(r, n, e) {
        return A2(LE, m([
            yE("my-3 mx-3 mx-md-0 pt-md-4")
        ]), m([
            A2(HE, m([
                yE("icon"),
                A2(VV, "label", n + " icon")
            ]), m([
                r
            ])),
            A2(fz, m([
                yE("ml-2 ml-md-1 ml-lg-2 metricTitle pb-3")
            ]), m([
                Xd(n)
            ])),
            A2(fz, m([
                yE("d-md-none metricTitle mr-2")
            ]), m([
                Xd(": ")
            ])),
            A2(LE, m([
                yE("mt-4 font-weight-bold metricText")
            ]), m([
                Xd(e)
            ]))
        ]));
    }), dZ = F3(function(r, n, e) {
        var t = A2(LE, m([
            yE("metricTitle mb-2")
        ]), m([
            Xd("Teams")
        ]));
        if (pF(e)) {
            var a = bm(A3(EC, r, n, Jo));
            return A2(LE, m([
                yE("my-3 mx-3 mx-md-0 pt-md-3")
            ]), m([
                t,
                A2(LE, m([
                    yE("font-weight-light")
                ]), m([
                    Xd("This User is not currently on any teams.")
                ])),
                A2(wE, m([
                    yE("d-none d-md-inline-block")
                ]), b),
                A2(lE, m([
                    yE("mt-3 font-weight-bold metricText"),
                    FE(a),
                    rG("_self")
                ]), m([
                    Xd("Add User to Team")
                ]))
            ]));
        }
        var u = A2(aa, function(e) {
            var t = bm(A3(EC, r, n, Qo(e.iw))), a = fm(e.iw);
            return A2(lE, m([
                FE(t),
                rG("_self"),
                EE("activity-team-link-" + a)
            ]), m([
                Xd(e.lh)
            ]));
        }, e);
        return A2(LE, m([
            yE("my-3 mx-3 mx-md-0 pt-md-3")
        ]), A2(ye, t, u));
    }), vZ = A2(az, m([
        cz("0 0 512 512"),
        JE("20px"),
        YE("#fff")
    ]), m([
        A2(XE, m([
            BE("M232 120C232 106.7 242.7 96 256 96C269.3 96 280 106.7 280 120V243.2L365.3 300C376.3 307.4 379.3 322.3 371.1 333.3C364.6 344.3 349.7 347.3 338.7 339.1L242.7 275.1C236 271.5 232 264 232 255.1L232 120zM256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256z")
        ]), b)
    ])), mZ = F3(function(r, n, e) {
        var t, a, u, c, o, i, f;
        return A2(LE, m([
            yE("row mt-2 no-gutters metricsRow")
        ]), m([
            A2(LE, m([
                yE("col-md-3 text-md-center")
            ]), m([
                A2(LE, m([
                    yE("metricsCard")
                ]), m([
                    (i = r.hC, f = 1 === i.$ ? "No Activity" : Sk(i.a), A3(bZ, lZ, "Last Login", f))
                ]))
            ])),
            A2(LE, m([
                yE("col-md-3 text-md-center")
            ]), m([
                A2(LE, m([
                    yE("metricsCard")
                ]), m([
                    (t = r.hD, a = t / 3600 | 0, u = (t - 3600 * a) / 60 | 0, c = t - 3600 * a - 60 * u, o = A2(Ne, ":", m([
                        A3(zb, 2, "0", Ie(a)),
                        A3(zb, 2, "0", Ie(u)),
                        A3(zb, 2, "0", Ie(c))
                    ])), A3(bZ, vZ, "Total Viewing Time", o))
                ]))
            ])),
            A2(LE, m([
                yE("col-md-3 text-md-center")
            ]), m([
                A2(LE, m([
                    yE("metricsCard")
                ]), m([
                    A2(sZ, r.hA, r.hB)
                ]))
            ])),
            A2(LE, m([
                yE("col-md-3 text-md-center")
            ]), m([
                A2(LE, m([
                    yE("metricsCard")
                ]), m([
                    A3(dZ, n, e, r.cI)
                ]))
            ]))
        ]));
    }), gZ = function(r) {
        return {
            $: 45,
            a: r
        };
    }, pZ = function(r) {
        return {
            $: 41,
            a: r
        };
    }, $Z = function(r) {
        return {
            $: 42,
            a: r
        };
    }, hZ = function(r) {
        return {
            $: 43,
            a: r
        };
    }, wZ = {
        $: 39
    }, CZ = {
        $: 46
    }, kZ = function(r) {
        return {
            $: 44,
            a: r
        };
    }, yZ = F4(function(r, n, e, t) {
        return A2(LE, m([
            yE("form-check form-check-inline")
        ]), m([
            A2(SE, m([
                yE("form-check-label")
            ]), m([
                A2(TE, A3(pz, m([
                    yE("form-check-input"),
                    sz("radio"),
                    jP(n)
                ]), t, r), b),
                Xd(e)
            ]))
        ]));
    }), xZ = F2(function(r, n) {
        return A2(LE, m([
            yE("form-group col-12 col-lg-4 pl-lg-4")
        ]), m([
            A4(yZ, kZ(0), !r, "Assign user a subscription", "assign-sub-" + n),
            A4(yZ, kZ(1), 1 === r, "Give user ProPortal(admin)", "assign-admin-" + n),
            A4(yZ, kZ(2), 2 === r, "Assign user a subscription and ProPortal(admin)", "assign-sub-and-admin-" + n)
        ]));
    }), LZ = function(r) {
        return Ie(r);
    }, jZ = F4(function(r, n, e, t) {
        return A2(TE, A3(GE, m([
            yE("form-control"),
            _E(r),
            HV(n),
            Lv(!0)
        ]), e, t), b);
    }), AZ = A2(di, bi, A2(li, {
        jf: !0,
        ku: !1
    }, "^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$")), MZ = F2(function(r, n) {
        return function(e) {
            var t = r(e);
            return function(r) {
                return A2(si, AZ, r);
            }(t) ? b : m([
                n(t)
            ]);
        };
    }), FZ = function(r) {
        var n = dE(m([
            A2(mE, function(r) {
                return r.jM;
            }, 0),
            A2(mE, function(r) {
                return r.ka;
            }, 1),
            A2(MZ, function(r) {
                return r.jC;
            }, Es(2))
        ])), e = A2(hE, n, r);
        return e.$ ? sc(e.a) : We;
    }, HZ = function(r) {
        return {
            $: 5,
            a: r
        };
    }, TZ = {
        $: 0
    }, SZ = {
        $: 1
    }, EZ = "data-dropdown-id", zZ = F2(function(r, n) {
        var t = A2(Ov, m([
            "relatedTarget",
            "attributes",
            EZ,
            "value"
        ]), wc), a = A2(St, di(SZ), A2(St, Ba(function(r) {
            return e(r, n.jW) ? TZ : SZ;
        }), jc(t)));
        return A2(mz, "blur", a);
    }), RZ = {
        $: 4
    }, VZ = A2(tu, "keyCode", uu), WZ = function(r) {
        switch(r){
            case 13:
                return 3;
            case 27:
                return 4;
            case 32:
                return 5;
            case 38:
                return 2;
            case 40:
                return 1;
            default:
                return 0;
        }
    }, PZ = function(r) {
        return A2(mz, "keyup", A2(xu, function(n) {
            switch(WZ(n)){
                case 3:
                case 5:
                    return zt(HZ(r));
                case 4:
                    return zt(RZ);
                default:
                    return Us("not ENTER");
            }
        }, VZ));
    }, GZ = F2(function(r, n) {
        return A2(RV, EZ, n.jW);
    }), IZ = F4(function(r, n, t, a) {
        var u = m([
            i("cursor", "pointer")
        ]), c = t.$ ? i("", b) : e(t.a, a) ? i(r.k0, r.k1) : i("", b), o = r.j6 + " " + c.a, f = ui(m([
            u,
            c.b,
            r.j7
        ]));
        return A2(LE, l(m([
            yE(o),
            A2(zZ, r, n),
            gz(HZ(a)),
            PZ(a),
            A2(GZ, r, n),
            pW(-1)
        ]), A2(aa, function(r) {
            return A2(_W, r.a, r.b);
        }, f)), m([
            Xd(r.iz(a))
        ]));
    }), NZ = F4(function(r, n, e, t) {
        var a = A2(ai, r.kl, m([
            i("position", "absolute"),
            i("width", "100%")
        ])), u = A2(aa, A3(IZ, r, n, t), e);
        return A2(LE, A2(ye, yE(r.kk), A2(aa, function(r) {
            return A2(_W, r.a, r.b);
        }, a)), u);
    }), ZZ = {
        $: 3
    }, DZ = function(r) {
        return A2(az, m([
            aR(r.i0),
            oz("16"),
            JE("16"),
            cz("0 0 16 16")
        ]), m([
            A2(Wz, m([
                Qz("translate(3, 6)")
            ]), m([
                A2(lG, m([
                    MR("4.5,5 9,0 0,0")
                ]), b)
            ]))
        ]));
    }, _Z = F2(function(r) {
        var n = A2(ai, r.i$, m([
            i("margin", "0 0.25rem 0 0"),
            i("line-height", "0rem")
        ]));
        return A2(fz, A2(ye, yE("elm-dropdown-arrow " + r.i_), A2(aa, function(r) {
            return A2(_W, r.a, r.b);
        }, n)), m([
            DZ(r)
        ]));
    }), OZ = {
        $: 2
    }, qZ = function(r) {
        return A2(az, m([
            aR(r.jj),
            oz("16"),
            JE("16"),
            cz("0 0 16 16")
        ]), m([
            A2(Wz, m([
                Qz("translate(3, 3)")
            ]), m([
                A2(XE, m([
                    BE("M5,-2.5575245e-15 C3.66990575,-0.0132303807 2.39043461,0.509304222 1.44986941,1.44986941 C0.509304222,2.39043461 -0.0132303807,3.66990575 1.22125617e-14,5 C-0.0132303807,6.33009425 0.509304222,7.60956539 1.44986941,8.55013059 C2.39043461,9.49069578 3.66990575,10.0132304 5,10 C6.33009425,10.0132304 7.60956539,9.49069578 8.55013059,8.55013059 C9.49069578,7.60956539 10.0132304,6.33009425 10,5 C10.0132304,3.66990575 9.49069578,2.39043461 8.55013059,1.44986941 C7.60956539,0.509304222 6.33009425,-0.0132303807 5,-2.5575245e-15 Z M7,6.2 C7.20014558,6.42911206 7.20014558,6.77088794 7,7 C6.77088794,7.20014558 6.42911206,7.20014558 6.2,7 L5,5.8 L3.7,7 C3.60882286,7.09587507 3.48230759,7.15015018 3.35,7.15015018 C3.21769241,7.15015018 3.09117714,7.09587507 3,7 C2.90412493,6.90882286 2.84984982,6.78230759 2.84984982,6.65 C2.84984982,6.51769241 2.90412493,6.39117714 3,6.3 L4.2,5 L3,3.8 C2.79985442,3.57088794 2.79985442,3.22911206 3,3 C3.22776052,2.79628479 3.57223948,2.79628479 3.8,3 L5,4.2 L6.3,3 C6.39117714,2.90412493 6.51769241,2.84984982 6.65,2.84984982 C6.78230759,2.84984982 6.90882286,2.90412493 7,3 C7.09587507,3.09117714 7.15015018,3.21769241 7.15015018,3.35 C7.15015018,3.48230759 7.09587507,3.60882286 7,3.7 L5.8,5 L7,6.2 Z")
                ]), b)
            ]))
        ]));
    }, KZ = F3(function(r, n, e) {
        var t, a = A2(ai, r.ji, m([
            i("line-height", "0rem")
        ])), u = "elm-dropdown-clear " + r.jh, c = function(r) {
            return i(r, !0);
        };
        return r.jO ? 1 === e.$ ? Xd("") : A2(fz, l(m([
            yE(u),
            (t = OZ, A2(VE, "click", A2(St, c, zt(t))))
        ]), A2(aa, function(r) {
            return A2(_W, r.a, r.b);
        }, a)), m([
            qZ(r)
        ])) : Xd("");
    }), UZ = A2(mz, "keyup", A2(xu, function(r) {
        switch(WZ(r)){
            case 3:
            case 5:
            case 1:
                return zt(ZZ);
            default:
                return Us("Invalid");
        }
    }, VZ)), BZ = F3(function(r, n, e) {
        var t = 1 === e.$ ? r.kP : r.iz(e.a), a = 1 === e.$ ? i(r.kQ, r.kR) : i("", b), u = a.b, c = a.a, o = A2(ai, m([
            i("flex-grow", "1"),
            i("text-overflow", "ellipsis"),
            i("overflow", "hidden"),
            i("white-space", "nowrap")
        ]), u);
        return A2(fz, A2(ye, yE(c), A2(aa, function(r) {
            return A2(_W, r.a, r.b);
        }, o)), m([
            Xd(t)
        ]));
    }), QZ = F4(function(r, n, e, t) {
        var a = A2(ai, r.ll, m([
            i("display", "flex"),
            i("align-items", "center"),
            i("cursor", "pointer")
        ]));
        return A2(LE, l(m([
            yE(r.lk),
            A2(zZ, r, n),
            gz(ZZ),
            UZ,
            pW(0),
            A2(GZ, r, n)
        ]), A2(aa, function(r) {
            return A2(_W, r.a, r.b);
        }, a)), m([
            A3(BZ, r, n, t),
            A3(KZ, r, n, t),
            A2(_Z, r, n)
        ]));
    }), YZ = F4(function(r, n, e, t) {
        var a = n.j5 ? A2(LE, m([
            A2(_W, "position", "relative")
        ]), m([
            A4(NZ, r, n, e, t)
        ])) : A2(fz, b, b);
        return A2(LE, m([
            EE(n.jW)
        ]), m([
            A4(QZ, r, n, e, t),
            a
        ]));
    }), JZ = F4(function(r, n, e, t) {
        return A2(iE, Vt, A4(YZ, r, n, e, t));
    }), XZ = F3(function(r, n, e) {
        var t, a = 1 === (t = r.eY).$ ? Me(t.a) : b, u = r.dX, c = function() {
            if (u) {
                var t = pF(a) ? i("form-row", "form-group col-12") : i("form-row has-teams", "form-group col-12 col-md-6"), c = r.$7;
                return A2(LE, m([
                    yE("col-12")
                ]), m([
                    A2(ME, A3(DE, b, "assign-user-" + n.jW, (o = FZ(c), {
                        $: 10,
                        a: o
                    })), m([
                        A2(LE, m([
                            yE(t.a)
                        ]), m([
                            A2(LE, m([
                                yE("col-12 col-lg-8")
                            ]), m([
                                A2(LE, m([
                                    yE("row")
                                ]), m([
                                    A2(LE, m([
                                        yE("form-group col-12 col-md-6")
                                    ]), m([
                                        A4(jZ, "First Name", c.jM, "assign-users-first-name-" + n.jW, A2($l, $Z, Vt))
                                    ])),
                                    A2(LE, m([
                                        yE("form-group col-12 col-md-6")
                                    ]), m([
                                        A4(jZ, "Last Name", c.ka, "assign-users-last-name-" + n.jW, A2($l, hZ, Vt))
                                    ])),
                                    A2(LE, m([
                                        yE(t.b)
                                    ]), m([
                                        A4(jZ, "Email", c.jC, "assign-users-email-" + n.jW, A2($l, pZ, Vt))
                                    ])),
                                    A2(LE, m([
                                        yE("form-group teams-dropdown col-12 col-md-6")
                                    ]), m([
                                        A2(LE, b, m([
                                            A2(iE, gZ, A4(JZ, CM, r.c0, a, r.cY))
                                        ]))
                                    ]))
                                ]))
                            ])),
                            A2(xZ, c.i4, n.jW),
                            A2(LE, m([
                                yE("col-12")
                            ]), m([
                                A2(LE, m([
                                    yE("row")
                                ]), m([
                                    A2(LE, m([
                                        yE("form-group col-12 col-lg-2 offset-lg-10")
                                    ]), m([
                                        A2(CE, m([
                                            yE("btn btn-block btn-primary mb-4"),
                                            sz("submit")
                                        ]), m([
                                            Xd("Invite")
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ]));
            }
            var o, f, s = A2(bc, 0, e) ? A2(CE, m([
                yE("btn btn-sm btn-primary mb-4"),
                EE("learning-reminders-btn"),
                gz(CZ)
            ]), m([
                Xd("Manage Learning Reminders")
            ])) : A2(lE, m([
                yE("btn btn-learning-reminders btn-block btn-primary mb-4"),
                EE("learning-reminders-btn"),
                FE(A3(Hl, cs, r.by, n.jW)),
                rG("_self")
            ]), m([
                Xd("Manage Learning Reminders")
            ]));
            return A2(LE, m([
                yE("col-12")
            ]), m([
                A2(LE, m([
                    yE("row d-md-flex align-items-md-center")
                ]), m([
                    A2(LE, m([
                        yE("col-12 col-md-3 col-lg-6 pb-4 pb-md-0")
                    ]), m([
                        Xd("Assigned Seats: " + (f = n.i1, Ie(f) + " / " + LZ(n.jN)))
                    ])),
                    A2(LE, m([
                        yE("col-12 col-md-6 col-lg-4")
                    ]), m([
                        s
                    ])),
                    A2(LE, m([
                        yE("col-12 col-md-3 col-lg-2")
                    ]), m([
                        A2(CE, m([
                            yE("btn btn-block btn-primary mb-4"),
                            EE("show-invite-form-btn"),
                            gz(wZ)
                        ]), m([
                            Xd("Invite")
                        ]))
                    ]))
                ]))
            ]));
        }();
        return A2(LE, m([
            yE("row")
        ]), m([
            c
        ]));
    }), rD = function(r) {
        return {
            $: 23,
            a: r
        };
    }, nD = function(r) {
        return {
            $: 24,
            a: r
        };
    }, eD = function(r) {
        return A2(kE, "autocomplete", r ? "on" : "off");
    }, tD = m([
        0,
        1,
        2,
        3,
        4
    ]), aD = F2(function(r, n) {
        var e = mi(l(n.jM, n.ka));
        return A3(GT, e, n.iL, r);
    }), uD = function(r) {
        return 1 === r.eK;
    }, cD = function(r) {
        return 1 === r.gh;
    }, oD = function(r) {
        return !r.eK;
    }, iD = function(r) {
        var n = r.f;
        switch(n.$){
            case 1:
                var e = n.a;
                return kA(A2(fc, aD(A2(di, "", r.c1)), A2(fc, function(r) {
                    if (r.$) return wF;
                    switch(r.a){
                        case 0:
                            return wF;
                        case 1:
                            return cD;
                        case 2:
                            return oD;
                        case 3:
                            return uD;
                        default:
                            return Es(!0);
                    }
                }(r.a_), e)));
            case 0:
                return Bc;
            default:
                return yA;
        }
    }, fD = function(r) {
        switch(iD(r).$){
            case 1:
                var n = A4(JZ, QA, r.g2, tD, r.a_);
                return A2(LE, m([
                    yE("form-row")
                ]), m([
                    A2(LE, m([
                        yE("mb-1 col-12 col-sm-4 offset-sm-8 col-md-3 offset-md-9 order-2 order-sm-1")
                    ]), m([
                        Xd("Filter by status")
                    ])),
                    A2(LE, m([
                        yE("mb-2 col-12 col-sm-8 col-md-9 order-1 order-sm-2")
                    ]), m([
                        A2(TE, m([
                            yE("form-control"),
                            EE("filter-users-in-user-tab"),
                            sz("text"),
                            _E("Filter by name or email"),
                            kW("filter_users_name_email"),
                            eD(!1),
                            A2(VV, "label", "Filter by name or email"),
                            PE(nD)
                        ]), b)
                    ])),
                    A2(LE, m([
                        yE("mb-2 col-12 col-sm-4 col-md-3 order-3")
                    ]), m([
                        A2(iE, rD, n)
                    ]))
                ]));
            case 0:
                return A2(LE, b, m([
                    Xd("Loading")
                ]));
            default:
                return A2(LE, b, b);
        }
    }, sD = yE("mr-2"), lD = A2(fz, m([
        yE("icon"),
        A2(VV, "hidden", "true"),
        sD
    ]), m([
        Iz
    ])), bD = yE("mb-2"), dD = function(r) {
        return Xd(r.jM + " " + r.ka);
    }, vD = A2(az, m([
        oz("25px"),
        JE("25px"),
        cz("0 0 25 25"),
        Gz("1.1")
    ]), m([
        A2(Wz, m([
            Pz("success-icon")
        ]), m([
            A2(XE, m([
                BE("M24.435,12.782 C24.435,19.53 18.965,25 12.218,25 C5.47,25 0,19.53 0,12.782 C0,6.035 5.47,0.565 12.218,0.565 C18.965,0.565 24.435,6.035 24.435,12.782"),
                Pz("dot"),
                YE("#E37B44")
            ]), b),
            A2(XE, m([
                BE("M8.41,21.261 C8.885,21.804 10.946,21.137 11.283,20.6 C14.365,15.702 17.447,10.805 20.529,5.907 C20.666,5.689 18.118,5.755 17.681,6.451 C14.598,11.348 11.0201527,17.0187322 9.73819247,19.1045366 C7.95356889,16.7879528 7.47833807,16.2231001 5.53,13.88 C4.98946005,13.2299387 2.504,14.511 2.632,14.657 C4.558,16.858 6.484,19.059 8.41,21.261 Z"),
                Pz("check"),
                YE("#FFFFFF")
            ]), b)
        ]))
    ])), mD = A2(fz, m([
        yE("icon"),
        A2(VV, "hidden", "true"),
        sD
    ]), m([
        vD
    ])), gD = function(r) {
        if (r.$) return Xd("");
        var n = r.a, e = function() {
            switch(n.$){
                case 0:
                    return n.a.$ ? (r = n.a.a, i(lD, m([
                        Xd("An error occurred while attempting to make "),
                        dD(r),
                        Xd(" an admin")
                    ]))) : i(mD, m([
                        dD(r = n.a.a),
                        Xd(" has been made an admin")
                    ]));
                case 1:
                    return n.a.$ ? (r = n.a.a, i(lD, m([
                        Xd("An error occurred while attempting to remove "),
                        dD(r),
                        Xd(" as a seat admin")
                    ]))) : i(mD, m([
                        dD(r = n.a.a),
                        Xd(" has been removed as a seat admin")
                    ]));
                default:
                    var r;
                    return n.a.$ ? (r = n.a.a, i(lD, m([
                        Xd("An error occurred while attempting to remove "),
                        dD(r),
                        Xd(" as a billing admin")
                    ]))) : i(mD, m([
                        dD(r = n.a.a),
                        Xd(" has been removed as a billing admin")
                    ]));
            }
        }(), t = e.a, a = e.b;
        return A2(LE, m([
            yE("small"),
            bD
        ]), A2(ye, t, a));
    }, pD = function(r) {
        return Xd(r.$ ? "<no product name>" : r.a);
    }, $D = F2(function(r, n) {
        if (r.$) return Xd("");
        var e = r.a, t = function() {
            if (e.$) return e.a.$ ? (r = e.a.a, i(lD, m([
                Xd("An error occurred while attempting to reassign "),
                dD(r),
                Xd(" to "),
                pD(n)
            ]))) : i(mD, m([
                dD(r = e.a.a),
                Xd(" has been successfully reassigned to "),
                pD(n)
            ]));
            if (e.a.$) {
                var r = e.a.a;
                return i(lD, m([
                    Xd("An error occurred while attempting to remove "),
                    dD(r),
                    Xd(" from "),
                    pD(n)
                ]));
            }
            return i(mD, m([
                dD(r = e.a.a),
                Xd(" has been successfully unassigned from "),
                pD(n)
            ]));
        }(), a = t.a, u = t.b;
        return A2(LE, m([
            yE("small"),
            bD
        ]), A2(ye, a, u));
    }), hD = {
        $: 27
    }, wD = F2(function(r, n) {
        return r + " " + n;
    }), CD = function(r) {
        var n, e, t = EE("resetPasswordModalWrapper");
        switch(r.$){
            case 1:
                var a = r.a;
                return A2(LE, m([
                    t
                ]), m([
                    A2(kP, 0, A3(fP, b, m([
                        A4(ZV, m([
                            pV
                        ]), (e = a, {
                            $: 28,
                            a: e
                        }), Xd("Ok"), "reset-user-password")
                    ]), A3(oP, b, m([
                        Xd("An email will be sent to " + A2(wD, a.jM, a.ka) + " at "),
                        A2(fz, m([
                            yE("font-weight-bold")
                        ]), m([
                            Xd(a.iL)
                        ])),
                        Xd(" with a link to reset their password.")
                    ]), A3(bP, b, m([
                        Xd("Reset Password?")
                    ]), iP(hD)))))
                ]));
            case 2:
                return A2(LE, m([
                    yE("loadingModal"),
                    t
                ]), m([
                    A2(kP, 0, A3(oP, m([
                        yE("text-center")
                    ]), m([
                        IR
                    ]), (n = iP(hD), s(n, {
                        kI: s(n.kI, {
                            cL: Ve(1)
                        })
                    }))))
                ]));
            case 4:
                return a = r.a, A2(LE, m([
                    t
                ]), m([
                    A2(kP, 0, A3(fP, b, m([
                        A4(ZV, m([
                            pV
                        ]), hD, Xd("Ok"), "reset-user-password-error")
                    ]), A3(oP, b, m([
                        Xd("There was an error processing the request for " + A2(wD, a.jM, a.ka) + " at "),
                        A2(fz, m([
                            yE("font-weight-bold")
                        ]), m([
                            Xd(a.iL)
                        ])),
                        Xd(". Please contact support if the issue persists.")
                    ]), A3(bP, b, m([
                        Xd("Reset Password Error")
                    ]), iP(hD)))))
                ]));
            default:
                return A2(LE, m([
                    t
                ]), b);
        }
    }, kD = function(r) {
        return A2(SP, m([
            yE("error")
        ]), m([
            A2(fz, m([
                yE("icon mr-2"),
                A2(VV, "hidden", "true")
            ]), m([
                Iz
            ])),
            Xd(r)
        ]));
    }, yD = function(r) {
        switch(r.$){
            case 2:
                return kD(1 === (n = r.a).$ ? n.a : function(r) {
                    switch(r){
                        case 2:
                            return "Sorry, there are no more seats available.";
                        case 1:
                            return "The user cannot be added. This username is associated with another organization. Please contact " + xN + " if you have any questions.";
                        case 0:
                            return "Sorry, the specified user is already assigned to this grant.";
                        case 3:
                            return "That user is already a seat admin for this grant.";
                        case 4:
                            return "Sorry, you cannot modify this grant.";
                        default:
                            return "Sorry, an unknown error occurred.";
                    }
                }(n.a));
            case 3:
                return kD(function(r) {
                    switch(r){
                        case 0:
                            return "Sorry, that is not a valid first name.";
                        case 1:
                            return "Sorry, that is not a valid last name.";
                        default:
                            return "Sorry, that is not a valid email address.";
                    }
                }(r.a));
            default:
                return Xd("");
        }
        var n;
    }, xD = {
        $: 47
    }, LD = F3(function(r, n, e) {
        return A2(LE, b, r ? m([
            A2(kP, 0, A3(fP, b, m([
                A2(LV, A3(CV, m([
                    NI
                ]), "hide-sso-lr-modal-button", xD), m([
                    Xd("Cancel")
                ])),
                A2(lE, m([
                    yE("btn btn-learning-reminders btn-block btn-primary mb-4"),
                    EE("learning-reminders-btn"),
                    FE(A3(Hl, cs, n.by, e.jW)),
                    rG("_self")
                ]), m([
                    Xd("Proceed")
                ]))
            ]), A3(oP, b, m([
                A2(SP, b, m([
                    Xd("As an SSO (Single Sign On) customer, you will need to make sure you are syncing user email data so that reminder emails will reach your users inbox. If you are not syncing emails, Learning Reminders and other features will not work as intended. Please reach out to our success team in the chat with any questions or issues.")
                ]))
            ]), A3(II, b, m([
                Xd("Learning Reminders for SSO Users")
            ]), iP(xD)))))
        ]) : b);
    }), jD = function(r) {
        return A2(Yt, "#", r) ? r : "#" + r;
    }, AD = function(r) {
        return A2(az, m([
            Gz("1.1"),
            JE("14"),
            oz("17.759"),
            Jz("0px"),
            Xz("0px"),
            cz("0 0 22.8 18"),
            FG("new 0 0 22.8 18")
        ]), m([
            A2(lG, m([
                YE(jD(r)),
                MR("10.8,18 22.8,0 17.9,0 8.6,14 4.9,8.6 0,8.6 6.3,18 ")
            ]), b)
        ]));
    }, MD = function(r) {
        return A2(CE, A3(pz, m([
            yE("btn btn-block btn-sm btn-outline-secondary btn-sm")
        ]), "member-activity-" + r.g7, {
            $: 20,
            a: r
        }), m([
            Xd("Activity")
        ]));
    }, FD = A2(az, m([
        cz("0 0 448 512"),
        YE("#00A3e0"),
        oz("17px")
    ]), m([
        A2(XE, m([
            BE("M432 256C432 269.3 421.3 280 408 280h-160v160c0 13.25-10.75 24.01-24 24.01S200 453.3 200 440v-160h-160c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h160v-160c0-13.25 10.75-23.99 24-23.99S248 58.75 248 72v160h160C421.3 232 432 242.8 432 256z")
        ]), b)
    ])), HD = A2(az, m([
        cz("0 0 320 512"),
        oz("13px"),
        YE("#00A3E0")
    ]), m([
        A2(XE, m([
            BE("M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z")
        ]), b)
    ])), TD = function(r) {
        return {
            $: 31,
            a: r
        };
    }, SD = F2(function(r, n) {
        return n.$ ? 3 === n.a.$ ? A2(fz, b, m([
            A2(CE, A3(pz, m([
                yE("btn btn-sm btn-link-underline text-info offset-md-1")
            ]), "redeem-access-code" + r, TD(r)), m([
                A2(fz, m([
                    yE("mr-2")
                ]), m([
                    Xd("Redeem Access Code")
                ]))
            ])),
            A2(fz, m([
                yE("success")
            ]), m([
                Xd("Access Code Success ")
            ])),
            A2(fz, b, m([
                AD("6cc24a")
            ]))
        ])) : A2(CE, A3(pz, m([
            yE("btn btn-sm btn-link-underline text-info offset-md-1")
        ]), "redeem-access-code" + r, TD(r)), m([
            A2(fz, m([
                yE("mr-2")
            ]), m([
                Xd("Redeem Access Code")
            ]))
        ])) : 4 === n.a.$ ? A2(fz, b, m([
            A2(CE, A3(pz, m([
                yE("btn btn-sm btn-link-underline text-info offset-md-1")
            ]), "redeem-access-code" + r, TD(r)), m([
                A2(fz, m([
                    yE("mr-2")
                ]), m([
                    Xd("Redeem Access Code")
                ]))
            ])),
            A2(fz, m([
                yE("mr-2 failed")
            ]), m([
                Xd("Invalid Access Code")
            ]))
        ])) : A2(LE, b, b);
    }), ED = function(r) {
        return {
            $: 32,
            a: r
        };
    }, zD = F2(function(r, n) {
        if (n.$) return A2(LE, b, b);
        if (2 === n.a.$) {
            var e = n.a.a;
            return A2(LE, m([
                yE("row")
            ]), m([
                A2(LE, m([
                    yE("col-12 col-lg-6 d-flex align-items-center pt-3")
                ]), m([
                    A2(TE, m([
                        yE("form-control mr-2"),
                        sz("text"),
                        _E("Enter Access Code"),
                        kW("user_access_code"),
                        eD(!1),
                        A2(VV, "label", "Enter Access Code"),
                        PE(ED),
                        HV(e)
                    ]), b),
                    A2(CE, A3(pz, m([
                        yE("btn btn-primary")
                    ]), "submit-access-code" + r, (t = i(r, e), {
                        $: 33,
                        a: t
                    })), m([
                        A2(fz, b, m([
                            Xd("Submit")
                        ]))
                    ]))
                ]))
            ]));
        }
        var t;
        return A2(LE, b, b);
    }), RD = function(r) {
        return A2(CE, A3(pz, m([
            yE("btn btn-sm btn-link-underline text-info")
        ]), "reassign-" + r.g7, {
            $: 7,
            a: r
        }), m([
            Xd("Activate Subscription")
        ]));
    }, VD = A2(az, m([
        cz("0 0 512 512"),
        oz("15px"),
        YE("#00A3E0")
    ]), m([
        A2(XE, m([
            BE("M40 16C53.25 16 64 26.75 64 40v102.1C103.7 75.57 176.3 32.11 256.1 32.11C379.6 32.11 480 132.5 480 256s-100.4 223.9-223.9 223.9c-52.31 0-103.3-18.33-143.5-51.77c-10.19-8.5-11.56-23.62-3.062-33.81c8.5-10.22 23.66-11.56 33.81-3.062C174.9 417.5 214.9 432 256 432c97.03 0 176-78.97 176-176S353 80 256 80c-66.54 0-126.8 38.28-156.5 96H200C213.3 176 224 186.8 224 200S213.3 224 200 224h-160C26.75 224 16 213.3 16 200v-160C16 26.75 26.75 16 40 16z")
        ]), b)
    ])), WD = function(r) {
        return A2(CE, A3(pz, m([
            yE("btn btn-sm btn-link-underline text-info text-left text-md-center")
        ]), "reset-password" + r.g7, {
            $: 26,
            a: r
        }), m([
            A2(fz, m([
                yE("mr-2")
            ]), m([
                Xd("Reset Password")
            ])),
            A2(HE, m([
                A2(VV, "label", "reset icon")
            ]), m([
                A2(fz, m([
                    yE("sr-only")
                ]), m([
                    Xd("reset icon")
                ])),
                VD
            ]))
        ]));
    }, PD = function(r) {
        return A2(CE, A3(pz, m([
            yE("btn btn-sm btn-link-underline text-info text-left text-md-center")
        ]), "unassign-" + r.g7, {
            $: 4,
            a: r
        }), m([
            A2(fz, m([
                yE("mr-2")
            ]), m([
                Xd("Deactivate Subscription")
            ])),
            A2(HE, m([
                A2(VV, "label", "remove icon")
            ]), m([
                A2(fz, m([
                    yE("sr-only")
                ]), m([
                    Xd("remove icon")
                ])),
                HD
            ]))
        ]));
    }, GD = F2(function(r, n) {
        var e = function() {
            switch(r.eK){
                case 2:
                    return function(r) {
                        return A2(CE, A3(pz, m([
                            yE("btn btn-sm btn-link-underline text-info text-left text-md-center")
                        ]), "addAdmin-" + r.g7, {
                            $: 36,
                            a: r
                        }), m([
                            A2(fz, m([
                                yE("mr-2")
                            ]), m([
                                Xd("Give Admin Rights")
                            ])),
                            A2(HE, m([
                                A2(VV, "label", "add icon")
                            ]), m([
                                A2(fz, m([
                                    yE("sr-only")
                                ]), m([
                                    Xd("add icon")
                                ])),
                                FD
                            ]))
                        ]));
                    }(r);
                case 0:
                    return function(r) {
                        return A2(CE, A3(pz, m([
                            yE("btn btn-sm btn-link-underline text-info text-left text-md-center")
                        ]), "removeSeatAdmin-" + r.g7, {
                            $: 14,
                            a: r
                        }), m([
                            A2(fz, m([
                                yE("mr-2")
                            ]), m([
                                Xd("Remove as Admin")
                            ])),
                            A2(HE, m([
                                A2(VV, "label", "remove icon")
                            ]), m([
                                A2(fz, m([
                                    yE("sr-only")
                                ]), m([
                                    Xd("remove icon")
                                ])),
                                HD
                            ]))
                        ]));
                    }(r);
                default:
                    return function(r) {
                        return A2(CE, A3(pz, m([
                            yE("btn btn-sm btn-link-underline text-info text-left text-md-center")
                        ]), "removeBillingAdmin-" + r.g7, {
                            $: 17,
                            a: r
                        }), m([
                            A2(fz, m([
                                yE("mr-2")
                            ]), m([
                                Xd("Remove as Billing Admin")
                            ])),
                            A2(HE, m([
                                A2(VV, "label", "remove icon")
                            ]), m([
                                A2(fz, m([
                                    yE("sr-only")
                                ]), m([
                                    Xd("remove icon")
                                ])),
                                HD
                            ]))
                        ]));
                    }(r);
            }
        }(), t = m(r.gh ? [
            A2(LE, m([
                yE("row")
            ]), m([
                A2(LE, m([
                    yE("col-12 col-lg-6 order-2 d-flex justify-content-start")
                ]), b),
                A2(LE, m([
                    yE("col-12 col-lg-6 d-flex flex-column flex-md-row order-lg-2 justify-content-start justify-content-lg-end")
                ]), m([
                    WD(r),
                    RD(r),
                    e
                ]))
            ]))
        ] : [
            A2(LE, m([
                yE("row")
            ]), m([
                A2(LE, m([
                    yE("col-12 col-lg-6 order-2 d-flex justify-content-start")
                ]), m([
                    A2(SD, r.g7, n)
                ])),
                A2(LE, m([
                    yE("col-12 col-lg-6 d-flex flex-column flex-md-row order-lg-2 justify-content-start justify-content-lg-end")
                ]), m([
                    WD(r),
                    PD(r),
                    e
                ]))
            ])),
            A2(zD, r.g7, n)
        ]);
        return A2(LE, b, t);
    }), ID = function(r) {
        var n = r.A;
        if (1 === n.$) return A2(LE, b, b);
        var e = n.a;
        return A2(LE, m([
            yE("col-12 user-options py-3")
        ]), m([
            A2(GD, r, e)
        ]));
    }, ND = function(r) {
        var n, e, t, a, u = r.A.$ ? "false" : "true", c = r.kf ? m([
            AD("6cc24a")
        ]) : b;
        return A2(LE, m([
            yE("row user-row")
        ]), m([
            A2(LE, m([
                yE("col-2 col-sm-1 text-right")
            ]), m([
                A2(HE, m([
                    gz((a = r.g7, {
                        $: 25,
                        a: a
                    })),
                    yE("toggle-team pb-4 pt-1 toggle pressed-" + u),
                    XP("button"),
                    A2(VV, "pressed", u)
                ]), m([
                    WV
                ]))
            ])),
            A2(LE, m([
                yE("col-5 col-sm-4 col-lg-2")
            ]), m([
                A2(fG, m([
                    yE("member-name truncate  pt-2")
                ]), m([
                    dD(r)
                ]))
            ])),
            A2(LE, m([
                yE("d-none d-lg-block col-lg-3")
            ]), m([
                A2(fG, m([
                    yE("truncate pt-2")
                ]), m([
                    (t = r.iL, Xd(t))
                ]))
            ])),
            A2(LE, m([
                yE("d-none d-md-block col-md-3 col-lg-2")
            ]), m([
                A2(fG, m([
                    yE("pt-2")
                ]), m([
                    (n = r.j9, e = 1 === n.$ ? " " : Sk(n.a), Xd(e))
                ]))
            ])),
            A2(LE, m([
                yE("d-none d-lg-block col-2")
            ]), m([
                A2(LE, m([
                    yE("pt-2")
                ]), c)
            ])),
            A2(LE, m([
                yE("col-5 col-sm-5 offset-sm-2 col-md-3 offset-md-0 col-lg-2")
            ]), m([
                A2(LE, m([
                    yE("activity-btn-col")
                ]), m([
                    MD(r)
                ]))
            ])),
            ID(r)
        ]));
    }, ZD = {
        $: 0
    }, DD = function(r) {
        return {
            $: 1,
            a: r
        };
    }, _D = F2(function(r, n) {
        return A2(tV, A2(ye, yE("card-title"), n), m([
            Xd(r)
        ]));
    }), OD = yE("d-inline"), qD = A2(LE, m([
        yE("row")
    ]), m([
        A2(LE, m([
            yE("col-12")
        ]), m([
            A2(_D, "Learning Modules to Assign", m([
                OD
            ]))
        ]))
    ])), KD = {
        $: 6
    }, UD = function(r) {
        if (1 === r.$) return A2(LE, b, b);
        var n, e = r.a;
        return A2(LE, b, m([
            A2(kP, 0, A3(fP, b, m([
                A2(LV, A3(CV, m([
                    NI
                ]), "hide-module-delete-modal-button-" + e.g7, KD), m([
                    Xd("Cancel")
                ])),
                A2(LV, A3(CV, m([
                    pV
                ]), "confim-module-delete-button-" + e.g7, (n = e.g7, {
                    $: 8,
                    a: n
                })), m([
                    Xd("Confirm")
                ]))
            ]), A3(oP, b, m([
                A2(SP, b, m([
                    Xd("Once deleted, module '" + e.hF + "' will no longer be able to be assigned.")
                ]))
            ]), A3(II, b, m([
                Xd("Are You Sure?")
            ]), iP(KD)))))
        ]));
    }, BD = m([
        A2(LE, m([
            yE("border-top py-2 d-flex justify-content-between align-items-center")
        ]), m([
            A2(LE, m([
                yE("col-12")
            ]), m([
                Xd("No learning modules found. Create a new learning module to assign to your team members.")
            ]))
        ]))
    ]), QD = yE("ml-2"), YD = function(r) {
        return A2(LV, A3(CV, m([
            jI,
            $V(m([
                yE("float-right")
            ]))
        ]), "clone-module-button-" + r, {
            $: 11,
            a: r
        }), m([
            A2(AI, b, m([
                Xd("Clone")
            ]))
        ]));
    }, JD = function(r) {
        return A2(LV, A3(CV, m([
            jI,
            $V(m([
                yE("float-right")
            ]))
        ]), "show-module-delete-modal-button-" + r.g7, {
            $: 5,
            a: r
        }), m([
            A2(AI, b, m([
                Xd("Delete")
            ]))
        ]));
    }, XD = function(r) {
        return A2(LV, A3(CV, m([
            TI,
            $V(m([
                yE("float-right"),
                QD
            ]))
        ]), "show-module-details-button-" + r, {
            $: 4,
            a: r
        }), m([
            Xd("View")
        ]));
    }, r_ = function(r) {
        var n, e;
        return A2(LE, m([
            yE("border-top py-3 d-flex justify-content-between align-items-center")
        ]), m([
            A2(LE, m([
                yE("col-6")
            ]), m([
                (e = r.hF, Xd(e))
            ])),
            A2(LE, m([
                yE("col-6")
            ]), m([
                (n = r.g7, A2(LV, A3(CV, m([
                    pV,
                    $V(m([
                        yE("float-right"),
                        QD
                    ]))
                ]), "create-new-assignment-button-" + n, {
                    $: 10,
                    a: n
                }), m([
                    Xd("Assign")
                ]))),
                XD(r.g7),
                YD(r.g7),
                JD(r)
            ]))
        ]));
    }, n_ = F2(function(r, n) {
        switch(r.$){
            case 1:
                var e = r.a;
                return A2(LE, m([
                    yE("row")
                ]), m([
                    A2(LE, m([
                        yE("col-12 mt-3")
                    ]), m([
                        A2(LE, b, pF(e) ? BD : A2(aa, r_, e)),
                        UD(n)
                    ]))
                ]));
            case 0:
                return A2(LE, m([
                    yE("row")
                ]), m([
                    A2(LE, m([
                        yE("col-12")
                    ]), m([
                        Xd("Loading...")
                    ]))
                ]));
            default:
                return A2(LE, m([
                    yE("row")
                ]), m([
                    A2(LE, m([
                        yE("col-12")
                    ]), m([
                        Xd("An error occurred while loading modules for this grant.")
                    ]))
                ]));
        }
    }), e_ = {
        $: 4
    }, t_ = {
        $: 6
    }, a_ = function(r) {
        return {
            $: 3,
            a: r
        };
    }, u_ = function(r) {
        var n;
        return A2(LE, m([
            yE("col-12 col-md-2 delete-btn-col")
        ]), m([
            A2(CE, m([
                yE("btn btn-link-underline btn-block"),
                EE("show-team-delete-modal-button-" + fm(r.g7)),
                gz((n = r, {
                    $: 5,
                    a: n
                }))
            ]), m([
                Xd("Delete")
            ]))
        ]));
    }, c_ = function(r) {
        var n, e = r.bl ? "false" : "true";
        return A2(LE, m([
            yE("row team-row toggle pressed-" + e)
        ]), m([
            A2(LE, m([
                yE("col-10 col-md-8 team-name")
            ]), m([
                A2(fG, m([
                    yE("team-name")
                ]), m([
                    Xd(r.kv)
                ]))
            ])),
            A2(LE, m([
                yE("col-2 text-right d-md-none")
            ]), m([
                A2(HE, m([
                    gz((n = r.g7, {
                        $: 0,
                        a: n
                    })),
                    yE("toggle-team pressed-" + e),
                    XP("button"),
                    A2(VV, "pressed", e)
                ]), m([
                    WV
                ]))
            ])),
            u_(r),
            A2(LE, m([
                gz(a_(r.g7)),
                yE("col-12 col-md-2 manage-btn-col")
            ]), m([
                A2(CE, m([
                    yE("btn btn-outline-secondary btn-block"),
                    EE("manage-team-button")
                ]), m([
                    Xd("Manage")
                ]))
            ]))
        ]));
    }, o_ = F2(function(r, n) {
        var e = function(r) {
            return A2(Ca, A2(tu, "message", wc), r);
        }(n);
        return e.$ ? {
            $: 0,
            a: r.k6
        } : {
            $: 1,
            a: e.a
        };
    }), i_ = F2(function(r, n) {
        var e = A2(o_, r, n);
        return 1 === e.$ ? "An error occured: " + e.a : "An error occured with status: " + Ie(e.a);
    }), f_ = function(r) {
        return A2(LE, b, m([
            Xd(r)
        ]));
    }, s_ = OE("ellipse"), l_ = A2(az, m([
        oz("320"),
        JE("98"),
        cz("15 0 320 150")
    ]), m([
        A2(XE, m([
            BE("M149.2 95.1718V28.4795H140.052H130.903V95.1718H149.2Z"),
            YE("#FFFFFF")
        ]), b),
        A2(XE, m([
            BE("M59.7757 95.2622H42.1571V91.3349C34.8086 96.1924 29.8854 96.6176 22.2488 96.1924C14.0314 95.6042 0 89.5433 0 75.705C0 57.451 19.3872 46.041 41.4433 56.3696V51.4793C41.6268 41.5904 30.596 41.6951 27.6316 42.0835C19.378 43.1648 14.9038 46.3159 8.64175 49.6726L2.15311 38.4788C10.7655 30.909 19.2014 27.6484 30.6211 27.6484C48.4449 27.6484 59.7757 39.0671 59.7757 49.2158V95.2622ZM41.4365 70.9536C29.3516 62.2884 16.5072 65.1507 16.5072 74.7535C16.5072 80.4937 22.2488 83.0442 26.5481 83.0442C32.2966 83.0442 38.1868 79.4458 41.4365 75.4743V70.9536Z"),
            YE("#FFFFFF")
        ]), b),
        A2(XE, m([
            BE("M97.3969 96.1774C91.1185 96.1774 85.4924 94.688 80.5186 91.7092C75.5448 88.7304 71.5901 84.6759 68.6548 79.5457C65.8009 74.3327 64.374 68.4578 64.374 61.921C64.374 55.3841 65.8009 49.5506 68.6548 44.4204C71.5901 39.2074 75.5448 35.1116 80.5186 32.1327C85.4924 29.1539 91.1185 27.6645 97.3969 27.6645C103.186 27.6645 108.486 28.6988 113.297 30.7674C118.189 32.8361 122.062 35.7321 124.916 39.4557L114.275 52.3639C113.134 51.04 111.788 49.7988 110.239 48.6404C108.69 47.482 106.978 46.5718 105.102 45.9098C103.227 45.2478 101.27 44.9168 99.2315 44.9168C96.1331 44.9168 93.4016 45.6616 91.037 47.151C88.6724 48.5576 86.8378 50.5435 85.5332 53.1086C84.2285 55.6737 83.5762 58.6112 83.5762 61.921C83.5762 65.0653 84.2285 67.92 85.5332 70.4851C86.9193 73.0502 88.7947 75.0774 91.1593 76.5669C93.5239 78.0563 96.2146 78.801 99.2315 78.801C101.352 78.801 103.308 78.5527 105.102 78.0563C106.896 77.477 108.527 76.6496 109.995 75.5739C111.544 74.4982 112.971 73.1743 114.275 71.6021L124.794 84.6345C122.021 88.1925 118.148 91.0059 113.175 93.0745C108.282 95.1431 103.023 96.1774 97.3969 96.1774Z"),
            YE("#FFFFFF")
        ]), b),
        A2(s_, m([
            KE("139.952"),
            UE("10.0931"),
            tI("10.0478"),
            aI("10.0931"),
            YE("#F4B43A")
        ]), b),
        A2(XE, m([
            BE("M3.32983 125.791V111.156H5.57768V123.617H12.4045V125.791H3.32983Z"),
            YE("#FFFFFF")
        ]), b),
        A2(XE, m([
            BE("M20.7846 125.791V111.156H29.9633V113.33H23.0325V123.617H29.9633V125.791H20.7846ZM21.8045 119.372V117.198H28.8186V119.372H21.8045Z"),
            YE("#FFFFFF")
        ]), b),
        A2(XE, m([
            BE("M37.0452 125.791L42.6856 111.156H44.9751L50.5739 125.791H48.1804L44.8502 116.968C44.8086 116.871 44.7254 116.634 44.6005 116.257C44.4895 115.881 44.3577 115.463 44.205 115.003C44.0524 114.543 43.9136 114.125 43.7888 113.748C43.6639 113.358 43.5806 113.107 43.539 112.996L44.0177 112.975C43.9345 113.212 43.8304 113.511 43.7055 113.874C43.5945 114.236 43.4696 114.62 43.3309 115.024C43.206 115.428 43.0811 115.811 42.9562 116.174C42.8313 116.522 42.7273 116.815 42.644 117.052L39.3347 125.791H37.0452ZM39.5428 122.153L40.3754 119.979H46.994L47.9514 122.153H39.5428Z"),
            YE("#FFFFFF")
        ]), b),
        A2(XE, m([
            BE("M58.1332 125.791V111.156H64.3356C65.1682 111.156 65.9313 111.365 66.6251 111.783C67.3328 112.187 67.8947 112.745 68.311 113.456C68.7272 114.153 68.9354 114.94 68.9354 115.818C68.9354 116.613 68.7272 117.351 68.311 118.034C67.8947 118.717 67.3397 119.268 66.6459 119.686C65.9521 120.09 65.182 120.292 64.3356 120.292H60.3811V125.791H58.1332ZM66.7916 125.791L63.0868 119.184L65.3971 118.662L69.5182 125.812L66.7916 125.791ZM60.3811 118.118H64.5438C64.9462 118.118 65.3069 118.02 65.6261 117.825C65.9452 117.616 66.195 117.337 66.3753 116.989C66.5557 116.627 66.6459 116.229 66.6459 115.797C66.6459 115.309 66.528 114.884 66.2921 114.522C66.0701 114.146 65.7509 113.853 65.3347 113.644C64.9323 113.435 64.4744 113.33 63.961 113.33H60.3811V118.118Z"),
            YE("#FFFFFF")
        ]), b),
        A2(XE, m([
            BE("M77.6002 125.791V111.156H79.6191L88.5273 123.136L88.1943 123.324C88.1388 122.975 88.0902 122.599 88.0486 122.195C88.0069 121.777 87.9653 121.338 87.9237 120.878C87.8959 120.404 87.8682 119.909 87.8404 119.393C87.8266 118.864 87.8127 118.313 87.7988 117.742C87.7849 117.17 87.778 116.578 87.778 115.965V111.156H90.0258V125.791H87.9653L79.2029 114.25L79.4318 113.957C79.5012 114.808 79.5567 115.532 79.5983 116.132C79.6538 116.717 79.6955 117.219 79.7232 117.637C79.7648 118.041 79.7926 118.376 79.8065 118.641C79.8203 118.892 79.8273 119.101 79.8273 119.268C79.8411 119.435 79.8481 119.581 79.8481 119.707V125.791H77.6002Z"),
            YE("#FFFFFF")
        ]), b),
        A2(XE, m([
            BE("M98.5587 125.791V123.7H100.911V113.247H98.5587V111.156H105.51V113.247H103.158V123.7H105.51V125.791H98.5587Z"),
            YE("#FFFFFF")
        ]), b),
        A2(XE, m([
            BE("M114.034 125.791V111.156H116.053L124.961 123.136L124.628 123.324C124.573 122.975 124.524 122.599 124.483 122.195C124.441 121.777 124.399 121.338 124.358 120.878C124.33 120.404 124.302 119.909 124.274 119.393C124.261 118.864 124.247 118.313 124.233 117.742C124.219 117.17 124.212 116.578 124.212 115.965V111.156H126.46V125.791H124.399L115.637 114.25L115.866 113.957C115.935 114.808 115.991 115.532 116.032 116.132C116.088 116.717 116.129 117.219 116.157 117.637C116.199 118.041 116.227 118.376 116.24 118.641C116.254 118.892 116.261 119.101 116.261 119.268C116.275 119.435 116.282 119.581 116.282 119.707V125.791H114.034Z"),
            YE("#FFFFFF")
        ]), b),
        A2(XE, m([
            BE("M142.048 126C140.994 126 140.009 125.812 139.093 125.436C138.177 125.045 137.372 124.509 136.679 123.826C135.985 123.143 135.444 122.348 135.055 121.442C134.68 120.522 134.493 119.533 134.493 118.473C134.493 117.428 134.68 116.452 135.055 115.546C135.444 114.64 135.978 113.853 136.658 113.184C137.351 112.501 138.156 111.971 139.072 111.595C139.988 111.219 140.973 111.03 142.028 111.03C142.763 111.03 143.478 111.135 144.171 111.344C144.879 111.553 145.517 111.846 146.086 112.222C146.655 112.598 147.12 113.031 147.481 113.518L146.024 115.045C145.607 114.64 145.177 114.306 144.733 114.041C144.303 113.776 143.859 113.574 143.401 113.435C142.943 113.295 142.485 113.226 142.028 113.226C141.278 113.226 140.585 113.358 139.946 113.623C139.322 113.888 138.767 114.257 138.281 114.731C137.809 115.205 137.442 115.762 137.178 116.404C136.914 117.031 136.783 117.721 136.783 118.473C136.783 119.198 136.921 119.888 137.199 120.543C137.476 121.184 137.858 121.749 138.344 122.237C138.843 122.725 139.412 123.108 140.05 123.387C140.702 123.665 141.389 123.805 142.111 123.805C142.652 123.805 143.165 123.728 143.651 123.575C144.137 123.408 144.567 123.178 144.941 122.885C145.316 122.592 145.607 122.258 145.816 121.881C146.024 121.491 146.128 121.08 146.128 120.648V120.23L146.44 120.522H141.986V118.285H148.438C148.466 118.439 148.487 118.592 148.501 118.745C148.514 118.885 148.521 119.024 148.521 119.163C148.535 119.289 148.542 119.414 148.542 119.54C148.542 120.501 148.376 121.38 148.043 122.174C147.71 122.955 147.245 123.631 146.648 124.202C146.065 124.773 145.379 125.219 144.588 125.54C143.811 125.847 142.964 126 142.048 126Z"),
            YE("#FFFFFF")
        ]), b),
        A2(XE, m([
            BE("M180 57.021L180 3.40327"),
            nz("#F4B43A"),
            tz("5.43948"),
            ez("square")
        ]), b),
        A2(XE, m([
            BE("M180 57.021L186.145 57.021"),
            nz("#F4B43A"),
            tz("5.43948"),
            ez("square")
        ]), b),
        A2(XE, m([
            BE("M180 3.40356L186.145 3.40357"),
            nz("#F4B43A"),
            tz("5.43948"),
            ez("square")
        ]), b),
        A2(XE, m([
            BE("M204.474 41.7122V37.2673H208.141V24.3991H204.474V19.9542H217.124V24.3991H213.425V37.2673H217.124V41.7122H204.474ZM228.739 41.7122V24.6166H222.274V19.9542H240.644V24.6166H234.024V41.7122H228.739ZM246.714 41.7122V19.9542H255.324C256.463 19.9542 257.489 20.234 258.401 20.7935C259.313 21.353 260.038 22.13 260.577 23.1247C261.115 24.0986 261.385 25.1969 261.385 26.4194C261.385 27.7042 261.115 28.8543 260.577 29.8696C260.038 30.8643 259.313 31.6621 258.401 32.263C257.489 32.8432 256.463 33.1333 255.324 33.1333H249.138V41.7122H246.714ZM249.138 30.771H255.448C256.09 30.771 256.66 30.5845 257.158 30.2115C257.676 29.8178 258.09 29.2998 258.401 28.6574C258.712 27.9943 258.867 27.238 258.867 26.3884C258.867 25.6217 258.712 24.9378 258.401 24.3369C258.09 23.7152 257.676 23.2283 257.158 22.876C256.66 22.503 256.09 22.3165 255.448 22.3165H249.138V30.771ZM267.914 41.7122V19.9542H276.431C277.695 19.9542 278.835 20.2547 279.85 20.8556C280.886 21.4358 281.705 22.2336 282.306 23.249C282.907 24.2644 283.207 25.4144 283.207 26.6992C283.207 27.9011 282.917 28.9889 282.337 29.9629C281.757 30.9368 280.969 31.7139 279.975 32.2941C278.98 32.8536 277.861 33.1333 276.618 33.1333H270.339V41.7122H267.914ZM281.187 41.7122L275.716 32.1387L278.047 31.3305L284.077 41.7122H281.187ZM270.339 30.771H276.835C277.602 30.771 278.275 30.5949 278.856 30.2426C279.436 29.8903 279.892 29.4137 280.223 28.8128C280.555 28.1912 280.721 27.4866 280.721 26.6992C280.721 25.8496 280.524 25.0932 280.13 24.4301C279.736 23.767 279.187 23.249 278.483 22.876C277.799 22.503 277.011 22.3165 276.12 22.3165H270.339V30.771ZM298.978 42.023C297.445 42.023 296.025 41.7536 294.72 41.2148C293.435 40.6553 292.306 39.8783 291.332 38.8836C290.379 37.889 289.633 36.7182 289.094 35.3713C288.576 34.0036 288.317 32.5117 288.317 30.8954C288.317 29.2791 288.576 27.7974 289.094 26.4505C289.633 25.0829 290.379 23.9017 291.332 22.9071C292.306 21.8917 293.435 21.1147 294.72 20.5759C296.025 20.0164 297.445 19.7366 298.978 19.7366C300.532 19.7366 301.952 20.0164 303.237 20.5759C304.542 21.1147 305.671 21.8917 306.625 22.9071C307.599 23.9017 308.345 25.0829 308.863 26.4505C309.401 27.7974 309.671 29.2791 309.671 30.8954C309.671 32.4909 309.401 33.9726 308.863 35.3402C308.345 36.6871 307.599 37.8683 306.625 38.8836C305.671 39.8783 304.542 40.6553 303.237 41.2148C301.952 41.7536 300.532 42.023 298.978 42.023ZM298.978 39.6296C300.159 39.6296 301.247 39.4224 302.242 39.008C303.257 38.5728 304.128 37.9615 304.853 37.1741C305.578 36.3866 306.138 35.4645 306.531 34.4077C306.946 33.3302 307.153 32.1594 307.153 30.8954C307.153 29.6106 306.946 28.4398 306.531 27.383C306.138 26.3055 305.578 25.373 304.853 24.5856C304.128 23.7981 303.257 23.1868 302.242 22.7517C301.247 22.3165 300.159 22.0989 298.978 22.0989C297.797 22.0989 296.699 22.3165 295.683 22.7517C294.689 23.1868 293.829 23.7981 293.104 24.5856C292.378 25.373 291.819 26.3055 291.425 27.383C291.031 28.4398 290.835 29.6106 290.835 30.8954C290.835 32.1594 291.031 33.3302 291.425 34.4077C291.819 35.4645 292.378 36.3866 293.104 37.1741C293.829 37.9615 294.689 38.5728 295.683 39.008C296.699 39.4224 297.797 39.6296 298.978 39.6296Z"),
            YE("#FFFFFF")
        ]), b),
        A2(XE, m([
            BE("M333.372 3.40323L333.372 57.021"),
            nz("#F4B43A"),
            tz("5.43948"),
            ez("square")
        ]), b),
        A2(XE, m([
            BE("M333.372 3.40323L327.228 3.40323"),
            nz("#F4B43A"),
            tz("5.43948"),
            ez("square")
        ]), b),
        A2(XE, m([
            BE("M333.372 57.0204L327.228 57.0204"),
            nz("#F4B43A"),
            tz("5.43948"),
            ez("square")
        ]), b),
        A2(XE, m([
            BE("M180 122.597L180 68.979"),
            nz("#F4B43A"),
            tz("5.43948"),
            ez("square")
        ]), b),
        A2(XE, m([
            BE("M180 122.597L186.145 122.597"),
            nz("#F4B43A"),
            tz("5.43948"),
            ez("square")
        ]), b),
        A2(XE, m([
            BE("M180 68.9795L186.145 68.9795"),
            nz("#F4B43A"),
            tz("5.43948"),
            ez("square")
        ]), b),
        A2(XE, m([
            BE("M201.696 107.288L210.306 85.5299H214.782L223.33 107.288H217.984L213.881 96.2535C213.715 95.8183 213.549 95.3521 213.383 94.8547C213.218 94.3574 213.052 93.8497 212.886 93.3317C212.72 92.7929 212.555 92.2749 212.389 91.7775C212.244 91.2595 212.119 90.7829 212.016 90.3477L212.948 90.3167C212.824 90.8347 212.679 91.3424 212.513 91.8397C212.368 92.337 212.213 92.8344 212.047 93.3317C211.902 93.8083 211.736 94.2952 211.55 94.7926C211.363 95.2692 211.187 95.7665 211.021 96.2845L206.918 107.288H201.696ZM205.799 103.123L207.447 99.1442H217.455L219.072 103.123H205.799ZM236.472 107.474C234.669 107.474 233.063 107.112 231.654 106.386C230.245 105.64 229.136 104.625 228.328 103.34C227.541 102.056 227.147 100.584 227.147 98.9266V85.5299H232.493V98.6468C232.493 99.4343 232.669 100.149 233.022 100.792C233.374 101.413 233.851 101.911 234.452 102.284C235.052 102.636 235.726 102.812 236.472 102.812C237.259 102.812 237.954 102.636 238.554 102.284C239.176 101.911 239.673 101.413 240.046 100.792C240.419 100.149 240.606 99.4343 240.606 98.6468V85.5299H245.766V98.9266C245.766 100.584 245.362 102.056 244.553 103.34C243.766 104.625 242.668 105.64 241.259 106.386C239.85 107.112 238.254 107.474 236.472 107.474ZM252.935 107.288V85.5299H262.042C263.638 85.5299 265.099 85.7993 266.425 86.3381C267.751 86.8561 268.891 87.6021 269.844 88.576C270.818 89.5499 271.564 90.7 272.082 92.0262C272.6 93.3524 272.859 94.8133 272.859 96.4089C272.859 98.0045 272.6 99.4757 272.082 100.823C271.564 102.149 270.818 103.299 269.844 104.273C268.891 105.226 267.751 105.972 266.425 106.511C265.099 107.029 263.638 107.288 262.042 107.288H252.935ZM258.219 103.682L257.504 102.625H261.887C262.757 102.625 263.534 102.48 264.218 102.19C264.902 101.879 265.482 101.455 265.959 100.916C266.456 100.377 266.839 99.7244 267.109 98.9577C267.378 98.191 267.513 97.3414 267.513 96.4089C267.513 95.4764 267.378 94.6268 267.109 93.8601C266.839 93.0934 266.456 92.4406 265.959 91.9019C265.482 91.3631 264.902 90.9487 264.218 90.6586C263.534 90.3477 262.757 90.1923 261.887 90.1923H257.411L258.219 89.1977V103.682ZM277.92 107.288V102.843H281.587V89.9747H277.92V85.5299H290.57V89.9747H286.871V102.843H290.57V107.288H277.92ZM302.185 107.288V90.1923H295.72V85.5299H314.09V90.1923H307.47V107.288H302.185ZM320.16 107.288V85.5299H328.77C329.909 85.5299 330.935 85.8097 331.847 86.3691C332.759 86.9286 333.484 87.7057 334.023 88.7004C334.561 89.6743 334.831 90.7725 334.831 91.9951C334.831 93.2799 334.561 94.4299 334.023 95.4453C333.484 96.44 332.759 97.2378 331.847 97.8387C330.935 98.4189 329.909 98.709 328.77 98.709H322.584V107.288H320.16ZM322.584 96.3467H328.894C329.536 96.3467 330.106 96.1602 330.604 95.7872C331.122 95.3935 331.536 94.8755 331.847 94.2331C332.158 93.57 332.313 92.8136 332.313 91.964C332.313 91.1973 332.158 90.5135 331.847 89.9126C331.536 89.2909 331.122 88.804 330.604 88.4517C330.106 88.0787 329.536 87.8922 328.894 87.8922H322.584V96.3467ZM341.36 107.288V85.5299H349.877C351.141 85.5299 352.281 85.8304 353.296 86.4313C354.332 87.0115 355.151 87.8093 355.752 88.8247C356.353 89.8401 356.653 90.9901 356.653 92.2749C356.653 93.4767 356.363 94.5646 355.783 95.5386C355.203 96.5125 354.415 97.2896 353.421 97.8698C352.426 98.4293 351.307 98.709 350.064 98.709H343.785V107.288H341.36ZM354.633 107.288L349.162 97.7144L351.493 96.9062L357.523 107.288H354.633ZM343.785 96.3467H350.281C351.048 96.3467 351.721 96.1706 352.302 95.8183C352.882 95.466 353.338 94.9894 353.669 94.3885C354.001 93.7668 354.167 93.0623 354.167 92.2749C354.167 91.4253 353.97 90.6689 353.576 90.0058C353.182 89.3427 352.633 88.8247 351.929 88.4517C351.245 88.0787 350.457 87.8922 349.566 87.8922H343.785V96.3467ZM372.424 107.599C370.891 107.599 369.471 107.329 368.166 106.791C366.881 106.231 365.752 105.454 364.778 104.459C363.825 103.465 363.079 102.294 362.54 100.947C362.022 99.5793 361.763 98.0873 361.763 96.471C361.763 94.8547 362.022 93.3731 362.54 92.0262C363.079 90.6586 363.825 89.4774 364.778 88.4828C365.752 87.4674 366.881 86.6903 368.166 86.1516C369.471 85.5921 370.891 85.3123 372.424 85.3123C373.978 85.3123 375.398 85.5921 376.683 86.1516C377.988 86.6903 379.117 87.4674 380.071 88.4828C381.045 89.4774 381.791 90.6586 382.309 92.0262C382.847 93.3731 383.117 94.8547 383.117 96.471C383.117 98.0666 382.847 99.5482 382.309 100.916C381.791 102.263 381.045 103.444 380.071 104.459C379.117 105.454 377.988 106.231 376.683 106.791C375.398 107.329 373.978 107.599 372.424 107.599ZM372.424 105.205C373.605 105.205 374.693 104.998 375.688 104.584C376.703 104.148 377.574 103.537 378.299 102.75C379.024 101.962 379.584 101.04 379.977 99.9834C380.392 98.9059 380.599 97.7351 380.599 96.471C380.599 95.1863 380.392 94.0155 379.977 92.9587C379.584 91.8812 379.024 90.9487 378.299 90.1612C377.574 89.3738 376.703 88.7625 375.688 88.3274C374.693 87.8922 373.605 87.6746 372.424 87.6746C371.243 87.6746 370.145 87.8922 369.129 88.3274C368.135 88.7625 367.275 89.3738 366.55 90.1612C365.824 90.9487 365.265 91.8812 364.871 92.9587C364.477 94.0155 364.281 95.1863 364.281 96.471C364.281 97.7351 364.477 98.9059 364.871 99.9834C365.265 101.04 365.824 101.962 366.55 102.75C367.275 103.537 368.135 104.148 369.129 104.584C370.145 104.998 371.243 105.205 372.424 105.205Z"),
            YE("#FFFFFF")
        ]), b),
        A2(XE, m([
            BE("M406.372 68.979L406.372 122.597"),
            nz("#F4B43A"),
            tz("5.43948"),
            ez("square")
        ]), b),
        A2(XE, m([
            BE("M406.372 68.979L400.228 68.979"),
            nz("#F4B43A"),
            tz("5.43948"),
            ez("square")
        ]), b),
        A2(XE, m([
            BE("M406.372 122.596L400.228 122.596"),
            nz("#F4B43A"),
            tz("5.43948"),
            ez("square")
        ]), b)
    ])), b_ = A2(LE, m([
        EE("recaptcha"),
        yE("g-recaptcha")
    ]), b), d_ = function(r) {
        return {
            $: 1,
            a: r
        };
    }, v_ = {
        $: 4
    }, m_ = function(r) {
        return {
            $: 5,
            a: r
        };
    }, g_ = function(r) {
        return {
            $: 0,
            a: r
        };
    }, p_ = function(r) {
        var n;
        return A2(LE, b, r.$ ? b : m([
            Xd((n = r.a, n ? "Sorry, something unexpected happened. Please try again in a few moments." : "Sorry, the login provided is not valid."))
        ]));
    }, $_ = function(r) {
        return AV(r);
    }, h_ = function(r) {
        var n = r.ap;
        if (n.$) {
            var e = n.a, t = function() {
                var n = r.cU;
                if (!n.$) return n.a;
                switch(e){
                    case 1:
                        return "If you have an account, an email has been sent. Please check your spam folder if you do not see the email in your primary inbox.";
                    case 0:
                        return "";
                    default:
                        return JM;
                }
            }(), a = 1 === e ? "Back" : "Cancel";
            return A2(LE, m([
                yE("col col-md-8 offset-md-2 d-flex flex-column align-items-center align-middle")
            ]), m([
                A2(iz, "ACI Learning ProPortal logo", m([
                    lz(230)
                ])),
                A2(ME, m([
                    ZE(v_)
                ]), m([
                    p_(r.a8),
                    A2(LE, m([
                        yE("text-center mt-3 requestTitle mb-4")
                    ]), m([
                        Xd("Request Password Reset")
                    ])),
                    A2(LE, m([
                        yE("mb-4 text-center")
                    ]), m([
                        Xd(t)
                    ])),
                    function() {
                        if (1 !== e) {
                            var n = A2(LE, m([
                                yE("form-group")
                            ]), m([
                                A2(SE, m([
                                    AE("Username"),
                                    yE("sr-only")
                                ]), m([
                                    Xd("Username")
                                ])),
                                A2(TE, A3(GE, m([
                                    yE("form-control"),
                                    _E("Username"),
                                    Lv(!0)
                                ]), "username", A2($l, g_, Vt)), b)
                            ]));
                            return A2(LE, b, m([
                                n,
                                A2(LE, m([
                                    yE("text-center mt-3")
                                ]), m([
                                    A2(CE, m([
                                        yE("btn login btn-primary btn-block mt-5"),
                                        sz("submit"),
                                        xE($_(r.bw))
                                    ]), m([
                                        Xd("Send")
                                    ]))
                                ]))
                            ]));
                        }
                        return A2(LE, b, b);
                    }(),
                    A2(LE, m([
                        yE("text-center mt-3")
                    ]), m([
                        A2(CE, m([
                            yE("btn btn-link"),
                            gz(m_(_h))
                        ]), m([
                            Xd(a)
                        ]))
                    ]))
                ]))
            ]));
        }
        return A2(LE, m([
            yE("col col-md-8 offset-md-2 d-flex flex-column align-items-center align-middle")
        ]), m([
            A2(fz, m([
                yE("mb-4")
            ]), m([
                A2(iz, "ACI Learning ProPortal logo", m([
                    lz(230)
                ]))
            ])),
            A2(ME, m([
                ZE(v_)
            ]), m([
                p_(r.a8),
                A2(LE, m([
                    yE("form-group")
                ]), m([
                    A2(SE, m([
                        AE("Username"),
                        yE("sr-only")
                    ]), m([
                        Xd("Username")
                    ])),
                    A2(TE, A3(GE, m([
                        yE("form-control"),
                        _E("Username"),
                        Lv(!0)
                    ]), "username", A2($l, g_, Vt)), b)
                ])),
                A2(LE, m([
                    yE("form-group")
                ]), m([
                    A2(SE, m([
                        AE("Password"),
                        yE("sr-only")
                    ]), m([
                        Xd("Password")
                    ])),
                    A2(TE, A3(GE, m([
                        yE("form-control"),
                        _E("Password"),
                        Lv(!0),
                        sz("password")
                    ]), "password", A2($l, d_, Vt)), b)
                ])),
                A2(LE, b, m([
                    A2(CE, m([
                        yE("btn login btn-primary btn-block mt-5"),
                        sz("submit"),
                        xE($_(r.bw))
                    ]), m([
                        Xd("Login")
                    ]))
                ])),
                A2(LE, m([
                    yE("text-center mt-3")
                ]), m([
                    A2(CE, m([
                        yE("btn btn-link"),
                        gz(m_(NM(0)))
                    ]), m([
                        Xd("Reset Password")
                    ]))
                ]))
            ]))
        ]));
    }, w_ = function(r) {
        return {
            $: 4,
            a: r
        };
    }, C_ = {
        $: 10
    }, k_ = F2(function(r, n) {
        var e = mi(l(n.u.jM, n.u.ka));
        return A3(GT, e, n.u.iL, r);
    }), y_ = F2(function(r, n) {
        var e;
        return e = r, A2(fc, k_(n), e);
    }), x_ = yE("d-inline-block"), L_ = F2(function(r, n) {
        return !A2(XV, A2(Fk, 11, n), A2(Fk, 11, r));
    }), j_ = yE("mr-1"), A_ = yE("mt-2"), M_ = F2(function(r, n) {
        var e = Xd("When an assignment is created a module is assigned to a team member with a due date.");
        return A3(wN, r, e, n);
    }), F_ = function(r) {
        return {
            $: 16,
            a: r
        };
    }, H_ = function(r) {
        return {
            $: 18,
            a: r
        };
    }, T_ = {
        $: 17
    }, S_ = function(r) {
        return r.$ ? r.a.kv : "All Users";
    }, E_ = F2(function(r, n) {
        return {
            $: 8,
            a: r,
            b: n
        };
    }), z_ = F2(function(r, n) {
        return {
            ht: n,
            kI: r
        };
    }), R_ = F2(function(r, n) {
        switch(r.$){
            case 0:
                return s(n, {
                    jW: Ve(r.a)
                });
            case 1:
                return s(n, {
                    il: r.a
                });
            case 2:
                return s(n, {
                    cA: !0
                });
            case 3:
                return s(n, {
                    ej: Ve(r.a)
                });
            case 4:
                return s(n, {
                    M: !0
                });
            case 5:
                return s(n, {
                    dF: r.a
                });
            case 6:
                return s(n, {
                    fd: Ve(r.a)
                });
            default:
                return s(n, {
                    gG: l(n.gG, r.a)
                });
        }
    }), V_ = {
        gG: b,
        M: !1,
        dF: !1,
        jW: We,
        cA: !1,
        ej: We,
        il: 1,
        fd: We
    }, W_ = A2(Ov, m([
        "target",
        "checked"
    ]), wu), P_ = function(r) {
        return A2(mz, "change", A2(St, r, W_));
    }, G_ = function(r) {
        switch(r){
            case 0:
                return jP(!0);
            case 1:
                return jP(!1);
            default:
                return A2(RV, "indeterminate", "true");
        }
    }, I_ = function(r) {
        return r ? "is-invalid" : "is-valid";
    }, N_ = function(r) {
        var n;
        return l(m([
            Fz(m([
                i("form-check-input", !r.M),
                i("custom-control-input", r.M)
            ])),
            sz("checkbox"),
            xE(r.dF),
            G_(r.il)
        ]), l(A2(Af, Vt, m([
            A2(Ba, P_, r.ej),
            A2(Ba, EE, r.jW)
        ])), l((n = r.fd).$ ? b : m([
            yE(I_(n.a))
        ]), r.gG)));
    }, Z_ = F2(function(r, n) {
        var e, t, a;
        return A2(LE, m([
            Fz(m([
                i("form-check", !(a = A3(_e, R_, V_, (t = A2(z_, r, n)).kI)).M),
                i("form-check-inline", !a.M && a.cA),
                i("custom-control", a.M),
                i("custom-checkbox", a.M),
                i("custom-control-inline", a.cA && a.M)
            ]))
        ]), m([
            A2(TE, N_(a), b),
            A2(SE, l(m([
                Fz(m([
                    i("form-check-label", !a.M),
                    i("custom-control-label", a.M)
                ]))
            ]), (e = a.jW, e.$ ? b : m([
                AE(e.a)
            ]))), m([
                Xd(t.ht)
            ]))
        ]));
    }), D_ = function(r) {
        return {
            $: 1,
            a: r ? 0 : 1
        };
    }, __ = function(r) {
        return {
            $: 0,
            a: r
        };
    }, O_ = function(r) {
        return {
            $: 3,
            a: r
        };
    }, q_ = function(r) {
        var n = r.u.g7;
        return A2(Z_, m([
            __("member-selection-" + n + "-checked"),
            D_($F(r.aM)),
            O_(E_(n))
        ]), "");
    }, K_ = function(r) {
        return Xd(r.iL);
    }, U_ = function(r) {
        var n;
        return A2(LE, m([
            yE("row pt-2 pb-2 border-top")
        ]), m([
            A2(LE, m([
                yE("col-3")
            ]), m([
                (n = r.u, Xd(A2(wD, n.jM, n.ka)))
            ])),
            A2(LE, m([
                yE("col-6")
            ]), m([
                K_(r.u)
            ])),
            A2(LE, m([
                yE("col-3 text-right")
            ]), m([
                q_(r)
            ]))
        ]));
    }, B_ = function(r) {
        return {
            $: 7,
            a: r
        };
    }, Q_ = function(r) {
        return A2(aa, function(r) {
            var n = {
                $: 1,
                a: r
            };
            return A2(CE, m([
                yE("dropdown-item"),
                gz(H_(n))
            ]), m([
                Xd(S_(n))
            ]));
        }, r);
    }, Y_ = F4(function(r, n, e, t) {
        var a, u = function() {
            if (pF(n)) return b;
            var r = t ? m([
                A2(_W, "position", "absolute"),
                A2(_W, "transform", "translate3d(14px, 62px, 0px)"),
                A2(_W, "top", "-28px"),
                A2(_W, "left", "0px"),
                A2(_W, "will-change", "transform")
            ]) : b;
            return m([
                A2(CE, m([
                    yE("btn btn-block btn-secondary dropdown-toggle text-left"),
                    Fz(m([
                        i("show", t)
                    ])),
                    gz(T_)
                ]), m([
                    Xd("Filter by Team")
                ])),
                A2(LE, l(m([
                    yE("dropdown-menu"),
                    Fz(m([
                        i("show", t)
                    ]))
                ]), r), A2(ye, A2(CE, m([
                    yE("dropdown-item"),
                    gz(H_(Z$))
                ]), m([
                    Xd(S_(Z$))
                ])), Q_(n)))
            ]);
        }();
        return A2(ye, A2(LE, m([
            yE("row pt-2 pb-3")
        ]), m([
            A2(LE, m([
                yE("col-12 col-sm-6 col-md-8 col-lg-9 pb-2")
            ]), m([
                A2(TE, m([
                    yE("form-control"),
                    sz("text"),
                    HV(e),
                    PE(F_),
                    _E("Filter users by name or email")
                ]), b)
            ])),
            A2(LE, m([
                yE("col-12 col-sm-6 col-md-3")
            ]), u),
            A2(LE, m([
                yE("d-none d-md-block col-md-6")
            ]), b),
            A2(LE, m([
                yE("col-12 pt-2 text-right")
            ]), m([
                (a = r, A2(LE, m([
                    yE("form-check form-check-inline mr-0 mt-2")
                ]), m([
                    A2(SE, m([
                        yE("form-check-label mr-2"),
                        AE("select-all-checked")
                    ]), m([
                        Xd("Select All")
                    ])),
                    A2(TE, m([
                        yE("form-check-input"),
                        P_(B_),
                        sz("checkbox"),
                        EE("select-all-checked"),
                        jP(A2(Gx, hF, a))
                    ]), b)
                ])))
            ]))
        ])), A2(aa, U_, r));
    }), J_ = {
        $: 11
    }, X_ = F2(function(r, n) {
        return 1 !== n.$ && !A2(L_, r, n.a);
    }), rO = F3(function(r, n, e) {
        return A2(X_, r, n) && A2(lc, hF, function(r) {
            return 1 === r.$ ? r.a : b;
        }(e));
    }), nO = F3(function(r, n, e) {
        return A4(ZV, m([
            pV,
            hV,
            jV(!A2(di, !1, A2(Ba, function(e) {
                return A3(rO, e, r, n);
            }, e)))
        ]), J_, Xd("Assign Module"), "assignment-creation-button");
    }), eO = F2(function(r, n) {
        return A2(ME, r, n);
    }), tO = function(r) {
        return eO(A2(ye, yE("form-inline"), r));
    }, aO = yE("justify-content-md-end"), uO = F2(function(r, n) {
        return A2(SE, A2(ye, yE("form-control-label"), r), n);
    }), cO = F3(function(r, n, e) {
        return A2(iE, I$, A2(tO, m([
            A_,
            aO
        ]), m([
            A2(uO, m([
                sD
            ]), m([
                Xd("Due Date")
            ])),
            A3(LW, A2(Ba, kF, r), e, n)
        ])));
    }), oO = function(r) {
        var n = A2(Uz, 1, r), e = 1 === n ? "" : "s";
        return (c(n, 168) > -1 ? "too many" : Oz(n)) + " hour" + e;
    }, iO = yE("mb-sm-0"), fO = function(r) {
        return r.$ ? A2(di, 0, r.a.hv) : r.a.hv;
    }, sO = Vt, lO = function(r) {
        var n = f(r.cM, r.aP, r.jA);
        if (1 !== n.a.$ || n.b.$ || n.c.$) return Xd("");
        var e = n.a.a, t = n.c.a, a = function(r) {
            return r / 7;
        }(A3(KP, 3, A2(Fk, 11, n.b.a), A2(Tk, 11, t))), u = sO(function(r) {
            return r / 3600;
        }(BN(A2(aa, fO, e.hE))) / a);
        return A2(fz, m([
            bD,
            iO
        ]), m([
            A2(HE, b, m([
                Xd("Learning pace:")
            ])),
            Xd(" " + oO(u) + " per week.")
        ]));
    }, bO = function(r) {
        var n = A2(La, 3600, r) / 60 | 0, e = r / 3600 | 0;
        return e ? Ie(e) + "H " + Ie(n) + "M" : Ie(n) + "M";
    }, dO = function(r) {
        if (r.$) {
            var n = r.a;
            return A2(LE, m([
                yE("row")
            ]), m([
                A2(LE, m([
                    yE("col-md-6")
                ]), m([
                    A2(LE, m([
                        yE("mb-2 text-muted")
                    ]), m([
                        Xd(n.hF)
                    ]))
                ])),
                A2(LE, m([
                    yE("col-md-6 text-md-right")
                ]), m([
                    (e = n.hE, t = bO(BN(A2(aa, fO, e))), A2(LE, m([
                        yE("mb-2 text-muted")
                    ]), m([
                        Xd("Total Module Time: "),
                        Xd(t)
                    ])))
                ]))
            ]));
        }
        var e, t;
        return Xd("Loading module information...");
    }, vO = A2(Z_, m([
        __("send-emails"),
        D_(!0),
        O_(function(r) {
            return {
                $: 9,
                a: r
            };
        })
    ]), "Send Emails"), mO = {
        $: 15
    }, gO = function(r) {
        return {
            $: 2,
            a: r
        };
    }, pO = F2(function(r, n) {
        var e = Xd("A module is simply a group of content (courses and/or episodes) with a name and a description. Once you create a module, it can be assigned to team members. After a module is assigned your team will see the name and description in the notifications panel on the dashboard.");
        return A3(wN, r, e, n);
    }), $O = A2(CE, m([
        yE("btn btn-block btn-sm btn-outline-secondary cursor-pointer"),
        EE("done-with-module"),
        gz({
            $: 5
        })
    ]), m([
        Xd("Done")
    ])), hO = {
        $: 12
    }, wO = kE("title"), CO = function(r) {
        var n = r.cM;
        switch(n.$){
            case 0:
                return A2(LE, b, m([
                    Xd("Loading...")
                ]));
            case 1:
                var e = n.a;
                return A2(CE, A3(pz, m([
                    yE("btn btn-link-underline btn-small text-info"),
                    xE(AV(r.cs)),
                    wO("Download assignment activity"),
                    A2(VV, "label", "Download assignment activity")
                ]), "download-assignment-activity-" + e.g7, hO), m([
                    A2(fz, m([
                        yE("text-info mr-2")
                    ]), m([
                        Xd("Assignment Activity")
                    ])),
                    A2(HE, m([
                        A2(VV, "label", "Download icon")
                    ]), m([
                        A2(fz, m([
                            yE("sr-only")
                        ]), m([
                            Xd("Download icon")
                        ])),
                        QI
                    ]))
                ]));
            default:
                return A2(LE, b, m([
                    Xd("Error")
                ]));
        }
    }, kO = function(r) {
        return {
            $: 3,
            a: r
        };
    }, yO = function(r) {
        return {
            jW: r.jW,
            hx: r.hx,
            hS: r.hS
        };
    }, xO = F2(function(r, n) {
        return {
            gG: r,
            gM: n
        };
    }), LO = F2(function(r, n) {
        return {
            gG: r,
            gM: n
        };
    }), jO = function(r) {
        return 1 === r;
    }, AO = function(r) {
        return !r.dD || jO(r.dD);
    }, MO = function(r) {
        var n = XN(r);
        if (n) {
            var e = Oz(n), t = Ie(wt(n / 100)) + "%";
            return A2(LE, m([
                yE("d-flex justify-content-end justify-content-lg-between")
            ]), m([
                A2(LE, m([
                    yE("mt-2 w-100 progress")
                ]), m([
                    A2(LE, m([
                        yE("progress-bar"),
                        A2(_W, "width", t),
                        XP("progressbar"),
                        A2(VV, "valuenow", e),
                        A2(VV, "valuemin", "0"),
                        A2(VV, "valuemax", "1")
                    ]), b)
                ])),
                A2(fz, m([
                    yE("ml-1")
                ]), m([
                    Xd(t)
                ]))
            ]));
        }
        return A2(LE, m([
            yE("text-right text-lg-left")
        ]), m([
            A2(fz, m([
                yE("d-lg-none")
            ]), m([
                Xd("No progress recorded")
            ])),
            A2(fz, m([
                yE("d-none d-lg-inline")
            ]), m([
                Xd("None recorded")
            ]))
        ]));
    }, FO = function(r) {
        return Xd(A2(Ne, " ", m([
            r.jM,
            r.ka
        ])));
    }, HO = function(r) {
        var n, e, t, a, u = (n = r.$7.gR).$ ? "" : n.a, c = r.$7.g7;
        return A2(LE, m([
            yE("row mt-2 user-row")
        ]), m([
            A2(LE, m([
                yE("col-lg-2 truncate")
            ]), m([
                FO(r.$7.u)
            ])),
            A2(LE, m([
                yE("d-none d-lg-block col-lg-2 truncate")
            ]), m([
                (a = r.$7.u, Xd(a.iL))
            ])),
            A2(LE, m([
                yE("col-lg-1 truncate")
            ]), m([
                FO(r.$7.gA)
            ])),
            A2(LE, m([
                yE("col-lg-1")
            ]), m([
                A2(fz, b, m([
                    Xd(r.$7.gz)
                ]))
            ])),
            A2(LE, m([
                yE("col-lg-1")
            ]), m([
                MO(r.$7.kO)
            ])),
            A2(LE, m([
                yE("col-lg-1")
            ]), m([
                A2(fz, b, m([
                    Xd(r.$7.jA)
                ]))
            ])),
            A2(LE, m([
                yE("col-lg-1 text-right text-lg-left")
            ]), m([
                A2(fz, b, m([
                    Xd(u)
                ]))
            ])),
            A2(LE, m([
                yE("col-lg-2 offset-lg-0 mt-4 mt-lg-0")
            ]), m([
                A2(CE, m([
                    yE("btn btn-block btn-sm btn-outline-secondary btn-sm cursor-pointer"),
                    xE((t = r.dD, jO(t) || 2 === t)),
                    EE("unassign-assignment-" + c),
                    gz((e = c, {
                        $: 9,
                        a: e
                    }))
                ]), m([
                    Xd("Unassign")
                ]))
            ]))
        ]));
    }, TO = F2(function(r, n) {
        var t, a = e(r.jQ, n) ? A2(AG, r.bA, !1) : A2(AG, r.bA, !0), u = function() {
            switch(n){
                case 0:
                    return {
                        bb: "col-lg-2 font-weight-bold d-flex align-items-center",
                        bc: "User"
                    };
                case 1:
                    return {
                        bb: "col-lg-1 offset-lg-2 font-weight-bold d-flex align-items-center",
                        bc: "Assigned By"
                    };
                case 3:
                    return {
                        bb: "col-lg-1 font-weight-bold d-flex align-items-center",
                        bc: "Assigned Date"
                    };
                case 2:
                    return {
                        bb: "col-lg-1 font-weight-bold d-flex align-items-center",
                        bc: "Progress"
                    };
                case 4:
                    return {
                        bb: "col-lg-1 font-weight-bold d-flex align-items-center",
                        bc: "Due Date"
                    };
                default:
                    return {
                        bb: "col-lg-1 font-weight-bold d-flex align-items-center",
                        bc: "Completed"
                    };
            }
        }(), c = u.bc;
        return A2(LE, m([
            yE(u.bb)
        ]), m([
            A2(fz, m([
                yE("float-left pr-2")
            ]), m([
                Xd(c)
            ])),
            A2(fz, b, m([
                A2(fz, m([
                    yE("d-flex flex-row sort-toggle"),
                    gz((t = n, {
                        $: 16,
                        a: t
                    }))
                ]), m([
                    a
                ]))
            ]))
        ]));
    }), SO = F2(function(r, n) {
        switch(r.$){
            case 0:
                return m([
                    A2(LE, b, m([
                        Xd("Loading...")
                    ]))
                ]);
            case 1:
                var e = A2(fc, AO, r.a), t = n.jQ, a = n.bA, u = function() {
                    switch(t){
                        case 0:
                            return A2(yG, a, A2($l, A2($l, A2($l, VT, function(r) {
                                return r.jM;
                            }), function(r) {
                                return r.u;
                            }), function(r) {
                                return r.$7;
                            }));
                        case 1:
                            return A2(yG, a, A2($l, A2($l, A2($l, VT, function(r) {
                                return r.jM;
                            }), function(r) {
                                return r.gA;
                            }), function(r) {
                                return r.$7;
                            }));
                        case 3:
                            return A2(yG, a, A2($l, A2($l, Cx, function(r) {
                                return r.gz;
                            }), function(r) {
                                return r.$7;
                            }));
                        case 2:
                            return A2(yG, a, A2($l, A2($l, XN, function(r) {
                                return r.kO;
                            }), function(r) {
                                return r.$7;
                            }));
                        case 4:
                            return A2(yG, a, A2($l, A2($l, Cx, function(r) {
                                return r.jA;
                            }), function(r) {
                                return r.$7;
                            }));
                        default:
                            return A2(yG, a, A2($l, A2($l, A2(KC, "0", Cx), function(r) {
                                return r.gR;
                            }), function(r) {
                                return r.$7;
                            }));
                    }
                }(), c = A2(LG, u, e);
                return l(m([
                    A2(LE, m([
                        yE("row d-flex table-header mt-4")
                    ]), m([
                        A2(TO, n, 0),
                        A2(TO, n, 1),
                        A2(TO, n, 3),
                        A2(TO, n, 2),
                        A2(TO, n, 4),
                        A2(TO, n, 5)
                    ])),
                    A2(LE, m([
                        yE("row")
                    ]), b)
                ]), A2(aa, HO, c));
            default:
                return m([
                    A2(LE, b, m([
                        Xd("Error while loading...")
                    ]))
                ]);
        }
    }), EO = F3(function(r, n, e) {
        var t;
        return m([
            A2(LE, m([
                yE("row mt-4")
            ]), m([
                A2(LE, m([
                    yE("col-12 col-md-6 offset-md-6 col-lg-4 offset-lg-8")
                ]), m([
                    A2(CE, m([
                        yE("btn btn-block btn-primary mb-4"),
                        EE("create-new-assignment"),
                        gz((t = n, {
                            $: 6,
                            a: t
                        }))
                    ]), m([
                        Xd("Create New Assignment")
                    ]))
                ]))
            ])),
            A2(LE, b, A2(SO, r, e))
        ]);
    }), zO = F3(function(r, n, e) {
        return yO({
            jW: "assignments",
            hx: A2(xO, m([
                yE("px-4")
            ]), m([
                Xd("Assignments")
            ])),
            hS: A2(LO, m([
                yE("view-content")
            ]), A3(EO, r, n, e))
        });
    }), RO = F2(function(r, n) {
        return s(n, {
            gG: l(n.gG, r)
        });
    }), VO = function(r) {
        return r.$ ? "" : r.a;
    }, WO = function(r) {
        var n = A2(La, 3600, r) / 60 | 0, e = r / 3600 | 0;
        return e ? Ie(e) + "H " + Ie(n) + "M" : Ie(n) + "M";
    }, PO = function(r) {
        if (r.$) {
            var n = r.a, e = "Episode: " + n.z;
            return {
                ft: a = WO(A2(di, 0, n.hv)),
                fu: e,
                fv: n.gT
            };
        }
        var t = r.a, a = WO(t.hv), u = VO(t.lb);
        return {
            ft: a,
            fu: "Course: " + t.kv,
            fv: u
        };
    }, GO = function(r) {
        var n = PO(r);
        return A2(LE, m([
            yE("module-content-row")
        ]), m([
            A2(LE, m([
                yE("module-content-details-col")
            ]), m([
                A2(fG, b, m([
                    Xd(n.fu)
                ])),
                A2(xG, b, m([
                    Xd(n.fv)
                ]))
            ])),
            A2(LE, m([
                yE("module-content-time-col")
            ]), m([
                A2(fG, b, m([
                    Xd(n.ft)
                ]))
            ]))
        ]));
    }, IO = function(r) {
        var n;
        return A2(ye, (n = BN(A2(aa, fO, r)), A2(LE, m([
            yE("row mt-4")
        ]), m([
            A2(LE, m([
                yE("col-12 col-md-6")
            ]), m([
                A2(LE, m([
                    yE("font-weight-bold")
                ]), m([
                    Xd("Selected courses and episodes:")
                ]))
            ])),
            A2(LE, m([
                yE("col-12 col-md-6 text-left text-md-right")
            ]), m([
                Xd("Total module length: "),
                Xd(bO(n))
            ]))
        ]))), function(r) {
            return A2(aa, GO, r);
        }(r));
    }, NO = function(r) {
        return yO({
            jW: "contents",
            hx: A2(xO, m([
                yE("px-4")
            ]), m([
                Xd("Content")
            ])),
            hS: A2(LO, m([
                EE("content-area-row")
            ]), m([
                A2(LE, m([
                    EE("content-area-col")
                ]), IO(r))
            ]))
        });
    }, ZO = F2(function(r, n) {
        return s(n, {
            hq: r
        });
    }), DO = F2(function(r, n) {
        var t = r.fj;
        if (1 === t.$) return sc(n.hq);
        var a, u = t.a;
        return (a = sc(A2(fc, function(r) {
            return e(r.jW, u);
        }, n.hq))).$ ? sc(n.hq) : Ve(a.a);
    }), _O = F2(function(r, n) {
        var e = i(r, n);
        r: for(; e.a;)switch(e.b){
            case 0:
                return 1;
            case 1:
                return 2;
            default:
                break r;
        }
        return 2;
    }), OO = F4(function(r, n, e, t) {
        var a = e.gG, u = e.gM, c = m([
            i("nav-link", !0),
            i("active", n)
        ]), o = gz(t.go({
            fj: Ve(r),
            B: A2(_O, t.bq && !n, 0)
        })), f = t.c6 ? A2(lE, l(m([
            Fz(c),
            o,
            FE("#" + r)
        ]), a), u) : A2(CE, l(m([
            Fz(l(c, m([
                i("btn", !0),
                i("btn-link", !0)
            ]))),
            o
        ]), a), u);
        return A2(Hz, m([
            yE("nav-item")
        ]), m([
            f
        ]));
    }), qO = F2(function(r) {
        switch(r.B){
            case 0:
                return m([
                    A2(_W, "display", "none")
                ]);
            case 1:
                return m([
                    A2(_W, "display", "block"),
                    A2(_W, "opacity", "0")
                ]);
            default:
                return l(m([
                    A2(_W, "display", "block")
                ]), m([
                    A2(_W, "opacity", Ie(1)),
                    A2(_W, "-webkit-transition", "opacity 0.15s linear"),
                    A2(_W, "-o-transition", "opacity 0.15s linear"),
                    A2(_W, "transition", "opacity 0.15s linear")
                ]));
        }
    }), KO = F5(function(r, n, e, t, a) {
        var u = e.gG, c = e.gM, o = n ? A2(qO, t, a) : m([
            A2(_W, "display", "none")
        ]);
        return A2(LE, l(m([
            EE(r),
            yE("tab-pane")
        ]), l(o, u)), c);
    }), UO = function(r) {
        return l(m([
            Fz(m([
                i("nav", !0),
                i("nav-tabs", !r.bM),
                i("nav-pills", r.bM)
            ]))
        ]), l(function() {
            var n = r.bN;
            if (n.$) return b;
            switch(n.a){
                case 3:
                    return m([
                        yE("nav-justified")
                    ]);
                case 2:
                    return m([
                        yE("nav-fill")
                    ]);
                case 0:
                    return m([
                        yE("justify-content-center")
                    ]);
                default:
                    return m([
                        yE("justify-content-end")
                    ]);
            }
        }(), r.gG));
    }, BO = F2(function(r, n) {
        var t = n, a = A2(DO, r, t);
        if (1 === a.$) return A2(LE, b, m([
            A2(Sz, UO(t), b),
            A2(LE, m([
                yE("tab-content")
            ]), b)
        ]));
        var u = a.a;
        return A2(LE, b, m([
            A2(Sz, UO(t), A2(aa, function(r) {
                var n = r;
                return A4(OO, n.jW, e(n.jW, u.jW), n.hx, t);
            }, t.hq)),
            A2(LE, m([
                yE("tab-content")
            ]), A2(aa, function(n) {
                var a = n;
                return A5(KO, a.jW, e(a.jW, u.jW), a.hS, r, t);
            }, t.hq))
        ]));
    }), QO = F5(function(r, n, e, t, a) {
        return A2(BO, r, A2(RO, m([
            yE("mt-5")
        ]), A2(ZO, m([
            A3(zO, n, t, a),
            NO(e)
        ]), {
            gG: b,
            bM: !1,
            hq: b,
            bN: We,
            go: kO,
            c6: !1,
            bq: !1
        })));
    }), YO = F4(function(r, n, e, t) {
        var a;
        return m([
            A2(LE, m([
                yE("mt-4 px-0 row")
            ]), m([
                A2(LE, m([
                    yE("col-12")
                ]), m([
                    A2(tV, m([
                        yE("card-title d-inline-block")
                    ]), m([
                        Xd(n.hF),
                        A2(CE, m([
                            yE("btn btn-link cursor-pointer"),
                            XP("link"),
                            EE("edit-module"),
                            gz((a = n.g7, {
                                $: 4,
                                a: a
                            }))
                        ]), m([
                            SW(m([
                                yE("icon")
                            ]))
                        ]))
                    ]))
                ])),
                A2(LE, m([
                    yE("col-12")
                ]), m([
                    Xd(n.kr)
                ]))
            ])),
            A5(QO, r, e, n.hE, n.g7, t)
        ]);
    }), JO = {
        $: 3
    }, XO = F2(function(r, n) {
        return {
            $: 4,
            a: r,
            b: n
        };
    }), rq = F3(function(r, n, e) {
        return A2(OR, m([
            _R,
            yE("pl-0 card-subtitle")
        ]), m([
            A2(fz, A3(pz, b, "toggle-" + Im(r), A2(XO, r, e)), m([
                n
            ]))
        ]));
    }), nq = F4(function(r, n, e, t) {
        return eV({
            jb: m([
                A2(nV, m([
                    KR(m([
                        iV,
                        oV
                    ]))
                ]), m([
                    A2(LE, m([
                        yE("wizard-content-row")
                    ]), m([
                        A2(LE, m([
                            yE("wizard-content-col")
                        ]), m([
                            e
                        ]))
                    ]))
                ]))
            ]),
            jQ: A2(uV, m([
                cV,
                yE("pl-0")
            ]), A3(rq, r, n, t)),
            jW: Im(r),
            kI: m([
                qR(m([
                    cV
                ]))
            ])
        });
    }), eq = function(r) {
        return {
            $: 1,
            a: r
        };
    }, tq = function(r) {
        return {
            $: 0,
            a: r
        };
    }, aq = function(r) {
        return {
            $: 6,
            a: r
        };
    }, uq = F3(function(r, n, e) {
        var t, a;
        return l(r, m([
            (a = n + "-input", {
                $: 1,
                a: a
            }),
            (t = e, {
                $: 5,
                a: t
            })
        ]));
    }), cq = function(r) {
        return {
            $: 7,
            a: r
        };
    }, oq = function(r) {
        return {
            $: 1,
            a: r
        };
    }, iq = F2(function(r, n) {
        var e;
        return {
            kI: A2(ye, (e = r, {
                $: 2,
                a: e
            }), n)
        };
    }), fq = F2(function(r, n) {
        switch(r.$){
            case 0:
                return s(n, {
                    eT: Ve(r.a)
                });
            case 1:
                return s(n, {
                    jW: Ve(r.a)
                });
            case 2:
                return s(n, {
                    e$: r.a
                });
            case 3:
                return s(n, {
                    dF: r.a
                });
            case 4:
                return s(n, {
                    fe: Ve(r.a)
                });
            case 7:
                return s(n, {
                    f5: Ve(r.a)
                });
            case 5:
                return s(n, {
                    em: Ve(r.a)
                });
            case 6:
                return s(n, {
                    fd: Ve(r.a)
                });
            case 8:
                return s(n, {
                    eE: r.a
                });
            default:
                return s(n, {
                    gG: l(n.gG, r.a)
                });
        }
    }), sq = {
        gG: b,
        dF: !1,
        jW: We,
        em: We,
        f5: We,
        eE: !1,
        eT: We,
        e$: 0,
        fd: We,
        fe: We
    }, lq = xv("readOnly"), bq = function(r) {
        return A2(Ba, function(r) {
            return yE("form-control-" + r);
        }, QR(r));
    }, dq = function(r) {
        return yE(I_(r));
    }, vq = F2(function(r, n) {
        return function(r) {
            var n, e;
            return A2(TE, (e = A3(_e, fq, sq, r.kI), l(m([
                yE("form-control"),
                xE(e.dF),
                lq(e.eE),
                (n = e.e$, sz(function() {
                    switch(n){
                        case 0:
                            return "text";
                        case 1:
                            return "password";
                        case 2:
                            return "datetime-local";
                        case 3:
                            return "date";
                        case 4:
                            return "month";
                        case 5:
                            return "time";
                        case 6:
                            return "week";
                        case 7:
                            return "number";
                        case 8:
                            return "email";
                        case 9:
                            return "url";
                        case 10:
                            return "search";
                        case 11:
                            return "tel";
                        default:
                            return "color";
                    }
                }()))
            ]), l(A2(Af, Vt, m([
                A2(Ba, EE, e.jW),
                A2(Dv, bq, e.eT),
                A2(Ba, HV, e.fe),
                A2(Ba, _E, e.f5),
                A2(Ba, PE, e.em),
                A2(Ba, dq, e.fd)
            ])), e.gG))), b);
        }(A2(iq, r, n));
    }), mq = vq(0), gq = F3(function(r, n, e) {
        var t, a;
        return l(r, m([
            (a = n + "-input", {
                $: 0,
                a: a
            }),
            (t = e, {
                $: 4,
                a: t
            })
        ]));
    }), pq = function(r) {
        return {
            kI: r
        };
    }, $q = bn("textarea"), hq = F2(function(r, n) {
        switch(r.$){
            case 0:
                return s(n, {
                    jW: Ve(r.a)
                });
            case 1:
                return s(n, {
                    eL: Ve(r.a)
                });
            case 2:
                return s(n, {
                    dF: !0
                });
            case 3:
                return s(n, {
                    fe: Ve(r.a)
                });
            case 4:
                return s(n, {
                    em: Ve(r.a)
                });
            case 5:
                return s(n, {
                    fd: Ve(r.a)
                });
            default:
                return s(n, {
                    gG: l(n.gG, r.a)
                });
        }
    }), wq = {
        gG: b,
        dF: !1,
        jW: We,
        em: We,
        eL: We,
        fd: We,
        fe: We
    }, Cq = function(r) {
        return A2($n, "rows", Ie(r));
    }, kq = function(r) {
        return yE(I_(r));
    }, yq = function(r) {
        var n;
        return A2($q, (n = A3(_e, hq, wq, r.kI), l(m([
            yE("form-control"),
            xE(n.dF)
        ]), l(A2(Af, Vt, m([
            A2(Ba, EE, n.jW),
            A2(Ba, Cq, n.eL),
            A2(Ba, HV, n.fe),
            A2(Ba, PE, n.em),
            A2(Ba, kq, n.fd)
        ])), n.gG))), b);
    }, xq = A2($l, yq, pq), Lq = function(r) {
        return {
            $: 4,
            a: r
        };
    }, jq = F3(function(r, n, e) {
        return A2(LE, m([
            yE("row")
        ]), m([
            A2(LE, m([
                yE("col-12 col-xl-10 offset-xl-1")
            ]), m([
                A3(DV, r, A2(XO, n, e), Im(n) + "-" + e)
            ]))
        ]));
    }), Aq = F4(function(r, n, e, t) {
        var a, u;
        return A2(LE, b, m([
            A2(iE, GF, (a = e, A2(ME, m([
                yE("form-group")
            ]), m([
                A2(LE, m([
                    yE("row")
                ]), m([
                    A2(LE, m([
                        yE("col-12 col-xl-10 offset-xl-1")
                    ]), m([
                        mq(A3(uq, m([
                            cq("Module Name (required)"),
                            Lq(a.kv)
                        ]), "new-module-name", A2($l, tq, Vt)))
                    ]))
                ])),
                A2(LE, m([
                    yE("row mt-2")
                ]), m([
                    A2(LE, m([
                        yE("col-12 col-xl-10 offset-xl-1")
                    ]), m([
                        xq(A3(gq, m([
                            oq(5),
                            aq(m([
                                _E("Module Description (required)")
                            ])),
                            (u = a.bz, {
                                $: 3,
                                a: u
                            }),
                            oq(5),
                            aq(m([
                                _E("Module Description (required)")
                            ]))
                        ]), "new-module-description", A2($l, eq, Vt)))
                    ]))
                ]))
            ])))),
            A3(jq, r, n, t)
        ]));
    }), Mq = F4(function(r, n, e, t) {
        return A2(fz, b, m([
            A2(fz, m([
                EV
            ]), m([
                r
            ])),
            A2(fz, m([
                yE("font-weight-bold"),
                EV
            ]), m([
                n
            ])),
            A2(fz, b, m([
                e
            ])),
            t
        ]));
    }), Fq = F2(function(r, n) {
        return e(r, n) ? A2(fz, m([
            EV,
            A2(VV, "expanded", "false"),
            yE("toggle")
        ]), m([
            A2(fz, m([
                yE("sr-only")
            ]), m([
                Xd("Open collapsed content")
            ])),
            WV
        ])) : A2(fz, m([
            EV,
            A2(VV, "expanded", "true"),
            yE("toggle rotate-right")
        ]), m([
            A2(fz, m([
                yE("sr-only")
            ]), m([
                Xd("Collapse content")
            ])),
            WV
        ]));
    }), Hq = F4(function(r, n, t, a) {
        var u = function() {
            switch(r.$){
                case 0:
                default:
                    return 1;
                case 1:
                    return 2;
            }
        }(), c = lH(n);
        return A4(nq, 0, function(r) {
            var n = e(r, Ve(0)) ? Xd("") : SW(m([
                yE("edit-area")
            ]));
            return A4(Mq, A2(Fq, r, Ve(0)), Xd("Step 1:"), Xd("Name and Description"), n);
        }(t), A4(Aq, c, u, n, a), a);
    }), Tq = function(r) {
        switch(r.$){
            case 0:
                return "create new";
            case 1:
                return "edit";
            default:
                return "clone";
        }
    }, Sq = {
        $: 5
    }, Eq = F4(function(r, n, e, t) {
        return A4(ZV, m([
            pV,
            hV,
            jV(AV(t))
        ]), r, n, e);
    }), zq = A3(Eq, Sq, Xd("Create Module"), "submit-module-creation-button"), Rq = bn("dd"), Vq = bn("dt"), Wq = yE("pt-lg-0"), Pq = yE("pt-3"), Gq = F3(function(r, n, e) {
        return {
            $: 15,
            a: r,
            b: n,
            c: e
        };
    }), Iq = A2(az, m([
        oz("10px"),
        JE("7px"),
        cz("0 0 10 7"),
        Gz("1.1")
    ]), m([
        A2(QE, b, m([
            uz("Created with Sketch.")
        ])),
        A2(xR, b, b),
        A2(Wz, m([
            Pz("Page-1"),
            nz("none"),
            tz("1"),
            YE("none"),
            Vz("evenodd")
        ]), m([
            A2(Wz, m([
                Pz("move-item"),
                YE("#FFFFFF")
            ]), m([
                A2(lG, m([
                    Pz("Triangle"),
                    MR("5 0 10 7 0 7")
                ]), b)
            ]))
        ]))
    ])), Nq = F2(function(r, n) {
        var e = r + 1, t = r - 1, a = "move-content-item-" + Ie(r) + "-up-click", u = "move-content-item-" + Ie(r) + "-down-mobile-click", c = "move-content-item-" + Ie(r) + "-down-click", o = PO(n);
        return A2(LE, m([
            yE("module-content-row")
        ]), m([
            A2(LE, m([
                yE("move-content-col")
            ]), m([
                A2(LE, m([
                    yE("move-controls")
                ]), m([
                    A2(CE, m([
                        EE(a),
                        yE("move-up-btn"),
                        gz(A3(Gq, r, t, a))
                    ]), m([
                        A2(HE, m([
                            yE("move-icon secondary-action-fill")
                        ]), m([
                            Iq
                        ])),
                        A2(fz, m([
                            yE("sr-only")
                        ]), m([
                            Xd("Reorder " + o.fu + " up")
                        ]))
                    ])),
                    A2(CE, m([
                        EE(c),
                        yE("move-down-btn"),
                        gz(A3(Gq, r, e, c))
                    ]), m([
                        A2(HE, m([
                            yE("move-icon move-icon-down secondary-action-fill")
                        ]), m([
                            Iq
                        ])),
                        A2(fz, m([
                            yE("sr-only")
                        ]), m([
                            Xd("Reorder " + o.fu + " down")
                        ]))
                    ]))
                ]))
            ])),
            A2(LE, m([
                yE("module-content-details-col")
            ]), m([
                A2(fG, b, m([
                    Xd(o.fu)
                ])),
                A2(xG, b, m([
                    Xd(o.fv)
                ]))
            ])),
            A2(LE, m([
                yE("module-content-time-col")
            ]), m([
                A2(fG, b, m([
                    Xd(o.ft)
                ]))
            ])),
            A2(LE, m([
                yE("move-content-mobile-col")
            ]), m([
                A2(CE, m([
                    EE(u),
                    yE("move-down-btn"),
                    gz(A3(Gq, r, e, u))
                ]), m([
                    A2(HE, m([
                        yE("move-icon move-icon-down secondary-action-fill")
                    ]), m([
                        Iq
                    ])),
                    A2(fz, m([
                        yE("sr-only")
                    ]), m([
                        Xd("Reorder " + o.fu + " down")
                    ]))
                ]))
            ]))
        ]));
    }), Zq = function(r) {
        return A2(LE, m([
            EE("content-area-row")
        ]), m([
            A2(LE, m([
                EE("content-area-col")
            ]), A2(Be, Nq, r))
        ]));
    }, Dq = function(r) {
        var n = function(r) {
            return r.$ ? A2(di, 0, r.a.hv) : r.a.hv;
        };
        return A2(LE, m([
            yE("col")
        ]), m([
            Xd("Total module length: "),
            Xd(bO(BN(A2(aa, n, r))))
        ]));
    }, _q = F3(function(r, n, e) {
        return A2(LE, b, m([
            A2(LE, m([
                yE("row")
            ]), m([
                A2(LE, m([
                    yE("col-lg-4 col-12")
                ]), m([
                    A2(Vq, m([
                        yE("font-weight-bold")
                    ]), m([
                        Xd(r + ":")
                    ]))
                ])),
                A2(LE, m([
                    yE("col-lg-8 col-12")
                ]), m([
                    A2(Rq, m([
                        yE("text-wrap"),
                        Pq,
                        Wq
                    ]), m([
                        Xd(n)
                    ]))
                ]))
            ])),
            Zq(e),
            A2(LE, m([
                yE("row text-right")
            ]), m([
                Dq(e)
            ]))
        ]));
    }), Oq = function(r) {
        return A3(Eq, {
            $: 8,
            a: r
        }, Xd("Update Module"), "submit-module-update-button");
    }, qq = F4(function(r, n, e, t) {
        var a = 1 === r.$ ? A2(Oq, r.a, t) : zq(t);
        return A2(LE, m([
            yE("mode-" + Tq(r))
        ]), m([
            A3(_q, n.kv, n.bz, e),
            A2(LE, m([
                yE("pro-card-bottom-row")
            ]), m([
                A2(LE, m([
                    yE("pro-card-bottom-col")
                ]), m([
                    a
                ]))
            ]))
        ]));
    }), Kq = F6(function(r, n, e, t, a, u) {
        return A4(nq, 2, function(r) {
            return A4(Mq, A2(Fq, r, Ve(2)), Xd("Step 3:"), Xd("Review and Save"), Xd(""));
        }(t), A4(qq, r, n, e, u), a);
    }), Uq = {
        $: 6
    }, Bq = {
        $: 7
    }, Qq = function(r) {
        return {
            $: 4,
            a: r
        };
    }, Yq = function(r) {
        return {
            $: 17,
            a: r
        };
    }, Jq = A2(az, m([
        oz("21.799"),
        JE("21.799"),
        cz("0 0 21.799 21.799")
    ]), m([
        A2(XE, m([
            BE("M-2268.908-1632.08l-7.778-7.778-7.778,7.778a1,1,0,0,1-1.414,0l-1.415-1.414a1,1,0,0,1,0-1.415l7.779-7.778-7.778-7.777a1,1,0,0,1,0-1.415l1.414-1.414a1,1,0,0,1,1.414,0l7.778,7.778,7.778-7.778a1,1,0,0,1,1.414,0l1.415,1.414a1,1,0,0,1,0,1.415l-7.779,7.778,7.779,7.778a1,1,0,0,1,0,1.414l-1.414,1.414a1,1,0,0,1-.707.293A1,1,0,0,1-2268.908-1632.08Z"),
            Qz("translate(2287.585 1653.586)"),
            YE("#ffffff")
        ]), b)
    ])), Xq = function(r) {
        return A2(RV, "data-toggle", r);
    }, rK = function(r) {
        var n, e = r.a;
        return A2(Hz, m([
            yE("nav-item tagSelectableContent")
        ]), m([
            A2(CE, m([
                gz((n = e.b5, {
                    $: 2,
                    a: n
                })),
                yE("nav-link btn btn-link tag-tab pb-2")
            ]), m([
                A2(fz, m([
                    yE("tag-tab-text")
                ]), m([
                    Xd(e.kv)
                ]))
            ]))
        ]));
    }, nK = function(r) {
        return {
            $: 11,
            a: r
        };
    }, eK = F3(function(r, n, e) {
        return {
            dW: n,
            el: r,
            gm: e
        };
    }), tK = function(r) {
        return {
            $: 12,
            a: r
        };
    }, aK = function(r) {
        return {
            $: 19,
            a: r
        };
    }, uK = F2(function(r, n) {
        return A2(lc, function(n) {
            return e(n.a.g7, r);
        }, n);
    }), cK = function(r) {
        var n = A2(La, 60, r), e = r / 60 | 0;
        return e ? Ie(e) + "M " + Ie(n) + "S" : Ie(n) + "S";
    }, oK = F2(function(r, n) {
        return A2(aa, function(r) {
            var e = sg({
                gT: r.gT,
                g7: r.g7,
                cC: r.cC,
                hv: r.hv,
                z: r.z
            }), t = r.cC ? A2(LE, m([
                yE("col-12 d-md-none pb-3 font-orange font-italic searchEpisodeCourse")
            ]), m([
                Xd("Licensed Content")
            ])) : A2(LE, b, b), a = r.cC ? A2(LE, m([
                yE("col-4 offset-6 d-none d-md-block font-orange font-italic pb-2")
            ]), m([
                Xd("Licensed Content")
            ])) : A2(LE, b, b), u = A2(di, 0, r.hv), c = A2(uK, r.g7, n) ? A3(eK, tK(m([
                e
            ])), AD("F4B43A"), "Unselect episode ") : A3(eK, r.cC ? aK({
                $: 3,
                a: e
            }) : nK(e), qG, "Select episode ");
            return A2(LE, m([
                yE("row border-top small")
            ]), m([
                A2(LE, m([
                    yE("col-12")
                ]), m([
                    A2(CE, A3(pz, m([
                        yE("px-0 btn btn-link selectEpisodeBtn d-flex flex-row justify-content-between align-items-center w-100 cursor-pointer text-left")
                    ]), "select-search-episode-" + _F(r.g7), c.el), m([
                        A2(LE, m([
                            yE("d-flex align-items-center col-9 col-sm-10 col-md-6 py-2")
                        ]), m([
                            c.dW,
                            A2(fz, m([
                                yE("sr-only")
                            ]), m([
                                Xd(c.gm)
                            ])),
                            A2(fz, m([
                                yE("ml-2 text-truncate")
                            ]), m([
                                Xd(r.z)
                            ]))
                        ])),
                        A2(LE, m([
                            yE("d-none d-md-block col-md-4 text-truncate")
                        ]), m([
                            Xd(r.gT)
                        ])),
                        A2(LE, m([
                            yE("col-3 col-sm-2 text-right text-nowrap font-weight-light")
                        ]), m([
                            Xd(cK(u))
                        ]))
                    ]))
                ])),
                a,
                A2(LE, m([
                    yE("col-12 d-md-none pb-3 text-truncate searchEpisodeCourse")
                ]), m([
                    Xd(r.gT)
                ])),
                t
            ]));
        }, r);
    }), iK = function(r) {
        return {
            $: 9,
            a: r
        };
    }, fK = F3(function(r, n, e) {
        return {
            $: 8,
            a: r,
            b: n,
            c: e
        };
    }), sK = F3(function(r, n, e) {
        return {
            $: 10,
            a: r,
            b: n,
            c: e
        };
    }), lK = {
        $: 20
    }, bK = function(r) {
        if (r.$) return A2(LE, b, b);
        var n = r.a, e = function() {
            switch(n.$){
                case 0:
                    return iK(n.a);
                case 1:
                    return A3(sK, n.a, n.b, n.c);
                case 2:
                    return A3(fK, n.a, n.b, n.c);
                default:
                    return nK(n.a);
            }
        }();
        return A2(LE, b, m([
            A2(kP, 0, A3(fP, b, m([
                A2(CE, A3(pz, m([
                    yE("btn btn-outline-dark")
                ]), "hide-licensed-content", lK), m([
                    Xd("Cancel")
                ])),
                A2(CE, A3(pz, m([
                    yE("btn btn-primary")
                ]), "confirm-licensed-content", e), m([
                    Xd("Confirm")
                ]))
            ]), A3(oP, b, m([
                A2(SP, b, m([
                    Xd("In order to comply with requirements from PeopleCert, the accreditation body for Axelos content, ACI Learning must validate that you have purchased an exam voucher in order to make the course associated with that exam voucher available to users on the ACI Learning platform.")
                ])),
                A2(SP, m([
                    yE("font-weight-bold")
                ]), m([
                    Xd("The selected content from the course will only be accessible by learners if ACI Learning has validated the above.")
                ])),
                A2(SP, b, m([
                    Xd("For more information about this new requirement, "),
                    A2(lE, m([
                        yE("font-orange btn-link"),
                        FE("https://help.acilearning.com/en/articles/4228401-peoplecert-exam-voucher-requirement"),
                        rG("_blank")
                    ]), m([
                        Xd("view this help article")
                    ])),
                    Xd(" or chat with our Success team by using the chat bubble.")
                ]))
            ]), A3(II, b, m([
                Xd("Licensed Content Notification")
            ]), iP(lK)))))
        ]));
    }, dK = function(r) {
        return {
            $: 21,
            a: r
        };
    }, vK = F3(function(r, n, t) {
        var a = n.a, u = n.b;
        if (r.$) return A2(LE, b, b);
        var c = r.a, o = A3(Nt, 0, 60, c) + "...";
        return a && e(t, u) ? A2(LE, m([
            yE("small font-weight-light")
        ]), m([
            Xd(c),
            A2(LE, m([
                gz(dK(t)),
                yE("descriptionToggle")
            ]), m([
                Xd("See Less")
            ]))
        ])) : A2(LE, m([
            yE("small font-weight-light")
        ]), m([
            A2(fz, b, m([
                Xd(o)
            ])),
            A2(fz, m([
                gz(dK(t)),
                yE("ml-2 descriptionToggle")
            ]), m([
                Xd("See More")
            ]))
        ]));
    }), mK = F5(function(r, n, e, t, a) {
        return A2(LE, m([
            yE("col-8")
        ]), m([
            A2(LE, m([
                yE("mb-1")
            ]), m([
                A2(VR, b, m([
                    Xd(r)
                ])),
                A2(LE, m([
                    yE("my-1")
                ]), m([
                    Xd(VO(n))
                ])),
                A3(vK, e, i(t, a), r)
            ]))
        ]));
    }), gK = F2(function(r, n) {
        return r ? A2(fz, b, m([
            AD("F4B43A"),
            A2(fz, m([
                yE("sr-only")
            ]), m([
                Xd("Unselect course " + n)
            ]))
        ])) : A2(fz, m([
            yE("addCourseSvg")
        ]), m([
            qG,
            A2(fz, m([
                yE("sr-only")
            ]), m([
                Xd("Select course " + n)
            ]))
        ]));
    }), pK = F3(function(r, n, e) {
        var t = e, a = n.dz, u = function() {
            if (r) {
                var e = FH(a);
                return tK(m([
                    e
                ]));
            }
            return t ? aK({
                $: 0,
                a: n
            }) : iK(n);
        }();
        return A2(LE, m([
            yE("col-2")
        ]), m([
            A2(LE, A3(pz, m([
                yE("text-right")
            ]), "select-course-" + _F(a.g7), u), m([
                A2(gK, r, a.kv)
            ]))
        ]));
    }), $K = F3(function(r, n, e) {
        return {
            $: 15,
            a: r,
            b: n,
            c: e
        };
    }), hK = F3(function(r, n, e) {
        return {
            $: 14,
            a: r,
            b: n,
            c: e
        };
    }), wK = F3(function(r, n, e) {
        return {
            $: 1,
            a: r,
            b: n,
            c: e
        };
    }), CK = F2(function(r, n) {
        return A2(Gx, function(r) {
            return A2(uK, r, n);
        }, r);
    }), kK = F3(function(r, n, e) {
        return {
            $: 2,
            a: r,
            b: n,
            c: e
        };
    }), yK = F3(function(r, n, e) {
        return {
            $: 13,
            a: r,
            b: n,
            c: e
        };
    }), xK = function(r) {
        return {
            $: 22,
            a: r
        };
    }, LK = F3(function(r, n, t) {
        var a = n.a, u = n.b;
        if (r.$) return A2(LE, b, b);
        var c = r.a, o = A3(Nt, 0, 60, c) + "...";
        return a && e(t, u) ? A2(LE, m([
            yE("small my-2")
        ]), m([
            Xd(c),
            A2(LE, m([
                gz(xK(t)),
                yE("descriptionToggle")
            ]), m([
                Xd("See Less")
            ]))
        ])) : A2(LE, m([
            yE("small my-2")
        ]), m([
            A2(fz, b, m([
                Xd(o)
            ])),
            A2(fz, m([
                gz(xK(t)),
                yE("ml-2 descriptionToggle")
            ]), m([
                Xd("See More")
            ]))
        ]));
    }), jK = F7(function(r, n, e, t, a, u, c) {
        var o = c.z, f = A2(TH, c, n), s = A2(di, 0, c.hv), b = t ? A3(eK, A3(yK, n, f, e), AD("F4B43A"), "Unselect episode ") : A2(uK, c.g7, r) ? A3(eK, tK(m([
            f
        ])), AD("F4B43A"), "Unselect episode ") : A3(eK, n.bP ? aK(A3(kK, n, f, e)) : A3(fK, n, f, e), qG, "Select episode ");
        return A2(LE, m([
            yE("row border-top small")
        ]), m([
            A2(LE, m([
                yE("col-12 my-2")
            ]), m([
                A2(CE, A3(pz, m([
                    yE("px-0 btn btn-link selectEpisodeBtn d-flex flex-row justify-content-between w-100")
                ]), "select-episode-" + _F(c.g7), b.el), m([
                    A2(LE, m([
                        yE("d-flex flex-row text-left")
                    ]), m([
                        b.dW,
                        A2(fz, m([
                            yE("sr-only")
                        ]), m([
                            Xd(l(b.gm, o))
                        ])),
                        A2(LE, m([
                            yE("ml-2")
                        ]), m([
                            Xd(o)
                        ]))
                    ])),
                    A2(LE, m([
                        yE("text-right text-nowrap font-weight-light ml-2")
                    ]), m([
                        Xd(cK(s))
                    ]))
                ])),
                A3(LK, c.bz, i(a, u), c.z)
            ]))
        ]));
    }), AK = F7(function(r, n, e, t, a, u, c) {
        var o = c.z, i = c.dH, f = A2(aa, function(r) {
            return A2(TH, r, n);
        }, i), s = A2(aa, function(r) {
            return r.g7;
        }, i), l = t ? A3(eK, A3(hK, n, c, e), AD("F4B43A"), "Unselect topic ") : A2(CK, s, r) ? A3(eK, tK(f), AD("F4B43A"), "Unselect topic ") : A3(eK, n.bP ? aK(A3(wK, n, c, e)) : A3(sK, n, c, e), qG, "Select topic ");
        return A2(LE, m([
            yE("mt-2")
        ]), m([
            A2(LE, m([
                yE("font-weight-bold topicTitle my-3")
            ]), m([
                A2(tV, m([
                    gz(l.el)
                ]), m([
                    A2(fz, m([
                        yE("mr-2")
                    ]), m([
                        l.dW
                    ])),
                    Xd(o)
                ]))
            ])),
            A2(LE, b, A2(aa, A6(jK, r, n, e, t, a, u), i))
        ]));
    }), MK = F6(function(r, n, e, t, a, u) {
        if (e.$) return A2(LE, b, m([
            Xd("Loading Topics...")
        ]));
        var c = e.a;
        return A2(LE, b, A2(aa, A6(AK, r, n, c, t, a, u), c));
    }), FK = F5(function(r, n, e, t, a) {
        var u = r.e1 ? "mr-3 toogle-episodes-open" : "mr-3";
        return A2(LE, m([
            yE("col-12")
        ]), m([
            A2(LE, m([
                yE("pl-4")
            ]), m([
                A2(CE, A3(pz, m([
                    yE("btn btn-link px-0")
                ]), "render-episode-" + _F(r.dz.g7), A3($K, r.dz.b5, r.e2, r.ke)), m([
                    A2(fz, m([
                        yE(u)
                    ]), m([
                        WV
                    ])),
                    A2(fz, m([
                        yE("sr-only")
                    ]), m([
                        Xd("toggle episodes for " + r.dz.kv)
                    ])),
                    Xd("Episodes")
                ])),
                r.e1 ? A2(LE, b, b) : A6(MK, n, r.dz, r.e2, e, t, a)
            ]))
        ]));
    }), HK = F6(function(r, n, e, t, a, u) {
        var c, o, i, f, s, l = u.dz, d = A2(uK, l.g7, r);
        return A2(LE, m([
            yE("my-4")
        ]), m([
            A2(LE, m([
                yE("row")
            ]), m([
                A5(mK, l.kv, l.lb, l.bz, n, e),
                (o = l.hv, A2(LE, m([
                    yE("col-2")
                ]), m([
                    A2(LE, m([
                        yE("text-right")
                    ]), m([
                        A2(fz, m([
                            yE("font-weight-light")
                        ]), m([
                            Xd((i = o, f = A2(La, 3600, i) / 60 | 0, s = i / 3600 | 0, s ? Ie(s) + "H " + Ie(f) + "M" : Ie(f) + "M"))
                        ]))
                    ]))
                ]))),
                A3(pK, d, u, l.bP)
            ])),
            (c = l.bP, c ? A2(LE, m([
                yE("row")
            ]), m([
                A2(LE, m([
                    yE("col-6")
                ]), m([
                    A2(LE, m([
                        yE("mb-1")
                    ]), m([
                        A2(LE, m([
                            yE("small font-italic font-orange")
                        ]), m([
                            Xd("Licensed Content")
                        ]))
                    ]))
                ]))
            ])) : A2(LE, b, b)),
            A2(LE, m([
                yE("row")
            ]), m([
                A5(FK, u, r, d, t, a)
            ]))
        ]));
    }), TK = F7(function(r, n, t, a, u, c, o) {
        var i = sc(A2(fc, function(n) {
            return e(n.a.b5, r);
        }, n));
        return A2(di, b, A2(Ba, function(r) {
            var n = r.a, e = r.b;
            if (e.$) {
                if (e.a.b) {
                    var i = e.a;
                    return A2(aa, A5(HK, t, a, u, c, o), i);
                }
                return m([
                    Xd("No courses for the tag: " + n.kv)
                ]);
            }
            return m([
                Xd("Waiting to load courses for the tag: " + n.kv)
            ]);
        }, i));
    }), SK = function(r) {
        var n = r.$ ? "20.3" : Oz(r.a);
        return A2(az, m([
            Gz("1.1"),
            Pz("searchIcon"),
            Jz("0px"),
            Xz("0px"),
            oz(n),
            cz("0 0 22 22"),
            FG("new 0 0 22 22;")
        ]), m([
            A2(XE, m([
                Pz("search"),
                YE("#fff"),
                BE("M21.7,20l-5.1-5.1c-0.1-0.1-0.2-0.1-0.4-0.1h-0.6c3.2-3.7,2.8-9.2-0.9-12.4S5.5-0.5,2.3,3.2 s-2.8,9.2,0.9,12.4c3.3,2.9,8.2,2.9,11.5,0v0.6c0,0.1,0.1,0.3,0.1,0.4l5.1,5.1c0.2,0.2,0.5,0.2,0.7,0c0,0,0,0,0,0l1-1 C21.9,20.5,21.9,20.2,21.7,20C21.7,20,21.7,20,21.7,20z M9,15.7c-3.7,0-6.8-3-6.8-6.8s3-6.8,6.8-6.8s6.8,3,6.8,6.8 C15.7,12.7,12.7,15.7,9,15.7C9,15.7,9,15.7,9,15.7z")
            ]), b)
        ]));
    }, EK = function(r) {
        var n = r;
        return m([
            A2(VR, m([
                yE("font-weight-bold mt-3")
            ]), m([
                Xd("Search Tips")
            ])),
            A2(Sz, m([
                yE("lt-blue-vertical-rule ml-2 pl-2 list-unstyled")
            ]), m([
                A2(Hz, m([
                    yE("pt-0 my-1")
                ]), m([
                    Xd('Use quotes for specific results like "Security+," "70-740," or "CCNA."')
                ])),
                A2(Hz, m([
                    yE("pt-0 my-1")
                ]), m([
                    Xd("Visit '"),
                    A2(AI, b, m([
                        A2(lE, m([
                            FE(A3(iG, n, m([
                                "course-library"
                            ]), b)),
                            rG("_blank")
                        ]), m([
                            Xd("Courses")
                        ]))
                    ])),
                    Xd("' to find results by category, job role, etc.")
                ])),
                A2(Hz, m([
                    yE("pt-0 my-1")
                ]), m([
                    Xd("Legacy courses are not included in search results. Go to the Legacy tab in '"),
                    A2(AI, b, m([
                        A2(lE, m([
                            FE(A3(iG, n, m([
                                "course-library"
                            ]), m([
                                A2(R$, "tagcategory", "course-library"),
                                A2(R$, "tag", "legacy")
                            ]))),
                            rG("_blank")
                        ]), m([
                            Xd("Courses")
                        ]))
                    ])),
                    Xd("' to browse legacy content.")
                ]))
            ]))
        ]);
    }, zK = function(r) {
        var n = r.le, t = r.bZ, a = function() {
            var n = r.w;
            switch(n.$){
                case 0:
                    var e = r.b_;
                    return e.$ ? b : A7(TK, e.a, r.le, t, r.X.a, r.X.b, r.Y.a, r.Y.b);
                case 1:
                    return 1 === It(r.aL) ? m([
                        A2(SP, b, m([
                            Xd("Search requires at least two characters")
                        ]))
                    ]) : b;
                case 2:
                    return m([
                        A2(LE, m([
                            yE("py-3")
                        ]), m([
                            IR
                        ]))
                    ]);
                case 3:
                    var a = n.a, u = n.b, c = n.c;
                    return m([
                        A2(Sz, m([
                            yE("nav nav-tabs my-4 resultContainer container"),
                            EE("searchTabs"),
                            XP("tablist")
                        ]), m([
                            A2(Hz, m([
                                yE("nav-item")
                            ]), m([
                                A2(CE, m([
                                    yE("nav-link"),
                                    Fz(m([
                                        i("active", !r.W)
                                    ])),
                                    EE("courses-tab"),
                                    Xq("tab"),
                                    XP("tab"),
                                    A2(VV, "controls", "course-results"),
                                    A2(VV, "selected", "true"),
                                    gz(Yq(0))
                                ]), m([
                                    Xd("Courses")
                                ]))
                            ])),
                            A2(Hz, m([
                                yE("nav-item")
                            ]), m([
                                A2(CE, m([
                                    yE("nav-link"),
                                    Fz(m([
                                        i("active", 1 === r.W)
                                    ])),
                                    EE("episodes-tab"),
                                    Xq("tab"),
                                    XP("tab"),
                                    A2(VV, "controls", "episode-results"),
                                    A2(VV, "selected", "true"),
                                    gz(Yq(1))
                                ]), m([
                                    Xd("Episodes")
                                ]))
                            ])),
                            A2(Hz, m([
                                yE("nav-item")
                            ]), m([
                                A2(CE, m([
                                    yE("nav-link"),
                                    Fz(m([
                                        i("active", 2 === r.W)
                                    ])),
                                    EE("bonus-series-tab"),
                                    Xq("tab"),
                                    XP("tab"),
                                    A2(VV, "controls", "bonus-results"),
                                    A2(VV, "selected", "true"),
                                    gz(Yq(2))
                                ]), m([
                                    Xd("Bonus Series")
                                ]))
                            ])),
                            A2(Hz, m([
                                yE("nav-item flex-grow-1")
                            ]), m([
                                A2(CE, m([
                                    yE("nav-link btn btn-sm btn-link font-orange float-right font-weight-bold pr-0"),
                                    EE("tips-tab"),
                                    Xq("tab"),
                                    XP("tab"),
                                    A2(VV, "controls", "search-tips"),
                                    A2(VV, "selected", "true"),
                                    gz(Yq(3))
                                ]), m([
                                    Xd("Not finding what you're looking for?")
                                ]))
                            ]))
                        ])),
                        A2(LE, m([
                            yE("tab-content"),
                            EE("searchTabsContent")
                        ]), m([
                            A2(LE, m([
                                yE("tab-pane fade"),
                                Fz(m([
                                    i("show active", !r.W)
                                ])),
                                EE("course-results"),
                                XP("tabpanel"),
                                A2(VV, "labelledby", "courses-tab")
                            ]), A2(aa, A5(HK, r.bZ, r.X.a, r.X.b, r.Y.a, r.Y.b), a)),
                            A2(LE, m([
                                yE("tab-pane fade"),
                                Fz(m([
                                    i("show active", 1 === r.W)
                                ])),
                                EE("episode-results"),
                                XP("tabpanel"),
                                A2(VV, "labelledby", "episodes-tab")
                            ]), A2(oK, u, t)),
                            A2(LE, m([
                                yE("tab-pane fade"),
                                Fz(m([
                                    i("show active", 2 === r.W)
                                ])),
                                EE("bonus-results"),
                                XP("tabpanel"),
                                A2(VV, "labelledby", "bonus-episodes-tab")
                            ]), A2(oK, c, t)),
                            A2(LE, m([
                                yE("tab-pane fade pb-3"),
                                Fz(m([
                                    i("show active", 3 === r.W)
                                ])),
                                EE("tip-results"),
                                XP("tabpanel"),
                                A2(VV, "labelledby", "tips-tab")
                            ]), EK(r.fk))
                        ]))
                    ]);
                default:
                    return m([
                        A2(LE, m([
                            yE("p-3")
                        ]), A2(ye, A2(SP, b, m([
                            Xd("Your search returned no results")
                        ])), EK(r.fk)))
                    ]);
            }
        }();
        return A2(LE, b, m([
            A2(LE, m([
                yE("row")
            ]), m([
                A2(LE, m([
                    yE("col-xl-10 offset-xl-1")
                ]), m([
                    A2(Sz, m([
                        yE("nav nav-tabs pb-3")
                    ]), A2(aa, rK, n)),
                    A2(LE, m([
                        yE("searchField d-flex")
                    ]), m([
                        A2(fz, m([
                            yE("btn btn-link")
                        ]), m([
                            SK(We)
                        ])),
                        A2(TE, m([
                            Fz(m([
                                i("flex-grow-1", !0),
                                i("hiddenOutline", r.cN)
                            ])),
                            PE(Qq),
                            HV(r.aL),
                            nR(Bq)
                        ]), b),
                        A2(CE, m([
                            Fz(m([
                                i("btn btn-link", !0),
                                i("d-none", e(r.w, Wm))
                            ])),
                            gz(Uq)
                        ]), m([
                            Jq,
                            A2(fz, m([
                                yE("sr-only")
                            ]), m([
                                Xd("Cancel search")
                            ]))
                        ]))
                    ])),
                    A2(LE, m([
                        yE("content-results")
                    ]), a)
                ]))
            ])),
            bK(r.R)
        ]));
    }, RK = F4(function(r, n, e, t) {
        return A2(LE, b, m([
            A2(iE, gm, zK(t)),
            A3(jq, r, n, e)
        ]));
    }), VK = function(r) {
        return {
            $: 2,
            a: r
        };
    }, WK = F2(function(r, n) {
        var e = Xd("Changing Courses and Episodes is not yet supported when editing a module.");
        return A3(wN, r, e, n);
    }), PK = F4(function(r, n, t, a) {
        var u = 1 === r.$ ? A2(WK, n, VK) : e(a, Ve(1)) || !t ? Xd("") : SW(m([
            yE("edit-area")
        ]));
        return A4(Mq, A2(Fq, a, Ve(1)), Xd("Step 2:"), Xd("Select Courses and Episodes"), A2(fz, m([
            yE("edit-area")
        ]), m([
            u
        ])));
    }), GK = F6(function(r, n, e, t, a, u) {
        var c = bH(e);
        return A4(nq, 1, A4(PK, r, n, c, t), A4(RK, c, 2, a, u), a);
    }), IK = function(r) {
        var n = function(r) {
            return A2(LE, m([
                yE("row mt-4")
            ]), m([
                A2(LE, m([
                    yE("text-center")
                ]), m([
                    r
                ]))
            ]));
        };
        switch(r.bQ){
            case 0:
                return n(Xd("Loading module..."));
            case 1:
                return function(r) {
                    return A2(uP, r.cc, A2(ZR, m([
                        A4(Hq, r.az, r.F, r.a0, r.E),
                        A6(GK, r.az, r.c5, r.C.bZ, r.a0, r.E, r.C),
                        A6(Kq, r.az, r.F, r.C.bZ, r.a0, r.E, r.bY)
                    ]), DR(Es(JO))));
                }(r);
            default:
                return n(Xd("Error loading module. Please try again or contact support."));
        }
    }, NK = function(r) {
        return A2(LE, m([
            yE("row")
        ]), m([
            A2(LE, m([
                yE("col-12")
            ]), m([
                IK(r)
            ]))
        ]));
    }, ZK = {
        $: 0
    }, DK = function(r) {
        return {
            $: 1,
            a: r
        };
    }, _K = function(r) {
        return A2(LE, m([
            yE("pro-card-title-row")
        ]), m([
            A2(LE, m([
                yE("pro-card-title-col")
            ]), m([
                A2(VR, m([
                    yE("text-capitalize")
                ]), m([
                    Xd(Tq(r.az) + " module"),
                    A2(fz, m([
                        yE("information-icon")
                    ]), m([
                        A2(pO, r.ea, DK)
                    ]))
                ]))
            ])),
            A2(LE, m([
                yE("pro-card-action-col")
            ]), m([
                A2(CE, m([
                    EE("cancel-module-creation-button-click"),
                    yE("btn-outline-secondary btn-sm btn-block btn"),
                    gz(ZK)
                ]), m([
                    Xd("Cancel")
                ]))
            ]))
        ]));
    }, OK = {
        $: 13
    }, qK = {
        $: 15
    }, KK = function(r) {
        return r.jM + " " + r.ka;
    }, UK = F2(function(r, n) {
        if (r.$) return A2(LE, b, b);
        var e, t = r.a;
        return A2(kP, n, A3(fP, b, m([
            A4(ZV, m([
                pV
            ]), (e = t.g7, {
                $: 7,
                a: e
            }), Xd("Yes"), "remove-team-member-" + t.g7)
        ]), A3(oP, b, m([
            Xd("This action will remove " + KK(t) + " from the team, but they will still have access to their ACI Learning account.")
        ]), A3(bP, b, m([
            Xd("Are You Sure?")
        ]), iP(qK)))));
    }), BK = A2(CE, m([
        yE("btn btn-outline-secondary btn-block btn-small"),
        EE("done-with-team"),
        gz({
            $: 2
        })
    ]), m([
        Xd("Done")
    ])), QK = {
        $: 10
    }, YK = function(r) {
        var n = r.lg;
        switch(n.$){
            case 0:
                return A2(LE, b, m([
                    Xd("Loading...")
                ]));
            case 1:
                var e = n.a;
                return A2(CE, A3(pz, m([
                    yE("btn btn-link-underline text-info"),
                    xE(AV(r.ct)),
                    wO("Download team activity"),
                    A2(VV, "label", "Download team activity")
                ]), "download-team-activity-" + fm(e.g7), QK), m([
                    A2(fz, m([
                        yE("text-info mr-2")
                    ]), m([
                        Xd("Team Activity")
                    ])),
                    A2(HE, m([
                        A2(VV, "label", "Download icon")
                    ]), m([
                        A2(fz, m([
                            yE("sr-only")
                        ]), m([
                            Xd("Download icon")
                        ])),
                        QI
                    ]))
                ]));
            default:
                return A2(LE, b, m([
                    Xd("Error")
                ]));
        }
    }, JK = function(r) {
        var n = r.lg;
        switch(n.$){
            case 0:
                return "Loading...";
            case 1:
                return n.a.kv;
            default:
                return "Error";
        }
    }, XK = F2(function(r, n) {
        return {
            $: 4,
            a: r,
            b: n
        };
    }), rU = function(r) {
        return {
            $: 5,
            a: r
        };
    }, nU = function(r) {
        return A2(CE, A3(pz, m([
            yE("btn btn-outline-secondary btn-block mb-4")
        ]), "member-activity-" + r.g7, {
            $: 3,
            a: r
        }), m([
            Xd("Activity")
        ]));
    }, eU = function(r) {
        var n;
        return A2(CE, m([
            gz((n = r, {
                $: 14,
                a: n
            })),
            yE("btn btn-sm btn-link-underline text-info")
        ]), m([
            Xd("Remove from Team")
        ]));
    }, tU = function(r) {
        var n, e, t, a = r.eX ? "false" : "true";
        return A2(LE, m([
            yE("row member-row")
        ]), m([
            A2(LE, m([
                yE("col-2 col-sm-1 text-right")
            ]), m([
                A2(HE, m([
                    gz((t = r.g7, {
                        $: 6,
                        a: t
                    })),
                    yE("toggle-team pb-4 pt-1 toggle pressed-" + a),
                    XP("button"),
                    A2(VV, "pressed", a)
                ]), m([
                    WV
                ]))
            ])),
            A2(LE, m([
                yE("col-5 col-sm-4")
            ]), m([
                A2(fG, m([
                    yE("member-name pt-2")
                ]), m([
                    Xd(KK(r))
                ]))
            ])),
            A2(LE, m([
                yE("col-md-4 col-lg-5 d-none d-md-block")
            ]), m([
                A2(fG, m([
                    yE("truncate pt-2")
                ]), m([
                    (e = r.iL, Xd(e))
                ]))
            ])),
            A2(LE, m([
                yE("col-5 col-sm-5 offset-sm-2 col-md-3 offset-md-0 col-lg-2")
            ]), m([
                A2(LE, m([
                    yE("activity-btn-col")
                ]), m([
                    nU(r)
                ]))
            ])),
            (n = r, 1 === n.eX ? A2(LE, b, b) : A2(LE, m([
                yE("col-12 d-flex justify-content-end team-member-options py-3")
            ]), m([
                eU(n)
            ])))
        ]));
    }, aU = function(r) {
        var n = r.lg;
        switch(n.$){
            case 0:
                return m([
                    A2(LE, m([
                        yE("col-12")
                    ]), m([
                        A2(LE, m([
                            yE("card-body")
                        ]), m([
                            Xd("Loading...")
                        ]))
                    ]))
                ]);
            case 1:
                var e = n.a;
                return m([
                    A2(LE, m([
                        yE("row justify-content-end my-4")
                    ]), m([
                        A2(LE, m([
                            yE("col-12 col-md-4")
                        ]), m([
                            A2(CE, m([
                                yE("btn btn-block btn-primary"),
                                EE("add-team-members-button"),
                                gz(A2(XK, r.E, e.g7))
                            ]), m([
                                Xd("Add Team Members")
                            ]))
                        ]))
                    ])),
                    A2(LE, m([
                        yE("row")
                    ]), m([
                        A2(LE, m([
                            yE("col")
                        ]), m([
                            A2(LE, m([
                                yE("form-group")
                            ]), m([
                                A2(TE, m([
                                    yE("form-control"),
                                    EE("team-member-search-in-team-detail-view"),
                                    A2(VV, "label", "Search by name or email address"),
                                    kW("search_for_users"),
                                    PE(rU),
                                    _E("Search by name or email address"),
                                    sz("text")
                                ]), b)
                            ]))
                        ]))
                    ])),
                    A2(LE, m([
                        yE("container-fluid")
                    ]), A2(aa, tU, r.ax))
                ]);
            default:
                return m([
                    A2(LE, m([
                        yE("col")
                    ]), m([
                        Xd("An error occured while fetching your team members. Please reload or contact support.")
                    ]))
                ]);
        }
    }, uU = {
        $: 14
    }, cU = {
        $: 17
    }, oU = {
        $: 0
    }, iU = F3(function(r, n, e) {
        var t;
        return eV({
            jb: m([
                A2(nV, m([
                    KR(m([
                        iV,
                        oV
                    ]))
                ]), m([
                    A2(LE, m([
                        yE("wizard-content-row")
                    ]), m([
                        A2(LE, m([
                            yE("wizard-content-col")
                        ]), e)
                    ]))
                ]))
            ]),
            jQ: A2(uV, m([
                cV,
                yE("wizard-header")
            ]), (t = n, A2(OR, m([
                _R,
                yE("card-subtitle")
            ]), m([
                A2(fz, b, m([
                    t
                ]))
            ])))),
            jW: am(r),
            kI: m([
                qR(m([
                    cV
                ]))
            ])
        });
    }), fU = F2(function(r) {
        return !_t(sH(r));
    }), sU = F2(function(r, n) {
        switch(n){
            case 0:
                return !0;
            case 1:
                return A2(fU, r, 0);
            default:
                return A2(fU, r, 1);
        }
    }), lU = {
        $: 8
    }, bU = function(r) {
        if (r.$) return A5(MV, 1, m([
            pV
        ]), lU, Xd("Create Team"), "save-team-button");
        var n = r.a;
        return A5(MV, 1, m([
            pV
        ]), {
            $: 11,
            a: n
        }, Xd("Update Team"), "update-team-button");
    }, dU = function(r) {
        return A2(LE, m([
            yE("row card-body")
        ]), m([
            A2(LE, m([
                yE("col-6")
            ]), m([
                Xd(A2(wD, r.jM, r.ka))
            ])),
            A2(LE, m([
                yE("col-6 truncate")
            ]), m([
                Xd(r.iL)
            ]))
        ]));
    }, vU = function(r) {
        return {
            $: 2,
            a: r
        };
    }, mU = F2(function(r, n) {
        return e(r, n) ? A2(fz, m([
            EV,
            A2(VV, "expanded", "false"),
            yE("toggle")
        ]), m([
            A2(fz, m([
                yE("sr-only")
            ]), m([
                Xd("Open collapsed content")
            ])),
            WV
        ])) : A2(fz, m([
            EV,
            A2(VV, "expanded", "true"),
            yE("toggle rotate-right")
        ]), m([
            A2(fz, m([
                yE("sr-only")
            ]), m([
                Xd("Collapse content")
            ])),
            WV
        ]));
    }), gU = F6(function(r, n, e, t, a, u) {
        var c = e ? m([
            gz(vU(n))
        ]) : b;
        return A2(fz, c, m([
            A2(fz, m([
                EV
            ]), m([
                A2(mU, r, n)
            ])),
            A2(fz, m([
                yE("font-weight-bold"),
                EV
            ]), m([
                t
            ])),
            A2(fz, m([
                yE("font-weight-light")
            ]), m([
                a
            ])),
            u
        ]));
    }), pU = F2(function(r, n) {
        return A6(gU, r, 2, n, Xd("Step 3:"), Xd("Review and Save"), Xd(""));
    }), $U = function(r) {
        return A3(iU, 2, A2(pU, r.a0, A2(sU, r.lh, 2)), function(r) {
            var n, e, t = A2(ye, A2(LE, m([
                yE("row card-body")
            ]), m([
                A2(LE, m([
                    yE("col-12")
                ]), m([
                    (e = r.lh, A2(fz, b, m([
                        A2(fz, m([
                            yE("font-weight-bold pr-2")
                        ]), m([
                            Xd("Team Name: ")
                        ])),
                        Xd(e)
                    ])))
                ]))
            ])), (n = r.y, A2(ye, A2(LE, m([
                yE("row card-body")
            ]), m([
                A2(LE, m([
                    yE("col-12 ")
                ]), m([
                    A2(fz, m([
                        yE("font-weight-bold pr-2")
                    ]), m([
                        Xd("Members: ")
                    ]))
                ]))
            ])), A2(aa, dU, n)))), a = A2(LE, m([
                yE("row card-body")
            ]), m([
                A2(LE, m([
                    yE("col-12 col-sm-4 offset-sm-8 col-xl-3 offset-xl-9")
                ]), m([
                    bU(r.iw)
                ]))
            ]));
            return l(t, m([
                a
            ]));
        }(r));
    }, hU = F3(function(r, n, e) {
        return A3(DV, r, vU(n), am(n) + "-" + e);
    }), wU = function(r) {
        return {
            $: 1,
            a: r
        };
    }, CU = F2(function(r, n) {
        var e = r ? SW(m([
            yE("icon")
        ])) : Xd("");
        return A6(gU, r, 0, n, Xd("Step 1:"), Xd("Name"), A2(fz, m([
            HW
        ]), m([
            e
        ])));
    }), kU = function(r) {
        return A3(iU, 0, A2(CU, r.a0, A2(sU, r.lh, 0)), function(r) {
            var n, e;
            return m([
                (n = r.lh, A2(ME, m([
                    ZE(vU(A2(sU, n, 1) ? 1 : 0))
                ]), m([
                    A2(LE, m([
                        yE("form-group row")
                    ]), m([
                        A2(LE, m([
                            yE("col-12")
                        ]), m([
                            mq(A3(uq, m([
                                cq("Team Name"),
                                Lq(n),
                                (e = m([
                                    eD(!1)
                                ]), {
                                    $: 9,
                                    a: e
                                })
                            ]), "new-team-name", A2($l, wU, Vt)))
                        ]))
                    ]))
                ]))),
                A2(LE, m([
                    yE("row")
                ]), m([
                    A2(LE, m([
                        yE("col-4 offset-8 col-xl-3 offset-xl-9")
                    ]), m([
                        A3(hU, A2(sU, r.lh, 1), 1, r.E)
                    ]))
                ]))
            ]);
        }(r));
    }, yU = function(r) {
        return {
            $: 5,
            a: r
        };
    }, xU = A2(az, m([
        oz("10px"),
        JE("10px"),
        cz("0 0 16 16"),
        Gz("1.1")
    ]), m([
        A2(XE, m([
            YE("#FFF"),
            BE("M9.41238815,7.99817459 L15.7763492,1.63421356 L14.3621356,0.219999999 L7.99817459,6.58396103 L1.63421356,0.219999999 L0.219999999,1.63421356 L6.58396103,7.99817459 L0.219999999,14.3621356 L1.63421356,15.7763492 L7.99817459,9.41238815 L14.3621356,15.7763492 L15.7763492,14.3621356 L9.41238815,7.99817459 Z")
        ]), b)
    ])), LU = function(r) {
        var n, e = A2(HE, m([
            A2(VV, "hidden", "true")
        ]), m([
            xU
        ])), t = A2(wD, r.jM, r.ka), a = m([
            Xd(" " === t ? r.iL : t),
            e
        ]);
        return A2(Hz, m([
            yE("list-inline-item mb-2")
        ]), m([
            A2(CE, m([
                yE("btn btn-xs badge badge-info removeTeamMateBtn"),
                gz((n = r, {
                    $: 7,
                    a: n
                }))
            ]), a)
        ]));
    }, jU = function(r) {
        var n;
        return A2(LE, m([
            yE("row pt-4")
        ]), m([
            A2(LE, m([
                yE("col-4")
            ]), m([
                Xd(A2(wD, r.jM, r.ka))
            ])),
            A2(LE, m([
                yE("col-4 col-xl-5 truncate")
            ]), m([
                Xd(r.iL)
            ])),
            A2(LE, m([
                yE("col-4 col-xl-3 text-right")
            ]), m([
                A2(CE, m([
                    gz((n = r, {
                        $: 6,
                        a: n
                    })),
                    EE("select-button-for-" + r.g7),
                    yE("btn btn-block btn-sm btn-outline-secondary")
                ]), m([
                    Xd("Select")
                ]))
            ]))
        ]));
    }, AU = function(r) {
        var n = r.aw;
        switch(n.$){
            case 0:
                return m([
                    Xd("Loading...")
                ]);
            case 1:
                var e = n.a, t = _t(r.a9) ? A2(fc, function(n) {
                    return !A2(bc, n, r.y);
                }, e) : r.ax;
                return A2(aa, jU, t);
            default:
                return m([
                    Xd("Error")
                ]);
        }
    }, MU = F2(function(r, n) {
        var e = 1 !== r && n ? SW(m([
            yE("icon")
        ])) : Xd("");
        return A6(gU, r, 1, n, Xd("Step 2:"), Xd("Select Team Members"), A2(fz, m([
            HW
        ]), m([
            e
        ])));
    }), FU = function(r) {
        return A3(iU, 1, A2(MU, r.a0, A2(sU, r.lh, 2)), function(r) {
            return m([
                A2(fI, m([
                    yE("selectedMember")
                ]), m([
                    Xd("Team Members Selected: " + Ie(Oe(r.y))),
                    A2(Sz, m([
                        yE("list-unstyled list-inline py-3")
                    ]), A2(aa, LU, r.y))
                ])),
                A2(LE, m([
                    yE("row pb-4")
                ]), m([
                    A2(LE, m([
                        yE("col-4 offset-8 col-xl-3 offset-xl-9")
                    ]), m([
                        A3(hU, A2(sU, r.lh, 2), 2, r.E)
                    ]))
                ])),
                A2(fI, b, m([
                    A2(LE, m([
                        yE("row")
                    ]), m([
                        A2(LE, m([
                            yE("col input-group")
                        ]), m([
                            A2(TE, m([
                                yE("form-control"),
                                EE("search-for-users"),
                                sz("text"),
                                _E("Search by name or email address"),
                                kW("search_for_users"),
                                eD(!1),
                                A2(VV, "label", "Search by name or email address"),
                                PE(yU),
                                HV(r.a9)
                            ]), b)
                        ]))
                    ]))
                ])),
                A2(fI, b, AU(r))
            ]);
        }(r));
    }, HU = function(r) {
        return A2(uP, r.cc, A2(ZR, m([
            kU(r),
            FU(r),
            $U(r)
        ]), DR(Es(oU))));
    }, TU = F2(function(r, n) {
        return {
            $: 0,
            a: r,
            b: n
        };
    }), SU = {
        $: 4
    }, EU = function(r) {
        return {
            $: 2,
            a: r
        };
    }, zU = function(r) {
        return {
            $: 1,
            a: r
        };
    }, RU = function(r) {
        var n = Ie(r) + "px";
        return A2(az, m([
            Jz("0px"),
            Xz("0px"),
            cz("0 0 254 251"),
            JE(n),
            FG("new 0 0 254 251")
        ]), m([
            A2(Wz, b, m([
                A2(XE, m([
                    YE("#ffffff"),
                    BE("M240.8,174.8V72.6h-14h-14v102.3H240.8z")
                ]), b),
                A2(XE, m([
                    YE("#ffffff"),
                    BE("M103.7,175h-27v-6c-11.3,7.4-18.8,8.1-30.5,7.4C33.5,175.5,12,166.2,12,145c0-28,29.7-45.5,63.5-29.6v-7.5\n\t\tc0.3-15.2-16.6-15-21.2-14.4c-12.7,1.7-19.5,6.5-29.1,11.6l-9.9-17.2C28.5,76.3,41.4,71.3,59,71.3c27.3,0,44.7,17.5,44.7,33.1V175z\n\t\t M75.5,137.7c-18.5-13.3-38.2-8.9-38.2,5.8c0,8.8,8.8,12.7,15.4,12.7c8.8,0,17.8-5.5,22.8-11.6V137.7z")
                ]), b),
                A2(XE, m([
                    YE("#ffffff"),
                    BE("M161.3,176.4c-9.6,0-18.3-2.3-25.9-6.9c-7.6-4.6-13.7-10.8-18.2-18.7c-4.4-8-6.6-17-6.6-27\n\t\tc0-10,2.2-19,6.6-26.8c4.5-8,10.6-14.3,18.2-18.8c7.6-4.6,16.3-6.9,25.9-6.9c8.9,0,17,1.6,24.4,4.8c7.5,3.2,13.4,7.6,17.8,13.3\n\t\tl-16.3,19.8c-1.7-2-3.8-3.9-6.2-5.7c-2.4-1.8-5-3.2-7.9-4.2c-2.9-1-5.9-1.5-9-1.5c-4.8,0-8.9,1.1-12.6,3.4\n\t\tc-3.6,2.2-6.4,5.2-8.4,9.1c-2,3.9-3,8.4-3,13.5c0,4.8,1,9.2,3,13.1c2.1,3.9,5,7,8.6,9.3c3.6,2.3,7.8,3.4,12.4,3.4\n\t\tc3.3,0,6.3-0.4,9-1.1c2.8-0.9,5.3-2.2,7.5-3.8c2.4-1.6,4.6-3.7,6.6-6.1l16.1,20c-4.3,5.5-10.2,9.8-17.8,12.9\n\t\tC178,174.8,170,176.4,161.3,176.4z")
                ]), b),
                A2(s_, m([
                    YE("#F4B43A"),
                    KE("226.6"),
                    UE("44.4"),
                    tI("15.4"),
                    aI("15.5")
                ]), b),
                A2(XE, m([
                    YE("#ffffff"),
                    BE("M17.1,221.8v-22.4h3.4v19.1H31v3.3H17.1z")
                ]), b),
                A2(XE, m([
                    YE("#ffffff"),
                    BE("M43.9,221.8v-22.4h14.1v3.3H47.3v15.8h10.6v3.3H43.9z M45.4,211.9v-3.3h10.8v3.3H45.4z")
                ]), b),
                A2(XE, m([
                    YE("#ffffff"),
                    BE("M68.8,221.8l8.6-22.4H81l8.6,22.4h-3.7l-5.1-13.5c-0.1-0.1-0.2-0.5-0.4-1.1c-0.2-0.6-0.4-1.2-0.6-1.9\n\t\tc-0.2-0.7-0.4-1.3-0.6-1.9c-0.2-0.6-0.3-1-0.4-1.2l0.7,0c-0.1,0.4-0.3,0.8-0.5,1.4c-0.2,0.6-0.4,1.1-0.6,1.8\n\t\tc-0.2,0.6-0.4,1.2-0.6,1.8c-0.2,0.5-0.4,1-0.5,1.3l-5.1,13.4H68.8z M72.6,216.2l1.3-3.3h10.1l1.5,3.3H72.6z")
                ]), b),
                A2(XE, m([
                    YE("#ffffff"),
                    BE("M101.1,221.8v-22.4h9.5c1.3,0,2.4,0.3,3.5,1c1.1,0.6,1.9,1.5,2.6,2.6c0.6,1.1,1,2.3,1,3.6c0,1.2-0.3,2.4-1,3.4\n\t\tc-0.6,1-1.5,1.9-2.6,2.5c-1.1,0.6-2.2,0.9-3.5,0.9h-6.1v8.4H101.1z M114.4,221.8l-5.7-10.1l3.5-0.8l6.3,11L114.4,221.8z M104.6,210\n\t\th6.4c0.6,0,1.2-0.2,1.7-0.4c0.5-0.3,0.9-0.7,1.1-1.3c0.3-0.6,0.4-1.2,0.4-1.8c0-0.7-0.2-1.4-0.5-2c-0.3-0.6-0.8-1-1.5-1.3\n\t\tc-0.6-0.3-1.3-0.5-2.1-0.5h-5.5V210z")
                ]), b),
                A2(XE, m([
                    YE("#ffffff"),
                    BE("M131,221.8v-22.4h3.1l13.7,18.4l-0.5,0.3c-0.1-0.5-0.2-1.1-0.2-1.7c-0.1-0.6-0.1-1.3-0.2-2\n\t\tc0-0.7-0.1-1.5-0.1-2.3c0-0.8,0-1.7-0.1-2.5c0-0.9,0-1.8,0-2.7v-7.4h3.4v22.4h-3.2l-13.4-17.7l0.4-0.4c0.1,1.3,0.2,2.4,0.3,3.3\n\t\tc0.1,0.9,0.1,1.7,0.2,2.3c0.1,0.6,0.1,1.1,0.1,1.5c0,0.4,0,0.7,0,1c0,0.3,0,0.5,0,0.7v9.3H131z")
                ]), b),
                A2(XE, m([
                    YE("#ffffff"),
                    BE("M163.1,221.8v-3.2h3.6v-16h-3.6v-3.2h10.7v3.2h-3.6v16h3.6v3.2H163.1z")
                ]), b),
                A2(XE, m([
                    YE("#ffffff"),
                    BE("M186.9,221.8v-22.4h3.1l13.7,18.4l-0.5,0.3c-0.1-0.5-0.2-1.1-0.2-1.7c-0.1-0.6-0.1-1.3-0.2-2\n\t\tc0-0.7-0.1-1.5-0.1-2.3c0-0.8,0-1.7-0.1-2.5c0-0.9,0-1.8,0-2.7v-7.4h3.4v22.4h-3.2l-13.4-17.7l0.4-0.4c0.1,1.3,0.2,2.4,0.3,3.3\n\t\tc0.1,0.9,0.1,1.7,0.2,2.3c0.1,0.6,0.1,1.1,0.1,1.5c0,0.4,0,0.7,0,1c0,0.3,0,0.5,0,0.7v9.3H186.9z")
                ]), b),
                A2(XE, m([
                    YE("#ffffff"),
                    BE("M229.8,222.1c-1.6,0-3.1-0.3-4.5-0.9c-1.4-0.6-2.6-1.4-3.7-2.5c-1.1-1-1.9-2.3-2.5-3.7\n\t\tc-0.6-1.4-0.9-2.9-0.9-4.6c0-1.6,0.3-3.1,0.9-4.5c0.6-1.4,1.4-2.6,2.5-3.6c1.1-1,2.3-1.9,3.7-2.4c1.4-0.6,2.9-0.9,4.5-0.9\n\t\tc1.1,0,2.2,0.2,3.3,0.5c1.1,0.3,2.1,0.8,2.9,1.3c0.9,0.6,1.6,1.2,2.1,2l-2.2,2.3c-0.6-0.6-1.3-1.1-2-1.5c-0.7-0.4-1.3-0.7-2-0.9\n\t\tc-0.7-0.2-1.4-0.3-2.1-0.3c-1.2,0-2.2,0.2-3.2,0.6c-1,0.4-1.8,1-2.6,1.7c-0.7,0.7-1.3,1.6-1.7,2.6c-0.4,1-0.6,2-0.6,3.2\n\t\tc0,1.1,0.2,2.2,0.6,3.2c0.4,1,1,1.8,1.8,2.6c0.8,0.7,1.6,1.3,2.6,1.8c1,0.4,2.1,0.6,3.2,0.6c0.8,0,1.6-0.1,2.4-0.4\n\t\tc0.7-0.3,1.4-0.6,2-1.1c0.6-0.4,1-1,1.3-1.5c0.3-0.6,0.5-1.2,0.5-1.9v-0.6l0.5,0.4h-6.8v-3.4h9.9c0,0.2,0.1,0.5,0.1,0.7\n\t\tc0,0.2,0,0.4,0,0.6c0,0.2,0,0.4,0,0.6c0,1.5-0.3,2.8-0.8,4c-0.5,1.2-1.2,2.2-2.1,3.1c-0.9,0.9-1.9,1.6-3.2,2.1\n\t\tC232.5,221.9,231.2,222.1,229.8,222.1z")
                ]), b)
            ]))
        ]));
    }, VU = bn("h1"), WU = function(r) {
        return A2(az, m([
            Gz("1.1"),
            Jz("0px"),
            Xz("0px"),
            JE("25px"),
            cz("0 0 24 18"),
            FG("new 0 0 24 18;")
        ]), m([
            A2(XE, m([
                Pz("sign-out"),
                YE(jD(r)),
                BE("M4.6,0.4h3.9C8.8,0.4,9,0.7,9,1V2c0,0.3-0.3,0.5-0.6,0.5H4.6c-1.2,0-2.2,0.9-2.2,2.1v8.6 c0,1.2,1,2.2,2.2,2.1h3.9C8.8,15.4,9,15.7,9,16V17c0,0.3-0.3,0.5-0.6,0.5H4.6c-2.4,0-4.4-1.9-4.5-4.3V4.7C0.1,2.3,2.1,0.4,4.6,0.4z  M15.3,1.3l-0.9,0.9c-0.2,0.2-0.2,0.5,0,0.7c0,0,0,0,0,0l5.3,4.9H8.1c-0.3,0-0.6,0.2-0.6,0.5v1.2c0,0.3,0.3,0.5,0.6,0.5h11.6 l-5.3,4.9c-0.2,0.2-0.2,0.5,0,0.7c0,0,0,0,0,0l0.9,0.9c0.2,0.2,0.6,0.2,0.8,0l7.7-7.3c0.2-0.2,0.2-0.5,0-0.7c0,0,0,0,0,0l-7.7-7.3 C15.9,1.1,15.5,1.1,15.3,1.3z")
            ]), b)
        ]));
    }, PU = F2(function(r, n) {
        return {
            $: 6,
            a: r,
            b: n
        };
    }), GU = {
        $: 5
    }, IU = F2(function(r, n) {
        var e = _t(r.cb) ? We : Ve(r.cb);
        return A2(LE, b, m([
            A2(kP, n, A3(fP, m([
                yE("d-flex justify-content-between")
            ]), m([
                A2(CE, m([
                    yE("btn btn-accent-translucent"),
                    gz(GU)
                ]), m([
                    Xd("Cancel")
                ])),
                A2(CE, m([
                    yE("btn btn-primary"),
                    gz(A2(PU, r, e))
                ]), m([
                    Xd("Apply")
                ]))
            ]), A3(oP, b, m([
                Xd("Are you sure you want to apply changes? These changes will apply to all users within this company and will show up upon next refresh for each user.")
            ]), A3(bP, b, m([
                Xd("Are You Sure?")
            ]), iP(GU)))))
        ]));
    }), NU = F2(function(r, n) {
        var e = r.n;
        if (e.$) switch(n){
            case 0:
                return qc.ad;
            case 1:
                return qc.ae;
            case 2:
                return qc.am;
            case 3:
                return qc.an;
            case 4:
                return qc.Z;
            default:
                return qc._;
        }
        else {
            var t = e.a;
            switch(n){
                case 0:
                    return t.ad;
                case 1:
                    return t.ae;
                case 2:
                    return t.am;
                case 3:
                    return t.an;
                case 4:
                    return t.Z;
                default:
                    return t._;
            }
        }
    }), ZU = {
        $: 44
    }, DU = function(r) {
        return {
            $: 30,
            a: r
        };
    }, _U = {
        $: 48
    }, OU = {
        $: 31
    }, qU = function(r) {
        var n = r.g8;
        if (1 === n.$) return r.fI;
        switch(n.a){
            case 0:
                return r.fI;
            case 2:
                return A2(Iw, function(r) {
                    return !r.bG.iY;
                }, r.fI);
            default:
                return A2(Iw, function(r) {
                    return 1 === r.bG.iY;
                }, r.fI);
        }
    }, KU = F2(function(r, n) {
        return A2(az, l(m([
            Jz("0px"),
            Xz("0px"),
            cz("0 0 202.7 196.8"),
            aR("my-2 my-md-3 mx-2"),
            JE("70px"),
            FG("new 0 0 202.7 196.8")
        ]), n), m([
            A2(QE, b, m([
                uz(r)
            ])),
            A2(XE, m([
                YE("none"),
                nz("#F0F0EA"),
                tz("3.94"),
                ez("square"),
                BE("M14.7,186.6v-38.4")
            ]), b),
            A2(XE, m([
                YE("none"),
                nz("#F0F0EA"),
                tz("3.94"),
                ez("square"),
                BE("M14.7,186.6l4.4,0")
            ]), b),
            A2(XE, m([
                YE("none"),
                nz("#F0F0EA"),
                tz("3.94"),
                ez("square"),
                BE("M14.7,148.3h4.4")
            ]), b),
            A2(XE, m([
                YE("#F8F8F6"),
                BE("M32.2,175.4v-15.6h6.7c1,0,1.8,0.2,2.6,0.7c0.8,0.4,1.4,1.1,1.8,1.8c0.5,0.8,0.7,1.6,0.7,2.6\n\tc0,1-0.2,1.9-0.7,2.7c-0.4,0.8-1.1,1.4-1.8,1.9c-0.8,0.5-1.6,0.7-2.6,0.7H36v5.2H32.2z M35.9,166.9h2.5c0.3,0,0.6-0.1,0.9-0.2\n\tc0.3-0.2,0.5-0.4,0.6-0.7c0.2-0.3,0.2-0.6,0.2-1c0-0.4-0.1-0.7-0.2-1c-0.2-0.3-0.4-0.5-0.6-0.6c-0.3-0.1-0.6-0.2-0.9-0.2h-2.5V166.9\n\tz M48.3,175.4v-15.6h7c1,0,1.9,0.2,2.7,0.6c0.8,0.4,1.5,1,1.9,1.8c0.5,0.7,0.7,1.6,0.7,2.5c0,1-0.2,1.9-0.7,2.6\n\tc-0.5,0.8-1.1,1.4-1.9,1.8c-0.8,0.4-1.7,0.7-2.7,0.7h-3.4v5.5H48.3z M56.9,175.4l-4-7l3.9-0.6l4.4,7.6H56.9z M51.9,167.1h3.1\n\tc0.4,0,0.7-0.1,1-0.2c0.3-0.2,0.5-0.4,0.7-0.7c0.2-0.3,0.2-0.7,0.2-1.1c0-0.4-0.1-0.7-0.3-1c-0.2-0.3-0.4-0.5-0.8-0.7\n\tc-0.3-0.2-0.7-0.2-1.2-0.2h-2.7V167.1z M72.1,175.7c-1.2,0-2.3-0.2-3.2-0.6c-1-0.4-1.8-1-2.6-1.7c-0.7-0.7-1.3-1.6-1.7-2.6\n\ts-0.6-2.1-0.6-3.2s0.2-2.2,0.6-3.2c0.4-1,1-1.8,1.7-2.6c0.7-0.7,1.6-1.3,2.6-1.7c1-0.4,2.1-0.6,3.2-0.6s2.2,0.2,3.2,0.6\n\tc1,0.4,1.8,1,2.6,1.7c0.7,0.7,1.3,1.6,1.7,2.6c0.4,1,0.6,2.1,0.6,3.2c0,1.2-0.2,2.2-0.6,3.2c-0.4,1-0.9,1.8-1.7,2.6\n\tc-0.7,0.7-1.6,1.3-2.6,1.7C74.3,175.5,73.2,175.7,72.1,175.7z M72.1,172.1c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,1-0.5,1.3-0.9\n\tc0.4-0.4,0.7-0.9,0.9-1.4c0.2-0.5,0.3-1.1,0.3-1.8s-0.1-1.3-0.3-1.8c-0.2-0.5-0.5-1-0.9-1.4c-0.4-0.4-0.8-0.7-1.3-1\n\tc-0.5-0.2-1.1-0.3-1.7-0.3s-1.2,0.1-1.7,0.3c-0.5,0.2-0.9,0.5-1.3,1c-0.4,0.4-0.7,0.9-0.9,1.4c-0.2,0.5-0.3,1.1-0.3,1.8\n\ts0.1,1.3,0.3,1.8c0.2,0.5,0.5,1,0.9,1.4c0.4,0.4,0.8,0.7,1.3,0.9C70.9,172,71.5,172.1,72.1,172.1z M84.7,175.4v-15.6h6.2\n\tc0.8,0,1.5,0.2,2.2,0.6c0.7,0.4,1.2,1,1.6,1.7c0.4,0.7,0.6,1.5,0.6,2.4c0,0.9-0.2,1.7-0.6,2.5c-0.4,0.7-0.9,1.3-1.6,1.7\n\tc-0.7,0.4-1.4,0.6-2.2,0.6h-4.4v6.1H84.7z M86.4,167.6H91c0.5,0,0.9-0.1,1.2-0.4c0.4-0.3,0.7-0.7,0.9-1.1c0.2-0.5,0.3-1,0.3-1.6\n\tc0-0.5-0.1-1-0.3-1.5c-0.2-0.4-0.5-0.8-0.9-1c-0.4-0.3-0.8-0.4-1.2-0.4h-4.5V167.6z M106.3,175.7c-1.1,0-2.1-0.2-3-0.6\n\tc-0.9-0.4-1.7-1-2.4-1.7c-0.7-0.7-1.2-1.5-1.6-2.5c-0.4-1-0.6-2-0.6-3.2c0-1.2,0.2-2.2,0.6-3.2c0.4-1,0.9-1.8,1.6-2.5\n\tc0.7-0.7,1.5-1.3,2.4-1.7c0.9-0.4,1.9-0.6,3-0.6c1.1,0,2.1,0.2,3,0.6c0.9,0.4,1.7,0.9,2.4,1.7c0.7,0.7,1.2,1.6,1.6,2.5\n\tc0.4,1,0.6,2,0.6,3.2c0,1.1-0.2,2.2-0.6,3.2c-0.4,1-0.9,1.8-1.6,2.5c-0.7,0.7-1.5,1.3-2.4,1.7C108.4,175.5,107.4,175.7,106.3,175.7z\n\t M106.3,174c0.8,0,1.6-0.1,2.3-0.4c0.7-0.3,1.3-0.7,1.9-1.3c0.5-0.6,0.9-1.2,1.2-2c0.3-0.8,0.4-1.6,0.4-2.5c0-0.9-0.1-1.8-0.4-2.5\n\tc-0.3-0.8-0.7-1.4-1.2-2c-0.5-0.6-1.1-1-1.9-1.3c-0.7-0.3-1.5-0.5-2.3-0.5s-1.6,0.2-2.4,0.5c-0.7,0.3-1.3,0.7-1.8,1.3\n\tc-0.5,0.6-0.9,1.2-1.2,2c-0.3,0.8-0.4,1.6-0.4,2.5c0,0.9,0.1,1.7,0.4,2.5c0.3,0.8,0.7,1.4,1.2,2c0.5,0.6,1.1,1,1.8,1.3\n\tC104.7,173.8,105.5,174,106.3,174z M118.7,175.4v-15.6h6.1c0.9,0,1.7,0.2,2.4,0.6c0.7,0.4,1.3,1,1.8,1.7c0.4,0.7,0.6,1.5,0.6,2.5\n\tc0,0.9-0.2,1.6-0.6,2.3c-0.4,0.7-1,1.3-1.7,1.7c-0.7,0.4-1.5,0.6-2.4,0.6h-4.5v6.1H118.7z M128.2,175.4l-3.9-6.8l1.7-0.6l4.3,7.4\n\tH128.2z M120.4,167.6h4.6c0.5,0,1-0.1,1.4-0.4s0.7-0.6,1-1c0.2-0.4,0.4-0.9,0.4-1.5c0-0.6-0.1-1.1-0.4-1.6c-0.3-0.5-0.7-0.8-1.2-1.1\n\tc-0.5-0.3-1.1-0.4-1.7-0.4h-4.1V167.6z M137.1,175.4v-13.9h-4.4v-1.7h10.8v1.7h-4.6v13.9H137.1z M144.9,175.4l6-15.6h2l5.9,15.6\n\th-1.9l-3.8-10.1c-0.1-0.3-0.2-0.6-0.4-1c-0.1-0.4-0.3-0.8-0.4-1.2c-0.1-0.4-0.3-0.8-0.4-1.2c-0.1-0.4-0.2-0.7-0.3-1h0.4\n\tc-0.1,0.4-0.2,0.7-0.4,1.1c-0.1,0.4-0.2,0.7-0.4,1.1c-0.1,0.4-0.3,0.7-0.4,1.1c-0.1,0.4-0.3,0.7-0.4,1.1l-3.8,10H144.9z\n\t M147.4,171.2l0.6-1.7h7.4l0.7,1.7H147.4z M162.9,175.4v-15.6h1.7v13.9h7.5v1.7H162.9z")
            ]), b),
            A2(XE, m([
                YE("none"),
                nz("#F0F0EA"),
                tz("3.94"),
                ez("square"),
                BE("M188.7,148.3v38.4")
            ]), b),
            A2(XE, m([
                YE("none"),
                nz("#F0F0EA"),
                tz("3.94"),
                ez("square"),
                BE("M188.7,148.3h-4.4")
            ]), b),
            A2(XE, m([
                YE("none"),
                nz("#F0F0EA"),
                tz("3.94"),
                ez("square"),
                BE("M188.7,186.6h-4.4")
            ]), b),
            A2(Wz, b, m([
                A2(XE, m([
                    YE("#F8F8F6"),
                    BE("M164.5,94.2V37.3h-7.8h-7.8v56.9H164.5z")
                ]), b),
                A2(XE, m([
                    YE("#F8F8F6"),
                    BE("M87.9,93.5H72.8v-3.3c-6.3,4.1-10.5,4.5-17.1,4.1c-7,0-19.1-5.7-19.1-17.5c0-15.6,16.6-25.3,35.5-16.5v-4.2\n\t\tc0.2-8.4-9.3-7.8-11.8-7.5c-7.1,0.9-10.9,3.6-16.3,6.5l-5.6-9.5c7.4-6.5,14.6-9.2,24.4-9.2c15.3,0,25,9.2,25,17.9V93.5z M72.2,72.8\n\t\tc-10.4-7.4-21.4-4.9-21.4,3.2c0,4.9,4.9,7.1,8.6,7.1c4.9,0,10-3.1,12.8-6.5V72.8z")
                ]), b),
                A2(XE, m([
                    YE("#F8F8F6"),
                    BE("M120.2,95c-5.4,0-10.2-1.3-14.5-3.8c-4.3-2.5-7.6-6-10.2-10.4c-2.4-4.4-3.7-9.5-3.7-15\n\t\tc0-5.6,1.2-10.5,3.7-14.9c2.5-4.4,5.9-7.9,10.2-10.5c4.3-2.5,9.1-3.8,14.5-3.8c5,0,9.5,0.9,13.6,2.6c4.2,1.8,7.5,4.2,10,7.4\n\t\tl-9.1,11c-1-1.1-2.1-2.2-3.5-3.2c-1.3-1-2.8-1.8-4.4-2.3c-1.6-0.6-3.3-0.8-5-0.8c-2.7,0-5,0.6-7,1.9c-2,1.2-3.6,2.9-4.7,5.1\n\t\tc-1.1,2.2-1.7,4.7-1.7,7.5c0,2.7,0.6,5.1,1.7,7.3c1.2,2.2,2.8,3.9,4.8,5.2c2,1.3,4.3,1.9,6.9,1.9c1.8,0,3.5-0.2,5-0.6\n\t\tc1.5-0.5,2.9-1.2,4.2-2.1c1.3-0.9,2.5-2,3.7-3.4l9,11.1c-2.4,3-5.7,5.4-10,7.2C129.5,94.2,125,95,120.2,95z")
                ]), b),
                A2(qE, m([
                    YE("#F4B43A"),
                    KE("156.6"),
                    UE("21.6"),
                    rz("8.6")
                ]), b),
                A2(XE, m([
                    YE("#F8F8F6"),
                    BE("M39.6,120.3v-12.5h1.9v10.6h5.8v1.9H39.6z")
                ]), b),
                A2(XE, m([
                    YE("#F8F8F6"),
                    BE("M54.5,120.3v-12.5h7.9v1.9h-5.9v8.8h5.9v1.9H54.5z M55.4,114.8V113h6v1.9H55.4z")
                ]), b),
                A2(XE, m([
                    YE("#F8F8F6"),
                    BE("M68.5,120.3l4.8-12.5h2l4.8,12.5H78l-2.9-7.5c0-0.1-0.1-0.3-0.2-0.6c-0.1-0.3-0.2-0.7-0.3-1.1\n\t\tc-0.1-0.4-0.2-0.7-0.4-1.1c-0.1-0.3-0.2-0.5-0.2-0.6l0.4,0c-0.1,0.2-0.2,0.5-0.3,0.8c-0.1,0.3-0.2,0.6-0.3,1\n\t\tc-0.1,0.3-0.2,0.7-0.3,1c-0.1,0.3-0.2,0.5-0.3,0.7l-2.8,7.5H68.5z M70.6,117.2l0.7-1.9H77l0.8,1.9H70.6z")
                ]), b),
                A2(XE, m([
                    YE("#F8F8F6"),
                    BE("M86.5,120.3v-12.5h5.3c0.7,0,1.4,0.2,2,0.5c0.6,0.3,1.1,0.8,1.4,1.4c0.4,0.6,0.5,1.3,0.5,2\n\t\tc0,0.7-0.2,1.3-0.5,1.9c-0.4,0.6-0.8,1.1-1.4,1.4c-0.6,0.3-1.3,0.5-2,0.5h-3.4v4.7H86.5z M93.9,120.3l-3.2-5.6l2-0.4l3.5,6.1\n\t\tL93.9,120.3z M88.4,113.7H92c0.3,0,0.7-0.1,0.9-0.2c0.3-0.2,0.5-0.4,0.6-0.7c0.2-0.3,0.2-0.6,0.2-1c0-0.4-0.1-0.8-0.3-1.1\n\t\tc-0.2-0.3-0.5-0.6-0.8-0.7c-0.3-0.2-0.7-0.3-1.2-0.3h-3.1V113.7z")
                ]), b),
                A2(XE, m([
                    YE("#F8F8F6"),
                    BE("M103.2,120.3v-12.5h1.7l7.6,10.2l-0.3,0.2c0-0.3-0.1-0.6-0.1-1c0-0.4-0.1-0.7-0.1-1.1c0-0.4,0-0.8-0.1-1.3\n\t\tc0-0.5,0-0.9,0-1.4c0-0.5,0-1,0-1.5v-4.1h1.9v12.5h-1.8l-7.5-9.8l0.2-0.2c0.1,0.7,0.1,1.3,0.1,1.9c0,0.5,0.1,0.9,0.1,1.3\n\t\tc0,0.3,0.1,0.6,0.1,0.9c0,0.2,0,0.4,0,0.5c0,0.1,0,0.3,0,0.4v5.2H103.2z")
                ]), b),
                A2(XE, m([
                    YE("#F8F8F6"),
                    BE("M121.1,120.3v-1.8h2v-8.9h-2v-1.8h6v1.8h-2v8.9h2v1.8H121.1z")
                ]), b),
                A2(XE, m([
                    YE("#F8F8F6"),
                    BE("M134.4,120.3v-12.5h1.7l7.6,10.2l-0.3,0.2c0-0.3-0.1-0.6-0.1-1c0-0.4-0.1-0.7-0.1-1.1c0-0.4,0-0.8-0.1-1.3\n\t\tc0-0.5,0-0.9,0-1.4c0-0.5,0-1,0-1.5v-4.1h1.9v12.5h-1.8l-7.5-9.8l0.2-0.2c0.1,0.7,0.1,1.3,0.1,1.9c0,0.5,0.1,0.9,0.1,1.3\n\t\tc0,0.3,0.1,0.6,0.1,0.9c0,0.2,0,0.4,0,0.5c0,0.1,0,0.3,0,0.4v5.2H134.4z")
                ]), b),
                A2(XE, m([
                    YE("#F8F8F6"),
                    BE("M158.4,120.5c-0.9,0-1.7-0.2-2.5-0.5c-0.8-0.3-1.5-0.8-2.1-1.4c-0.6-0.6-1.1-1.3-1.4-2\n\t\tc-0.3-0.8-0.5-1.6-0.5-2.5c0-0.9,0.2-1.7,0.5-2.5c0.3-0.8,0.8-1.4,1.4-2c0.6-0.6,1.3-1,2.1-1.4c0.8-0.3,1.6-0.5,2.5-0.5\n\t\tc0.6,0,1.2,0.1,1.8,0.3c0.6,0.2,1.2,0.4,1.6,0.7c0.5,0.3,0.9,0.7,1.2,1.1l-1.2,1.3c-0.4-0.3-0.7-0.6-1.1-0.9\n\t\tc-0.4-0.2-0.7-0.4-1.1-0.5c-0.4-0.1-0.8-0.2-1.2-0.2c-0.6,0-1.2,0.1-1.8,0.3c-0.5,0.2-1,0.5-1.4,0.9c-0.4,0.4-0.7,0.9-0.9,1.4\n\t\tc-0.2,0.5-0.3,1.1-0.3,1.8c0,0.6,0.1,1.2,0.4,1.8c0.2,0.5,0.6,1,1,1.4c0.4,0.4,0.9,0.7,1.5,1c0.6,0.2,1.1,0.4,1.8,0.4\n\t\tc0.5,0,0.9-0.1,1.3-0.2c0.4-0.1,0.8-0.3,1.1-0.6c0.3-0.2,0.6-0.5,0.7-0.9c0.2-0.3,0.3-0.7,0.3-1.1v-0.4l0.3,0.2h-3.8v-1.9h5.5\n\t\tc0,0.1,0,0.3,0.1,0.4c0,0.1,0,0.2,0,0.4c0,0.1,0,0.2,0,0.3c0,0.8-0.1,1.6-0.4,2.2c-0.3,0.7-0.7,1.2-1.2,1.7\n\t\tc-0.5,0.5-1.1,0.9-1.8,1.1C159.9,120.3,159.2,120.5,158.4,120.5z")
                ]), b)
            ]))
        ]));
    }), UU = A2(az, m([
        cz("0 0 448 512"),
        YE("#fff")
    ]), m([
        A2(XE, m([
            BE("M248 320C248 333.3 237.3 344 224 344C210.7 344 200 333.3 200 320V216C200 202.7 210.7 192 224 192C237.3 192 248 202.7 248 216V320zM144 24C144 10.75 154.7 0 168 0H280C293.3 0 304 10.75 304 24C304 37.25 293.3 48 280 48H248V97.37C291.4 102.4 330.8 120.7 361.8 148.2L391 119C400.4 109.7 415.6 109.7 424.1 119C434.3 128.4 434.3 143.6 424.1 152.1L393.9 184C417.9 217.9 432 259.3 432 304C432 418.9 338.9 512 224 512C109.1 512 16 418.9 16 304C16 197.2 96.43 109.3 200 97.37V48H168C154.7 48 144 37.25 144 24V24zM224 464C312.4 464 384 392.4 384 304C384 215.6 312.4 144 224 144C135.6 144 64 215.6 64 304C64 392.4 135.6 464 224 464z")
        ]), b)
    ])), BU = A2(az, m([
        Gz("1.1"),
        Pz("Layer_1"),
        Jz("0px"),
        Xz("0px"),
        cz("0 0 22 16"),
        JE("35px"),
        FG("new 0 0 22 16;")
    ]), m([
        A2(XE, m([
            Pz("tachometer-alt-fast"),
            YE("#FFFFFF"),
            BE("M15.5,10.2c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1l0,0 C16,9.1,15.5,9.6,15.5,10.2z M8.8,11.4c0,0.4,0.1,0.8,0.3,1.1h3.9c0.4-0.7,0.4-1.5,0-2.2l2.6-3.4c0.3-0.4,0.2-0.9-0.1-1.2 s-0.9-0.2-1.2,0.1l0,0l-2.7,3.4c-1.2-0.4-2.4,0.3-2.8,1.5C8.8,10.9,8.8,11.1,8.8,11.4L8.8,11.4z M12.1,4.6c0-0.6-0.5-1.1-1.1-1.1 c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1C11.6,5.8,12.1,5.3,12.1,4.6C12.1,4.6,12.1,4.6,12.1,4.6z M5.4,9.1 c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1C6.5,9.6,6,9.1,5.4,9.1C5.4,9.1,5.4,9.1,5.4,9.1z M7.1,7.4 c0.6,0,1.1-0.5,1.1-1.1S7.7,5.2,7.1,5.2S6,5.7,6,6.3l0,0C6,6.9,6.5,7.4,7.1,7.4z M0.9,10.2c0,1.8,0.5,3.5,1.4,5.1 c0.2,0.3,0.6,0.5,1,0.5h15.5c0.4,0,0.8-0.2,1-0.5c2.8-4.8,1.2-11-3.7-13.8S5.1,0.4,2.3,5.2C1.4,6.7,0.9,8.5,0.9,10.2z M2.6,10.2 c0-4.6,3.7-8.4,8.4-8.4c4.6,0,8.4,3.7,8.4,8.4c0,1.4-0.3,2.7-1,4H3.6C2.9,12.9,2.6,11.6,2.6,10.2z")
        ]), b)
    ])), QU = F2(function(r, n) {
        var t = i(r.a, r.b);
        r: for(;;)switch(t.b.$){
            case 0:
                if (1 === t.a.$) break r;
                return e(n, Ms);
            case 2:
                if (1 === t.a.$) break r;
                return e(n, Ls);
            case 1:
                if (1 === t.a.$) break r;
                return e(n, Df);
            case 3:
                if (1 === t.a.$) break r;
                return e(n, $s);
            case 5:
                if (1 === t.a.$) break r;
                return e(n, ws);
            default:
                if (1 === t.a.$) break r;
                return !1;
        }
        return e(n, Xf);
    }), YU = bn("nav"), JU = A2(az, m([
        cz("0 0 384 512"),
        YE("#fff")
    ]), m([
        A2(XE, m([
            BE("M365.3 93.38l-74.63-74.64C278.6 6.742 262.3 0 245.4 0H64C28.65 0 0 28.65 0 64l.0065 384c0 35.34 28.65 64 64 64H320c35.2 0 64-28.8 64-64V138.6C384 121.7 377.3 105.4 365.3 93.38zM336 448c0 8.836-7.164 16-16 16H64.02c-8.838 0-16-7.164-16-16L48 64.13c0-8.836 7.164-16 16-16h160L224 128c0 17.67 14.33 32 32 32h79.1V448zM192 256C178.8 256 168 266.8 168 280v128c0 13.25 10.75 24 24 24s24-10.75 24-24v-128C216 266.8 205.3 256 192 256zM256 408c0 13.25 10.75 24 24 24s24-10.75 24-24v-96C304 298.8 293.3 288 280 288S256 298.8 256 312V408zM104 320c-13.25 0-24 10.75-24 24v64c0 13.25 10.75 24 24 24S128 421.3 128 408v-64C128 330.8 117.3 320 104 320z")
        ]), b)
    ])), XU = A2(az, m([
        JE("30px"),
        cz("0 0 512 512")
    ]), m([
        A2(XE, m([
            eR("1"),
            YE("#ffffff"),
            BE("M256 0c17 0 33.6 1.7 49.8 4.8c7.9 1.5 21.8 6.1 29.4 20.1c2 3.7 3.6 7.6 4.6 11.8l9.3 38.5C350.5 81 360.3 86.7 366 85l38-11.2c4-1.2 8.1-1.8 12.2-1.9c16.1-.5 27 9.4 32.3 15.4c22.1 25.1 39.1 54.6 49.9 86.3c2.6 7.6 5.6 21.8-2.7 35.4c-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10c8.2 13.6 5.2 27.8 2.7 35.4c-10.8 31.7-27.8 61.1-49.9 86.3c-5.3 6-16.3 15.9-32.3 15.4c-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8c-7.7 14-21.6 18.5-29.4 20.1C289.6 510.3 273 512 256 512s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1c-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9c-16.1 .5-27-9.4-32.3-15.4c-22-25.1-39.1-54.6-49.9-86.3c-2.6-7.6-5.6-21.8 2.7-35.4c2.2-3.6 4.9-7 8-10L53 265.7c4.2-4 4.2-15.5 0-19.5L24.2 218.9c-3.1-3-5.8-6.4-8-10C8 195.3 11 181.1 13.6 173.6c10.8-31.7 27.8-61.1 49.9-86.3c5.3-6 16.3-15.9 32.3-15.4c4.1 .1 8.2 .8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8c7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zM218.1 51.4l-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6L97.9 120.9c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89L59.9 325.4c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zM208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192z")
        ]), b)
    ])), rB = A2(az, m([
        cz("0 0 640 512"),
        YE("#fff")
    ]), m([
        A2(XE, m([
            BE("M319.9 320c57.41 0 103.1-46.56 103.1-104c0-57.44-46.54-104-103.1-104c-57.41 0-103.1 46.56-103.1 104C215.9 273.4 262.5 320 319.9 320zM319.9 160c30.85 0 55.96 25.12 55.96 56S350.7 272 319.9 272S263.9 246.9 263.9 216S289 160 319.9 160zM512 160c44.18 0 80-35.82 80-80S556.2 0 512 0c-44.18 0-80 35.82-80 80S467.8 160 512 160zM369.9 352H270.1C191.6 352 128 411.7 128 485.3C128 500.1 140.7 512 156.4 512h327.2C499.3 512 512 500.1 512 485.3C512 411.7 448.4 352 369.9 352zM178.1 464c10.47-36.76 47.36-64 91.14-64H369.9c43.77 0 80.66 27.24 91.14 64H178.1zM551.9 192h-61.84c-12.8 0-24.88 3.037-35.86 8.24C454.8 205.5 455.8 210.6 455.8 216c0 33.71-12.78 64.21-33.16 88h199.7C632.1 304 640 295.6 640 285.3C640 233.8 600.6 192 551.9 192zM183.9 216c0-5.449 .9824-10.63 1.609-15.91C174.6 194.1 162.6 192 149.9 192H88.08C39.44 192 0 233.8 0 285.3C0 295.6 7.887 304 17.62 304h199.5C196.7 280.2 183.9 249.7 183.9 216zM128 160c44.18 0 80-35.82 80-80S172.2 0 128 0C83.82 0 48 35.82 48 80S83.82 160 128 160z")
        ]), b)
    ])), nB = A2(az, m([
        cz("0 0 448 512"),
        YE("#fff")
    ]), m([
        A2(XE, m([
            BE("M272 304h-96C78.8 304 0 382.8 0 480c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32C448 382.8 369.2 304 272 304zM48.99 464C56.89 400.9 110.8 352 176 352h96c65.16 0 119.1 48.95 127 112H48.99zM224 256c70.69 0 128-57.31 128-128c0-70.69-57.31-128-128-128S96 57.31 96 128C96 198.7 153.3 256 224 256zM224 48c44.11 0 80 35.89 80 80c0 44.11-35.89 80-80 80S144 172.1 144 128C144 83.89 179.9 48 224 48z")
        ]), b)
    ])), eB = function(r) {
        var n = r.gW;
        if (n.$) return A2(YU, m([
            EE("bottomNav"),
            yE("d-flex flex-row justify-content-between align-items-center d-md-none fixed-bottom"),
            XP("navigation")
        ]), b);
        var e = n.a, t = m([
            A2(Hz, m([
                yE("nav-item")
            ]), m([
                A2(lE, m([
                    yE("nav-link d-flex flex-column"),
                    Fz(m([
                        i("active", A2(QU, i(r.kK, e.fj), Xf))
                    ])),
                    EE("mobileDashboardNav"),
                    rG("_self"),
                    FE(A3(Hl, Xf, r.by, e.bG.jW)),
                    XP("menuitem")
                ]), m([
                    BU,
                    A2(fz, m([
                        yE("d-none d-sm-inline")
                    ]), m([
                        Xd("Dashboard")
                    ]))
                ]))
            ])),
            A2(Hz, m([
                yE("nav-item")
            ]), m([
                A2(lE, m([
                    yE("nav-link d-flex flex-column"),
                    Fz(m([
                        i("active", A2(QU, i(r.kK, e.fj), Ms))
                    ])),
                    EE("mobileUsersDashboardNav"),
                    rG("_self"),
                    XP("menuitem"),
                    FE(A3(Hl, Ms, r.by, e.bG.jW))
                ]), m([
                    nB,
                    A2(fz, m([
                        yE("d-none d-sm-inline")
                    ]), m([
                        Xd("Users")
                    ]))
                ]))
            ])),
            A2(Hz, m([
                yE("nav-item")
            ]), m([
                A2(lE, m([
                    yE("nav-link d-flex flex-column"),
                    Fz(m([
                        i("active", A2(QU, i(r.kK, e.fj), Ls))
                    ])),
                    EE("mobileTeamsDashboardNav"),
                    rG("_self"),
                    XP("menuitem"),
                    FE(A3(Hl, Ls, r.by, e.bG.jW))
                ]), m([
                    rB,
                    A2(fz, m([
                        yE("d-none d-sm-inline")
                    ]), m([
                        Xd("Teams")
                    ]))
                ]))
            ])),
            A2(Hz, m([
                yE("nav-item")
            ]), m([
                A2(lE, m([
                    yE("nav-link d-flex flex-column"),
                    Fz(m([
                        i("active", A2(QU, i(r.kK, e.fj), Df))
                    ])),
                    EE("mobileAssignmentsDashboardNav"),
                    rG("_self"),
                    XP("menuitem"),
                    FE(A3(Hl, Df, r.by, e.bG.jW))
                ]), m([
                    UU,
                    A2(fz, m([
                        yE("d-none d-sm-inline")
                    ]), m([
                        Xd("Assignments")
                    ]))
                ]))
            ])),
            A2(Hz, m([
                yE("nav-item")
            ]), m([
                A2(lE, m([
                    yE("nav-link d-flex flex-column"),
                    Fz(m([
                        i("active", A2(QU, i(r.kK, e.fj), $s))
                    ])),
                    EE("mobileReportsDashboardNav"),
                    rG("_self"),
                    XP("menuitem"),
                    FE(A3(Hl, $s, r.by, e.bG.jW))
                ]), m([
                    JU,
                    A2(fz, m([
                        yE("d-none d-sm-inline")
                    ]), m([
                        Xd("Reports")
                    ]))
                ]))
            ])),
            A2(Hz, m([
                yE("nav-item")
            ]), m([
                A2(lE, m([
                    yE("nav-link d-flex flex-column"),
                    Fz(m([
                        i("active", A2(QU, i(r.kK, e.fj), ws))
                    ])),
                    EE("mobileSettingsDashboardNav"),
                    rG("_self"),
                    XP("menuitem"),
                    FE(A3(Hl, ws, r.by, e.bG.jW))
                ]), m([
                    XU,
                    A2(fz, m([
                        yE("d-none d-sm-inline")
                    ]), m([
                        Xd("Settings")
                    ]))
                ]))
            ]))
        ]);
        return A2(YU, m([
            EE("bottomNav"),
            yE("d-flex flex-row justify-content-around align-items-center d-md-none fixed-bottom"),
            XP("navigation")
        ]), m([
            A2(Sz, m([
                yE("nav nav-fill flex-row justify-content-around  d-md-flex"),
                XP("menu")
            ]), t)
        ]));
    }, tB = A2(az, m([
        cz("0 0 512 512"),
        YE("#fff")
    ]), m([
        A2(XE, m([
            BE("M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM256 336c-18 0-32 14-32 32s13.1 32 32 32c17.1 0 32-14 32-32S273.1 336 256 336zM289.1 128h-51.1C199 128 168 159 168 198c0 13 11 24 24 24s24-11 24-24C216 186 225.1 176 237.1 176h51.1C301.1 176 312 186 312 198c0 8-4 14.1-11 18.1L244 251C236 256 232 264 232 272V288c0 13 11 24 24 24S280 301 280 288V286l45.1-28c21-13 34-36 34-60C360 159 329 128 289.1 128z")
        ]), b)
    ])), aB = A2(lE, m([
        EE("helpButton"),
        yE("d-flex justify-content-center align-items-center mb-5 pl-1 mt-auto"),
        FE("https://aciondemand.zendesk.com/"),
        rG("_blank")
    ]), m([
        A2(fz, m([
            yE("sr-only")
        ]), m([
            Xd("Help")
        ])),
        tB
    ])), uB = F5(function(r, n, e, t, a) {
        return A2(Hz, m([
            yE("nav-item")
        ]), m([
            A2(lE, m([
                yE("nav-link d-flex flex-column align-items-center"),
                Fz(m([
                    i("active", A2(QU, n, e))
                ])),
                EE(r + "DashboardNav"),
                rG("_self"),
                XP("menuitem"),
                t
            ]), m([
                a,
                A2(fz, b, m([
                    Xd(r)
                ]))
            ]))
        ]));
    }), cB = function(r) {
        switch(r.$){
            case 0:
                return "Dashboard";
            case 1:
                return "Users";
            case 2:
                return "Teams";
            case 3:
                return "Assignments";
            case 5:
                return "Reports";
            case 6:
                return "Learning Reminders";
            case 7:
                return "Assignment Details";
            case 4:
                return "New Module";
            default:
                return "Settings";
        }
    }, oB = function(r) {
        var n = r.gW;
        if (n.$) return A2(YU, m([
            EE("sideNav"),
            yE("d-md-flex flex-md-column d-none justify-content-start align-items-center"),
            XP("navigation")
        ]), m([
            A2(Sz, m([
                yE("list-unstyled w-100 d-flex justify-content-center")
            ]), m([
                A2(Hz, m([
                    yE("logo")
                ]), m([
                    A2(KU, "ProPortal logo", b)
                ]))
            ])),
            aB
        ]));
        var e = n.a, t = m([
            A5(uB, cB(Xf), i(r.kK, e.fj), Xf, FE(A3(Hl, Xf, r.by, e.bG.jW)), BU),
            A5(uB, cB(Ms), i(r.kK, e.fj), Ms, FE(A3(Hl, Ms, r.by, e.bG.jW)), nB),
            A5(uB, cB(Ls), i(r.kK, e.fj), Ls, FE(A3(Hl, Ls, r.by, e.bG.jW)), rB),
            A5(uB, cB(Df), i(r.kK, e.fj), Df, FE(A3(Hl, Df, r.by, e.bG.jW)), UU),
            A5(uB, cB($s), i(r.kK, e.fj), $s, FE(A3(Hl, $s, r.by, e.bG.jW)), JU),
            A5(uB, cB(ws), i(r.kK, e.fj), ws, FE(A3(Hl, ws, r.by, e.bG.jW)), XU)
        ]);
        return A2(YU, m([
            EE("sideNav"),
            yE("d-md-flex flex-md-column d-none justify-content-start align-items-center d-md-flex flex-md-column d-none"),
            XP("navigation")
        ]), m([
            A2(Sz, m([
                yE("list-unstyled w-100 d-flex justify-content-center")
            ]), m([
                A2(Hz, m([
                    yE("logo")
                ]), m([
                    A2(KU, "ProPortal logo", b)
                ]))
            ])),
            A2(Sz, m([
                yE("nav nav-fill flex-column d-md-flex"),
                XP("menu")
            ]), t),
            aB
        ]));
    }, iB = {
        $: 35
    }, fB = {
        $: 0,
        a: 1
    }, sB = F4(function(r, n, e, t) {
        return A2(LV, A3(CV, l(m([
            fB,
            $V(m([
                yE("col-12")
            ]))
        ]), r), t, n), m([
            e
        ]));
    }), lB = mV(gV(1)), bB = F2(function(r, n) {
        return A4(sB, m([
            lB
        ]), n, Xd("Cancel"), "cancel-archive-" + r);
    }), dB = function(r) {
        return A4(sB, m([
            pV
        ]), {
            $: 36,
            a: r
        }, Xd("Ok"), "confirm-archive-" + r);
    }, vB = F2(function(r, n) {
        return A2(LE, b, m([
            A2(kP, n, A3(fP, b, m([
                dB(r),
                A2(bB, r, iB)
            ]), A3(bP, b, m([
                Xd("Are You Sure?")
            ]), iP(iB))))
        ]));
    }), mB = function(r) {
        return {
            $: 28,
            a: r
        };
    }, gB = m([
        0,
        1,
        2
    ]), pB = A2(Vw, "btn btn-secondary dropdown-toggle text-left elm-dropdown-trigger", A2(zw, "elm-dropdown-menu", A2(Ew, "elm-dropdown-item", A2(Sw, !1, A2(Rw, "Filter Subscriptions", A2(Hw, Aw, Mw)))))), $B = function(r) {
        return A2(iE, mB, A4(JZ, pB, r.g2, gB, r.g8));
    }, hB = {
        $: 40
    }, wB = function(r) {
        var n = r.a, e = r.c;
        return Xd(Ie(r.b) + "/" + Ie(e) + "/" + Ie(n));
    }, CB = function(r) {
        return wB(r);
    }, kB = function(r) {
        var n;
        return A2(SP, m([
            yE("access m-1")
        ]), m([
            A2(LE, m([
                yE("term")
            ]), m([
                Xd("Access from "),
                (n = r.ja, wB(n)),
                Xd(" through "),
                CB(r.jH)
            ]))
        ]));
    }, yB = {
        $: 34
    }, xB = function(r) {
        return yE(1 === r.$ ? "badge-pill" : function(r) {
            switch(r){
                case 0:
                    return "badge-primary";
                case 1:
                    return "badge-secondary";
                case 2:
                    return "badge-success";
                case 3:
                    return "badge-info";
                case 4:
                    return "badge-warning";
                case 5:
                    return "badge-danger";
                case 6:
                    return "badge-light";
                default:
                    return "badge-dark";
            }
        }(r.a));
    }, LB = A2(F3(function(r, n, e) {
        return A2(fz, l(function(r) {
            return A2(ye, yE("badge"), A2(aa, xB, r));
        }(r), n), e);
    })(m([
        {
            $: 0,
            a: 3
        }
    ])), m([
        QD
    ]), m([
        Xd("Archived")
    ])), jB = bn("code"), AB = function(r) {
        return A2(LE, b, m([
            A2(SP, b, m([
                Xd("Contents:")
            ])),
            A2(Sz, b, A2(aa, function(r) {
                return A2(Hz, b, m([
                    Xd(r.kv),
                    Xd(" ("),
                    A2(jB, m([
                        yE("font-color-slate")
                    ]), m([
                        Xd(tl(r.iI))
                    ])),
                    Xd(")")
                ]));
            }, A2(mc, function(r) {
                return r.kv;
            }, r.jl)))
        ]));
    }, MB = F3(function(r, n, e) {
        if (n.$) {
            var t = n.a, a = r.iY ? (u = r.jW, A2(LE, m([
                OD
            ]), m([
                A2(LV, A3(CV, m([
                    pV,
                    fB,
                    $V(m([
                        QD
                    ]))
                ]), "archive-grant-" + u, yB), m([
                    Xd("Archive")
                ]))
            ]))) : LB;
            return A2(LE, b, m([
                A2(kP, e, A3(fP, b, m([
                    A2(bB, r.jW, hB)
                ]), A3(oP, m([
                    yE("d-flex flex-column"),
                    EE(r.jW)
                ]), m([
                    A2(LE, m([
                        yE("d-flex align-items-center")
                    ]), m([
                        A2(VR, m([
                            yE("mb-0")
                        ]), m([
                            a
                        ]))
                    ])),
                    A2(ME, b, m([
                        A2(LE, m([
                            yE("d-flex flex-row justify-content-start align-items-center pt-3")
                        ]), m([
                            A2(SE, m([
                                yE("form-check-label form-control-sm pl-0")
                            ]), m([
                                Xd("EG:")
                            ])),
                            A2(TE, m([
                                yE("form-control-plaintext form-control-sm"),
                                HV(r.jW),
                                lq(!0)
                            ]), b)
                        ])),
                        A2(LE, m([
                            yE("d-flex flex-row justify-content-start align-items-center")
                        ]), m([
                            A2(SE, m([
                                yE("form-check-label form-control-sm pl-0")
                            ]), m([
                                Xd("Company:")
                            ])),
                            A2(TE, m([
                                yE("form-control-plaintext form-control-sm"),
                                HV(t),
                                lq(!0)
                            ]), b)
                        ]))
                    ])),
                    kB(r),
                    AB(r)
                ]), iP(hB))))
            ]));
        }
        var u;
        return A2(fz, b, b);
    }), FB = function(r) {
        return A4(sB, m([
            pV
        ]), r, Xd("Go to Insights"), "insights");
    }, HB = function(r) {
        return A4(sB, m([
            pV
        ]), r, Xd("Manage Subscription"), "manage-subscription");
    }, TB = $n("dy"), SB = OE("feComposite"), EB = OE("feFlood"), zB = OE("feGaussianBlur"), RB = OE("feOffset"), VB = OE("filter"), WB = $n("filter"), PB = $n("filterUnits"), GB = $n("flood-opacity"), IB = $n("in2"), NB = $n("in"), ZB = $n("operator"), DB = $n("result"), _B = $n("stdDeviation"), OB = A2(az, m([
        oz("45.322"),
        JE("45.322"),
        cz("0 0 45.322 45.322")
    ]), m([
        A2(xR, b, m([
            A2(VB, m([
                Pz("Union_1"),
                Jz("0"),
                Xz("0"),
                oz("45.322"),
                JE("45.322"),
                PB("userSpaceOnUse")
            ]), m([
                A2(RB, m([
                    TB("3")
                ]), b),
                A2(zB, m([
                    _B("3"),
                    DB("blur")
                ]), b),
                A2(EB, m([
                    GB("0.161")
                ]), b),
                A2(SB, m([
                    ZB("in"),
                    IB("blur")
                ]), b),
                A2(SB, m([
                    NB("SourceGraphic")
                ]), b)
            ]))
        ])),
        A2(Wz, m([
            Qz("matrix(1, 0, 0, 1, 0, 0)"),
            WB("url(#Union_1)")
        ]), m([
            A2(XE, m([
                Pz("Union_1-2"),
                BE("M3.68-1150.32l-11.893,11.893L3.68-1150.32l-11.893-11.893L3.68-1150.32l11.893-11.893L3.68-1150.32l11.893,11.893Z"),
                Qz("translate(18.98 1169.98)"),
                YE("rgba(0,0,0,0)"),
                nz("#fff"),
                tz("5")
            ]), b)
        ]))
    ])), qB = function(r) {
        var n = r.bG.kN;
        return n.$ ? r.bG.jW : n.a;
    }, KB = F2(function(r, n) {
        var t = Me(qU(r));
        return A2(LE, m([
            EE("overlayDropdown"),
            yE("dropdown d-md-none")
        ]), m([
            A2(LE, m([
                EE("belowNavOverlay"),
                yE("dropdown-menu"),
                Fz(m([
                    i("d-flex flex-column show", !r.hR)
                ]))
            ]), m([
                A2(LE, m([
                    yE("d-flex justify-content-end align-items-center")
                ]), m([
                    A2(CE, m([
                        yE("btn btn-link"),
                        gz(OU)
                    ]), m([
                        OB
                    ]))
                ])),
                A2(LE, m([
                    yE("container-fluid d-flex flex-column px-5")
                ]), m([
                    A2(LE, m([
                        yE("d-flex align-items-center")
                    ]), m([
                        A2(LE, m([
                            yE("select-wrapper mr-1")
                        ]), m([
                            A2($G, m([
                                yE("overflow-y-scroll overflow-hidden"),
                                PE(DU)
                            ]), A2(aa, function(r) {
                                return A2(bW, m([
                                    gW(e(r.bG.jW, n.bG.jW)),
                                    HV(r.bG.jW)
                                ]), m([
                                    Xd(qB(r))
                                ]));
                            }, t))
                        ]))
                    ])),
                    A2(lE, m([
                        yE("d-flex justify-content-start align-items-center"),
                        FE("https://help.acilearning.com/en/collections/141590-proportal"),
                        rG("_blank")
                    ]), m([
                        A2(VR, b, m([
                            Xd("Help")
                        ]))
                    ])),
                    A2(yI, m([
                        yE("w-100")
                    ]), b),
                    A2(CE, m([
                        yE("d-flex justify-content-start align-items-center btn btn-link px-0"),
                        gz(ga)
                    ]), m([
                        A2(VR, b, m([
                            Xd("Sign Out")
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), UB = {
        $: 49
    }, BB = {
        $: 50
    }, QB = {
        $: 39
    }, YB = {
        $: 33
    }, JB = F2(function(r, n) {
        var e = n ? "100%" : "0";
        return A2(LE, m([
            yE("popover fade show bs-popover-bottom"),
            XP("tooltip"),
            EE("GrantDetailsPopover"),
            A2(_W, "width", "200px"),
            A2(_W, "left", "-105px"),
            A2(_W, "top", "100%"),
            A2(_W, "opacity", e)
        ]), m([
            A2(LE, m([
                yE("arrow"),
                A2(_W, "left", "50%"),
                A2(_W, "right", "50%")
            ]), b),
            kB(r)
        ]));
    }), XB = F3(function(r, n, e) {
        var t;
        return e.$ ? A2(fz, m([
            yE("ml-2 grant-details-btn"),
            gz(QB)
        ]), m([
            Xd("Grant Details")
        ])) : A2(fz, m([
            yE("ml-2 infoIcon position-relative"),
            nR((t = !0, {
                $: 32,
                a: t
            })),
            gz(YB)
        ]), m([
            A2(fz, m([
                yE("info-icon icon cursor-help")
            ]), m([
                A2(fz, m([
                    yE("sr-only")
                ]), m([
                    Xd("Information popover icon")
                ])),
                WR("20px")
            ])),
            A2(JB, r.bG, n)
        ]));
    }), rQ = {
        $: 0
    }, nQ = F2(function(r, n) {
        return {
            $: 3,
            a: r,
            b: n
        };
    }), eQ = function(r) {
        var n = r.a, e = r.b;
        if (1 !== e) {
            var t = 2 === e;
            return m([
                A2(Z_, m([
                    __("skip-step"),
                    D_(t),
                    O_(nQ(n))
                ]), "Skip this step for now")
            ]);
        }
        return b;
    }, tQ = {
        $: 4
    }, aQ = F3(function(r, n, e) {
        switch(r){
            case 0:
                return A3(Hl, Ls, n, e);
            case 1:
                return A3(Hl, tQ, n, e);
            case 2:
            case 3:
                return A3(Hl, Ms, n, e);
            case 4:
                return A3(Hl, Df, n, e);
            default:
                return A3(Hl, $s, n, e);
        }
    }), uQ = F3(function(r, n, e) {
        var t, a = e.im, u = e.cX, c = e.gh, o = function(r) {
            switch(r){
                case 0:
                    return i("Create a Team", "Group users to easily provide them with customized assignments, monitor progress and report on usage of the platform.");
                case 1:
                    return i("Build Learning Module", "Group courses and/or episodes into modules. Once you create a module, it can be assigned to team members.");
                case 2:
                    return i("Invite a User", "Give your fellow employees access to the e-learning platform and/or ProPortal.");
                case 3:
                    return i("Enable Learning Reminders", "Learning Reminders help staff stay on top of their learning goals. Choose from a cadence of between 2 to 14 days to send an email with a prompt to log in to ACI On-Demand to resume watching.");
                case 4:
                    return i("Allocate an Assignment", "Keep team members on track with learning goals by assigning modules. After a module is assigned, learners will be notified by email and see the assignment in the notifications panel on the platform dashboard.");
                default:
                    return i("Establish Custom Report", "Get immediate insight into your team\u2019s viewing patterns and progress over any period of time with visual reports. Static reports can be generated using a preset or custom time frame. Recurring reports are updated weekly, monthly, and quarterly, and can be sent directly to your inbox by adding recipients.");
            }
        }(a), f = o.a, s = o.b, l = m(2 === c ? [
            A2(fz, m([
                yE("titleText")
            ]), m([
                Xd(f)
            ])),
            A2(fz, m([
                yE("ml-2 skippedText")
            ]), m([
                Xd("(Skipped)")
            ]))
        ] : [
            Xd(f)
        ]);
        if (u) {
            var d = A2(lE, m([
                yE("btn btn-sm btn-primary my-3"),
                FE(A3(aQ, a, r, n)),
                rG("_self")
            ]), m([
                Xd(f)
            ])), v = 2 === a ? A2(fz, b, m([
                d,
                A2(fz, m([
                    yE("ml-3"),
                    EE("open-bulk-upload-bot"),
                    XP("button")
                ]), m([
                    Xd("Invite 10+ Users")
                ]))
            ])) : d;
            return A2(LE, m([
                yE("py-3 border-bottom")
            ]), m([
                A2(LE, m([
                    Fz(m([
                        i("titleText", 2 !== c)
                    ]))
                ]), l),
                A2(LE, m([
                    yE("mt-3 descriptionText")
                ]), m([
                    Xd(s)
                ])),
                v,
                A2(LE, b, eQ(i(a, c)))
            ]));
        }
        return A2(LE, m([
            Fz(m([
                i("py-3 border-bottom", !0),
                i("completedStep", 1 === c),
                i("incompletedStep", 1 !== c)
            ])),
            XP("button"),
            gz((t = a, {
                $: 1,
                a: t
            }))
        ]), l);
    }), cQ = A2(az, m([
        cz("0 0 320 512"),
        YE("#00A5E1"),
        JE("30px")
    ]), m([
        A2(XE, m([
            BE("M206.7 464.6l-183.1-191.1C18.22 267.1 16 261.1 16 256s2.219-11.97 6.688-16.59l183.1-191.1c9.152-9.594 24.34-9.906 33.9-.7187c9.625 9.125 9.938 24.37 .7187 33.91L73.24 256l168 175.4c9.219 9.5 8.906 24.78-.7187 33.91C231 474.5 215.8 474.2 206.7 464.6z")
        ]), b)
    ])), oQ = F2(function(r, n) {
        return A2(LE, m([
            EE("onboardingPanel"),
            Fz(m([
                i("open position-fixed vh-100", n.hQ.cQ),
                i("closed p-0 position-fixed vh-100", !n.hQ.cQ)
            ]))
        ]), m([
            A2(LE, m([
                yE("onboardingContent p-4 vh-100 d-xl-block")
            ]), m([
                A2(LE, m([
                    yE("onboardingToggle position-fixed"),
                    Fz(m([
                        i("open toggleRotate", n.hQ.cQ),
                        i("closed", !n.hQ.cQ)
                    ])),
                    EE("toggleBtn-onboardingPanel")
                ]), m([
                    A2(LE, m([
                        yE("halfCircle"),
                        gz(rQ)
                    ]), m([
                        cQ
                    ])),
                    A2(LE, m([
                        yE("p-0 d-xl-none position-fixed vh-100 onboardingMobilePanelOverlay")
                    ]), b)
                ])),
                A2(VR, m([
                    yE("text-center headerText font-weight-bold")
                ]), m([
                    Xd("ProPortal Onboarding")
                ])),
                A2(LE, b, A2(aa, A2(uQ, r.by, r.dM), n.hQ.$9))
            ]))
        ]));
    }), iQ = F2(function(r, n) {
        var t, a, u, c, o = F2(function(n, e) {
            return A2(fG, m([
                Fz(m([
                    i("d-inline", n),
                    i("ml-3", e)
                ]))
            ]), m([
                Xd(r.gQ)
            ]));
        }), f = function(n) {
            var e = r.hy;
            return e.$ ? A2(o, !1, !1) : e.a.js ? A2(lE, m([
                yE("btn-link btn mr-3 d-none d-sm-block text-left"),
                FE("/companies"),
                rG("_self")
            ]), m([
                A2(fz, m([
                    yE("sr-only")
                ]), m([
                    Xd("search Companies")
                ])),
                SK(Ve(14)),
                A2(o, !0, n)
            ])) : A2(o, !1, !1);
        }, s = function() {
            var n = A2(LV, A3(CV, m([
                jI,
                $V(m([
                    yE("pb-2 pt-1")
                ]))
            ]), "logout-button", ga), m([
                WU("#fff")
            ])), t = A2(LE, b, b), a = {
                dx: m([
                    n
                ]),
                dN: b,
                d4: b,
                d5: b,
                d6: t,
                d7: t
            };
            if (3 === r.kK.$) return a;
            var u, c, o, s = m([
                n
            ]), l = (o = r.hQ).$ ? t : A2(iE, ps, A2(oQ, o.a, r.ih)), d = Me(r.fI), v = i(r.gW, Oe(d));
            if (v.a.$) return a;
            switch(v.b){
                case 0:
                    return a;
                case 1:
                    var g = v.a.a;
                    return {
                        dx: s,
                        dN: m([
                            A2(LE, m([
                                yE("d-flex flex-column justify-content-center h-100 ml-sm-3 ml-0")
                            ]), m([
                                f(!0),
                                A2(LE, m([
                                    yE("d-flex align-items-center")
                                ]), m([
                                    A2(LE, m([
                                        yE("d-flex flex-row align-items-center")
                                    ]), A2(aa, function(r) {
                                        return Xd(qB(r));
                                    }, d)),
                                    A2(fz, m([
                                        yE("ml-3")
                                    ]), m([
                                        A3(XB, g, r.hf, r.by)
                                    ]))
                                ]))
                            ]))
                        ]),
                        d4: (c = r.hy, c.$ ? b : c.a.jP ? m([
                            FB(ZU)
                        ]) : b),
                        d5: A2(bc, 3, g.bG.lo) ? m([
                            HB(_U)
                        ]) : b,
                        d6: l,
                        d7: A2(KB, r, g)
                    };
                default:
                    g = v.a.a;
                    var p = Me(qU(r));
                    return {
                        dx: s,
                        dN: m([
                            A2(LE, m([
                                yE("d-flex flex-column justify-content-center h-100 ml-sm-3 ml-0")
                            ]), m([
                                f(!0),
                                A2(LE, m([
                                    yE("d-flex align-items-center")
                                ]), m([
                                    A2(LE, m([
                                        yE("select-wrapper mr-1")
                                    ]), m([
                                        A2($G, m([
                                            PE(DU)
                                        ]), A2(aa, function(r) {
                                            return A2(bW, m([
                                                gW(e(r.bG.jW, g.bG.jW)),
                                                HV(r.bG.jW)
                                            ]), m([
                                                Xd(qB(r))
                                            ]));
                                        }, p))
                                    ])),
                                    A3(XB, g, r.hf, r.by)
                                ]))
                            ]))
                        ]),
                        d4: (u = r.hy, u.$ ? b : u.a.jP ? m([
                            FB(ZU)
                        ]) : b),
                        d5: A2(bc, 3, g.bG.lo) ? m([
                            HB(_U)
                        ]) : b,
                        d6: l,
                        d7: A2(KB, r, g)
                    };
            }
        }(), d = s.dN, v = s.dx, g = s.d7, p = s.d6, $ = s.d5, h = s.d4, w = function(r) {
            var n = A2(Mi, 0, r.fI);
            return 1 !== n.$ && !e(n.a.by, Vc);
        }(r) ? m([
            $B(r)
        ]) : $, C = function() {
            var n = r.gW;
            if (n.$) return i(A2(LE, b, b), A2(LE, b, b));
            var e = n.a;
            return i(A3(MB, e.bG, r.by, r.he), A2(vB, e.bG.jW, r.gy));
        }(), k = C.a, y = C.b;
        return A2(LE, m([
            EE("mainView"),
            yE("d-flex flex-row")
        ]), m([
            oB(r),
            eB(r),
            k,
            y,
            p,
            (u = r.it, A2(LE, b, m([
                A2(kP, u, A3(fP, b, m([
                    (c = BB, A4(sB, m([
                        pV
                    ]), c, Xd("Contact Support"), "contact-support"))
                ]), A3(oP, b, m([
                    A2(SP, b, m([
                        Xd(A2(Ne, " ", m([
                            "If you\u2019re here to view, manage, or update your existing subscription,",
                            "don\u2019t worry\u2014we\u2019ve got you covered. Our support team is standing by to",
                            "help with anything  you need, from updating billing details to",
                            "modifying your learning plan as we transition existing customers over."
                        ])))
                    ]))
                ]), A3(II, m([
                    yE("text-center")
                ]), m([
                    Xd("ACI Learning is improving our commerce experience!")
                ]), iP(UB)))))
            ]))),
            A2(LE, m([
                EE("contentContainer")
            ]), (t = m([
                Ve(A2(LE, m([
                    EE("topNav"),
                    yE("navbar navbar-expand-md fixed-top d-flex justify-content-end align-items-center")
                ]), m([
                    A2(LE, m([
                        yE("container-fluid d-md-flex flex-md-row d-none justify-content-between align-items-center h-100")
                    ]), l(d, m([
                        A2(LE, m([
                            yE("d-flex flex-row justify-content-between align-items-center h-100")
                        ]), w),
                        A2(LE, m([
                            yE("d-flex flex-row h-100 align-items-center text-underline")
                        ]), m([
                            A2(lE, m([
                                FE(r.fk),
                                rG("_blank"),
                                bG("norefer")
                            ]), m([
                                A2(AI, b, m([
                                    Xd("ACI On Demand")
                                ]))
                            ]))
                        ])),
                        A2(LE, m([
                            yE("d-flex flex-row justify-content-between")
                        ]), h),
                        A2(LE, m([
                            yE("d-flex flex-row justify-content-end align-items-center h-100")
                        ]), v)
                    ]))),
                    A2(LE, m([
                        yE("h-100 w-100 d-flex d-md-none flex-row justify-content-between")
                    ]), m([
                        A2(fz, m([
                            yE("logo mb-1")
                        ]), m([
                            A2(KU, "ProPortal logo", b)
                        ])),
                        A2(CE, m([
                            sz("button"),
                            EE("navToggleMobileMenu"),
                            yE("navbar-toggler"),
                            kW("ProPortal Menu"),
                            gz(OU)
                        ]), m([
                            (a = "#fff", A2(az, m([
                                Pz("hamburgerIcon"),
                                cz("0 0 25.575 19.418")
                            ]), m([
                                A2(Wz, m([
                                    Qz("translate(-317.184 -22)")
                                ]), m([
                                    A2(iR, m([
                                        sR("22.575"),
                                        Qz("translate(318.684 23.5)"),
                                        YE("none"),
                                        nz(a),
                                        ez("round"),
                                        tz("3")
                                    ]), b),
                                    A2(iR, m([
                                        sR("22.575"),
                                        Qz("translate(318.684 31.709)"),
                                        YE("none"),
                                        nz(a),
                                        ez("round"),
                                        tz("3")
                                    ]), b),
                                    A2(XE, m([
                                        BE("M0,0H22.575"),
                                        Qz("translate(318.684 39.918)"),
                                        YE("none"),
                                        nz(a),
                                        ez("round"),
                                        tz("3")
                                    ]), b)
                                ]))
                            ])))
                        ]))
                    ])),
                    g
                ]))),
                Ve(n)
            ]), A2(Af, Vt, t)))
        ]));
    }), fQ = function(r) {
        var n = r.kK;
        switch(n.$){
            case 0:
                return A2(iE, Pi, function(r) {
                    return function(r) {
                        return A2(LE, m([
                            yE("login w-100 bg-wrapper")
                        ]), m([
                            A2(LE, m([
                                yE("container-xl vh-100")
                            ]), m([
                                A2(LE, m([
                                    yE("row vh-100")
                                ]), m([
                                    A2(LE, m([
                                        yE("col-12 col-md-7 col-lg-5 wall d-flex align-items-center")
                                    ]), m([
                                        A2(LE, m([
                                            yE("w-100 px-md-1 wall-content")
                                        ]), m([
                                            b_,
                                            h_(r)
                                        ]))
                                    ])),
                                    A2(LE, m([
                                        yE("ml-5 d-none d-md-flex align-items-center")
                                    ]), m([
                                        l_
                                    ]))
                                ]))
                            ]))
                        ]));
                    }(r);
                }(n.a));
            case 2:
                return CI;
            case 7:
                return A2(iQ, r, A2(iE, gs, function(r) {
                    return A2(LE, m([
                        yE("pro-card-row")
                    ]), m([
                        A2(LE, m([
                            yE("pro-card")
                        ]), m([
                            _K(r),
                            NK(r)
                        ]))
                    ]));
                }(n.a)));
            case 6:
                return A2(iQ, r, A2(iE, vs, function(r) {
                    var n;
                    return A2(LE, m([
                        yE("pt-3")
                    ]), m([
                        (n = r.E, A2(LE, m([
                            yE("row no-gutter mb-5")
                        ]), m([
                            A2(LE, m([
                                yE("col-md-8 col-lg-9 col-12")
                            ]), m([
                                A2(TE, A3(GE, m([
                                    yE("form-control"),
                                    _E("New Module Name, example: Help Desk New Hires")
                                ]), "new-module-name", A2($l, DD, Vt)), b)
                            ])),
                            A2(LE, m([
                                yE("col-md-4 col-lg-3 col-12 text-center mt-md-0 mt-2")
                            ]), m([
                                A2(CE, A3(pz, m([
                                    yE("form-control btn-primary btn btn-block")
                                ]), "create-new-module-button-" + n, ZD), m([
                                    Xd("Create New Module")
                                ]))
                            ]))
                        ]))),
                        qD,
                        A2(n_, r.bU, r.bT)
                    ]));
                }(n.a)));
            case 10:
                return A2(iQ, r, A2(iE, bs, function(r) {
                    return A2(LE, m([
                        yE("mt-3")
                    ]), A2(ye, A2(LE, m([
                        yE("row")
                    ]), m([
                        A2(LE, m([
                            yE("col-6 col-sm-7 col-md-4 col-lg-7")
                        ]), m([
                            A2(tV, m([
                                yE("d-inline-block mr-2")
                            ]), m([
                                Xd("Module")
                            ])),
                            A2(pO, r.ea, gO)
                        ])),
                        A2(LE, m([
                            yE("col-md-5 col-lg-3 d-none d-md-block text-right")
                        ]), m([
                            CO(r)
                        ])),
                        A2(LE, m([
                            yE("col-6 col-sm-5 col-md-3 col-lg-2")
                        ]), m([
                            $O
                        ])),
                        A2(LE, m([
                            yE("col-12 d-block d-md-none pt-3 pb-0 pr-0 pl-0 text-right")
                        ]), m([
                            CO(r)
                        ]))
                    ])), A2(ye, A6(yP, "Assignment Activity Requested", "You have successfully requested your assignment activity report. Please allow 30 seconds for the download to occur. If an error occurs please contact " + xN + ".", We, r.E, r.ch, mO), function(r) {
                        var n = r.cM;
                        switch(n.$){
                            case 0:
                                return m([
                                    A2(LE, m([
                                        yE("row justify-content-center mt-4")
                                    ]), m([
                                        Xd("Loading module...")
                                    ]))
                                ]);
                            case 1:
                                return A4(YO, r.eW, n.a, r.gC, r.ci);
                            default:
                                return m([
                                    A2(LE, m([
                                        yE("row justify-content-center mt-4")
                                    ]), m([
                                        Xd("Error loading module. Please try again or contact support.")
                                    ]))
                                ]);
                        }
                    }(r))));
                }(n.a)));
            case 8:
                return A2(iQ, r, A2(iE, _f, function(r) {
                    var n, e = A3(KC, Es(!0), L_, r.aP), t = r.dC;
                    return n = m([
                        A2(LE, m([
                            yE("row")
                        ]), m([
                            A2(LE, m([
                                yE("col-md-3")
                            ]), m([
                                A2(_D, "New Assignment", m([
                                    x_,
                                    j_
                                ])),
                                A2(M_, r.dq, w_)
                            ])),
                            A2(LE, m([
                                yE("col-md-2 offset-md-7")
                            ]), m([
                                A4(ZV, m([
                                    TI,
                                    hV
                                ]), C_, Xd("Cancel"), "assignment-cancel-button")
                            ]))
                        ])),
                        dO(r.cM),
                        A2(LE, m([
                            yE("row")
                        ]), m([
                            A2(LE, m([
                                yE("col-md-12 text-md-right")
                            ]), m([
                                A3(cO, r.jA, r.cv, s(t, {
                                    j4: e
                                }))
                            ]))
                        ])),
                        A2(LE, m([
                            yE("row")
                        ]), m([
                            A2(LE, m([
                                yE("col-md-12 text-md-right")
                            ]), m([
                                A2(LE, m([
                                    A_
                                ]), m([
                                    vO
                                ]))
                            ]))
                        ])),
                        A2(LE, m([
                            yE("row align-middle mt-3")
                        ]), m([
                            A2(LE, m([
                                yE("col-12 d-flex justify-content-start justify-content-md-end")
                            ]), m([
                                lO(r)
                            ]))
                        ])),
                        A2(LE, m([
                            yE("row align-middle mt-3")
                        ]), m([
                            A2(LE, m([
                                yE("col-12 col-md-3 col-lg-2 offset-md-9 offset-lg-10")
                            ]), m([
                                A3(nO, r.jA, r.ki, r.aP)
                            ]))
                        ])),
                        function() {
                            var n = i(r.ki, r.eY);
                            r: for(;;)switch(n.a.$){
                                case 1:
                                    switch(n.b.$){
                                        case 2:
                                            var e = n.b.a, t = A2(y_, A2(mc, function(r) {
                                                return r.u.jM;
                                            }, r.ac), r.cW);
                                            return A2(LE, m([
                                                yE("container-fluid mt-2")
                                            ]), A4(Y_, t, Me(e), r.cW, r.aF));
                                        case 0:
                                            return A2(LE, b, m([
                                                Xd("Loading...")
                                            ]));
                                        default:
                                            break r;
                                    }
                                case 0:
                                    switch(n.b.$){
                                        case 2:
                                        case 0:
                                            return A2(LE, b, m([
                                                Xd("Loading...")
                                            ]));
                                        default:
                                            break r;
                                    }
                                default:
                                    break r;
                            }
                            return A2(LE, b, m([
                                Xd("An error occurred while loading the page. Please contact support or try reloading.")
                            ]));
                        }()
                    ]), A2(LE, m([
                        yE("mt-3 card")
                    ]), m([
                        A2(LE, m([
                            yE("card-body")
                        ]), n)
                    ]));
                }(n.a)));
            case 11:
                return A2(iQ, r, A2(iE, js, function(r) {
                    var n = r.eY;
                    switch(n.$){
                        case 0:
                            return A2(LE, m([
                                yE("row")
                            ]), m([
                                Xd("Loading...")
                            ]));
                        case 1:
                            var e = n.a;
                            return A2(LE, m([
                                yE("teams-content pt-3")
                            ]), A2(ye, A2(LE, m([
                                yE("row justify-content-lg-end create-new-team-row")
                            ]), m([
                                A2(LE, m([
                                    yE("col-12 col-lg-3")
                                ]), m([
                                    A2(CE, m([
                                        gz(e_),
                                        yE("btn btn-primary btn-block"),
                                        EE("create-team-button")
                                    ]), m([
                                        Xd("Create New Team")
                                    ]))
                                ]))
                            ])), A2(ye, function(r) {
                                if (1 === r.$) return A2(LE, b, b);
                                var n, e = r.a;
                                return A2(LE, b, m([
                                    A2(kP, 0, A3(fP, b, m([
                                        A2(LV, A3(CV, m([
                                            NI
                                        ]), "hide-team-delete-modal-button-" + fm(e.g7), t_), m([
                                            Xd("Cancel")
                                        ])),
                                        A2(LV, A3(CV, m([
                                            pV
                                        ]), "confim-team-delete-button-" + fm(e.g7), (n = e.g7, {
                                            $: 7,
                                            a: n
                                        })), m([
                                            Xd("Confirm")
                                        ]))
                                    ]), A3(oP, b, m([
                                        A2(SP, b, m([
                                            Xd("Once deleted, team '" + e.kv + "' will no longer be able to be assigned.")
                                        ]))
                                    ]), A3(II, b, m([
                                        Xd("Are You Sure?")
                                    ]), iP(t_)))))
                                ]));
                            }(r.b2), Me(A2(Si, c_, e)))));
                        default:
                            return A2(LE, m([
                                yE("row")
                            ]), m([
                                Xd("An error occured. Please reload or contact support.")
                            ]));
                    }
                }(n.a)));
            case 12:
                return A2(iQ, r, A2(iE, ys, function(r) {
                    return A2(LE, m([
                        yE("card team-content")
                    ]), m([
                        A2(LE, m([
                            yE("card-body")
                        ]), A2(ye, A2(LE, m([
                            yE("row")
                        ]), m([
                            A2(LE, m([
                                yE("col-6 col-sm-7 col-md-5 col-lg-7 col-xl-8")
                            ]), m([
                                A2(GI, m([
                                    yE("card-title inline-block mr1 team-name")
                                ]), m([
                                    Xd("Team: " + JK(r))
                                ]))
                            ])),
                            A2(LE, m([
                                yE("col-md-4 col-lg-3 col-xl-2 d-none d-md-block text-right")
                            ]), m([
                                YK(r)
                            ])),
                            A2(LE, m([
                                yE("col-6 col-sm-5 col-md-3 col-lg-2")
                            ]), m([
                                A2(LE, m([
                                    yE("col-12")
                                ]), m([
                                    BK
                                ])),
                                A2(LE, m([
                                    yE("col-12 d-block d-md-none pt-3 pb-0 pr-0 pl-0 text-right")
                                ]), m([
                                    YK(r)
                                ]))
                            ]))
                        ])), A2(ye, A6(yP, "Team Activity Requested", "You have successfully requested your team activity report. Please allow 30 seconds for the download to occur. If an error occurs please contact " + xN + ".", We, r.E, r.c$, OK), aU(r)))),
                        A2(UK, r.bk, r.a4)
                    ]));
                }(n.a)));
            case 13:
                return A2(iQ, r, A2(iE, Uf, function(r) {
                    var n = r.iw.$ ? "Create New Team" : "Edit Team";
                    return A2(LE, m([
                        yE("pro-card-row")
                    ]), m([
                        A2(LE, m([
                            yE("pro-card")
                        ]), m([
                            A2(LE, m([
                                yE("pro-card-title-row")
                            ]), m([
                                A2(LE, m([
                                    yE("pro-card-title-col")
                                ]), m([
                                    A2(VR, m([
                                        yE("text-capitalize pb-2 pb-sm-0")
                                    ]), m([
                                        Xd(n)
                                    ]))
                                ])),
                                A2(LE, m([
                                    yE("pro-card-action-col")
                                ]), m([
                                    A2(CE, m([
                                        EE("cancel-team-creation-button-click"),
                                        yE("btn-outline-secondary btn-sm btn-block btn"),
                                        gz(uU)
                                    ]), m([
                                        Xd("Cancel")
                                    ]))
                                ]))
                            ])),
                            A2(LE, m([
                                yE("row")
                            ]), m([
                                A2(LE, m([
                                    yE("col-12")
                                ]), m([
                                    HU(r)
                                ]))
                            ])),
                            A6(yP, n + " Error", r.a8, We, r.E, r.b3, cU)
                        ]))
                    ]));
                }(n.a)));
            case 3:
                return A2(iQ, r, A2(iE, qf, function(r) {
                    return A2(LE, m([
                        yE("container")
                    ]), m([
                        A2(LE, m([
                            yE("row")
                        ]), m([
                            A2(LE, m([
                                yE("col-12")
                            ]), m([
                                A2(bz, b, m([
                                    Xd("Companies")
                                ])),
                                A2(Sz, m([
                                    yE("nav nav-tabs")
                                ]), m([
                                    A3(Tz, r.b1, 1, "Search"),
                                    A3(Tz, r.b1, 0, "Browse")
                                ]))
                            ]))
                        ])),
                        A2(LE, m([
                            yE("row")
                        ]), m([
                            A2(LE, m([
                                yE("col-12")
                            ]), m([
                                A2(LE, m([
                                    yE("tab-content-padded")
                                ]), m([
                                    A2(LE, m([
                                        yE("tab-pane pt-2 active")
                                    ]), m([
                                        Mz(r)
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]));
                }(n.a)));
            case 15:
                return A2(iQ, r, function(r) {
                    switch(r.$){
                        case 0:
                            return f_("bad url " + r.a);
                        case 4:
                            return f_("bad payload " + r.a);
                        case 1:
                            return f_("network timeout");
                        case 2:
                            return f_("network error");
                        default:
                            return f_(A2(i_, r.a, r.b));
                    }
                }(n.a));
            case 4:
                return A2(iQ, r, A2(iE, ss, function(r) {
                    var n = i(iD(r), r.dG);
                    r: for(;;)switch(n.a.$){
                        case 1:
                            if (1 === n.b.$) {
                                var e = n.a.a, t = n.b.a, a = r.$7, u = A2(LE, m([
                                    yE("row")
                                ]), m([
                                    A2(LE, m([
                                        yE("col-12")
                                    ]), m([
                                        A2($D, r.aT, t.kN),
                                        gD(r.ar)
                                    ]))
                                ]));
                                return A2(LE, m([
                                    yE("view-content pt-3")
                                ]), m([
                                    A2(LE, m([
                                        yE("row")
                                    ]), m([
                                        A2(LE, m([
                                            yE("col-12")
                                        ]), m([
                                            yD(a.il)
                                        ]))
                                    ])),
                                    A3(XZ, r, t, r.c7),
                                    fD(r),
                                    A2(LE, m([
                                        yE("row")
                                    ]), m([
                                        A2(LE, m([
                                            yE("col")
                                        ]), m([
                                            u
                                        ]))
                                    ])),
                                    A2(LE, m([
                                        yE("row pt-4 pb-2")
                                    ]), m([
                                        A2(LE, m([
                                            yE("col-2 col-sm-1")
                                        ]), b),
                                        A2(LE, m([
                                            yE("col-5 col-sm-4 col-lg-2")
                                        ]), m([
                                            Xd("Name")
                                        ])),
                                        A2(LE, m([
                                            yE("d-none d-lg-block col-lg-3")
                                        ]), m([
                                            Xd("Email")
                                        ])),
                                        A2(LE, m([
                                            yE("d-none d-md-block col-md-4 col-lg-2")
                                        ]), m([
                                            Xd("Last Login")
                                        ])),
                                        A2(LE, m([
                                            yE("d-none d-lg-block col-2")
                                        ]), m([
                                            Xd("Reminders Enabled")
                                        ])),
                                        A2(LE, m([
                                            yE("col-5 col-sm-5 offset-sm-2 col-md-3 offset-md-0 col-lg-2")
                                        ]), b)
                                    ])),
                                    A2(LE, b, A2(aa, ND, e)),
                                    CD(r.aK),
                                    A3(LD, r.cD, r, t)
                                ]));
                            }
                            break r;
                        case 2:
                            return A2(LE, b, m([
                                Xd("An error occurred while loading users for this grant.")
                            ]));
                        default:
                            break r;
                    }
                    return A2(LE, b, m([
                        Xd("Loading")
                    ]));
                }(n.a)));
            case 5:
                return A2(iQ, r, A2(iE, fs, function(r) {
                    var n, e = r.b6;
                    switch(e.$){
                        case 0:
                            return ON("Loading User and Metrics");
                        case 2:
                            return ON("An error occured loading User or Metrics. Please reload or contact customer support");
                        default:
                            var t = e.a, a = Ve(t.g7);
                            return A2(LE, m([
                                yE("d-flex flex-column")
                            ]), m([
                                A2(LE, m([
                                    yE("row mt-4")
                                ]), m([
                                    A2(LE, m([
                                        yE("col-6")
                                    ]), m([
                                        A2(tV, b, m([
                                            (n = t, Xd(n.jM + " " + n.ka))
                                        ]))
                                    ])),
                                    A2(LE, m([
                                        yE("col-6 text-right")
                                    ]), m([
                                        A3(UN, r.E, a, 1)
                                    ]))
                                ])),
                                A3(mZ, r.j, r.by, r.E),
                                A2(JN, r.j, r.dV),
                                A4(iZ, r.j, r.by, r.E, r.aP)
                            ]));
                    }
                }(n.a)));
            case 18:
                return A2(iQ, r, A2(iE, os, function(r) {
                    var n = Me(r.eY), t = function(n) {
                        var t = r.a_;
                        if (t.$) {
                            var a = A2(aa, function(r) {
                                return r.g7;
                            }, t.a.kj);
                            return A2(Gx, function(r) {
                                return e(r.T, n);
                            }, A2(fc, function(r) {
                                return A2(bc, r.g7, a);
                            }, r.s));
                        }
                        return A2(Gx, function(r) {
                            return e(r.T, n);
                        }, r.s);
                    }, a = A3(zN, _N(r.s), r.a_, r.cW), u = function() {
                        if (pF(n)) return b;
                        var e = r.aF ? m([
                            A2(_W, "position", "absolute"),
                            A2(_W, "transform", "translate3d(14px, 62px, 0px)"),
                            A2(_W, "top", "0px"),
                            A2(_W, "left", "0px"),
                            A2(_W, "will-change", "transform")
                        ]) : b;
                        return m([
                            A2(CE, m([
                                yE("btn btn-block btn-secondary dropdown-toggle text-left"),
                                Fz(m([
                                    i("show", r.aF)
                                ])),
                                gz(TN)
                            ]), m([
                                Xd("Filter by Team")
                            ])),
                            A2(LE, l(m([
                                yE("dropdown-menu"),
                                Fz(m([
                                    i("show", r.aF)
                                ]))
                            ]), e), A2(ye, A2(CE, m([
                                yE("dropdown-item"),
                                gz(MN(Ah))
                            ]), m([
                                Xd(RN(Ah))
                            ])), DN(n)))
                        ]);
                    }(), c = m([
                        A2($G, m([
                            yE("overflow-y-scroll overflow-hidden cadenceSelect"),
                            PE(FN)
                        ]), A2(aa, function(n) {
                            var t, a;
                            return A2(bW, m([
                                gW((t = n, a = r.cH, 1 !== a.$ && e(t, a.a))),
                                HV(Ie(n))
                            ]), m([
                                Xd(Ie(n))
                            ]));
                        }, A2(Ue, 2, 31)))
                    ]), o = A2(LE, m([
                        yE("row border-top py-1 mx-0 applyToAll")
                    ]), m([
                        A2(LE, m([
                            yE("col-6 col-md-6 col-lg-8 px-0 applyToAllHeader")
                        ]), m([
                            Xd("Apply to All Users")
                        ])),
                        A2(LE, m([
                            yE("col-3 col-md-3 col-lg-2")
                        ]), m([
                            A2(SP, m([
                                yE("d-inline mb-0 font-weight-light text-nowrap learningReminderToggle")
                            ]), m([
                                A2(CE, m([
                                    yE("ml-2 toggleBtn sm-font selectAllToggle"),
                                    Fz(m([
                                        i("onState", t(0))
                                    ])),
                                    A2(VV, "label", "Turn on learning reminders"),
                                    A2(oG, "pressed", !1)
                                ]), m([
                                    A2(fz, m([
                                        yE("off default"),
                                        Fz(m([
                                            i("active", t(1)),
                                            i("inactive", t(0))
                                        ])),
                                        gz(A2(SN, 1, r.a_))
                                    ]), m([
                                        Xd("Off")
                                    ])),
                                    A2(fz, m([
                                        yE("on"),
                                        Fz(m([
                                            i("active", t(0))
                                        ])),
                                        gz(A2(SN, 0, r.a_))
                                    ]), m([
                                        Xd("On")
                                    ]))
                                ]))
                            ]))
                        ])),
                        A2(LE, m([
                            yE("d-flex align-items-center col-3 col-md-3 col-lg-2")
                        ]), c)
                    ]));
                    return A2(LE, m([
                        yE("d-flex flex-column pt-3")
                    ]), m([
                        A2(LE, m([
                            yE("row")
                        ]), m([
                            A2(LE, m([
                                yE("col-12")
                            ]), m([
                                A2(tV, m([
                                    yE("d-inline-block mr-2")
                                ]), m([
                                    Xd("Learning Reminders")
                                ])),
                                A2(VN, r.d$, AN)
                            ])),
                            A2(LE, m([
                                yE("col-12 col-sm-5 offset-sm-7 col-md-3 offset-md-6 my-3")
                            ]), m([
                                A2(CE, m([
                                    yE("btn btn-outline-secondary btn-block"),
                                    EE("cancel-learning-reminders"),
                                    gz(jN)
                                ]), m([
                                    Xd("Cancel")
                                ]))
                            ])),
                            A2(LE, m([
                                yE("col-12 col-sm-5 offset-sm-7 col-md-3 offset-md-0 mb-3 my-md-3")
                            ]), m([
                                A2(CE, m([
                                    yE("btn btn-primary btn-block"),
                                    EE("update-learning-reminders"),
                                    gz(HN)
                                ]), m([
                                    Xd("Save Changes")
                                ]))
                            ])),
                            A2(LE, m([
                                yE("col-12 col-sm-6 col-md-8 col-lg-9 pt-4 pb-2")
                            ]), m([
                                A2(TE, m([
                                    yE("form-control"),
                                    sz("text"),
                                    HV(r.cW),
                                    PE(LN),
                                    _E("Filter users by name or email")
                                ]), b)
                            ])),
                            A2(LE, m([
                                yE("col-12 col-sm-6 col-md-4 col-lg-3 dropdown pt-4 pb-2")
                            ]), u)
                        ])),
                        A2(LE, m([
                            yE("row pt-4 pb-2 mx-0")
                        ]), m([
                            A2(LE, m([
                                yE("col-6 col-md-6 col-lg-4 px-0")
                            ]), m([
                                Xd("Name")
                            ])),
                            A2(LE, m([
                                yE("d-none d-lg-block col-lg-4")
                            ]), m([
                                Xd("Email")
                            ])),
                            A2(LE, m([
                                yE("d-none d-md-block col-md-3 col-lg-2")
                            ]), m([
                                Xd("Reminders")
                            ])),
                            A2(LE, m([
                                yE("d-md-none col-6 d-lg-none")
                            ]), m([
                                Xd("Login Reminders")
                            ])),
                            A2(LE, m([
                                yE("d-none d-md-block col-md-3 col-lg-2")
                            ]), m([
                                Xd("Frequency (Days)")
                            ]))
                        ])),
                        A2(LE, m([
                            yE("d-flex flex-column")
                        ]), A2(ye, o, A2(aa, ZN, a))),
                        A2(PN, r.r, r.cl)
                    ]));
                }(n.a)));
            case 1:
                return A2(iQ, r, A2(iE, rs, A2(wI, n.a, r.ih)));
            case 9:
                return A2(iE, Ri, function(r) {
                    return function(r) {
                        var n, e, t, a;
                        return A2(LE, m([
                            yE("container")
                        ]), m([
                            A2(LE, m([
                                yE("row")
                            ]), m([
                                A2(HE, m([
                                    yE("mx-auto d-block my-5")
                                ]), m([
                                    A2(fz, m([
                                        yE("sr-only")
                                    ]), m([
                                        Xd("ProPortal Logo Icon")
                                    ])),
                                    A2(iz, "ACI Learning ProProtal logo", m([
                                        lz(125)
                                    ]))
                                ]))
                            ])),
                            A2(LE, m([
                                yE("row justify-content-center")
                            ]), m([
                                A2(LE, m([
                                    yE("col col-md-8 col-lg-6 col-xl-4")
                                ]), m([
                                    (a = r.gj, 1 === a.$ ? A2(ME, A3(DE, b, "reset-password", (t = function(r) {
                                        var n = dE(m([
                                            A2(mE, function(r) {
                                                return r.bg;
                                            }, 0),
                                            A2(vE, $E, 1),
                                            A2(gE, pE, 2)
                                        ])), e = A2(hE, n, r);
                                        return e.$ ? sc(e.a) : We;
                                    }(r), {
                                        $: 0,
                                        a: t
                                    })), m([
                                        (e = r.a8, A2(LE, b, e.$ ? b : m([
                                            Xd(jE(e.a))
                                        ]))),
                                        A2(LE, m([
                                            yE("form-group")
                                        ]), m([
                                            A2(SE, m([
                                                AE("Password"),
                                                yE("sr-only")
                                            ]), m([
                                                Xd("Password")
                                            ])),
                                            A2(TE, A3(GE, m([
                                                yE("form-control"),
                                                _E("Password"),
                                                Lv(!0),
                                                sz("password")
                                            ]), "password", A2($l, sE, Vt)), b)
                                        ])),
                                        A2(LE, m([
                                            yE("form-group")
                                        ]), m([
                                            A2(SE, m([
                                                AE("ConfirmPassword"),
                                                yE("sr-only")
                                            ]), m([
                                                Xd("ConfirmPassword")
                                            ])),
                                            A2(TE, A3(GE, m([
                                                yE("form-control"),
                                                _E("Confirm Password"),
                                                Lv(!0),
                                                sz("password")
                                            ]), "confirm-password", A2($l, fE, Vt)), b)
                                        ])),
                                        A2(LE, b, m([
                                            A2(CE, m([
                                                yE("btn btn-primary btn-block"),
                                                sz("submit"),
                                                xE((n = r.a8, 1 !== n.$))
                                            ]), m([
                                                Xd("Set My Password")
                                            ]))
                                        ]))
                                    ])) : A2(LE, b, m([
                                        Xd(a.a),
                                        A2(wE, b, b),
                                        Xd("Click "),
                                        A2(lE, m([
                                            FE("/")
                                        ]), m([
                                            Xd("here")
                                        ])),
                                        Xd(" to login.")
                                    ])))
                                ]))
                            ]))
                        ]));
                    }(r);
                }(n.a));
            case 17:
                return A2(iQ, r, A2(iE, Yf, function(r) {
                    return A2(LE, m([
                        yE("pt-3")
                    ]), function() {
                        var n = r.bG;
                        if (n.$) {
                            var e = n.a;
                            return m([
                                A2(yN, r, e),
                                A6(yP, "Activity Requested", "You have successfully requested your activity report. Please allow 30 seconds for the download to occur. If an error occurs please contact " + xN, We, e.jW, r.cd, kI)
                            ]);
                        }
                        return m([
                            Xd("Loading")
                        ]);
                    }());
                }(n.a)));
            case 14:
                return A2(iQ, r, A2(iE, Kf, function(r) {
                    var n = r.g7.$ ? "Create New Report" : "Edit Custom Report", e = function() {
                        var n = r.eI;
                        if (n.$) return A2(CE, m([
                            EE("download-customReport-creation-button-click"),
                            yE("col-12 col-md-6 btn-primary setMaxWidth btn")
                        ]), m([
                            Xd("Download CSV")
                        ]));
                        var e, t = n.a;
                        return A2(CE, m([
                            EE("download-customReport-creation-button-click"),
                            yE("col-12 col-md-6 btn-primary setMaxWidth btn"),
                            gz((e = t, {
                                $: 21,
                                a: e
                            }))
                        ]), m([
                            Xd("Download CSV")
                        ]));
                    }(), t = A2(LE, m([
                        yE("pro-card-action-col")
                    ]), m([
                        A2(CE, m([
                            EE("cancel-customReport-creation-button-click"),
                            yE("btn-outline-secondary btn-sm btn-block btn"),
                            gz(Ez)
                        ]), m([
                            Xd("Cancel")
                        ]))
                    ])), a = function() {
                        var a = r.aE;
                        switch(a.$){
                            case 0:
                                return A2(LE, m([
                                    yE("pro-card")
                                ]), m([
                                    A2(LE, m([
                                        yE("pro-card-title-row")
                                    ]), m([
                                        A2(LE, m([
                                            yE("pro-card-title-col")
                                        ]), m([
                                            A2(VR, m([
                                                yE("text-capitalize pb-2 pb-sm-0")
                                            ]), m([
                                                Xd(n)
                                            ]))
                                        ])),
                                        t
                                    ])),
                                    A2(LE, m([
                                        yE("row")
                                    ]), m([
                                        A2(LE, m([
                                            yE("col-12")
                                        ]), m([
                                            cP(r)
                                        ]))
                                    ])),
                                    A6(yP, n + " Error", r.a8, We, r.E, r.fZ, zz)
                                ]));
                            case 1:
                                return A2(LE, m([
                                    yE("pro-card")
                                ]), m([
                                    A2(LE, m([
                                        yE("row my-5 py-5")
                                    ]), m([
                                        A2(LE, m([
                                            yE("col-12 text-center mb-5")
                                        ]), m([
                                            IR
                                        ])),
                                        A2(LE, m([
                                            yE("col-12 text-center")
                                        ]), m([
                                            A2(fz, m([
                                                yE("mr-2")
                                            ]), m([
                                                WR("20px")
                                            ])),
                                            A2(fz, b, m([
                                                Xd("This may take a few minutes to generate. Please do not refresh your browser.")
                                            ]))
                                        ]))
                                    ]))
                                ]));
                            case 2:
                                return A2(LE, m([
                                    yE("pro-card")
                                ]), m([
                                    A2(LE, m([
                                        yE("pro-card-title-row")
                                    ]), m([
                                        A2(LE, m([
                                            yE("pro-card-title-col")
                                        ]), m([
                                            A2(VR, m([
                                                yE("text-capitalize pb-2 pb-sm-0")
                                            ]), m([
                                                Xd(n)
                                            ]))
                                        ])),
                                        t
                                    ])),
                                    A2(LE, m([
                                        yE("row my-5 py-5")
                                    ]), m([
                                        A2(LE, m([
                                            yE("col-12 text-center")
                                        ]), m([
                                            A2(fz, m([
                                                yE("mr-2")
                                            ]), m([
                                                Iz
                                            ])),
                                            A2(fz, b, m([
                                                Xd("An error has occurred while generating this report. Please try refreshing your browser.")
                                            ]))
                                        ]))
                                    ]))
                                ]));
                            default:
                                var u = a.a;
                                return A2(LE, m([
                                    yE("pro-card")
                                ]), m([
                                    A2(LE, m([
                                        yE("pro-card-title-row")
                                    ]), m([
                                        A2(LE, m([
                                            yE("col-12 col-xl-7")
                                        ]), m([
                                            A2(VR, m([
                                                yE("text-capitalize pb-5 pb-xl-0")
                                            ]), m([
                                                Xd(r.kv)
                                            ]))
                                        ])),
                                        A2(LE, m([
                                            yE("col-12 col-md-8 offset-md-4 col-lg-6 offset-lg-6 col-xl-5 offset-xl-0")
                                        ]), m([
                                            A2(LE, m([
                                                yE("row d-flex justify-content-around")
                                            ]), m([
                                                e,
                                                A2(CE, m([
                                                    EE("done-customReport-creation-button-click"),
                                                    yE("col-12 col-md-6 btn-outline-secondary setMaxWidth btn mt-3 mt-md-0"),
                                                    gz(Ez)
                                                ]), m([
                                                    Xd("Done")
                                                ]))
                                            ]))
                                        ]))
                                    ])),
                                    A2(LE, m([
                                        yE("col-12 mt-5 mb-3")
                                    ]), m([
                                        A2(LE, m([
                                            yE("row")
                                        ]), m([
                                            A2(LE, m([
                                                yE("col-12")
                                            ]), m([
                                                Xd("Usage Overview")
                                            ]))
                                        ])),
                                        A2(LE, m([
                                            yE("row")
                                        ]), m([
                                            A2(LE, m([
                                                yE("col-12 mt-1")
                                            ]), m([
                                                A6(RR, Rz, u, r.dV, 250, 1e3, PR(u.iX))
                                            ]))
                                        ]))
                                    ])),
                                    A2(LE, m([
                                        yE("row")
                                    ]), m([
                                        A2(LE, m([
                                            yE("col-12")
                                        ]), m([
                                            A2(fz, m([
                                                yE("mr-2")
                                            ]), m([
                                                WR("20px")
                                            ])),
                                            A2(fz, b, m([
                                                Xd("This report will be saved in your Saved Reports and will be available for download at any time.")
                                            ]))
                                        ]))
                                    ]))
                                ]));
                        }
                    }();
                    return A2(LE, m([
                        yE("pro-card-row reports")
                    ]), m([
                        a
                    ]));
                }(n.a)));
            case 16:
                return A2(iQ, r, A2(iE, hs, function(r) {
                    var n = A2(Ba, pk, r.eH), e = A2(LE, m([
                        yE("pro-card-action-col")
                    ]), m([
                        A2(CE, m([
                            EE("cancel-customReport-creation-button-click"),
                            yE("btn-outline-secondary btn-sm btn-block btn"),
                            gz(xP)
                        ]), m([
                            Xd("Cancel")
                        ]))
                    ]));
                    return A2(LE, m([
                        yE("pro-card-row reports")
                    ]), m([
                        A2(LE, m([
                            yE("pro-card")
                        ]), m([
                            A2(LE, m([
                                yE("pro-card-title-row")
                            ]), m([
                                A2(LE, m([
                                    yE("pro-card-title-col")
                                ]), m([
                                    A2(VR, m([
                                        yE("text-capitalize pb-2 pb-sm-0")
                                    ]), m([
                                        Xd(A2(Ne, " ", m([
                                            "Schedule Report:",
                                            A2(di, "Loading", n)
                                        ])))
                                    ]))
                                ])),
                                e
                            ])),
                            A2(LE, m([
                                yE("row")
                            ]), m([
                                A2(LE, m([
                                    yE("col-12")
                                ]), m([
                                    A2(VP, r, 0),
                                    A2(VP, r, 1)
                                ]))
                            ]))
                        ]))
                    ]));
                }(n.a)));
            default:
                return A2(iQ, r, A2(iE, Cs, function(r) {
                    var n, e, t, a, u = A2(Ba, function(r) {
                        return r.cb;
                    }, r.n), c = A2(IU, (n = r.n).$ ? qc : n.a, r.as), o = function() {
                        var n = r.n;
                        if (n.$) return "Logo Url";
                        var e = n.a;
                        return _t(e.Q) ? "Logo Url" : e.Q;
                    }(), i = function() {
                        var n = r.n;
                        if (n.$) return RU(36);
                        var e = n.a;
                        return _t(e.Q) || "Logo Url" === e.Q ? RU(36) : A2(sG, m([
                            dG(e.Q),
                            yE("preview-header-logo")
                        ]), b);
                    }(), f = (e = r.n).$ ? "8" : e.a.aC;
                    return A2(LE, b, m([
                        c,
                        A2(LE, m([
                            yE("container mx-0")
                        ]), m([
                            A2(LE, m([
                                yE("row mt-4")
                            ]), m([
                                A2(LE, m([
                                    yE("col-lg-7 col-12 pb-5 pb-lg-0")
                                ]), m([
                                    A2(LE, m([
                                        yE("pb-4")
                                    ]), m([
                                        A2(VU, m([
                                            yE("h2 mb-3")
                                        ]), m([
                                            Xd("Training Platform Branding")
                                        ])),
                                        A2(LE, m([
                                            yE("body mb-5")
                                        ]), m([
                                            Xd("Set your company\u2019s logo in the top left and brand color values to change the look and feel of the Training Platform. Please ensure when choosing your colors that they meet required accessibility standards.")
                                        ])),
                                        A2(GI, m([
                                            yE("h5")
                                        ]), m([
                                            Xd("Global")
                                        ])),
                                        A2(LE, m([
                                            yE("label mb-2")
                                        ]), m([
                                            A2(fz, b, m([
                                                Xd("Logo URL")
                                            ])),
                                            A2(fz, m([
                                                yE("label-small")
                                            ]), m([
                                                Xd(" (Recommended size: smaller than 150px tall)")
                                            ]))
                                        ])),
                                        A2(LE, m([
                                            yE("mb-4")
                                        ]), m([
                                            A2(SE, m([
                                                AE("logoURL"),
                                                yE("sr-only")
                                            ]), m([
                                                Xd("Logo URL, Recommended size: smaller than 150px tall")
                                            ])),
                                            A2(TE, m([
                                                sz("text"),
                                                yE("form-control"),
                                                EE("logoURL"),
                                                HV(o),
                                                PE(zU)
                                            ]), b)
                                        ])),
                                        A2(LE, m([
                                            yE("mb-2 d-flex align-items-baseline")
                                        ]), m([
                                            A2(LE, m([
                                                yE("label")
                                            ]), m([
                                                Xd("Button Radius (px)")
                                            ])),
                                            A2(LE, m([
                                                yE("popover-wrapper ml-2 mb-2")
                                            ]), m([
                                                A2(LE, m([
                                                    yE("popover-title")
                                                ]), m([
                                                    WR("1rem")
                                                ])),
                                                A2(LE, m([
                                                    yE("popover-content")
                                                ]), m([
                                                    A2(SP, m([
                                                        yE("popover-message")
                                                    ]), m([
                                                        Xd("This value will be used to calculate the roundness of the button corners in pixels.")
                                                    ]))
                                                ]))
                                            ]))
                                        ])),
                                        A2(LE, m([
                                            yE("mb-5")
                                        ]), m([
                                            A2(SE, m([
                                                AE("borderRadius"),
                                                yE("sr-only")
                                            ]), m([
                                                Xd("Button Radius, calculated in pixels")
                                            ])),
                                            A2(TE, m([
                                                sz("number"),
                                                yE("form-control"),
                                                EE("borderRadius"),
                                                HV(f),
                                                PE(EU)
                                            ]), b)
                                        ])),
                                        A2(LE, m([
                                            yE("bottom-rule")
                                        ]), b)
                                    ])),
                                    A2(LE, m([
                                        yE("mx-0 pb-4")
                                    ]), m([
                                        A2(LE, m([
                                            yE("mb-2 d-flex align-items-center")
                                        ]), m([
                                            A2(GI, m([
                                                yE("h5")
                                            ]), m([
                                                Xd("Header")
                                            ])),
                                            A2(LE, m([
                                                yE("popover-wrapper ml-2 mb-2")
                                            ]), m([
                                                A2(LE, m([
                                                    yE("popover-title")
                                                ]), m([
                                                    WR("1rem")
                                                ])),
                                                A2(LE, m([
                                                    yE("popover-content")
                                                ]), m([
                                                    A2(SP, m([
                                                        yE("popover-message")
                                                    ]), m([
                                                        Xd("This value will be used to affect the background and icon/text color in the header.")
                                                    ]))
                                                ]))
                                            ]))
                                        ])),
                                        A2(LE, m([
                                            yE("row mb-4")
                                        ]), m([
                                            A2(LE, m([
                                                yE("col-6 d-flex align-items-center")
                                            ]), m([
                                                A2(TE, m([
                                                    sz("color"),
                                                    HV(A2(NU, r, 0)),
                                                    PE(TU(0))
                                                ]), b),
                                                A2(LE, m([
                                                    yE("body ml-3")
                                                ]), m([
                                                    Xd("Background")
                                                ]))
                                            ])),
                                            A2(LE, m([
                                                yE("col-6 d-flex align-items-center")
                                            ]), m([
                                                A2(TE, m([
                                                    sz("color"),
                                                    HV(A2(NU, r, 1)),
                                                    PE(TU(1))
                                                ]), b),
                                                A2(LE, m([
                                                    yE("body ml-3")
                                                ]), m([
                                                    Xd("Text/Icon")
                                                ]))
                                            ]))
                                        ])),
                                        A2(LE, m([
                                            yE("bottom-rule")
                                        ]), b)
                                    ])),
                                    A2(LE, m([
                                        yE("mx-0 pb-4")
                                    ]), m([
                                        A2(LE, m([
                                            yE("mb-2 d-flex align-items-center")
                                        ]), m([
                                            A2(GI, m([
                                                yE("h5")
                                            ]), m([
                                                Xd("Primary")
                                            ])),
                                            A2(LE, m([
                                                yE("popover-wrapper ml-2 mb-2")
                                            ]), m([
                                                A2(LE, m([
                                                    yE("popover-title")
                                                ]), m([
                                                    WR("1rem")
                                                ])),
                                                A2(LE, m([
                                                    yE("popover-content")
                                                ]), m([
                                                    A2(SP, m([
                                                        yE("popover-message")
                                                    ]), m([
                                                        Xd("This value will be used to affect the hover state of the primary button style.")
                                                    ]))
                                                ]))
                                            ]))
                                        ])),
                                        A2(LE, m([
                                            yE("row mb-4")
                                        ]), m([
                                            A2(LE, m([
                                                yE("col-6 d-flex align-items-center")
                                            ]), m([
                                                A2(TE, m([
                                                    sz("color"),
                                                    HV(A2(NU, r, 2)),
                                                    PE(TU(2))
                                                ]), b),
                                                A2(LE, m([
                                                    yE("body ml-3")
                                                ]), m([
                                                    Xd("Button Background")
                                                ]))
                                            ])),
                                            A2(LE, m([
                                                yE("col-6 d-flex align-items-center")
                                            ]), m([
                                                A2(TE, m([
                                                    sz("color"),
                                                    HV(A2(NU, r, 3)),
                                                    PE(TU(3))
                                                ]), b),
                                                A2(LE, m([
                                                    yE("body ml-3")
                                                ]), m([
                                                    Xd("Button Text")
                                                ]))
                                            ]))
                                        ])),
                                        A2(LE, m([
                                            yE("bottom-rule")
                                        ]), b)
                                    ])),
                                    A2(LE, m([
                                        yE("mx-0 pb-4")
                                    ]), m([
                                        A2(LE, m([
                                            yE("mb-2 d-flex align-items-center")
                                        ]), m([
                                            A2(GI, m([
                                                yE("h5")
                                            ]), m([
                                                Xd("Accent")
                                            ])),
                                            A2(LE, m([
                                                yE("popover-wrapper ml-2 mb-2")
                                            ]), m([
                                                A2(LE, m([
                                                    yE("popover-title")
                                                ]), m([
                                                    WR("1rem")
                                                ])),
                                                A2(LE, m([
                                                    yE("popover-content")
                                                ]), m([
                                                    A2(SP, m([
                                                        yE("popover-message")
                                                    ]), m([
                                                        Xd("This value will be used to affect the secondary button style, control inputs, various accent flairs, and more.")
                                                    ]))
                                                ]))
                                            ]))
                                        ])),
                                        A2(LE, m([
                                            yE("row mb-4")
                                        ]), m([
                                            A2(LE, m([
                                                yE("col-6 d-flex align-items-center")
                                            ]), m([
                                                A2(TE, m([
                                                    sz("color"),
                                                    HV(A2(NU, r, 4)),
                                                    PE(TU(4))
                                                ]), b),
                                                A2(LE, m([
                                                    yE("body ml-3")
                                                ]), m([
                                                    Xd("Button Background")
                                                ]))
                                            ])),
                                            A2(LE, m([
                                                yE("col-6 d-flex align-items-center")
                                            ]), m([
                                                A2(TE, m([
                                                    sz("color"),
                                                    HV(A2(NU, r, 5)),
                                                    PE(TU(5))
                                                ]), b),
                                                A2(LE, m([
                                                    yE("body ml-3")
                                                ]), m([
                                                    Xd("Button Text")
                                                ]))
                                            ]))
                                        ])),
                                        A2(LE, m([
                                            yE("bottom-rule")
                                        ]), b)
                                    ])),
                                    A2(LE, m([
                                        yE("mt-2")
                                    ]), m([
                                        A2(LE, b, m([
                                            Xd("Once the changes are reset, you must click Apply Changes to save the reset.")
                                        ])),
                                        A2(LE, m([
                                            yE("mt-3")
                                        ]), m([
                                            A2(CE, m([
                                                yE("btn btn-white-outline mr-4"),
                                                gz((a = u, {
                                                    $: 3,
                                                    a: a
                                                }))
                                            ]), m([
                                                Xd("Reset Changes")
                                            ])),
                                            A2(CE, m([
                                                yE("btn btn-primary"),
                                                gz(SU)
                                            ]), m([
                                                Xd("Apply Changes")
                                            ]))
                                        ]))
                                    ]))
                                ])),
                                A2(LE, m([
                                    yE("col-lg-5 pl-lg-5 col-12")
                                ]), m([
                                    A2(bz, m([
                                        yE("mb-3")
                                    ]), m([
                                        Xd("Preview User of Interface")
                                    ])),
                                    A2(LE, m([
                                        yE("preview")
                                    ]), m([
                                        A2(LE, m([
                                            EE("header"),
                                            yE("row mx-0 p-3 d-flex justify-content-between align-items-center"),
                                            A2(_W, "background-color", A2(NU, r, 0)),
                                            A2(_W, "color", A2(NU, r, 1))
                                        ]), m([
                                            A2(LE, m([
                                                yE("logo")
                                            ]), m([
                                                i
                                            ])),
                                            A2(LE, m([
                                                yE("header-right-side")
                                            ]), m([
                                                Xd("Header Text Color"),
                                                WU(A2(NU, r, 1))
                                            ]))
                                        ])),
                                        A2(LE, m([
                                            yE("row mx-0 p-3")
                                        ]), m([
                                            A2(LE, m([
                                                yE("col-12 preview-label mb-2")
                                            ]), m([
                                                Xd("Buttons:")
                                            ])),
                                            A2(LE, m([
                                                yE("col-12 d-flex flex-wrap pb-3")
                                            ]), m([
                                                A2(CE, m([
                                                    yE("btn btn-navy-outline mr-3 mb-3"),
                                                    A2(_W, "border-color", A2(NU, r, 2)),
                                                    A2(_W, "border-radius", f + "px")
                                                ]), m([
                                                    Xd("Outline")
                                                ])),
                                                A2(CE, m([
                                                    yE("btn btn-primary mr-3 mb-3"),
                                                    A2(_W, "background-color", A2(NU, r, 4)),
                                                    A2(_W, "color", A2(NU, r, 5)),
                                                    A2(_W, "border-color", A2(NU, r, 4)),
                                                    A2(_W, "border-radius", f + "px")
                                                ]), m([
                                                    Xd("Filled")
                                                ])),
                                                A2(CE, m([
                                                    yE("btn btn-accent-translucent mb-3"),
                                                    A2(_W, "background-color", "color-mix(in srgb, " + A2(NU, r, 4) + " 20%, white)"),
                                                    A2(_W, "border-color", A2(NU, r, 4)),
                                                    A2(_W, "border-radius", f + "px")
                                                ]), m([
                                                    Xd("Translucent")
                                                ]))
                                            ])),
                                            A2(LE, m([
                                                yE("col-12 preview-label mb-2")
                                            ]), m([
                                                Xd("Button Hover States:")
                                            ])),
                                            A2(LE, m([
                                                yE("col-12 d-flex flex-wrap")
                                            ]), m([
                                                A2(CE, m([
                                                    yE("btn btn-navy-outline mr-3 mb-3"),
                                                    A2(_W, "color", A2(NU, r, 3)),
                                                    A2(_W, "background-color", A2(NU, r, 2)),
                                                    A2(_W, "border-color", A2(NU, r, 2)),
                                                    A2(_W, "border-radius", f + "px")
                                                ]), m([
                                                    Xd("Outline")
                                                ])),
                                                A2(CE, m([
                                                    yE("btn btn-primary mr-3 mb-3"),
                                                    A2(_W, "background-color", "color-mix(in srgb, " + A2(NU, r, 4) + " 90%, black)"),
                                                    A2(_W, "color", A2(NU, r, 5)),
                                                    A2(_W, "border-color", "color-mix(in srgb, " + A2(NU, r, 4) + " 90%, black)"),
                                                    A2(_W, "border-radius", f + "px")
                                                ]), m([
                                                    Xd("Filled")
                                                ])),
                                                A2(CE, m([
                                                    yE("btn btn-accent-translucent mb-3"),
                                                    A2(_W, "background-color", A2(NU, r, 4)),
                                                    A2(_W, "color", A2(NU, r, 5)),
                                                    A2(_W, "border-color", A2(NU, r, 4)),
                                                    A2(_W, "border-radius", f + "px")
                                                ]), m([
                                                    Xd("Translucent")
                                                ]))
                                            ]))
                                        ])),
                                        A2(LE, m([
                                            yE("row mx-0 p-3")
                                        ]), m([
                                            A2(LE, m([
                                                yE("col-12 preview-label mb-2")
                                            ]), m([
                                                Xd("Tabs:")
                                            ])),
                                            A2(LE, m([
                                                yE("col-12")
                                            ]), m([
                                                A2(fz, m([
                                                    yE("tab mr-3 tab-rule"),
                                                    A2(_W, "border-color", A2(NU, r, 4))
                                                ]), m([
                                                    Xd("Tab1")
                                                ])),
                                                A2(fz, m([
                                                    yE("tab")
                                                ]), m([
                                                    Xd("Tab2")
                                                ]))
                                            ]))
                                        ])),
                                        A2(LE, m([
                                            yE("row mx-0 p-3 pb-4")
                                        ]), m([
                                            A2(LE, m([
                                                yE("col-12 preview-label mb-2")
                                            ]), m([
                                                Xd("Controls:")
                                            ])),
                                            A2(LE, m([
                                                yE("col-12 d-flex align-items-center")
                                            ]), m([
                                                A2(LE, m([
                                                    yE("checkbox-background mr-3"),
                                                    A2(_W, "background-color", A2(NU, r, 4)),
                                                    A2(_W, "border-color", A2(NU, r, 4))
                                                ]), m([
                                                    A2(LE, m([
                                                        yE("check")
                                                    ]), m([
                                                        (t = A2(NU, r, 5), A2(az, m([
                                                            cz("0 0 20 20")
                                                        ]), m([
                                                            A2(XE, m([
                                                                YE("none"),
                                                                nz(jD(t)),
                                                                ez("round"),
                                                                HR("round"),
                                                                tz("3"),
                                                                BE("m6 10 3 3 6-6")
                                                            ]), b)
                                                        ])))
                                                    ]))
                                                ])),
                                                A2(LE, m([
                                                    yE("toggle-background d-flex align-items-center"),
                                                    A2(_W, "background-color", A2(NU, r, 4))
                                                ]), m([
                                                    A2(LE, m([
                                                        yE("switch")
                                                    ]), b)
                                                ]))
                                            ]))
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]));
                }(n.a)));
        }
    };
    qS = {
        Main: {
            init: (US = (KS = {
                jZ: jS,
                kF: function(r) {
                    return {
                        $: 1,
                        a: r
                    };
                },
                kG: function(r) {
                    return {
                        $: 0,
                        a: r
                    };
                },
                la: function(r) {
                    var n = r.hQ.$ ? HS : A2(FS, ps, uE), e = r.kK;
                    switch(e.$){
                        case 1:
                            return AS(m([
                                A2(FS, rs, nE(e.a)),
                                n
                            ]));
                        case 0:
                            return AS(m([
                                A2(FS, Pi, tE),
                                n
                            ]));
                        default:
                            return AS(m([
                                MS(cE),
                                n
                            ]));
                    }
                },
                ln: LS,
                lr: function(r) {
                    return {
                        bv: m([
                            fQ(r)
                        ]),
                        z: A2(Ne, " ", m([
                            Tl,
                            "ProPortal"
                        ]))
                    };
                }
            }).kF, BS = KS.kG, QS = function() {
                QS.a(US(Kn()));
            }, _n({
                ge: function(r) {
                    return QS.a = r, Bn.addEventListener("popstate", QS), 0 > Bn.navigator.userAgent.indexOf("Trident") || Bn.addEventListener("hashchange", QS), F2(function(n, e) {
                        if (!(e.ctrlKey || e.metaKey || e.shiftKey || e.button >= 1 || n.target || n.hasAttribute("download"))) {
                            e.preventDefault();
                            var t = n.href, a = Kn(), u = Jt(t).a;
                            r(BS(u && a.h$ === u.h$ && a.hg === u.hg && a.hW.a === u.hW.a ? {
                                $: 0,
                                a: u
                            } : function(r) {
                                return {
                                    $: 1,
                                    a: r
                                };
                            }(t)));
                        }
                    });
                },
                jZ: function(r) {
                    return A3(KS.jZ, r, Kn(), QS);
                },
                lr: KS.lr,
                ln: KS.ln,
                la: KS.la
            }))(ru)(0)
        }
    }, r.Elm ? function r(n, e) {
        for(var t in e)t in n ? "init" == t ? j(6) : r(n[t], e[t]) : n[t] = e[t];
    }(r.Elm, qS) : r.Elm = qS;
}(module.exports);

});

parcelRegister("jPv2J", function(module, exports) {
module.exports = JSON.parse('{"v":"5.7.4","fr":30,"ip":0,"op":665,"w":1200,"h":180,"nm":"Web","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Left Side Matte \u2014 HealthTech","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[227.411,92.943,0],"ix":2,"l":2},"a":{"a":0,"k":[296.411,919.943,0],"ix":1,"l":2},"s":{"a":0,"k":[7241,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[0,-76.837],[0,76.837]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.733333349228,0.254901975393,0.152941182256,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4.849,"ix":5},"lc":1,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[294.036,919.943],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":665,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"HealthTech","tt":2,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.345,"y":1},"o":{"x":0.167,"y":0.167},"t":375,"s":[-291.776,92.943,0],"to":[133.333,0,0],"ti":[-133.333,0,0]},{"i":{"x":0.345,"y":0.345},"o":{"x":0.167,"y":0.167},"t":415,"s":[508.224,92.943,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.655,"y":0},"t":445,"s":[508.224,92.943,0],"to":[-134.167,0,0],"ti":[134.167,0,0]},{"t":485,"s":[-296.776,92.943,0]}],"ix":2,"l":2},"a":{"a":0,"k":[577.847,919.943,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"a","pt":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[1142.203,800],[312,800],[312,1044.984],[1142.203,1044.984]],"c":true},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"Mask 1"}],"shapes":[{"ty":"gr","it":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,12.707],[6.978,0],[0,-11.77],[-7.707,0]],"o":[[0,-11.872],[-7.082,0],[0,12.082],[6.875,0]],"v":[[10.676,-0.417],[0.468,-16.456],[-10.572,-0.208],[0.156,16.665]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,16.247],[-18.852,0],[0,-16.04],[19.477,0]],"o":[[0,-17.394],[18.852,0],[0,17.706],[-19.685,0]],"v":[[-27.028,0.209],[0.885,-28.331],[27.028,-0.937],[-0.573,28.331]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[1043.808,921.93],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[4.584,-3.644],[0,0],[0,0],[0,0],[0,0],[0,0],[-8.332,0],[-0.937,-0.105],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[3.645,-5.312],[0.833,0],[0,0],[-7.082,-0.625]],"v":[[-1.459,-7.396],[-1.459,27.706],[-17.185,27.706],[-17.185,-26.559],[-3.75,-26.559],[-2.604,-18.018],[14.477,-27.706],[17.185,-27.601],[17.185,-12.29]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[992.865,921.306],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,11.041],[7.812,0],[0,0],[0,0],[0,0]],"o":[[0,-9.686],[0,0],[0,0],[0,0],[8.229,0]],"v":[[10.364,-13.019],[-3.177,-24.788],[-10.884,-24.788],[-10.884,0.416],[-4.426,0.416]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,-11.977],[19.581,0],[0,0],[0,0]],"o":[[0,0],[0,0],[19.268,0],[0,18.123],[0,0],[0,0],[0,0]],"v":[[-26.82,37.704],[-26.82,-37.704],[1.719,-37.704],[26.82,-14.165],[-2.656,13.332],[-10.884,13.332],[-10.884,37.704]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[938.756,911.307],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[4.895,0],[2.082,-1.875],[0,0],[0,0],[0,0],[0,0],[0,0],[-7.707,0],[0,-12.394],[0,0]],"o":[[0,0],[0,-5.833],[-4.271,0],[0,0],[0,0],[0,0],[0,0],[0,0],[3.854,-3.021],[11.666,0],[0,0],[0,0]],"v":[[8.905,39.319],[8.905,5.052],[1.719,-3.281],[-8.905,0.989],[-8.905,39.319],[-24.632,39.319],[-24.632,-39.319],[-9.01,-39.319],[-9.01,-9.947],[7.759,-16.093],[24.632,2.239],[24.632,39.319]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[870.854,909.693],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,16.04],[-17.602,0],[-1.042,-13.229],[0,0],[6.145,0],[0,-12.603],[-6.666,0],[-0.937,6.874],[0,0],[12.707,0]],"o":[[0,-18.644],[13.019,0],[0,0],[-0.625,-6.77],[-5.937,0],[0,12.602],[6.041,0],[0,0],[-1.875,13.644],[-18.123,0]],"v":[[-25.257,0.833],[2.448,-28.331],[25.049,-7.811],[10.988,-5.729],[2.135,-16.248],[-8.801,-0.832],[1.926,16.04],[12.03,6.146],[25.257,8.645],[0.885,28.331]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[808.869,921.93],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 5","np":2,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[5.103,0],[0.104,-7.917],[0,0]],"o":[[-4.479,0],[0,0],[0,-7.812]],"v":[[0.782,-16.977],[-8.176,-6.145],[8.697,-6.145]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,14.685],[-14.582,0],[0,-15.102],[0.209,-1.875],[0,0],[-6.874,0],[-1.042,4.583],[0,0],[12.916,0]],"o":[[0,-19.581],[16.457,0],[0,1.772],[0,0],[0.312,8.958],[5.625,0],[0,0],[-1.978,10.104],[-20.101,0]],"v":[[-24.945,0.105],[1.614,-28.331],[24.945,-3.229],[24.632,3.854],[-8.385,3.854],[2.551,16.144],[11.405,8.437],[24.632,11.665],[1.614,28.331]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[747.862,921.93],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 6","np":3,"cix":2,"bm":0,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-7.968,-24.163],[-30.153,-24.163],[-30.153,-37.704],[30.153,-37.704],[30.153,-24.163],[8.176,-24.163],[8.176,37.704],[-7.968,37.704]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[696.128,911.307],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 7","np":2,"cix":2,"bm":0,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[4.895,0],[2.082,-1.875],[0,0],[0,0],[0,0],[0,0],[0,0],[-7.707,0],[0,-12.394],[0,0]],"o":[[0,0],[0,-5.833],[-4.271,0],[0,0],[0,0],[0,0],[0,0],[0,0],[3.854,-3.021],[11.666,0],[0,0],[0,0]],"v":[[8.905,39.319],[8.905,5.052],[1.719,-3.281],[-8.905,0.989],[-8.905,39.319],[-24.632,39.319],[-24.632,-39.319],[-9.01,-39.319],[-9.01,-9.947],[7.759,-16.093],[24.632,2.239],[24.632,39.319]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[640.171,909.693],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 8","np":2,"cix":2,"bm":0,"ix":8,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[6.875,0],[0,12.394],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-4.999,0],[-2.083,1.25],[0,0]],"o":[[-11.352,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,4.791],[3.124,0],[0,0],[-2.708,1.77]],"v":[[4.739,36.819],[-12.551,19.216],[-12.551,-7.239],[-20.675,-7.239],[-20.675,-18.696],[-12.551,-18.696],[-12.551,-34.736],[3.177,-36.819],[3.177,-18.696],[17.551,-18.696],[17.551,-7.239],[3.177,-7.239],[3.177,17.029],[9.53,24.319],[18.488,21.82],[20.675,32.965]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[584.499,913.442],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 9","np":2,"cix":2,"bm":0,"ix":9,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-7.864,39.319],[-7.864,-39.319],[7.864,-39.319],[7.864,39.319]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[545.701,909.693],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 10","np":2,"cix":2,"bm":0,"ix":10,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-5.521],[-5,0],[-1.667,1.667],[0,0],[0,0]],"o":[[0,3.124],[3.749,0],[0,0],[0,0],[-7.499,0.209]],"v":[[-10.884,11.25],[-4.531,17.186],[4.531,13.644],[4.531,4.062],[2.031,4.062]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[-2.708,0],[-1.355,0.417],[0,0],[3.333,0],[1.146,5.104],[7.499,0],[0,5.415],[-13.957,-0.104],[0,0],[6.875,0],[1.041,-5.311],[0,0],[-14.79,0],[0,-13.54],[0,0]],"o":[[0.937,0],[0,0],[-2.083,1.041],[-6.25,0],[-3.437,4.479],[-13.54,0],[0,-16.561],[0,0],[0,-6.144],[-5.208,0],[0,0],[1.666,-10.207],[14.477,0],[0,0],[0,2.916]],"v":[[23.07,17.706],[26.299,17.081],[26.715,26.143],[16.717,28.226],[5.572,21.352],[-10.572,28.331],[-26.715,13.853],[4.426,-5.104],[4.426,-7.083],[-3.281,-16.977],[-11.509,-9.478],[-24.841,-12.082],[-1.926,-28.331],[19.841,-9.165],[19.841,13.54]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[500.421,921.93],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 11","np":3,"cix":2,"bm":0,"ix":11,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[5.103,0],[0.104,-7.917],[0,0]],"o":[[-4.479,0],[0,0],[0,-7.812]],"v":[[0.782,-16.977],[-8.176,-6.145],[8.697,-6.145]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,14.685],[-14.582,0],[0,-15.102],[0.209,-1.875],[0,0],[-6.874,0],[-1.042,4.583],[0,0],[12.916,0]],"o":[[0,-19.581],[16.457,0],[0,1.772],[0,0],[0.312,8.958],[5.625,0],[0,0],[-1.978,10.104],[-20.101,0]],"v":[[-24.945,0.105],[1.614,-28.331],[24.945,-3.229],[24.632,3.854],[-8.385,3.854],[2.551,16.144],[11.405,8.437],[24.632,11.665],[1.614,28.331]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[439.978,921.93],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 12","np":3,"cix":2,"bm":0,"ix":12,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[14.374,37.704],[14.374,6.77],[-14.478,6.77],[-14.478,37.704],[-30.518,37.704],[-30.518,-37.704],[-14.478,-37.704],[-14.478,-7.082],[14.374,-7.082],[14.374,-37.704],[30.518,-37.704],[30.518,37.704]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[371.807,911.307],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 13","np":2,"cix":2,"bm":0,"ix":13,"mn":"ADBE Vector Group","hd":false},{"ty":"tr","p":{"a":0,"k":[371.807,911.307],"ix":2},"a":{"a":0,"k":[371.807,911.307],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":13,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[0,-76.837],[0,76.837]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.145098045468,0.749019622803,0.733333349228,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4.849,"ix":5},"lc":1,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[293.399,919.943],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[10.126,36.367],[-10.126,36.367],[-10.126,-36.367],[10.126,-36.367]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[235.817,913.55],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[15.756,0],[0,22.981],[-21.985,0],[-4.4,-13.479],[0,0],[7.376,0],[0,-15.891],[-9.368,0],[-3.123,8.797]],"o":[[-4.111,13.054],[-21.985,0],[0,-21.989],[18.022,0],[0,0],[-2.837,-9.221],[-9.927,0],[0,16.034],[7.793,0],[0,0]],"v":[[33.27,15.532],[3.333,36.958],[-33.27,0.069],[2.341,-36.958],[32.988,-15.111],[15.823,-9.58],[2.341,-23.202],[-12.84,0.069],[2.916,23.336],[18.097,10.993]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[187.696,914.091],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,-6.94],[-6.944,0],[-4.864,3.329]],"o":[[-20.267,1.389],[0,6.102],[5.825,0],[0,0]],"v":[[12.008,2.02],[-13.671,14.653],[-2.982,23.672],[12.008,18.121]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[10.328,0],[0,14.716],[-30.147,1.131],[0,0],[9.035,0.647],[6.67,-3.571],[0,0],[-12.165,0],[0,-15.284]],"o":[[0,0],[0,0],[-8.066,6.936],[-11.463,0],[0,-16.133],[0,0],[0,-7.928],[-12.534,-0.893],[0,0],[9.665,-6.206],[20.386,0],[0,0]],"v":[[32.411,35.448],[14.865,35.448],[14.012,26.394],[-10.612,36.44],[-32.411,16.204],[12.881,-8.562],[12.881,-11.11],[0.002,-22.152],[-28.435,-15.867],[-28.304,-27.758],[4.525,-36.44],[32.411,-13.518]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[117.3,914.09],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[10.126,10.021],[-10.126,10.021],[-10.126,-10.021],[10.126,-10.021]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.40000000596,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[235.817,859.83],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,6.102],[-5.432,0],[-0.98,-4.115],[0.107,0],[0,0],[0.036,0.139],[2.65,0],[0,-4.678],[-3.666,0],[-0.091,3.416],[0,0],[0,0.107],[0,0],[-0.119,0],[0,0],[0,-0.115],[5.845,0]],"o":[[-5.547,0],[0,-6.214],[4.622,0],[0.024,0.111],[0,0],[-0.139,0],[-0.643,-2.464],[-3.619,0],[0,4.531],[3.273,0],[0,0],[-0.119,0],[0,0],[0,-0.115],[0,0],[0.111,0],[0.083,7.027],[0,0]],"v":[[0.213,10.191],[-9.17,-0.002],[0.098,-10.191],[8.72,-3.724],[8.558,-3.498],[5.471,-3.498],[5.189,-3.724],[0.13,-7.449],[-5.615,0.058],[0.241,7.446],[5.534,2.041],[0.13,2.041],[-0.096,1.823],[-0.096,-0.419],[0.13,-0.645],[8.943,-0.645],[9.169,-0.419],[0.213,10.191]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[236.499,979.886],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 5","np":2,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0.115,0],[0,0],[0,0.111],[0,0],[0,0],[-0.115,0],[0,0],[-0.056,-0.115],[0,0],[0,0],[0,0],[0,0],[-0.119,0],[0,0],[0,-0.107],[0,0],[0,0],[0.107,0],[0,0],[0.056,0.111],[0,0],[0,0]],"o":[[0,0],[0,0.111],[0,0],[-0.115,0],[0,0],[0,0],[0,-0.107],[0,0],[0.143,0],[0,0],[0,0],[0,0],[0,0],[0,-0.107],[0,0],[0.107,0],[0,0],[0,0],[0,0.111],[0,0],[-0.139,0],[0,0],[0,0],[0,0]],"v":[[-4.966,0.839],[-4.938,9.572],[-5.168,9.798],[-7.961,9.798],[-8.187,9.572],[-8.104,-0.058],[-8.187,-9.576],[-7.961,-9.798],[-4.295,-9.798],[-3.962,-9.6],[5.112,5.458],[5.077,4.478],[4.97,-0.224],[4.97,-9.576],[5.196,-9.798],[7.965,-9.798],[8.187,-9.576],[8.108,-0.058],[8.187,9.572],[7.965,9.798],[4.156,9.798],[3.819,9.6],[-5.108,-5.235],[-5.053,-3.867]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[213.683,979.886],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 6","np":2,"cix":2,"bm":0,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0.111],[0,0],[0,0],[-0.107,0],[0,0],[0,-0.111],[0,0],[0,0],[0.115,0]],"o":[[-0.107,0],[0,0],[0,0],[0,-0.111],[0,0],[0.115,0],[0,0],[0,0],[0,0.111],[0,0]],"v":[[-1.512,9.796],[-1.738,9.57],[-1.619,-0.083],[-1.738,-9.574],[-1.512,-9.796],[1.512,-9.796],[1.738,-9.574],[1.627,-0.083],[1.738,9.57],[1.512,9.796]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[196.629,979.887],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 7","np":2,"cix":2,"bm":0,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0.111,0],[0,0],[0,0.111],[0,0],[0,0],[-0.115,0],[0,0],[-0.06,-0.115],[0,0],[0,0],[0,0],[0,0],[-0.119,0],[0,0],[0,-0.107],[0,0],[0,0],[0.111,0],[0,0],[0.056,0.111],[0,0],[0,0]],"o":[[0,0],[0,0.111],[0,0],[-0.115,0],[0,0],[0,0],[0,-0.107],[0,0],[0.143,0],[0,0],[0,0],[0,0],[0,0],[0,-0.107],[0,0],[0.111,0],[0,0],[0,0],[0,0.111],[0,0],[-0.135,0],[0,0],[0,0],[0,0]],"v":[[-4.968,0.839],[-4.94,9.572],[-5.166,9.798],[-7.963,9.798],[-8.189,9.572],[-8.106,-0.058],[-8.189,-9.576],[-7.963,-9.798],[-4.297,-9.798],[-3.96,-9.6],[5.11,5.458],[5.079,4.478],[4.968,-0.224],[4.968,-9.576],[5.198,-9.798],[7.963,-9.798],[8.189,-9.576],[8.106,-0.058],[8.189,9.572],[7.963,9.798],[4.154,9.798],[3.821,9.6],[-5.11,-5.235],[-5.055,-3.867]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[178.556,979.886],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 8","np":2,"cix":2,"bm":0,"ix":8,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,2.353],[2.496,0]],"o":[[0,0],[0,0],[0,0],[2.182,0],[0,-2.266],[0,0]],"v":[[0.045,-7.168],[-4.344,-7.168],[-4.407,-0.45],[0.132,-0.45],[3.961,-3.752],[0.045,-7.168]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0.107,0],[0,0],[0,0.111],[0,0],[0,0],[-0.115,0],[0,0],[0,-3.976],[2.829,-0.754],[0,0],[0.107,0],[0,0],[0.056,0.107]],"o":[[0,0],[0,0],[0,0],[0,0.111],[0,0],[-0.115,0],[0,0],[0,0],[0,-0.111],[0,0],[4.67,0],[0,2.996],[0,0],[0.056,0.079],[0,0],[-0.143,0],[0,0]],"v":[[1.584,5.878],[-0.852,2.212],[-4.379,2.212],[-4.32,9.572],[-4.542,9.798],[-7.566,9.798],[-7.792,9.572],[-7.708,-0.113],[-7.792,-9.572],[-7.566,-9.798],[-0.146,-9.798],[7.298,-3.807],[2.786,1.875],[7.77,9.604],[7.663,9.798],[4.104,9.798],[3.77,9.604]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[155.833,979.886],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 9","np":3,"cix":2,"bm":0,"ix":9,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[2.869,1.567],[-0.099,-7.392],[-3.003,1.567]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0.056,0.143],[0,0],[0,0],[0,0],[0.135,0],[0,0],[-0.056,0.111],[0,0],[-0.135,0],[0,0],[-0.056,-0.143],[0,0],[0.111,0]],"o":[[-0.139,0],[0,0],[0,0],[0,0],[-0.028,0.143],[0,0],[-0.107,0],[0,0],[0.056,-0.143],[0,0],[0.135,0],[0,0],[0.052,0.111],[0,0]],"v":[[5.837,9.796],[5.527,9.57],[3.825,4.42],[-3.928,4.42],[-5.614,9.57],[-5.892,9.796],[-8.915,9.796],[-9.058,9.57],[-2.309,-9.574],[-2.003,-9.796],[2.119,-9.796],[2.425,-9.574],[9.059,9.57],[8.92,9.796]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[132.224,979.886],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 10","np":3,"cix":2,"bm":0,"ix":10,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0.111],[0,0],[0,0],[-0.115,0],[0,0],[0,-0.111],[0,0],[0.107,0],[0,0],[0,0],[0,0],[0,-0.111],[0,0],[0.115,0],[0,0],[0,0],[0,0],[0,-0.111],[0,0],[0.107,0]],"o":[[-0.115,0],[0,0],[0,0],[0,-0.111],[0,0],[0.107,0],[0,0],[0,0.111],[0,0],[0,0],[0,0],[0.115,0],[0,0],[0,0.111],[0,0],[0,0],[0,0],[0.107,0],[0,0],[0,0.111],[0,0]],"v":[[-6.394,9.796],[-6.62,9.57],[-6.509,-0.143],[-6.62,-9.574],[-6.394,-9.796],[6.176,-9.796],[6.402,-9.574],[6.402,-7.336],[6.176,-7.11],[-3.144,-7.11],[-3.232,-1.936],[5.418,-1.936],[5.64,-1.71],[5.64,0.532],[5.418,0.754],[-3.232,0.754],[-3.144,7.11],[6.402,7.11],[6.62,7.332],[6.62,9.57],[6.402,9.796]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[110.047,979.887],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 11","np":2,"cix":2,"bm":0,"ix":11,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0.111],[0,0],[0,0],[-0.115,0],[0,0],[0,-0.111],[0,0],[0,0],[0,0],[0,-0.111],[0,0],[0.107,0]],"o":[[-0.115,0],[0,0],[0,0],[0,-0.111],[0,0],[0.107,0],[0,0],[0,0],[0,0],[0.107,0],[0,0],[0,0.111],[0,0]],"v":[[-5.793,9.796],[-6.019,9.57],[-5.908,-0.198],[-6.019,-9.574],[-5.793,-9.796],[-2.742,-9.796],[-2.52,-9.574],[-2.635,-0.393],[-2.52,7.11],[5.797,7.11],[6.019,7.332],[6.019,9.57],[5.797,9.796]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[90.878,979.887],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 12","np":2,"cix":2,"bm":0,"ix":12,"mn":"ADBE Vector Group","hd":false},{"ty":"tr","p":{"a":0,"k":[90.878,979.887],"ix":2},"a":{"a":0,"k":[90.878,979.887],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":12,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":665,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Left Side Matte \u2014 Skills","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[227.411,92.943,0],"ix":2,"l":2},"a":{"a":0,"k":[296.411,919.943,0],"ix":1,"l":2},"s":{"a":0,"k":[7241,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[0,-76.837],[0,76.837]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.733333349228,0.254901975393,0.152941182256,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4.849,"ix":5},"lc":1,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[294.036,919.943],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":665,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"SkillsProTV","tt":2,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.345,"y":1},"o":{"x":0.167,"y":0.167},"t":265,"s":[-177.776,92.943,0],"to":[97,0,0],"ti":[-97,0,0]},{"i":{"x":0.345,"y":0.345},"o":{"x":0.167,"y":0.167},"t":305,"s":[404.224,92.943,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.655,"y":0},"t":335,"s":[404.224,92.943,0],"to":[-97,0,0],"ti":[97,0,0]},{"t":375,"s":[-177.776,92.943,0]}],"ix":2,"l":2},"a":{"a":0,"k":[475.545,919.943,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"a","pt":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[895.199,789],[317,789],[317,1036.945],[895.199,1036.945]],"c":true},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"Mask 1"}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[0,-76.837],[0,76.837]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.133333340287,0.666666686535,0.266666680574,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4.849,"ix":5},"lc":1,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[293.399,919.943],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-33.323,-36.116],[-16.063,-36.116],[0.399,20.952],[0.997,20.952],[17.459,-36.116],[33.323,-36.116],[10.874,36.116],[-9.877,36.116]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[832.909,913.285],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-7.632,-23.146],[-28.883,-23.146],[-28.883,-36.116],[28.883,-36.116],[28.883,-23.146],[7.831,-23.146],[7.831,36.116],[-7.632,36.116]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[782.674,913.285],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,12.171],[6.684,0],[0,-11.274],[-7.382,0]],"o":[[0,-11.374],[-6.784,0],[0,11.573],[6.585,0]],"v":[[10.226,-0.398],[0.448,-15.763],[-10.127,-0.199],[0.149,15.963]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,15.563],[-18.058,0],[0,-15.364],[18.656,0]],"o":[[0,-16.662],[18.058,0],[0,16.96],[-18.856,0]],"v":[[-25.89,0.2],[0.848,-27.137],[25.89,-0.897],[-0.549,27.137]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[731.574,923.461],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[4.39,-3.492],[0,0],[0,0],[0,0],[0,0],[0,0],[-7.981,0],[-0.898,-0.1],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[3.492,-5.088],[0.798,0],[0,0],[-6.784,-0.599]],"v":[[-1.396,-7.084],[-1.396,26.538],[-16.462,26.538],[-16.462,-25.441],[-3.592,-25.441],[-2.494,-17.26],[13.867,-26.538],[16.462,-26.438],[16.462,-11.773]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[683.169,922.863],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,10.575],[7.483,0],[0,0],[0,0],[0,0]],"o":[[0,-9.278],[0,0],[0,0],[0,0],[7.882,0]],"v":[[9.927,-12.471],[-3.043,-23.744],[-10.425,-23.744],[-10.425,0.399],[-4.24,0.399]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,-11.473],[18.757,0],[0,0],[0,0]],"o":[[0,0],[0,0],[18.457,0],[0,17.36],[0,0],[0,0],[0,0]],"v":[[-25.69,36.116],[-25.69,-36.116],[1.647,-36.116],[25.69,-13.568],[-2.544,12.771],[-10.425,12.771],[-10.425,36.116]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[631.729,913.285],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 5","np":3,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[1.695,8.68],[0,0],[-7.083,0],[0,3.392],[5.886,1.098],[0,12.671],[-11.673,0],[-2.494,-8.78],[0,0],[5.487,0],[0,-2.893],[-6.486,-1.197],[0,-12.172],[12.87,0]],"o":[[0,0],[1.198,4.09],[5.089,0],[0,-3.99],[-8.281,-1.596],[0,-11.373],[11.773,0],[0,0],[-1.197,-4.49],[-4.988,0],[0,4.09],[8.58,1.596],[0,11.773],[-13.269,0]],"v":[[-22.498,13.369],[-10.327,9.179],[0.049,17.16],[7.931,12.072],[-2.046,5.887],[-20.802,-10.276],[0.848,-27.137],[21.599,-13.169],[9.528,-9.577],[0.648,-17.16],[-6.435,-12.171],[4.24,-6.085],[22.498,9.678],[-0.449,27.137]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[570.27,923.461],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 6","np":2,"cix":2,"bm":0,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-7.533,37.662],[-7.533,-37.662],[7.533,-37.662],[7.533,37.662]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[529.155,911.739],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 7","np":2,"cix":2,"bm":0,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-7.533,37.662],[-7.533,-37.662],[7.533,-37.662],[7.533,37.662]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[499.482,911.739],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 8","np":2,"cix":2,"bm":0,"ix":8,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-7.582,38.51],[-7.582,-13.469],[7.483,-13.469],[7.483,38.51]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[5.686,0],[0,5.787],[-5.787,0],[0,-5.787]],"o":[[-5.787,0],[0,-5.787],[5.686,0],[0,5.787]],"v":[[0,-20.253],[-9.079,-29.432],[0,-38.51],[9.079,-29.432]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[469.81,910.891],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 9","np":3,"cix":2,"bm":0,"ix":9,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[7.133,-14.317],[23.795,-14.317],[6.535,4.339],[25.092,37.662],[8.431,37.662],[-5.038,13.917],[-10.027,18.806],[-10.027,37.662],[-25.092,37.662],[-25.092,-37.662],[-10.027,-37.662],[-10.027,3.841]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[429.215,911.739],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 10","np":2,"cix":2,"bm":0,"ix":10,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-4.59],[-7.882,-2.194],[0,-15.065],[14.367,0],[1.297,18.757],[0,0],[-10.575,0],[0,6.684],[7.782,1.995],[0,15.763],[-14.566,0],[-1.097,-17.16],[0,0],[8.48,0]],"o":[[0,6.486],[10.476,2.893],[0,16.362],[-12.97,0],[0,0],[1.197,6.984],[6.385,0],[0,-6.286],[-10.575,-2.794],[0,-14.068],[12.87,0],[0,0],[-0.599,-6.784],[-7.382,0]],"v":[[-9.727,-17.809],[5.038,-7.133],[27.785,14.517],[0.15,37.363],[-27.785,14.416],[-13.818,12.321],[0.548,25.191],[12.521,16.312],[-2.046,6.136],[-25.092,-15.613],[1.247,-37.363],[26.987,-16.212],[12.92,-14.616],[1.047,-25.49]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[365.804,913.235],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 11","np":2,"cix":2,"bm":0,"ix":11,"mn":"ADBE Vector Group","hd":false},{"ty":"tr","p":{"a":0,"k":[365.804,913.235],"ix":2},"a":{"a":0,"k":[365.804,913.235],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":11,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[10.126,36.367],[-10.126,36.367],[-10.126,-36.367],[10.126,-36.367]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[235.817,913.55],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[15.756,0],[0,22.981],[-21.985,0],[-4.4,-13.479],[0,0],[7.376,0],[0,-15.891],[-9.368,0],[-3.123,8.797]],"o":[[-4.111,13.054],[-21.985,0],[0,-21.989],[18.022,0],[0,0],[-2.837,-9.221],[-9.927,0],[0,16.034],[7.793,0],[0,0]],"v":[[33.27,15.532],[3.333,36.958],[-33.27,0.069],[2.341,-36.958],[32.988,-15.111],[15.823,-9.58],[2.341,-23.202],[-12.84,0.069],[2.916,23.336],[18.097,10.993]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[187.696,914.091],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,-6.94],[-6.944,0],[-4.864,3.329]],"o":[[-20.267,1.389],[0,6.102],[5.825,0],[0,0]],"v":[[12.008,2.02],[-13.671,14.653],[-2.982,23.672],[12.008,18.121]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[10.328,0],[0,14.716],[-30.147,1.131],[0,0],[9.035,0.647],[6.67,-3.571],[0,0],[-12.165,0],[0,-15.284]],"o":[[0,0],[0,0],[-8.066,6.936],[-11.463,0],[0,-16.133],[0,0],[0,-7.928],[-12.534,-0.893],[0,0],[9.665,-6.206],[20.386,0],[0,0]],"v":[[32.411,35.448],[14.865,35.448],[14.012,26.394],[-10.612,36.44],[-32.411,16.204],[12.881,-8.562],[12.881,-11.11],[0.002,-22.152],[-28.435,-15.867],[-28.304,-27.758],[4.525,-36.44],[32.411,-13.518]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[117.3,914.09],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[10.126,10.021],[-10.126,10.021],[-10.126,-10.021],[10.126,-10.021]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.40000000596,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[235.817,859.83],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,6.102],[-5.432,0],[-0.98,-4.115],[0.107,0],[0,0],[0.036,0.139],[2.65,0],[0,-4.678],[-3.666,0],[-0.091,3.416],[0,0],[0,0.107],[0,0],[-0.119,0],[0,0],[0,-0.115],[5.845,0]],"o":[[-5.547,0],[0,-6.214],[4.622,0],[0.024,0.111],[0,0],[-0.139,0],[-0.643,-2.464],[-3.619,0],[0,4.531],[3.273,0],[0,0],[-0.119,0],[0,0],[0,-0.115],[0,0],[0.111,0],[0.083,7.027],[0,0]],"v":[[0.213,10.191],[-9.17,-0.002],[0.098,-10.191],[8.72,-3.724],[8.558,-3.498],[5.471,-3.498],[5.189,-3.724],[0.13,-7.449],[-5.615,0.058],[0.241,7.446],[5.534,2.041],[0.13,2.041],[-0.096,1.823],[-0.096,-0.419],[0.13,-0.645],[8.943,-0.645],[9.169,-0.419],[0.213,10.191]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[236.499,979.886],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 5","np":2,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0.115,0],[0,0],[0,0.111],[0,0],[0,0],[-0.115,0],[0,0],[-0.056,-0.115],[0,0],[0,0],[0,0],[0,0],[-0.119,0],[0,0],[0,-0.107],[0,0],[0,0],[0.107,0],[0,0],[0.056,0.111],[0,0],[0,0]],"o":[[0,0],[0,0.111],[0,0],[-0.115,0],[0,0],[0,0],[0,-0.107],[0,0],[0.143,0],[0,0],[0,0],[0,0],[0,0],[0,-0.107],[0,0],[0.107,0],[0,0],[0,0],[0,0.111],[0,0],[-0.139,0],[0,0],[0,0],[0,0]],"v":[[-4.966,0.839],[-4.938,9.572],[-5.168,9.798],[-7.961,9.798],[-8.187,9.572],[-8.104,-0.058],[-8.187,-9.576],[-7.961,-9.798],[-4.295,-9.798],[-3.962,-9.6],[5.112,5.458],[5.077,4.478],[4.97,-0.224],[4.97,-9.576],[5.196,-9.798],[7.965,-9.798],[8.187,-9.576],[8.108,-0.058],[8.187,9.572],[7.965,9.798],[4.156,9.798],[3.819,9.6],[-5.108,-5.235],[-5.053,-3.867]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[213.683,979.886],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 6","np":2,"cix":2,"bm":0,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0.111],[0,0],[0,0],[-0.107,0],[0,0],[0,-0.111],[0,0],[0,0],[0.115,0]],"o":[[-0.107,0],[0,0],[0,0],[0,-0.111],[0,0],[0.115,0],[0,0],[0,0],[0,0.111],[0,0]],"v":[[-1.512,9.796],[-1.738,9.57],[-1.619,-0.083],[-1.738,-9.574],[-1.512,-9.796],[1.512,-9.796],[1.738,-9.574],[1.627,-0.083],[1.738,9.57],[1.512,9.796]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[196.629,979.887],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 7","np":2,"cix":2,"bm":0,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0.111,0],[0,0],[0,0.111],[0,0],[0,0],[-0.115,0],[0,0],[-0.06,-0.115],[0,0],[0,0],[0,0],[0,0],[-0.119,0],[0,0],[0,-0.107],[0,0],[0,0],[0.111,0],[0,0],[0.056,0.111],[0,0],[0,0]],"o":[[0,0],[0,0.111],[0,0],[-0.115,0],[0,0],[0,0],[0,-0.107],[0,0],[0.143,0],[0,0],[0,0],[0,0],[0,0],[0,-0.107],[0,0],[0.111,0],[0,0],[0,0],[0,0.111],[0,0],[-0.135,0],[0,0],[0,0],[0,0]],"v":[[-4.968,0.839],[-4.94,9.572],[-5.166,9.798],[-7.963,9.798],[-8.189,9.572],[-8.106,-0.058],[-8.189,-9.576],[-7.963,-9.798],[-4.297,-9.798],[-3.96,-9.6],[5.11,5.458],[5.079,4.478],[4.968,-0.224],[4.968,-9.576],[5.198,-9.798],[7.963,-9.798],[8.189,-9.576],[8.106,-0.058],[8.189,9.572],[7.963,9.798],[4.154,9.798],[3.821,9.6],[-5.11,-5.235],[-5.055,-3.867]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[178.556,979.886],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 8","np":2,"cix":2,"bm":0,"ix":8,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,2.353],[2.496,0]],"o":[[0,0],[0,0],[0,0],[2.182,0],[0,-2.266],[0,0]],"v":[[0.045,-7.168],[-4.344,-7.168],[-4.407,-0.45],[0.132,-0.45],[3.961,-3.752],[0.045,-7.168]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0.107,0],[0,0],[0,0.111],[0,0],[0,0],[-0.115,0],[0,0],[0,-3.976],[2.829,-0.754],[0,0],[0.107,0],[0,0],[0.056,0.107]],"o":[[0,0],[0,0],[0,0],[0,0.111],[0,0],[-0.115,0],[0,0],[0,0],[0,-0.111],[0,0],[4.67,0],[0,2.996],[0,0],[0.056,0.079],[0,0],[-0.143,0],[0,0]],"v":[[1.584,5.878],[-0.852,2.212],[-4.379,2.212],[-4.32,9.572],[-4.542,9.798],[-7.566,9.798],[-7.792,9.572],[-7.708,-0.113],[-7.792,-9.572],[-7.566,-9.798],[-0.146,-9.798],[7.298,-3.807],[2.786,1.875],[7.77,9.604],[7.663,9.798],[4.104,9.798],[3.77,9.604]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[155.833,979.886],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 9","np":3,"cix":2,"bm":0,"ix":9,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[2.869,1.567],[-0.099,-7.392],[-3.003,1.567]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0.056,0.143],[0,0],[0,0],[0,0],[0.135,0],[0,0],[-0.056,0.111],[0,0],[-0.135,0],[0,0],[-0.056,-0.143],[0,0],[0.111,0]],"o":[[-0.139,0],[0,0],[0,0],[0,0],[-0.028,0.143],[0,0],[-0.107,0],[0,0],[0.056,-0.143],[0,0],[0.135,0],[0,0],[0.052,0.111],[0,0]],"v":[[5.837,9.796],[5.527,9.57],[3.825,4.42],[-3.928,4.42],[-5.614,9.57],[-5.892,9.796],[-8.915,9.796],[-9.058,9.57],[-2.309,-9.574],[-2.003,-9.796],[2.119,-9.796],[2.425,-9.574],[9.059,9.57],[8.92,9.796]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[132.224,979.886],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 10","np":3,"cix":2,"bm":0,"ix":10,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0.111],[0,0],[0,0],[-0.115,0],[0,0],[0,-0.111],[0,0],[0.107,0],[0,0],[0,0],[0,0],[0,-0.111],[0,0],[0.115,0],[0,0],[0,0],[0,0],[0,-0.111],[0,0],[0.107,0]],"o":[[-0.115,0],[0,0],[0,0],[0,-0.111],[0,0],[0.107,0],[0,0],[0,0.111],[0,0],[0,0],[0,0],[0.115,0],[0,0],[0,0.111],[0,0],[0,0],[0,0],[0.107,0],[0,0],[0,0.111],[0,0]],"v":[[-6.394,9.796],[-6.62,9.57],[-6.509,-0.143],[-6.62,-9.574],[-6.394,-9.796],[6.176,-9.796],[6.402,-9.574],[6.402,-7.336],[6.176,-7.11],[-3.144,-7.11],[-3.232,-1.936],[5.418,-1.936],[5.64,-1.71],[5.64,0.532],[5.418,0.754],[-3.232,0.754],[-3.144,7.11],[6.402,7.11],[6.62,7.332],[6.62,9.57],[6.402,9.796]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[110.047,979.887],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 11","np":2,"cix":2,"bm":0,"ix":11,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0.111],[0,0],[0,0],[-0.115,0],[0,0],[0,-0.111],[0,0],[0,0],[0,0],[0,-0.111],[0,0],[0.107,0]],"o":[[-0.115,0],[0,0],[0,0],[0,-0.111],[0,0],[0.107,0],[0,0],[0,0],[0,0],[0.107,0],[0,0],[0,0.111],[0,0]],"v":[[-5.793,9.796],[-6.019,9.57],[-5.908,-0.198],[-6.019,-9.574],[-5.793,-9.796],[-2.742,-9.796],[-2.52,-9.574],[-2.635,-0.393],[-2.52,7.11],[5.797,7.11],[6.019,7.332],[6.019,9.57],[5.797,9.796]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[90.878,979.887],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 12","np":2,"cix":2,"bm":0,"ix":12,"mn":"ADBE Vector Group","hd":false},{"ty":"tr","p":{"a":0,"k":[90.878,979.887],"ix":2},"a":{"a":0,"k":[90.878,979.887],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":12,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":665,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Left Side Matte \u2014\xa0Audit","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[227.411,92.943,0],"ix":2,"l":2},"a":{"a":0,"k":[296.411,919.943,0],"ix":1,"l":2},"s":{"a":0,"k":[7241,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[0,-76.837],[0,76.837]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.733333349228,0.254901975393,0.152941182256,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4.849,"ix":5},"lc":1,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[294.036,919.943],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":665,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"AuditProTV","tt":2,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.345,"y":1},"o":{"x":0.167,"y":0.167},"t":155,"s":[-177.776,92.943,0],"to":[97,0,0],"ti":[-97,0,0]},{"i":{"x":0.345,"y":0.345},"o":{"x":0.167,"y":0.167},"t":195,"s":[404.224,92.943,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.655,"y":0},"t":225,"s":[404.224,92.943,0],"to":[-97,0,0],"ti":[97,0,0]},{"t":265,"s":[-177.776,92.943,0]}],"ix":2,"l":2},"a":{"a":0,"k":[474.224,919.943,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-32.932,-35.693],[-15.875,-35.693],[0.394,20.706],[0.986,20.706],[17.255,-35.693],[32.932,-35.693],[10.747,35.693],[-9.761,35.693]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[830.657,913.722],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-7.543,-22.875],[-28.544,-22.875],[-28.544,-35.693],[28.544,-35.693],[28.544,-22.875],[7.74,-22.875],[7.74,35.693],[-7.543,35.693]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[781.011,913.722],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,12.029],[6.606,0],[0,-11.142],[-7.296,0]],"o":[[0,-11.241],[-6.704,0],[0,11.438],[6.508,0]],"v":[[10.106,-0.394],[0.443,-15.578],[-10.008,-0.197],[0.147,15.776]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,15.382],[-17.846,0],[0,-15.184],[18.438,0]],"o":[[0,-16.466],[17.846,0],[0,16.762],[-18.635,0]],"v":[[-25.586,0.197],[0.838,-26.819],[25.586,-0.887],[-0.542,26.819]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[730.51,923.78],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[4.338,-3.452],[0,0],[0,0],[0,0],[0,0],[0,0],[-7.887,0],[-0.887,-0.098],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[3.451,-5.028],[0.789,0],[0,0],[-6.704,-0.592]],"v":[[-1.38,-7],[-1.38,26.227],[-16.269,26.227],[-16.269,-25.143],[-3.55,-25.143],[-2.465,-17.058],[13.705,-26.227],[16.269,-26.129],[16.269,-11.635]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[682.671,923.188],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,10.451],[7.395,0],[0,0],[0,0],[0,0]],"o":[[0,-9.17],[0,0],[0,0],[0,0],[7.79,0]],"v":[[9.811,-12.325],[-3.007,-23.467],[-10.303,-23.467],[-10.303,0.395],[-4.19,0.395]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,-11.339],[18.537,0],[0,0],[0,0]],"o":[[0,0],[0,0],[18.24,0],[0,17.156],[0,0],[0,0],[0,0]],"v":[[-25.389,35.693],[-25.389,-35.693],[1.628,-35.693],[25.389,-13.409],[-2.514,12.621],[-10.303,12.621],[-10.303,35.693]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[631.834,913.722],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 5","np":3,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[6.508,0],[0,11.733],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-4.732,0],[-1.972,1.183],[0,0]],"o":[[-10.747,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,4.535],[2.958,0],[0,0],[-2.564,1.676]],"v":[[4.486,34.855],[-11.881,18.193],[-11.881,-6.852],[-19.572,-6.852],[-19.572,-17.698],[-11.881,-17.698],[-11.881,-32.882],[3.007,-34.855],[3.007,-17.698],[16.615,-17.698],[16.615,-6.852],[3.007,-6.852],[3.007,16.122],[9.022,23.024],[17.502,20.657],[19.572,31.207]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[576.174,915.743],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 6","np":2,"cix":2,"bm":0,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-7.493,38.059],[-7.493,-13.311],[7.396,-13.311],[7.396,38.059]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[5.62,0],[0,5.719],[-5.719,0],[0,-5.719]],"o":[[-5.719,0],[0,-5.719],[5.62,0],[0,5.719]],"v":[[0,-20.015],[-8.973,-29.086],[0,-38.059],[8.973,-29.086]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[539.494,911.356],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 7","np":3,"cix":2,"bm":0,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[3.353,0],[0,-8.874],[-7,0],[-2.366,2.169],[0,0]],"o":[[-7.493,0],[0,9.17],[3.155,0],[0,0],[-1.972,-1.479]],"v":[[1.429,-3.993],[-8.924,11.487],[0.936,26.079],[9.712,22.432],[9.712,-1.133]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[6.804,0],[0,18.439],[-10.649,0],[-3.254,-3.057],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[-3.549,3.944],[-12.029,0],[0,-20.606],[5.719,0],[0,0],[0,0],[0,0],[0,0]],"v":[[12.078,36.629],[11.191,31.601],[10.895,31.502],[-4.29,37.813],[-24.502,11.98],[-2.811,-15.825],[10.205,-11.486],[10.205,-37.813],[24.502,-37.813],[24.502,36.629]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[492.903,912.786],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 8","np":3,"cix":2,"bm":0,"ix":8,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-4.732,0],[-1.972,1.775],[0,0],[0,0],[0,0],[0,0],[0,0],[7,0],[0,11.339],[0,0]],"o":[[0,0],[0,5.522],[3.846,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-3.648,4.142],[-10.55,0],[0,0],[0,0]],"v":[[-8.134,-26.228],[-8.134,6.211],[-1.627,14.199],[8.135,10.155],[8.135,-26.228],[23.023,-26.228],[23.023,25.142],[10.205,25.142],[9.121,19.621],[-7.247,26.228],[-23.023,9.17],[-23.023,-26.228]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[434.849,924.273],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 9","np":2,"cix":2,"bm":0,"ix":9,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-1.233,-21.396],[-10.007,6.211],[8.036,6.211],[-0.838,-21.396]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[33.77,35.693],[17.107,35.693],[11.191,18.34],[-12.571,18.34],[-18.093,35.693],[-33.77,35.693],[-10.402,-35.693],[8.529,-35.693]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[371.617,913.722],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 10","np":3,"cix":2,"bm":0,"ix":10,"mn":"ADBE Vector Group","hd":false},{"ty":"tr","p":{"a":0,"k":[371.617,913.722],"ix":2},"a":{"a":0,"k":[371.617,913.722],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":10,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":665,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Left Side Matte \u2014 ITPro","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[227.411,92.943,0],"ix":2,"l":2},"a":{"a":0,"k":[296.411,919.943,0],"ix":1,"l":2},"s":{"a":0,"k":[7241,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[0,-76.837],[0,76.837]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.733333349228,0.254901975393,0.152941182256,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4.849,"ix":5},"lc":1,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[294.036,919.943],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":665,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"ITProTV","tt":2,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.345,"y":1},"o":{"x":0.167,"y":0.167},"t":45,"s":[-177.776,102.943,0],"to":[85.167,0,0],"ti":[-85.167,0,0]},{"i":{"x":0.345,"y":0.345},"o":{"x":0.167,"y":0.167},"t":85,"s":[333.224,102.943,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.655,"y":0},"t":115,"s":[333.224,102.943,0],"to":[-85.167,0,0],"ti":[85.167,0,0]},{"t":155,"s":[-177.776,102.943,0]}],"ix":2,"l":2},"a":{"a":0,"k":[401.734,919.943,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"a","pt":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[735.789,826],[322,826],[322.49,947.32],[736.279,947.32]],"c":true},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"Mask 1"}],"shapes":[{"ty":"gr","it":[{"ty":"gr","it":[{"ty":"gr","it":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-23.153,-30.307],[23.153,-30.307],[23.153,-10.611],[11.014,-11.174],[11.014,30.307],[-11.014,30.307],[-11.014,-11.174],[-23.153,-10.611]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[189.685,940.212],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-11.014,-30.307],[11.014,-30.307],[11.014,30.307],[-11.014,30.307]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[149.495,940.212],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"tr","p":{"a":0,"k":[149.495,940.212],"ix":2},"a":{"a":0,"k":[149.495,940.212],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0]],"o":[[0,0]],"v":[[0,0]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.145098045468,0.662745118141,0.878431379795,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[173.896,992.789],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0.633,6.94],[3.585,2.596],[31.813,0.645],[0,0],[2.49,1.202],[0,0],[-0.367,0],[0,2.54],[2.576,0],[0,-2.54],[-0.273,-0.595],[0,0],[1.889,0.021],[0,0],[1.303,-0.216],[0,0],[-1.187,-2.077],[0,0],[-2.121,-1.533],[-1.04,-11.447],[-0.03,-9.63],[0.592,-7.318],[1.837,-2.583],[11.551,-1.508],[10.303,-0.183],[-2.452,-0.002],[0,0],[-0.047,0],[-0.047,0],[0,0],[-7.775,1.016],[-3.069,4.312],[-0.964,11.933],[0.028,9.645]],"o":[[-1.04,-11.447],[-2.12,-1.533],[0,0],[-1.187,-2.077],[0,0],[0.367,0.091],[2.576,0],[0,-2.54],[-2.576,0],[0,0.65],[0,0],[-1.763,-0.414],[0,0],[-1.36,0.015],[0,0],[2.49,1.202],[0,0],[31.813,0.645],[3.585,2.596],[0.632,6.94],[0.028,9.645],[-0.964,11.933],[-3.069,4.312],[-6.124,0.801],[2.776,0.049],[0,0],[0.047,0],[0.047,0],[0,0],[11.553,-0.009],[11.551,-1.508],[1.837,-2.583],[0.592,-7.318],[-0.03,-9.63]],"v":[[34.031,-10.911],[27.921,-29.46],[-11.347,-35.495],[-11.438,-35.654],[-17.123,-40.722],[1.279,-60.565],[2.385,-60.431],[7.056,-65.036],[2.385,-69.644],[-2.286,-65.036],[-1.876,-63.163],[-21.346,-42.734],[-26.853,-43.376],[-27.144,-43.376],[-31.135,-42.996],[-33.244,-40.722],[-27.558,-35.654],[-27.467,-35.495],[11.801,-29.46],[17.911,-10.911],[18.936,14.787],[18.063,41.092],[13.84,59.773],[-7.02,68.077],[-35.058,69.564],[-27.144,69.643],[-27.144,69.644],[-26.998,69.643],[-26.853,69.644],[-26.853,69.643],[9.1,68.077],[29.96,59.773],[34.183,41.092],[35.056,14.787]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0.639215707779,0.878431379795,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[208.967,923.225],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0.507,0.084],[0,0],[0.367,0],[0,2.54],[-2.576,0],[0,-2.54],[0.273,-0.595]],"o":[[0,0],[-0.494,-0.116],[0,0],[-0.367,0.091],[-2.576,0],[0,-2.54],[2.576,0],[0,0.65],[0,0]],"v":[[12.997,10.928],[10.589,13.455],[9.071,13.193],[-7.221,-4.376],[-8.326,-4.242],[-12.997,-8.847],[-8.326,-13.455],[-3.655,-8.847],[-4.065,-6.975]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0.639215707779,0.878431379795,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[160.911,867.036],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"tr","p":{"a":0,"k":[160.911,867.036],"ix":2},"a":{"a":0,"k":[160.911,867.036],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[6.124,0.801],[3.07,4.312],[0.964,11.933],[-0.028,9.645],[-0.633,6.94],[-3.586,2.596],[-31.814,0.645],[0,0],[-2.49,1.202],[0,0],[1.36,0.015],[0,0],[1.763,-0.414],[0,0],[0,0.65],[2.576,0],[0,-2.54],[-2.576,0],[-0.367,0.091],[0,0],[1.187,-2.077],[0,0],[2.12,-1.533],[1.04,-11.447],[0.03,-9.63],[-0.592,-7.318],[-1.837,-2.583],[-11.551,-1.508],[-11.554,-0.009],[0,0],[-0.047,0],[-0.047,0],[0,0],[-2.776,0.049]],"o":[[-11.551,-1.508],[-1.837,-2.583],[-0.592,-7.318],[0.03,-9.63],[1.04,-11.447],[2.12,-1.533],[0,0],[1.187,-2.077],[0,0],[-1.303,-0.216],[0,0],[-1.889,0.021],[0,0],[0.273,-0.595],[0,-2.54],[-2.576,0],[0,2.54],[0.367,0],[0,0],[-2.49,1.202],[0,0],[-31.814,0.645],[-3.585,2.596],[-0.633,6.94],[-0.028,9.645],[0.964,11.933],[3.069,4.312],[7.775,1.016],[0,0],[0.047,0],[0.047,0],[0,0],[2.452,-0.002],[-10.303,-0.183]],"v":[[7.02,68.077],[-13.84,59.773],[-18.063,41.092],[-18.936,14.787],[-17.911,-10.911],[-11.801,-29.46],[27.467,-35.495],[27.558,-35.654],[33.243,-40.722],[31.135,-42.996],[27.144,-43.376],[26.853,-43.376],[21.347,-42.734],[1.876,-63.163],[2.286,-65.036],[-2.385,-69.644],[-7.056,-65.036],[-2.385,-60.431],[-1.279,-60.565],[17.124,-40.722],[11.438,-35.654],[11.347,-35.495],[-27.921,-29.46],[-34.031,-10.911],[-35.056,14.787],[-34.183,41.092],[-29.96,59.773],[-9.1,68.077],[26.853,69.643],[26.853,69.644],[26.998,69.643],[27.144,69.644],[27.144,69.643],[35.058,69.564]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.403921574354,0.121568627656,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[138.848,923.225],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-0.506,0.084],[0,0],[-0.367,0],[0,2.54],[2.576,0],[0,-2.54],[-0.273,-0.595]],"o":[[0,0],[0.494,-0.116],[0,0],[0.367,0.091],[2.576,0],[0,-2.54],[-2.576,0],[0,0.65],[0,0]],"v":[[-12.997,10.928],[-10.589,13.455],[-9.071,13.193],[7.22,-4.376],[8.326,-4.242],[12.997,-8.847],[8.326,-13.455],[3.655,-8.847],[4.065,-6.975]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.403921574354,0.121568627656,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[186.903,867.036],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0]],"o":[[0,0]],"v":[[0,0]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.941176474094,0.352941185236,0.156862750649,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[173.921,992.789],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"tr","p":{"a":0,"k":[173.921,992.789],"ix":2},"a":{"a":0,"k":[173.921,992.789],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-3.069,4.312],[-0.964,11.933],[0.028,9.645],[0.632,6.94],[3.585,2.596],[31.813,0.645],[0,0],[2.49,1.202],[0,0],[0.494,-0.116],[0,0],[0,0],[0.507,0.084],[0,0],[1.187,-2.077],[0,0],[2.12,-1.533],[1.04,-11.447],[0.03,-9.63],[-0.592,-7.318],[-1.837,-2.583],[-11.551,-1.508],[-10.303,-0.183],[-6.125,0.801]],"o":[[1.837,-2.583],[0.592,-7.318],[-0.03,-9.63],[-1.04,-11.447],[-2.121,-1.533],[0,0],[-1.187,-2.077],[0,0],[-0.507,0.084],[0,0],[0,0],[-0.494,-0.116],[0,0],[-2.49,1.202],[0,0],[-31.814,0.645],[-3.586,2.596],[-0.633,6.94],[-0.028,9.645],[0.964,11.933],[3.07,4.312],[6.125,0.801],[10.303,-0.183],[11.551,-1.508]],"v":[[48.898,47.621],[53.122,28.94],[53.994,2.635],[52.97,-23.062],[46.859,-41.612],[7.592,-47.647],[7.501,-47.806],[1.815,-52.874],[3.926,-55.148],[2.408,-54.886],[0,-57.413],[-2.408,-54.886],[-3.923,-55.148],[-1.815,-52.874],[-7.501,-47.806],[-7.591,-47.647],[-46.859,-41.612],[-52.969,-23.062],[-53.994,2.635],[-53.121,28.94],[-48.898,47.621],[-28.039,55.925],[0,57.413],[28.039,55.925]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.06274510175,0.023529412225,0.623529434204,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[173.906,935.376],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"tr","p":{"a":0,"k":[173.906,935.376],"ix":2},"a":{"a":0,"k":[173.906,935.376],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":4,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tr","p":{"a":0,"k":[173.906,935.376],"ix":2},"a":{"a":0,"k":[173.906,935.376],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":1,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[8.036,-10.256],[1.414,2.369],[1.414,10.256],[-1.439,10.256],[-1.439,2.319],[-8.036,-10.256],[-4.911,-10.256],[0.05,-0.112],[5.01,-10.256]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[691.641,966.042],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[-0.083,-1.174],[0,-1.711],[0,0],[0,0],[0,0],[0,0],[0,0],[0.099,1.29],[0,1.067],[0,0],[0,0]],"o":[[0,0],[0,0],[0.116,1.356],[0,1.141],[0,0],[0,0],[0,0],[0,0],[0,0],[0,-0.521],[-0.099,-1.29],[0,0],[0,0],[0,0]],"v":[[7.193,10.194],[3.398,10.194],[-4.936,-7.168],[-4.638,-3.373],[-4.638,0.818],[-4.638,10.244],[-7.193,10.244],[-7.193,-10.244],[-3.497,-10.244],[4.936,7.119],[4.688,4.415],[4.539,0.868],[4.539,-10.244],[7.193,-10.244]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[673.287,966.03],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-3.262,2.741],[3.138,2.741],[-0.037,-7.974]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[5.37,10.182],[3.832,5.023],[-3.956,5.023],[-5.37,10.182],[-8.346,10.182],[-1.773,-10.256],[1.798,-10.256],[8.346,10.256]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[654.598,966.042],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-1.109,0.68],[0.149,1.282],[0.925,0.793],[1.304,-0.08],[0,0],[0,0],[0,0]],"o":[[0.958,-0.865],[0.116,-1.213],[-1.097,-0.708],[0,0],[0,0],[0,0],[1.299,0.066]],"v":[[2.387,-0.409],[3.677,-3.831],[2.387,-7.031],[-1.309,-7.998],[-3.789,-7.998],[-3.789,0.534],[-1.309,0.534]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[-1.741,-1.135],[0.12,-1.824],[1.483,-1.205],[2.054,0.101],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[1.426,1.145],[0.129,1.906],[-1.696,1.163],[0,0],[0,0],[0,0],[0,0],[0,0],[2.072,-0.154]],"v":[[4.594,-8.618],[6.678,-3.881],[4.52,1.08],[-1.259,2.717],[-3.864,2.717],[-3.864,10.158],[-6.691,10.158],[-6.691,-10.132],[-1.284,-10.132]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[640.219,965.917],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":3,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0.05,1.959],[0,0],[0,0],[0,0],[0.372,-3.249],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[-0.298,-3.621],[0,0],[0,0],[0,0],[0,2.48],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[9.686,10.256],[6.957,10.256],[6.238,0.98],[5.717,-7.379],[1.302,7.925],[-1.352,7.925],[-6.04,-7.404],[-6.412,1.203],[-7.007,10.256],[-9.686,10.256],[-7.974,-10.256],[-4.179,-10.256],[0.136,4.626],[4.254,-10.256],[8.098,-10.256]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[619.03,965.968],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 5","np":2,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0.967,-1.325],[-0.169,-2.203],[-1.154,-1.87],[-1.622,0.056],[0,5.506],[3.77,0]],"o":[[-1.137,1.895],[-0.171,2.191],[0.973,1.299],[3.77,0],[0,-5.531],[-1.64,-0.053]],"v":[[-4.167,-6.231],[-5.655,0.069],[-4.142,6.319],[0,8.304],[5.655,0.044],[0,-8.265]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[-1.359,-0.852],[-0.638,-1.481],[0.058,-1.98],[0.757,-1.804],[1.347,-0.897],[2.805,1.637],[0.629,1.473],[-0.06,1.975],[-0.777,1.799],[-1.361,0.902],[-1.597,-0.033]],"o":[[1.352,0.88],[0.761,1.829],[0.054,1.956],[-0.645,1.484],[-2.805,1.637],[-1.344,-0.872],[-0.779,-1.816],[-0.058,-1.959],[0.628,-1.507],[1.347,-0.858],[1.604,-0.027]],"v":[[4.539,-9.356],[7.59,-5.735],[8.656,0.044],[7.59,5.749],[4.539,9.395],[-4.539,9.395],[-7.565,5.799],[-8.656,0.044],[-7.565,-5.66],[-4.514,-9.356],[0,-10.621]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[597.91,965.936],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 6","np":3,"cix":2,"bm":0,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-1.007,-0.334],[-0.732,-0.651],[0,0],[1.459,0.024],[0.973,-1.283],[-2.068,-3.928],[-1.618,0.042],[-0.719,0.312],[-0.65,0.484],[0,0],[0.923,-0.383],[1.165,0.016],[1.207,3.04],[-0.058,1.975],[-0.808,1.817],[-1.337,0.828],[-1.528,-0.013]],"o":[[0.909,0.366],[0,0],[-1.105,-0.954],[-1.609,-0.054],[-2.068,3.928],[0.963,1.301],[0.784,0.018],[0.735,-0.341],[0,0],[-0.715,0.698],[-1.078,0.441],[-3.271,0.055],[-0.777,-1.816],[-0.057,-1.988],[0.67,-1.422],[1.288,-0.823],[1.06,-0.039]],"v":[[4.455,-10.142],[6.935,-8.604],[5.398,-6.794],[1.429,-8.307],[-2.688,-6.347],[-2.688,6.203],[1.429,8.212],[3.711,7.766],[5.794,6.526],[7.208,8.312],[4.728,9.949],[1.33,10.593],[-6.111,5.633],[-7.202,-0.122],[-6.061,-5.901],[-2.986,-9.348],[1.33,-10.589]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[580.284,965.928],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 7","np":2,"cix":2,"bm":0,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-1.11,-0.411],[-0.828,-0.729],[0,0],[0.777,0.299],[0.845,-0.036],[0.865,-0.558],[0.449,-1.087],[-0.054,-1.618],[-1.087,-1.913],[-1.638,0.101],[-1.204,0.642],[0,0],[0,0],[0,0],[0,0],[0,0],[2.354,0.005],[1.579,1.828],[-0.201,2.821],[-0.837,1.791],[-1.411,0.878],[-1.566,-0.003]],"o":[[1.027,0.403],[0,0],[-0.635,-0.538],[-0.792,-0.297],[-1.029,-0.007],[-0.96,0.679],[-0.594,1.507],[-0.166,2.194],[0.954,1.335],[1.364,0.04],[0,0],[0,0],[0,0],[0,0],[0,0],[-2.031,1.19],[-2.412,0.121],[-1.659,-2.29],[-0.055,-1.976],[0.711,-1.502],[1.338,-0.814],[1.183,-0.034]],"v":[[4.728,-10.048],[7.531,-8.337],[5.869,-6.625],[3.736,-7.89],[1.255,-8.287],[-1.647,-7.444],[-3.804,-4.74],[-4.623,-0.003],[-3.209,6.297],[0.958,8.281],[4.877,7.364],[4.877,1.188],[1.231,1.188],[0.908,-1.119],[7.655,-1.119],[7.655,8.802],[0.958,10.613],[-5.367,7.909],[-7.624,-0.003],[-6.434,-5.733],[-3.184,-9.379],[1.255,-10.619]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[554.043,965.958],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 8","np":2,"cix":2,"bm":0,"ix":8,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[-0.083,-1.174],[0,-1.711],[0,0],[0,0],[0,0],[0,0],[0,0],[0.099,1.29],[0,1.067],[0,0],[0,0]],"o":[[0,0],[0,0],[0.116,1.356],[0,1.141],[0,0],[0,0],[0,0],[0,0],[0,0],[0,-0.521],[-0.099,-1.29],[0,0],[0,0],[0,0]],"v":[[7.243,10.194],[3.448,10.194],[-4.886,-7.168],[-4.589,-3.373],[-4.589,0.818],[-4.589,10.244],[-7.243,10.244],[-7.243,-10.244],[-3.547,-10.244],[4.886,7.119],[4.638,4.415],[4.489,0.868],[4.489,-10.244],[7.243,-10.244]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[535.332,966.03],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 9","np":2,"cix":2,"bm":0,"ix":9,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[1.414,-10.256],[1.414,10.256],[-1.414,10.256],[-1.414,-10.256]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[521.318,966.042],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 10","np":2,"cix":2,"bm":0,"ix":10,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[-0.074,-1.166],[0,-1.711],[0,0],[0,0],[0,0],[0,0],[0,0],[0.099,1.29],[0,1.067],[0,0],[0,0]],"o":[[0,0],[0,0],[0,1.364],[0.074,1.166],[0,0],[0,0],[0,0],[0,0],[0,0],[0,-0.521],[-0.099,-1.29],[0,0],[0,0],[0,0]],"v":[[7.23,10.194],[3.46,10.194],[-4.874,-7.168],[-4.601,-3.373],[-4.601,0.818],[-4.601,10.244],[-7.23,10.244],[-7.23,-10.244],[-3.559,-10.244],[4.874,7.119],[4.626,4.415],[4.477,0.868],[4.477,-10.244],[7.131,-10.244]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[507.341,966.03],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 11","np":2,"cix":2,"bm":0,"ix":11,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-0.981,0.674],[0.104,1.101],[0.811,0.674],[1.281,-0.105],[0,0],[0,0]],"o":[[1.188,0.08],[0.822,-0.74],[0.096,-1.05],[-1.107,-0.653],[0,0],[0,0],[0,0]],"v":[[-1.463,-0.67],[1.885,-1.588],[3.026,-4.514],[1.885,-7.267],[-1.786,-8.111],[-4.266,-8.111],[-4.266,-0.67]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-1.728,-1.097],[0.124,-1.691],[0.756,-0.996],[1.288,-0.343],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[2.041,-0.147],[1.36,1.013],[0.051,1.249],[-0.898,0.985],[0,0],[0,0],[0,0]],"v":[[-1.141,1.488],[-4.316,1.488],[-4.316,10.194],[-7.143,10.194],[-7.143,-10.244],[-1.761,-10.244],[4.043,-8.78],[6.027,-4.44],[4.936,-0.967],[1.587,1.066],[7.143,10.268],[3.77,10.268]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[489.346,966.03],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 12","np":3,"cix":2,"bm":0,"ix":12,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-3.262,2.741],[3.138,2.741],[-0.037,-7.974]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[5.37,10.182],[3.832,5.023],[-3.931,5.023],[-5.494,10.182],[-8.346,10.182],[-1.773,-10.256],[1.798,-10.256],[8.346,10.256]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[470.682,966.042],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 13","np":3,"cix":2,"bm":0,"ix":13,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[5.444,-10.256],[5.097,-7.999],[-2.84,-7.999],[-2.84,-1.302],[4.055,-1.302],[4.055,0.955],[-2.84,0.955],[-2.84,7.974],[5.668,7.974],[5.668,10.256],[-5.668,10.256],[-5.668,-10.256]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[454.882,966.042],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 14","np":2,"cix":2,"bm":0,"ix":14,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-2.803,-10.256],[-2.803,7.776],[5.63,7.776],[5.308,10.256],[-5.63,10.256],[-5.63,-10.256]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[440.013,966.042],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 15","np":2,"cix":2,"bm":0,"ix":15,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[1.414,-10.256],[1.414,10.256],[-1.414,10.256],[-1.414,-10.256]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[419.129,966.042],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 16","np":2,"cix":2,"bm":0,"ix":16,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-1.034,-0.366],[-0.733,-0.65],[0,0],[1.453,0.019],[0.973,-1.283],[-2.068,-3.928],[-1.618,0.042],[-0.719,0.312],[-0.657,0.473],[0,0],[0.925,-0.38],[1.173,0.018],[1.329,0.833],[0.63,1.486],[-0.046,1.974],[-0.797,1.82],[-1.357,0.87],[-1.528,-0.013]],"o":[[0.908,0.368],[0,0],[-1.092,-0.958],[-1.609,-0.054],[-2.068,3.928],[0.962,1.301],[0.784,0.018],[0.729,-0.352],[0,0],[-0.713,0.701],[-1.086,0.444],[-1.569,0.023],[-1.358,-0.873],[-0.765,-1.82],[-0.045,-1.986],[0.649,-1.475],[1.288,-0.823],[1.096,-0.039]],"v":[[4.516,-10.118],[6.996,-8.58],[5.434,-6.769],[1.49,-8.282],[-2.627,-6.323],[-2.627,6.228],[1.49,8.237],[3.772,7.79],[5.855,6.55],[7.244,8.336],[4.764,9.973],[1.341,10.618],[-3.099,9.378],[-6.149,5.757],[-7.241,0.002],[-6.1,-5.777],[-3.024,-9.373],[1.292,-10.614]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[406.824,965.903],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 17","np":2,"cix":2,"bm":0,"ix":17,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-3.299,2.741],[3.1,2.741],[-0.074,-7.974]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[5.333,10.182],[3.869,5.023],[-3.894,5.023],[-5.457,10.182],[-8.309,10.182],[-1.811,-10.256],[1.761,-10.256],[8.309,10.256]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[389.886,966.042],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 18","np":3,"cix":2,"bm":0,"ix":18,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[-0.083,-1.174],[0,-1.711],[0,0],[0,0],[0,0],[0,0],[0,0],[0.099,1.29],[0,1.067],[0,0],[0,0]],"o":[[0,0],[0,0],[0.116,1.356],[0,1.141],[0,0],[0,0],[0,0],[0,0],[0,0],[0,-0.521],[-0.099,-1.29],[0,0],[0,0],[0,0]],"v":[[7.243,10.194],[3.448,10.194],[-4.886,-7.168],[-4.589,-3.373],[-4.589,0.818],[-4.589,10.244],[-7.243,10.244],[-7.243,-10.244],[-3.547,-10.244],[4.886,7.119],[4.638,4.415],[4.489,0.868],[4.489,-10.244],[7.143,-10.244]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[363.222,966.03],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 19","np":2,"cix":2,"bm":0,"ix":19,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-3.262,2.741],[3.138,2.741],[-0.037,-7.974]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[5.37,10.182],[3.832,5.023],[-3.956,5.023],[-5.395,10.182],[-8.346,10.182],[-1.773,-10.256],[1.798,-10.256],[8.346,10.256]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[344.583,966.042],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 20","np":3,"cix":2,"bm":0,"ix":20,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-33.103,-35.878],[-15.957,-35.878],[0.396,20.813],[0.991,20.813],[17.344,-35.878],[33.103,-35.878],[10.803,35.878],[-9.812,35.878]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[666.572,904.579],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-7.582,-22.993],[-28.692,-22.993],[-28.692,-35.878],[28.692,-35.878],[28.692,-22.993],[7.78,-22.993],[7.78,35.878],[-7.582,35.878]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[616.668,904.579],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,12.091],[6.64,0],[0,-11.2],[-7.334,0]],"o":[[0,-11.299],[-6.739,0],[0,11.497],[6.542,0]],"v":[[10.159,-0.396],[0.445,-15.659],[-10.06,-0.198],[0.148,15.858]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,15.461],[-17.939,0],[0,-15.263],[18.533,0]],"o":[[0,-16.552],[17.939,0],[0,16.848],[-18.732,0]],"v":[[-25.719,0.199],[0.843,-26.958],[25.719,-0.891],[-0.545,26.958]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[563.978,914.688],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[4.362,-3.469],[0,0],[0,0],[0,0],[0,0],[0,0],[-7.928,0],[-0.892,-0.1],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[3.469,-5.054],[0.793,0],[0,0],[-6.739,-0.595]],"v":[[-1.388,-7.037],[-1.388,26.363],[-16.353,26.363],[-16.353,-25.273],[-3.568,-25.273],[-2.478,-17.146],[13.776,-26.363],[16.353,-26.264],[16.353,-11.695]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[513.966,914.093],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,10.505],[7.433,0],[0,0],[0,0],[0,0]],"o":[[0,-9.217],[0,0],[0,0],[0,0],[7.83,0]],"v":[[9.862,-12.388],[-3.023,-23.588],[-10.357,-23.588],[-10.357,0.397],[-4.212,0.397]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,-11.397],[18.633,0],[0,0],[0,0]],"o":[[0,0],[0,0],[18.335,0],[0,17.245],[0,0],[0,0],[0,0]],"v":[[-25.521,35.878],[-25.521,-35.878],[1.636,-35.878],[25.521,-13.479],[-2.527,12.687],[-10.357,12.687],[-10.357,35.878]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[460.939,904.579],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 5","np":3,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-7.582,-22.993],[-28.692,-22.993],[-28.692,-35.878],[28.692,-35.878],[28.692,-22.993],[7.78,-22.993],[7.78,35.878],[-7.582,35.878]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[395.772,904.579],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 6","np":2,"cix":2,"bm":0,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-7.631,35.878],[-7.631,-35.878],[7.631,-35.878],[7.631,35.878]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[348.664,904.579],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 7","np":2,"cix":2,"bm":0,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"tr","p":{"a":0,"k":[348.664,904.579],"ix":2},"a":{"a":0,"k":[348.664,904.579],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 21","np":7,"cix":2,"bm":0,"ix":21,"mn":"ADBE Vector Group","hd":false},{"ty":"tr","p":{"a":0,"k":[348.664,904.579],"ix":2},"a":{"a":0,"k":[348.664,904.579],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":21,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[0,-76.837],[0,76.837]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0.639215707779,0.878431379795,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4.849,"ix":5},"lc":1,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[292.285,919.943],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":665,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"|","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[404.224,92.943,0],"ix":2,"l":2},"a":{"a":0,"k":[474.224,919.943,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.355,0.345,0.667],"y":[1,1,1]},"o":{"x":[0.677,0.648,0.333],"y":[0,0,0]},"t":5,"s":[100,0,100]},{"i":{"x":[0.355,0.345,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"t":35,"s":[100,100,100]},{"i":{"x":[0.323,0.352,0.667],"y":[1,1,1]},"o":{"x":[0.645,0.655,0.333],"y":[0,0,0]},"t":485,"s":[100,100,100]},{"t":515,"s":[100,0,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[0,-76.837],[0,76.837]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4.849,"ix":5},"lc":1,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[294.036,919.943],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":665,"st":0,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"ACI Learning","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[404.224,92.943,0],"ix":2,"l":2},"a":{"a":0,"k":[474.224,919.943,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[10.166,36.51],[-10.166,36.51],[-10.166,-36.51],[10.166,-36.51]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[236.413,913.525],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[15.818,0],[0,23.072],[-22.072,0],[-4.418,-13.532],[0,0],[7.405,0],[0,-15.954],[-9.405,0],[-3.135,8.831]],"o":[[-4.127,13.106],[-22.072,0],[0,-22.076],[18.093,0],[0,0],[-2.848,-9.258],[-9.967,0],[0,16.097],[7.823,0],[0,0]],"v":[[33.401,15.593],[3.346,37.104],[-33.401,0.07],[2.35,-37.104],[33.118,-15.171],[15.886,-9.618],[2.35,-23.293],[-12.89,0.07],[2.928,23.429],[18.168,11.036]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[188.102,914.068],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,-6.967],[-6.971,0],[-4.884,3.342]],"o":[[-20.347,1.394],[0,6.127],[5.848,0],[0,0]],"v":[[12.056,2.028],[-13.725,14.711],[-2.994,23.765],[12.056,18.192]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[10.369,0],[0,14.775],[-30.266,1.135],[0,0],[9.07,0.649],[6.696,-3.585],[0,0],[-12.213,0],[0,-15.344]],"o":[[0,0],[0,0],[-8.098,6.963],[-11.508,0],[0,-16.197],[0,0],[0,-7.959],[-12.584,-0.896],[0,0],[9.704,-6.23],[20.467,0],[0,0]],"v":[[32.539,35.588],[14.924,35.588],[14.068,26.498],[-10.654,36.584],[-32.539,16.268],[12.932,-8.596],[12.932,-11.154],[0.002,-22.24],[-28.547,-15.93],[-28.416,-27.868],[4.543,-36.584],[32.539,-13.572]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[117.428,914.067],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[10.166,10.06],[-10.166,10.06],[-10.166,-10.06],[10.166,-10.06]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.40000000596,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[236.413,859.593],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,6.127],[-5.453,0],[-0.984,-4.131],[0.108,0],[0,0],[0.036,0.139],[2.661,0],[0,-4.696],[-3.681,0],[-0.092,3.43],[0,0],[0,0.108],[0,0],[-0.119,0],[0,0],[0,-0.116],[5.868,0]],"o":[[-5.569,0],[0,-6.238],[4.641,0],[0.024,0.112],[0,0],[-0.139,0],[-0.645,-2.474],[-3.633,0],[0,4.549],[3.286,0],[0,0],[-0.119,0],[0,0],[0,-0.116],[0,0],[0.112,0],[0.084,7.055],[0,0]],"v":[[0.214,10.231],[-9.207,-0.002],[0.099,-10.231],[8.755,-3.738],[8.591,-3.511],[5.492,-3.511],[5.21,-3.738],[0.131,-7.479],[-5.637,0.058],[0.242,7.475],[5.556,2.049],[0.131,2.049],[-0.096,1.83],[-0.096,-0.42],[0.131,-0.647],[8.978,-0.647],[9.205,-0.42],[0.214,10.231]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[237.098,980.123],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 5","np":2,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0.116,0],[0,0],[0,0.112],[0,0],[0,0],[-0.116,0],[0,0],[-0.056,-0.116],[0,0],[0,0],[0,0],[0,0],[-0.119,0],[0,0],[0,-0.108],[0,0],[0,0],[0.108,0],[0,0],[0.056,0.112],[0,0],[0,0]],"o":[[0,0],[0,0.112],[0,0],[-0.116,0],[0,0],[0,0],[0,-0.108],[0,0],[0.143,0],[0,0],[0,0],[0,0],[0,0],[0,-0.108],[0,0],[0.108,0],[0,0],[0,0],[0,0.112],[0,0],[-0.139,0],[0,0],[0,0],[0,0]],"v":[[-4.985,0.842],[-4.957,9.61],[-5.188,9.837],[-7.993,9.837],[-8.22,9.61],[-8.136,-0.058],[-8.22,-9.614],[-7.993,-9.837],[-4.312,-9.837],[-3.977,-9.638],[5.133,5.479],[5.097,4.495],[4.989,-0.225],[4.989,-9.614],[5.216,-9.837],[7.997,-9.837],[8.22,-9.614],[8.14,-0.058],[8.22,9.61],[7.997,9.837],[4.173,9.837],[3.834,9.638],[-5.129,-5.256],[-5.073,-3.882]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[214.192,980.123],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 6","np":2,"cix":2,"bm":0,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0.112],[0,0],[0,0],[-0.108,0],[0,0],[0,-0.112],[0,0],[0,0],[0.116,0]],"o":[[-0.108,0],[0,0],[0,0],[0,-0.112],[0,0],[0.116,0],[0,0],[0,0],[0,0.112],[0,0]],"v":[[-1.518,9.835],[-1.745,9.608],[-1.625,-0.084],[-1.745,-9.612],[-1.518,-9.835],[1.518,-9.835],[1.745,-9.612],[1.633,-0.084],[1.745,9.608],[1.518,9.835]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[197.07,980.124],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 7","np":2,"cix":2,"bm":0,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0.112,0],[0,0],[0,0.112],[0,0],[0,0],[-0.116,0],[0,0],[-0.06,-0.116],[0,0],[0,0],[0,0],[0,0],[-0.119,0],[0,0],[0,-0.108],[0,0],[0,0],[0.112,0],[0,0],[0.056,0.112],[0,0],[0,0]],"o":[[0,0],[0,0.112],[0,0],[-0.116,0],[0,0],[0,0],[0,-0.108],[0,0],[0.143,0],[0,0],[0,0],[0,0],[0,0],[0,-0.108],[0,0],[0.112,0],[0,0],[0,0],[0,0.112],[0,0],[-0.135,0],[0,0],[0,0],[0,0]],"v":[[-4.987,0.842],[-4.959,9.61],[-5.186,9.837],[-7.995,9.837],[-8.222,9.61],[-8.138,-0.058],[-8.222,-9.614],[-7.995,-9.837],[-4.314,-9.837],[-3.975,-9.638],[5.131,5.479],[5.099,4.495],[4.987,-0.225],[4.987,-9.614],[5.218,-9.837],[7.995,-9.837],[8.222,-9.614],[8.138,-0.058],[8.222,9.61],[7.995,9.837],[4.171,9.837],[3.836,9.638],[-5.131,-5.256],[-5.075,-3.882]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[178.926,980.123],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 8","np":2,"cix":2,"bm":0,"ix":8,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,2.362],[2.506,0]],"o":[[0,0],[0,0],[0,0],[2.191,0],[0,-2.275],[0,0]],"v":[[0.045,-7.196],[-4.361,-7.196],[-4.425,-0.452],[0.132,-0.452],[3.976,-3.766],[0.045,-7.196]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0.108,0],[0,0],[0,0.112],[0,0],[0,0],[-0.116,0],[0,0],[0,-3.991],[2.84,-0.757],[0,0],[0.108,0],[0,0],[0.056,0.108]],"o":[[0,0],[0,0],[0,0],[0,0.112],[0,0],[-0.116,0],[0,0],[0,0],[0,-0.112],[0,0],[4.689,0],[0,3.007],[0,0],[0.056,0.08],[0,0],[-0.143,0],[0,0]],"v":[[1.59,5.901],[-0.855,2.221],[-4.397,2.221],[-4.337,9.61],[-4.56,9.837],[-7.595,9.837],[-7.823,9.61],[-7.739,-0.114],[-7.823,-9.61],[-7.595,-9.837],[-0.146,-9.837],[7.327,-3.822],[2.797,1.882],[7.801,9.642],[7.693,9.837],[4.12,9.837],[3.785,9.642]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[156.113,980.123],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 9","np":3,"cix":2,"bm":0,"ix":9,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[2.88,1.573],[-0.099,-7.421],[-3.015,1.573]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0.056,0.143],[0,0],[0,0],[0,0],[0.135,0],[0,0],[-0.056,0.112],[0,0],[-0.135,0],[0,0],[-0.056,-0.143],[0,0],[0.112,0]],"o":[[-0.139,0],[0,0],[0,0],[0,0],[-0.028,0.143],[0,0],[-0.108,0],[0,0],[0.056,-0.143],[0,0],[0.135,0],[0,0],[0.052,0.112],[0,0]],"v":[[5.86,9.835],[5.549,9.608],[3.84,4.438],[-3.943,4.438],[-5.636,9.608],[-5.915,9.835],[-8.95,9.835],[-9.094,9.608],[-2.318,-9.612],[-2.011,-9.835],[2.128,-9.835],[2.434,-9.612],[9.095,9.608],[8.955,9.835]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[132.411,980.123],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 10","np":3,"cix":2,"bm":0,"ix":10,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0.112],[0,0],[0,0],[-0.116,0],[0,0],[0,-0.112],[0,0],[0.108,0],[0,0],[0,0],[0,0],[0,-0.112],[0,0],[0.116,0],[0,0],[0,0],[0,0],[0,-0.112],[0,0],[0.108,0]],"o":[[-0.116,0],[0,0],[0,0],[0,-0.112],[0,0],[0.108,0],[0,0],[0,0.112],[0,0],[0,0],[0,0],[0.116,0],[0,0],[0,0.112],[0,0],[0,0],[0,0],[0.108,0],[0,0],[0,0.112],[0,0]],"v":[[-6.419,9.835],[-6.646,9.608],[-6.535,-0.143],[-6.646,-9.612],[-6.419,-9.835],[6.2,-9.835],[6.427,-9.612],[6.427,-7.365],[6.2,-7.138],[-3.157,-7.138],[-3.245,-1.944],[5.439,-1.944],[5.662,-1.717],[5.662,0.534],[5.439,0.757],[-3.245,0.757],[-3.157,7.138],[6.427,7.138],[6.646,7.361],[6.646,9.608],[6.427,9.835]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[110.147,980.124],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 11","np":2,"cix":2,"bm":0,"ix":11,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0.112],[0,0],[0,0],[-0.116,0],[0,0],[0,-0.112],[0,0],[0,0],[0,0],[0,-0.112],[0,0],[0.108,0]],"o":[[-0.116,0],[0,0],[0,0],[0,-0.112],[0,0],[0.108,0],[0,0],[0,0],[0,0],[0.108,0],[0,0],[0,0.112],[0,0]],"v":[[-5.816,9.835],[-6.043,9.608],[-5.931,-0.199],[-6.043,-9.612],[-5.816,-9.835],[-2.753,-9.835],[-2.529,-9.612],[-2.645,-0.394],[-2.529,7.138],[5.82,7.138],[6.043,7.361],[6.043,9.608],[5.82,9.835]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[90.902,980.124],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 12","np":2,"cix":2,"bm":0,"ix":12,"mn":"ADBE Vector Group","hd":false},{"ty":"tr","p":{"a":0,"k":[90.902,980.124],"ix":2},"a":{"a":0,"k":[90.902,980.124],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":12,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":665,"st":0,"bm":0}],"markers":[]}');

});

// https://docs.sentry.io/platforms/javascript/
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $18144a665bc8acf7$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



// This is a magic string replaced by rollup
const $b0bfa51115099518$export$31499a9cd224b78c = "8.55.0";


/** Get's the global object for the current JavaScript runtime */ const $1a40e26460b4422e$export$f1a6cdb1459e81d1 = globalThis;
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $1a40e26460b4422e$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $1a40e26460b4422e$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const versionedCarrier = __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] = __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] || {};
    return versionedCarrier[name] || (versionedCarrier[name] = creator());
}


/** Prefix for logging strings */ const $c9674f9e04798056$var$PREFIX = 'Sentry Logger ';
const $c9674f9e04798056$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $c9674f9e04798056$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $c9674f9e04798056$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($c9674f9e04798056$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $c9674f9e04798056$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $c9674f9e04798056$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $18144a665bc8acf7$export$16a28057038b10ef) $c9674f9e04798056$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $c9674f9e04798056$export$cda52e2a8927a2ca(()=>{
                (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console[name](`${$c9674f9e04798056$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $c9674f9e04798056$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $c9674f9e04798056$export$af88d00dbe7f521 = (0, $1a40e26460b4422e$export$7e223ec222791509)('logger', $c9674f9e04798056$var$makeLogger);


const $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT = 50;
const $4010ef0d9b3761f9$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $4010ef0d9b3761f9$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $4010ef0d9b3761f9$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $4010ef0d9b3761f9$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $4010ef0d9b3761f9$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $4010ef0d9b3761f9$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $4010ef0d9b3761f9$var$getLastStackFrame(localStack).filename,
            function: frame.function || $4010ef0d9b3761f9$export$27c7e15d453fc0ac
        }));
}
function $4010ef0d9b3761f9$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $4010ef0d9b3761f9$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $4010ef0d9b3761f9$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $4010ef0d9b3761f9$var$defaultFunctionName;
        return fn.name || $4010ef0d9b3761f9$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $4010ef0d9b3761f9$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $4010ef0d9b3761f9$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


// We keep the handlers globally
const $f079126c500c7ea2$var$handlers = {};
const $f079126c500c7ea2$var$instrumented = {};
/** Add a handler function. */ function $f079126c500c7ea2$export$a4e09611e30da72e(type, handler) {
    $f079126c500c7ea2$var$handlers[type] = $f079126c500c7ea2$var$handlers[type] || [];
    $f079126c500c7ea2$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $f079126c500c7ea2$export$b17eab759a1cb5fe() {
    Object.keys($f079126c500c7ea2$var$handlers).forEach((key)=>{
        $f079126c500c7ea2$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $f079126c500c7ea2$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$f079126c500c7ea2$var$instrumented[type]) {
        $f079126c500c7ea2$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $f079126c500c7ea2$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $f079126c500c7ea2$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $4010ef0d9b3761f9$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}

// eslint-disable-next-line @typescript-eslint/unbound-method
const $9a62450b4f3c2c3b$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$e6127cc7fe7395c3(wat) {
    switch($9a62450b4f3c2c3b$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$var$isBuiltin(wat, className) {
    return $9a62450b4f3c2c3b$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$9f9636d330b71954(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$ef9e2056653f0c8e(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$12e869b2a583f783(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$844ec244b1367d54(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$c3825b437cbdea5c(wat) {
    return wat === null || $9a62450b4f3c2c3b$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$53b83ca8eaab0383(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$49841c62b9eff15(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $9a62450b4f3c2c3b$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$bc2894c7158efbac(wat) {
    return $9a62450b4f3c2c3b$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}



const $cccaafc2216668b2$var$WINDOW = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
const $cccaafc2216668b2$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cccaafc2216668b2$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $cccaafc2216668b2$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $cccaafc2216668b2$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cccaafc2216668b2$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($cccaafc2216668b2$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $cccaafc2216668b2$export$1cfafeee2987818b() {
    try {
        return $cccaafc2216668b2$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existence of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 *
 * @deprecated This method is deprecated and will be removed in the next major version.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cccaafc2216668b2$export$c660c1f3ab49225c(selector) {
    if ($cccaafc2216668b2$var$WINDOW.document && $cccaafc2216668b2$var$WINDOW.document.querySelector) return $cccaafc2216668b2$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $cccaafc2216668b2$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$cccaafc2216668b2$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $cee8faa76567523a$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $cee8faa76567523a$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $cee8faa76567523a$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $9a62450b4f3c2c3b$export$7916fad0ebc23f48)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $cee8faa76567523a$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(value)) return false;
    if ((0, $9a62450b4f3c2c3b$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $cee8faa76567523a$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$cee8faa76567523a$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $f4dd084fe83374eb$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $f4dd084fe83374eb$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $f4dd084fe83374eb$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $f4dd084fe83374eb$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $f4dd084fe83374eb$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f4dd084fe83374eb$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 *
 * @deprecated This function is deprecated and will be removed in the next major version of the SDK.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f4dd084fe83374eb$export$9ef804feabbcbaf1(object) {
    return Object.entries(object).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $f4dd084fe83374eb$export$62ff257738bf57f5(value) {
    if ((0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$f4dd084fe83374eb$var$getOwnProperties(value)
    };
    else if ((0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $f4dd084fe83374eb$var$serializeEventTarget(value.target),
            currentTarget: $f4dd084fe83374eb$var$serializeEventTarget(value.currentTarget),
            ...$f4dd084fe83374eb$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $f4dd084fe83374eb$var$serializeEventTarget(target) {
    try {
        return (0, $9a62450b4f3c2c3b$export$45a5e7f76e0caa8d)(target) ? (0, $cccaafc2216668b2$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $f4dd084fe83374eb$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $f4dd084fe83374eb$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($f4dd084fe83374eb$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $cee8faa76567523a$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $cee8faa76567523a$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $f4dd084fe83374eb$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($f4dd084fe83374eb$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.getOwnPropertyNames(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($f4dd084fe83374eb$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $f4dd084fe83374eb$var$isPojo(input) {
    if (!(0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e2) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $f4dd084fe83374eb$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}


// Based on https://github.com/angular/angular.js/pull/13945/files
// The MIT License
const $210880305d43071a$var$WINDOW = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $210880305d43071a$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    // TODO(v9): Remove this custom check, it is pretty old and likely not needed anymore
    const chromeVar = $210880305d43071a$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    const hasHistoryApi = 'history' in $210880305d43071a$var$WINDOW && !!$210880305d43071a$var$WINDOW.history.pushState && !!$210880305d43071a$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



const $955496f5d3029976$export$56d8a8a25bd48b81 = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);


let $3d87653da885c31c$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3d87653da885c31c$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $3d87653da885c31c$var$instrumentHistory);
}
function $3d87653da885c31c$var$instrumentHistory() {
    if (!(0, $210880305d43071a$export$67fc34576016d6ec)()) return;
    const oldOnPopState = (0, $955496f5d3029976$export$56d8a8a25bd48b81).onpopstate;
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).onpopstate = function(...args) {
        const to = (0, $955496f5d3029976$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $3d87653da885c31c$var$lastHref;
        $3d87653da885c31c$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $3d87653da885c31c$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $3d87653da885c31c$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $f079126c500c7ea2$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $955496f5d3029976$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $955496f5d3029976$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}


const $4f6ba265374890ec$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $4f6ba265374890ec$export$7740643b9eeaf0c4() {
    return Date.now() / $4f6ba265374890ec$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $4f6ba265374890ec$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $4f6ba265374890ec$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $4f6ba265374890ec$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $4f6ba265374890ec$export$ee52dced521e3e18 = $4f6ba265374890ec$var$createUnixTimestampInSecondsFunc();
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 *
 * @deprecated This variable will be removed in the next major version.
 */ let $4f6ba265374890ec$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $4f6ba265374890ec$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        // eslint-disable-next-line deprecation/deprecation
        $4f6ba265374890ec$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            // eslint-disable-next-line deprecation/deprecation
            $4f6ba265374890ec$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            // eslint-disable-next-line deprecation/deprecation
            $4f6ba265374890ec$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    // eslint-disable-next-line deprecation/deprecation
    $4f6ba265374890ec$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();



/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $db00931c27c5ec41$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $db00931c27c5ec41$export$c8bfa33e4e8ae492((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1));
    return 0, $1a40e26460b4422e$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $db00931c27c5ec41$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $b0bfa51115099518$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] = __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] || {};
}









/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $4f55103f4332a5b0$export$19f53698e68b2496() {
    const gbl = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $4f55103f4332a5b0$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $4f55103f4332a5b0$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $4f55103f4332a5b0$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $4f55103f4332a5b0$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $4f55103f4332a5b0$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $4f55103f4332a5b0$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $4f55103f4332a5b0$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $4f55103f4332a5b0$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $4f55103f4332a5b0$export$d364f2020ab30578(input) {
    const match = input.match($4f55103f4332a5b0$var$SEMVER_REGEXP) || [];
    const major = $4f55103f4332a5b0$var$_parseInt(match[1]);
    const minor = $4f55103f4332a5b0$var$_parseInt(match[2]);
    const patch = $4f55103f4332a5b0$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $4f55103f4332a5b0$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $cee8faa76567523a$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $cee8faa76567523a$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $cee8faa76567523a$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $4f55103f4332a5b0$export$6de4ffac6a2f1098(exception) {
    if ($4f55103f4332a5b0$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $4f55103f4332a5b0$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {} // eslint-disable-line no-empty
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 *
 * @deprecated This function has been deprecated and will not be replaced.
 */ function $4f55103f4332a5b0$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $ecc06dd71ed8ff5f$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$ecc06dd71ed8ff5f$var$sessionToJSON(session)
    };
    if (context) $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $ecc06dd71ed8ff5f$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $ecc06dd71ed8ff5f$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $ecc06dd71ed8ff5f$var$sessionToJSON(session) {
    return (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}






/**
 * Returns a new minimal propagation context.
 *
 * @deprecated Use `generateTraceId` and `generateSpanId` instead.
 */ function $dc99b4184ec29e47$export$37f0f2f9cf343e5e() {
    return {
        traceId: $dc99b4184ec29e47$export$dc6d7ea554bcce10(),
        spanId: $dc99b4184ec29e47$export$295213bc4d0c54ad()
    };
}
/**
 * Generate a random, valid trace ID.
 */ function $dc99b4184ec29e47$export$dc6d7ea554bcce10() {
    return (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $dc99b4184ec29e47$export$295213bc4d0c54ad() {
    return (0, $4f55103f4332a5b0$export$19f53698e68b2496)().substring(16);
}



/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $05f9869a4b646370$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && mergeObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $05f9869a4b646370$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}



const $99af9a2b040631ba$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(scope, $99af9a2b040631ba$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$91f063ebb8eff307(scope) {
    return scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information.
 */ class $33c387bb26fe522d$var$ScopeClass {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** Request Mode Session Status */ // eslint-disable-next-line deprecation/deprecation
    /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)(),
            spanId: (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)()
        };
    }
    /**
   * @inheritDoc
   */ clone() {
        const newScope = new $33c387bb26fe522d$var$ScopeClass();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(newScope, (0, $99af9a2b040631ba$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * @inheritDoc
   */ setClient(client) {
        this._client = client;
    }
    /**
   * @inheritDoc
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this._client;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const [scopeInstance, requestSession] = scopeToMerge instanceof $33c387bb26fe522d$export$775b6bb06e53a214 ? [
            scopeToMerge.getScopeData(),
            scopeToMerge.getRequestSession()
        ] : (0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(scopeToMerge) ? [
            captureContext,
            captureContext.requestSession
        ] : [];
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (requestSession) this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._session = undefined;
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            if (this._client) this._client.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $99af9a2b040631ba$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * @inheritDoc
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $05f9869a4b646370$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = {
            // eslint-disable-next-line deprecation/deprecation
            spanId: (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)(),
            ...context
        };
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Holds additional event information.
 */ const $33c387bb26fe522d$export$775b6bb06e53a214 = $33c387bb26fe522d$var$ScopeClass;



/** Get the default current scope. */ function $4354bb0fac58a6e0$export$6f1b9191db9c4d5() {
    return (0, $1a40e26460b4422e$export$7e223ec222791509)('defaultCurrentScope', ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $4354bb0fac58a6e0$export$de9862929b76bf57() {
    return (0, $1a40e26460b4422e$export$7e223ec222791509)('defaultIsolationScope', ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $ab23dab597a507b7$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $ab23dab597a507b7$var$getAsyncContextStack() {
    const registry = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $ab23dab597a507b7$export$d36ec451f120cfba((0, $4354bb0fac58a6e0$export$6f1b9191db9c4d5)(), (0, $4354bb0fac58a6e0$export$de9862929b76bf57)());
}
function $ab23dab597a507b7$var$withScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(callback);
}
function $ab23dab597a507b7$var$withSetScope(scope, callback) {
    const stack = $ab23dab597a507b7$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $ab23dab597a507b7$var$withIsolationScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(()=>{
        return callback($ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $ab23dab597a507b7$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $ab23dab597a507b7$var$withIsolationScope,
        withScope: $ab23dab597a507b7$var$withScope,
        withSetScope: $ab23dab597a507b7$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $ab23dab597a507b7$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $5cec0a7bd2540b32$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $5cec0a7bd2540b32$export$f639b0c2752203be(carrier) {
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $ab23dab597a507b7$export$329d4d4d54e42710)();
}








/**
 * Get the currently active scope.
 */ function $f106fce27ec076f7$export$c7be4b0125a10cba() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $f106fce27ec076f7$export$68f3af03034c9e90() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $f106fce27ec076f7$export$aa55d5ab8e05984f() {
    return (0, $1a40e26460b4422e$export$7e223ec222791509)('globalScope', ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$ec58d9285c204497(...rest) {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $f106fce27ec076f7$export$6bb76d6eba7e258c() {
    return $f106fce27ec076f7$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $f106fce27ec076f7$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    // TODO(v9): Use generateSpanId() instead of spanId
    // eslint-disable-next-line deprecation/deprecation
    const { traceId: traceId, spanId: spanId, parentSpanId: parentSpanId } = propagationContext;
    const traceContext = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
        trace_id: traceId,
        span_id: spanId,
        parent_span_id: parentSpanId
    });
    return traceContext;
}



/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ const $deb2e427fa07e3b2$var$METRICS_SPAN_FIELD = '_sentryMetrics';
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $deb2e427fa07e3b2$export$2e7205e45c58797d(span) {
    const storage = span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD];
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        const arr = output[exportKey] || (output[exportKey] = []);
        arr.push((0, $f4dd084fe83374eb$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on a span.
 */ function $deb2e427fa07e3b2$export$102c7b059b14a4a(span, metricType, sanitizedName, value, unit, tags, bucketKey) {
    const existingStorage = span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD];
    const storage = existingStorage || (span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD] = new Map());
    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);
    if (bucketItem) {
        const [, summary] = bucketItem;
        storage.set(bucketKey, [
            exportKey,
            {
                min: Math.min(summary.min, value),
                max: Math.max(summary.max, value),
                count: summary.count += 1,
                sum: summary.sum += value,
                tags: summary.tags
            }
        ]);
    } else storage.set(bucketKey, [
        exportKey,
        {
            min: value,
            max: value,
            count: 1,
            sum: value,
            tags: tags
        }
    ]);
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $068c396dceb690a1$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $068c396dceb690a1$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $068c396dceb690a1$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $068c396dceb690a1$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $068c396dceb690a1$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $068c396dceb690a1$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $068c396dceb690a1$export$1efec95406bbe327 = 'sentry.profile_id';
const $068c396dceb690a1$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $068c396dceb690a1$export$b016f89ac1066ec = 'cache.hit';
const $068c396dceb690a1$export$3110e4c3f4386399 = 'cache.key';
const $068c396dceb690a1$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $068c396dceb690a1$export$be7a251980e7e946 = 'http.request.method';
const $068c396dceb690a1$export$25dfd73e0e32c6e1 = 'url.full';


const $006ad32cdaebe09b$export$136e25984ba4a383 = 0;
const $006ad32cdaebe09b$export$58f7963109c806fc = 1;
const $006ad32cdaebe09b$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $006ad32cdaebe09b$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $006ad32cdaebe09b$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $006ad32cdaebe09b$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}









/**
 * @deprecated Use a `"baggage"` string directly
 */ const $bcdb7fb6cf7e08bf$export$9ca9946bd449ac06 = 'baggage';
const $bcdb7fb6cf7e08bf$export$6e69537d67fa20f = 'sentry-';
const $bcdb7fb6cf7e08bf$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $bcdb7fb6cf7e08bf$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $bcdb7fb6cf7e08bf$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($bcdb7fb6cf7e08bf$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($bcdb7fb6cf7e08bf$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $bcdb7fb6cf7e08bf$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$bcdb7fb6cf7e08bf$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $bcdb7fb6cf7e08bf$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $bcdb7fb6cf7e08bf$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $bcdb7fb6cf7e08bf$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $bcdb7fb6cf7e08bf$export$bdd844ddb2def819) {
            (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $06e5b8314e290bf2$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $06e5b8314e290bf2$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($06e5b8314e290bf2$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $06e5b8314e290bf2$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $06e5b8314e290bf2$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData || !traceparentData.traceId) return {
        traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)(),
        spanId: (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)()
    };
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    const virtualSpanId = (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)();
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        spanId: virtualSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $06e5b8314e290bf2$export$f35d907436da45cf(traceId = (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)(), spanId = (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}



// These are aligned with OpenTelemetry trace flags
const $36b15c0d755e29f6$export$208d5b368507fb8b = 0x0;
const $36b15c0d755e29f6$export$eb571cd9b5d98de8 = 0x1;
// todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`
let $36b15c0d755e29f6$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $36b15c0d755e29f6$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin } = $36b15c0d755e29f6$export$92d8c23565496537(span);
    return (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin
    });
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $36b15c0d755e29f6$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $36b15c0d755e29f6$export$92d8c23565496537(span).parent_span_id;
    const span_id = isRemote ? (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)() : spanId;
    return (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $36b15c0d755e29f6$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $36b15c0d755e29f6$export$5caecac1caaf3a71(span);
    return (0, $06e5b8314e290bf2$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $36b15c0d755e29f6$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input.getTime());
    return (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $36b15c0d755e29f6$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $36b15c0d755e29f6$export$92d8c23565496537(span) {
    if ($36b15c0d755e29f6$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    try {
        const { spanId: span_id, traceId: trace_id } = span.spanContext();
        // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
        if ($36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
            const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status } = span;
            return (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
                span_id: span_id,
                trace_id: trace_id,
                data: attributes,
                description: name,
                parent_span_id: parentSpanId,
                start_timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(startTime),
                // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
                timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(endTime) || undefined,
                status: $36b15c0d755e29f6$export$e238a77ea3a8cd66(status),
                op: attributes[0, $068c396dceb690a1$export$1a413bd9a88fdb09],
                origin: attributes[0, $068c396dceb690a1$export$cca8dd30f57f805e],
                _metrics_summary: (0, $deb2e427fa07e3b2$export$2e7205e45c58797d)(span)
            });
        }
        // Finally, at least we have `spanContext()`....
        return {
            span_id: span_id,
            trace_id: trace_id
        };
    } catch (e) {
        return {};
    }
}
function $36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $36b15c0d755e29f6$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $36b15c0d755e29f6$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $36b15c0d755e29f6$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $36b15c0d755e29f6$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $006ad32cdaebe09b$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $006ad32cdaebe09b$export$58f7963109c806fc)) return 'ok';
    return status.message || 'unknown_error';
}
const $36b15c0d755e29f6$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $36b15c0d755e29f6$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $36b15c0d755e29f6$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(childSpan, $36b15c0d755e29f6$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(span, $36b15c0d755e29f6$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $36b15c0d755e29f6$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $36b15c0d755e29f6$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($36b15c0d755e29f6$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD] ? Array.from(span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $36b15c0d755e29f6$export$c4c6a79b1260ca1b(span) {
    return span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $36b15c0d755e29f6$export$1be426a8e585c83e() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $99af9a2b040631ba$export$91f063ebb8eff307)((0, $f106fce27ec076f7$export$c7be4b0125a10cba)());
}
/**
 * Updates the metric summary on the currently active span
 */ function $36b15c0d755e29f6$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = $36b15c0d755e29f6$export$1be426a8e585c83e();
    if (span) (0, $deb2e427fa07e3b2$export$102c7b059b14a4a)(span, metricType, sanitizedName, value, unit, tags, bucketKey);
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 *
 * todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`.
 */ function $36b15c0d755e29f6$export$d11691ff45a3e535() {
    if (!$36b15c0d755e29f6$var$hasShownSpanDropWarning) {
        (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Deprecation warning: Returning null from `beforeSendSpan` will be disallowed from SDK version 9.0.0 onwards. The callback will only support mutating spans. To drop certain spans, configure the respective integrations directly.');
        });
        $36b15c0d755e29f6$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $36b15c0d755e29f6$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: 'custom',
        [(0, $068c396dceb690a1$export$165ce9a229f6f050)]: name
    });
}

/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $2bf5ed435a4428b5$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $2bf5ed435a4428b5$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 *
 * @deprecated This function will be removed in the next major version.
 */ // TODO(v9): Hoist this function into the places where we use it. (as it stands only react router v6 instrumentation)
function $2bf5ed435a4428b5$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $2bf5ed435a4428b5$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b776c95debaa4af0$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;





/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $3ed76239c787a980$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $068c396dceb690a1$export$69cd5c610c7bb96a)]: value,
            [(0, $068c396dceb690a1$export$f5f95cff026507b5)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $3ed76239c787a980$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $068c396dceb690a1$export$f5f95cff026507b5];
        const value = attributes[0, $068c396dceb690a1$export$69cd5c610c7bb96a];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}




/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e0c2e3106e46caa2$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;




const $7f25ffc87954188c$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return 'poor';
    if (value > thresholds[0]) return 'needs-improvement';
    return 'good';
};
const $7f25ffc87954188c$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $7f25ffc87954188c$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $dd0ab4bb8fd34918$export$407ea409d1f3b539 = ()=>{
    return `v4-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // sentry-specific change:
// add optional param to not check for responseStart (see comment below)
const $44a719e67f846077$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance && (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance.getEntriesByType && (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance.getEntriesByType('navigation')[0];
    // Check to ensure the `responseStart` property is present and valid.
    // In some cases no value is reported by the browser (for
    // privacy/security reasons), and in other cases (bugs) the value is
    // negative or is larger than the current page time. Ignore these cases:
    // https://github.com/GoogleChrome/web-vitals/issues/137
    // https://github.com/GoogleChrome/web-vitals/issues/162
    // https://github.com/GoogleChrome/web-vitals/issues/275
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $087abae3f457004d$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $21249b77f35afbbd$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering || (0, $087abae3f457004d$export$d3e828b3c7b5b845)() > 0) navigationType = 'prerender';
        else if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.wasDiscarded) navigationType = 'restore';
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, '-');
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: entries,
        id: (0, $dd0ab4bb8fd34918$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $3c3fb26ba7f6478b$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Sentry-specific change:
// This function's logic was NOT updated to web-vitals 4.2.4 but we continue
// to use the web-vitals 3.5.2 due to us having stricter browser support.
// PR with context that made the changes: https://github.com/GoogleChrome/web-vitals/pull/442/files#r1530492402
// The PR removed listening to the `pagehide` event, in favour of only listening to `visibilitychange` event.
// This is "more correct" but some browsers we still support (Safari 12.1-14.0) don't fully support `visibilitychange`
// or have known bugs w.r.t the `visibilitychange` event.
// TODO (v9): If we decide to drop support for Safari 12.1-14.0, we can use the logic from web-vitals 4.2.4
// In this case, we also need to update the integration tests that currently trigger the `pagehide` event to
// simulate the page being hidden.
const $02a4610d4ee5af80$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') cb(event);
    };
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d9bb6b2adff68632$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $bf61d7f7ca9bd10a$var$firstHiddenTime = -1;
const $bf61d7f7ca9bd10a$var$initHiddenTime = ()=>{
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    return (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && !(0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $bf61d7f7ca9bd10a$var$onVisibilityUpdate = (event)=>{
    // If the document is 'hidden' and no previous hidden timestamp has been
    // set, update it based on the current event data.
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && $bf61d7f7ca9bd10a$var$firstHiddenTime > -1) {
        // If the event is a 'visibilitychange' event, it means the page was
        // visible prior to this change, so the event timestamp is the first
        // hidden time.
        // However, if the event is not a 'visibilitychange' event, then it must
        // be a 'prerenderingchange' event, and the fact that the document is
        // still 'hidden' from the above check means the tab was activated
        // in a background state and so has always been hidden.
        $bf61d7f7ca9bd10a$var$firstHiddenTime = event.type === 'visibilitychange' ? event.timeStamp : 0;
        // Remove all listeners now that a `firstHiddenTime` value has been set.
        $bf61d7f7ca9bd10a$var$removeChangeListeners();
    }
};
const $bf61d7f7ca9bd10a$var$addChangeListeners = ()=>{
    addEventListener('visibilitychange', $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
    // IMPORTANT: when a page is prerendering, its `visibilityState` is
    // 'hidden', so in order to account for cases where this module checks for
    // visibility during prerendering, an additional check after prerendering
    // completes is also required.
    addEventListener('prerenderingchange', $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
};
const $bf61d7f7ca9bd10a$var$removeChangeListeners = ()=>{
    removeEventListener('visibilitychange', $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
    removeEventListener('prerenderingchange', $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
};
const $bf61d7f7ca9bd10a$export$443f86b2c77012c4 = ()=>{
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && $bf61d7f7ca9bd10a$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $bf61d7f7ca9bd10a$var$firstHiddenTime = $bf61d7f7ca9bd10a$var$initHiddenTime();
        $bf61d7f7ca9bd10a$var$addChangeListeners();
    }
    return {
        get firstHiddenTime () {
            return $bf61d7f7ca9bd10a$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6f9bc735dd2b9313$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering) addEventListener('prerenderingchange', ()=>callback(), true);
    else callback();
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $c372737293087726$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $c372737293087726$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)('FCP');
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.name === 'first-contentful-paint') {
                    po.disconnect();
                    // Only report if the page wasn't hidden prior to the first paint.
                    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                        // The activationStart reference is used because FCP should be
                        // relative to page activation rather than navigation start if the
                        // page was prerendered. But in cases where `activationStart` occurs
                        // after the FCP, this time should be clamped at 0.
                        metric.value = Math.max(entry.startTime - (0, $087abae3f457004d$export$d3e828b3c7b5b845)(), 0);
                        metric.entries.push(entry);
                        report(true);
                    }
                }
            });
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)('paint', handleEntries);
        if (po) report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c372737293087726$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $c8cc3356aaa35be1$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $c8cc3356aaa35be1$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $c372737293087726$export$fe3c86b74e15d5de)((0, $d9bb6b2adff68632$export$b841d51e31c12bab)(()=>{
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)('CLS', 0);
        let report;
        let sessionValue = 0;
        let sessionEntries = [];
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                // Only count layout shifts without recent user input.
                if (!entry.hadRecentInput) {
                    const firstSessionEntry = sessionEntries[0];
                    const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                    // If the entry occurred less than 1 second after the previous entry
                    // and less than 5 seconds after the first entry in the session,
                    // include the entry in the current session. Otherwise, start a new
                    // session.
                    if (sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                        sessionValue += entry.value;
                        sessionEntries.push(entry);
                    } else {
                        sessionValue = entry.value;
                        sessionEntries = [
                            entry
                        ];
                    }
                }
            });
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                report();
            }
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)('layout-shift', handleEntries);
        if (po) {
            report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c8cc3356aaa35be1$export$3f20d8e089ac35b2, opts.reportAllChanges);
            (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            setTimeout(report, 0);
        }
    }));
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FID. See https://web.dev/articles/fid#what_is_a_good_fid_score */ const $88c48014ef58cf68$export$8f7f3c48ca6fbe34 = [
    100,
    300
];
/**
 * Calculates the [FID](https://web.dev/articles/fid) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $88c48014ef58cf68$export$39705a25c49af873 = (onReport, opts = {})=>{
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)('FID');
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntry = (entry)=>{
            // Only report if the page wasn't hidden prior to the first input.
            if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                metric.value = entry.processingStart - entry.startTime;
                metric.entries.push(entry);
                report(true);
            }
        };
        const handleEntries = (entries)=>{
            entries.forEach(handleEntry);
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)('first-input', handleEntries);
        report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $88c48014ef58cf68$export$8f7f3c48ca6fbe34, opts.reportAllChanges);
        if (po) (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)((0, $d9bb6b2adff68632$export$b841d51e31c12bab)(()=>{
            handleEntries(po.takeRecords());
            po.disconnect();
        }));
    });
};






/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $cc83e22cb516f528$var$interactionCountEstimate = 0;
let $cc83e22cb516f528$var$minKnownInteractionId = Infinity;
let $cc83e22cb516f528$var$maxKnownInteractionId = 0;
const $cc83e22cb516f528$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $cc83e22cb516f528$var$minKnownInteractionId = Math.min($cc83e22cb516f528$var$minKnownInteractionId, e.interactionId);
            $cc83e22cb516f528$var$maxKnownInteractionId = Math.max($cc83e22cb516f528$var$maxKnownInteractionId, e.interactionId);
            $cc83e22cb516f528$var$interactionCountEstimate = $cc83e22cb516f528$var$maxKnownInteractionId ? ($cc83e22cb516f528$var$maxKnownInteractionId - $cc83e22cb516f528$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $cc83e22cb516f528$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $cc83e22cb516f528$export$8a962f2683a476d1 = ()=>{
    return $cc83e22cb516f528$var$po ? $cc83e22cb516f528$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $cc83e22cb516f528$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $cc83e22cb516f528$var$po) return;
    $cc83e22cb516f528$var$po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)('event', $cc83e22cb516f528$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER long.
const $6ba5ec799590141e$export$fbb6a65efb09cd7a = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $6ba5ec799590141e$export$7b86959c9ded44e2 = new Map();
// The default `durationThreshold` used across this library for observing
// `event` entries via PerformanceObserver.
const $6ba5ec799590141e$export$9cebd8cf5d8d3416 = 40;
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
let $6ba5ec799590141e$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $6ba5ec799590141e$var$getInteractionCountForNavigation = ()=>{
    return (0, $cc83e22cb516f528$export$8a962f2683a476d1)() - $6ba5ec799590141e$var$prevInteractionCount;
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $6ba5ec799590141e$export$70cf089971ed4f82 = ()=>{
    const candidateInteractionIndex = Math.min($6ba5ec799590141e$export$fbb6a65efb09cd7a.length - 1, Math.floor($6ba5ec799590141e$var$getInteractionCountForNavigation() / 50));
    return $6ba5ec799590141e$export$fbb6a65efb09cd7a[candidateInteractionIndex];
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $6ba5ec799590141e$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
/**
 * A list of callback functions to run before each entry is processed.
 * Exposing this list allows the attribution build to hook into the
 * entry processing pipeline.
 */ const $6ba5ec799590141e$export$1c74e929da1e189d = [];
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $6ba5ec799590141e$export$6a7a48c2c643798f = (entry)=>{
    $6ba5ec799590141e$export$1c74e929da1e189d.forEach((cb)=>cb(entry));
    // Skip further processing for entries that cannot be INP candidates.
    if (!(entry.interactionId || entry.entryType === 'first-input')) return;
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $6ba5ec799590141e$export$fbb6a65efb09cd7a[$6ba5ec799590141e$export$fbb6a65efb09cd7a.length - 1];
    const existingInteraction = $6ba5ec799590141e$export$7b86959c9ded44e2.get(entry.interactionId);
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $6ba5ec799590141e$export$fbb6a65efb09cd7a.length < $6ba5ec799590141e$var$MAX_INTERACTIONS_TO_CONSIDER || minLongestInteraction && entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            // If the new entry has a longer duration, replace the old entries,
            // otherwise add to the array.
            if (entry.duration > existingInteraction.latency) {
                existingInteraction.entries = [
                    entry
                ];
                existingInteraction.latency = entry.duration;
            } else if (entry.duration === existingInteraction.latency && entry.startTime === (existingInteraction.entries[0] && existingInteraction.entries[0].startTime)) existingInteraction.entries.push(entry);
        } else {
            const interaction = {
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $6ba5ec799590141e$export$7b86959c9ded44e2.set(interaction.id, interaction);
            $6ba5ec799590141e$export$fbb6a65efb09cd7a.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $6ba5ec799590141e$export$fbb6a65efb09cd7a.sort((a, b)=>b.latency - a.latency);
        if ($6ba5ec799590141e$export$fbb6a65efb09cd7a.length > $6ba5ec799590141e$var$MAX_INTERACTIONS_TO_CONSIDER) $6ba5ec799590141e$export$fbb6a65efb09cd7a.splice($6ba5ec799590141e$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>$6ba5ec799590141e$export$7b86959c9ded44e2.delete(i.id));
    }
};









/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs the passed callback during the next idle period, or immediately
 * if the browser's visibility state is (or becomes) hidden.
 */ const $25236b21f8c05ee3$export$4d9952dcbf5b2792 = (cb)=>{
    const rIC = (0, $955496f5d3029976$export$56d8a8a25bd48b81).requestIdleCallback || (0, $955496f5d3029976$export$56d8a8a25bd48b81).setTimeout;
    let handle = -1;
    // eslint-disable-next-line no-param-reassign
    cb = (0, $d9bb6b2adff68632$export$b841d51e31c12bab)(cb);
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') cb();
    else {
        handle = rIC(cb);
        (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(cb);
    }
    return handle;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $c2ceebba2f8f4181$export$7f4cb060ded9173c = [
    200,
    500
];
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $c2ceebba2f8f4181$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!('PerformanceEventTiming' in (0, $955496f5d3029976$export$56d8a8a25bd48b81) && 'interactionId' in PerformanceEventTiming.prototype)) return;
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $cc83e22cb516f528$export$67d90cda6b78a2eb)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)('INP');
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntries = (entries)=>{
            // Queue the `handleEntries()` callback in the next idle task.
            // This is needed to increase the chances that all event entries that
            // occurred between the user interaction and the next paint
            // have been dispatched. Note: there is currently an experiment
            // running in Chrome (EventTimingKeypressAndCompositionInteractionId)
            // 123+ that if rolled out fully may make this no longer necessary.
            (0, $25236b21f8c05ee3$export$4d9952dcbf5b2792)(()=>{
                entries.forEach((0, $6ba5ec799590141e$export$6a7a48c2c643798f));
                const inp = (0, $6ba5ec799590141e$export$70cf089971ed4f82)();
                if (inp && inp.latency !== metric.value) {
                    metric.value = inp.latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)('event', handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold != null ? opts.durationThreshold : (0, $6ba5ec799590141e$export$9cebd8cf5d8d3416)
        });
        report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c2ceebba2f8f4181$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // Also observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            po.observe({
                type: 'first-input',
                buffered: true
            });
            (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};












/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $c89cf1e13796625e$export$948521ca5b0e1b17 = [
    2500,
    4000
];
const $c89cf1e13796625e$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $c89cf1e13796625e$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)('LCP');
        let report;
        const handleEntries = (entries)=>{
            // If reportAllChanges is set then call this function for each entry,
            // otherwise only consider the last one.
            if (!opts.reportAllChanges) // eslint-disable-next-line no-param-reassign
            entries = entries.slice(-1);
            entries.forEach((entry)=>{
                // Only report if the page wasn't hidden prior to LCP.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was pre-rendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $087abae3f457004d$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            });
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)('largest-contentful-paint', handleEntries);
        if (po) {
            report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c89cf1e13796625e$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $d9bb6b2adff68632$export$b841d51e31c12bab)(()=>{
                if (!$c89cf1e13796625e$var$reportedMetricIDs[metric.id]) {
                    handleEntries(po.takeRecords());
                    po.disconnect();
                    $c89cf1e13796625e$var$reportedMetricIDs[metric.id] = true;
                    report(true);
                }
            });
            // Stop listening after input. Note: while scrolling is an input that
            // stops LCP observation, it's unreliable since it can be programmatically
            // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
            [
                'keydown',
                'click'
            ].forEach((type)=>{
                // Wrap in a setTimeout so the callback is run in a separate task
                // to avoid extending the keyboard/click handler to reduce INP impact
                // https://github.com/GoogleChrome/web-vitals/issues/383
                if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document) addEventListener(type, ()=>(0, $25236b21f8c05ee3$export$4d9952dcbf5b2792)(stopListening), {
                    once: true,
                    capture: true
                });
            });
            (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(stopListening);
        }
    });
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $f3a7825c3a5278be$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $f3a7825c3a5278be$var$whenReady = (callback)=>{
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering) (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>$f3a7825c3a5278be$var$whenReady(callback));
    else if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.readyState !== 'complete') addEventListener('load', ()=>$f3a7825c3a5278be$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $f3a7825c3a5278be$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)('TTFB');
    const report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $f3a7825c3a5278be$export$65c59ea8064668fc, opts.reportAllChanges);
    $f3a7825c3a5278be$var$whenReady(()=>{
        const navigationEntry = (0, $44a719e67f846077$export$6431553786c94949)();
        if (navigationEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navigationEntry.responseStart - (0, $087abae3f457004d$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $31f3d198369e5cbf$var$handlers = {};
const $31f3d198369e5cbf$var$instrumented = {};
let $31f3d198369e5cbf$var$_previousCls;
let $31f3d198369e5cbf$var$_previousFid;
let $31f3d198369e5cbf$var$_previousLcp;
let $31f3d198369e5cbf$var$_previousTtfb;
let $31f3d198369e5cbf$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $31f3d198369e5cbf$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $31f3d198369e5cbf$var$addMetricObserver('cls', callback, $31f3d198369e5cbf$var$instrumentCls, $31f3d198369e5cbf$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $31f3d198369e5cbf$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $31f3d198369e5cbf$var$addMetricObserver('lcp', callback, $31f3d198369e5cbf$var$instrumentLcp, $31f3d198369e5cbf$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$2707d7471c0b918f(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver('fid', callback, $31f3d198369e5cbf$var$instrumentFid, $31f3d198369e5cbf$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $31f3d198369e5cbf$export$699d9529c099a797(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver('ttfb', callback, $31f3d198369e5cbf$var$instrumentTtfb, $31f3d198369e5cbf$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$da3b76aa2022cbd7(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver('inp', callback, $31f3d198369e5cbf$var$instrumentInp, $31f3d198369e5cbf$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$69816c1a049f8db6(type, callback) {
    $31f3d198369e5cbf$var$addHandler(type, callback);
    if (!$31f3d198369e5cbf$var$instrumented[type]) {
        $31f3d198369e5cbf$var$instrumentPerformanceObserver(type);
        $31f3d198369e5cbf$var$instrumented[type] = true;
    }
    return $31f3d198369e5cbf$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $31f3d198369e5cbf$var$triggerHandlers(type, data) {
    const typeHandlers = $31f3d198369e5cbf$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $4010ef0d9b3761f9$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $31f3d198369e5cbf$var$instrumentCls() {
    return (0, $c8cc3356aaa35be1$export$a7873055838e5ad8)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers('cls', {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $31f3d198369e5cbf$var$instrumentFid() {
    return (0, $88c48014ef58cf68$export$39705a25c49af873)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers('fid', {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousFid = metric;
    });
}
function $31f3d198369e5cbf$var$instrumentLcp() {
    return (0, $c89cf1e13796625e$export$947b1626ab8d5632)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers('lcp', {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $31f3d198369e5cbf$var$instrumentTtfb() {
    return (0, $f3a7825c3a5278be$export$33a01e6c5f2c7e33)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousTtfb = metric;
    });
}
function $31f3d198369e5cbf$var$instrumentInp() {
    return (0, $c2ceebba2f8f4181$export$7df4b36ecaed99e1)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers('inp', {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousInp = metric;
    });
}
function $31f3d198369e5cbf$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $31f3d198369e5cbf$var$addHandler(type, callback);
    let stopListening;
    if (!$31f3d198369e5cbf$var$instrumented[type]) {
        stopListening = instrumentFn();
        $31f3d198369e5cbf$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $31f3d198369e5cbf$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $31f3d198369e5cbf$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $3c3fb26ba7f6478b$export$d1203567a167490e)(type, (entries)=>{
        $31f3d198369e5cbf$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $31f3d198369e5cbf$var$addHandler(type, handler) {
    $31f3d198369e5cbf$var$handlers[type] = $31f3d198369e5cbf$var$handlers[type] || [];
    $31f3d198369e5cbf$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $31f3d198369e5cbf$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $31f3d198369e5cbf$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */ function $31f3d198369e5cbf$export$7affb50b622d8714(entry) {
    return 'duration' in entry;
}











/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $a328b345a75725bb$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $a328b345a75725bb$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $a328b345a75725bb$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $e426c875bd1d2890$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    // eslint-disable-next-line deprecation/deprecation
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}




const $3592a0510b526070$export$849dbeeeda01ae98 = 'production';








/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(spanWithMaybeDsc, $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $dfdaf30e5fcd5fd9$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
        environment: options.environment || (0, $3592a0510b526070$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $dfdaf30e5fcd5fd9$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $dfdaf30e5fcd5fd9$export$a117f995597e25df(span) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return frozenDsc;
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceState = rootSpan.spanContext().traceState;
    const traceStateDsc = traceState && traceState.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return dscOnTraceState;
    // Else, we generate it from the span
    const dsc = $dfdaf30e5fcd5fd9$export$366bad00d6815eed(span.spanContext().traceId, client);
    const jsonSpan = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
    const attributes = jsonSpan.data || {};
    const maybeSampleRate = attributes[0, $068c396dceb690a1$export$ccfe0a40627cc34b];
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = attributes[0, $068c396dceb690a1$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = jsonSpan.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasTracingEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $e426c875bd1d2890$export$5008da00b1b6dee6)()) dsc.sampled = String((0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(rootSpan));
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $dfdaf30e5fcd5fd9$export$95cf936fdacaff7b(span) {
    const dsc = $dfdaf30e5fcd5fd9$export$a117f995597e25df(span);
    return (0, $bcdb7fb6cf7e08bf$export$56766feef403f365)(dsc);
}





/**
 * Print a log message for a started span.
 */ function $09ada9a941cee5f6$export$2f3d84e767c9592b(span) {
    if (!(0, $b776c95debaa4af0$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >', parent_span_id: parentSpanId } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */ function $09ada9a941cee5f6$export$b77c830667a4d630(span) {
    if (!(0, $b776c95debaa4af0$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >' } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
    (0, $c9674f9e04798056$export$af88d00dbe7f521).log(msg);
}








/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $1053a52e7802e64c$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return undefined;
    }
    return rate;
}


/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $db2bd6d2ef458b60$export$5f833db634b217bb(options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $e426c875bd1d2890$export$5008da00b1b6dee6)(options)) return [
        false
    ];
    // Casting this from unknown, as the type of `sdkProcessingMetadata` is only changed in v9 and `normalizedRequest` is set in SentryHttpInstrumentation
    const normalizedRequest = (0, $f106fce27ec076f7$export$68f3af03034c9e90)().getScopeData().sdkProcessingMetadata.normalizedRequest;
    const enhancedSamplingContext = {
        ...samplingContext,
        normalizedRequest: samplingContext.normalizedRequest || normalizedRequest
    };
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') sampleRate = options.tracesSampler(enhancedSamplingContext);
    else if (enhancedSamplingContext.parentSampled !== undefined) sampleRate = enhancedSamplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') sampleRate = options.tracesSampleRate;
    else // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        return [
            false,
            parsedSampleRate
        ];
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const shouldSample = Math.random() < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return [
            false,
            parsedSampleRate
        ];
    }
    return [
        true,
        parsedSampleRate
    ];
}




/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $d899755a957e1f50$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)();
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $36b15c0d755e29f6$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLink(_link) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}







/** Regular expression used to parse a Dsn. */ const $9171e4713e443b9b$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $9171e4713e443b9b$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $9171e4713e443b9b$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $9171e4713e443b9b$export$b892860177f70a30(str) {
    const match = $9171e4713e443b9b$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $9171e4713e443b9b$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $9171e4713e443b9b$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $9171e4713e443b9b$var$validateDsn(dsn) {
    if (!(0, $18144a665bc8acf7$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$9171e4713e443b9b$var$isValidProtocol(protocol)) {
        (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $9171e4713e443b9b$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $9171e4713e443b9b$export$b892860177f70a30(from) : $9171e4713e443b9b$var$dsnFromComponents(from);
    if (!components || !$9171e4713e443b9b$var$validateDsn(components)) return undefined;
    return components;
}




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 *
 * @deprecated This function is deprecated and will be removed in the next major version.
 */ // TODO(v9): Move this function into normalize() directly
function $25eec345af6c49d3$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}




/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eb42146e0d2c9ef$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $5eb42146e0d2c9ef$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $5eb42146e0d2c9ef$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $5eb42146e0d2c9ef$export$a3295358bff77e(object, depth);
    if ($5eb42146e0d2c9ef$var$jsonSize(normalized) > maxSize) return $5eb42146e0d2c9ef$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $5eb42146e0d2c9ef$var$visit(key, value, depth = Infinity, maxProperties = Infinity, // eslint-disable-next-line deprecation/deprecation
memo = (0, $25eec345af6c49d3$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $5eb42146e0d2c9ef$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $5eb42146e0d2c9ef$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $f4dd084fe83374eb$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $5eb42146e0d2c9ef$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $5eb42146e0d2c9ef$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $9a62450b4f3c2c3b$export$7916fad0ebc23f48)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $9a62450b4f3c2c3b$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $4010ef0d9b3761f9$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $5eb42146e0d2c9ef$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $5eb42146e0d2c9ef$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $5eb42146e0d2c9ef$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eb42146e0d2c9ef$var$jsonSize(value) {
    return $5eb42146e0d2c9ef$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $5eb42146e0d2c9ef$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f5682b06913d5b03$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f5682b06913d5b03$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $f5682b06913d5b03$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $f5682b06913d5b03$export$604a45d95a155e2b(envelope, types) {
    return $f5682b06913d5b03$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $f5682b06913d5b03$var$encodeUTF8(input) {
    return (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill ? (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $f5682b06913d5b03$var$decodeUTF8(input) {
    return (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill ? (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $f5682b06913d5b03$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $f5682b06913d5b03$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $f5682b06913d5b03$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $5eb42146e0d2c9ef$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $f5682b06913d5b03$var$concatBuffers(parts);
}
function $f5682b06913d5b03$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $f5682b06913d5b03$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $f5682b06913d5b03$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($f5682b06913d5b03$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $f5682b06913d5b03$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $f5682b06913d5b03$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $f5682b06913d5b03$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $f5682b06913d5b03$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket',
    raw_security: 'security'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $f5682b06913d5b03$export$b11169581eeaf237(type) {
    return $f5682b06913d5b03$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $f5682b06913d5b03$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $f5682b06913d5b03$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $b89a3b4f1056006b$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f5682b06913d5b03$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $b89a3b4f1056006b$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f5682b06913d5b03$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $f5682b06913d5b03$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $b89a3b4f1056006b$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(spans[0]);
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client && client.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = beforeSendSpan((0, $36b15c0d755e29f6$export$92d8c23565496537)(span));
        if (!spanJson) (0, $36b15c0d755e29f6$export$d11691ff45a3e535)();
        return spanJson;
    } : (span)=>(0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $f5682b06913d5b03$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(headers, items);
}













const $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $4509d165411fd11c$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(span, $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(span, $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $4509d165411fd11c$export$c08fbc656a245d03(span) {
    return {
        scope: span[$4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


const $e47c8865bba9bc73$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $e47c8865bba9bc73$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
        this._attributes = {};
        this.setAttributes({
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'manual',
            [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLink(_link) {
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $36b15c0d755e29f6$export$eb571cd9b5d98de8) : (0, $36b15c0d755e29f6$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $068c396dceb690a1$export$d7a7d984b0791405), 'custom');
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(endTimestamp);
        (0, $09ada9a941cee5f6$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $068c396dceb690a1$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $36b15c0d755e29f6$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $068c396dceb690a1$export$cca8dd30f57f805e],
            _metrics_summary: (0, $deb2e427fa07e3b2$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $068c396dceb690a1$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $068c396dceb690a1$export$fea48ba9f4550879],
            measurements: (0, $3ed76239c787a980$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('[Tracing] Adding an event to span:', name);
        const time = $e47c8865bba9bc73$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
        const attributes = $e47c8865bba9bc73$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        if (client) client.emit('spanEnd', this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $e47c8865bba9bc73$var$sendSpanEnvelope((0, $b89a3b4f1056006b$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                if (client) client.recordDroppedEvent('sample_rate', 'span');
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $4509d165411fd11c$export$c08fbc656a245d03)(this).scope || (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$e47c8865bba9bc73$var$isFullFinishedSpan((0, $36b15c0d755e29f6$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $4509d165411fd11c$export$c08fbc656a245d03)(this);
        const scope = capturedSpanScope || (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
        const client = scope.getClient() || (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            if (client) client.recordDroppedEvent('sample_rate', 'transaction');
            return undefined;
        }
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $36b15c0d755e29f6$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$e47c8865bba9bc73$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $36b15c0d755e29f6$export$92d8c23565496537)(span)).filter($e47c8865bba9bc73$var$isFullFinishedSpan);
        const source = this._attributes[0, $068c396dceb690a1$export$d7a7d984b0791405];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $068c396dceb690a1$export$165ce9a229f6f050];
        spans.forEach((span)=>{
            span.data && delete span.data[0, $068c396dceb690a1$export$165ce9a229f6f050];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $36b15c0d755e29f6$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $e47c8865bba9bc73$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $e47c8865bba9bc73$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $deb2e427fa07e3b2$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $3ed76239c787a980$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $e47c8865bba9bc73$var$isSpanTimeInput(value) {
    return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $e47c8865bba9bc73$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $e47c8865bba9bc73$var$isStandaloneSpan(span) {
    return span instanceof $e47c8865bba9bc73$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $e47c8865bba9bc73$var$sendSpanEnvelope(envelope) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}




const $038737f78c636108$var$SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$a1bd95187356f372(options, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)(options.scope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $038737f78c636108$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
            const parentSpan = $038737f78c636108$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $d899755a957e1f50$export$d6636b700b76c516)() : $038737f78c636108$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $a328b345a75725bb$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            }, ()=>activeSpan.end());
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$c10292ad04b92aea(options, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)(options.scope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $038737f78c636108$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
            const parentSpan = $038737f78c636108$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $d899755a957e1f50$export$d6636b700b76c516)() : $038737f78c636108$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(scope, activeSpan);
            function finishAndSetSpan() {
                activeSpan.end();
            }
            return (0, $a328b345a75725bb$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$63dbba021a6b4047(options) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $f106fce27ec076f7$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$038737f78c636108$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
        const parentSpan = $038737f78c636108$var$getParentSpan(scope);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $d899755a957e1f50$export$d6636b700b76c516)();
        return $038737f78c636108$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $038737f78c636108$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $06e5b8314e290bf2$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $038737f78c636108$export$e57ac09b143d92a2(span, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $038737f78c636108$export$869298f9835abc68(callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$038737f78c636108$var$SUPPRESS_TRACING_KEY]: true
        });
        return callback();
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $038737f78c636108$export$f90b03291402f553(callback) {
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)()
        });
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).info(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $038737f78c636108$export$e57ac09b143d92a2(null, callback);
    });
}
function $038737f78c636108$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $e426c875bd1d2890$export$5008da00b1b6dee6)()) return new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $038737f78c636108$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $36b15c0d755e29f6$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(parentSpan);
        span = $038737f78c636108$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $038737f78c636108$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $09ada9a941cee5f6$export$2f3d84e767c9592b)(span);
    (0, $4509d165411fd11c$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $038737f78c636108$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $038737f78c636108$var$getAcs() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    return (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
}
function $038737f78c636108$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {};
    const { name: name = '', attributes: attributes } = spanArguments;
    const [sampled, sampleRate] = scope.getScopeData().sdkProcessingMetadata[$038737f78c636108$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $db2bd6d2ef458b60$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: parentSampled,
        attributes: attributes,
        transactionContext: {
            name: name,
            parentSampled: parentSampled
        }
    });
    const rootSpan = new (0, $e47c8865bba9bc73$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: 'custom',
            ...spanArguments.attributes
        },
        sampled: sampled
    });
    if (sampleRate !== undefined) rootSpan.setAttribute((0, $068c396dceb690a1$export$ccfe0a40627cc34b), sampleRate);
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $038737f78c636108$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$038737f78c636108$var$SUPPRESS_TRACING_KEY] ? false : (0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $e47c8865bba9bc73$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $d899755a957e1f50$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $36b15c0d755e29f6$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) {
        client.emit('spanStart', childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit('spanEnd', childSpan);
    }
    return childSpan;
}
function $038737f78c636108$var$getParentSpan(scope) {
    const span = (0, $99af9a2b040631ba$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $038737f78c636108$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $038737f78c636108$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}



/**
 * Checks if a given value is a valid measurement value.
 */ function $b0d1d845a8fb2673$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $b0d1d845a8fb2673$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $36b15c0d755e29f6$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === 'function') parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, $038737f78c636108$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $038737f78c636108$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */ function $b0d1d845a8fb2673$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment } = client.getOptions();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay && replay.getReplayId();
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    let profileId;
    try {
        // @ts-expect-error skip optional chaining to save bundle size with try catch
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch (e) {
    // do nothing
    }
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || undefined,
        profile_id: profileId || undefined,
        replay_id: replayId || undefined,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        'user_agent.original': (0, $955496f5d3029976$export$56d8a8a25bd48b81).navigator && (0, $955496f5d3029976$export$56d8a8a25bd48b81).navigator.userAgent,
        ...passedAttributes
    };
    return (0, $038737f78c636108$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
/** Get the browser performance API. */ function $b0d1d845a8fb2673$export$f72a13c439a30cab() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $955496f5d3029976$export$56d8a8a25bd48b81) && (0, $955496f5d3029976$export$56d8a8a25bd48b81).addEventListener && (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $b0d1d845a8fb2673$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $b0d1d845a8fb2673$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}



/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */ function $b444d11e9edd543f$export$585bab03c6c18c45() {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    let pageloadSpanId;
    if (!$b444d11e9edd543f$var$supportsLayoutShift()) return;
    let sentSpan = false;
    function _collectClsOnce() {
        if (sentSpan) return;
        sentSpan = true;
        if (pageloadSpanId) $b444d11e9edd543f$var$sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId);
        cleanupClsHandler();
    }
    const cleanupClsHandler = (0, $31f3d198369e5cbf$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    // use pagehide event from web-vitals
    (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(()=>{
        _collectClsOnce();
    });
    // Since the call chain of this function is synchronous and evaluates before the SDK client is created,
    // we need to wait with subscribing to a client hook until the client is created. Therefore, we defer
    // to the next tick after the SDK setup.
    setTimeout(()=>{
        const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        if (!client) return;
        const unsubscribeStartNavigation = client.on('startNavigationSpan', ()=>{
            _collectClsOnce();
            unsubscribeStartNavigation && unsubscribeStartNavigation();
        });
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const rootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
        const spanJSON = rootSpan && (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
        if (spanJSON && spanJSON.op === 'pageload') pageloadSpanId = rootSpan.spanContext().spanId;
    }, 0);
}
function $b444d11e9edd543f$var$sendStandaloneClsSpan(clsValue, entry, pageloadSpanId) {
    (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Sending CLS span (${clsValue})`);
    const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(((0, $4f6ba265374890ec$export$baf075a948ffc0bf) || 0) + (entry && entry.startTime || 0));
    const routeName = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $cccaafc2216668b2$export$5647df6b7814ac86)(entry.sources[0] && entry.sources[0].node) : 'Layout shift';
    const attributes = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
        [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.http.browser.cls',
        [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: 'ui.webvital.cls',
        [(0, $068c396dceb690a1$export$fea48ba9f4550879)]: entry && entry.duration || 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        'sentry.pageload.span_id': pageloadSpanId
    });
    const span = (0, $b0d1d845a8fb2673$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent('cls', {
            [(0, $068c396dceb690a1$export$f5f95cff026507b5)]: '',
            [(0, $068c396dceb690a1$export$69cd5c610c7bb96a)]: clsValue
        });
        // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
        // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
        span.end(startTime);
    }
}
function $b444d11e9edd543f$var$supportsLayoutShift() {
    try {
        return PerformanceObserver.supportedEntryTypes.includes('layout-shift');
    } catch (e) {
        return false;
    }
}







const $4ca18541755f3f2c$var$MAX_INT_AS_BYTES = 2147483647;
let $4ca18541755f3f2c$var$_performanceCursor = 0;
let $4ca18541755f3f2c$var$_measurements = {};
let $4ca18541755f3f2c$var$_lcpEntry;
let $4ca18541755f3f2c$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $4ca18541755f3f2c$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans }) {
    const performance = (0, $b0d1d845a8fb2673$export$f72a13c439a30cab)();
    if (performance && (0, $4f6ba265374890ec$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance.mark('sentry-tracing-init');
        const fidCleanupCallback = $4ca18541755f3f2c$var$_trackFID();
        const lcpCleanupCallback = $4ca18541755f3f2c$var$_trackLCP();
        const ttfbCleanupCallback = $4ca18541755f3f2c$var$_trackTtfb();
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $b444d11e9edd543f$export$585bab03c6c18c45)() : $4ca18541755f3f2c$var$_trackCLS();
        return ()=>{
            fidCleanupCallback();
            lcpCleanupCallback();
            ttfbCleanupCallback();
            clsCleanupCallback && clsCleanupCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $4ca18541755f3f2c$export$f396d19077034ad2() {
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)('longtask', ({ entries: entries })=>{
        const parent = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(parent);
        for (const entry of entries){
            const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $4f6ba265374890ec$export$baf075a948ffc0bf) + entry.startTime);
            const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-task',
                attributes: {
                    [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                }
            });
        }
    });
}
/**
 * Start tracking long animation frames.
 */ function $4ca18541755f3f2c$export$5b823ab2ccbc801d() {
    // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
    // we directly observe `long-animation-frame` events instead of through the web-vitals
    // `observe` helper function.
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $4f6ba265374890ec$export$baf075a948ffc0bf) + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(parent);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes['browser.script.invoker'] = invoker;
            attributes['browser.script.invoker_type'] = invokerType;
            if (sourceURL) attributes['code.filepath'] = sourceURL;
            if (sourceFunctionName) attributes['code.function'] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes['browser.script.source_char_position'] = sourceCharPosition;
            (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-animation-frame',
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: 'long-animation-frame',
        buffered: true
    });
}
/**
 * Start tracking interaction events.
 */ function $4ca18541755f3f2c$export$e27543e0976315e4() {
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)('event', ({ entries: entries })=>{
        const parent = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === 'click') {
            const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $4f6ba265374890ec$export$baf075a948ffc0bf) + entry.startTime);
            const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $cccaafc2216668b2$export$5647df6b7814ac86)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                }
            };
            const componentName = (0, $cccaafc2216668b2$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes['ui.component_name'] = componentName;
            (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */ function $4ca18541755f3f2c$var$_trackCLS() {
    return (0, $31f3d198369e5cbf$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $4ca18541755f3f2c$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $4ca18541755f3f2c$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $4ca18541755f3f2c$var$_trackLCP() {
    return (0, $31f3d198369e5cbf$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $4ca18541755f3f2c$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $4ca18541755f3f2c$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $4ca18541755f3f2c$var$_trackFID() {
    return (0, $31f3d198369e5cbf$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $4f6ba265374890ec$export$baf075a948ffc0bf));
        const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.startTime);
        $4ca18541755f3f2c$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $4ca18541755f3f2c$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
function $4ca18541755f3f2c$var$_trackTtfb() {
    return (0, $31f3d198369e5cbf$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $4ca18541755f3f2c$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
/** Add performance related spans to a transaction */ function $4ca18541755f3f2c$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $b0d1d845a8fb2673$export$f72a13c439a30cab)();
    if (!performance || !performance.getEntries || !(0, $4f6ba265374890ec$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    const timeOrigin = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $4f6ba265374890ec$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
    performanceEntries.slice($4ca18541755f3f2c$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $4ca18541755f3f2c$var$_addNavigationSpans(span, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $4ca18541755f3f2c$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) $4ca18541755f3f2c$var$_measurements['fp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    if (entry.name === 'first-contentful-paint' && shouldRecord) $4ca18541755f3f2c$var$_measurements['fcp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    break;
                }
            case 'resource':
                $4ca18541755f3f2c$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $4ca18541755f3f2c$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $4ca18541755f3f2c$var$_trackNavigator(span);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $4ca18541755f3f2c$var$_addTtfbRequestTimeToMeasurements($4ca18541755f3f2c$var$_measurements);
        const fidMark = $4ca18541755f3f2c$var$_measurements['mark.fid'];
        if (fidMark && $4ca18541755f3f2c$var$_measurements['fid']) {
            // create span for FID
            (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, fidMark.value, fidMark.value + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)($4ca18541755f3f2c$var$_measurements['fid'].value), {
                name: 'first input delay',
                op: 'ui.action',
                attributes: {
                    [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                }
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $4ca18541755f3f2c$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        // TODO: Check if the first condition is still necessary: `onCLS` already only fires once `onFCP` was called.
        if (!('fcp' in $4ca18541755f3f2c$var$_measurements) || !options.recordClsOnPageloadSpan) delete $4ca18541755f3f2c$var$_measurements.cls;
        Object.entries($4ca18541755f3f2c$var$_measurements).forEach(([measurementName, measurement])=>{
            (0, $3ed76239c787a980$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit);
        });
        // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
        span.setAttribute('performance.timeOrigin', timeOrigin);
        // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
        // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
        // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
        // time where the user actively started the navigation, for example by clicking a link.
        // This is user action is called "activation" and the time between navigation and activation is stored in
        // the `activationStart` attribute of the "navigation" PerformanceEntry.
        span.setAttribute('performance.activationStart', (0, $087abae3f457004d$export$d3e828b3c7b5b845)());
        $4ca18541755f3f2c$var$_setWebVitalAttributes(span);
    }
    $4ca18541755f3f2c$var$_lcpEntry = undefined;
    $4ca18541755f3f2c$var$_clsEntry = undefined;
    $4ca18541755f3f2c$var$_measurements = {};
}
/**
 * Create measure related spans.
 * Exported only for tests.
 */ function $4ca18541755f3f2c$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin) {
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)(false);
    const requestTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    // Because performance.measure accepts arbitrary timestamps it can produce
    // spans that happen before the browser even makes a request for the page.
    //
    // An example of this is the automatically generated Next.js-before-hydration
    // spans created by the Next.js framework.
    //
    // To prevent this we will pin the start timestamp to the request start time
    // This does make duration inaccurate, so if this does happen, we will add
    // an attribute to the span
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.resource.browser.metrics'
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes['sentry.browser.measure_happened_before_request'] = true;
        attributes['sentry.browser.measure_start_time'] = measureStartTimestamp;
    }
    (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ function $4ca18541755f3f2c$var$_addNavigationSpans(span, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, 'secureConnection', timeOrigin, 'TLS/SSL');
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, 'fetch', timeOrigin, 'cache');
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, 'domainLookup', timeOrigin, 'DNS');
    $4ca18541755f3f2c$var$_addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $4ca18541755f3f2c$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
        }
    });
}
function $4ca18541755f3f2c$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === 'secureConnection') return 'connectEnd';
    if (event === 'fetch') return 'domainLookupStart';
    return `${event}End`;
}
/** Create request and response related spans */ function $4ca18541755f3f2c$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: 'browser.request',
            name: entry.name,
            attributes: {
                [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            }
        });
        (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: 'browser.response',
            name: entry.name,
            attributes: {
                [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            }
        });
    }
}
/**
 * Create resource-related spans.
 * Exported only for tests.
 */ function $4ca18541755f3f2c$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const parsedUrl = (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(resourceUrl);
    const attributes = {
        [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.resource.browser.metrics'
    };
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, 'transferSize', 'http.response_transfer_size');
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, 'encodedBodySize', 'http.response_content_length');
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    // `deliveryType` is experimental and does not exist everywhere
    const deliveryType = entry.deliveryType;
    if (deliveryType != null) attributes['http.response_delivery_type'] = deliveryType;
    // Types do not reflect this property yet
    const renderBlockingStatus = entry.renderBlockingStatus;
    if (renderBlockingStatus) attributes['resource.render_blocking_status'] = renderBlockingStatus;
    if (parsedUrl.protocol) attributes['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes['server.address'] = parsedUrl.host;
    attributes['url.same_origin'] = resourceUrl.includes((0, $955496f5d3029976$export$56d8a8a25bd48b81).location.origin);
    const { name: name, version: version } = (0, $b0d1d845a8fb2673$export$57c6f824442f9fe1)(entry.nextHopProtocol);
    attributes['network.protocol.name'] = name;
    attributes['network.protocol.version'] = version;
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $955496f5d3029976$export$56d8a8a25bd48b81).location.origin, ''),
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        attributes: attributes
    });
}
/**
 * Capture the information of the user agent.
 */ function $4ca18541755f3f2c$var$_trackNavigator(span) {
    const navigator = (0, $955496f5d3029976$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute('effectiveConnectionType', connection.effectiveType);
        if (connection.type) span.setAttribute('connectionType', connection.type);
        if ((0, $b0d1d845a8fb2673$export$27169ccae1b439e3)(connection.rtt)) $4ca18541755f3f2c$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $b0d1d845a8fb2673$export$27169ccae1b439e3)(navigator.deviceMemory)) span.setAttribute('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $b0d1d845a8fb2673$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) span.setAttribute('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to span to allow debugging */ function $4ca18541755f3f2c$var$_setWebVitalAttributes(span) {
    if ($4ca18541755f3f2c$var$_lcpEntry) {
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($4ca18541755f3f2c$var$_lcpEntry.element) span.setAttribute('lcp.element', (0, $cccaafc2216668b2$export$5647df6b7814ac86)($4ca18541755f3f2c$var$_lcpEntry.element));
        if ($4ca18541755f3f2c$var$_lcpEntry.id) span.setAttribute('lcp.id', $4ca18541755f3f2c$var$_lcpEntry.id);
        if ($4ca18541755f3f2c$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute('lcp.url', $4ca18541755f3f2c$var$_lcpEntry.url.trim().slice(0, 200));
        if ($4ca18541755f3f2c$var$_lcpEntry.loadTime != null) // loadTime is the time of LCP that's related to receiving the LCP element response..
        span.setAttribute('lcp.loadTime', $4ca18541755f3f2c$var$_lcpEntry.loadTime);
        if ($4ca18541755f3f2c$var$_lcpEntry.renderTime != null) // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        span.setAttribute('lcp.renderTime', $4ca18541755f3f2c$var$_lcpEntry.renderTime);
        span.setAttribute('lcp.size', $4ca18541755f3f2c$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($4ca18541755f3f2c$var$_clsEntry && $4ca18541755f3f2c$var$_clsEntry.sources) $4ca18541755f3f2c$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $cccaafc2216668b2$export$5647df6b7814ac86)(source.node)));
}
function $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $4ca18541755f3f2c$var$MAX_INT_AS_BYTES) attributes[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $4ca18541755f3f2c$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements['ttfb.requestTime'] = {
        value: responseStart - requestStart,
        unit: 'millisecond'
    };
}




const $751b596e3029fa17$var$LAST_INTERACTIONS = [];
const $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP = new Map();
/**
 * Start tracking INP webvital events.
 */ function $751b596e3029fa17$export$f17d06681a4744a3() {
    const performance = (0, $b0d1d845a8fb2673$export$f72a13c439a30cab)();
    if (performance && (0, $4f6ba265374890ec$export$baf075a948ffc0bf)) {
        const inpCallback = $751b596e3029fa17$var$_trackINP();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
const $751b596e3029fa17$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $751b596e3029fa17$var$_trackINP() {
    return (0, $31f3d198369e5cbf$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value == undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $751b596e3029fa17$var$INP_ENTRY_MAP[entry.name]);
        if (!entry) return;
        const { interactionId: interactionId } = entry;
        const interactionType = $751b596e3029fa17$var$INP_ENTRY_MAP[entry.name];
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $4f6ba265374890ec$export$baf075a948ffc0bf) + entry.startTime);
        const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(metric.value);
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const rootSpan = activeSpan ? (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan) : undefined;
        // We first try to lookup the span from our INTERACTIONS_SPAN_MAP,
        // where we cache the route per interactionId
        const cachedSpan = interactionId != null ? $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
        const spanToUse = cachedSpan || rootSpan;
        // Else, we try to use the active span.
        // Finally, we fall back to look at the transactionName on the scope
        const routeName = spanToUse ? (0, $36b15c0d755e29f6$export$92d8c23565496537)(spanToUse).description : (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().getScopeData().transactionName;
        const name = (0, $cccaafc2216668b2$export$5647df6b7814ac86)(entry.target);
        const attributes = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.http.browser.inp',
            [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
            [(0, $068c396dceb690a1$export$fea48ba9f4550879)]: entry.duration
        });
        const span = (0, $b0d1d845a8fb2673$export$b71b9c7b60c5a4aa)({
            name: name,
            transaction: routeName,
            attributes: attributes,
            startTime: startTime
        });
        if (span) {
            span.addEvent('inp', {
                [(0, $068c396dceb690a1$export$f5f95cff026507b5)]: 'millisecond',
                [(0, $068c396dceb690a1$export$69cd5c610c7bb96a)]: metric.value
            });
            span.end(startTime + duration);
        }
    });
}
/**
 * Register a listener to cache route information for INP interactions.
 * TODO(v9): `latestRoute` no longer needs to be passed in and will be removed in v9.
 */ function $751b596e3029fa17$export$e4e04d43e223cce2(_latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $31f3d198369e5cbf$export$7affb50b622d8714)(entry) || !activeRootSpan) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            // If the interaction was already recorded before, nothing more to do
            if ($751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            // We keep max. 10 interactions in the list, then remove the oldest one & clean up
            if ($751b596e3029fa17$var$LAST_INTERACTIONS.length > 10) {
                const last = $751b596e3029fa17$var$LAST_INTERACTIONS.shift();
                $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            // We add the interaction to the list of recorded interactions
            // and store the span for this interaction
            $751b596e3029fa17$var$LAST_INTERACTIONS.push(interactionId);
            $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.set(interactionId, activeRootSpan);
        });
    };
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)('event', handleEntries);
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)('first-input', handleEntries);
}





let $4d76cdf59d4d2156$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4d76cdf59d4d2156$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $4d76cdf59d4d2156$var$instrumentError);
}
function $4d76cdf59d4d2156$var$instrumentError() {
    $4d76cdf59d4d2156$var$_oldOnErrorHandler = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('error', handlerData);
        if ($4d76cdf59d4d2156$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $4d76cdf59d4d2156$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}




let $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7878483f8a9932cd$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $7878483f8a9932cd$var$instrumentUnhandledRejection);
}
function $7878483f8a9932cd$var$instrumentUnhandledRejection() {
    $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





let $d4be1d52827a3f28$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $d4be1d52827a3f28$export$b0914730ee1f6c80() {
    if ($d4be1d52827a3f28$var$errorsInstrumented) return;
    $d4be1d52827a3f28$var$errorsInstrumented = true;
    (0, $4d76cdf59d4d2156$export$55b5c3ba2194f0c6)($d4be1d52827a3f28$var$errorCallback);
    (0, $7878483f8a9932cd$export$8bf4fc6858821a4e)($d4be1d52827a3f28$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active root span as failed
 */ function $d4be1d52827a3f28$var$errorCallback() {
    const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const rootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        const message = 'internal_error';
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`[Tracing] Root span: ${message} -> Global error occurred`);
        rootSpan.setStatus({
            code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
            message: message
        });
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$d4be1d52827a3f28$var$errorCallback.tag = 'sentry_tracingErrorCallback';












const $fd927ea1b5d85956$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $fd927ea1b5d85956$var$FINISH_REASON_HEARTBEAT_FAILED = 'heartbeatFailed';
const $fd927ea1b5d85956$var$FINISH_REASON_IDLE_TIMEOUT = 'idleTimeout';
const $fd927ea1b5d85956$var$FINISH_REASON_FINAL_TIMEOUT = 'finalTimeout';
const $fd927ea1b5d85956$var$FINISH_REASON_EXTERNAL_FINISH = 'externalFinish';
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $fd927ea1b5d85956$export$901bffd97bd52797(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.idleTimeout, finalTimeout: finalTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.finalTimeout, childSpanTimeout: childSpanTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.childSpanTimeout, beforeSpanEnd: beforeSpanEnd } = options;
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client || !(0, $e426c875bd1d2890$export$5008da00b1b6dee6)()) return new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const previousActiveSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const span = $fd927ea1b5d85956$var$_startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
            const spanEndTimestamp = (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = (0, $36b15c0d755e29f6$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
            // If we have no spans, we just end, nothing else to do here
            if (!spans.length) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const childEndTimestamps = spans.map((span)=>(0, $36b15c0d755e29f6$export$92d8c23565496537)(span).timestamp).filter((timestamp)=>!!timestamp);
            const latestSpanEndTimestamp = childEndTimestamps.length ? Math.max(...childEndTimestamps) : undefined;
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(scope, previousActiveSpan);
        const spanJSON = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data || {};
        if (!attributes[0, $068c396dceb690a1$export$ba73f34502b7a3b3]) span.setAttribute((0, $068c396dceb690a1$export$ba73f34502b7a3b3), _finishReason);
        (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, $36b15c0d755e29f6$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                    message: 'cancelled'
                });
                childSpan.end(endTimestamp);
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('[Tracing] Cancelling span since span ended early', JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = (0, $36b15c0d755e29f6$export$92d8c23565496537)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, $b776c95debaa4af0$export$16a28057038b10ef) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $c9674f9e04798056$export$af88d00dbe7f521).log('[Tracing] Discarding span since it happened after idle span was finished', stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $c9674f9e04798056$export$af88d00dbe7f521).log('[Tracing] Discarding span since it finished after idle span final timeout', stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $36b15c0d755e29f6$export$c2a0c9438bb89d91)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute('sentry.idle_span_discarded_spans', discardedSpans);
    }
    _cleanupHooks.push(client.on('spanStart', (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!(0, $36b15c0d755e29f6$export$92d8c23565496537)(startedSpan).timestamp) return;
        const allSpans = (0, $36b15c0d755e29f6$export$340c5c8a13ffc680)(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('spanEnd', (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('idleSpanEnableAutoFinish', (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                message: 'deadline_exceeded'
            });
            _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $fd927ea1b5d85956$var$_startIdleSpan(options) {
    const span = (0, $038737f78c636108$export$63dbba021a6b4047)(options);
    (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)((0, $f106fce27ec076f7$export$c7be4b0125a10cba)(), span);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('[Tracing] Started span is an idle span');
    return span;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $7b8b500cb80621bc$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

















/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $9ad49a0639c06d33$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($9ad49a0639c06d33$var$States || ($9ad49a0639c06d33$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $9ad49a0639c06d33$export$1fda8aa4d135f8aa(value) {
    return new $9ad49a0639c06d33$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $9ad49a0639c06d33$export$78e43115b553f358(reason) {
    return new $9ad49a0639c06d33$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $9ad49a0639c06d33$export$6f292d4960313241 {
    constructor(executor){
        $9ad49a0639c06d33$export$6f292d4960313241.prototype.__init.call(this);
        $9ad49a0639c06d33$export$6f292d4960313241.prototype.__init2.call(this);
        $9ad49a0639c06d33$export$6f292d4960313241.prototype.__init3.call(this);
        $9ad49a0639c06d33$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $9ad49a0639c06d33$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $9ad49a0639c06d33$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $9ad49a0639c06d33$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($9ad49a0639c06d33$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($9ad49a0639c06d33$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $9ad49a0639c06d33$var$States.PENDING) return;
            if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $9ad49a0639c06d33$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $9ad49a0639c06d33$var$States.RESOLVED) handler[1](this._value);
                if (this._state === $9ad49a0639c06d33$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}


/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $9ad49a0639c06d33$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && processor.id && result === null && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(result)) result.then((final)=>$fa62667502ab5c7a$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}




let $107941ce73c7a34f$var$parsedStackResults;
let $107941ce73c7a34f$var$lastKeysCount;
let $107941ce73c7a34f$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $107941ce73c7a34f$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($107941ce73c7a34f$var$cachedFilenameDebugIds && debugIdKeys.length === $107941ce73c7a34f$var$lastKeysCount) return $107941ce73c7a34f$var$cachedFilenameDebugIds;
    $107941ce73c7a34f$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $107941ce73c7a34f$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$107941ce73c7a34f$var$parsedStackResults) $107941ce73c7a34f$var$parsedStackResults = {};
        const result = $107941ce73c7a34f$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame && stackFrame.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $107941ce73c7a34f$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $107941ce73c7a34f$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $107941ce73c7a34f$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $107941ce73c7a34f$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}










/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $29ab5181ea4a2c1b$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $29ab5181ea4a2c1b$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $29ab5181ea4a2c1b$var$applySpanToEvent(event, span);
    $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint);
    $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $29ab5181ea4a2c1b$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'extra', extra);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'tags', tags);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'user', user);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $05f9869a4b646370$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $05f9869a4b646370$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $29ab5181ea4a2c1b$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    const cleanedExtra = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $29ab5181ea4a2c1b$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $36b15c0d755e29f6$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $baba650ac852ba0c$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $baba650ac852ba0c$export$d7e04067a6fbc882(prepared, options);
    $baba650ac852ba0c$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $baba650ac852ba0c$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $baba650ac852ba0c$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $f106fce27ec076f7$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $29ab5181ea4a2c1b$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $29ab5181ea4a2c1b$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $29ab5181ea4a2c1b$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $fa62667502ab5c7a$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $baba650ac852ba0c$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $baba650ac852ba0c$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $baba650ac852ba0c$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $3592a0510b526070$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    if (event.message) event.message = (0, $cee8faa76567523a$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $cee8faa76567523a$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $cee8faa76567523a$export$6a506b36fdea397d)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $baba650ac852ba0c$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $107941ce73c7a34f$export$e069fee9c632ed00)(stackParser);
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (filenameDebugIdMap && frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $baba650ac852ba0c$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $baba650ac852ba0c$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $baba650ac852ba0c$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts && event.contexts.flags && normalized.contexts) normalized.contexts.flags = (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $baba650ac852ba0c$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $baba650ac852ba0c$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($baba650ac852ba0c$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($baba650ac852ba0c$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $baba650ac852ba0c$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $33c387bb26fe522d$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $baba650ac852ba0c$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $baba650ac852ba0c$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$baba650ac852ba0c$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $f2b90654edf2c0a1$export$f5282963edea4a68(exception, hint) {
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureException(exception, (0, $baba650ac852ba0c$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $f2b90654edf2c0a1$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $f2b90654edf2c0a1$export$1462b974fdcf6ba2(event, hint) {
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $f2b90654edf2c0a1$export$2f04de43fe27971a(name, context) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $f2b90654edf2c0a1$export$bb4922da0dd51b92(extras) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $f2b90654edf2c0a1$export$8e8e7789d42ed61d(key, extra) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $f2b90654edf2c0a1$export$74a8fb34822092e6(tags) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $f2b90654edf2c0a1$export$a37d07ee78eb4569(key, value) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $f2b90654edf2c0a1$export$8b6bb3dd62a01be2(user) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $f2b90654edf2c0a1$export$5d4e9fd7fac8e617() {
    return (0, $f106fce27ec076f7$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $f2b90654edf2c0a1$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $f2b90654edf2c0a1$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $f106fce27ec076f7$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn('ok');
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        else finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$4909b86c8034bf73(timeout) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$8360e631d277ea4d(timeout) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $f2b90654edf2c0a1$export$3f95c6f800b78024() {
    return !!(0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $f2b90654edf2c0a1$export$3b029eb57ac4d562() {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    return !!client && client.getOptions().enabled !== false && !!client.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $f2b90654edf2c0a1$export$9aac0b9f77928fbf(callback) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $f2b90654edf2c0a1$export$c0d84948cecf78d8(context) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const { release: release, environment: environment = (0, $3592a0510b526070$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $ecc06dd71ed8ff5f$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $f2b90654edf2c0a1$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $f2b90654edf2c0a1$export$17a5be43989a0bc1() {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $ecc06dd71ed8ff5f$export$56521d9ba90f62ee)(session);
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $f2b90654edf2c0a1$var$_sendSessionUpdate() {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $f2b90654edf2c0a1$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $f2b90654edf2c0a1$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
}


const $9130afac94f0b7c9$export$56d8a8a25bd48b81 = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
let $9130afac94f0b7c9$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$b79738ab10c590b2() {
    return $9130afac94f0b7c9$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $9130afac94f0b7c9$var$ignoreOnError++;
    setTimeout(()=>{
        $9130afac94f0b7c9$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $9130afac94f0b7c9$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $f4dd084fe83374eb$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$9130afac94f0b7c9$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $9130afac94f0b7c9$export$1265a142ff5ba165();
            (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $4f55103f4332a5b0$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $f2b90654edf2c0a1$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (e2) {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $f4dd084fe83374eb$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch (e3) {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}





/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $755e6178fce08d17$export$6f18f55521af71a1() {
    if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81) && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        if (!activeSpan) return;
        const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
        if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = 'cancelled';
            const { op: op, status: status } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
            if (0, $7b8b500cb80621bc$export$16a28057038b10ef) (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                message: cancelledStatus
            });
            rootSpan.setAttribute('sentry.cancellation_reason', 'document.hidden');
            rootSpan.end();
        }
    });
    else (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}




const $63e43e59b4196dc4$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $63e43e59b4196dc4$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $63e43e59b4196dc4$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $63e43e59b4196dc4$export$c67d533bf77cbf54() {
    if (!(0, $955496f5d3029976$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $63e43e59b4196dc4$var$parseUrl(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $f079126c500c7ea2$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(header) && (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $f079126c500c7ea2$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $63e43e59b4196dc4$var$parseUrl(url) {
    if ((0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}







const $020e060e3b422828$var$WINDOW = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $020e060e3b422828$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $020e060e3b422828$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $020e060e3b422828$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$020e060e3b422828$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($020e060e3b422828$export$d5f608b368e73f38($020e060e3b422828$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $020e060e3b422828$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $020e060e3b422828$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$531055a6c684a70a() {
    return 'ReportingObserver' in $020e060e3b422828$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$020e060e3b422828$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $da5e32477400e3c6$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, ()=>$da5e32477400e3c6$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $da5e32477400e3c6$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, ()=>$da5e32477400e3c6$var$instrumentFetch($da5e32477400e3c6$var$streamHandler));
}
function $da5e32477400e3c6$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $020e060e3b422828$export$c82d238e23c40b21)()) return;
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $da5e32477400e3c6$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(error, 'framesToPop', 1);
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $da5e32477400e3c6$var$resolveResponse(res, onFinishedResolving) {
    if (res && res.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $da5e32477400e3c6$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $da5e32477400e3c6$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch-body-resolved', {
            endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $da5e32477400e3c6$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $da5e32477400e3c6$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($da5e32477400e3c6$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $da5e32477400e3c6$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $da5e32477400e3c6$var$getUrlFromResource(url),
            method: $da5e32477400e3c6$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $da5e32477400e3c6$var$getUrlFromResource(arg),
        method: $da5e32477400e3c6$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}














/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values to strings. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */ function $1ca539d872b9359e$export$dec8f001b9d982cb(options = {}) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!(0, $f2b90654edf2c0a1$export$3b029eb57ac4d562)() || !client) return {};
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const span = options.span || (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const sentryTrace = span ? (0, $36b15c0d755e29f6$export$7e9f8ae9e4a328ab)(span) : $1ca539d872b9359e$var$scopeToTraceHeader(scope);
    const dsc = span ? (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span) : (0, $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b)(client, scope);
    const baggage = (0, $bcdb7fb6cf7e08bf$export$56766feef403f365)(dsc);
    const isValidSentryTraceHeader = (0, $06e5b8314e290bf2$export$394a210812ba3012).test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Invalid sentry-trace data. Cannot generate trace data');
        return {};
    }
    return {
        'sentry-trace': sentryTrace,
        baggage: baggage
    };
}
/**
 * Get a sentry-trace header value for the given scope.
 */ function $1ca539d872b9359e$var$scopeToTraceHeader(scope) {
    // TODO(v9): Use generateSpanId() instead of spanId
    // eslint-disable-next-line deprecation/deprecation
    const { traceId: traceId, sampled: sampled, spanId: spanId } = scope.getPropagationContext();
    return (0, $06e5b8314e290bf2$export$f35d907436da45cf)(traceId, spanId, sampled);
}

















/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $0b4497afe5c251f9$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = 'auto.http.browser') {
    if (!handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() && shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $0b4497afe5c251f9$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $0b4497afe5c251f9$var$getFullURL(url);
    const host = fullUrl ? (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const hasParent = !!(0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $038737f78c636108$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        attributes: {
            url: url,
            type: 'fetch',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': host,
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: spanOrigin,
            [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: 'http.client'
        }
    }) : new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = handlerData.args[1] || {};
        const headers = $0b4497afe5c251f9$var$_addTracingHeadersToFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() && hasParent ? span : undefined);
        if (headers) {
            // Ensure this is actually set, if no options have been passed previously
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 */ function $0b4497afe5c251f9$var$_addTracingHeadersToFetchRequest(request, fetchOptionsObj, span) {
    const traceHeaders = (0, $1ca539d872b9359e$export$dec8f001b9d982cb)({
        span: span
    });
    const sentryTrace = traceHeaders['sentry-trace'];
    const baggage = traceHeaders.baggage;
    // Nothing to do, when we return undefined here, the original headers will be used
    if (!sentryTrace) return undefined;
    const headers = fetchOptionsObj.headers || ($0b4497afe5c251f9$var$isRequest(request) ? request.headers : undefined);
    if (!headers) return {
        ...traceHeaders
    };
    else if ($0b4497afe5c251f9$var$isHeaders(headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.set('sentry-trace', sentryTrace);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get('baggage');
            if (prevBaggageHeader) {
                const prevHeaderStrippedFromSentryBaggage = $0b4497afe5c251f9$var$stripBaggageHeaderOfSentryBaggageValues(prevBaggageHeader);
                newHeaders.set('baggage', // If there are non-sentry entries (i.e. if the stripped string is non-empty/truthy) combine the stripped header and sentry baggage header
                // otherwise just set the sentry baggage header
                prevHeaderStrippedFromSentryBaggage ? `${prevHeaderStrippedFromSentryBaggage},${baggage}` : baggage);
            } else newHeaders.set('baggage', baggage);
        }
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers// Remove any existing sentry-trace headers
            .filter((header)=>{
                return !(Array.isArray(header) && header[0] === 'sentry-trace');
            })// Get rid of previous sentry baggage values in baggage header
            .map((header)=>{
                if (Array.isArray(header) && header[0] === 'baggage' && typeof header[1] === 'string') {
                    const [headerName, headerValue, ...rest] = header;
                    return [
                        headerName,
                        $0b4497afe5c251f9$var$stripBaggageHeaderOfSentryBaggageValues(headerValue),
                        ...rest
                    ];
                } else return header;
            }),
            // Attach the new sentry-trace header
            [
                'sentry-trace',
                sentryTrace
            ]
        ];
        if (baggage) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            'baggage',
            baggage
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        let newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders = existingBaggageHeader.map((headerItem)=>typeof headerItem === 'string' ? $0b4497afe5c251f9$var$stripBaggageHeaderOfSentryBaggageValues(headerItem) : headerItem).filter((headerItem)=>headerItem === '');
        else if (existingBaggageHeader) newBaggageHeaders.push($0b4497afe5c251f9$var$stripBaggageHeaderOfSentryBaggageValues(existingBaggageHeader));
        if (baggage) newBaggageHeaders.push(baggage);
        return {
            ...headers,
            'sentry-trace': sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 *
 * @deprecated This function will not be exported anymore in v9.
 */ function $0b4497afe5c251f9$export$6717acf674206871(request, _client, _scope, fetchOptionsObj, span) {
    return $0b4497afe5c251f9$var$_addTracingHeadersToFetchRequest(request, fetchOptionsObj, span);
}
function $0b4497afe5c251f9$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $0b4497afe5c251f9$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $006ad32cdaebe09b$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
        message: 'internal_error'
    });
    span.end();
}
function $0b4497afe5c251f9$var$stripBaggageHeaderOfSentryBaggageValues(baggageHeader) {
    return baggageHeader.split(',')// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .filter((baggageEntry)=>!baggageEntry.split('=')[0].startsWith((0, $bcdb7fb6cf7e08bf$export$6e69537d67fa20f))).join(',');
}
function $0b4497afe5c251f9$var$isRequest(request) {
    return typeof Request !== 'undefined' && (0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(request, Request);
}
function $0b4497afe5c251f9$var$isHeaders(headers) {
    return typeof Headers !== 'undefined' && (0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(headers, Headers);
}



/** Options for Request Instrumentation */ const $edec20d6c9712df6$var$responseToSpanId = new WeakMap();
const $edec20d6c9712df6$var$spanIdToEndTimestamp = new Map();
const $edec20d6c9712df6$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
/** Registers span creators for xhr and fetch requests  */ function $edec20d6c9712df6$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets } = {
        traceFetch: $edec20d6c9712df6$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $edec20d6c9712df6$export$cc17fb3c0bc95cd7.traceXHR,
        trackFetchStreamPerformance: $edec20d6c9712df6$export$cc17fb3c0bc95cd7.trackFetchStreamPerformance,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$edec20d6c9712df6$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    if (traceFetch) {
        // Keeping track of http requests, whose body payloads resolved later than the initial resolved request
        // e.g. streaming using server sent events (SSE)
        client.addEventProcessor((event)=>{
            if (event.type === 'transaction' && event.spans) event.spans.forEach((span)=>{
                if (span.op === 'http.client') {
                    const updatedTimestamp = $edec20d6c9712df6$var$spanIdToEndTimestamp.get(span.span_id);
                    if (updatedTimestamp) {
                        span.timestamp = updatedTimestamp / 1000;
                        $edec20d6c9712df6$var$spanIdToEndTimestamp.delete(span.span_id);
                    }
                }
            });
            return event;
        });
        if (trackFetchStreamPerformance) (0, $da5e32477400e3c6$export$1a79663eb318fe6a)((handlerData)=>{
            if (handlerData.response) {
                const span = $edec20d6c9712df6$var$responseToSpanId.get(handlerData.response);
                if (span && handlerData.endTimestamp) $edec20d6c9712df6$var$spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
            }
        });
        (0, $da5e32477400e3c6$export$f75d3c772c923df0)((handlerData)=>{
            const createdSpan = (0, $0b4497afe5c251f9$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
            if (handlerData.response && handlerData.fetchData.__span) $edec20d6c9712df6$var$responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                const fullUrl = $edec20d6c9712df6$var$getFullURL(handlerData.fetchData.url);
                const host = fullUrl ? (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    'http.url': fullUrl,
                    'server.address': host
                });
            }
            if (enableHTTPTimings && createdSpan) $edec20d6c9712df6$var$addHTTPTimings(createdSpan);
        });
    }
    if (traceXHR) (0, $63e43e59b4196dc4$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $edec20d6c9712df6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $edec20d6c9712df6$var$addHTTPTimings(createdSpan);
    });
}
function $edec20d6c9712df6$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $edec20d6c9712df6$var$addHTTPTimings(span) {
    const { url: url } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $31f3d198369e5cbf$export$69816c1a049f8db6)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($edec20d6c9712df6$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $edec20d6c9712df6$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
function $edec20d6c9712df6$var$getAbsoluteTime(time = 0) {
    return (((0, $4f6ba265374890ec$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $edec20d6c9712df6$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = (0, $b0d1d845a8fb2673$export$57c6f824442f9fe1)(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, $4f6ba265374890ec$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            'http.request.redirect_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function $edec20d6c9712df6$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    const href = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href;
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch (e) {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $edec20d6c9712df6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $63e43e59b4196dc4$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() && shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $006ad32cdaebe09b$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const fullUrl = $edec20d6c9712df6$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const hasParent = !!(0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $038737f78c636108$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        attributes: {
            type: 'xhr',
            'http.method': sentryXhrData.method,
            'http.url': fullUrl,
            url: sentryXhrData.url,
            'server.address': host,
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.http.browser',
            [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: 'http.client'
        }
    }) : new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders(sentryXhrData.url)) $edec20d6c9712df6$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() && hasParent ? span : undefined);
    return span;
}
function $edec20d6c9712df6$var$addTracingHeadersToXhrRequest(xhr, span) {
    const { 'sentry-trace': sentryTrace, baggage: baggage } = (0, $1ca539d872b9359e$export$dec8f001b9d982cb)({
        span: span
    });
    if (sentryTrace) $edec20d6c9712df6$var$setHeaderOnXhr(xhr, sentryTrace, baggage);
}
function $edec20d6c9712df6$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('baggage', sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $edec20d6c9712df6$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e2) {
        return undefined;
    }
}


/* eslint-disable max-lines */ const $400f75f99113439b$export$bbd2089f30bd3708 = 'BrowserTracing';
const $400f75f99113439b$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $fd927ea1b5d85956$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    _experiments: {},
    ...(0, $edec20d6c9712df6$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $400f75f99113439b$export$b4109253475213e9 = (_options = {})=>{
    (0, $d4be1d52827a3f28$export$b0914730ee1f6c80)();
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation } = {
        ...$400f75f99113439b$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $4ca18541755f3f2c$export$7c69f0412d101b88)({
        recordClsStandaloneSpans: enableStandaloneClsSpans || false
    });
    if (enableInp) (0, $751b596e3029fa17$export$f17d06681a4744a3)();
    if (enableLongAnimationFrame && (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('long-animation-frame')) (0, $4ca18541755f3f2c$export$5b823ab2ccbc801d)();
    else if (enableLongTask) (0, $4ca18541755f3f2c$export$f396d19077034ad2)();
    if (enableInteractions) (0, $4ca18541755f3f2c$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        source: undefined
    };
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions) {
        const isPageloadTransaction = startSpanOptions.op === 'pageload';
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (startSpanOptions.name !== finalStartSpanOptions.name) {
            attributes[0, $068c396dceb690a1$export$d7a7d984b0791405] = 'custom';
            finalStartSpanOptions.attributes = attributes;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $068c396dceb690a1$export$d7a7d984b0791405];
        const idleSpan = (0, $fd927ea1b5d85956$export$901bffd97bd52797)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadTransaction,
            beforeSpanEnd: (span)=>{
                _collectWebVitals();
                (0, $4ca18541755f3f2c$export$5f8fa6b3467a7443)(span, {
                    recordClsOnPageloadSpan: !enableStandaloneClsSpans
                });
            }
        });
        function emitFinish() {
            if ([
                'interactive',
                'complete'
            ].includes((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.readyState)) client.emit('idleSpanEnableAutoFinish', idleSpan);
        }
        if (isPageloadTransaction && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) {
            (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener('readystatechange', ()=>{
                emitFinish();
            });
            emitFinish();
        }
        return idleSpan;
    }
    return {
        name: $400f75f99113439b$export$bbd2089f30bd3708,
        afterAllSetup (client) {
            let activeSpan;
            let startingUrl = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href;
            function maybeEndActiveSpan() {
                if (activeSpan && !(0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan).timestamp) {
                    (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`[Tracing] Finishing current active span with op: ${(0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan).op}`);
                    // If there's an open active span, we need to finish it before creating an new one.
                    activeSpan.end();
                }
            }
            client.on('startNavigationSpan', (startSpanOptions)=>{
                if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
                maybeEndActiveSpan();
                activeSpan = _createRouteSpan(client, {
                    op: 'navigation',
                    ...startSpanOptions
                });
            });
            client.on('startPageLoadSpan', (startSpanOptions, traceOptions = {})=>{
                if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $400f75f99113439b$export$f147b32b03c9cf11('sentry-trace');
                const baggage = traceOptions.baggage || $400f75f99113439b$export$f147b32b03c9cf11('baggage');
                const propagationContext = (0, $06e5b8314e290bf2$export$261f383d16a93e39)(sentryTrace, baggage);
                (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setPropagationContext(propagationContext);
                activeSpan = _createRouteSpan(client, {
                    op: 'pageload',
                    ...startSpanOptions
                });
            });
            // A trace should to stay the consistent over the entire time span of one route.
            // Therefore, when the initial pageload or navigation root span ends, we update the
            // scope's propagation context to keep span-specific attributes like the `sampled` decision and
            // the dynamic sampling context valid, even after the root span has ended.
            // This ensures that the trace data is consistent for the entire duration of the route.
            client.on('spanEnd', (span)=>{
                const op = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).op;
                if (span !== (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span) || op !== 'navigation' && op !== 'pageload') return;
                const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    sampled: oldPropagationContext.sampled !== undefined ? oldPropagationContext.sampled : (0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(span),
                    dsc: oldPropagationContext.dsc || (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span)
                });
            });
            if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) $400f75f99113439b$export$aa44a07f82af519f(client, {
                    name: (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTime: (0, $4f6ba265374890ec$export$baf075a948ffc0bf) ? (0, $4f6ba265374890ec$export$baf075a948ffc0bf) / 1000 : undefined,
                    attributes: {
                        [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: 'url',
                        [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.pageload.browser'
                    }
                });
                if (instrumentNavigation) (0, $3d87653da885c31c$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    if (from !== to) {
                        startingUrl = undefined;
                        $400f75f99113439b$export$7d159749bd9969ad(client, {
                            name: (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.pathname,
                            attributes: {
                                [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: 'url',
                                [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.navigation.browser'
                            }
                        });
                    }
                });
            }
            if (markBackgroundSpan) (0, $755e6178fce08d17$export$6f18f55521af71a1)();
            if (enableInteractions) $400f75f99113439b$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            if (enableInp) (0, $751b596e3029fa17$export$e4e04d43e223cce2)();
            (0, $edec20d6c9712df6$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                trackFetchStreamPerformance: trackFetchStreamPerformance,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function $400f75f99113439b$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit('startPageLoadSpan', spanOptions, traceOptions);
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    const span = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const op = span && (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).op;
    return op === 'pageload' ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function $400f75f99113439b$export$7d159749bd9969ad(client, spanOptions) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setPropagationContext({
        traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)()
    });
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setPropagationContext({
        traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)()
    });
    client.emit('startNavigationSpan', spanOptions);
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    const span = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const op = span && (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).op;
    return op === 'navigation' ? span : undefined;
}
/** Returns the value of a meta tag */ function $400f75f99113439b$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    // eslint-disable-next-line deprecation/deprecation
    const metaTag = (0, $cccaafc2216668b2$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
/** Start listener for interaction transactions */ function $400f75f99113439b$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = 'ui.action.click';
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const rootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
        if (rootSpan) {
            const currentRootSpanOp = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan).op;
            if ([
                'navigation',
                'pageload'
            ].includes(currentRootSpanOp)) {
                (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $068c396dceb690a1$export$ba73f34502b7a3b3), 'interactionInterrupted');
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        inflightInteractionSpan = (0, $fd927ea1b5d85956$export$901bffd97bd52797)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: latestRoute.source || 'url'
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) addEventListener('click', registerInteractionTransaction, {
        once: false,
        capture: true
    });
}




const $fbb22756c9507e85$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $fbb22756c9507e85$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $fbb22756c9507e85$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    const finalIntegrations = $fbb22756c9507e85$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = finalIntegrations.findIndex((integration)=>integration.name === 'Debug');
    if (debugIndex > -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $fbb22756c9507e85$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $fbb22756c9507e85$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($fbb22756c9507e85$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $fbb22756c9507e85$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $fbb22756c9507e85$export$2d8f5188773bcddd(integration) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $fbb22756c9507e85$export$2323046b9414659f(fn) {
    return fn;
}





const $b99d5bb3db344fdd$var$INTEGRATION_NAME = 'Dedupe';
const $b99d5bb3db344fdd$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $b99d5bb3db344fdd$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $b99d5bb3db344fdd$export$6d39aa44cd0c7567 = (0, $fbb22756c9507e85$export$2323046b9414659f)($b99d5bb3db344fdd$var$_dedupeIntegration);
/** only exported for tests. */ function $b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(previousEvent);
    const currentException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $4010ef0d9b3761f9$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $4010ef0d9b3761f9$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $b99d5bb3db344fdd$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}




let $7dd448759c7f5e18$var$originalFunctionToString;
const $7dd448759c7f5e18$var$INTEGRATION_NAME = 'FunctionToString';
const $7dd448759c7f5e18$var$SETUP_CLIENTS = new WeakMap();
const $7dd448759c7f5e18$var$_functionToStringIntegration = ()=>{
    return {
        name: $7dd448759c7f5e18$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $7dd448759c7f5e18$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $f4dd084fe83374eb$export$e6cc1e135e2092e5)(this);
                    const context = $7dd448759c7f5e18$var$SETUP_CLIENTS.has((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $7dd448759c7f5e18$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $7dd448759c7f5e18$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $7dd448759c7f5e18$export$7918117e9202e4fb = (0, $fbb22756c9507e85$export$2323046b9414659f)($7dd448759c7f5e18$var$_functionToStringIntegration);


const $0e303f054920e2b1$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $0e303f054920e2b1$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $0e303f054920e2b1$var$_getIngestEndpoint(dsn) {
    return `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $0e303f054920e2b1$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $0e303f054920e2b1$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$0e303f054920e2b1$var$_getIngestEndpoint(dsn)}?${$0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $0e303f054920e2b1$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $9171e4713e443b9b$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}






// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $67b350191b117f2b$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    "undefined is not an object (evaluating 'a.L')",
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/
];
/** Options for the InboundFilters integration */ const $67b350191b117f2b$var$INTEGRATION_NAME = 'InboundFilters';
const $67b350191b117f2b$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $67b350191b117f2b$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $67b350191b117f2b$var$_mergeOptions(options, clientOptions);
            return $67b350191b117f2b$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $67b350191b117f2b$export$cb3c5c2ceb9818ba = (0, $fbb22756c9507e85$export$2323046b9414659f)($67b350191b117f2b$var$_inboundFiltersIntegration);
function $67b350191b117f2b$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $67b350191b117f2b$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $67b350191b117f2b$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $67b350191b117f2b$var$_isSentryError(event)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isUselessError(event)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}.\nUrl: ${$67b350191b117f2b$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$67b350191b117f2b$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}.\nUrl: ${$67b350191b117f2b$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $67b350191b117f2b$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $67b350191b117f2b$var$_getPossibleEventMessages(event).some((message)=>(0, $cee8faa76567523a$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $67b350191b117f2b$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $67b350191b117f2b$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $67b350191b117f2b$var$_getEventFilterUrl(event);
    return !url ? false : (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $67b350191b117f2b$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $67b350191b117f2b$var$_getEventFilterUrl(event);
    return !url ? true : (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $67b350191b117f2b$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    return possibleMessages;
}
function $67b350191b117f2b$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $67b350191b117f2b$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $67b350191b117f2b$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $67b350191b117f2b$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $67b350191b117f2b$var$_isUselessError(event) {
    if (event.type) // event is not an error
    return false;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception || !event.exception.values || event.exception.values.length === 0) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $9af71b6a24a126c8$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $b776c95debaa4af0$export$16a28057038b10ef) (0, $c9674f9e04798056$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $9af71b6a24a126c8$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $9af71b6a24a126c8$export$ecb76f41d43c0e43(client) {
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setClient(client);
}



/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $605291aa308d4b89$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $b0bfa51115099518$export$31499a9cd224b78c)
            })),
        version: (0, $b0bfa51115099518$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}










/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $bbe8beff1aee2812$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}




/** An error emitted by Sentry SDKs and related utilities. */ class $71e03e2f84576ceb$export$5949942ba2a7c0e2 extends Error {
    constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}









const $4f30d529f2099042$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $4f30d529f2099042$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $9171e4713e443b9b$export$128827c3562ec0cb)(options.dsn);
        else (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $0e303f054920e2b1$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        // TODO(v9): Remove this deprecation warning
        const tracingOptions = [
            'enableTracing',
            'tracesSampleRate',
            'tracesSampler'
        ];
        const undefinedOption = tracingOptions.find((option)=>option in options && options[option] == undefined);
        if (undefinedOption) (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn(`[Sentry] Deprecation warning: \`${undefinedOption}\` is set to undefined, which leads to tracing being enabled. In v9, a value of \`undefined\` will result in tracing being disabled.`);
        });
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint, scope) {
        const eventId = (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $4f55103f4332a5b0$export$6de4ffac6a2f1098)(exception)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log($4f30d529f2099042$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $9a62450b4f3c2c3b$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $4f55103f4332a5b0$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log($4f30d529f2099042$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $fbb22756c9507e85$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $fbb22756c9507e85$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $b89a3b4f1056006b$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $f5682b06913d5b03$export$d650323442802f6f)(env, (0, $f5682b06913d5b03$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $b89a3b4f1056006b$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * @inheritdoc
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Transport disabled');
        return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $fbb22756c9507e85$export$51abed9797baa598)(this, integrations);
        (0, $fbb22756c9507e85$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $9ad49a0639c06d33$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)(), isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $baba650ac852ba0c$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            evt.contexts = {
                trace: (0, $f106fce27ec076f7$export$1e83db7ee4876dc4)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $b776c95debaa4af0$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                if (reason instanceof (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2) && reason.logLevel === 'log') (0, $c9674f9e04798056$export$af88d00dbe7f521).log(reason.message);
                else (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $4f30d529f2099042$var$isTransactionEvent(event);
        const isError = $4f30d529f2099042$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $9ad49a0639c06d33$export$78e43115b553f358)(new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, currentScope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $4f30d529f2099042$var$processBeforeSend(this, options, prepared, hint);
            return $4f30d529f2099042$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = currentScope && currentScope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('Sending outcomes:', outcomes);
        const envelope = (0, $bbe8beff1aee2812$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $9171e4713e443b9b$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $4f30d529f2099042$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $4f30d529f2099042$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    if ($4f30d529f2099042$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($4f30d529f2099042$var$isTransactionEvent(event)) {
        if (event.spans && beforeSendSpan) {
            const processedSpans = [];
            for (const span of event.spans){
                const processedSpan = beforeSendSpan(span);
                if (processedSpan) processedSpans.push(processedSpan);
                else {
                    (0, $36b15c0d755e29f6$export$d11691ff45a3e535)();
                    client.recordDroppedEvent('before_send', 'span');
                }
            }
            event.spans = processedSpans;
        }
        if (beforeSendTransaction) {
            if (event.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = event.spans.length;
                event.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(event, hint);
        }
    }
    return event;
}
function $4f30d529f2099042$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $4f30d529f2099042$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $1d72e3a9e632bed3$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $1d72e3a9e632bed3$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}




/**
 * This function creates an exception from a JavaScript Error
 */ function $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $23dde874fe12fd4c$export$2e9ae379995d99e3(ex),
        value: $23dde874fe12fd4c$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $23dde874fe12fd4c$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $5eb42146e0d2c9ef$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $23dde874fe12fd4c$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $23dde874fe12fd4c$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $23dde874fe12fd4c$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex) {
    if (ex && $23dde874fe12fd4c$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $23dde874fe12fd4c$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $23dde874fe12fd4c$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $23dde874fe12fd4c$export$2e9ae379995d99e3(ex) {
    const name = ex && ex.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $23dde874fe12fd4c$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $23dde874fe12fd4c$export$86005d1b62804363(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
    if ($23dde874fe12fd4c$var$isWebAssemblyException(ex) && Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $23dde874fe12fd4c$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $23dde874fe12fd4c$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $9a62450b4f3c2c3b$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $23dde874fe12fd4c$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $9a62450b4f3c2c3b$export$ef9e2056653f0c8e)(exception) || (0, $9a62450b4f3c2c3b$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $9a62450b4f3c2c3b$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $4f55103f4332a5b0$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
    if ((0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(exception) || (0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $23dde874fe12fd4c$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $4f55103f4332a5b0$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $9a62450b4f3c2c3b$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $f4dd084fe83374eb$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $9a62450b4f3c2c3b$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(exception)) {
        const className = $23dde874fe12fd4c$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $23dde874fe12fd4c$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $23dde874fe12fd4c$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}




/**
 * Creates an envelope from a user feedback.
 */ function $6c3623cb2e9b8dd7$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $6c3623cb2e9b8dd7$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $6c3623cb2e9b8dd7$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $72d27c0252bb80ff$export$1df9218a526d318d extends (0, $4f30d529f2099042$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $1d72e3a9e632bed3$export$8ad33f488b1ab046)();
        (0, $605291aa308d4b89$export$b9f95b027256052c)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        if (opts.sendClientReports && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $23dde874fe12fd4c$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $23dde874fe12fd4c$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $6c3623cb2e9b8dd7$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
}






const $c79bca128681c716$var$DEBOUNCE_DURATION = 1000;
let $c79bca128681c716$var$debounceTimerID;
let $c79bca128681c716$var$lastCapturedEventType;
let $c79bca128681c716$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c79bca128681c716$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $c79bca128681c716$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $c79bca128681c716$export$3014bbf0af0e1d4a() {
    if (!(0, $955496f5d3029976$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $f079126c500c7ea2$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $955496f5d3029976$export$56d8a8a25bd48b81);
        const targetObj = globalObject[target];
        const proto = targetObj && targetObj.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $c79bca128681c716$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $c79bca128681c716$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $c79bca128681c716$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $c79bca128681c716$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $c79bca128681c716$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $c79bca128681c716$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($c79bca128681c716$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(target, '_sentryId', (0, $4f55103f4332a5b0$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$c79bca128681c716$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $c79bca128681c716$var$lastCapturedEventType = event.type;
            $c79bca128681c716$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($c79bca128681c716$var$debounceTimerID);
        $c79bca128681c716$var$debounceTimerID = (0, $955496f5d3029976$export$56d8a8a25bd48b81).setTimeout(()=>{
            $c79bca128681c716$var$lastCapturedEventTargetId = undefined;
            $c79bca128681c716$var$lastCapturedEventType = undefined;
        }, $c79bca128681c716$var$DEBOUNCE_DURATION);
    };
}
function $c79bca128681c716$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}





/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $4d76c9d78abc3a9e$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $16d762171e064dbd$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $16d762171e064dbd$var$instrumentConsole);
}
function $16d762171e064dbd$var$instrumentConsole() {
    if (!('console' in (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1))) return;
    (0, $c9674f9e04798056$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console)) return;
        (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $c9674f9e04798056$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $f079126c500c7ea2$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $c9674f9e04798056$export$77c4ce905194557b)[level];
                log && log.apply((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $24280af9d15f06bf$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

/**
 * @deprecated This variable has been deprecated and will be removed in the next major version.
 */ const $197a1d16f7c0faf5$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $197a1d16f7c0faf5$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $8b5b3242e956e79f$var$INTEGRATION_NAME = 'Breadcrumbs';
const $8b5b3242e956e79f$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $8b5b3242e956e79f$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $16d762171e064dbd$export$1d6e0d073f9e6723)($8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $c79bca128681c716$export$5aeffd3db2cf9df7)($8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $63e43e59b4196dc4$export$26ace48dd54c9aea)($8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $da5e32477400e3c6$export$f75d3c772c923df0)($8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $3d87653da885c31c$export$3f18c56c58114e75)($8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $8b5b3242e956e79f$export$c079d904b326663a = (0, $fbb22756c9507e85$export$2323046b9414659f)($8b5b3242e956e79f$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $4f55103f4332a5b0$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $8b5b3242e956e79f$var$_isEvent(event) ? event.target : event;
            target = (0, $cccaafc2216668b2$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $cccaafc2216668b2$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $197a1d16f7c0faf5$export$d771ef054122c30a)(handlerData.level),
            message: (0, $cee8faa76567523a$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $cee8faa76567523a$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $63e43e59b4196dc4$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const level = (0, $24280af9d15f06bf$export$b8cfcc4175694bcc)(status_code);
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: 'xhr',
            data: data,
            type: 'http',
            level: level
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const level = (0, $24280af9d15f06bf$export$b8cfcc4175694bcc)(data.status_code);
            (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                type: 'http',
                level: level
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $8b5b3242e956e79f$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $4e018dbe28beb052$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $4e018dbe28beb052$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $4e018dbe28beb052$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), 'setTimeout', $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), 'setInterval', $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), 'requestAnimationFrame', $4e018dbe28beb052$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81)) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $4e018dbe28beb052$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($4e018dbe28beb052$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $4e018dbe28beb052$export$59bfe9f1c76150e = (0, $fbb22756c9507e85$export$2323046b9414659f)($4e018dbe28beb052$var$_browserApiErrorsIntegration);
function $4e018dbe28beb052$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
function $4e018dbe28beb052$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $4e018dbe28beb052$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $f4dd084fe83374eb$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $4e018dbe28beb052$var$_wrapEventTarget(target) {
    const globalObject = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81);
    const targetObj = globalObject[target];
    const proto = targetObj && targetObj.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($4e018dbe28beb052$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (e2) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $4e018dbe28beb052$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $8a5b32760c0daa50$export$1baa7880e357371c = (0, $fbb22756c9507e85$export$2323046b9414659f)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document === 'undefined') {
                (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $f2b90654edf2c0a1$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $f2b90654edf2c0a1$export$667e7b4d445d566b)();
            // We want to create a session for every navigation as well
            (0, $3d87653da885c31c$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $f2b90654edf2c0a1$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $f2b90654edf2c0a1$export$667e7b4d445d566b)();
                }
            });
        }
    };
});






const $3920039f2d643754$var$INTEGRATION_NAME = 'GlobalHandlers';
const $3920039f2d643754$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $3920039f2d643754$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $3920039f2d643754$var$_installGlobalOnErrorHandler(client);
                $3920039f2d643754$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client);
                $3920039f2d643754$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $3920039f2d643754$export$66acc70e8cf2b71a = (0, $fbb22756c9507e85$export$2323046b9414659f)($3920039f2d643754$var$_globalHandlersIntegration);
function $3920039f2d643754$var$_installGlobalOnErrorHandler(client) {
    (0, $4d76cdf59d4d2156$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client || (0, $9130afac94f0b7c9$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $3920039f2d643754$var$_enhanceEventWithInitialFrame((0, $23dde874fe12fd4c$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $f2b90654edf2c0a1$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $7878483f8a9932cd$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client || (0, $9130afac94f0b7c9$export$b79738ab10c590b2)()) return;
        const error = $3920039f2d643754$var$_getUnhandledRejectionError(e);
        const event = (0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(error) ? $3920039f2d643754$var$_eventFromRejectionWithPrimitive(error) : (0, $23dde874fe12fd4c$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $f2b90654edf2c0a1$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $3920039f2d643754$var$_getUnhandledRejectionError(error) {
    if ((0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $3920039f2d643754$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $3920039f2d643754$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $cccaafc2216668b2$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $3920039f2d643754$var$globalHandlerLog(type) {
    (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $3920039f2d643754$var$getOptions() {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $e873ad23f512125c$export$1378794447170364 = (0, $fbb22756c9507e85$export$2323046b9414659f)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator && !(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && !(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});




/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $71a9151fcd5ea774$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $71a9151fcd5ea774$var$truncateAggregateExceptions($71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(error[key], Error)) {
        $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(childError, Error)) {
            $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $71a9151fcd5ea774$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $cee8faa76567523a$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $74ac7e452f6a0785$var$DEFAULT_KEY = 'cause';
const $74ac7e452f6a0785$var$DEFAULT_LIMIT = 5;
const $74ac7e452f6a0785$var$INTEGRATION_NAME = 'LinkedErrors';
const $74ac7e452f6a0785$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $74ac7e452f6a0785$var$DEFAULT_LIMIT;
    const key = options.key || $74ac7e452f6a0785$var$DEFAULT_KEY;
    return {
        name: $74ac7e452f6a0785$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $71a9151fcd5ea774$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $23dde874fe12fd4c$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $74ac7e452f6a0785$export$ebabb00eb7f3a395 = (0, $fbb22756c9507e85$export$2323046b9414659f)($74ac7e452f6a0785$var$_linkedErrorsIntegration);



// This was originally forked from https://github.com/csnover/TraceKit, and was largely
// re - written as part of raven - js.
//
// This code was later copied to the JavaScript mono - repo and further modified and
// refactored over the years.
const $e103414b28380d9b$var$OPERA10_PRIORITY = 10;
const $e103414b28380d9b$var$OPERA11_PRIORITY = 20;
const $e103414b28380d9b$var$CHROME_PRIORITY = 30;
const $e103414b28380d9b$var$WINJS_PRIORITY = 40;
const $e103414b28380d9b$var$GECKO_PRIORITY = 50;
function $e103414b28380d9b$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $e103414b28380d9b$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $e103414b28380d9b$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $e103414b28380d9b$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $e103414b28380d9b$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $e103414b28380d9b$var$createFrame(filename, (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $e103414b28380d9b$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(parts[1] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), parts[2]);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$263a749fff749872 = [
    $e103414b28380d9b$var$CHROME_PRIORITY,
    $e103414b28380d9b$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $e103414b28380d9b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $e103414b28380d9b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $e103414b28380d9b$var$gecko = (line)=>{
    const parts = $e103414b28380d9b$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac);
        [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(func, filename);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$cdba47a5dd2804d = [
    $e103414b28380d9b$var$GECKO_PRIORITY,
    $e103414b28380d9b$var$gecko
];
const $e103414b28380d9b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$winjs = (line)=>{
    const parts = $e103414b28380d9b$var$winjsRegex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[1] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $e103414b28380d9b$export$179460296da408e8 = [
    $e103414b28380d9b$var$WINJS_PRIORITY,
    $e103414b28380d9b$var$winjs
];
const $e103414b28380d9b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $e103414b28380d9b$var$opera10 = (line)=>{
    const parts = $e103414b28380d9b$var$opera10Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[3] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $e103414b28380d9b$export$f892b52c880ffc7a = [
    $e103414b28380d9b$var$OPERA10_PRIORITY,
    $e103414b28380d9b$var$opera10
];
const $e103414b28380d9b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $e103414b28380d9b$var$opera11 = (line)=>{
    const parts = $e103414b28380d9b$var$opera11Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[5], parts[3] || parts[4] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $e103414b28380d9b$export$af11af13f09fb0dc = [
    $e103414b28380d9b$var$OPERA11_PRIORITY,
    $e103414b28380d9b$var$opera11
];
const $e103414b28380d9b$export$7197c0fe6554c079 = [
    $e103414b28380d9b$export$263a749fff749872,
    $e103414b28380d9b$export$cdba47a5dd2804d
];
const $e103414b28380d9b$export$2b2b997d81bf3907 = (0, $4010ef0d9b3761f9$export$a5739666fb2d03d4)(...$e103414b28380d9b$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $e103414b28380d9b$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};





/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $d09fa7e5070984b9$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $d09fa7e5070984b9$export$e464f4a514ac28a8(name) {
    const cached = $d09fa7e5070984b9$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $955496f5d3029976$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $020e060e3b422828$export$d5f608b368e73f38)(impl)) return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $955496f5d3029976$export$56d8a8a25bd48b81));
    const document = (0, $955496f5d3029976$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $955496f5d3029976$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $d09fa7e5070984b9$export$8aa36702e8c8978(name) {
    $d09fa7e5070984b9$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $d09fa7e5070984b9$export$e7aa7bc5c1b3cfb3(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $d09fa7e5070984b9$export$831dc9f2ab0a617b(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8('setTimeout')(...rest);
}








/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $f3cbf180d3404fe0$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $9ad49a0639c06d33$export$78e43115b553f358)(new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $9ad49a0639c06d33$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $5325f8e04d3d0467$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $5325f8e04d3d0467$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $5325f8e04d3d0467$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $5325f8e04d3d0467$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $5325f8e04d3d0467$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $5325f8e04d3d0467$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $5325f8e04d3d0467$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $5325f8e04d3d0467$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



const $edfbff9038a67171$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $edfbff9038a67171$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $f3cbf180d3404fe0$export$85a4f67f852183e6)(options.bufferSize || $edfbff9038a67171$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $f5682b06913d5b03$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $f5682b06913d5b03$export$b11169581eeaf237)(type);
            if ((0, $5325f8e04d3d0467$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $edfbff9038a67171$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)({});
        const filteredEnvelope = (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $f5682b06913d5b03$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $edfbff9038a67171$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $f5682b06913d5b03$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $f5682b06913d5b03$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $5325f8e04d3d0467$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)) {
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
function $edfbff9038a67171$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $296be0c65ac1edb3$export$b2311068c46d7cc8(options, nativeFetch = (0, $d09fa7e5070984b9$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $d09fa7e5070984b9$export$8aa36702e8c8978)('fetch');
            return (0, $9ad49a0639c06d33$export$78e43115b553f358)('No fetch implementation available');
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $d09fa7e5070984b9$export$8aa36702e8c8978)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $9ad49a0639c06d33$export$78e43115b553f358)(e);
        }
    }
    return (0, $edfbff9038a67171$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** Get the default integrations for the browser SDK. */ function $928f566aa50bb77a$export$5783b2920b1d62b9(options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ const integrations = [
        (0, $67b350191b117f2b$export$cb3c5c2ceb9818ba)(),
        (0, $7dd448759c7f5e18$export$7918117e9202e4fb)(),
        (0, $4e018dbe28beb052$export$59bfe9f1c76150e)(),
        (0, $8b5b3242e956e79f$export$c079d904b326663a)(),
        (0, $3920039f2d643754$export$66acc70e8cf2b71a)(),
        (0, $74ac7e452f6a0785$export$ebabb00eb7f3a395)(),
        (0, $b99d5bb3db344fdd$export$6d39aa44cd0c7567)(),
        (0, $e873ad23f512125c$export$1378794447170364)()
    ];
    // eslint-disable-next-line deprecation/deprecation
    if (options.autoSessionTracking !== false) integrations.push((0, $8a5b32760c0daa50$export$1baa7880e357371c)());
    return integrations;
}
function $928f566aa50bb77a$var$applyDefaultOptions(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $928f566aa50bb77a$export$5783b2920b1d62b9(optionsArg),
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE.id // This supports the variable that sentry-webpack-plugin injects
         ? (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE.id : undefined,
        autoSessionTracking: true,
        sendClientReports: true
    };
    // TODO: Instead of dropping just `defaultIntegrations`, we should simply
    // call `dropUndefinedKeys` on the entire `optionsArg`.
    // However, for this to work we need to adjust the `hasTracingEnabled()` logic
    // first as it differentiates between `undefined` and the key not being in the object.
    if (optionsArg.defaultIntegrations == null) delete optionsArg.defaultIntegrations;
    return {
        ...defaultOptions,
        ...optionsArg
    };
}
function $928f566aa50bb77a$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).window !== 'undefined' && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? 'chrome' : 'browser';
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject && extensionObject.runtime && extensionObject.runtime.id;
    const href = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href || '';
    const extensionProtocols = [
        'chrome-extension:',
        'moz-extension:',
        'ms-browser-extension:',
        'safari-web-extension:'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81) === (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== 'undefined';
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $928f566aa50bb77a$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $928f566aa50bb77a$var$applyDefaultOptions(browserOptions);
    if (!options.skipBrowserExtensionCheck && $928f566aa50bb77a$var$shouldShowBrowserExtensionError()) {
        (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return;
    }
    if (0, $7b8b500cb80621bc$export$16a28057038b10ef) {
        if (!(0, $020e060e3b422828$export$edf3cb81fd7d2a3e)()) (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.');
    }
    const clientOptions = {
        ...options,
        stackParser: (0, $4010ef0d9b3761f9$export$1d5cf88b347146d4)(options.stackParser || (0, $e103414b28380d9b$export$2b2b997d81bf3907)),
        integrations: (0, $fbb22756c9507e85$export$68bc4c01ab8ae766)(options),
        transport: options.transport || (0, $296be0c65ac1edb3$export$b2311068c46d7cc8)
    };
    return (0, $9af71b6a24a126c8$export$5333c3f1c58d9bc1)((0, $72d27c0252bb80ff$export$1df9218a526d318d), clientOptions);
}
/**
 * All properties the report dialog supports
 */ /**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $928f566aa50bb77a$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Global document not defined in showReportDialog call');
        return;
    }
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = scope.getClient();
    const dsn = client && client.getDsn();
    if (!dsn) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $f2b90654edf2c0a1$export$5d4e9fd7fac8e617)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $0e303f054920e2b1$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.head || (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Not injecting report dialog. No injection point found in HTML');
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Captures user feedback and sends it to Sentry.
 *
 * @deprecated Use `captureFeedback` instead.
 */ function $928f566aa50bb77a$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) // eslint-disable-next-line deprecation/deprecation
    client.captureUserFeedback(feedback);
}


$928f566aa50bb77a$export$2cd8252107eb640b({
    dsn: "https://717ad6a740df4f88b0e2dd83e05361f0@o212731.ingest.sentry.io/4505308035809280",
    integrations: [
        $400f75f99113439b$export$b4109253475213e9()
    ],
    tracesSampleRate: 0.01,
    environment: {
        'proportal.acilearning.com': 'production',
        'staging-proportal.acilearning.com': 'staging'
    }[location.host] || 'development'
});



const $2135536a6dbfe182$var$GTM_IDS = {
    'proportal.acilearning.com': 'GTM-P2BX8CX',
    'staging-proportal.acilearning.com': 'GTM-T5PG3QC'
};
window.GTM_ID = $2135536a6dbfe182$var$GTM_IDS[window.location.host] || 'GTM-T5PG3QC';
(function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
    });
    var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', window.GTM_ID);



var $5PFTV = parcelRequire("5PFTV");
document.body.addEventListener("dragstart", (event)=>{
    if (event.target && event.target.draggable) // absurdly, this is needed for Firefox; see https://medium.com/elm-shorts/elm-drag-and-drop-game-630205556d2
    event.dataTransfer.setData("text/html", "blank");
});
document.body.addEventListener("dragover", (event)=>{
    // this is needed in order to make dragging work
    return false;
});
var $35da740d59af89ba$var$CONSTANTS = {
    CONFIG_STORAGE: "configStorage",
    CUSTOMER_SUCCESS: "customerSuccess",
    HAS_INSIGHTS: "hasInsights",
    ZENDESK_TOKEN: "zendeskToken",
    ELM: "elm",
    FEATURES: "features",
    LOTTIE: "lottie",
    MESSAGE_KEY: "message",
    ONBOARD_TOGGLE: "onboardToggle",
    STRING_TYPE: "string",
    TOKEN: "token"
};
var $35da740d59af89ba$var$token = localStorage.getItem($35da740d59af89ba$var$CONSTANTS.TOKEN);
var $35da740d59af89ba$var$customerSuccess = JSON.parse(localStorage.getItem($35da740d59af89ba$var$CONSTANTS.CUSTOMER_SUCCESS));
var $35da740d59af89ba$var$hasInsights = JSON.parse(localStorage.getItem($35da740d59af89ba$var$CONSTANTS.HAS_INSIGHTS));
var $35da740d59af89ba$var$zendeskToken = localStorage.getItem($35da740d59af89ba$var$CONSTANTS.ZENDESK_TOKEN);
var $35da740d59af89ba$var$storedDashboardConfig = localStorage.getItem($35da740d59af89ba$var$CONSTANTS.CONFIG_STORAGE);
var $35da740d59af89ba$var$onboardToggle = JSON.parse(localStorage.getItem($35da740d59af89ba$var$CONSTANTS.ONBOARD_TOGGLE));
var $35da740d59af89ba$var$parsedDashboardConfig = $35da740d59af89ba$var$storedDashboardConfig ? JSON.parse($35da740d59af89ba$var$storedDashboardConfig) : null;
if (window.location.hash) try {
    const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, "?"));
    $35da740d59af89ba$var$token = hashParams.get($35da740d59af89ba$var$CONSTANTS.TOKEN);
    $35da740d59af89ba$var$customerSuccess = JSON.parse(hashParams.get($35da740d59af89ba$var$CONSTANTS.CUSTOMER_SUCCESS));
    $35da740d59af89ba$var$hasInsights = JSON.parse(hashParams.get($35da740d59af89ba$var$CONSTANTS.HAS_INSIGHTS));
    $35da740d59af89ba$var$zendeskToken = hashParams.get($35da740d59af89ba$var$CONSTANTS.ZENDESK_TOKEN);
    localStorage.setItem($35da740d59af89ba$var$CONSTANTS.TOKEN, $35da740d59af89ba$var$token);
    localStorage.setItem($35da740d59af89ba$var$CONSTANTS.CUSTOMER_SUCCESS, $35da740d59af89ba$var$customerSuccess);
    localStorage.setItem($35da740d59af89ba$var$CONSTANTS.HAS_INSIGHTS, $35da740d59af89ba$var$hasInsights);
    localStorage.setItem($35da740d59af89ba$var$CONSTANTS.ZENDESK_TOKEN, $35da740d59af89ba$var$zendeskToken);
    hashParams.delete($35da740d59af89ba$var$CONSTANTS.TOKEN);
    hashParams.delete($35da740d59af89ba$var$CONSTANTS.CUSTOMER_SUCCESS);
    hashParams.delete($35da740d59af89ba$var$CONSTANTS.HAS_INSIGHTS);
    hashParams.delete($35da740d59af89ba$var$CONSTANTS.ZENDESK_TOKEN);
    window.location.hash = `#${hashParams.toString()}`;
} catch (err) {
    $35da740d59af89ba$var$token = null;
    $35da740d59af89ba$var$customerSuccess = null;
    $35da740d59af89ba$var$hasInsights = null;
    $35da740d59af89ba$var$zendeskToken = null;
    localStorage.removeItem($35da740d59af89ba$var$CONSTANTS.TOKEN);
    localStorage.removeItem($35da740d59af89ba$var$CONSTANTS.CUSTOMER_SUCCESS);
    localStorage.removeItem($35da740d59af89ba$var$CONSTANTS.HAS_INSIGHTS);
    localStorage.removeItem($35da740d59af89ba$var$CONSTANTS.ZENDESK_TOKEN);
}
var $35da740d59af89ba$var$features = localStorage.getItem($35da740d59af89ba$var$CONSTANTS.FEATURES);

var $e4262bc82e149ac0$exports = {};
$e4262bc82e149ac0$exports = import.meta.resolve("9IVxw");


var $35da740d59af89ba$var$app = (parcelRequire("dNre6")).Elm.Main.init({
    node: document.getElementById($35da740d59af89ba$var$CONSTANTS.ELM),
    flags: {
        token: $35da740d59af89ba$var$token,
        customerSuccess: $35da740d59af89ba$var$customerSuccess,
        hasInsights: $35da740d59af89ba$var$hasInsights,
        zendeskToken: $35da740d59af89ba$var$zendeskToken,
        features: $35da740d59af89ba$var$features,
        appSite: '{{env "CONSUMER_WEB_URL"}}',
        dashboardConfig: $35da740d59af89ba$var$parsedDashboardConfig,
        thumbnailACILearning: new URL($e4262bc82e149ac0$exports).pathname,
        onboardToggle: $35da740d59af89ba$var$onboardToggle
    }
});
$35da740d59af89ba$var$app.ports.newTab.subscribe((url)=>window.open(url, "_blank"));
$35da740d59af89ba$var$app.ports.openZendesk.subscribe(function() {
    if (typeof zE !== "function") return;
    zE("messenger", "open");
});
$35da740d59af89ba$var$app.ports.downloadCsv.subscribe(function(args) {
    var fileName = args[0];
    var csvString = args[1];
    var blob = new Blob([
        csvString
    ], {
        type: "text/csv"
    });
    var url = window.URL.createObjectURL(blob);
    if (navigator.msSaveOrOpenBlob) navigator.msSaveBlob(blob, fileName);
    else {
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    window.URL.revokeObjectURL(url);
});
$35da740d59af89ba$var$app.ports.setDashboardConfig.subscribe(function(dashboardConfig) {
    localStorage.setItem($35da740d59af89ba$var$CONSTANTS.CONFIG_STORAGE, JSON.stringify(dashboardConfig));
});
$35da740d59af89ba$var$app.ports.setOnboardToggle.subscribe(function(toggled) {
    localStorage.setItem($35da740d59af89ba$var$CONSTANTS.ONBOARD_TOGGLE, toggled);
});
$35da740d59af89ba$var$app.ports.logout.subscribe(function() {
    localStorage.removeItem($35da740d59af89ba$var$CONSTANTS.TOKEN);
    localStorage.removeItem($35da740d59af89ba$var$CONSTANTS.CUSTOMER_SUCCESS);
    localStorage.removeItem($35da740d59af89ba$var$CONSTANTS.HAS_INSIGHTS);
    localStorage.removeItem($35da740d59af89ba$var$CONSTANTS.ZENDESK_TOKEN);
});
$35da740d59af89ba$var$app.ports.logoutZendesk.subscribe(function() {
    if (typeof zE === "function") zE("messenger", "logoutUser");
    localStorage.removeItem($35da740d59af89ba$var$CONSTANTS.ZENDESK_TOKEN);
    $35da740d59af89ba$var$zendeskToken = null;
});

$35da740d59af89ba$var$app.ports.initLottie.subscribe(function() {
    if ($5PFTV) {
        $5PFTV.destroy();
        setTimeout(function() {
            $5PFTV.loadAnimation({
                container: document.getElementById($35da740d59af89ba$var$CONSTANTS.LOTTIE),
                renderer: "svg",
                loop: true,
                autoplay: true,
                animationData: (parcelRequire("jPv2J"))
            });
        }, 2000);
    }
});
var $35da740d59af89ba$var$portSends = {
    RECAPTCHA_LOADED: "RECAPTCHA_LOADED",
    RECAPTCHA_TOKEN: "RECAPTCHA_TOKEN",
    RECAPTCHA_EXPIRED: "RECAPTCHA_EXPIRED",
    RECAPTCHA_ERROR: "RECAPTCHA_ERROR"
};
var $35da740d59af89ba$var$recaptchaSuccess = function(token) {
    var sendConfig = {};
    sendConfig[$35da740d59af89ba$var$portSends.RECAPTCHA_TOKEN] = token;
    $35da740d59af89ba$var$app.ports.receive.send(sendConfig);
};
var $35da740d59af89ba$var$recaptchaExpired = function() {
    var sendConfig = {};
    sendConfig[$35da740d59af89ba$var$portSends.RECAPTCHA_EXPIRED] = $35da740d59af89ba$var$portSends.RECAPTCHA_EXPIRED;
    $35da740d59af89ba$var$app.ports.receive.send(sendConfig);
};
var $35da740d59af89ba$var$recaptchaError = function() {
    var sendConfig = {};
    sendConfig[$35da740d59af89ba$var$portSends.RECAPTCHA_ERROR] = $35da740d59af89ba$var$portSends.RECAPTCHA_ERROR;
    $35da740d59af89ba$var$app.ports.receive.send(sendConfig);
};
var $35da740d59af89ba$var$recaptchRenderConfig = {
    sitekey: '{{env "RECAPTCHA_INVISIBLE_PUBLIC_KEY"}}',
    badge: "bottomleft",
    callback: $35da740d59af89ba$var$recaptchaSuccess,
    "expired-callback": $35da740d59af89ba$var$recaptchaExpired,
    "error-callback": $35da740d59af89ba$var$recaptchaError,
    size: "invisible"
};
var $35da740d59af89ba$var$recaptchaBypass = false;
const $35da740d59af89ba$var$recaptchaLoaded = ()=>{
    let sendConfig = {};
    sendConfig[$35da740d59af89ba$var$portSends.RECAPTCHA_LOADED] = $35da740d59af89ba$var$portSends.RECAPTCHA_LOADED;
    $35da740d59af89ba$var$app.ports.receive.send(sendConfig);
};
window.recaptchaLoaded = $35da740d59af89ba$var$recaptchaLoaded;
const $35da740d59af89ba$var$loadRecaptcha = ()=>{
    const existingScript = document.getElementById("Recaptcha");
    if (!existingScript) {
        const script = document.createElement("script");
        script.defer = true;
        script.src = `https://www.google.com/recaptcha/api.js?onload=recaptchaLoaded&render=explicit`;
        script.id = "Recaptcha";
        document.body.appendChild(script);
    }
};
$35da740d59af89ba$var$loadRecaptcha();
var $35da740d59af89ba$var$portSubs = {
    RECAPTCHA_RENDER: "RECAPTCHA_RENDER",
    RECAPTCHA_EXECUTE: "RECAPTCHA_EXECUTE",
    RECAPTCHA_RESET: "RECAPTCHA_RESET",
    GO_TO_EXTERNAL_LINK_NEW_TAB: "GO_TO_EXTERNAL_LINK_NEW_TAB",
    SET_LOGIN_VARIABLES: "SET_LOGIN_VARIABLES"
};
$35da740d59af89ba$var$app.ports.call.subscribe(function(portConfig) {
    var UNKNOWN_PORT_MESSAGE = function(location) {
        var logMessage = location + " - Elm port sent unknown message: ";
        console.log(logMessage, portConfig);
    };
    if (portConfig.hasOwnProperty($35da740d59af89ba$var$CONSTANTS.MESSAGE_KEY) && typeof portConfig[$35da740d59af89ba$var$CONSTANTS.MESSAGE_KEY] == $35da740d59af89ba$var$CONSTANTS.STRING_TYPE) switch(portConfig[$35da740d59af89ba$var$CONSTANTS.MESSAGE_KEY]){
        case $35da740d59af89ba$var$portSubs.RECAPTCHA_RENDER:
            if (!$35da740d59af89ba$var$recaptchaBypass) window.grecaptcha.ready(()=>{
                window.grecaptcha.render("recaptcha", $35da740d59af89ba$var$recaptchRenderConfig);
            });
            break;
        case $35da740d59af89ba$var$portSubs.RECAPTCHA_EXECUTE:
            if ($35da740d59af89ba$var$recaptchaBypass) $35da740d59af89ba$var$recaptchaSuccess("bypass");
            else window.grecaptcha.ready(()=>{
                window.grecaptcha.execute().then($35da740d59af89ba$var$recaptchaSuccess).catch($35da740d59af89ba$var$recaptchaError);
            });
            break;
        case $35da740d59af89ba$var$portSubs.RECAPTCHA_RESET:
            if (!$35da740d59af89ba$var$recaptchaBypass) window.grecaptcha.reset();
            break;
        case $35da740d59af89ba$var$portSubs.SET_LOGIN_VARIABLES:
            localStorage.setItem($35da740d59af89ba$var$CONSTANTS.TOKEN, portConfig.token);
            localStorage.setItem($35da740d59af89ba$var$CONSTANTS.CUSTOMER_SUCCESS, portConfig.customerSuccess);
            localStorage.setItem($35da740d59af89ba$var$CONSTANTS.HAS_INSIGHTS, portConfig.hasInsights);
            localStorage.setItem($35da740d59af89ba$var$CONSTANTS.ZENDESK_TOKEN, portConfig.zendeskToken);
            $35da740d59af89ba$var$loginZendesk(portConfig.zendeskToken);
            break;
        default:
            return UNKNOWN_PORT_MESSAGE("Switch Statement");
    }
    else return UNKNOWN_PORT_MESSAGE("If/Else");
});
// Whenever localStorage changes in another tab, report it if necessary.
window.addEventListener("storage", function(event) {
    if (event.storageArea === localStorage && event.key === $35da740d59af89ba$var$CONSTANTS.CONFIG_STORAGE) $35da740d59af89ba$var$app.ports.configUpdate.send(JSON.parse(event.newValue));
    if (event.storageArea === localStorage && event.key === $35da740d59af89ba$var$CONSTANTS.ONBOARD_TOGGLE) $35da740d59af89ba$var$app.ports.onboardToggleUpdate.send(JSON.parse(event.newValue));
}, false);
$35da740d59af89ba$var$app.ports.captureException.subscribe((message)=>{
    console.error(message);
    $f2b90654edf2c0a1$export$f5282963edea4a68(new Error(message));
});
const $35da740d59af89ba$var$loginZendesk = (mZendeskToken)=>{
    /* race condition; token isn't fully set yet in localStorage.
  When user first logs in pass the token from SET_LOGIN_VARIABLES Port
  all other times just get from localStorage */ const t = mZendeskToken || $35da740d59af89ba$var$zendeskToken;
    const s = document.createElement("script");
    s.id = "ze-snippet";
    s.src = `https://static.zdassets.com/ekr/snippet.js?key=${'{{env "ZENDESK_KEY"}}'}`;
    s.async = true;
    s.onload = ()=>{
        if (!t) return;
        zE("messenger", "logoutUser");
        zE("messenger", "loginUser", (callback)=>callback(t));
    };
    document.head.appendChild(s);
};
$35da740d59af89ba$var$loginZendesk(null);


//# sourceMappingURL=proportal.d03bbe86.js.map
